/* eslint-disable */
// @ts-nocheck
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Dimension: { input: any; output: any; }
  HexColor: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Quality: { input: any; output: any; }
};

/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type Accordions = Entry & _Node & {
  __typename?: 'Accordions';
  _id: Scalars['ID']['output'];
  accordionsCollection?: Maybe<AccordionsAccordionsCollection>;
  accordionsContentSectionsCollection?: Maybe<AccordionsAccordionsContentSectionsCollection>;
  accordionsContentSectionsCursorCollection?: Maybe<AccordionsAccordionsContentSectionsCursorCollection>;
  accordionsCursorCollection?: Maybe<AccordionsAccordionsCursorCollection>;
  accordionsHeading?: Maybe<Scalars['String']['output']>;
  allowMultipleExpanded?: Maybe<Scalars['Boolean']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<Asset>;
  buttonCollectionAlignment?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<AccordionsButtonsCollection>;
  buttonsCursorCollection?: Maybe<AccordionsButtonsCursorCollection>;
  centerAlign?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  defaultExpanded?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionAlignment?: Maybe<Scalars['String']['output']>;
  descriptionRichText?: Maybe<AccordionsDescriptionRichText>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  expandIconPosition?: Maybe<Scalars['String']['output']>;
  expandIconType?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<FocalPointImage>;
  imagePositionRight?: Maybe<Scalars['Boolean']['output']>;
  imageRoundedCorner?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AccordionsLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  roundedCornersSize?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleAlignment?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  withInnerGap?: Maybe<Scalars['Boolean']['output']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AccordionsAccordionsFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAccordionsContentSectionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsAccordionsContentSectionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAccordionsContentSectionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsAccordionsContentSectionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAccordionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AccordionsAccordionsFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAccordionsHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAllowMultipleExpandedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsButtonCollectionAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsCenterAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDefaultExpandedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDescriptionAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDescriptionRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsExpandIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsExpandIconTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsImagePositionRightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsImageRoundedCornerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsRoundedCornersSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsTitleAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsTitleColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Group allowed Templates in an Accordion experience [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/accordions) */
export type AccordionsWithInnerGapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionsAccordionsCollection = {
  __typename?: 'AccordionsAccordionsCollection';
  items: Array<Maybe<AccordionsAccordionsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionsAccordionsContentSectionsCollection = {
  __typename?: 'AccordionsAccordionsContentSectionsCollection';
  items: Array<Maybe<ContentSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionsAccordionsContentSectionsCollectionOrder =
  | 'alignment_ASC'
  | 'alignment_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsAccordionsContentSectionsCursorCollection = {
  __typename?: 'AccordionsAccordionsContentSectionsCursorCollection';
  items: Array<Maybe<ContentSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AccordionsAccordionsContentSectionsCursorCollectionOrder =
  | 'alignment_ASC'
  | 'alignment_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsAccordionsCursorCollection = {
  __typename?: 'AccordionsAccordionsCursorCollection';
  items: Array<Maybe<AccordionsAccordionsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AccordionsAccordionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionsAccordionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionsAccordionsFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccordionsAccordionsItem = AgendaStepper | ContentTypeRichText;

export type AccordionsButtonsCollection = {
  __typename?: 'AccordionsButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionsButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AccordionsButtonsCursorCollection = {
  __typename?: 'AccordionsButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AccordionsButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AccordionsCollection = {
  __typename?: 'AccordionsCollection';
  items: Array<Maybe<Accordions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AccordionsCursorCollection = {
  __typename?: 'AccordionsCursorCollection';
  items: Array<Maybe<Accordions>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AccordionsDescriptionRichText = {
  __typename?: 'AccordionsDescriptionRichText';
  json: Scalars['JSON']['output'];
  links: AccordionsDescriptionRichTextLinks;
};

export type AccordionsDescriptionRichTextAssets = {
  __typename?: 'AccordionsDescriptionRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AccordionsDescriptionRichTextEntries = {
  __typename?: 'AccordionsDescriptionRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AccordionsDescriptionRichTextLinks = {
  __typename?: 'AccordionsDescriptionRichTextLinks';
  assets: AccordionsDescriptionRichTextAssets;
  entries: AccordionsDescriptionRichTextEntries;
  resources: AccordionsDescriptionRichTextResources;
};

export type AccordionsDescriptionRichTextResources = {
  __typename?: 'AccordionsDescriptionRichTextResources';
  block: Array<AccordionsDescriptionRichTextResourcesBlock>;
  hyperlink: Array<AccordionsDescriptionRichTextResourcesHyperlink>;
  inline: Array<AccordionsDescriptionRichTextResourcesInline>;
};

export type AccordionsDescriptionRichTextResourcesBlock = ResourceLink & {
  __typename?: 'AccordionsDescriptionRichTextResourcesBlock';
  sys: ResourceSys;
};

export type AccordionsDescriptionRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'AccordionsDescriptionRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type AccordionsDescriptionRichTextResourcesInline = ResourceLink & {
  __typename?: 'AccordionsDescriptionRichTextResourcesInline';
  sys: ResourceSys;
};

export type AccordionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionsFilter>>>;
  accordions?: InputMaybe<CfaccordionsMultiTypeNestedFilter>;
  accordionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsContentSections?: InputMaybe<CfContentSectionNestedFilter>;
  accordionsContentSectionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsHeading?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_contains?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accordionsHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accordionsHeading_not?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  accordionsHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowMultipleExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultipleExpanded_exists?: InputMaybe<Scalars['Boolean']['input']>;
  allowMultipleExpanded_not?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonCollectionAlignment?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonCollectionAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonCollectionAlignment_not?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonCollectionAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultExpanded?: InputMaybe<Scalars['Boolean']['input']>;
  defaultExpanded_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultExpanded_not?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionAlignment_not?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconPosition?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconPosition_not?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconType?: InputMaybe<Scalars['String']['input']>;
  expandIconType_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  expandIconType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expandIconType_not?: InputMaybe<Scalars['String']['input']>;
  expandIconType_not_contains?: InputMaybe<Scalars['String']['input']>;
  expandIconType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfFocalPointImageNestedFilter>;
  imagePositionRight?: InputMaybe<Scalars['Boolean']['input']>;
  imagePositionRight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imagePositionRight_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageRoundedCorner?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_contains?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRoundedCorner_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRoundedCorner_not?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageRoundedCorner_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roundedCornersSize?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_contains?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  roundedCornersSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roundedCornersSize_not?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  roundedCornersSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAlignment?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleAlignment_not?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColor?: InputMaybe<Scalars['String']['input']>;
  titleColor_contains?: InputMaybe<Scalars['String']['input']>;
  titleColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColor_not?: InputMaybe<Scalars['String']['input']>;
  titleColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withInnerGap?: InputMaybe<Scalars['Boolean']['input']>;
  withInnerGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withInnerGap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionsLinkingCollections = {
  __typename?: 'AccordionsLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  columnsCollection?: Maybe<ColumnsCollection>;
  columnsCursorCollection?: Maybe<ColumnsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type AccordionsLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsColumnsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionsLinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsLinkingCollectionsTabCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionsLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsColumnsCursorCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type AccordionsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type AccordionsLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AccordionsLinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AccordionsLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AccordionsLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AccordionsLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AccordionsLinkingCollectionsTabCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AccordionsLinkingCollectionsTabCursorCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AccordionsOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooter = Entry & _Node & {
  __typename?: 'AdFooter';
  _id: Scalars['ID']['output'];
  about?: Maybe<AdFooterAbout>;
  aboutDescription?: Maybe<AdFooterAboutDescription>;
  bookNowButton?: Maybe<Entry>;
  componentName?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  copyright?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<DisclaimerV2>;
  exclusivelyAt?: Maybe<Entry>;
  footerPolicyGroupCollection?: Maybe<AdFooterFooterPolicyGroupCollection>;
  footerPolicyGroupCursorCollection?: Maybe<AdFooterFooterPolicyGroupCursorCollection>;
  isLightFooter?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<AdFooterLinkingCollections>;
  logo?: Maybe<Asset>;
  navigationGroupsCollection?: Maybe<AdFooterNavigationGroupsCollection>;
  navigationGroupsCursorCollection?: Maybe<AdFooterNavigationGroupsCursorCollection>;
  socialNetworksCollection?: Maybe<AdFooterSocialNetworksCollection>;
  socialNetworksCursorCollection?: Maybe<AdFooterSocialNetworksCursorCollection>;
  stickyFooterButton?: Maybe<Button>;
  stickyFooterButtonsCollection?: Maybe<AdFooterStickyFooterButtonsCollection>;
  stickyFooterButtonsCursorCollection?: Maybe<AdFooterStickyFooterButtonsCursorCollection>;
  stickyFooterScheduleButton?: Maybe<Button>;
  sys: Sys;
  useDesktopStickyFooter?: Maybe<Scalars['Boolean']['output']>;
  useMobileStickyFooter?: Maybe<Scalars['Boolean']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterAboutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterAboutDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterBookNowButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterContactNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterCopyrightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterExclusivelyAtArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterFooterPolicyGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterFooterPolicyGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterFooterPolicyGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterFooterPolicyGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterIsLightFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterNavigationGroupsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterNavigationGroupsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FooterNavigationGroupFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterNavigationGroupsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterNavigationGroupsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FooterNavigationGroupFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterSocialNetworksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterSocialNetworksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterStickyFooterButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterStickyFooterButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterStickyFooterButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterStickyFooterButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterStickyFooterButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterStickyFooterScheduleButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterUseDesktopStickyFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterUseMobileStickyFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/adFooter) */
export type AdFooterVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdFooterAbout = {
  __typename?: 'AdFooterAbout';
  json: Scalars['JSON']['output'];
  links: AdFooterAboutLinks;
};

export type AdFooterAboutAssets = {
  __typename?: 'AdFooterAboutAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AdFooterAboutDescription = {
  __typename?: 'AdFooterAboutDescription';
  json: Scalars['JSON']['output'];
  links: AdFooterAboutDescriptionLinks;
};

export type AdFooterAboutDescriptionAssets = {
  __typename?: 'AdFooterAboutDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AdFooterAboutDescriptionEntries = {
  __typename?: 'AdFooterAboutDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AdFooterAboutDescriptionLinks = {
  __typename?: 'AdFooterAboutDescriptionLinks';
  assets: AdFooterAboutDescriptionAssets;
  entries: AdFooterAboutDescriptionEntries;
  resources: AdFooterAboutDescriptionResources;
};

export type AdFooterAboutDescriptionResources = {
  __typename?: 'AdFooterAboutDescriptionResources';
  block: Array<AdFooterAboutDescriptionResourcesBlock>;
  hyperlink: Array<AdFooterAboutDescriptionResourcesHyperlink>;
  inline: Array<AdFooterAboutDescriptionResourcesInline>;
};

export type AdFooterAboutDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'AdFooterAboutDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type AdFooterAboutDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'AdFooterAboutDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type AdFooterAboutDescriptionResourcesInline = ResourceLink & {
  __typename?: 'AdFooterAboutDescriptionResourcesInline';
  sys: ResourceSys;
};

export type AdFooterAboutEntries = {
  __typename?: 'AdFooterAboutEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AdFooterAboutLinks = {
  __typename?: 'AdFooterAboutLinks';
  assets: AdFooterAboutAssets;
  entries: AdFooterAboutEntries;
  resources: AdFooterAboutResources;
};

export type AdFooterAboutResources = {
  __typename?: 'AdFooterAboutResources';
  block: Array<AdFooterAboutResourcesBlock>;
  hyperlink: Array<AdFooterAboutResourcesHyperlink>;
  inline: Array<AdFooterAboutResourcesInline>;
};

export type AdFooterAboutResourcesBlock = ResourceLink & {
  __typename?: 'AdFooterAboutResourcesBlock';
  sys: ResourceSys;
};

export type AdFooterAboutResourcesHyperlink = ResourceLink & {
  __typename?: 'AdFooterAboutResourcesHyperlink';
  sys: ResourceSys;
};

export type AdFooterAboutResourcesInline = ResourceLink & {
  __typename?: 'AdFooterAboutResourcesInline';
  sys: ResourceSys;
};

export type AdFooterCollection = {
  __typename?: 'AdFooterCollection';
  items: Array<Maybe<AdFooter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterCursorCollection = {
  __typename?: 'AdFooterCursorCollection';
  items: Array<Maybe<AdFooter>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AdFooterFilter = {
  AND?: InputMaybe<Array<InputMaybe<AdFooterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AdFooterFilter>>>;
  aboutDescription_contains?: InputMaybe<Scalars['String']['input']>;
  aboutDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aboutDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  about_contains?: InputMaybe<Scalars['String']['input']>;
  about_exists?: InputMaybe<Scalars['Boolean']['input']>;
  about_not_contains?: InputMaybe<Scalars['String']['input']>;
  bookNowButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  contactNumber_contains?: InputMaybe<Scalars['String']['input']>;
  contactNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber_not?: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  copyright_contains?: InputMaybe<Scalars['String']['input']>;
  copyright_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyright_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyright_not?: InputMaybe<Scalars['String']['input']>;
  copyright_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyright_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer?: InputMaybe<CfDisclaimerV2NestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  exclusivelyAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerPolicyGroup?: InputMaybe<CfNavigationLinkNestedFilter>;
  footerPolicyGroupCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroups?: InputMaybe<CfFooterNavigationGroupNestedFilter>;
  navigationGroupsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetworksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterButton?: InputMaybe<CfButtonNestedFilter>;
  stickyFooterButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterButtons?: InputMaybe<CfButtonNestedFilter>;
  stickyFooterButtonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterScheduleButton?: InputMaybe<CfButtonNestedFilter>;
  stickyFooterScheduleButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useDesktopStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  useDesktopStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useDesktopStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AdFooterFooterPolicyGroupCollection = {
  __typename?: 'AdFooterFooterPolicyGroupCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterFooterPolicyGroupCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterFooterPolicyGroupCursorCollection = {
  __typename?: 'AdFooterFooterPolicyGroupCursorCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AdFooterFooterPolicyGroupCursorCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterLinkingCollections = {
  __typename?: 'AdFooterLinkingCollections';
  appCollection?: Maybe<AppCollection>;
  appCursorCollection?: Maybe<AppCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AdFooterLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterLinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdFooterLinkingCollectionsAppCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterLinkingCollectionsAppCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdFooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdFooterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdFooterLinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterLinkingCollectionsAppCursorCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterNavigationGroupsCollection = {
  __typename?: 'AdFooterNavigationGroupsCollection';
  items: Array<Maybe<FooterNavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterNavigationGroupsCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterNavigationGroupsCursorCollection = {
  __typename?: 'AdFooterNavigationGroupsCursorCollection';
  items: Array<Maybe<FooterNavigationGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AdFooterNavigationGroupsCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AdFooterOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AdFooterSocialNetworksCollection = {
  __typename?: 'AdFooterSocialNetworksCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterSocialNetworksCursorCollection = {
  __typename?: 'AdFooterSocialNetworksCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AdFooterStickyFooterButtonsCollection = {
  __typename?: 'AdFooterStickyFooterButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AdFooterStickyFooterButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AdFooterStickyFooterButtonsCursorCollection = {
  __typename?: 'AdFooterStickyFooterButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AdFooterStickyFooterButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModal = Entry & _Node & {
  __typename?: 'AgendaModal';
  _id: Scalars['ID']['output'];
  bodyText?: Maybe<ContentTypeRichText>;
  contentfulMetadata: ContentfulMetadata;
  headlineHeading?: Maybe<Scalars['String']['output']>;
  headlineText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AgendaModalLinkingCollections>;
  modalName?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalBodyTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalHeadlineHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalHeadlineTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaModal) */
export type AgendaModalModalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgendaModalCollection = {
  __typename?: 'AgendaModalCollection';
  items: Array<Maybe<AgendaModal>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AgendaModalCursorCollection = {
  __typename?: 'AgendaModalCursorCollection';
  items: Array<Maybe<AgendaModal>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AgendaModalFilter = {
  AND?: InputMaybe<Array<InputMaybe<AgendaModalFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AgendaModalFilter>>>;
  bodyText?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineHeading?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_contains?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineHeading_not?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText?: InputMaybe<Scalars['String']['input']>;
  headlineText_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText_not?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalName?: InputMaybe<Scalars['String']['input']>;
  modalName_contains?: InputMaybe<Scalars['String']['input']>;
  modalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalName_not?: InputMaybe<Scalars['String']['input']>;
  modalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  modalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AgendaModalLinkingCollections = {
  __typename?: 'AgendaModalLinkingCollections';
  agendaStepperCollection?: Maybe<AgendaStepperCollection>;
  agendaStepperCursorCollection?: Maybe<AgendaStepperCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AgendaModalLinkingCollectionsAgendaStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaModalLinkingCollectionsAgendaStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaModalLinkingCollectionsAgendaStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaModalLinkingCollectionsAgendaStepperCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaModalLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaModalLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgendaModalLinkingCollectionsAgendaStepperCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type AgendaModalLinkingCollectionsAgendaStepperCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type AgendaModalOrder =
  | 'headlineHeading_ASC'
  | 'headlineHeading_DESC'
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'modalName_ASC'
  | 'modalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepper = Entry & _Node & {
  __typename?: 'AgendaStepper';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  anchorId?: Maybe<Scalars['String']['output']>;
  areStepsCenteredForMobile?: Maybe<Scalars['Boolean']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentTypeRichText>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  hideStepperDot?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isHighlightedSteps?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<AgendaStepperLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  stepsCollection?: Maybe<AgendaStepperStepsCollection>;
  stepsCursorCollection?: Maybe<AgendaStepperStepsCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  useNumericStepper?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperAreStepsCenteredForMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperHideStepperDotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperIsHighlightedStepsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperStepsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperStepsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgendaModalFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperStepsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperStepsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgendaModalFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/agendaStepper) */
export type AgendaStepperUseNumericStepperArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgendaStepperCollection = {
  __typename?: 'AgendaStepperCollection';
  items: Array<Maybe<AgendaStepper>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AgendaStepperCursorCollection = {
  __typename?: 'AgendaStepperCursorCollection';
  items: Array<Maybe<AgendaStepper>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AgendaStepperFilter = {
  AND?: InputMaybe<Array<InputMaybe<AgendaStepperFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AgendaStepperFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  areStepsCenteredForMobile?: InputMaybe<Scalars['Boolean']['input']>;
  areStepsCenteredForMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  areStepsCenteredForMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideStepperDot?: InputMaybe<Scalars['Boolean']['input']>;
  hideStepperDot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideStepperDot_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isHighlightedSteps?: InputMaybe<Scalars['Boolean']['input']>;
  isHighlightedSteps_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isHighlightedSteps_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steps?: InputMaybe<CfAgendaModalNestedFilter>;
  stepsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useNumericStepper?: InputMaybe<Scalars['Boolean']['input']>;
  useNumericStepper_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useNumericStepper_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgendaStepperLinkingCollections = {
  __typename?: 'AgendaStepperLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  accordionsCursorCollection?: Maybe<AccordionsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type AgendaStepperLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaStepperLinkingCollectionsAccordionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperLinkingCollectionsAccordionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaStepperLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaStepperLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaStepperLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaStepperLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaStepperLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgendaStepperLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgendaStepperLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type AgendaStepperLinkingCollectionsAccordionsCursorCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type AgendaStepperLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type AgendaStepperLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type AgendaStepperLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AgendaStepperLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AgendaStepperOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type AgendaStepperStepsCollection = {
  __typename?: 'AgendaStepperStepsCollection';
  items: Array<Maybe<AgendaModal>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AgendaStepperStepsCollectionOrder =
  | 'headlineHeading_ASC'
  | 'headlineHeading_DESC'
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'modalName_ASC'
  | 'modalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AgendaStepperStepsCursorCollection = {
  __typename?: 'AgendaStepperStepsCursorCollection';
  items: Array<Maybe<AgendaModal>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AgendaStepperStepsCursorCollectionOrder =
  | 'headlineHeading_ASC'
  | 'headlineHeading_DESC'
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'modalName_ASC'
  | 'modalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContext = Entry & _Node & {
  __typename?: 'AnalyticsContext';
  _id: Scalars['ID']['output'];
  appointmentSelectedFacilityId?: Maybe<Scalars['String']['output']>;
  appointmentSelectedFacilityName?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  clickName?: Maybe<Scalars['String']['output']>;
  clickPosition?: Maybe<Scalars['String']['output']>;
  clickType?: Maybe<Scalars['String']['output']>;
  componentName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  errorDetails?: Maybe<Scalars['String']['output']>;
  errorStatus?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AnalyticsContextLinkingCollections>;
  navigationType?: Maybe<Scalars['String']['output']>;
  pageName?: Maybe<Scalars['String']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  siteSection?: Maybe<Scalars['String']['output']>;
  socialMediaName?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  virtualPageTitle?: Maybe<Scalars['String']['output']>;
  virtualPageUrl?: Maybe<Scalars['String']['output']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextAppointmentSelectedFacilityIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextAppointmentSelectedFacilityNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextClickNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextClickPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextClickTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextErrorDetailsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextErrorStatusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextErrorTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextEventArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextEventNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextNavigationTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextPageUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextSiteSectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextSocialMediaNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextVirtualPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for adding analytics data to certain components for various events such as page views, link/button clicks, CTA interactions, etc. Not all fields are relevant to every brand. Relevant brands will be noted in helper text e.g. (CC), (WN), etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/analyticsContext) */
export type AnalyticsContextVirtualPageUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsContextCollection = {
  __typename?: 'AnalyticsContextCollection';
  items: Array<Maybe<AnalyticsContext>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AnalyticsContextCursorCollection = {
  __typename?: 'AnalyticsContextCursorCollection';
  items: Array<Maybe<AnalyticsContext>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AnalyticsContextFilter = {
  AND?: InputMaybe<Array<InputMaybe<AnalyticsContextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AnalyticsContextFilter>>>;
  appointmentSelectedFacilityId?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSelectedFacilityId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityId_not?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityName?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSelectedFacilityName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityName_not?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_contains?: InputMaybe<Scalars['String']['input']>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand_not?: InputMaybe<Scalars['String']['input']>;
  brand_not_contains?: InputMaybe<Scalars['String']['input']>;
  brand_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickName?: InputMaybe<Scalars['String']['input']>;
  clickName_contains?: InputMaybe<Scalars['String']['input']>;
  clickName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickName_not?: InputMaybe<Scalars['String']['input']>;
  clickName_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickPosition?: InputMaybe<Scalars['String']['input']>;
  clickPosition_contains?: InputMaybe<Scalars['String']['input']>;
  clickPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickPosition_not?: InputMaybe<Scalars['String']['input']>;
  clickPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickType?: InputMaybe<Scalars['String']['input']>;
  clickType_contains?: InputMaybe<Scalars['String']['input']>;
  clickType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickType_not?: InputMaybe<Scalars['String']['input']>;
  clickType_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  errorDetails?: InputMaybe<Scalars['String']['input']>;
  errorDetails_contains?: InputMaybe<Scalars['String']['input']>;
  errorDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorDetails_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorDetails_not?: InputMaybe<Scalars['String']['input']>;
  errorDetails_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorDetails_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorStatus?: InputMaybe<Scalars['String']['input']>;
  errorStatus_contains?: InputMaybe<Scalars['String']['input']>;
  errorStatus_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorStatus_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorStatus_not?: InputMaybe<Scalars['String']['input']>;
  errorStatus_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorStatus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  errorType_contains?: InputMaybe<Scalars['String']['input']>;
  errorType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorType_not?: InputMaybe<Scalars['String']['input']>;
  errorType_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventName_contains?: InputMaybe<Scalars['String']['input']>;
  eventName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventName_not?: InputMaybe<Scalars['String']['input']>;
  eventName_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_contains?: InputMaybe<Scalars['String']['input']>;
  event_exists?: InputMaybe<Scalars['Boolean']['input']>;
  event_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_not?: InputMaybe<Scalars['String']['input']>;
  event_not_contains?: InputMaybe<Scalars['String']['input']>;
  event_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationType?: InputMaybe<Scalars['String']['input']>;
  navigationType_contains?: InputMaybe<Scalars['String']['input']>;
  navigationType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationType_not?: InputMaybe<Scalars['String']['input']>;
  navigationType_not_contains?: InputMaybe<Scalars['String']['input']>;
  navigationType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  pageName_contains?: InputMaybe<Scalars['String']['input']>;
  pageName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not?: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  pageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  pageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageUrl_not?: InputMaybe<Scalars['String']['input']>;
  pageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteSection?: InputMaybe<Scalars['String']['input']>;
  siteSection_contains?: InputMaybe<Scalars['String']['input']>;
  siteSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  siteSection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteSection_not?: InputMaybe<Scalars['String']['input']>;
  siteSection_not_contains?: InputMaybe<Scalars['String']['input']>;
  siteSection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaName?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_contains?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialMediaName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaName_not?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  virtualPageTitle?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  virtualPageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageTitle_not?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageUrl?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  virtualPageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageUrl_not?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AnalyticsContextLinkingCollections = {
  __typename?: 'AnalyticsContextLinkingCollections';
  agendaStepperCollection?: Maybe<AgendaStepperCollection>;
  agendaStepperCursorCollection?: Maybe<AgendaStepperCursorCollection>;
  buttonCollection?: Maybe<ButtonCollection>;
  buttonCursorCollection?: Maybe<ButtonCursorCollection>;
  cardCollection?: Maybe<CardCollection>;
  cardCursorCollection?: Maybe<CardCursorCollection>;
  categoryCollection?: Maybe<CategoryCollection>;
  categoryCursorCollection?: Maybe<CategoryCursorCollection>;
  contentTypeRichTextCollection?: Maybe<ContentTypeRichTextCollection>;
  contentTypeRichTextCursorCollection?: Maybe<ContentTypeRichTextCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  error404Collection?: Maybe<Error404Collection>;
  error404CursorCollection?: Maybe<Error404CursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  medicalServiceCollection?: Maybe<MedicalServiceCollection>;
  medicalServiceCursorCollection?: Maybe<MedicalServiceCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type AnalyticsContextLinkingCollectionsAgendaStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsAgendaStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsAgendaStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsAgendaStepperCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsCategoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsContentTypeRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsContentTypeRichTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsContentTypeRichTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsContentTypeRichTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsError404CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsError404CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsError404CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsError404CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsMedicalServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsMedicalServiceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsMedicalServiceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsMedicalServiceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsNavigationLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyticsContextLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalyticsContextLinkingCollectionsAgendaStepperCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type AnalyticsContextLinkingCollectionsAgendaStepperCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type AnalyticsContextLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AnalyticsContextLinkingCollectionsButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type AnalyticsContextLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsCardCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsCategoryCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsCategoryCursorCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsContentTypeRichTextCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsContentTypeRichTextCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsError404CollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AnalyticsContextLinkingCollectionsError404CursorCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AnalyticsContextLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsMedicalServiceCollectionOrder =
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsMedicalServiceCursorCollectionOrder =
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AnalyticsContextLinkingCollectionsNavigationLinkCursorCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AnalyticsContextLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AnalyticsContextOrder =
  | 'appointmentSelectedFacilityId_ASC'
  | 'appointmentSelectedFacilityId_DESC'
  | 'appointmentSelectedFacilityName_ASC'
  | 'appointmentSelectedFacilityName_DESC'
  | 'brand_ASC'
  | 'brand_DESC'
  | 'clickName_ASC'
  | 'clickName_DESC'
  | 'clickPosition_ASC'
  | 'clickPosition_DESC'
  | 'clickType_ASC'
  | 'clickType_DESC'
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'errorDetails_ASC'
  | 'errorDetails_DESC'
  | 'errorStatus_ASC'
  | 'errorStatus_DESC'
  | 'errorType_ASC'
  | 'errorType_DESC'
  | 'eventName_ASC'
  | 'eventName_DESC'
  | 'event_ASC'
  | 'event_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'navigationType_ASC'
  | 'navigationType_DESC'
  | 'pageName_ASC'
  | 'pageName_DESC'
  | 'pageUrl_ASC'
  | 'pageUrl_DESC'
  | 'siteSection_ASC'
  | 'siteSection_DESC'
  | 'socialMediaName_ASC'
  | 'socialMediaName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'virtualPageTitle_ASC'
  | 'virtualPageTitle_DESC'
  | 'virtualPageUrl_ASC'
  | 'virtualPageUrl_DESC';

/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type App = Entry & _Node & {
  __typename?: 'App';
  _id: Scalars['ID']['output'];
  brandImageLink?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<Scalars['String']['output']>;
  breadcrumbsPosition?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  config?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  featureFlags?: Maybe<FeatureFlags>;
  footer?: Maybe<AdFooter>;
  header?: Maybe<Header>;
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<AppLinkingCollections>;
  logo?: Maybe<Asset>;
  logoMobile?: Maybe<Asset>;
  mottoLogo?: Maybe<Asset>;
  mottoLogoMobile?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  notFoundPage?: Maybe<Error404>;
  sys: Sys;
  warningBanner?: Maybe<Iframe>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppBrandImageLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppBrandingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppBreadcrumbsPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppConfigArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppFeatureFlagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FeatureFlagsFilter>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AdFooterFilter>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderFilter>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppIsDeprecatedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppLogoMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppMottoLogoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppMottoLogoMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppNotFoundPageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Error404Filter>;
};


/** Used for MicroFrontend Applications. For both Gatsby and NextJS Apps.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/app) */
export type AppWarningBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IframeFilter>;
};

export type AppCollection = {
  __typename?: 'AppCollection';
  items: Array<Maybe<App>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** TAG-controlled user-facing COPY for the Aspen Dental mobile app (legal, consent, marketing, FTUE). The text sibling of App Media Slot. Published + Active + non-empty wins; empty/inactive/offline falls back to the app's built-in default, so you can never blank a screen. See docs/CONTENTFUL-COPY-SLOTS-GUIDE.md. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appCopySlot) */
export type AppCopySlot = Entry & _Node & {
  __typename?: 'AppCopySlot';
  _id: Scalars['ID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  displayName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AppCopySlotLinkingCollections>;
  slotId?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<Scalars['String']['output']>;
  whereItAppears?: Maybe<Scalars['String']['output']>;
};


/** TAG-controlled user-facing COPY for the Aspen Dental mobile app (legal, consent, marketing, FTUE). The text sibling of App Media Slot. Published + Active + non-empty wins; empty/inactive/offline falls back to the app's built-in default, so you can never blank a screen. See docs/CONTENTFUL-COPY-SLOTS-GUIDE.md. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appCopySlot) */
export type AppCopySlotActiveArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** TAG-controlled user-facing COPY for the Aspen Dental mobile app (legal, consent, marketing, FTUE). The text sibling of App Media Slot. Published + Active + non-empty wins; empty/inactive/offline falls back to the app's built-in default, so you can never blank a screen. See docs/CONTENTFUL-COPY-SLOTS-GUIDE.md. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appCopySlot) */
export type AppCopySlotDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** TAG-controlled user-facing COPY for the Aspen Dental mobile app (legal, consent, marketing, FTUE). The text sibling of App Media Slot. Published + Active + non-empty wins; empty/inactive/offline falls back to the app's built-in default, so you can never blank a screen. See docs/CONTENTFUL-COPY-SLOTS-GUIDE.md. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appCopySlot) */
export type AppCopySlotLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** TAG-controlled user-facing COPY for the Aspen Dental mobile app (legal, consent, marketing, FTUE). The text sibling of App Media Slot. Published + Active + non-empty wins; empty/inactive/offline falls back to the app's built-in default, so you can never blank a screen. See docs/CONTENTFUL-COPY-SLOTS-GUIDE.md. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appCopySlot) */
export type AppCopySlotSlotIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** TAG-controlled user-facing COPY for the Aspen Dental mobile app (legal, consent, marketing, FTUE). The text sibling of App Media Slot. Published + Active + non-empty wins; empty/inactive/offline falls back to the app's built-in default, so you can never blank a screen. See docs/CONTENTFUL-COPY-SLOTS-GUIDE.md. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appCopySlot) */
export type AppCopySlotTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** TAG-controlled user-facing COPY for the Aspen Dental mobile app (legal, consent, marketing, FTUE). The text sibling of App Media Slot. Published + Active + non-empty wins; empty/inactive/offline falls back to the app's built-in default, so you can never blank a screen. See docs/CONTENTFUL-COPY-SLOTS-GUIDE.md. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appCopySlot) */
export type AppCopySlotWhereItAppearsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppCopySlotCollection = {
  __typename?: 'AppCopySlotCollection';
  items: Array<Maybe<AppCopySlot>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppCopySlotCursorCollection = {
  __typename?: 'AppCopySlotCursorCollection';
  items: Array<Maybe<AppCopySlot>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppCopySlotFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppCopySlotFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppCopySlotFilter>>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_exists?: InputMaybe<Scalars['Boolean']['input']>;
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  displayName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  slotId_contains?: InputMaybe<Scalars['String']['input']>;
  slotId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slotId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slotId_not?: InputMaybe<Scalars['String']['input']>;
  slotId_not_contains?: InputMaybe<Scalars['String']['input']>;
  slotId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  whereItAppears?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_contains?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_exists?: InputMaybe<Scalars['Boolean']['input']>;
  whereItAppears_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  whereItAppears_not?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_not_contains?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppCopySlotLinkingCollections = {
  __typename?: 'AppCopySlotLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppCopySlotLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppCopySlotLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppCopySlotOrder =
  | 'active_ASC'
  | 'active_DESC'
  | 'displayName_ASC'
  | 'displayName_DESC'
  | 'slotId_ASC'
  | 'slotId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AppCursorCollection = {
  __typename?: 'AppCursorCollection';
  items: Array<Maybe<App>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appFaq) */
export type AppFaq = Entry & _Node & {
  __typename?: 'AppFaq';
  _id: Scalars['ID']['output'];
  answer?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  faqId?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AppFaqLinkingCollections>;
  question?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appFaq) */
export type AppFaqAnswerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appFaq) */
export type AppFaqFaqIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appFaq) */
export type AppFaqLinkLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appFaq) */
export type AppFaqLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appFaq) */
export type AppFaqQuestionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppFaqCollection = {
  __typename?: 'AppFaqCollection';
  items: Array<Maybe<AppFaq>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppFaqCursorCollection = {
  __typename?: 'AppFaqCursorCollection';
  items: Array<Maybe<AppFaq>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppFaqFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppFaqFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppFaqFilter>>>;
  answer?: InputMaybe<Scalars['String']['input']>;
  answer_contains?: InputMaybe<Scalars['String']['input']>;
  answer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  answer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  answer_not?: InputMaybe<Scalars['String']['input']>;
  answer_not_contains?: InputMaybe<Scalars['String']['input']>;
  answer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  faqId?: InputMaybe<Scalars['String']['input']>;
  faqId_contains?: InputMaybe<Scalars['String']['input']>;
  faqId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  faqId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faqId_not?: InputMaybe<Scalars['String']['input']>;
  faqId_not_contains?: InputMaybe<Scalars['String']['input']>;
  faqId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  linkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  linkLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkLabel_not?: InputMaybe<Scalars['String']['input']>;
  linkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question?: InputMaybe<Scalars['String']['input']>;
  question_contains?: InputMaybe<Scalars['String']['input']>;
  question_exists?: InputMaybe<Scalars['Boolean']['input']>;
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_not?: InputMaybe<Scalars['String']['input']>;
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AppFaqLinkingCollections = {
  __typename?: 'AppFaqLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppFaqLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppFaqLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppFaqOrder =
  | 'faqId_ASC'
  | 'faqId_DESC'
  | 'linkLabel_ASC'
  | 'linkLabel_DESC'
  | 'question_ASC'
  | 'question_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AppFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppFilter>>>;
  brandImageLink?: InputMaybe<Scalars['String']['input']>;
  brandImageLink_contains?: InputMaybe<Scalars['String']['input']>;
  brandImageLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandImageLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandImageLink_not?: InputMaybe<Scalars['String']['input']>;
  brandImageLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandImageLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branding?: InputMaybe<Scalars['String']['input']>;
  branding_contains?: InputMaybe<Scalars['String']['input']>;
  branding_exists?: InputMaybe<Scalars['Boolean']['input']>;
  branding_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branding_not?: InputMaybe<Scalars['String']['input']>;
  branding_not_contains?: InputMaybe<Scalars['String']['input']>;
  branding_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsPosition_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsPosition_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsPosition_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  config_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  featureFlags?: InputMaybe<CfFeatureFlagsNestedFilter>;
  featureFlags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footer?: InputMaybe<CfAdFooterNestedFilter>;
  footer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  header?: InputMaybe<CfHeaderNestedFilter>;
  header_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated_not?: InputMaybe<Scalars['Boolean']['input']>;
  logoMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mottoLogoMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mottoLogo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notFoundPage?: InputMaybe<CfError404NestedFilter>;
  notFoundPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  warningBanner?: InputMaybe<CfIframeNestedFilter>;
  warningBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appLegalDocument) */
export type AppLegalDocument = Entry & _Node & {
  __typename?: 'AppLegalDocument';
  _id: Scalars['ID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  documentId?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AppLegalDocumentLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appLegalDocument) */
export type AppLegalDocumentBodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appLegalDocument) */
export type AppLegalDocumentDocumentIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appLegalDocument) */
export type AppLegalDocumentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppLegalDocumentCollection = {
  __typename?: 'AppLegalDocumentCollection';
  items: Array<Maybe<AppLegalDocument>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppLegalDocumentCursorCollection = {
  __typename?: 'AppLegalDocumentCursorCollection';
  items: Array<Maybe<AppLegalDocument>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppLegalDocumentFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppLegalDocumentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppLegalDocumentFilter>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentId_contains?: InputMaybe<Scalars['String']['input']>;
  documentId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  documentId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentId_not?: InputMaybe<Scalars['String']['input']>;
  documentId_not_contains?: InputMaybe<Scalars['String']['input']>;
  documentId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AppLegalDocumentLinkingCollections = {
  __typename?: 'AppLegalDocumentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppLegalDocumentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppLegalDocumentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppLegalDocumentOrder =
  | 'documentId_ASC'
  | 'documentId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AppLinkingCollections = {
  __typename?: 'AppLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlot = Entry & _Node & {
  __typename?: 'AppMediaSlot';
  _id: Scalars['ID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  altText?: Maybe<Scalars['String']['output']>;
  brandfolderUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  displayName?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<AppMediaSlotLinkingCollections>;
  mediaType?: Maybe<Scalars['String']['output']>;
  slotId?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  videoUrl?: Maybe<Scalars['String']['output']>;
  whereItAppears?: Maybe<Scalars['String']['output']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotActiveArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotBrandfolderUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotMediaTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotSlotIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotVideoUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Aspen Dental native app — stakeholder-controlled image/video slots (task #4383). One entry per named slot in the app. Populate image (or videoUrl) + set Active, publish, and the app picks it up within its cache TTL. Empty media = app renders its built-in fallback (honest state). Images live in Brandfolder (The Aspen Group DAM) and are referenced through brandfolderUrl; the Contentful image asset is the fallback. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appMediaSlot) */
export type AppMediaSlotWhereItAppearsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppMediaSlotCollection = {
  __typename?: 'AppMediaSlotCollection';
  items: Array<Maybe<AppMediaSlot>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppMediaSlotCursorCollection = {
  __typename?: 'AppMediaSlotCursorCollection';
  items: Array<Maybe<AppMediaSlot>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppMediaSlotFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppMediaSlotFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppMediaSlotFilter>>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_exists?: InputMaybe<Scalars['Boolean']['input']>;
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  altText?: InputMaybe<Scalars['String']['input']>;
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  altText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not?: InputMaybe<Scalars['String']['input']>;
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandfolderUrl?: InputMaybe<Scalars['String']['input']>;
  brandfolderUrl_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandfolderUrl_not?: InputMaybe<Scalars['String']['input']>;
  brandfolderUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  displayName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  mediaType_contains?: InputMaybe<Scalars['String']['input']>;
  mediaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaType_not?: InputMaybe<Scalars['String']['input']>;
  mediaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  slotId_contains?: InputMaybe<Scalars['String']['input']>;
  slotId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slotId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slotId_not?: InputMaybe<Scalars['String']['input']>;
  slotId_not_contains?: InputMaybe<Scalars['String']['input']>;
  slotId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  videoUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl_not?: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  whereItAppears?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_contains?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_exists?: InputMaybe<Scalars['Boolean']['input']>;
  whereItAppears_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  whereItAppears_not?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_not_contains?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppMediaSlotLinkingCollections = {
  __typename?: 'AppMediaSlotLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppMediaSlotLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppMediaSlotLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppMediaSlotOrder =
  | 'active_ASC'
  | 'active_DESC'
  | 'altText_ASC'
  | 'altText_DESC'
  | 'brandfolderUrl_ASC'
  | 'brandfolderUrl_DESC'
  | 'displayName_ASC'
  | 'displayName_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'slotId_ASC'
  | 'slotId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'videoUrl_ASC'
  | 'videoUrl_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOffer = Entry & _Node & {
  __typename?: 'AppOffer';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  ctaLabel?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AppOfferLinkingCollections>;
  offerId?: Maybe<Scalars['String']['output']>;
  partnerDisclosure?: Maybe<Scalars['String']['output']>;
  pricedHeadline?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  subline?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferCtaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferOfferIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferPartnerDisclosureArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferPricedHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appOffer) */
export type AppOfferSublineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppOfferCollection = {
  __typename?: 'AppOfferCollection';
  items: Array<Maybe<AppOffer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppOfferCursorCollection = {
  __typename?: 'AppOfferCursorCollection';
  items: Array<Maybe<AppOffer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppOfferFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppOfferFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppOfferFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaLabel?: InputMaybe<Scalars['String']['input']>;
  ctaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaLabel_not?: InputMaybe<Scalars['String']['input']>;
  ctaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimer_contains?: InputMaybe<Scalars['String']['input']>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer_not?: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_contains?: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerId_contains?: InputMaybe<Scalars['String']['input']>;
  offerId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  offerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offerId_not?: InputMaybe<Scalars['String']['input']>;
  offerId_not_contains?: InputMaybe<Scalars['String']['input']>;
  offerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerDisclosure?: InputMaybe<Scalars['String']['input']>;
  partnerDisclosure_contains?: InputMaybe<Scalars['String']['input']>;
  partnerDisclosure_exists?: InputMaybe<Scalars['Boolean']['input']>;
  partnerDisclosure_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerDisclosure_not?: InputMaybe<Scalars['String']['input']>;
  partnerDisclosure_not_contains?: InputMaybe<Scalars['String']['input']>;
  partnerDisclosure_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pricedHeadline?: InputMaybe<Scalars['String']['input']>;
  pricedHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  pricedHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pricedHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pricedHeadline_not?: InputMaybe<Scalars['String']['input']>;
  pricedHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  pricedHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subline?: InputMaybe<Scalars['String']['input']>;
  subline_contains?: InputMaybe<Scalars['String']['input']>;
  subline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subline_not?: InputMaybe<Scalars['String']['input']>;
  subline_not_contains?: InputMaybe<Scalars['String']['input']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AppOfferLinkingCollections = {
  __typename?: 'AppOfferLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppOfferLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppOfferLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppOfferOrder =
  | 'ctaLabel_ASC'
  | 'ctaLabel_DESC'
  | 'headline_ASC'
  | 'headline_DESC'
  | 'offerId_ASC'
  | 'offerId_DESC'
  | 'partnerDisclosure_ASC'
  | 'partnerDisclosure_DESC'
  | 'pricedHeadline_ASC'
  | 'pricedHeadline_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'subline_ASC'
  | 'subline_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type AppOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appReachYouCard) */
export type AppReachYouCard = Entry & _Node & {
  __typename?: 'AppReachYouCard';
  _id: Scalars['ID']['output'];
  channelId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<AppReachYouCardLinkingCollections>;
  settingsSubtitle?: Maybe<Scalars['String']['output']>;
  settingsTitle?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appReachYouCard) */
export type AppReachYouCardChannelIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appReachYouCard) */
export type AppReachYouCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appReachYouCard) */
export type AppReachYouCardSettingsSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appReachYouCard) */
export type AppReachYouCardSettingsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appReachYouCard) */
export type AppReachYouCardSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appReachYouCard) */
export type AppReachYouCardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppReachYouCardCollection = {
  __typename?: 'AppReachYouCardCollection';
  items: Array<Maybe<AppReachYouCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppReachYouCardCursorCollection = {
  __typename?: 'AppReachYouCardCursorCollection';
  items: Array<Maybe<AppReachYouCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppReachYouCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppReachYouCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppReachYouCardFilter>>>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  channelId_contains?: InputMaybe<Scalars['String']['input']>;
  channelId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  channelId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  channelId_not?: InputMaybe<Scalars['String']['input']>;
  channelId_not_contains?: InputMaybe<Scalars['String']['input']>;
  channelId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  settingsSubtitle?: InputMaybe<Scalars['String']['input']>;
  settingsSubtitle_contains?: InputMaybe<Scalars['String']['input']>;
  settingsSubtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  settingsSubtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settingsSubtitle_not?: InputMaybe<Scalars['String']['input']>;
  settingsSubtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  settingsSubtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settingsTitle?: InputMaybe<Scalars['String']['input']>;
  settingsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  settingsTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  settingsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  settingsTitle_not?: InputMaybe<Scalars['String']['input']>;
  settingsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  settingsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppReachYouCardLinkingCollections = {
  __typename?: 'AppReachYouCardLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppReachYouCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppReachYouCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppReachYouCardOrder =
  | 'channelId_ASC'
  | 'channelId_DESC'
  | 'settingsSubtitle_ASC'
  | 'settingsSubtitle_DESC'
  | 'settingsTitle_ASC'
  | 'settingsTitle_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appTip) */
export type AppTip = Entry & _Node & {
  __typename?: 'AppTip';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<AppTipLinkingCollections>;
  sys: Sys;
  tipId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appTip) */
export type AppTipLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appTip) */
export type AppTipTipIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appTip) */
export type AppTipTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppTipCollection = {
  __typename?: 'AppTipCollection';
  items: Array<Maybe<AppTip>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppTipCursorCollection = {
  __typename?: 'AppTipCursorCollection';
  items: Array<Maybe<AppTip>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppTipFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppTipFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppTipFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  tipId?: InputMaybe<Scalars['String']['input']>;
  tipId_contains?: InputMaybe<Scalars['String']['input']>;
  tipId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tipId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tipId_not?: InputMaybe<Scalars['String']['input']>;
  tipId_not_contains?: InputMaybe<Scalars['String']['input']>;
  tipId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppTipLinkingCollections = {
  __typename?: 'AppTipLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppTipLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppTipLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppTipOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tipId_ASC'
  | 'tipId_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appTreatmentInfo) */
export type AppTreatmentInfo = Entry & _Node & {
  __typename?: 'AppTreatmentInfo';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<AppTreatmentInfoLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  treatmentId?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appTreatmentInfo) */
export type AppTreatmentInfoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appTreatmentInfo) */
export type AppTreatmentInfoTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appTreatmentInfo) */
export type AppTreatmentInfoTreatmentIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppTreatmentInfoCollection = {
  __typename?: 'AppTreatmentInfoCollection';
  items: Array<Maybe<AppTreatmentInfo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppTreatmentInfoCursorCollection = {
  __typename?: 'AppTreatmentInfoCursorCollection';
  items: Array<Maybe<AppTreatmentInfo>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppTreatmentInfoFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppTreatmentInfoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppTreatmentInfoFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatmentId?: InputMaybe<Scalars['String']['input']>;
  treatmentId_contains?: InputMaybe<Scalars['String']['input']>;
  treatmentId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  treatmentId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatmentId_not?: InputMaybe<Scalars['String']['input']>;
  treatmentId_not_contains?: InputMaybe<Scalars['String']['input']>;
  treatmentId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppTreatmentInfoLinkingCollections = {
  __typename?: 'AppTreatmentInfoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppTreatmentInfoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppTreatmentInfoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppTreatmentInfoOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'treatmentId_ASC'
  | 'treatmentId_DESC';

/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopy = Entry & _Node & {
  __typename?: 'AppViewCopy';
  _id: Scalars['ID']['output'];
  active?: Maybe<Scalars['Boolean']['output']>;
  body?: Maybe<AppViewCopyBody>;
  contentfulMetadata: ContentfulMetadata;
  displayName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AppViewCopyLinkingCollections>;
  notes?: Maybe<Scalars['JSON']['output']>;
  strings?: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
  viewId?: Maybe<Scalars['String']['output']>;
  whereItAppears?: Maybe<Scalars['String']['output']>;
};


/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopyActiveArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopyBodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopyDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopyLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopyNotesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopyStringsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopyViewIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** One entry per app view (a tab or a major flow): every string that view shows, as a key/value map. Replaces one App Copy Slot entry per line (TAG ask 2026-09-17: Jon Arme "Do a view at a time", Constantin Pojoga). The app honours a published App Copy Slot entry for an individual string over the same key here, then this map, then its built-in wording. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appViewCopy) */
export type AppViewCopyWhereItAppearsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppViewCopyBody = {
  __typename?: 'AppViewCopyBody';
  json: Scalars['JSON']['output'];
  links: AppViewCopyBodyLinks;
};

export type AppViewCopyBodyAssets = {
  __typename?: 'AppViewCopyBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AppViewCopyBodyEntries = {
  __typename?: 'AppViewCopyBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AppViewCopyBodyLinks = {
  __typename?: 'AppViewCopyBodyLinks';
  assets: AppViewCopyBodyAssets;
  entries: AppViewCopyBodyEntries;
  resources: AppViewCopyBodyResources;
};

export type AppViewCopyBodyResources = {
  __typename?: 'AppViewCopyBodyResources';
  block: Array<AppViewCopyBodyResourcesBlock>;
  hyperlink: Array<AppViewCopyBodyResourcesHyperlink>;
  inline: Array<AppViewCopyBodyResourcesInline>;
};

export type AppViewCopyBodyResourcesBlock = ResourceLink & {
  __typename?: 'AppViewCopyBodyResourcesBlock';
  sys: ResourceSys;
};

export type AppViewCopyBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'AppViewCopyBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type AppViewCopyBodyResourcesInline = ResourceLink & {
  __typename?: 'AppViewCopyBodyResourcesInline';
  sys: ResourceSys;
};

export type AppViewCopyCollection = {
  __typename?: 'AppViewCopyCollection';
  items: Array<Maybe<AppViewCopy>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppViewCopyCursorCollection = {
  __typename?: 'AppViewCopyCursorCollection';
  items: Array<Maybe<AppViewCopy>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppViewCopyFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppViewCopyFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppViewCopyFilter>>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  active_exists?: InputMaybe<Scalars['Boolean']['input']>;
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  displayName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  strings_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  viewId?: InputMaybe<Scalars['String']['input']>;
  viewId_contains?: InputMaybe<Scalars['String']['input']>;
  viewId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  viewId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewId_not?: InputMaybe<Scalars['String']['input']>;
  viewId_not_contains?: InputMaybe<Scalars['String']['input']>;
  viewId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  whereItAppears?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_contains?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_exists?: InputMaybe<Scalars['Boolean']['input']>;
  whereItAppears_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  whereItAppears_not?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_not_contains?: InputMaybe<Scalars['String']['input']>;
  whereItAppears_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppViewCopyLinkingCollections = {
  __typename?: 'AppViewCopyLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppViewCopyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppViewCopyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppViewCopyOrder =
  | 'active_ASC'
  | 'active_DESC'
  | 'displayName_ASC'
  | 'displayName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'viewId_ASC'
  | 'viewId_DESC';

/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPage = Entry & _Node & {
  __typename?: 'AppointmentBookingPage';
  _id: Scalars['ID']['output'];
  bottomContentCollection?: Maybe<AppointmentBookingPageBottomContentCollection>;
  bottomContentCursorCollection?: Maybe<AppointmentBookingPageBottomContentCursorCollection>;
  brand?: Maybe<Brand>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  enableBirdEyeChatBot?: Maybe<Scalars['Boolean']['output']>;
  enableFraudCheck?: Maybe<Scalars['Boolean']['output']>;
  featuredContent?: Maybe<SingleMessage>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<AppointmentBookingPageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<AppointmentBookingPagePageTitle>;
  path?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  theme?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageBottomContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppointmentBookingPageBottomContentFilter>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageBottomContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppointmentBookingPageBottomContentFilter>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageEnableBirdEyeChatBotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageEnableFraudCheckArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageFeaturedContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SingleMessageFilter>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPagePageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Full Page Template for Appointment Booking [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/appointmentBookingPage) */
export type AppointmentBookingPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppointmentBookingPageBottomContentCollection = {
  __typename?: 'AppointmentBookingPageBottomContentCollection';
  items: Array<Maybe<AppointmentBookingPageBottomContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppointmentBookingPageBottomContentCursorCollection = {
  __typename?: 'AppointmentBookingPageBottomContentCursorCollection';
  items: Array<Maybe<AppointmentBookingPageBottomContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppointmentBookingPageBottomContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppointmentBookingPageBottomContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppointmentBookingPageBottomContentFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppointmentBookingPageBottomContentItem = CategoryPicker | SingleMessage;

export type AppointmentBookingPageCollection = {
  __typename?: 'AppointmentBookingPageCollection';
  items: Array<Maybe<AppointmentBookingPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppointmentBookingPageCursorCollection = {
  __typename?: 'AppointmentBookingPageCursorCollection';
  items: Array<Maybe<AppointmentBookingPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AppointmentBookingPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppointmentBookingPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppointmentBookingPageFilter>>>;
  bottomContent?: InputMaybe<CfbottomContentMultiTypeNestedFilter>;
  bottomContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  enableBirdEyeChatBot?: InputMaybe<Scalars['Boolean']['input']>;
  enableBirdEyeChatBot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableBirdEyeChatBot_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck_not?: InputMaybe<Scalars['Boolean']['input']>;
  featuredContent?: InputMaybe<CfSingleMessageNestedFilter>;
  featuredContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AppointmentBookingPageLinkingCollections = {
  __typename?: 'AppointmentBookingPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type AppointmentBookingPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AppointmentBookingPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppointmentBookingPageOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'enableBirdEyeChatBot_ASC'
  | 'enableBirdEyeChatBot_DESC'
  | 'enableFraudCheck_ASC'
  | 'enableFraudCheck_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AppointmentBookingPagePageTitle = {
  __typename?: 'AppointmentBookingPagePageTitle';
  json: Scalars['JSON']['output'];
  links: AppointmentBookingPagePageTitleLinks;
};

export type AppointmentBookingPagePageTitleAssets = {
  __typename?: 'AppointmentBookingPagePageTitleAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AppointmentBookingPagePageTitleEntries = {
  __typename?: 'AppointmentBookingPagePageTitleEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AppointmentBookingPagePageTitleLinks = {
  __typename?: 'AppointmentBookingPagePageTitleLinks';
  assets: AppointmentBookingPagePageTitleAssets;
  entries: AppointmentBookingPagePageTitleEntries;
  resources: AppointmentBookingPagePageTitleResources;
};

export type AppointmentBookingPagePageTitleResources = {
  __typename?: 'AppointmentBookingPagePageTitleResources';
  block: Array<AppointmentBookingPagePageTitleResourcesBlock>;
  hyperlink: Array<AppointmentBookingPagePageTitleResourcesHyperlink>;
  inline: Array<AppointmentBookingPagePageTitleResourcesInline>;
};

export type AppointmentBookingPagePageTitleResourcesBlock = ResourceLink & {
  __typename?: 'AppointmentBookingPagePageTitleResourcesBlock';
  sys: ResourceSys;
};

export type AppointmentBookingPagePageTitleResourcesHyperlink = ResourceLink & {
  __typename?: 'AppointmentBookingPagePageTitleResourcesHyperlink';
  sys: ResourceSys;
};

export type AppointmentBookingPagePageTitleResourcesInline = ResourceLink & {
  __typename?: 'AppointmentBookingPagePageTitleResourcesInline';
  sys: ResourceSys;
};

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = _Node & {
  __typename?: 'Asset';
  _id: Scalars['ID']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  transform?: InputMaybe<ImageTransformOptions>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetCursorCollection = {
  __typename?: 'AssetCursorCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  accordionsCursorCollection?: Maybe<AccordionsCursorCollection>;
  adFooterCollection?: Maybe<AdFooterCollection>;
  adFooterCursorCollection?: Maybe<AdFooterCursorCollection>;
  appCollection?: Maybe<AppCollection>;
  appCursorCollection?: Maybe<AppCursorCollection>;
  appMediaSlotCollection?: Maybe<AppMediaSlotCollection>;
  appMediaSlotCursorCollection?: Maybe<AppMediaSlotCursorCollection>;
  cardCollection?: Maybe<CardCollection>;
  cardCursorCollection?: Maybe<CardCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  error404Collection?: Maybe<Error404Collection>;
  error404CursorCollection?: Maybe<Error404CursorCollection>;
  experimentalModalCollection?: Maybe<ExperimentalModalCollection>;
  experimentalModalCursorCollection?: Maybe<ExperimentalModalCursorCollection>;
  focalPointImageCollection?: Maybe<FocalPointImageCollection>;
  focalPointImageCursorCollection?: Maybe<FocalPointImageCursorCollection>;
  formFieldCollection?: Maybe<FormFieldCollection>;
  formFieldCursorCollection?: Maybe<FormFieldCursorCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  googleMapTemplateCursorCollection?: Maybe<GoogleMapTemplateCursorCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  patientReviewV2Collection?: Maybe<PatientReviewV2Collection>;
  patientReviewV2CursorCollection?: Maybe<PatientReviewV2CursorCollection>;
  serviceCollection?: Maybe<ServiceCollection>;
  serviceCursorCollection?: Maybe<ServiceCursorCollection>;
  smallScreenContentCollection?: Maybe<SmallScreenContentCollection>;
  smallScreenContentCursorCollection?: Maybe<SmallScreenContentCursorCollection>;
  successCardCollection?: Maybe<SuccessCardCollection>;
  successCardCursorCollection?: Maybe<SuccessCardCursorCollection>;
  videoCollection?: Maybe<VideoCollection>;
  videoCursorCollection?: Maybe<VideoCursorCollection>;
};


export type AssetLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsAccordionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsAdFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsAppCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsAppMediaSlotCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsAppMediaSlotCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsError404CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsError404CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsExperimentalModalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsExperimentalModalCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsFocalPointImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsFocalPointImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsFormFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsFormFieldCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsGoogleMapTemplateCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPatientReviewV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPatientReviewV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsServiceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSmallScreenContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSmallScreenContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSuccessCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSuccessCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetOrder =
  | 'contentType_ASC'
  | 'contentType_DESC'
  | 'fileName_ASC'
  | 'fileName_DESC'
  | 'height_ASC'
  | 'height_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'width_ASC'
  | 'width_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type Badge = Entry & _Node & {
  __typename?: 'Badge';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BadgeLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type BadgeLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type BadgeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type BadgeNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/badge) */
export type BadgeVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BadgeCollection = {
  __typename?: 'BadgeCollection';
  items: Array<Maybe<Badge>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BadgeCursorCollection = {
  __typename?: 'BadgeCursorCollection';
  items: Array<Maybe<Badge>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BadgeFilter = {
  AND?: InputMaybe<Array<InputMaybe<BadgeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BadgeFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BadgeLinkingCollections = {
  __typename?: 'BadgeLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  mediaSliderCollection?: Maybe<MediaSliderCollection>;
  mediaSliderCursorCollection?: Maybe<MediaSliderCursorCollection>;
};


export type BadgeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BadgeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BadgeLinkingCollectionsMediaSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BadgeLinkingCollectionsMediaSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BadgeLinkingCollectionsMediaSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BadgeLinkingCollectionsMediaSliderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BadgeLinkingCollectionsMediaSliderCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BadgeLinkingCollectionsMediaSliderCursorCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BadgeOrder =
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type Banner = Entry & _Node & {
  __typename?: 'Banner';
  _id: Scalars['ID']['output'];
  alertMessagesCollection?: Maybe<BannerAlertMessagesCollection>;
  alertMessagesCursorCollection?: Maybe<BannerAlertMessagesCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BannerLinkingCollections>;
  mobileAlertMessagesCollection?: Maybe<BannerMobileAlertMessagesCollection>;
  mobileAlertMessagesCursorCollection?: Maybe<BannerMobileAlertMessagesCursorCollection>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerAlertMessagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerAlertMessagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerAlertMessagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerAlertMessagesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerMobileAlertMessagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerMobileAlertMessagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerMobileAlertMessagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerMobileAlertMessagesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This content type is used to create Banners across website. Like Alert Banner at the Top or Bottom of the Header or any promo banner anywhere in the page etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/banner) */
export type BannerVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BannerAlertMessagesCollection = {
  __typename?: 'BannerAlertMessagesCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BannerAlertMessagesCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerAlertMessagesCursorCollection = {
  __typename?: 'BannerAlertMessagesCursorCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BannerAlertMessagesCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerCollection = {
  __typename?: 'BannerCollection';
  items: Array<Maybe<Banner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BannerCursorCollection = {
  __typename?: 'BannerCursorCollection';
  items: Array<Maybe<Banner>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BannerFilter = {
  AND?: InputMaybe<Array<InputMaybe<BannerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BannerFilter>>>;
  alertMessages?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  alertMessagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  mobileAlertMessages?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  mobileAlertMessagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BannerLinkingCollections = {
  __typename?: 'BannerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerCursorCollection?: Maybe<HeaderCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type BannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BannerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BannerLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BannerLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BannerLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BannerLinkingCollectionsHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerLinkingCollectionsHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BannerLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BannerLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BannerLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BannerLinkingCollectionsHeaderCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BannerLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerMobileAlertMessagesCollection = {
  __typename?: 'BannerMobileAlertMessagesCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BannerMobileAlertMessagesCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerMobileAlertMessagesCursorCollection = {
  __typename?: 'BannerMobileAlertMessagesCursorCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BannerMobileAlertMessagesCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BannerOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviews = Entry & _Node & {
  __typename?: 'BirdEyeReviews';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  filteredReviewsMinRating?: Maybe<Scalars['String']['output']>;
  filteredReviewsTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BirdEyeReviewsLinkingCollections>;
  mediaContent?: Maybe<BirdEyeReviewsMediaContent>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  titleHeading?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsFilteredReviewsMinRatingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsFilteredReviewsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsMediaContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BirdEyeReviewsMediaContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/birdEyeReviews) */
export type BirdEyeReviewsTitleHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BirdEyeReviewsCollection = {
  __typename?: 'BirdEyeReviewsCollection';
  items: Array<Maybe<BirdEyeReviews>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BirdEyeReviewsCursorCollection = {
  __typename?: 'BirdEyeReviewsCursorCollection';
  items: Array<Maybe<BirdEyeReviews>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BirdEyeReviewsFilter = {
  AND?: InputMaybe<Array<InputMaybe<BirdEyeReviewsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BirdEyeReviewsFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  filteredReviewsMinRating?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsMinRating_contains?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsMinRating_exists?: InputMaybe<Scalars['Boolean']['input']>;
  filteredReviewsMinRating_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filteredReviewsMinRating_not?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsMinRating_not_contains?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsMinRating_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filteredReviewsTitle?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  filteredReviewsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filteredReviewsTitle_not?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  filteredReviewsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaContent?: InputMaybe<CfmediaContentMultiTypeNestedFilter>;
  mediaContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BirdEyeReviewsLinkingCollections = {
  __typename?: 'BirdEyeReviewsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type BirdEyeReviewsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BirdEyeReviewsLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BirdEyeReviewsLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type BirdEyeReviewsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BirdEyeReviewsMediaContent = FocalPointImage | Video;

export type BirdEyeReviewsMediaContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BirdEyeReviewsMediaContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BirdEyeReviewsMediaContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BirdEyeReviewsOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'filteredReviewsMinRating_ASC'
  | 'filteredReviewsMinRating_DESC'
  | 'filteredReviewsTitle_ASC'
  | 'filteredReviewsTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthor = Entry & _Node & {
  __typename?: 'BlogAuthor';
  _id: Scalars['ID']['output'];
  authorBioSummary?: Maybe<BlogAuthorAuthorBioSummary>;
  bioSummary?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Scalars['JSON']['output']>;
  linkedFrom?: Maybe<BlogAuthorLinkingCollections>;
  moreAboutTheAuthorPagePath?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorAuthorBioSummaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorBioSummaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorMoreAboutTheAuthorPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The author of a blog. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogAuthor) */
export type BlogAuthorTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogAuthorAuthorBioSummary = {
  __typename?: 'BlogAuthorAuthorBioSummary';
  json: Scalars['JSON']['output'];
  links: BlogAuthorAuthorBioSummaryLinks;
};

export type BlogAuthorAuthorBioSummaryAssets = {
  __typename?: 'BlogAuthorAuthorBioSummaryAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogAuthorAuthorBioSummaryEntries = {
  __typename?: 'BlogAuthorAuthorBioSummaryEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogAuthorAuthorBioSummaryLinks = {
  __typename?: 'BlogAuthorAuthorBioSummaryLinks';
  assets: BlogAuthorAuthorBioSummaryAssets;
  entries: BlogAuthorAuthorBioSummaryEntries;
  resources: BlogAuthorAuthorBioSummaryResources;
};

export type BlogAuthorAuthorBioSummaryResources = {
  __typename?: 'BlogAuthorAuthorBioSummaryResources';
  block: Array<BlogAuthorAuthorBioSummaryResourcesBlock>;
  hyperlink: Array<BlogAuthorAuthorBioSummaryResourcesHyperlink>;
  inline: Array<BlogAuthorAuthorBioSummaryResourcesInline>;
};

export type BlogAuthorAuthorBioSummaryResourcesBlock = ResourceLink & {
  __typename?: 'BlogAuthorAuthorBioSummaryResourcesBlock';
  sys: ResourceSys;
};

export type BlogAuthorAuthorBioSummaryResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogAuthorAuthorBioSummaryResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogAuthorAuthorBioSummaryResourcesInline = ResourceLink & {
  __typename?: 'BlogAuthorAuthorBioSummaryResourcesInline';
  sys: ResourceSys;
};

export type BlogAuthorCollection = {
  __typename?: 'BlogAuthorCollection';
  items: Array<Maybe<BlogAuthor>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogAuthorCursorCollection = {
  __typename?: 'BlogAuthorCursorCollection';
  items: Array<Maybe<BlogAuthor>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogAuthorFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogAuthorFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogAuthorFilter>>>;
  authorBioSummary_contains?: InputMaybe<Scalars['String']['input']>;
  authorBioSummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  authorBioSummary_not_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary?: InputMaybe<Scalars['String']['input']>;
  bioSummary_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bioSummary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bioSummary_not?: InputMaybe<Scalars['String']['input']>;
  bioSummary_not_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreAboutTheAuthorPagePath?: InputMaybe<Scalars['String']['input']>;
  moreAboutTheAuthorPagePath_contains?: InputMaybe<Scalars['String']['input']>;
  moreAboutTheAuthorPagePath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreAboutTheAuthorPagePath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  moreAboutTheAuthorPagePath_not?: InputMaybe<Scalars['String']['input']>;
  moreAboutTheAuthorPagePath_not_contains?: InputMaybe<Scalars['String']['input']>;
  moreAboutTheAuthorPagePath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogAuthorLinkingCollections = {
  __typename?: 'BlogAuthorLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BlogAuthorLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogAuthorLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogAuthorLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogAuthorLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogAuthorLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogAuthorLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogAuthorLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogAuthorLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogAuthorOrder =
  | 'moreAboutTheAuthorPagePath_ASC'
  | 'moreAboutTheAuthorPagePath_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategory = Entry & _Node & {
  __typename?: 'BlogCategory';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlogCategoryLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategoryBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog main category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogCategory) */
export type BlogCategorySlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogCategoryCollection = {
  __typename?: 'BlogCategoryCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogCategoryCursorCollection = {
  __typename?: 'BlogCategoryCursorCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogCategoryFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BlogCategoryLinkingCollections = {
  __typename?: 'BlogCategoryLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  blogListCollection?: Maybe<BlogListCollection>;
  blogListCursorCollection?: Maybe<BlogListCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BlogCategoryLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogCategoryLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogCategoryLinkingCollectionsBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogCategoryLinkingCollectionsBlogListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogCategoryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogCategoryLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogCategoryLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogCategoryLinkingCollectionsBlogListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogCategoryLinkingCollectionsBlogListCursorCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogCategoryOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPage = Entry & _Node & {
  __typename?: 'BlogDetailsPage';
  _id: Scalars['ID']['output'];
  additionalContentCollection?: Maybe<BlogDetailsPageAdditionalContentCollection>;
  additionalContentCursorCollection?: Maybe<BlogDetailsPageAdditionalContentCursorCollection>;
  author?: Maybe<BlogAuthor>;
  blogImage?: Maybe<Scalars['JSON']['output']>;
  brand?: Maybe<Brand>;
  canonical?: Maybe<Scalars['String']['output']>;
  category?: Maybe<BlogCategory>;
  contentfulMetadata: ContentfulMetadata;
  date?: Maybe<Scalars['DateTime']['output']>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  facilityIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  heroBackgroundColor?: Maybe<Scalars['String']['output']>;
  heroButtonCollection?: Maybe<BlogDetailsPageHeroButtonCollection>;
  heroButtonCursorCollection?: Maybe<BlogDetailsPageHeroButtonCursorCollection>;
  heroContentCollection?: Maybe<BlogDetailsPageHeroContentCollection>;
  heroContentCursorCollection?: Maybe<BlogDetailsPageHeroContentCursorCollection>;
  heroContentTitle?: Maybe<BlogDetailsPageHeroContentTitle>;
  imageAsset?: Maybe<ImageAsset>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<BlogDetailsPageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageDesignType?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  relatedBlogsContentSection?: Maybe<ContentSection>;
  reviewer?: Maybe<BlogAuthor>;
  subCategory?: Maybe<BlogSubCategory>;
  summary?: Maybe<BlogDetailsPageSummary>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<BlogDetailsPageText>;
  theme?: Maybe<Scalars['String']['output']>;
  timeToRead?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageAdditionalContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogDetailsPageAdditionalContentFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageAdditionalContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogDetailsPageAdditionalContentFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageAuthorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogAuthorFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageBlogImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageFacilityIdsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageHeroButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageHeroButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageHeroContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageHeroContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageHeroContentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPagePageDesignTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageRelatedBlogsContentSectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageReviewerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogAuthorFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageSubCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogSubCategoryFilter>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageSummaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageTimeToReadArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content to describe a blog entry in its entirety [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogDetailsPage) */
export type BlogDetailsPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogDetailsPageAdditionalContentCollection = {
  __typename?: 'BlogDetailsPageAdditionalContentCollection';
  items: Array<Maybe<BlogDetailsPageAdditionalContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogDetailsPageAdditionalContentCursorCollection = {
  __typename?: 'BlogDetailsPageAdditionalContentCursorCollection';
  items: Array<Maybe<BlogDetailsPageAdditionalContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogDetailsPageAdditionalContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogDetailsPageAdditionalContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogDetailsPageAdditionalContentFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogDetailsPageAdditionalContentItem = Accordions | SingleMessage;

export type BlogDetailsPageCollection = {
  __typename?: 'BlogDetailsPageCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogDetailsPageCursorCollection = {
  __typename?: 'BlogDetailsPageCursorCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogDetailsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogDetailsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogDetailsPageFilter>>>;
  additionalContent?: InputMaybe<CfadditionalContentMultiTypeNestedFilter>;
  additionalContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<CfBlogAuthorNestedFilter>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  blogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<CfBlogCategoryNestedFilter>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_not?: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  facilityIds_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityIds_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityIds_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityIds_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroBackgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroBackgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroButton?: InputMaybe<CfButtonNestedFilter>;
  heroButtonCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContent?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  heroContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  heroContentTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDesignType?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_contains?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageDesignType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDesignType_not?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedBlogsContentSection?: InputMaybe<CfContentSectionNestedFilter>;
  relatedBlogsContentSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reviewer?: InputMaybe<CfBlogAuthorNestedFilter>;
  reviewer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subCategory?: InputMaybe<CfBlogSubCategoryNestedFilter>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeToRead?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  timeToRead_gt?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_gte?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeToRead_lt?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_lte?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_not?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogDetailsPageHeroButtonCollection = {
  __typename?: 'BlogDetailsPageHeroButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogDetailsPageHeroButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogDetailsPageHeroButtonCursorCollection = {
  __typename?: 'BlogDetailsPageHeroButtonCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogDetailsPageHeroButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogDetailsPageHeroContentCollection = {
  __typename?: 'BlogDetailsPageHeroContentCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogDetailsPageHeroContentCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogDetailsPageHeroContentCursorCollection = {
  __typename?: 'BlogDetailsPageHeroContentCursorCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogDetailsPageHeroContentCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogDetailsPageHeroContentTitle = {
  __typename?: 'BlogDetailsPageHeroContentTitle';
  json: Scalars['JSON']['output'];
  links: BlogDetailsPageHeroContentTitleLinks;
};

export type BlogDetailsPageHeroContentTitleAssets = {
  __typename?: 'BlogDetailsPageHeroContentTitleAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogDetailsPageHeroContentTitleEntries = {
  __typename?: 'BlogDetailsPageHeroContentTitleEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogDetailsPageHeroContentTitleLinks = {
  __typename?: 'BlogDetailsPageHeroContentTitleLinks';
  assets: BlogDetailsPageHeroContentTitleAssets;
  entries: BlogDetailsPageHeroContentTitleEntries;
  resources: BlogDetailsPageHeroContentTitleResources;
};

export type BlogDetailsPageHeroContentTitleResources = {
  __typename?: 'BlogDetailsPageHeroContentTitleResources';
  block: Array<BlogDetailsPageHeroContentTitleResourcesBlock>;
  hyperlink: Array<BlogDetailsPageHeroContentTitleResourcesHyperlink>;
  inline: Array<BlogDetailsPageHeroContentTitleResourcesInline>;
};

export type BlogDetailsPageHeroContentTitleResourcesBlock = ResourceLink & {
  __typename?: 'BlogDetailsPageHeroContentTitleResourcesBlock';
  sys: ResourceSys;
};

export type BlogDetailsPageHeroContentTitleResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogDetailsPageHeroContentTitleResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogDetailsPageHeroContentTitleResourcesInline = ResourceLink & {
  __typename?: 'BlogDetailsPageHeroContentTitleResourcesInline';
  sys: ResourceSys;
};

export type BlogDetailsPageLinkingCollections = {
  __typename?: 'BlogDetailsPageLinkingCollections';
  blogListCollection?: Maybe<BlogListCollection>;
  blogListCursorCollection?: Maybe<BlogListCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
};


export type BlogDetailsPageLinkingCollectionsBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageLinkingCollectionsBlogListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogDetailsPageLinkingCollectionsBlogListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageLinkingCollectionsBlogListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogDetailsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogDetailsPageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogDetailsPageLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageLinkingCollectionsNavigationLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogDetailsPageLinkingCollectionsBlogListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogDetailsPageLinkingCollectionsBlogListCursorCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogDetailsPageLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BlogDetailsPageLinkingCollectionsNavigationLinkCursorCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BlogDetailsPageOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogDetailsPageSummary = {
  __typename?: 'BlogDetailsPageSummary';
  json: Scalars['JSON']['output'];
  links: BlogDetailsPageSummaryLinks;
};

export type BlogDetailsPageSummaryAssets = {
  __typename?: 'BlogDetailsPageSummaryAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogDetailsPageSummaryEntries = {
  __typename?: 'BlogDetailsPageSummaryEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogDetailsPageSummaryLinks = {
  __typename?: 'BlogDetailsPageSummaryLinks';
  assets: BlogDetailsPageSummaryAssets;
  entries: BlogDetailsPageSummaryEntries;
  resources: BlogDetailsPageSummaryResources;
};

export type BlogDetailsPageSummaryResources = {
  __typename?: 'BlogDetailsPageSummaryResources';
  block: Array<BlogDetailsPageSummaryResourcesBlock>;
  hyperlink: Array<BlogDetailsPageSummaryResourcesHyperlink>;
  inline: Array<BlogDetailsPageSummaryResourcesInline>;
};

export type BlogDetailsPageSummaryResourcesBlock = ResourceLink & {
  __typename?: 'BlogDetailsPageSummaryResourcesBlock';
  sys: ResourceSys;
};

export type BlogDetailsPageSummaryResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogDetailsPageSummaryResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogDetailsPageSummaryResourcesInline = ResourceLink & {
  __typename?: 'BlogDetailsPageSummaryResourcesInline';
  sys: ResourceSys;
};

export type BlogDetailsPageText = {
  __typename?: 'BlogDetailsPageText';
  json: Scalars['JSON']['output'];
  links: BlogDetailsPageTextLinks;
};

export type BlogDetailsPageTextAssets = {
  __typename?: 'BlogDetailsPageTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogDetailsPageTextEntries = {
  __typename?: 'BlogDetailsPageTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogDetailsPageTextLinks = {
  __typename?: 'BlogDetailsPageTextLinks';
  assets: BlogDetailsPageTextAssets;
  entries: BlogDetailsPageTextEntries;
  resources: BlogDetailsPageTextResources;
};

export type BlogDetailsPageTextResources = {
  __typename?: 'BlogDetailsPageTextResources';
  block: Array<BlogDetailsPageTextResourcesBlock>;
  hyperlink: Array<BlogDetailsPageTextResourcesHyperlink>;
  inline: Array<BlogDetailsPageTextResourcesInline>;
};

export type BlogDetailsPageTextResourcesBlock = ResourceLink & {
  __typename?: 'BlogDetailsPageTextResourcesBlock';
  sys: ResourceSys;
};

export type BlogDetailsPageTextResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogDetailsPageTextResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogDetailsPageTextResourcesInline = ResourceLink & {
  __typename?: 'BlogDetailsPageTextResourcesInline';
  sys: ResourceSys;
};

/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogList = Entry & _Node & {
  __typename?: 'BlogList';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  cardDesignType?: Maybe<Scalars['String']['output']>;
  category?: Maybe<BlogCategory>;
  contentfulMetadata: ContentfulMetadata;
  countAcrossDesktop?: Maybe<Scalars['Int']['output']>;
  countAcrossMobile?: Maybe<Scalars['Int']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  featuredBlogsListCollection?: Maybe<BlogListFeaturedBlogsListCollection>;
  featuredBlogsListCursorCollection?: Maybe<BlogListFeaturedBlogsListCursorCollection>;
  hasPagination?: Maybe<Scalars['Boolean']['output']>;
  heroBlogsListCollection?: Maybe<BlogListHeroBlogsListCollection>;
  heroBlogsListCursorCollection?: Maybe<BlogListHeroBlogsListCursorCollection>;
  linkedFrom?: Maybe<BlogListLinkingCollections>;
  loadMoreButtonLabel?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<BlogSubCategory>;
  sys: Sys;
  tagsFilter?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListCardDesignTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListCountAcrossDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListCountAcrossMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListDisplayTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListFeaturedBlogsListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListFeaturedBlogsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListFeaturedBlogsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListFeaturedBlogsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListHasPaginationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListHeroBlogsListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListHeroBlogsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListHeroBlogsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListHeroBlogsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListLoadMoreButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListSubCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogSubCategoryFilter>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListTagsFilterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List content type which includes the title for the list, number of blogs, brand, category etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogList) */
export type BlogListVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogListCollection = {
  __typename?: 'BlogListCollection';
  items: Array<Maybe<BlogList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListCursorCollection = {
  __typename?: 'BlogListCursorCollection';
  items: Array<Maybe<BlogList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogListFeaturedBlogsListCollection = {
  __typename?: 'BlogListFeaturedBlogsListCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListFeaturedBlogsListCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListFeaturedBlogsListCursorCollection = {
  __typename?: 'BlogListFeaturedBlogsListCursorCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogListFeaturedBlogsListCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogListFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardDesignType?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_contains?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardDesignType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardDesignType_not?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<CfBlogCategoryNestedFilter>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countAcrossDesktop?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countAcrossDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossMobile?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countAcrossMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_not?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  displayType?: InputMaybe<Scalars['String']['input']>;
  displayType_contains?: InputMaybe<Scalars['String']['input']>;
  displayType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayType_not?: InputMaybe<Scalars['String']['input']>;
  displayType_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredBlogsList?: InputMaybe<CfBlogDetailsPageNestedFilter>;
  featuredBlogsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination_not?: InputMaybe<Scalars['Boolean']['input']>;
  heroBlogsList?: InputMaybe<CfBlogDetailsPageNestedFilter>;
  heroBlogsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreButtonLabel?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loadMoreButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategory?: InputMaybe<CfBlogSubCategoryNestedFilter>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tagsFilter_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogListHeroBlogsListCollection = {
  __typename?: 'BlogListHeroBlogsListCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListHeroBlogsListCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListHeroBlogsListCursorCollection = {
  __typename?: 'BlogListHeroBlogsListCursorCollection';
  items: Array<Maybe<BlogDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogListHeroBlogsListCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollections = {
  __typename?: 'BlogListLinkingCollections';
  blogListPageCollection?: Maybe<BlogListPageCollection>;
  blogListPageCursorCollection?: Maybe<BlogListPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type BlogListLinkingCollectionsBlogListPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsBlogListPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsBlogListPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsBlogListPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogListLinkingCollectionsBlogListPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogListLinkingCollectionsBlogListPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogListLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type BlogListLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type BlogListLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogListOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPage = Entry & _Node & {
  __typename?: 'BlogListPage';
  _id: Scalars['ID']['output'];
  blogList?: Maybe<BlogList>;
  brand?: Maybe<Brand>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentAfterListCollection?: Maybe<BlogListPageContentAfterListCollection>;
  contentAfterListCursorCollection?: Maybe<BlogListPageContentAfterListCursorCollection>;
  contentListCollection?: Maybe<BlogListPageContentListCollection>;
  contentListCursorCollection?: Maybe<BlogListPageContentListCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<BlogListPageDescription>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<BlogListPageLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shouldDisplayCategoryFilterChips?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageBlogListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogListFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageContentAfterListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageContentAfterListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SingleMessageFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageContentAfterListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageContentAfterListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SingleMessageFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageContentListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageContentListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogListFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageContentListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageContentListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogListFilter>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageShouldDisplayCategoryFilterChipsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog List Page to display the list of blogs for an app with other contents like Title, Hero etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogListPage) */
export type BlogListPageVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogListPageCollection = {
  __typename?: 'BlogListPageCollection';
  items: Array<Maybe<BlogListPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListPageContentAfterListCollection = {
  __typename?: 'BlogListPageContentAfterListCollection';
  items: Array<Maybe<SingleMessage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListPageContentAfterListCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogListPageContentAfterListCursorCollection = {
  __typename?: 'BlogListPageContentAfterListCursorCollection';
  items: Array<Maybe<SingleMessage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogListPageContentAfterListCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogListPageContentListCollection = {
  __typename?: 'BlogListPageContentListCollection';
  items: Array<Maybe<BlogList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogListPageContentListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogListPageContentListCursorCollection = {
  __typename?: 'BlogListPageContentListCursorCollection';
  items: Array<Maybe<BlogList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogListPageContentListCursorCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogListPageCursorCollection = {
  __typename?: 'BlogListPageCursorCollection';
  items: Array<Maybe<BlogListPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogListPageDescription = {
  __typename?: 'BlogListPageDescription';
  json: Scalars['JSON']['output'];
  links: BlogListPageDescriptionLinks;
};

export type BlogListPageDescriptionAssets = {
  __typename?: 'BlogListPageDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlogListPageDescriptionEntries = {
  __typename?: 'BlogListPageDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlogListPageDescriptionLinks = {
  __typename?: 'BlogListPageDescriptionLinks';
  assets: BlogListPageDescriptionAssets;
  entries: BlogListPageDescriptionEntries;
  resources: BlogListPageDescriptionResources;
};

export type BlogListPageDescriptionResources = {
  __typename?: 'BlogListPageDescriptionResources';
  block: Array<BlogListPageDescriptionResourcesBlock>;
  hyperlink: Array<BlogListPageDescriptionResourcesHyperlink>;
  inline: Array<BlogListPageDescriptionResourcesInline>;
};

export type BlogListPageDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'BlogListPageDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type BlogListPageDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'BlogListPageDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type BlogListPageDescriptionResourcesInline = ResourceLink & {
  __typename?: 'BlogListPageDescriptionResourcesInline';
  sys: ResourceSys;
};

export type BlogListPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogListPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogListPageFilter>>>;
  blogList?: InputMaybe<CfBlogListNestedFilter>;
  blogList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAfterList?: InputMaybe<CfSingleMessageNestedFilter>;
  contentAfterListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentList?: InputMaybe<CfBlogListNestedFilter>;
  contentListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shouldDisplayCategoryFilterChips?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCategoryFilterChips_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCategoryFilterChips_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogListPageLinkingCollections = {
  __typename?: 'BlogListPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BlogListPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogListPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogListPageOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategory = Entry & _Node & {
  __typename?: 'BlogSubCategory';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BlogSubCategoryLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategoryBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Blog Sub Category [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/blogSubCategory) */
export type BlogSubCategorySlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogSubCategoryCollection = {
  __typename?: 'BlogSubCategoryCollection';
  items: Array<Maybe<BlogSubCategory>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogSubCategoryCursorCollection = {
  __typename?: 'BlogSubCategoryCursorCollection';
  items: Array<Maybe<BlogSubCategory>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BlogSubCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogSubCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogSubCategoryFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BlogSubCategoryLinkingCollections = {
  __typename?: 'BlogSubCategoryLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  blogListCollection?: Maybe<BlogListCollection>;
  blogListCursorCollection?: Maybe<BlogListCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BlogSubCategoryLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogSubCategoryLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogSubCategoryLinkingCollectionsBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryLinkingCollectionsBlogListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogSubCategoryLinkingCollectionsBlogListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryLinkingCollectionsBlogListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogSubCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlogSubCategoryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogSubCategoryLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogSubCategoryLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BlogSubCategoryLinkingCollectionsBlogListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogSubCategoryLinkingCollectionsBlogListCursorCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BlogSubCategoryOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/bodyText) */
export type BodyText = Entry & _Node & {
  __typename?: 'BodyText';
  _id: Scalars['ID']['output'];
  content?: Maybe<BodyTextContent>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BodyTextLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/bodyText) */
export type BodyTextContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/bodyText) */
export type BodyTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/bodyText) */
export type BodyTextNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BodyTextCollection = {
  __typename?: 'BodyTextCollection';
  items: Array<Maybe<BodyText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BodyTextContent = {
  __typename?: 'BodyTextContent';
  json: Scalars['JSON']['output'];
  links: BodyTextContentLinks;
};

export type BodyTextContentAssets = {
  __typename?: 'BodyTextContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BodyTextContentEntries = {
  __typename?: 'BodyTextContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BodyTextContentLinks = {
  __typename?: 'BodyTextContentLinks';
  assets: BodyTextContentAssets;
  entries: BodyTextContentEntries;
  resources: BodyTextContentResources;
};

export type BodyTextContentResources = {
  __typename?: 'BodyTextContentResources';
  block: Array<BodyTextContentResourcesBlock>;
  hyperlink: Array<BodyTextContentResourcesHyperlink>;
  inline: Array<BodyTextContentResourcesInline>;
};

export type BodyTextContentResourcesBlock = ResourceLink & {
  __typename?: 'BodyTextContentResourcesBlock';
  sys: ResourceSys;
};

export type BodyTextContentResourcesHyperlink = ResourceLink & {
  __typename?: 'BodyTextContentResourcesHyperlink';
  sys: ResourceSys;
};

export type BodyTextContentResourcesInline = ResourceLink & {
  __typename?: 'BodyTextContentResourcesInline';
  sys: ResourceSys;
};

export type BodyTextCursorCollection = {
  __typename?: 'BodyTextCursorCollection';
  items: Array<Maybe<BodyText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BodyTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<BodyTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BodyTextFilter>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BodyTextLinkingCollections = {
  __typename?: 'BodyTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type BodyTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BodyTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BodyTextOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Brands within The Aspen Group [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/brand) */
export type Brand = Entry & _Node & {
  __typename?: 'Brand';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<BrandLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** Brands within The Aspen Group [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/brand) */
export type BrandLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Brands within The Aspen Group [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/brand) */
export type BrandNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Brands within The Aspen Group [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/brand) */
export type BrandTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandCollection = {
  __typename?: 'BrandCollection';
  items: Array<Maybe<Brand>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BrandCursorCollection = {
  __typename?: 'BrandCursorCollection';
  items: Array<Maybe<Brand>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BrandFilter = {
  AND?: InputMaybe<Array<InputMaybe<BrandFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BrandFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BrandLinkingCollections = {
  __typename?: 'BrandLinkingCollections';
  appointmentBookingPageCollection?: Maybe<AppointmentBookingPageCollection>;
  appointmentBookingPageCursorCollection?: Maybe<AppointmentBookingPageCursorCollection>;
  blogCategoryCollection?: Maybe<BlogCategoryCollection>;
  blogCategoryCursorCollection?: Maybe<BlogCategoryCursorCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  blogListCollection?: Maybe<BlogListCollection>;
  blogListCursorCollection?: Maybe<BlogListCursorCollection>;
  blogListPageCollection?: Maybe<BlogListPageCollection>;
  blogListPageCursorCollection?: Maybe<BlogListPageCursorCollection>;
  blogSubCategoryCollection?: Maybe<BlogSubCategoryCollection>;
  blogSubCategoryCursorCollection?: Maybe<BlogSubCategoryCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  productCollection?: Maybe<ProductCollection>;
  productCursorCollection?: Maybe<ProductCursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  quizCollection?: Maybe<QuizCollection>;
  quizCursorCollection?: Maybe<QuizCursorCollection>;
};


export type BrandLinkingCollectionsAppointmentBookingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsAppointmentBookingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsAppointmentBookingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsAppointmentBookingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogCategoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogListPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogListPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogListPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogListPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogSubCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogSubCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsBlogSubCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsBlogSubCategoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsProductCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsProductCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsProductCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsQuizCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsQuizCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BrandLinkingCollectionsQuizCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandLinkingCollectionsQuizCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandLinkingCollectionsAppointmentBookingPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'enableBirdEyeChatBot_ASC'
  | 'enableBirdEyeChatBot_DESC'
  | 'enableFraudCheck_ASC'
  | 'enableFraudCheck_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BrandLinkingCollectionsAppointmentBookingPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'enableBirdEyeChatBot_ASC'
  | 'enableBirdEyeChatBot_DESC'
  | 'enableFraudCheck_ASC'
  | 'enableFraudCheck_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BrandLinkingCollectionsBlogCategoryCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsBlogCategoryCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BrandLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type BrandLinkingCollectionsBlogListCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BrandLinkingCollectionsBlogListCursorCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'cardDesignType_ASC'
  | 'cardDesignType_DESC'
  | 'countAcrossDesktop_ASC'
  | 'countAcrossDesktop_DESC'
  | 'countAcrossMobile_ASC'
  | 'countAcrossMobile_DESC'
  | 'displayType_ASC'
  | 'displayType_DESC'
  | 'hasPagination_ASC'
  | 'hasPagination_DESC'
  | 'loadMoreButtonLabel_ASC'
  | 'loadMoreButtonLabel_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BrandLinkingCollectionsBlogListPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BrandLinkingCollectionsBlogListPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type BrandLinkingCollectionsBlogSubCategoryCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsBlogSubCategoryCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsProductCollectionOrder =
  | 'brandfolderImageAssetUrl_ASC'
  | 'brandfolderImageAssetUrl_DESC'
  | 'category_ASC'
  | 'category_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disclaimer_ASC'
  | 'disclaimer_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subCategory_ASC'
  | 'subCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsProductCursorCollectionOrder =
  | 'brandfolderImageAssetUrl_ASC'
  | 'brandfolderImageAssetUrl_DESC'
  | 'category_ASC'
  | 'category_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disclaimer_ASC'
  | 'disclaimer_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subCategory_ASC'
  | 'subCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsQuizCollectionOrder =
  | 'clearChoicePoorCreditRedirectPath_ASC'
  | 'clearChoicePoorCreditRedirectPath_DESC'
  | 'isFormBuilder_ASC'
  | 'isFormBuilder_DESC'
  | 'leadGenPopUpImageDesktop_ASC'
  | 'leadGenPopUpImageDesktop_DESC'
  | 'leadGenPopUpImageMobile_ASC'
  | 'leadGenPopUpImageMobile_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizType_ASC'
  | 'quizType_DESC'
  | 'submitEndpointUrl_ASC'
  | 'submitEndpointUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandLinkingCollectionsQuizCursorCollectionOrder =
  | 'clearChoicePoorCreditRedirectPath_ASC'
  | 'clearChoicePoorCreditRedirectPath_DESC'
  | 'isFormBuilder_ASC'
  | 'isFormBuilder_DESC'
  | 'leadGenPopUpImageDesktop_ASC'
  | 'leadGenPopUpImageDesktop_DESC'
  | 'leadGenPopUpImageMobile_ASC'
  | 'leadGenPopUpImageMobile_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizType_ASC'
  | 'quizType_DESC'
  | 'submitEndpointUrl_ASC'
  | 'submitEndpointUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type BrandOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type Button = Entry & _Node & {
  __typename?: 'Button';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  buttonLink?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']['output']>;
  iconPosition?: Maybe<Scalars['String']['output']>;
  iconSize?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  launchCrestaAgent?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ButtonLinkingCollections>;
  mobileButton?: Maybe<MobileButton>;
  name?: Maybe<Scalars['String']['output']>;
  navigationDetails?: Maybe<NavigationLink>;
  popoverContentCollection?: Maybe<ButtonPopoverContentCollection>;
  popoverContentCursorCollection?: Maybe<ButtonPopoverContentCursorCollection>;
  quizDetails?: Maybe<Quiz>;
  quizSelector?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonButtonLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonIconSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonLaunchCrestaAgentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonMobileButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MobileButtonFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonNavigationDetailsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonPopoverContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonPopoverContentFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonPopoverContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonPopoverContentFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonQuizDetailsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuizFilter>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonQuizSelectorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/button) */
export type ButtonVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonCollection = {
  __typename?: 'ButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ButtonCursorCollection = {
  __typename?: 'ButtonCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ButtonFilter = {
  AND?: InputMaybe<Array<InputMaybe<ButtonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ButtonFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Scalars['String']['input']>;
  iconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize?: InputMaybe<Scalars['String']['input']>;
  iconSize_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize_not?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  launchCrestaAgent?: InputMaybe<Scalars['Boolean']['input']>;
  launchCrestaAgent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  launchCrestaAgent_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileButton?: InputMaybe<CfMobileButtonNestedFilter>;
  mobileButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationDetails?: InputMaybe<CfNavigationLinkNestedFilter>;
  navigationDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  popoverContent?: InputMaybe<CfpopoverContentMultiTypeNestedFilter>;
  popoverContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizDetails?: InputMaybe<CfQuizNestedFilter>;
  quizDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizSelector?: InputMaybe<Scalars['String']['input']>;
  quizSelector_contains?: InputMaybe<Scalars['String']['input']>;
  quizSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizSelector_not?: InputMaybe<Scalars['String']['input']>;
  quizSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  quizSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ButtonLinkingCollections = {
  __typename?: 'ButtonLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  accordionsCursorCollection?: Maybe<AccordionsCursorCollection>;
  adFooterCollection?: Maybe<AdFooterCollection>;
  adFooterCursorCollection?: Maybe<AdFooterCursorCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  cardCollection?: Maybe<CardCollection>;
  cardCursorCollection?: Maybe<CardCursorCollection>;
  categoryPickerCollection?: Maybe<CategoryPickerCollection>;
  categoryPickerCursorCollection?: Maybe<CategoryPickerCursorCollection>;
  contentTypeRichTextCollection?: Maybe<ContentTypeRichTextCollection>;
  contentTypeRichTextCursorCollection?: Maybe<ContentTypeRichTextCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  error404Collection?: Maybe<Error404Collection>;
  error404CursorCollection?: Maybe<Error404CursorCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  googleMapTemplateCursorCollection?: Maybe<GoogleMapTemplateCursorCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  multiCardV2CursorCollection?: Maybe<MultiCardV2CursorCollection>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  odpHeroCursorCollection?: Maybe<OdpHeroCursorCollection>;
  patientReviewsV2Collection?: Maybe<PatientReviewsV2Collection>;
  patientReviewsV2CursorCollection?: Maybe<PatientReviewsV2CursorCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureCursorCollection?: Maybe<ProductFeatureCursorCollection>;
  quickLinksCollection?: Maybe<QuickLinksCollection>;
  quickLinksCursorCollection?: Maybe<QuickLinksCursorCollection>;
  serviceCollection?: Maybe<ServiceCollection>;
  serviceCursorCollection?: Maybe<ServiceCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  singleMessageCursorCollection?: Maybe<SingleMessageCursorCollection>;
  triggeredContentModalCollection?: Maybe<TriggeredContentModalCollection>;
  triggeredContentModalCursorCollection?: Maybe<TriggeredContentModalCursorCollection>;
  videoCarouselCollection?: Maybe<VideoCarouselCollection>;
  videoCarouselCursorCollection?: Maybe<VideoCarouselCursorCollection>;
  videoWithContentCollection?: Maybe<VideoWithContentCollection>;
  videoWithContentCursorCollection?: Maybe<VideoWithContentCursorCollection>;
};


export type ButtonLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsAccordionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsAccordionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsAdFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsAdFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsAdFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsCategoryPickerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsCategoryPickerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsCategoryPickerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsCategoryPickerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsContentTypeRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsContentTypeRichTextCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsContentTypeRichTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsContentTypeRichTextCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsError404CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsError404CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsError404CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsError404CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsGoogleMapTemplateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsGoogleMapTemplateCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsGoogleMapTemplateCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHalfScreenCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsHeroV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsMultiCardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsMultiCardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsMultiCardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsOdpHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsOdpHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsOdpHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsPatientReviewsV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsPatientReviewsV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsPatientReviewsV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsPatientReviewsV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsProductFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsProductFeatureCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsQuickLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsQuickLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsServiceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsServiceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsServiceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsSingleMessageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsSingleMessageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsTriggeredContentModalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsTriggeredContentModalCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsTriggeredContentModalCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsTriggeredContentModalCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsVideoCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsVideoCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsVideoCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsVideoCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsVideoWithContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsVideoWithContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ButtonLinkingCollectionsVideoWithContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonLinkingCollectionsVideoWithContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ButtonLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ButtonLinkingCollectionsAccordionsCursorCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ButtonLinkingCollectionsAdFooterCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsAdFooterCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsCardCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsCategoryPickerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsCategoryPickerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsContentTypeRichTextCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsContentTypeRichTextCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsError404CollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsError404CursorCollectionOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsGoogleMapTemplateCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type ButtonLinkingCollectionsGoogleMapTemplateCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type ButtonLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsHalfScreenCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsHeroV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsMultiCardV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsMultiCardV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsOdpHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsOdpHeroCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ButtonLinkingCollectionsPatientReviewsV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type ButtonLinkingCollectionsPatientReviewsV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type ButtonLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsProductFeatureCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsQuickLinksCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'displayAsTitles_ASC'
  | 'displayAsTitles_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC';

export type ButtonLinkingCollectionsQuickLinksCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'displayAsTitles_ASC'
  | 'displayAsTitles_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC';

export type ButtonLinkingCollectionsServiceCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type ButtonLinkingCollectionsServiceCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type ButtonLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsSingleMessageCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonLinkingCollectionsTriggeredContentModalCollectionOrder =
  | 'bodyTextAlign_ASC'
  | 'bodyTextAlign_DESC'
  | 'delay_ASC'
  | 'delay_DESC'
  | 'dismissLabel_ASC'
  | 'dismissLabel_DESC'
  | 'modalId_ASC'
  | 'modalId_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trigger_ASC'
  | 'trigger_DESC';

export type ButtonLinkingCollectionsTriggeredContentModalCursorCollectionOrder =
  | 'bodyTextAlign_ASC'
  | 'bodyTextAlign_DESC'
  | 'delay_ASC'
  | 'delay_DESC'
  | 'dismissLabel_ASC'
  | 'dismissLabel_DESC'
  | 'modalId_ASC'
  | 'modalId_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trigger_ASC'
  | 'trigger_DESC';

export type ButtonLinkingCollectionsVideoCarouselCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsVideoCarouselCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsVideoWithContentCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonLinkingCollectionsVideoWithContentCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ButtonOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ButtonPopoverContentCollection = {
  __typename?: 'ButtonPopoverContentCollection';
  items: Array<Maybe<ButtonPopoverContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ButtonPopoverContentCursorCollection = {
  __typename?: 'ButtonPopoverContentCursorCollection';
  items: Array<Maybe<ButtonPopoverContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ButtonPopoverContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<ButtonPopoverContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ButtonPopoverContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ButtonPopoverContentItem = Iframe | MultiCardV2;

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type Card = Entry & _Node & {
  __typename?: 'Card';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonIcon?: Maybe<Scalars['String']['output']>;
  buttonIconPosition?: Maybe<Scalars['String']['output']>;
  buttonIconSize?: Maybe<Scalars['String']['output']>;
  buttonSize?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  buttonVariant?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<CardButtonsCollection>;
  buttonsCursorCollection?: Maybe<CardButtonsCursorCollection>;
  cardIcon?: Maybe<Scalars['String']['output']>;
  cardIconAlignment?: Maybe<Scalars['String']['output']>;
  cardTextAlignment?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  focalPointImage?: Maybe<FocalPointImage>;
  image?: Maybe<Asset>;
  imageAsset?: Maybe<ImageAsset>;
  imageRatio?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CardLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  pdfDownloadTitle?: Maybe<Scalars['String']['output']>;
  pdfFileLink?: Maybe<Asset>;
  priority?: Maybe<Scalars['Int']['output']>;
  richTextDescription?: Maybe<CardRichTextDescription>;
  showBorder?: Maybe<Scalars['Boolean']['output']>;
  slot?: Maybe<Scalars['Int']['output']>;
  stepName?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tc?: Maybe<TermsAndConditions>;
  tcText?: Maybe<Scalars['String']['output']>;
  tcUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonIconSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardCardIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardCardIconAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardCardTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardEventTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardFocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardImageRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardImageUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardPdfDownloadTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardPdfFileLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardPriorityArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardRichTextDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardShowBorderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardSlotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardStepNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTcArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTcTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTcUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/card) */
export type CardTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardButtonsCollection = {
  __typename?: 'CardButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CardButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CardButtonsCursorCollection = {
  __typename?: 'CardButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CardButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CardCollection = {
  __typename?: 'CardCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CardCursorCollection = {
  __typename?: 'CardCursorCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CardFilter = {
  AND?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconPosition_not?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconSize?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon_not?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize?: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonVariant?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_contains?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonVariant_not?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIcon?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIconAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIconAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_contains?: InputMaybe<Scalars['String']['input']>;
  cardIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_not?: InputMaybe<Scalars['String']['input']>;
  cardIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTextAlignment?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardTextAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTextAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventType_contains?: InputMaybe<Scalars['String']['input']>;
  eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType_not?: InputMaybe<Scalars['String']['input']>;
  eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRatio?: InputMaybe<Scalars['String']['input']>;
  imageRatio_contains?: InputMaybe<Scalars['String']['input']>;
  imageRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRatio_not?: InputMaybe<Scalars['String']['input']>;
  imageRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  imageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl_not?: InputMaybe<Scalars['String']['input']>;
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfDownloadTitle?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pdfDownloadTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfDownloadTitle_not?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfFileLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  priority_exists?: InputMaybe<Scalars['Boolean']['input']>;
  priority_gt?: InputMaybe<Scalars['Int']['input']>;
  priority_gte?: InputMaybe<Scalars['Int']['input']>;
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priority_lt?: InputMaybe<Scalars['Int']['input']>;
  priority_lte?: InputMaybe<Scalars['Int']['input']>;
  priority_not?: InputMaybe<Scalars['Int']['input']>;
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  showBorder?: InputMaybe<Scalars['Boolean']['input']>;
  showBorder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showBorder_not?: InputMaybe<Scalars['Boolean']['input']>;
  slot?: InputMaybe<Scalars['Int']['input']>;
  slot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slot_gt?: InputMaybe<Scalars['Int']['input']>;
  slot_gte?: InputMaybe<Scalars['Int']['input']>;
  slot_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slot_lt?: InputMaybe<Scalars['Int']['input']>;
  slot_lte?: InputMaybe<Scalars['Int']['input']>;
  slot_not?: InputMaybe<Scalars['Int']['input']>;
  slot_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepName?: InputMaybe<Scalars['String']['input']>;
  stepName_contains?: InputMaybe<Scalars['String']['input']>;
  stepName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepName_not?: InputMaybe<Scalars['String']['input']>;
  stepName_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tc?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  tcText?: InputMaybe<Scalars['String']['input']>;
  tcText_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText_not?: InputMaybe<Scalars['String']['input']>;
  tcText_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcUrl?: InputMaybe<Scalars['String']['input']>;
  tcUrl_contains?: InputMaybe<Scalars['String']['input']>;
  tcUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcUrl_not?: InputMaybe<Scalars['String']['input']>;
  tcUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CardLinkingCollections = {
  __typename?: 'CardLinkingCollections';
  carouselCollection?: Maybe<CarouselCollection>;
  carouselCursorCollection?: Maybe<CarouselCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  multiCardV2CursorCollection?: Maybe<MultiCardV2CursorCollection>;
};


export type CardLinkingCollectionsCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CardLinkingCollectionsCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CardLinkingCollectionsMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsMultiCardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CardLinkingCollectionsMultiCardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsMultiCardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardLinkingCollectionsCarouselCollectionOrder =
  | 'arrowsColor_ASC'
  | 'arrowsColor_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRounded_ASC'
  | 'imageRounded_DESC'
  | 'imageWidth_ASC'
  | 'imageWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quotesColor_ASC'
  | 'quotesColor_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CardLinkingCollectionsCarouselCursorCollectionOrder =
  | 'arrowsColor_ASC'
  | 'arrowsColor_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRounded_ASC'
  | 'imageRounded_DESC'
  | 'imageWidth_ASC'
  | 'imageWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quotesColor_ASC'
  | 'quotesColor_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CardLinkingCollectionsMultiCardV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CardLinkingCollectionsMultiCardV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CardOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CardRichTextDescription = {
  __typename?: 'CardRichTextDescription';
  json: Scalars['JSON']['output'];
  links: CardRichTextDescriptionLinks;
};

export type CardRichTextDescriptionAssets = {
  __typename?: 'CardRichTextDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CardRichTextDescriptionEntries = {
  __typename?: 'CardRichTextDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CardRichTextDescriptionLinks = {
  __typename?: 'CardRichTextDescriptionLinks';
  assets: CardRichTextDescriptionAssets;
  entries: CardRichTextDescriptionEntries;
  resources: CardRichTextDescriptionResources;
};

export type CardRichTextDescriptionResources = {
  __typename?: 'CardRichTextDescriptionResources';
  block: Array<CardRichTextDescriptionResourcesBlock>;
  hyperlink: Array<CardRichTextDescriptionResourcesHyperlink>;
  inline: Array<CardRichTextDescriptionResourcesInline>;
};

export type CardRichTextDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'CardRichTextDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type CardRichTextDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'CardRichTextDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type CardRichTextDescriptionResourcesInline = ResourceLink & {
  __typename?: 'CardRichTextDescriptionResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type Carousel = Entry & _Node & {
  __typename?: 'Carousel';
  _id: Scalars['ID']['output'];
  arrowsColor?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  imageRounded?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<CarouselLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  quotesColor?: Maybe<Scalars['String']['output']>;
  rotationContentCollection?: Maybe<CarouselRotationContentCollection>;
  rotationContentCursorCollection?: Maybe<CarouselRotationContentCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselArrowsColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselImageRoundedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselImageWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselQuotesColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselRotationContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CarouselRotationContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselRotationContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CarouselRotationContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/carousel) */
export type CarouselTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarouselCollection = {
  __typename?: 'CarouselCollection';
  items: Array<Maybe<Carousel>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CarouselCursorCollection = {
  __typename?: 'CarouselCursorCollection';
  items: Array<Maybe<Carousel>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CarouselFilter = {
  AND?: InputMaybe<Array<InputMaybe<CarouselFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CarouselFilter>>>;
  arrowsColor?: InputMaybe<Scalars['String']['input']>;
  arrowsColor_contains?: InputMaybe<Scalars['String']['input']>;
  arrowsColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  arrowsColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrowsColor_not?: InputMaybe<Scalars['String']['input']>;
  arrowsColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  arrowsColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRounded?: InputMaybe<Scalars['String']['input']>;
  imageRounded_contains?: InputMaybe<Scalars['String']['input']>;
  imageRounded_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRounded_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRounded_not?: InputMaybe<Scalars['String']['input']>;
  imageRounded_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageRounded_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  imageWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageWidth_gt?: InputMaybe<Scalars['Int']['input']>;
  imageWidth_gte?: InputMaybe<Scalars['Int']['input']>;
  imageWidth_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  imageWidth_lt?: InputMaybe<Scalars['Int']['input']>;
  imageWidth_lte?: InputMaybe<Scalars['Int']['input']>;
  imageWidth_not?: InputMaybe<Scalars['Int']['input']>;
  imageWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quotesColor?: InputMaybe<Scalars['String']['input']>;
  quotesColor_contains?: InputMaybe<Scalars['String']['input']>;
  quotesColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quotesColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quotesColor_not?: InputMaybe<Scalars['String']['input']>;
  quotesColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  quotesColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rotationContent?: InputMaybe<CfrotationContentMultiTypeNestedFilter>;
  rotationContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CarouselLinkingCollections = {
  __typename?: 'CarouselLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type CarouselLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarouselLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarouselLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CarouselLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CarouselLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CarouselLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarouselLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CarouselLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CarouselOrder =
  | 'arrowsColor_ASC'
  | 'arrowsColor_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRounded_ASC'
  | 'imageRounded_DESC'
  | 'imageWidth_ASC'
  | 'imageWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quotesColor_ASC'
  | 'quotesColor_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CarouselRotationContentCollection = {
  __typename?: 'CarouselRotationContentCollection';
  items: Array<Maybe<CarouselRotationContentItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CarouselRotationContentCursorCollection = {
  __typename?: 'CarouselRotationContentCursorCollection';
  items: Array<Maybe<CarouselRotationContentItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CarouselRotationContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<CarouselRotationContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CarouselRotationContentFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CarouselRotationContentItem = Card | Service | SingleMessage;

/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type Category = Entry & _Node & {
  __typename?: 'Category';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']['output']>;
  imageAsset?: Maybe<ImageAsset>;
  isLocalized?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CategoryLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryIsLocalizedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Category for the Categories Array within the Category Picker [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/category) */
export type CategoryTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryCollection = {
  __typename?: 'CategoryCollection';
  items: Array<Maybe<Category>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryCursorCollection = {
  __typename?: 'CategoryCursorCollection';
  items: Array<Maybe<Category>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_contains?: InputMaybe<Scalars['String']['input']>;
  link_exists?: InputMaybe<Scalars['Boolean']['input']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not?: InputMaybe<Scalars['String']['input']>;
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CategoryLinkingCollections = {
  __typename?: 'CategoryLinkingCollections';
  categoryPickerCollection?: Maybe<CategoryPickerCollection>;
  categoryPickerCursorCollection?: Maybe<CategoryPickerCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type CategoryLinkingCollectionsCategoryPickerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryLinkingCollectionsCategoryPickerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryLinkingCollectionsCategoryPickerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryLinkingCollectionsCategoryPickerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryLinkingCollectionsCategoryPickerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CategoryLinkingCollectionsCategoryPickerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CategoryOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPicker = Entry & _Node & {
  __typename?: 'CategoryPicker';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<CategoryPickerButtonsCollection>;
  buttonsCursorCollection?: Maybe<CategoryPickerButtonsCursorCollection>;
  categoriesCollection?: Maybe<CategoryPickerCategoriesCollection>;
  categoriesCursorCollection?: Maybe<CategoryPickerCategoriesCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentTypeRichText>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowHeading?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CategoryPickerLinkingCollections>;
  mobileThreshold?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  setTwoRows?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHeading?: Maybe<Scalars['String']['output']>;
  transparentCategories?: Maybe<Scalars['Boolean']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerCategoriesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerCategoriesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerCategoriesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerEyebrowHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerMobileThresholdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerSetTwoRowsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerTitleHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerTransparentCategoriesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/categoryPicker) */
export type CategoryPickerVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryPickerButtonsCollection = {
  __typename?: 'CategoryPickerButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryPickerButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CategoryPickerButtonsCursorCollection = {
  __typename?: 'CategoryPickerButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CategoryPickerButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type CategoryPickerCategoriesCollection = {
  __typename?: 'CategoryPickerCategoriesCollection';
  items: Array<Maybe<Category>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryPickerCategoriesCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerCategoriesCursorCollection = {
  __typename?: 'CategoryPickerCategoriesCursorCollection';
  items: Array<Maybe<Category>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CategoryPickerCategoriesCursorCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerCollection = {
  __typename?: 'CategoryPickerCollection';
  items: Array<Maybe<CategoryPicker>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CategoryPickerCursorCollection = {
  __typename?: 'CategoryPickerCursorCollection';
  items: Array<Maybe<CategoryPicker>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CategoryPickerFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategoryPickerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategoryPickerFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<CfCategoryNestedFilter>;
  categoriesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHeading_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileThreshold?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mobileThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  mobileThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setTwoRows?: InputMaybe<Scalars['Boolean']['input']>;
  setTwoRows_exists?: InputMaybe<Scalars['Boolean']['input']>;
  setTwoRows_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transparentCategories?: InputMaybe<Scalars['Boolean']['input']>;
  transparentCategories_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transparentCategories_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CategoryPickerLinkingCollections = {
  __typename?: 'CategoryPickerLinkingCollections';
  appointmentBookingPageCollection?: Maybe<AppointmentBookingPageCollection>;
  appointmentBookingPageCursorCollection?: Maybe<AppointmentBookingPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type CategoryPickerLinkingCollectionsAppointmentBookingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsAppointmentBookingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsAppointmentBookingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsAppointmentBookingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CategoryPickerLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryPickerLinkingCollectionsAppointmentBookingPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'enableBirdEyeChatBot_ASC'
  | 'enableBirdEyeChatBot_DESC'
  | 'enableFraudCheck_ASC'
  | 'enableFraudCheck_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsAppointmentBookingPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'enableBirdEyeChatBot_ASC'
  | 'enableBirdEyeChatBot_DESC'
  | 'enableFraudCheck_ASC'
  | 'enableFraudCheck_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type CategoryPickerLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type CategoryPickerLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CategoryPickerOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinks = Entry & _Node & {
  __typename?: 'CityLinks';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  groupByState?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<CityLinksLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  useDisplayName?: Maybe<Scalars['Boolean']['output']>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksGroupByStateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A container component for city links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/cityLinks) */
export type CityLinksUseDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CityLinksCollection = {
  __typename?: 'CityLinksCollection';
  items: Array<Maybe<CityLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CityLinksCursorCollection = {
  __typename?: 'CityLinksCursorCollection';
  items: Array<Maybe<CityLinks>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type CityLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<CityLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CityLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  groupByState?: InputMaybe<Scalars['Boolean']['input']>;
  groupByState_exists?: InputMaybe<Scalars['Boolean']['input']>;
  groupByState_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  useDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  useDisplayName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useDisplayName_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CityLinksLinkingCollections = {
  __typename?: 'CityLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type CityLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CityLinksLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CityLinksLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CityLinksLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CityLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CityLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CityLinksLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CityLinksLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CityLinksLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CityLinksLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CityLinksLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type CityLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type CityLinksLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CityLinksLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type CityLinksOrder =
  | 'groupByState_ASC'
  | 'groupByState_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDisplayName_ASC'
  | 'useDisplayName_DESC';

/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type Columns = Entry & _Node & {
  __typename?: 'Columns';
  _id: Scalars['ID']['output'];
  allowEqualHeights?: Maybe<Scalars['Boolean']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  columnsCollection?: Maybe<ColumnsColumnsCollection>;
  columnsCursorCollection?: Maybe<ColumnsColumnsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ColumnsLinkingCollections>;
  mobileDisplayAccordion?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsAllowEqualHeightsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ColumnsColumnsFilter>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ColumnsColumnsFilter>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsMobileDisplayAccordionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Create a multi-column experience. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/columns) */
export type ColumnsTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColumnsCollection = {
  __typename?: 'ColumnsCollection';
  items: Array<Maybe<Columns>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ColumnsColumnsCollection = {
  __typename?: 'ColumnsColumnsCollection';
  items: Array<Maybe<ColumnsColumnsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ColumnsColumnsCursorCollection = {
  __typename?: 'ColumnsColumnsCursorCollection';
  items: Array<Maybe<ColumnsColumnsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ColumnsColumnsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ColumnsColumnsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ColumnsColumnsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ColumnsColumnsItem = Accordions | ContentTypeRichText | ImageAsset | SchemaStep | SingleMessage;

export type ColumnsCursorCollection = {
  __typename?: 'ColumnsCursorCollection';
  items: Array<Maybe<Columns>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ColumnsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ColumnsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ColumnsFilter>>>;
  allowEqualHeights?: InputMaybe<Scalars['Boolean']['input']>;
  allowEqualHeights_exists?: InputMaybe<Scalars['Boolean']['input']>;
  allowEqualHeights_not?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columns?: InputMaybe<CfcolumnsMultiTypeNestedFilter>;
  columnsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileDisplayAccordion?: InputMaybe<Scalars['Boolean']['input']>;
  mobileDisplayAccordion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileDisplayAccordion_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ColumnsLinkingCollections = {
  __typename?: 'ColumnsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type ColumnsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ColumnsLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ColumnsLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ColumnsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ColumnsLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ColumnsOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStep = Entry & _Node & {
  __typename?: 'ConfirmationStep';
  _id: Scalars['ID']['output'];
  accountNumberText?: Maybe<Scalars['String']['output']>;
  cardInfoText?: Maybe<Scalars['String']['output']>;
  confirmationPageName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  copyTextButtonText?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ConfirmationStepLinkingCollections>;
  marketingContent?: Maybe<MultiCardV2>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
  successCardsCollection?: Maybe<ConfirmationStepSuccessCardsCollection>;
  successCardsCursorCollection?: Maybe<ConfirmationStepSuccessCardsCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepAccountNumberTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepCardInfoTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepConfirmationPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepCopyTextButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepFooterTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepMarketingContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MultiCardV2Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepStepNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepSuccessCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepSuccessCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SuccessCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/confirmationStep) */
export type ConfirmationStepSuccessCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepSuccessCardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SuccessCardFilter>;
};

export type ConfirmationStepCollection = {
  __typename?: 'ConfirmationStepCollection';
  items: Array<Maybe<ConfirmationStep>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConfirmationStepCursorCollection = {
  __typename?: 'ConfirmationStepCursorCollection';
  items: Array<Maybe<ConfirmationStep>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ConfirmationStepFilter = {
  AND?: InputMaybe<Array<InputMaybe<ConfirmationStepFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ConfirmationStepFilter>>>;
  accountNumberText?: InputMaybe<Scalars['String']['input']>;
  accountNumberText_contains?: InputMaybe<Scalars['String']['input']>;
  accountNumberText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  accountNumberText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accountNumberText_not?: InputMaybe<Scalars['String']['input']>;
  accountNumberText_not_contains?: InputMaybe<Scalars['String']['input']>;
  accountNumberText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardInfoText?: InputMaybe<Scalars['String']['input']>;
  cardInfoText_contains?: InputMaybe<Scalars['String']['input']>;
  cardInfoText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardInfoText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardInfoText_not?: InputMaybe<Scalars['String']['input']>;
  cardInfoText_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardInfoText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationPageName?: InputMaybe<Scalars['String']['input']>;
  confirmationPageName_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationPageName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationPageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationPageName_not?: InputMaybe<Scalars['String']['input']>;
  confirmationPageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationPageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyTextButtonText?: InputMaybe<Scalars['String']['input']>;
  copyTextButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  copyTextButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyTextButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyTextButtonText_not?: InputMaybe<Scalars['String']['input']>;
  copyTextButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyTextButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  footerText_contains?: InputMaybe<Scalars['String']['input']>;
  footerText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footerText_not?: InputMaybe<Scalars['String']['input']>;
  footerText_not_contains?: InputMaybe<Scalars['String']['input']>;
  footerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  marketingContent?: InputMaybe<CfMultiCardV2NestedFilter>;
  marketingContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepNumber?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  successCards?: InputMaybe<CfSuccessCardNestedFilter>;
  successCardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ConfirmationStepLinkingCollections = {
  __typename?: 'ConfirmationStepLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  stepperCollection?: Maybe<StepperCollection>;
  stepperCursorCollection?: Maybe<StepperCursorCollection>;
};


export type ConfirmationStepLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConfirmationStepLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConfirmationStepLinkingCollectionsStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepLinkingCollectionsStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConfirmationStepLinkingCollectionsStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepLinkingCollectionsStepperCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfirmationStepLinkingCollectionsStepperCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ConfirmationStepLinkingCollectionsStepperCursorCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ConfirmationStepOrder =
  | 'accountNumberText_ASC'
  | 'accountNumberText_DESC'
  | 'cardInfoText_ASC'
  | 'cardInfoText_DESC'
  | 'confirmationPageName_ASC'
  | 'confirmationPageName_DESC'
  | 'copyTextButtonText_ASC'
  | 'copyTextButtonText_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ConfirmationStepSuccessCardsCollection = {
  __typename?: 'ConfirmationStepSuccessCardsCollection';
  items: Array<Maybe<SuccessCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConfirmationStepSuccessCardsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'imageAltText_ASC'
  | 'imageAltText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleText_ASC'
  | 'titleText_DESC';

export type ConfirmationStepSuccessCardsCursorCollection = {
  __typename?: 'ConfirmationStepSuccessCardsCursorCollection';
  items: Array<Maybe<SuccessCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ConfirmationStepSuccessCardsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'imageAltText_ASC'
  | 'imageAltText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleText_ASC'
  | 'titleText_DESC';

/** A holder for any type of data with JSON, associate it with a custom editor if needed. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentData) */
export type ContentData = Entry & _Node & {
  __typename?: 'ContentData';
  _id: Scalars['ID']['output'];
  content?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ContentDataLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A holder for any type of data with JSON, associate it with a custom editor if needed. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentData) */
export type ContentDataContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A holder for any type of data with JSON, associate it with a custom editor if needed. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentData) */
export type ContentDataLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A holder for any type of data with JSON, associate it with a custom editor if needed. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentData) */
export type ContentDataNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentDataCollection = {
  __typename?: 'ContentDataCollection';
  items: Array<Maybe<ContentData>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentDataCursorCollection = {
  __typename?: 'ContentDataCursorCollection';
  items: Array<Maybe<ContentData>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContentDataFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentDataFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentDataFilter>>>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ContentDataLinkingCollections = {
  __typename?: 'ContentDataLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ContentDataLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentDataLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentDataOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSection = Entry & _Node & {
  __typename?: 'ContentSection';
  _id: Scalars['ID']['output'];
  alignment?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentSectionDescription>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowHtag?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentSectionLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  titleIcon?: Maybe<Scalars['String']['output']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionEyebrowHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for common section fields like eyebrow, title, description and choosing heading levels [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentSection) */
export type ContentSectionTitleIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSectionCollection = {
  __typename?: 'ContentSectionCollection';
  items: Array<Maybe<ContentSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentSectionCursorCollection = {
  __typename?: 'ContentSectionCursorCollection';
  items: Array<Maybe<ContentSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContentSectionDescription = {
  __typename?: 'ContentSectionDescription';
  json: Scalars['JSON']['output'];
  links: ContentSectionDescriptionLinks;
};

export type ContentSectionDescriptionAssets = {
  __typename?: 'ContentSectionDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentSectionDescriptionEntries = {
  __typename?: 'ContentSectionDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentSectionDescriptionLinks = {
  __typename?: 'ContentSectionDescriptionLinks';
  assets: ContentSectionDescriptionAssets;
  entries: ContentSectionDescriptionEntries;
  resources: ContentSectionDescriptionResources;
};

export type ContentSectionDescriptionResources = {
  __typename?: 'ContentSectionDescriptionResources';
  block: Array<ContentSectionDescriptionResourcesBlock>;
  hyperlink: Array<ContentSectionDescriptionResourcesHyperlink>;
  inline: Array<ContentSectionDescriptionResourcesInline>;
};

export type ContentSectionDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ContentSectionDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ContentSectionDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentSectionDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentSectionDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ContentSectionDescriptionResourcesInline';
  sys: ResourceSys;
};

export type ContentSectionFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentSectionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentSectionFilter>>>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignment_not?: InputMaybe<Scalars['String']['input']>;
  alignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHtag_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon?: InputMaybe<Scalars['String']['input']>;
  titleIcon_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon_not?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentSectionLinkingCollections = {
  __typename?: 'ContentSectionLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  accordionsCursorCollection?: Maybe<AccordionsCursorCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureCursorCollection?: Maybe<ProductFeatureCursorCollection>;
  videoCarouselCollection?: Maybe<VideoCarouselCollection>;
  videoCarouselCursorCollection?: Maybe<VideoCarouselCursorCollection>;
  videoWithContentCollection?: Maybe<VideoWithContentCollection>;
  videoWithContentCursorCollection?: Maybe<VideoWithContentCursorCollection>;
};


export type ContentSectionLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsAccordionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsAccordionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsProductFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsProductFeatureCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsVideoCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsVideoCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsVideoCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsVideoCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsVideoWithContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsVideoWithContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentSectionLinkingCollectionsVideoWithContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionLinkingCollectionsVideoWithContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentSectionLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ContentSectionLinkingCollectionsAccordionsCursorCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ContentSectionLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentSectionLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentSectionLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionLinkingCollectionsProductFeatureCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionLinkingCollectionsVideoCarouselCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionLinkingCollectionsVideoCarouselCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionLinkingCollectionsVideoWithContentCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionLinkingCollectionsVideoWithContentCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentSectionOrder =
  | 'alignment_ASC'
  | 'alignment_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTile = Entry & _Node & {
  __typename?: 'ContentTile';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['JSON']['output']>;
  internalPage?: Maybe<Page>;
  linkedFrom?: Maybe<ContentTileLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileExternalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileInternalPageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content tile with an Image, Title and Description which is used to display in the Header Navigation Menu [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/contentTile) */
export type ContentTileTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentTileCollection = {
  __typename?: 'ContentTileCollection';
  items: Array<Maybe<ContentTile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentTileCursorCollection = {
  __typename?: 'ContentTileCursorCollection';
  items: Array<Maybe<ContentTile>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContentTileFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentTileFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentTileFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalPage?: InputMaybe<CfPageNestedFilter>;
  internalPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentTileLinkingCollections = {
  __typename?: 'ContentTileLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  headerSubNavCollection?: Maybe<HeaderSubNavCollection>;
  headerSubNavCursorCollection?: Maybe<HeaderSubNavCursorCollection>;
};


export type ContentTileLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTileLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTileLinkingCollectionsHeaderSubNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTileLinkingCollectionsHeaderSubNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTileLinkingCollectionsHeaderSubNavCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTileLinkingCollectionsHeaderSubNavCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentTileLinkingCollectionsHeaderSubNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTileLinkingCollectionsHeaderSubNavCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTileOrder =
  | 'description_ASC'
  | 'description_DESC'
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichText = Entry & _Node & {
  __typename?: 'ContentTypeRichText';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<ContentTypeRichTextButtonsCollection>;
  buttonsCursorCollection?: Maybe<ContentTypeRichTextButtonsCursorCollection>;
  centerAlign?: Maybe<Scalars['Boolean']['output']>;
  contained?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<ContentTypeRichTextContent>;
  contentMaxWidth?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  display?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ContentTypeRichTextLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  secondaryContent?: Maybe<ContentTypeRichTextSecondaryContent>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHeading?: Maybe<Scalars['String']['output']>;
  titleIcon?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextCenterAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextContainedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextContentMaxWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextDisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextSecondaryContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextTitleHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/richText) */
export type ContentTypeRichTextTitleIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentTypeRichTextButtonsCollection = {
  __typename?: 'ContentTypeRichTextButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentTypeRichTextButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextButtonsCursorCollection = {
  __typename?: 'ContentTypeRichTextButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContentTypeRichTextButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextCollection = {
  __typename?: 'ContentTypeRichTextCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ContentTypeRichTextContent = {
  __typename?: 'ContentTypeRichTextContent';
  json: Scalars['JSON']['output'];
  links: ContentTypeRichTextContentLinks;
};

export type ContentTypeRichTextContentAssets = {
  __typename?: 'ContentTypeRichTextContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentTypeRichTextContentEntries = {
  __typename?: 'ContentTypeRichTextContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentTypeRichTextContentLinks = {
  __typename?: 'ContentTypeRichTextContentLinks';
  assets: ContentTypeRichTextContentAssets;
  entries: ContentTypeRichTextContentEntries;
  resources: ContentTypeRichTextContentResources;
};

export type ContentTypeRichTextContentResources = {
  __typename?: 'ContentTypeRichTextContentResources';
  block: Array<ContentTypeRichTextContentResourcesBlock>;
  hyperlink: Array<ContentTypeRichTextContentResourcesHyperlink>;
  inline: Array<ContentTypeRichTextContentResourcesInline>;
};

export type ContentTypeRichTextContentResourcesBlock = ResourceLink & {
  __typename?: 'ContentTypeRichTextContentResourcesBlock';
  sys: ResourceSys;
};

export type ContentTypeRichTextContentResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentTypeRichTextContentResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentTypeRichTextContentResourcesInline = ResourceLink & {
  __typename?: 'ContentTypeRichTextContentResourcesInline';
  sys: ResourceSys;
};

export type ContentTypeRichTextCursorCollection = {
  __typename?: 'ContentTypeRichTextCursorCollection';
  items: Array<Maybe<ContentTypeRichText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ContentTypeRichTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContentTypeRichTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContentTypeRichTextFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contained?: InputMaybe<Scalars['Boolean']['input']>;
  contained_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contained_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryContent_contains?: InputMaybe<Scalars['String']['input']>;
  secondaryContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon?: InputMaybe<Scalars['String']['input']>;
  titleIcon_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon_not?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentTypeRichTextLinkingCollections = {
  __typename?: 'ContentTypeRichTextLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  accordionsCursorCollection?: Maybe<AccordionsCursorCollection>;
  agendaModalCollection?: Maybe<AgendaModalCollection>;
  agendaModalCursorCollection?: Maybe<AgendaModalCursorCollection>;
  agendaStepperCollection?: Maybe<AgendaStepperCollection>;
  agendaStepperCursorCollection?: Maybe<AgendaStepperCursorCollection>;
  bannerCollection?: Maybe<BannerCollection>;
  bannerCursorCollection?: Maybe<BannerCursorCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  categoryPickerCollection?: Maybe<CategoryPickerCollection>;
  categoryPickerCursorCollection?: Maybe<CategoryPickerCursorCollection>;
  columnsCollection?: Maybe<ColumnsCollection>;
  columnsCursorCollection?: Maybe<ColumnsCursorCollection>;
  disclaimerV2Collection?: Maybe<DisclaimerV2Collection>;
  disclaimerV2CursorCollection?: Maybe<DisclaimerV2CursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  localizedServiceTitleCollection?: Maybe<LocalizedServiceTitleCollection>;
  localizedServiceTitleCursorCollection?: Maybe<LocalizedServiceTitleCursorCollection>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  odpHeroCursorCollection?: Maybe<OdpHeroCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureCursorCollection?: Maybe<ProductFeatureCursorCollection>;
  productFeatureDescriptionListItemCollection?: Maybe<ProductFeatureDescriptionListItemCollection>;
  productFeatureDescriptionListItemCursorCollection?: Maybe<ProductFeatureDescriptionListItemCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
};


export type ContentTypeRichTextLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsAccordionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAccordionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsAgendaModalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAgendaModalCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsAgendaModalCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAgendaModalCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsAgendaStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAgendaStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsAgendaStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsAgendaStepperCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsBannerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsBannerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsCategoryPickerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsCategoryPickerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsCategoryPickerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsCategoryPickerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsColumnsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsDisclaimerV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsDisclaimerV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsDisclaimerV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsDisclaimerV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsOdpHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsOdpHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsOdpHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsProductFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsProductFeatureCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContentTypeRichTextLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentTypeRichTextLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ContentTypeRichTextLinkingCollectionsAccordionsCursorCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type ContentTypeRichTextLinkingCollectionsAgendaModalCollectionOrder =
  | 'headlineHeading_ASC'
  | 'headlineHeading_DESC'
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'modalName_ASC'
  | 'modalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsAgendaModalCursorCollectionOrder =
  | 'headlineHeading_ASC'
  | 'headlineHeading_DESC'
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'modalName_ASC'
  | 'modalName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsAgendaStepperCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type ContentTypeRichTextLinkingCollectionsAgendaStepperCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'areStepsCenteredForMobile_ASC'
  | 'areStepsCenteredForMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'hideStepperDot_ASC'
  | 'hideStepperDot_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isHighlightedSteps_ASC'
  | 'isHighlightedSteps_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useNumericStepper_ASC'
  | 'useNumericStepper_DESC';

export type ContentTypeRichTextLinkingCollectionsBannerCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextLinkingCollectionsBannerCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsCategoryPickerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextLinkingCollectionsCategoryPickerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'eyebrowHeading_ASC'
  | 'eyebrowHeading_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'mobileThreshold_ASC'
  | 'mobileThreshold_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'setTwoRows_ASC'
  | 'setTwoRows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'transparentCategories_ASC'
  | 'transparentCategories_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsColumnsCursorCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsDisclaimerV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ContentTypeRichTextLinkingCollectionsDisclaimerV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type ContentTypeRichTextLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ContentTypeRichTextLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCollectionOrder =
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsLocalizedServiceTitleCursorCollectionOrder =
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsOdpHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsOdpHeroCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsProductFeatureCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsProductFeatureDescriptionListItemCursorCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ContentTypeRichTextLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ContentTypeRichTextOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'titleIcon_ASC'
  | 'titleIcon_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ContentTypeRichTextSecondaryContent = {
  __typename?: 'ContentTypeRichTextSecondaryContent';
  json: Scalars['JSON']['output'];
  links: ContentTypeRichTextSecondaryContentLinks;
};

export type ContentTypeRichTextSecondaryContentAssets = {
  __typename?: 'ContentTypeRichTextSecondaryContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ContentTypeRichTextSecondaryContentEntries = {
  __typename?: 'ContentTypeRichTextSecondaryContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ContentTypeRichTextSecondaryContentLinks = {
  __typename?: 'ContentTypeRichTextSecondaryContentLinks';
  assets: ContentTypeRichTextSecondaryContentAssets;
  entries: ContentTypeRichTextSecondaryContentEntries;
  resources: ContentTypeRichTextSecondaryContentResources;
};

export type ContentTypeRichTextSecondaryContentResources = {
  __typename?: 'ContentTypeRichTextSecondaryContentResources';
  block: Array<ContentTypeRichTextSecondaryContentResourcesBlock>;
  hyperlink: Array<ContentTypeRichTextSecondaryContentResourcesHyperlink>;
  inline: Array<ContentTypeRichTextSecondaryContentResourcesInline>;
};

export type ContentTypeRichTextSecondaryContentResourcesBlock = ResourceLink & {
  __typename?: 'ContentTypeRichTextSecondaryContentResourcesBlock';
  sys: ResourceSys;
};

export type ContentTypeRichTextSecondaryContentResourcesHyperlink = ResourceLink & {
  __typename?: 'ContentTypeRichTextSecondaryContentResourcesHyperlink';
  sys: ResourceSys;
};

export type ContentTypeRichTextSecondaryContentResourcesInline = ResourceLink & {
  __typename?: 'ContentTypeRichTextSecondaryContentResourcesInline';
  sys: ResourceSys;
};

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCta = Entry & _Node & {
  __typename?: 'ConvertFlowCta';
  _id: Scalars['ID']['output'];
  buttonLabel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaId?: Maybe<Scalars['String']['output']>;
  embedId?: Maybe<Scalars['String']['output']>;
  enableUserDetailsValidation?: Maybe<Scalars['Boolean']['output']>;
  fallbackLabel?: Maybe<Scalars['String']['output']>;
  fallbackUrl?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  isSpanish?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ConvertFlowCtaLinkingCollections>;
  loadingMessage?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  timeoutMs?: Maybe<Scalars['Int']['output']>;
  websiteId?: Maybe<Scalars['String']['output']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaCtaIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaEmbedIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaEnableUserDetailsValidationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaFallbackLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaFallbackUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaIsSpanishArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaLoadingMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaTimeoutMsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Load convertflow popups [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowCta) */
export type ConvertFlowCtaWebsiteIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConvertFlowCtaCollection = {
  __typename?: 'ConvertFlowCtaCollection';
  items: Array<Maybe<ConvertFlowCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConvertFlowCtaCursorCollection = {
  __typename?: 'ConvertFlowCtaCursorCollection';
  items: Array<Maybe<ConvertFlowCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ConvertFlowCtaFilter = {
  AND?: InputMaybe<Array<InputMaybe<ConvertFlowCtaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ConvertFlowCtaFilter>>>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaId?: InputMaybe<Scalars['String']['input']>;
  ctaId_contains?: InputMaybe<Scalars['String']['input']>;
  ctaId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaId_not?: InputMaybe<Scalars['String']['input']>;
  ctaId_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  embedId?: InputMaybe<Scalars['String']['input']>;
  embedId_contains?: InputMaybe<Scalars['String']['input']>;
  embedId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  embedId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  embedId_not?: InputMaybe<Scalars['String']['input']>;
  embedId_not_contains?: InputMaybe<Scalars['String']['input']>;
  embedId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableUserDetailsValidation?: InputMaybe<Scalars['Boolean']['input']>;
  enableUserDetailsValidation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableUserDetailsValidation_not?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackLabel?: InputMaybe<Scalars['String']['input']>;
  fallbackLabel_contains?: InputMaybe<Scalars['String']['input']>;
  fallbackLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fallbackLabel_not?: InputMaybe<Scalars['String']['input']>;
  fallbackLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  fallbackLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fallbackUrl?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl_contains?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fallbackUrl_not?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSpanish?: InputMaybe<Scalars['Boolean']['input']>;
  isSpanish_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isSpanish_not?: InputMaybe<Scalars['Boolean']['input']>;
  loadingMessage?: InputMaybe<Scalars['String']['input']>;
  loadingMessage_contains?: InputMaybe<Scalars['String']['input']>;
  loadingMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadingMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loadingMessage_not?: InputMaybe<Scalars['String']['input']>;
  loadingMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  loadingMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  timeoutMs_gt?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_gte?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeoutMs_lt?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_lte?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_not?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  websiteId?: InputMaybe<Scalars['String']['input']>;
  websiteId_contains?: InputMaybe<Scalars['String']['input']>;
  websiteId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  websiteId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteId_not?: InputMaybe<Scalars['String']['input']>;
  websiteId_not_contains?: InputMaybe<Scalars['String']['input']>;
  websiteId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConvertFlowCtaLinkingCollections = {
  __typename?: 'ConvertFlowCtaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type ConvertFlowCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConvertFlowCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConvertFlowCtaLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowCtaLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConvertFlowCtaLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowCtaLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConvertFlowCtaLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ConvertFlowCtaLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ConvertFlowCtaOrder =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'ctaId_ASC'
  | 'ctaId_DESC'
  | 'embedId_ASC'
  | 'embedId_DESC'
  | 'enableUserDetailsValidation_ASC'
  | 'enableUserDetailsValidation_DESC'
  | 'fallbackLabel_ASC'
  | 'fallbackLabel_DESC'
  | 'fallbackUrl_ASC'
  | 'fallbackUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSpanish_ASC'
  | 'isSpanish_DESC'
  | 'loadingMessage_ASC'
  | 'loadingMessage_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'timeoutMs_ASC'
  | 'timeoutMs_DESC'
  | 'websiteId_ASC'
  | 'websiteId_DESC';

/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuiz = Entry & _Node & {
  __typename?: 'ConvertFlowQuiz';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  ctaId?: Maybe<Scalars['String']['output']>;
  enableUserDetailsValidation?: Maybe<Scalars['Boolean']['output']>;
  fallbackLabel?: Maybe<Scalars['String']['output']>;
  fallbackUrl?: Maybe<Scalars['String']['output']>;
  internalName?: Maybe<Scalars['String']['output']>;
  isSpanish?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ConvertFlowQuizLinkingCollections>;
  loadingMessage?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  timeoutMs?: Maybe<Scalars['Int']['output']>;
  websiteId?: Maybe<Scalars['String']['output']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizCtaIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizEnableUserDetailsValidationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizFallbackLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizFallbackUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizIsSpanishArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizLoadingMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizTimeoutMsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Quiz content loaded from ConvertFlow [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/convertFlowQuiz) */
export type ConvertFlowQuizWebsiteIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConvertFlowQuizCollection = {
  __typename?: 'ConvertFlowQuizCollection';
  items: Array<Maybe<ConvertFlowQuiz>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConvertFlowQuizCursorCollection = {
  __typename?: 'ConvertFlowQuizCursorCollection';
  items: Array<Maybe<ConvertFlowQuiz>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ConvertFlowQuizFilter = {
  AND?: InputMaybe<Array<InputMaybe<ConvertFlowQuizFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ConvertFlowQuizFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaId?: InputMaybe<Scalars['String']['input']>;
  ctaId_contains?: InputMaybe<Scalars['String']['input']>;
  ctaId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  ctaId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ctaId_not?: InputMaybe<Scalars['String']['input']>;
  ctaId_not_contains?: InputMaybe<Scalars['String']['input']>;
  ctaId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableUserDetailsValidation?: InputMaybe<Scalars['Boolean']['input']>;
  enableUserDetailsValidation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableUserDetailsValidation_not?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackLabel?: InputMaybe<Scalars['String']['input']>;
  fallbackLabel_contains?: InputMaybe<Scalars['String']['input']>;
  fallbackLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fallbackLabel_not?: InputMaybe<Scalars['String']['input']>;
  fallbackLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  fallbackLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fallbackUrl?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl_contains?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fallbackUrl_not?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  fallbackUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSpanish?: InputMaybe<Scalars['Boolean']['input']>;
  isSpanish_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isSpanish_not?: InputMaybe<Scalars['Boolean']['input']>;
  loadingMessage?: InputMaybe<Scalars['String']['input']>;
  loadingMessage_contains?: InputMaybe<Scalars['String']['input']>;
  loadingMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadingMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loadingMessage_not?: InputMaybe<Scalars['String']['input']>;
  loadingMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  loadingMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  timeoutMs_gt?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_gte?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeoutMs_lt?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_lte?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_not?: InputMaybe<Scalars['Int']['input']>;
  timeoutMs_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  websiteId?: InputMaybe<Scalars['String']['input']>;
  websiteId_contains?: InputMaybe<Scalars['String']['input']>;
  websiteId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  websiteId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteId_not?: InputMaybe<Scalars['String']['input']>;
  websiteId_not_contains?: InputMaybe<Scalars['String']['input']>;
  websiteId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ConvertFlowQuizLinkingCollections = {
  __typename?: 'ConvertFlowQuizLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type ConvertFlowQuizLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConvertFlowQuizLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConvertFlowQuizLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowQuizLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConvertFlowQuizLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowQuizLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConvertFlowQuizLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowQuizLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ConvertFlowQuizLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowQuizLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConvertFlowQuizLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ConvertFlowQuizLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ConvertFlowQuizLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ConvertFlowQuizLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ConvertFlowQuizOrder =
  | 'ctaId_ASC'
  | 'ctaId_DESC'
  | 'enableUserDetailsValidation_ASC'
  | 'enableUserDetailsValidation_DESC'
  | 'fallbackLabel_ASC'
  | 'fallbackLabel_DESC'
  | 'fallbackUrl_ASC'
  | 'fallbackUrl_DESC'
  | 'internalName_ASC'
  | 'internalName_DESC'
  | 'isSpanish_ASC'
  | 'isSpanish_DESC'
  | 'loadingMessage_ASC'
  | 'loadingMessage_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'timeoutMs_ASC'
  | 'timeoutMs_DESC'
  | 'websiteId_ASC'
  | 'websiteId_DESC';

export type CursorPages = {
  __typename?: 'CursorPages';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2 = Entry & _Node & {
  __typename?: 'DisclaimerV2';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  disclaimer?: Maybe<ContentTypeRichText>;
  entryName?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<DisclaimerV2LinkingCollections>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2AnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2DisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2EntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2FacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2SizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/DisclaimerV2) */
export type DisclaimerV2TemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisclaimerV2Collection = {
  __typename?: 'DisclaimerV2Collection';
  items: Array<Maybe<DisclaimerV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DisclaimerV2CursorCollection = {
  __typename?: 'DisclaimerV2CursorCollection';
  items: Array<Maybe<DisclaimerV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type DisclaimerV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<DisclaimerV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<DisclaimerV2Filter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DisclaimerV2LinkingCollections = {
  __typename?: 'DisclaimerV2LinkingCollections';
  adFooterCollection?: Maybe<AdFooterCollection>;
  adFooterCursorCollection?: Maybe<AdFooterCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureCursorCollection?: Maybe<ProductFeatureCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type DisclaimerV2LinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsAdFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsAdFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsAdFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsHalfScreenCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsHeroV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsProductFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsProductFeatureCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DisclaimerV2LinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2LinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisclaimerV2LinkingCollectionsAdFooterCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type DisclaimerV2LinkingCollectionsAdFooterCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type DisclaimerV2LinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type DisclaimerV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type DisclaimerV2LinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2LinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2LinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type DisclaimerV2LinkingCollectionsHalfScreenCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type DisclaimerV2LinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type DisclaimerV2LinkingCollectionsHeroV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type DisclaimerV2LinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2LinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2LinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type DisclaimerV2LinkingCollectionsProductFeatureCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type DisclaimerV2LinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type DisclaimerV2LinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type DisclaimerV2LinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2LinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type DisclaimerV2Order =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC';

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryCursorCollection = {
  __typename?: 'EntryCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type EntryOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404 = Entry & _Node & {
  __typename?: 'Error404';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  backgroundImage?: Maybe<Asset>;
  backgroundImageMobile?: Maybe<Asset>;
  body?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  darkTextColor?: Maybe<Scalars['Boolean']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<Error404LinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  supplementaryButton?: Maybe<Button>;
  sys: Sys;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404AnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404BackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404BackgroundImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404BodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404ButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404DarkTextColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404HeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404NameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404SubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will display when there is an error. It is equivalent to a 404 page one might expect when visiting a URL that doesn't exist. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/error404) */
export type Error404SupplementaryButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};

export type Error404Collection = {
  __typename?: 'Error404Collection';
  items: Array<Maybe<Error404>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Error404CursorCollection = {
  __typename?: 'Error404CursorCollection';
  items: Array<Maybe<Error404>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type Error404Filter = {
  AND?: InputMaybe<Array<InputMaybe<Error404Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<Error404Filter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImageMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplementaryButton?: InputMaybe<CfButtonNestedFilter>;
  supplementaryButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type Error404LinkingCollections = {
  __typename?: 'Error404LinkingCollections';
  appCollection?: Maybe<AppCollection>;
  appCursorCollection?: Maybe<AppCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type Error404LinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Error404LinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Error404LinkingCollectionsAppCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Error404LinkingCollectionsAppCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Error404LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Error404LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Error404LinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type Error404LinkingCollectionsAppCursorCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type Error404Order =
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subtitle_ASC'
  | 'subtitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type Experience = Entry & _Node & {
  __typename?: 'Experience';
  _id: Scalars['ID']['output'];
  componentSettings?: Maybe<Scalars['JSON']['output']>;
  componentTree?: Maybe<Scalars['JSON']['output']>;
  contentfulMetadata: ContentfulMetadata;
  dataSource?: Maybe<Scalars['JSON']['output']>;
  linkedFrom?: Maybe<ExperienceLinkingCollections>;
  pageLayout?: Maybe<PageLayout>;
  pageMetaInfo?: Maybe<PageMeta>;
  slug?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  unboundValues?: Maybe<Scalars['JSON']['output']>;
  usedComponentsCollection?: Maybe<ExperienceUsedComponentsCollection>;
  usedComponentsCursorCollection?: Maybe<ExperienceUsedComponentsCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceComponentSettingsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceComponentTreeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceDataSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperiencePageLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageLayoutFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperiencePageMetaInfoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageMetaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceUnboundValuesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceUsedComponentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperienceUsedComponentsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperienceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experience) */
export type ExperienceUsedComponentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperienceUsedComponentsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperienceFilter>;
};

export type ExperienceCollection = {
  __typename?: 'ExperienceCollection';
  items: Array<Maybe<Experience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperienceCursorCollection = {
  __typename?: 'ExperienceCursorCollection';
  items: Array<Maybe<Experience>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperienceFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExperienceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExperienceFilter>>>;
  componentSettings_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentTree_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  dataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageLayout?: InputMaybe<CfPageLayoutNestedFilter>;
  pageLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageMetaInfo?: InputMaybe<CfPageMetaNestedFilter>;
  pageMetaInfo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unboundValues_exists?: InputMaybe<Scalars['Boolean']['input']>;
  usedComponents?: InputMaybe<CfExperienceNestedFilter>;
  usedComponentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperienceLinkingCollections = {
  __typename?: 'ExperienceLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experienceCollection?: Maybe<ExperienceCollection>;
  experienceCursorCollection?: Maybe<ExperienceCursorCollection>;
};


export type ExperienceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperienceLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperienceLinkingCollectionsExperienceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperienceLinkingCollectionsExperienceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperienceLinkingCollectionsExperienceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperienceLinkingCollectionsExperienceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperienceLinkingCollectionsExperienceCollectionOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ExperienceLinkingCollectionsExperienceCursorCollectionOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ExperienceOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ExperienceUsedComponentsCollection = {
  __typename?: 'ExperienceUsedComponentsCollection';
  items: Array<Maybe<Experience>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperienceUsedComponentsCollectionOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ExperienceUsedComponentsCursorCollection = {
  __typename?: 'ExperienceUsedComponentsCursorCollection';
  items: Array<Maybe<Experience>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperienceUsedComponentsCursorCollectionOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Container tied to a VWO Experiment.  Must contain an ExperimentVariationContentsItem for each variation in the experiment. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentContainer) */
export type ExperimentContainer = Entry & _Node & {
  __typename?: 'ExperimentContainer';
  _id: Scalars['ID']['output'];
  containerName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  experimentId?: Maybe<Scalars['String']['output']>;
  experimentType?: Maybe<Scalars['String']['output']>;
  featureFlagKey?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ExperimentContainerLinkingCollections>;
  sys: Sys;
  variationItemsCollection?: Maybe<ExperimentContainerVariationItemsCollection>;
  variationItemsCursorCollection?: Maybe<ExperimentContainerVariationItemsCursorCollection>;
};


/** Container tied to a VWO Experiment.  Must contain an ExperimentVariationContentsItem for each variation in the experiment. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentContainer) */
export type ExperimentContainerContainerNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Container tied to a VWO Experiment.  Must contain an ExperimentVariationContentsItem for each variation in the experiment. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentContainer) */
export type ExperimentContainerExperimentIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Container tied to a VWO Experiment.  Must contain an ExperimentVariationContentsItem for each variation in the experiment. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentContainer) */
export type ExperimentContainerExperimentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Container tied to a VWO Experiment.  Must contain an ExperimentVariationContentsItem for each variation in the experiment. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentContainer) */
export type ExperimentContainerFeatureFlagKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Container tied to a VWO Experiment.  Must contain an ExperimentVariationContentsItem for each variation in the experiment. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentContainer) */
export type ExperimentContainerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Container tied to a VWO Experiment.  Must contain an ExperimentVariationContentsItem for each variation in the experiment. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentContainer) */
export type ExperimentContainerVariationItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentContainerVariationItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentVariationContentsItemFilter>;
};


/** Container tied to a VWO Experiment.  Must contain an ExperimentVariationContentsItem for each variation in the experiment. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentContainer) */
export type ExperimentContainerVariationItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentContainerVariationItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentVariationContentsItemFilter>;
};

export type ExperimentContainerCollection = {
  __typename?: 'ExperimentContainerCollection';
  items: Array<Maybe<ExperimentContainer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperimentContainerCursorCollection = {
  __typename?: 'ExperimentContainerCursorCollection';
  items: Array<Maybe<ExperimentContainer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperimentContainerFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExperimentContainerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExperimentContainerFilter>>>;
  containerName?: InputMaybe<Scalars['String']['input']>;
  containerName_contains?: InputMaybe<Scalars['String']['input']>;
  containerName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  containerName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  containerName_not?: InputMaybe<Scalars['String']['input']>;
  containerName_not_contains?: InputMaybe<Scalars['String']['input']>;
  containerName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  experimentId?: InputMaybe<Scalars['String']['input']>;
  experimentId_contains?: InputMaybe<Scalars['String']['input']>;
  experimentId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  experimentId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentId_not?: InputMaybe<Scalars['String']['input']>;
  experimentId_not_contains?: InputMaybe<Scalars['String']['input']>;
  experimentId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentType?: InputMaybe<Scalars['String']['input']>;
  experimentType_contains?: InputMaybe<Scalars['String']['input']>;
  experimentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  experimentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experimentType_not?: InputMaybe<Scalars['String']['input']>;
  experimentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  experimentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureFlagKey?: InputMaybe<Scalars['String']['input']>;
  featureFlagKey_contains?: InputMaybe<Scalars['String']['input']>;
  featureFlagKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  featureFlagKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureFlagKey_not?: InputMaybe<Scalars['String']['input']>;
  featureFlagKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  featureFlagKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variationItems?: InputMaybe<CfExperimentVariationContentsItemNestedFilter>;
  variationItemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperimentContainerLinkingCollections = {
  __typename?: 'ExperimentContainerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type ExperimentContainerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperimentContainerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperimentContainerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentContainerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperimentContainerLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentContainerLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperimentContainerLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ExperimentContainerLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ExperimentContainerOrder =
  | 'containerName_ASC'
  | 'containerName_DESC'
  | 'experimentId_ASC'
  | 'experimentId_DESC'
  | 'experimentType_ASC'
  | 'experimentType_DESC'
  | 'featureFlagKey_ASC'
  | 'featureFlagKey_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ExperimentContainerVariationItemsCollection = {
  __typename?: 'ExperimentContainerVariationItemsCollection';
  items: Array<Maybe<ExperimentVariationContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperimentContainerVariationItemsCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ExperimentContainerVariationItemsCursorCollection = {
  __typename?: 'ExperimentContainerVariationItemsCursorCollection';
  items: Array<Maybe<ExperimentVariationContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperimentContainerVariationItemsCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

/** Container that is set to render based on an active variation from a VWO experiment.  Can contain a reference to one or more content types. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentVariationContentsItem) */
export type ExperimentVariationContentsItem = Entry & _Node & {
  __typename?: 'ExperimentVariationContentsItem';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<ExperimentVariationContentsItemContentsCollection>;
  contentsCursorCollection?: Maybe<ExperimentVariationContentsItemContentsCursorCollection>;
  linkedFrom?: Maybe<ExperimentVariationContentsItemLinkingCollections>;
  sys: Sys;
  variationContentsItemName?: Maybe<Scalars['String']['output']>;
  variationId?: Maybe<Scalars['String']['output']>;
};


/** Container that is set to render based on an active variation from a VWO experiment.  Can contain a reference to one or more content types. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentVariationContentsItem) */
export type ExperimentVariationContentsItemContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentVariationContentsItemContentsFilter>;
};


/** Container that is set to render based on an active variation from a VWO experiment.  Can contain a reference to one or more content types. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentVariationContentsItem) */
export type ExperimentVariationContentsItemContentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentVariationContentsItemContentsFilter>;
};


/** Container that is set to render based on an active variation from a VWO experiment.  Can contain a reference to one or more content types. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentVariationContentsItem) */
export type ExperimentVariationContentsItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Container that is set to render based on an active variation from a VWO experiment.  Can contain a reference to one or more content types. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentVariationContentsItem) */
export type ExperimentVariationContentsItemVariationContentsItemNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Container that is set to render based on an active variation from a VWO experiment.  Can contain a reference to one or more content types. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentVariationContentsItem) */
export type ExperimentVariationContentsItemVariationIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperimentVariationContentsItemCollection = {
  __typename?: 'ExperimentVariationContentsItemCollection';
  items: Array<Maybe<ExperimentVariationContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperimentVariationContentsItemContentsCollection = {
  __typename?: 'ExperimentVariationContentsItemContentsCollection';
  items: Array<Maybe<ExperimentVariationContentsItemContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperimentVariationContentsItemContentsCursorCollection = {
  __typename?: 'ExperimentVariationContentsItemContentsCursorCollection';
  items: Array<Maybe<ExperimentVariationContentsItemContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperimentVariationContentsItemContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExperimentVariationContentsItemContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExperimentVariationContentsItemContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ExperimentVariationContentsItemContentsItem = Accordions | AgendaStepper | BirdEyeReviews | BlogList | CategoryPicker | CityLinks | Columns | ContentTypeRichText | ConvertFlowQuiz | DisclaimerV2 | GoogleMapTemplate | HalfScreen | HeaderNavMenu | HeroV2 | Iframe | Insurance | LinkForwarder | Marquee | MediaSlider | MeetOurStaff | MetroLinks | MultiCardV2 | OdpHero | PatientReviewsV2 | ProductFeature | Questionnaire | QuickLinks | Quiz | Schema | SchemaStep | SectionContent | SegmentsContainer | Service | ServiceGroup | ServiceLineHero | SharedForm | SingleMessage | SmileAssessmentForm | Spacer | StateLinks | Stepper | Table | Tabs | TermsAndConditions | TextBlockSeo | VideoCarousel;

export type ExperimentVariationContentsItemCursorCollection = {
  __typename?: 'ExperimentVariationContentsItemCursorCollection';
  items: Array<Maybe<ExperimentVariationContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperimentVariationContentsItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExperimentVariationContentsItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExperimentVariationContentsItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  variationContentsItemName?: InputMaybe<Scalars['String']['input']>;
  variationContentsItemName_contains?: InputMaybe<Scalars['String']['input']>;
  variationContentsItemName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variationContentsItemName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variationContentsItemName_not?: InputMaybe<Scalars['String']['input']>;
  variationContentsItemName_not_contains?: InputMaybe<Scalars['String']['input']>;
  variationContentsItemName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variationId?: InputMaybe<Scalars['String']['input']>;
  variationId_contains?: InputMaybe<Scalars['String']['input']>;
  variationId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variationId_not?: InputMaybe<Scalars['String']['input']>;
  variationId_not_contains?: InputMaybe<Scalars['String']['input']>;
  variationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExperimentVariationContentsItemLinkingCollections = {
  __typename?: 'ExperimentVariationContentsItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentContainerCollection?: Maybe<ExperimentContainerCollection>;
  experimentContainerCursorCollection?: Maybe<ExperimentContainerCursorCollection>;
};


export type ExperimentVariationContentsItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperimentVariationContentsItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperimentVariationContentsItemLinkingCollectionsExperimentContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentVariationContentsItemLinkingCollectionsExperimentContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperimentVariationContentsItemLinkingCollectionsExperimentContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentVariationContentsItemLinkingCollectionsExperimentContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperimentVariationContentsItemLinkingCollectionsExperimentContainerCollectionOrder =
  | 'containerName_ASC'
  | 'containerName_DESC'
  | 'experimentId_ASC'
  | 'experimentId_DESC'
  | 'experimentType_ASC'
  | 'experimentType_DESC'
  | 'featureFlagKey_ASC'
  | 'featureFlagKey_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ExperimentVariationContentsItemLinkingCollectionsExperimentContainerCursorCollectionOrder =
  | 'containerName_ASC'
  | 'containerName_DESC'
  | 'experimentId_ASC'
  | 'experimentId_DESC'
  | 'experimentType_ASC'
  | 'experimentType_DESC'
  | 'featureFlagKey_ASC'
  | 'featureFlagKey_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ExperimentVariationContentsItemOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModal = Entry & _Node & {
  __typename?: 'ExperimentalModal';
  _id: Scalars['ID']['output'];
  badgeLabel?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<ExperimentalModalBodyText>;
  contentfulMetadata: ContentfulMetadata;
  delay?: Maybe<Scalars['Int']['output']>;
  dismissLabel?: Maybe<Scalars['String']['output']>;
  excludePaths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  formTitle?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<Asset>;
  heroImageAlt?: Maybe<Scalars['String']['output']>;
  includeEmail?: Maybe<Scalars['Boolean']['output']>;
  includeFirstName?: Maybe<Scalars['Boolean']['output']>;
  includeLastName?: Maybe<Scalars['Boolean']['output']>;
  includePaths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  legalDisclaimerFootnote?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ExperimentalModalLinkingCollections>;
  modalId?: Maybe<Scalars['String']['output']>;
  optInConsentLine?: Maybe<Scalars['String']['output']>;
  primaryCtaLabel?: Maybe<Scalars['String']['output']>;
  promoBoldText?: Maybe<Scalars['String']['output']>;
  queryParams?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  submitEndpointUrl?: Maybe<Scalars['String']['output']>;
  successTitleText?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  trigger?: Maybe<Scalars['String']['output']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalBadgeLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalBodyTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalDelayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalDismissLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalExcludePathsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalFormTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalHeroImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalHeroImageAltArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalIncludeEmailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalIncludeFirstNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalIncludeLastNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalIncludePathsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalLegalDisclaimerFootnoteArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalModalIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalOptInConsentLineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalPrimaryCtaLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalPromoBoldTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalQueryParamsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalSubmitEndpointUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalSuccessTitleTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Promotional hero banner, fetched at runtime by contentfulId [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/experimentalModal) */
export type ExperimentalModalTriggerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperimentalModalBodyText = {
  __typename?: 'ExperimentalModalBodyText';
  json: Scalars['JSON']['output'];
  links: ExperimentalModalBodyTextLinks;
};

export type ExperimentalModalBodyTextAssets = {
  __typename?: 'ExperimentalModalBodyTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ExperimentalModalBodyTextEntries = {
  __typename?: 'ExperimentalModalBodyTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ExperimentalModalBodyTextLinks = {
  __typename?: 'ExperimentalModalBodyTextLinks';
  assets: ExperimentalModalBodyTextAssets;
  entries: ExperimentalModalBodyTextEntries;
  resources: ExperimentalModalBodyTextResources;
};

export type ExperimentalModalBodyTextResources = {
  __typename?: 'ExperimentalModalBodyTextResources';
  block: Array<ExperimentalModalBodyTextResourcesBlock>;
  hyperlink: Array<ExperimentalModalBodyTextResourcesHyperlink>;
  inline: Array<ExperimentalModalBodyTextResourcesInline>;
};

export type ExperimentalModalBodyTextResourcesBlock = ResourceLink & {
  __typename?: 'ExperimentalModalBodyTextResourcesBlock';
  sys: ResourceSys;
};

export type ExperimentalModalBodyTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ExperimentalModalBodyTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ExperimentalModalBodyTextResourcesInline = ResourceLink & {
  __typename?: 'ExperimentalModalBodyTextResourcesInline';
  sys: ResourceSys;
};

export type ExperimentalModalCollection = {
  __typename?: 'ExperimentalModalCollection';
  items: Array<Maybe<ExperimentalModal>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ExperimentalModalCursorCollection = {
  __typename?: 'ExperimentalModalCursorCollection';
  items: Array<Maybe<ExperimentalModal>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ExperimentalModalFilter = {
  AND?: InputMaybe<Array<InputMaybe<ExperimentalModalFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ExperimentalModalFilter>>>;
  badgeLabel?: InputMaybe<Scalars['String']['input']>;
  badgeLabel_contains?: InputMaybe<Scalars['String']['input']>;
  badgeLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  badgeLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badgeLabel_not?: InputMaybe<Scalars['String']['input']>;
  badgeLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  badgeLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyText_contains?: InputMaybe<Scalars['String']['input']>;
  bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  delay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  delay_gt?: InputMaybe<Scalars['Int']['input']>;
  delay_gte?: InputMaybe<Scalars['Int']['input']>;
  delay_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  delay_lt?: InputMaybe<Scalars['Int']['input']>;
  delay_lte?: InputMaybe<Scalars['Int']['input']>;
  delay_not?: InputMaybe<Scalars['Int']['input']>;
  delay_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dismissLabel?: InputMaybe<Scalars['String']['input']>;
  dismissLabel_contains?: InputMaybe<Scalars['String']['input']>;
  dismissLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  dismissLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dismissLabel_not?: InputMaybe<Scalars['String']['input']>;
  dismissLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  dismissLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePaths_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePaths_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePaths_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePaths_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formTitle?: InputMaybe<Scalars['String']['input']>;
  formTitle_contains?: InputMaybe<Scalars['String']['input']>;
  formTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formTitle_not?: InputMaybe<Scalars['String']['input']>;
  formTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  formTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_not?: InputMaybe<Scalars['String']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageAlt?: InputMaybe<Scalars['String']['input']>;
  heroImageAlt_contains?: InputMaybe<Scalars['String']['input']>;
  heroImageAlt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroImageAlt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImageAlt_not?: InputMaybe<Scalars['String']['input']>;
  heroImageAlt_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroImageAlt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  includeEmail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeEmail_not?: InputMaybe<Scalars['Boolean']['input']>;
  includeFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  includeFirstName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeFirstName_not?: InputMaybe<Scalars['Boolean']['input']>;
  includeLastName?: InputMaybe<Scalars['Boolean']['input']>;
  includeLastName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includeLastName_not?: InputMaybe<Scalars['Boolean']['input']>;
  includePaths_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includePaths_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includePaths_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includePaths_exists?: InputMaybe<Scalars['Boolean']['input']>;
  legalDisclaimerFootnote?: InputMaybe<Scalars['String']['input']>;
  legalDisclaimerFootnote_contains?: InputMaybe<Scalars['String']['input']>;
  legalDisclaimerFootnote_exists?: InputMaybe<Scalars['Boolean']['input']>;
  legalDisclaimerFootnote_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legalDisclaimerFootnote_not?: InputMaybe<Scalars['String']['input']>;
  legalDisclaimerFootnote_not_contains?: InputMaybe<Scalars['String']['input']>;
  legalDisclaimerFootnote_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalId?: InputMaybe<Scalars['String']['input']>;
  modalId_contains?: InputMaybe<Scalars['String']['input']>;
  modalId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalId_not?: InputMaybe<Scalars['String']['input']>;
  modalId_not_contains?: InputMaybe<Scalars['String']['input']>;
  modalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optInConsentLine?: InputMaybe<Scalars['String']['input']>;
  optInConsentLine_contains?: InputMaybe<Scalars['String']['input']>;
  optInConsentLine_exists?: InputMaybe<Scalars['Boolean']['input']>;
  optInConsentLine_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  optInConsentLine_not?: InputMaybe<Scalars['String']['input']>;
  optInConsentLine_not_contains?: InputMaybe<Scalars['String']['input']>;
  optInConsentLine_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryCtaLabel?: InputMaybe<Scalars['String']['input']>;
  primaryCtaLabel_contains?: InputMaybe<Scalars['String']['input']>;
  primaryCtaLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCtaLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryCtaLabel_not?: InputMaybe<Scalars['String']['input']>;
  primaryCtaLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  primaryCtaLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoBoldText?: InputMaybe<Scalars['String']['input']>;
  promoBoldText_contains?: InputMaybe<Scalars['String']['input']>;
  promoBoldText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  promoBoldText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoBoldText_not?: InputMaybe<Scalars['String']['input']>;
  promoBoldText_not_contains?: InputMaybe<Scalars['String']['input']>;
  promoBoldText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryParams_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryParams_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryParams_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryParams_exists?: InputMaybe<Scalars['Boolean']['input']>;
  submitEndpointUrl?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  submitEndpointUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl_not?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successTitleText?: InputMaybe<Scalars['String']['input']>;
  successTitleText_contains?: InputMaybe<Scalars['String']['input']>;
  successTitleText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  successTitleText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successTitleText_not?: InputMaybe<Scalars['String']['input']>;
  successTitleText_not_contains?: InputMaybe<Scalars['String']['input']>;
  successTitleText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  trigger_contains?: InputMaybe<Scalars['String']['input']>;
  trigger_exists?: InputMaybe<Scalars['Boolean']['input']>;
  trigger_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trigger_not?: InputMaybe<Scalars['String']['input']>;
  trigger_not_contains?: InputMaybe<Scalars['String']['input']>;
  trigger_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExperimentalModalLinkingCollections = {
  __typename?: 'ExperimentalModalLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ExperimentalModalLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ExperimentalModalLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperimentalModalOrder =
  | 'badgeLabel_ASC'
  | 'badgeLabel_DESC'
  | 'delay_ASC'
  | 'delay_DESC'
  | 'dismissLabel_ASC'
  | 'dismissLabel_DESC'
  | 'formTitle_ASC'
  | 'formTitle_DESC'
  | 'headline_ASC'
  | 'headline_DESC'
  | 'heroImageAlt_ASC'
  | 'heroImageAlt_DESC'
  | 'includeEmail_ASC'
  | 'includeEmail_DESC'
  | 'includeFirstName_ASC'
  | 'includeFirstName_DESC'
  | 'includeLastName_ASC'
  | 'includeLastName_DESC'
  | 'modalId_ASC'
  | 'modalId_DESC'
  | 'primaryCtaLabel_ASC'
  | 'primaryCtaLabel_DESC'
  | 'promoBoldText_ASC'
  | 'promoBoldText_DESC'
  | 'submitEndpointUrl_ASC'
  | 'submitEndpointUrl_DESC'
  | 'successTitleText_ASC'
  | 'successTitleText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trigger_ASC'
  | 'trigger_DESC';

/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPage = Entry & _Node & {
  __typename?: 'FacilityDetailsPage';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  appName?: Maybe<Scalars['String']['output']>;
  bannerInPage?: Maybe<Banner>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<FacilityDetailsPageContentsCollection>;
  contentsCursorCollection?: Maybe<FacilityDetailsPageContentsCursorCollection>;
  description?: Maybe<Scalars['String']['output']>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<FacilityDetailsPageLinkingCollections>;
  moreTextSeo?: Maybe<FacilityDetailsPageMoreTextSeo>;
  name?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<ImageAsset>;
  pageContentDataJson?: Maybe<Scalars['JSON']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  teletriageEnabled?: Maybe<Scalars['Boolean']['output']>;
  textSeo?: Maybe<FacilityDetailsPageTextSeo>;
  title?: Maybe<Scalars['String']['output']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageAppNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageBannerInPageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BannerFilter>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FacilityDetailsPageContentsFilter>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageContentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FacilityDetailsPageContentsFilter>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageFacilityIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageMoreTextSeoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPagePageContentDataJsonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPagePageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageTeletriageEnabledArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageTextSeoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This page defines meta data and contents of facility.  [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/facilityDetailsPage) */
export type FacilityDetailsPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacilityDetailsPageCollection = {
  __typename?: 'FacilityDetailsPageCollection';
  items: Array<Maybe<FacilityDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FacilityDetailsPageContentsCollection = {
  __typename?: 'FacilityDetailsPageContentsCollection';
  items: Array<Maybe<FacilityDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FacilityDetailsPageContentsCursorCollection = {
  __typename?: 'FacilityDetailsPageContentsCursorCollection';
  items: Array<Maybe<FacilityDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FacilityDetailsPageContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<FacilityDetailsPageContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FacilityDetailsPageContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type FacilityDetailsPageContentsItem = Accordions | BirdEyeReviews | BlogList | CategoryPicker | Columns | ContentTypeRichText | DisclaimerV2 | GoogleMapTemplate | HalfScreen | HeroV2 | Marquee | MeetOurStaff | MultiCardV2 | OdpHero | PatientReviewsV2 | ProductDisplay | ProductFeature | QuickLinks | Quiz | Schema | SegmentsContainer | ServiceLineHero | SingleMessage | Spacer | Tabs;

export type FacilityDetailsPageCursorCollection = {
  __typename?: 'FacilityDetailsPageCursorCollection';
  items: Array<Maybe<FacilityDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FacilityDetailsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<FacilityDetailsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FacilityDetailsPageFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appName_contains?: InputMaybe<Scalars['String']['input']>;
  appName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appName_not?: InputMaybe<Scalars['String']['input']>;
  appName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerInPage?: InputMaybe<CfBannerNestedFilter>;
  bannerInPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  facilityId_contains?: InputMaybe<Scalars['String']['input']>;
  facilityId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityId_not?: InputMaybe<Scalars['String']['input']>;
  facilityId_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  moreTextSeo_contains?: InputMaybe<Scalars['String']['input']>;
  moreTextSeo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreTextSeo_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfImageAssetNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageContentDataJson_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  teletriageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  teletriageEnabled_exists?: InputMaybe<Scalars['Boolean']['input']>;
  teletriageEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  textSeo_contains?: InputMaybe<Scalars['String']['input']>;
  textSeo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textSeo_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FacilityDetailsPageLinkingCollections = {
  __typename?: 'FacilityDetailsPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
};


export type FacilityDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FacilityDetailsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FacilityDetailsPageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FacilityDetailsPageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FacilityDetailsPageLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FacilityDetailsPageLinkingCollectionsNavigationLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacilityDetailsPageLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FacilityDetailsPageLinkingCollectionsNavigationLinkCursorCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FacilityDetailsPageMoreTextSeo = {
  __typename?: 'FacilityDetailsPageMoreTextSeo';
  json: Scalars['JSON']['output'];
  links: FacilityDetailsPageMoreTextSeoLinks;
};

export type FacilityDetailsPageMoreTextSeoAssets = {
  __typename?: 'FacilityDetailsPageMoreTextSeoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FacilityDetailsPageMoreTextSeoEntries = {
  __typename?: 'FacilityDetailsPageMoreTextSeoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FacilityDetailsPageMoreTextSeoLinks = {
  __typename?: 'FacilityDetailsPageMoreTextSeoLinks';
  assets: FacilityDetailsPageMoreTextSeoAssets;
  entries: FacilityDetailsPageMoreTextSeoEntries;
  resources: FacilityDetailsPageMoreTextSeoResources;
};

export type FacilityDetailsPageMoreTextSeoResources = {
  __typename?: 'FacilityDetailsPageMoreTextSeoResources';
  block: Array<FacilityDetailsPageMoreTextSeoResourcesBlock>;
  hyperlink: Array<FacilityDetailsPageMoreTextSeoResourcesHyperlink>;
  inline: Array<FacilityDetailsPageMoreTextSeoResourcesInline>;
};

export type FacilityDetailsPageMoreTextSeoResourcesBlock = ResourceLink & {
  __typename?: 'FacilityDetailsPageMoreTextSeoResourcesBlock';
  sys: ResourceSys;
};

export type FacilityDetailsPageMoreTextSeoResourcesHyperlink = ResourceLink & {
  __typename?: 'FacilityDetailsPageMoreTextSeoResourcesHyperlink';
  sys: ResourceSys;
};

export type FacilityDetailsPageMoreTextSeoResourcesInline = ResourceLink & {
  __typename?: 'FacilityDetailsPageMoreTextSeoResourcesInline';
  sys: ResourceSys;
};

export type FacilityDetailsPageOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FacilityDetailsPageTextSeo = {
  __typename?: 'FacilityDetailsPageTextSeo';
  json: Scalars['JSON']['output'];
  links: FacilityDetailsPageTextSeoLinks;
};

export type FacilityDetailsPageTextSeoAssets = {
  __typename?: 'FacilityDetailsPageTextSeoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type FacilityDetailsPageTextSeoEntries = {
  __typename?: 'FacilityDetailsPageTextSeoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type FacilityDetailsPageTextSeoLinks = {
  __typename?: 'FacilityDetailsPageTextSeoLinks';
  assets: FacilityDetailsPageTextSeoAssets;
  entries: FacilityDetailsPageTextSeoEntries;
  resources: FacilityDetailsPageTextSeoResources;
};

export type FacilityDetailsPageTextSeoResources = {
  __typename?: 'FacilityDetailsPageTextSeoResources';
  block: Array<FacilityDetailsPageTextSeoResourcesBlock>;
  hyperlink: Array<FacilityDetailsPageTextSeoResourcesHyperlink>;
  inline: Array<FacilityDetailsPageTextSeoResourcesInline>;
};

export type FacilityDetailsPageTextSeoResourcesBlock = ResourceLink & {
  __typename?: 'FacilityDetailsPageTextSeoResourcesBlock';
  sys: ResourceSys;
};

export type FacilityDetailsPageTextSeoResourcesHyperlink = ResourceLink & {
  __typename?: 'FacilityDetailsPageTextSeoResourcesHyperlink';
  sys: ResourceSys;
};

export type FacilityDetailsPageTextSeoResourcesInline = ResourceLink & {
  __typename?: 'FacilityDetailsPageTextSeoResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/faqAccordion) */
export type FaqAccordion = Entry & _Node & {
  __typename?: 'FaqAccordion';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  itemsCollection?: Maybe<FaqAccordionItemsCollection>;
  itemsCursorCollection?: Maybe<FaqAccordionItemsCursorCollection>;
  linkedFrom?: Maybe<FaqAccordionLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/faqAccordion) */
export type FaqAccordionItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FaqAccordionItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionAnswerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/faqAccordion) */
export type FaqAccordionItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FaqAccordionItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionAnswerFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/faqAccordion) */
export type FaqAccordionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/faqAccordion) */
export type FaqAccordionNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqAccordionCollection = {
  __typename?: 'FaqAccordionCollection';
  items: Array<Maybe<FaqAccordion>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FaqAccordionCursorCollection = {
  __typename?: 'FaqAccordionCursorCollection';
  items: Array<Maybe<FaqAccordion>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FaqAccordionFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqAccordionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqAccordionFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  items?: InputMaybe<CfQuestionAnswerNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FaqAccordionItemsCollection = {
  __typename?: 'FaqAccordionItemsCollection';
  items: Array<Maybe<QuestionAnswer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FaqAccordionItemsCollectionOrder =
  | 'question_ASC'
  | 'question_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FaqAccordionItemsCursorCollection = {
  __typename?: 'FaqAccordionItemsCursorCollection';
  items: Array<Maybe<QuestionAnswer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FaqAccordionItemsCursorCollectionOrder =
  | 'question_ASC'
  | 'question_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FaqAccordionLinkingCollections = {
  __typename?: 'FaqAccordionLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type FaqAccordionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FaqAccordionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaqAccordionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlags = Entry & _Node & {
  __typename?: 'FeatureFlags';
  _id: Scalars['ID']['output'];
  alternateSchedulingFlowOffices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: ContentfulMetadata;
  continentalUsMapFallbackThreshold?: Maybe<Scalars['Int']['output']>;
  defaultToCdn?: Maybe<Scalars['Boolean']['output']>;
  doNotIndexWholeSite?: Maybe<Scalars['Boolean']['output']>;
  enableCcMarketingSourceTransformation?: Maybe<Scalars['Boolean']['output']>;
  enableFacilityContextInSsr?: Maybe<Scalars['Boolean']['output']>;
  enableFicoTraffic?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enableFluidTypography?: Maybe<Scalars['Boolean']['output']>;
  enableFraudCheck?: Maybe<Scalars['Boolean']['output']>;
  enablePageReloadOnOdpLink?: Maybe<Scalars['Boolean']['output']>;
  enablePatientPortalNavigation?: Maybe<Scalars['Boolean']['output']>;
  enablePatientPortalPhase2?: Maybe<Scalars['Boolean']['output']>;
  enablePersistOnClearChoiceScheduler?: Maybe<Scalars['Boolean']['output']>;
  enableProvidersSitemap?: Maybe<Scalars['Boolean']['output']>;
  enablePtcSlotFilter?: Maybe<Scalars['Boolean']['output']>;
  enforceContinentalUsZoom?: Maybe<Scalars['Boolean']['output']>;
  featureList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fetchAllLocationsOnEmptyResults?: Maybe<Scalars['Boolean']['output']>;
  hideHeaderFacilityLocator?: Maybe<Scalars['Boolean']['output']>;
  hideHeaderSchedulingButton?: Maybe<Scalars['Boolean']['output']>;
  hideOdpHeaderLinks?: Maybe<Scalars['Boolean']['output']>;
  hideProviderWithNoImage?: Maybe<Scalars['Boolean']['output']>;
  hideSearchWithLocationCards?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<FeatureFlagsLinkingCollections>;
  loadFacilityReviewsFromBeffe?: Maybe<Scalars['Boolean']['output']>;
  migrationPaths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  officeRollout?: Maybe<Scalars['JSON']['output']>;
  oneTrust?: Maybe<Scalars['Boolean']['output']>;
  previsitPaperworkLocations?: Maybe<Scalars['JSON']['output']>;
  providerHeroTheme?: Maybe<Scalars['String']['output']>;
  providersExclusionList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  salesForceEvergageScript?: Maybe<Scalars['String']['output']>;
  showHeaderNavigationMenu?: Maybe<Scalars['Boolean']['output']>;
  showHeaderWithLocationNav?: Maybe<Scalars['Boolean']['output']>;
  showMobileHeaderLocationBar?: Maybe<Scalars['Boolean']['output']>;
  showProviderPageCtaInMeetOurStaff?: Maybe<Scalars['Boolean']['output']>;
  showProviderPageInsuranceInfo?: Maybe<Scalars['Boolean']['output']>;
  showReadMoreForBioInMeetOurStaff?: Maybe<Scalars['Boolean']['output']>;
  showSetOfficeButtonInGoogleMapsCards?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  transitionallyUseBeffe?: Maybe<Scalars['Boolean']['output']>;
  updateAddressLocations?: Maybe<Scalars['JSON']['output']>;
  useFacilityBeffeDataSource?: Maybe<Scalars['Boolean']['output']>;
  useFilterForOdpDetailsContent?: Maybe<Scalars['Boolean']['output']>;
  useGoogleMapAutocompleteSearch?: Maybe<Scalars['Boolean']['output']>;
  useInlineOneTrust?: Maybe<Scalars['Boolean']['output']>;
  useSessionStorageFacilityCode?: Maybe<Scalars['Boolean']['output']>;
  useSimpleFindOfficeLink?: Maybe<Scalars['Boolean']['output']>;
  withLeadingProviderAssociations?: Maybe<Scalars['Boolean']['output']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsAlternateSchedulingFlowOfficesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsContinentalUsMapFallbackThresholdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsDefaultToCdnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsDoNotIndexWholeSiteArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableCcMarketingSourceTransformationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableFacilityContextInSsrArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableFicoTrafficArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableFluidTypographyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableFraudCheckArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnablePageReloadOnOdpLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnablePatientPortalNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnablePatientPortalPhase2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnablePersistOnClearChoiceSchedulerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnableProvidersSitemapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnablePtcSlotFilterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsEnforceContinentalUsZoomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsFeatureListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsFetchAllLocationsOnEmptyResultsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideHeaderFacilityLocatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideHeaderSchedulingButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideOdpHeaderLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideProviderWithNoImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsHideSearchWithLocationCardsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsLoadFacilityReviewsFromBeffeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsMigrationPathsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsOfficeRolloutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsOneTrustArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsPrevisitPaperworkLocationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsProviderHeroThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsProvidersExclusionListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsSalesForceEvergageScriptArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowHeaderNavigationMenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowHeaderWithLocationNavArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowMobileHeaderLocationBarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowProviderPageCtaInMeetOurStaffArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowProviderPageInsuranceInfoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowReadMoreForBioInMeetOurStaffArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsShowSetOfficeButtonInGoogleMapsCardsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsTransitionallyUseBeffeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUpdateAddressLocationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseFacilityBeffeDataSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseFilterForOdpDetailsContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseGoogleMapAutocompleteSearchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseInlineOneTrustArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseSessionStorageFacilityCodeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsUseSimpleFindOfficeLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Concentrating all feature flags for an app in one model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/featureFlags) */
export type FeatureFlagsWithLeadingProviderAssociationsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureFlagsCollection = {
  __typename?: 'FeatureFlagsCollection';
  items: Array<Maybe<FeatureFlags>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FeatureFlagsCursorCollection = {
  __typename?: 'FeatureFlagsCursorCollection';
  items: Array<Maybe<FeatureFlags>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FeatureFlagsFilter = {
  AND?: InputMaybe<Array<InputMaybe<FeatureFlagsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FeatureFlagsFilter>>>;
  alternateSchedulingFlowOffices_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alternateSchedulingFlowOffices_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alternateSchedulingFlowOffices_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alternateSchedulingFlowOffices_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  continentalUsMapFallbackThreshold?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  continentalUsMapFallbackThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  continentalUsMapFallbackThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  defaultToCdn?: InputMaybe<Scalars['Boolean']['input']>;
  defaultToCdn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultToCdn_not?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite_exists?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableCcMarketingSourceTransformation?: InputMaybe<Scalars['Boolean']['input']>;
  enableCcMarketingSourceTransformation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableCcMarketingSourceTransformation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFicoTraffic_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableFicoTraffic_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableFicoTraffic_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableFicoTraffic_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePageReloadOnOdpLink?: InputMaybe<Scalars['Boolean']['input']>;
  enablePageReloadOnOdpLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePageReloadOnOdpLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePersistOnClearChoiceScheduler?: InputMaybe<Scalars['Boolean']['input']>;
  enablePersistOnClearChoiceScheduler_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePersistOnClearChoiceScheduler_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter_not?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom_not?: InputMaybe<Scalars['Boolean']['input']>;
  featureList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe_not?: InputMaybe<Scalars['Boolean']['input']>;
  migrationPaths_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  migrationPaths_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  migrationPaths_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  migrationPaths_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeRollout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  oneTrust?: InputMaybe<Scalars['Boolean']['input']>;
  oneTrust_exists?: InputMaybe<Scalars['Boolean']['input']>;
  oneTrust_not?: InputMaybe<Scalars['Boolean']['input']>;
  previsitPaperworkLocations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  providerHeroTheme?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_contains?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  providerHeroTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerHeroTheme_not?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_not_contains?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providersExclusionList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providersExclusionList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providersExclusionList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providersExclusionList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceEvergageScript?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_contains?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_exists?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceEvergageScript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesForceEvergageScript_not?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_not_contains?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showHeaderNavigationMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderNavigationMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderNavigationMenu_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav_not?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo_not?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff_not?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  transitionallyUseBeffe?: InputMaybe<Scalars['Boolean']['input']>;
  transitionallyUseBeffe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transitionallyUseBeffe_not?: InputMaybe<Scalars['Boolean']['input']>;
  updateAddressLocations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource_not?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent_not?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust_not?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode_not?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureFlagsLinkingCollections = {
  __typename?: 'FeatureFlagsLinkingCollections';
  appCollection?: Maybe<AppCollection>;
  appCursorCollection?: Maybe<AppCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type FeatureFlagsLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FeatureFlagsLinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureFlagsLinkingCollectionsAppCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FeatureFlagsLinkingCollectionsAppCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureFlagsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FeatureFlagsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureFlagsLinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FeatureFlagsLinkingCollectionsAppCursorCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FeatureFlagsOrder =
  | 'continentalUsMapFallbackThreshold_ASC'
  | 'continentalUsMapFallbackThreshold_DESC'
  | 'defaultToCdn_ASC'
  | 'defaultToCdn_DESC'
  | 'doNotIndexWholeSite_ASC'
  | 'doNotIndexWholeSite_DESC'
  | 'enableCcMarketingSourceTransformation_ASC'
  | 'enableCcMarketingSourceTransformation_DESC'
  | 'enableFacilityContextInSsr_ASC'
  | 'enableFacilityContextInSsr_DESC'
  | 'enableFluidTypography_ASC'
  | 'enableFluidTypography_DESC'
  | 'enableFraudCheck_ASC'
  | 'enableFraudCheck_DESC'
  | 'enablePageReloadOnOdpLink_ASC'
  | 'enablePageReloadOnOdpLink_DESC'
  | 'enablePatientPortalNavigation_ASC'
  | 'enablePatientPortalNavigation_DESC'
  | 'enablePatientPortalPhase2_ASC'
  | 'enablePatientPortalPhase2_DESC'
  | 'enablePersistOnClearChoiceScheduler_ASC'
  | 'enablePersistOnClearChoiceScheduler_DESC'
  | 'enableProvidersSitemap_ASC'
  | 'enableProvidersSitemap_DESC'
  | 'enablePtcSlotFilter_ASC'
  | 'enablePtcSlotFilter_DESC'
  | 'enforceContinentalUsZoom_ASC'
  | 'enforceContinentalUsZoom_DESC'
  | 'fetchAllLocationsOnEmptyResults_ASC'
  | 'fetchAllLocationsOnEmptyResults_DESC'
  | 'hideHeaderFacilityLocator_ASC'
  | 'hideHeaderFacilityLocator_DESC'
  | 'hideHeaderSchedulingButton_ASC'
  | 'hideHeaderSchedulingButton_DESC'
  | 'hideOdpHeaderLinks_ASC'
  | 'hideOdpHeaderLinks_DESC'
  | 'hideProviderWithNoImage_ASC'
  | 'hideProviderWithNoImage_DESC'
  | 'hideSearchWithLocationCards_ASC'
  | 'hideSearchWithLocationCards_DESC'
  | 'loadFacilityReviewsFromBeffe_ASC'
  | 'loadFacilityReviewsFromBeffe_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'oneTrust_ASC'
  | 'oneTrust_DESC'
  | 'providerHeroTheme_ASC'
  | 'providerHeroTheme_DESC'
  | 'salesForceEvergageScript_ASC'
  | 'salesForceEvergageScript_DESC'
  | 'showHeaderNavigationMenu_ASC'
  | 'showHeaderNavigationMenu_DESC'
  | 'showHeaderWithLocationNav_ASC'
  | 'showHeaderWithLocationNav_DESC'
  | 'showMobileHeaderLocationBar_ASC'
  | 'showMobileHeaderLocationBar_DESC'
  | 'showProviderPageCtaInMeetOurStaff_ASC'
  | 'showProviderPageCtaInMeetOurStaff_DESC'
  | 'showProviderPageInsuranceInfo_ASC'
  | 'showProviderPageInsuranceInfo_DESC'
  | 'showReadMoreForBioInMeetOurStaff_ASC'
  | 'showReadMoreForBioInMeetOurStaff_DESC'
  | 'showSetOfficeButtonInGoogleMapsCards_ASC'
  | 'showSetOfficeButtonInGoogleMapsCards_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'transitionallyUseBeffe_ASC'
  | 'transitionallyUseBeffe_DESC'
  | 'useFacilityBeffeDataSource_ASC'
  | 'useFacilityBeffeDataSource_DESC'
  | 'useFilterForOdpDetailsContent_ASC'
  | 'useFilterForOdpDetailsContent_DESC'
  | 'useGoogleMapAutocompleteSearch_ASC'
  | 'useGoogleMapAutocompleteSearch_DESC'
  | 'useInlineOneTrust_ASC'
  | 'useInlineOneTrust_DESC'
  | 'useSessionStorageFacilityCode_ASC'
  | 'useSessionStorageFacilityCode_DESC'
  | 'useSimpleFindOfficeLink_ASC'
  | 'useSimpleFindOfficeLink_DESC'
  | 'withLeadingProviderAssociations_ASC'
  | 'withLeadingProviderAssociations_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImage = Entry & _Node & {
  __typename?: 'FocalPointImage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  image?: Maybe<Asset>;
  linkedFrom?: Maybe<FocalPointImageLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImageFocalPointArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImageImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/focalPointImage) */
export type FocalPointImageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FocalPointImageCollection = {
  __typename?: 'FocalPointImageCollection';
  items: Array<Maybe<FocalPointImage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FocalPointImageCursorCollection = {
  __typename?: 'FocalPointImageCursorCollection';
  items: Array<Maybe<FocalPointImage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FocalPointImageFilter = {
  AND?: InputMaybe<Array<InputMaybe<FocalPointImageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FocalPointImageFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  focalPoint_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FocalPointImageLinkingCollections = {
  __typename?: 'FocalPointImageLinkingCollections';
  accordionsCollection?: Maybe<AccordionsCollection>;
  accordionsCursorCollection?: Maybe<AccordionsCursorCollection>;
  birdEyeReviewsCollection?: Maybe<BirdEyeReviewsCollection>;
  birdEyeReviewsCursorCollection?: Maybe<BirdEyeReviewsCursorCollection>;
  cardCollection?: Maybe<CardCollection>;
  cardCursorCollection?: Maybe<CardCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  mediaSliderCollection?: Maybe<MediaSliderCollection>;
  mediaSliderCursorCollection?: Maybe<MediaSliderCursorCollection>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  odpHeroCursorCollection?: Maybe<OdpHeroCursorCollection>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
  questionnaireCursorCollection?: Maybe<QuestionnaireCursorCollection>;
  sectionContentCollection?: Maybe<SectionContentCollection>;
  sectionContentCursorCollection?: Maybe<SectionContentCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  singleMessageCursorCollection?: Maybe<SingleMessageCursorCollection>;
  smallScreenContentCollection?: Maybe<SmallScreenContentCollection>;
  smallScreenContentCursorCollection?: Maybe<SmallScreenContentCursorCollection>;
};


export type FocalPointImageLinkingCollectionsAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsAccordionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsAccordionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsAccordionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsBirdEyeReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsBirdEyeReviewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsBirdEyeReviewsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsBirdEyeReviewsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsHeroV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsMediaSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsMediaSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsMediaSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsMediaSliderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsOdpHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsOdpHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsOdpHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsQuestionnaireCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsQuestionnaireCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsQuestionnaireCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsSectionContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSectionContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsSectionContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSectionContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsSingleMessageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSingleMessageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsSmallScreenContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSmallScreenContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FocalPointImageLinkingCollectionsSmallScreenContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageLinkingCollectionsSmallScreenContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FocalPointImageLinkingCollectionsAccordionsCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type FocalPointImageLinkingCollectionsAccordionsCursorCollectionOrder =
  | 'accordionsHeading_ASC'
  | 'accordionsHeading_DESC'
  | 'allowMultipleExpanded_ASC'
  | 'allowMultipleExpanded_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonCollectionAlignment_ASC'
  | 'buttonCollectionAlignment_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'defaultExpanded_ASC'
  | 'defaultExpanded_DESC'
  | 'descriptionAlignment_ASC'
  | 'descriptionAlignment_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'expandIconPosition_ASC'
  | 'expandIconPosition_DESC'
  | 'expandIconType_ASC'
  | 'expandIconType_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'imagePositionRight_ASC'
  | 'imagePositionRight_DESC'
  | 'imageRoundedCorner_ASC'
  | 'imageRoundedCorner_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'roundedCornersSize_ASC'
  | 'roundedCornersSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleAlignment_ASC'
  | 'titleAlignment_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withInnerGap_ASC'
  | 'withInnerGap_DESC';

export type FocalPointImageLinkingCollectionsBirdEyeReviewsCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'filteredReviewsMinRating_ASC'
  | 'filteredReviewsMinRating_DESC'
  | 'filteredReviewsTitle_ASC'
  | 'filteredReviewsTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsBirdEyeReviewsCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'filteredReviewsMinRating_ASC'
  | 'filteredReviewsMinRating_DESC'
  | 'filteredReviewsTitle_ASC'
  | 'filteredReviewsTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsCardCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FocalPointImageLinkingCollectionsHeroV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FocalPointImageLinkingCollectionsMediaSliderCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FocalPointImageLinkingCollectionsMediaSliderCursorCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FocalPointImageLinkingCollectionsOdpHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsOdpHeroCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsQuestionnaireCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsQuestionnaireCursorCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FocalPointImageLinkingCollectionsSectionContentCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageShape_ASC'
  | 'imageShape_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'orientation_ASC'
  | 'orientation_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type FocalPointImageLinkingCollectionsSectionContentCursorCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageShape_ASC'
  | 'imageShape_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'orientation_ASC'
  | 'orientation_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type FocalPointImageLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FocalPointImageLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FocalPointImageLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FocalPointImageLinkingCollectionsSingleMessageCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FocalPointImageLinkingCollectionsSmallScreenContentCollectionOrder =
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowSmallScreen_ASC'
  | 'eyebrowSmallScreen_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FocalPointImageLinkingCollectionsSmallScreenContentCursorCollectionOrder =
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowSmallScreen_ASC'
  | 'eyebrowSmallScreen_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FocalPointImageOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroup = Entry & _Node & {
  __typename?: 'FooterNavigationGroup';
  _id: Scalars['ID']['output'];
  componentName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<FooterNavigationGroupLinkingCollections>;
  navigationGroupLink?: Maybe<Page>;
  navigationGroupTitle?: Maybe<Scalars['String']['output']>;
  navigationLinksForGroupCollection?: Maybe<FooterNavigationGroupNavigationLinksForGroupCollection>;
  navigationLinksForGroupCursorCollection?: Maybe<FooterNavigationGroupNavigationLinksForGroupCursorCollection>;
  sys: Sys;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupNavigationGroupLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupNavigationGroupTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupNavigationLinksForGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FooterNavigationGroupNavigationLinksForGroupFilter>;
};


/** Footer Navigation Group Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/footerNavigationGroup) */
export type FooterNavigationGroupNavigationLinksForGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FooterNavigationGroupNavigationLinksForGroupFilter>;
};

export type FooterNavigationGroupCollection = {
  __typename?: 'FooterNavigationGroupCollection';
  items: Array<Maybe<FooterNavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FooterNavigationGroupCursorCollection = {
  __typename?: 'FooterNavigationGroupCursorCollection';
  items: Array<Maybe<FooterNavigationGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FooterNavigationGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterNavigationGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterNavigationGroupFilter>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  navigationGroupLink?: InputMaybe<CfPageNestedFilter>;
  navigationGroupLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupTitle?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_contains?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationGroupTitle_not?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationLinksForGroup?: InputMaybe<CfnavigationLinksForGroupMultiTypeNestedFilter>;
  navigationLinksForGroupCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterNavigationGroupLinkingCollections = {
  __typename?: 'FooterNavigationGroupLinkingCollections';
  adFooterCollection?: Maybe<AdFooterCollection>;
  adFooterCursorCollection?: Maybe<AdFooterCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerCursorCollection?: Maybe<HeaderCursorCollection>;
};


export type FooterNavigationGroupLinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupLinkingCollectionsAdFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FooterNavigationGroupLinkingCollectionsAdFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupLinkingCollectionsAdFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FooterNavigationGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FooterNavigationGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FooterNavigationGroupLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FooterNavigationGroupLinkingCollectionsHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupLinkingCollectionsHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FooterNavigationGroupLinkingCollectionsAdFooterCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FooterNavigationGroupLinkingCollectionsAdFooterCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FooterNavigationGroupLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FooterNavigationGroupLinkingCollectionsHeaderCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type FooterNavigationGroupNavigationLinksForGroupCollection = {
  __typename?: 'FooterNavigationGroupNavigationLinksForGroupCollection';
  items: Array<Maybe<FooterNavigationGroupNavigationLinksForGroupItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FooterNavigationGroupNavigationLinksForGroupCursorCollection = {
  __typename?: 'FooterNavigationGroupNavigationLinksForGroupCursorCollection';
  items: Array<Maybe<FooterNavigationGroupNavigationLinksForGroupItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FooterNavigationGroupNavigationLinksForGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterNavigationGroupNavigationLinksForGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterNavigationGroupNavigationLinksForGroupFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterNavigationGroupNavigationLinksForGroupItem = NavigationLink | Page;

export type FooterNavigationGroupOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownField = Entry & _Node & {
  __typename?: 'FormDropdownField';
  _id: Scalars['ID']['output'];
  alertMessage?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  clearTextItem?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  itemList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  itemsCollection?: Maybe<FormDropdownFieldItemsCollection>;
  itemsCursorCollection?: Maybe<FormDropdownFieldItemsCursorCollection>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<FormDropdownFieldLinkingCollections>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldAlertMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldApiKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldClearTextItemArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldItemListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldRequiredArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formDropdownField) */
export type FormDropdownFieldTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormDropdownFieldCollection = {
  __typename?: 'FormDropdownFieldCollection';
  items: Array<Maybe<FormDropdownField>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FormDropdownFieldCursorCollection = {
  __typename?: 'FormDropdownFieldCursorCollection';
  items: Array<Maybe<FormDropdownField>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FormDropdownFieldFilter = {
  AND?: InputMaybe<Array<InputMaybe<FormDropdownFieldFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FormDropdownFieldFilter>>>;
  alertMessage?: InputMaybe<Scalars['String']['input']>;
  alertMessage_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alertMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alertMessage_not?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey_not?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clearTextItem?: InputMaybe<Scalars['String']['input']>;
  clearTextItem_contains?: InputMaybe<Scalars['String']['input']>;
  clearTextItem_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearTextItem_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clearTextItem_not?: InputMaybe<Scalars['String']['input']>;
  clearTextItem_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearTextItem_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  itemList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  required_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormDropdownFieldItemsCollection = {
  __typename?: 'FormDropdownFieldItemsCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FormDropdownFieldItemsCursorCollection = {
  __typename?: 'FormDropdownFieldItemsCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FormDropdownFieldLinkingCollections = {
  __typename?: 'FormDropdownFieldLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
  questionnaireCursorCollection?: Maybe<QuestionnaireCursorCollection>;
  schemaStepCollection?: Maybe<SchemaStepCollection>;
  schemaStepCursorCollection?: Maybe<SchemaStepCursorCollection>;
};


export type FormDropdownFieldLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormDropdownFieldLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormDropdownFieldLinkingCollectionsQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldLinkingCollectionsQuestionnaireCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormDropdownFieldLinkingCollectionsQuestionnaireCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldLinkingCollectionsQuestionnaireCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormDropdownFieldLinkingCollectionsSchemaStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldLinkingCollectionsSchemaStepCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormDropdownFieldLinkingCollectionsSchemaStepCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldLinkingCollectionsSchemaStepCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormDropdownFieldLinkingCollectionsQuestionnaireCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FormDropdownFieldLinkingCollectionsQuestionnaireCursorCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FormDropdownFieldLinkingCollectionsSchemaStepCollectionOrder =
  | 'formTitle_ASC'
  | 'formTitle_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FormDropdownFieldLinkingCollectionsSchemaStepCursorCollectionOrder =
  | 'formTitle_ASC'
  | 'formTitle_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FormDropdownFieldOrder =
  | 'alertMessage_ASC'
  | 'alertMessage_DESC'
  | 'apiKey_ASC'
  | 'apiKey_DESC'
  | 'clearTextItem_ASC'
  | 'clearTextItem_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormField = Entry & _Node & {
  __typename?: 'FormField';
  _id: Scalars['ID']['output'];
  alertMessage?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Asset>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<FormFieldLinkingCollections>;
  onSubmitFormUrl?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldAlertMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldApiKeyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldOnSubmitFormUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldPlaceholderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldRequiredArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/formField) */
export type FormFieldTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormFieldCollection = {
  __typename?: 'FormFieldCollection';
  items: Array<Maybe<FormField>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FormFieldCursorCollection = {
  __typename?: 'FormFieldCursorCollection';
  items: Array<Maybe<FormField>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type FormFieldFilter = {
  AND?: InputMaybe<Array<InputMaybe<FormFieldFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FormFieldFilter>>>;
  alertMessage?: InputMaybe<Scalars['String']['input']>;
  alertMessage_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alertMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alertMessage_not?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey_not?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onSubmitFormUrl?: InputMaybe<Scalars['String']['input']>;
  onSubmitFormUrl_contains?: InputMaybe<Scalars['String']['input']>;
  onSubmitFormUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  onSubmitFormUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onSubmitFormUrl_not?: InputMaybe<Scalars['String']['input']>;
  onSubmitFormUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  onSubmitFormUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  placeholder_contains?: InputMaybe<Scalars['String']['input']>;
  placeholder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  placeholder_not?: InputMaybe<Scalars['String']['input']>;
  placeholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  required_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormFieldLinkingCollections = {
  __typename?: 'FormFieldLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
  questionnaireCursorCollection?: Maybe<QuestionnaireCursorCollection>;
  schemaStepCollection?: Maybe<SchemaStepCollection>;
  schemaStepCursorCollection?: Maybe<SchemaStepCursorCollection>;
};


export type FormFieldLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormFieldLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormFieldLinkingCollectionsQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormFieldLinkingCollectionsQuestionnaireCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormFieldLinkingCollectionsQuestionnaireCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormFieldLinkingCollectionsQuestionnaireCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormFieldLinkingCollectionsSchemaStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormFieldLinkingCollectionsSchemaStepCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FormFieldLinkingCollectionsSchemaStepCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormFieldLinkingCollectionsSchemaStepCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormFieldLinkingCollectionsQuestionnaireCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FormFieldLinkingCollectionsQuestionnaireCursorCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type FormFieldLinkingCollectionsSchemaStepCollectionOrder =
  | 'formTitle_ASC'
  | 'formTitle_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FormFieldLinkingCollectionsSchemaStepCursorCollectionOrder =
  | 'formTitle_ASC'
  | 'formTitle_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type FormFieldOrder =
  | 'alertMessage_ASC'
  | 'alertMessage_DESC'
  | 'apiKey_ASC'
  | 'apiKey_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'onSubmitFormUrl_ASC'
  | 'onSubmitFormUrl_DESC'
  | 'placeholder_ASC'
  | 'placeholder_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplate = Entry & _Node & {
  __typename?: 'GoogleMapTemplate';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  availableServicesTabs?: Maybe<Tabs>;
  contentfulMetadata: ContentfulMetadata;
  defaultImage?: Maybe<Asset>;
  desktopZoom?: Maybe<Scalars['Float']['output']>;
  disableMarkerClick?: Maybe<Scalars['Boolean']['output']>;
  facilityBadgeLabel?: Maybe<Scalars['String']['output']>;
  facilityBasePath?: Maybe<Scalars['String']['output']>;
  facilityButtonLabel?: Maybe<Scalars['String']['output']>;
  googleMapsBusinessQuery?: Maybe<Scalars['String']['output']>;
  hideLocationCardButtons?: Maybe<Scalars['Boolean']['output']>;
  hideLocationsListOnMobile?: Maybe<Scalars['Boolean']['output']>;
  hideOfficeDetailsButton?: Maybe<Scalars['Boolean']['output']>;
  holidayHoursMessageText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<GoogleMapTemplateLinkingCollections>;
  listTabIsHorizontalScrolling?: Maybe<Scalars['Boolean']['output']>;
  locationScheduleButtonUrl?: Maybe<Scalars['String']['output']>;
  mobileZoom?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noResultsContent?: Maybe<MultiCardV2>;
  noResultsFoundImage?: Maybe<ImageAsset>;
  noResultsFoundMessage?: Maybe<GoogleMapTemplateNoResultsFoundMessage>;
  officeDetailsButton?: Maybe<Button>;
  scheduleButton?: Maybe<Button>;
  searchRadius?: Maybe<Scalars['Int']['output']>;
  searchResultLimit?: Maybe<Scalars['Int']['output']>;
  selectedImage?: Maybe<Asset>;
  service?: Maybe<Scalars['String']['output']>;
  setAsOfficeButtonText?: Maybe<Scalars['String']['output']>;
  singleComingSoonMessage?: Maybe<GoogleMapTemplateSingleComingSoonMessage>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  useCumulativeDesign?: Maybe<Scalars['Boolean']['output']>;
  useModernDesign?: Maybe<Scalars['Boolean']['output']>;
  useUsaCountryMap?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateAvailableServicesTabsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateDefaultImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateDesktopZoomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateDisableMarkerClickArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateFacilityBadgeLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateFacilityBasePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateFacilityButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateGoogleMapsBusinessQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateHideLocationCardButtonsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateHideLocationsListOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateHideOfficeDetailsButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateHolidayHoursMessageTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateListTabIsHorizontalScrollingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateLocationScheduleButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateMobileZoomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateNoResultsContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MultiCardV2Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateNoResultsFoundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateNoResultsFoundMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateOfficeDetailsButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateScheduleButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSearchRadiusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSearchResultLimitArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSelectedImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateServiceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSetAsOfficeButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateSingleComingSoonMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateUseCumulativeDesignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateUseModernDesignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/googleMapTemplate) */
export type GoogleMapTemplateUseUsaCountryMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoogleMapTemplateCollection = {
  __typename?: 'GoogleMapTemplateCollection';
  items: Array<Maybe<GoogleMapTemplate>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GoogleMapTemplateCursorCollection = {
  __typename?: 'GoogleMapTemplateCursorCollection';
  items: Array<Maybe<GoogleMapTemplate>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GoogleMapTemplateFilter = {
  AND?: InputMaybe<Array<InputMaybe<GoogleMapTemplateFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<GoogleMapTemplateFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableServicesTabs?: InputMaybe<CfTabsNestedFilter>;
  availableServicesTabs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopZoom?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopZoom_gt?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_gte?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  desktopZoom_lt?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_lte?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_not?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  disableMarkerClick?: InputMaybe<Scalars['Boolean']['input']>;
  disableMarkerClick_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableMarkerClick_not?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBadgeLabel?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBadgeLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBadgeLabel_not?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBasePath?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBasePath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBasePath_not?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityButtonLabel?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideLocationCardButtons?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationCardButtons_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationCardButtons_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationsListOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationsListOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationsListOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideOfficeDetailsButton?: InputMaybe<Scalars['Boolean']['input']>;
  hideOfficeDetailsButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideOfficeDetailsButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  holidayHoursMessageText?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_contains?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  holidayHoursMessageText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holidayHoursMessageText_not?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_not_contains?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listTabIsHorizontalScrolling?: InputMaybe<Scalars['Boolean']['input']>;
  listTabIsHorizontalScrolling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  listTabIsHorizontalScrolling_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationScheduleButtonUrl?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationScheduleButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationScheduleButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileZoom?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileZoom_gt?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_gte?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  mobileZoom_lt?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_lte?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_not?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noResultsContent?: InputMaybe<CfMultiCardV2NestedFilter>;
  noResultsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundImage?: InputMaybe<CfImageAssetNestedFilter>;
  noResultsFoundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundMessage_contains?: InputMaybe<Scalars['String']['input']>;
  noResultsFoundMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeDetailsButton?: InputMaybe<CfButtonNestedFilter>;
  officeDetailsButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleButton?: InputMaybe<CfButtonNestedFilter>;
  scheduleButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRadius?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRadius_gt?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_gte?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchRadius_lt?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_lte?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_not?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchResultLimit?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchResultLimit_gt?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_gte?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchResultLimit_lt?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_lte?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_not?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  selectedImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  service_contains?: InputMaybe<Scalars['String']['input']>;
  service_exists?: InputMaybe<Scalars['Boolean']['input']>;
  service_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  service_not?: InputMaybe<Scalars['String']['input']>;
  service_not_contains?: InputMaybe<Scalars['String']['input']>;
  service_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setAsOfficeButtonText?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  setAsOfficeButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setAsOfficeButtonText_not?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  singleComingSoonMessage_contains?: InputMaybe<Scalars['String']['input']>;
  singleComingSoonMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  singleComingSoonMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useCumulativeDesign?: InputMaybe<Scalars['Boolean']['input']>;
  useCumulativeDesign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useCumulativeDesign_not?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign_not?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoogleMapTemplateLinkingCollections = {
  __typename?: 'GoogleMapTemplateLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerCursorCollection?: Maybe<HeaderCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type GoogleMapTemplateLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GoogleMapTemplateLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoogleMapTemplateLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type GoogleMapTemplateLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type GoogleMapTemplateLinkingCollectionsHeaderCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type GoogleMapTemplateLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type GoogleMapTemplateNoResultsFoundMessage = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessage';
  json: Scalars['JSON']['output'];
  links: GoogleMapTemplateNoResultsFoundMessageLinks;
};

export type GoogleMapTemplateNoResultsFoundMessageAssets = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type GoogleMapTemplateNoResultsFoundMessageEntries = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type GoogleMapTemplateNoResultsFoundMessageLinks = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageLinks';
  assets: GoogleMapTemplateNoResultsFoundMessageAssets;
  entries: GoogleMapTemplateNoResultsFoundMessageEntries;
  resources: GoogleMapTemplateNoResultsFoundMessageResources;
};

export type GoogleMapTemplateNoResultsFoundMessageResources = {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageResources';
  block: Array<GoogleMapTemplateNoResultsFoundMessageResourcesBlock>;
  hyperlink: Array<GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink>;
  inline: Array<GoogleMapTemplateNoResultsFoundMessageResourcesInline>;
};

export type GoogleMapTemplateNoResultsFoundMessageResourcesBlock = ResourceLink & {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesBlock';
  sys: ResourceSys;
};

export type GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink = ResourceLink & {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink';
  sys: ResourceSys;
};

export type GoogleMapTemplateNoResultsFoundMessageResourcesInline = ResourceLink & {
  __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesInline';
  sys: ResourceSys;
};

export type GoogleMapTemplateOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type GoogleMapTemplateSingleComingSoonMessage = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessage';
  json: Scalars['JSON']['output'];
  links: GoogleMapTemplateSingleComingSoonMessageLinks;
};

export type GoogleMapTemplateSingleComingSoonMessageAssets = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type GoogleMapTemplateSingleComingSoonMessageEntries = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type GoogleMapTemplateSingleComingSoonMessageLinks = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageLinks';
  assets: GoogleMapTemplateSingleComingSoonMessageAssets;
  entries: GoogleMapTemplateSingleComingSoonMessageEntries;
  resources: GoogleMapTemplateSingleComingSoonMessageResources;
};

export type GoogleMapTemplateSingleComingSoonMessageResources = {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageResources';
  block: Array<GoogleMapTemplateSingleComingSoonMessageResourcesBlock>;
  hyperlink: Array<GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink>;
  inline: Array<GoogleMapTemplateSingleComingSoonMessageResourcesInline>;
};

export type GoogleMapTemplateSingleComingSoonMessageResourcesBlock = ResourceLink & {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesBlock';
  sys: ResourceSys;
};

export type GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink = ResourceLink & {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink';
  sys: ResourceSys;
};

export type GoogleMapTemplateSingleComingSoonMessageResourcesInline = ResourceLink & {
  __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesInline';
  sys: ResourceSys;
};

/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreen = Entry & _Node & {
  __typename?: 'HalfScreen';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  body?: Maybe<HalfScreenBody>;
  buttonCollection?: Maybe<HalfScreenButtonCollection>;
  buttonCursorCollection?: Maybe<HalfScreenButtonCursorCollection>;
  contentSmallScreen?: Maybe<SmallScreenContent>;
  contentfulMetadata: ContentfulMetadata;
  disclaimer?: Maybe<DisclaimerV2>;
  display?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowStyle?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<HalfScreenHeading>;
  hideContentHalf?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Asset>;
  imageAsset?: Maybe<ImageAsset>;
  imageAssetTwo?: Maybe<ImageAsset>;
  isInsetLayout?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<HalfScreenLinkingCollections>;
  mediaFirst?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<HalfScreenSubHeading>;
  sys: Sys;
  templateSize?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<TermsAndConditions>;
  textAlignment?: Maybe<Scalars['String']['output']>;
  useStaticImageSize?: Maybe<Scalars['Boolean']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Video>;
  videoAsset?: Maybe<VideoAsset>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenBodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenContentSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenDisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenEyebrowStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenHideContentHalfArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenImageAssetTwoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenIsInsetLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenMediaFirstArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenSubHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenTemplateSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenTermsAndConditionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenUseStaticImageSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/**
 * HalfScreen template:
 *
 * https://www.figma.com/file/CzH3RUoUxD7Kihz8tfwuI6/2023-Redesign-Templates?node-id=19%3A198&t=tBH0ZaSVvcii3NoH-0 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/halfScreen)
 */
export type HalfScreenVideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};

export type HalfScreenBody = {
  __typename?: 'HalfScreenBody';
  json: Scalars['JSON']['output'];
  links: HalfScreenBodyLinks;
};

export type HalfScreenBodyAssets = {
  __typename?: 'HalfScreenBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HalfScreenBodyEntries = {
  __typename?: 'HalfScreenBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HalfScreenBodyLinks = {
  __typename?: 'HalfScreenBodyLinks';
  assets: HalfScreenBodyAssets;
  entries: HalfScreenBodyEntries;
  resources: HalfScreenBodyResources;
};

export type HalfScreenBodyResources = {
  __typename?: 'HalfScreenBodyResources';
  block: Array<HalfScreenBodyResourcesBlock>;
  hyperlink: Array<HalfScreenBodyResourcesHyperlink>;
  inline: Array<HalfScreenBodyResourcesInline>;
};

export type HalfScreenBodyResourcesBlock = ResourceLink & {
  __typename?: 'HalfScreenBodyResourcesBlock';
  sys: ResourceSys;
};

export type HalfScreenBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'HalfScreenBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type HalfScreenBodyResourcesInline = ResourceLink & {
  __typename?: 'HalfScreenBodyResourcesInline';
  sys: ResourceSys;
};

export type HalfScreenButtonCollection = {
  __typename?: 'HalfScreenButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HalfScreenButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HalfScreenButtonCursorCollection = {
  __typename?: 'HalfScreenButtonCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HalfScreenButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HalfScreenCollection = {
  __typename?: 'HalfScreenCollection';
  items: Array<Maybe<HalfScreen>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HalfScreenCursorCollection = {
  __typename?: 'HalfScreenCursorCollection';
  items: Array<Maybe<HalfScreen>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HalfScreenFilter = {
  AND?: InputMaybe<Array<InputMaybe<HalfScreenFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HalfScreenFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<CfButtonNestedFilter>;
  buttonCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentSmallScreen?: InputMaybe<CfSmallScreenContentNestedFilter>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer?: InputMaybe<CfDisclaimerV2NestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowStyle_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  hideContentHalf?: InputMaybe<Scalars['Boolean']['input']>;
  hideContentHalf_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideContentHalf_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAssetTwo?: InputMaybe<CfImageAssetNestedFilter>;
  imageAssetTwo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInsetLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isInsetLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInsetLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  subHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateSize?: InputMaybe<Scalars['String']['input']>;
  templateSize_contains?: InputMaybe<Scalars['String']['input']>;
  templateSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateSize_not?: InputMaybe<Scalars['String']['input']>;
  templateSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  termsAndConditions_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment?: InputMaybe<Scalars['String']['input']>;
  textAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useStaticImageSize?: InputMaybe<Scalars['Boolean']['input']>;
  useStaticImageSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useStaticImageSize_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video?: InputMaybe<CfVideoNestedFilter>;
  videoAsset?: InputMaybe<CfVideoAssetNestedFilter>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HalfScreenHeading = {
  __typename?: 'HalfScreenHeading';
  json: Scalars['JSON']['output'];
  links: HalfScreenHeadingLinks;
};

export type HalfScreenHeadingAssets = {
  __typename?: 'HalfScreenHeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HalfScreenHeadingEntries = {
  __typename?: 'HalfScreenHeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HalfScreenHeadingLinks = {
  __typename?: 'HalfScreenHeadingLinks';
  assets: HalfScreenHeadingAssets;
  entries: HalfScreenHeadingEntries;
  resources: HalfScreenHeadingResources;
};

export type HalfScreenHeadingResources = {
  __typename?: 'HalfScreenHeadingResources';
  block: Array<HalfScreenHeadingResourcesBlock>;
  hyperlink: Array<HalfScreenHeadingResourcesHyperlink>;
  inline: Array<HalfScreenHeadingResourcesInline>;
};

export type HalfScreenHeadingResourcesBlock = ResourceLink & {
  __typename?: 'HalfScreenHeadingResourcesBlock';
  sys: ResourceSys;
};

export type HalfScreenHeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'HalfScreenHeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type HalfScreenHeadingResourcesInline = ResourceLink & {
  __typename?: 'HalfScreenHeadingResourcesInline';
  sys: ResourceSys;
};

export type HalfScreenLinkingCollections = {
  __typename?: 'HalfScreenLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type HalfScreenLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HalfScreenLinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenLinkingCollectionsTabCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HalfScreenLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type HalfScreenLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type HalfScreenLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HalfScreenLinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HalfScreenLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HalfScreenLinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HalfScreenLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HalfScreenLinkingCollectionsTabCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HalfScreenLinkingCollectionsTabCursorCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HalfScreenOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HalfScreenSubHeading = {
  __typename?: 'HalfScreenSubHeading';
  json: Scalars['JSON']['output'];
  links: HalfScreenSubHeadingLinks;
};

export type HalfScreenSubHeadingAssets = {
  __typename?: 'HalfScreenSubHeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HalfScreenSubHeadingEntries = {
  __typename?: 'HalfScreenSubHeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HalfScreenSubHeadingLinks = {
  __typename?: 'HalfScreenSubHeadingLinks';
  assets: HalfScreenSubHeadingAssets;
  entries: HalfScreenSubHeadingEntries;
  resources: HalfScreenSubHeadingResources;
};

export type HalfScreenSubHeadingResources = {
  __typename?: 'HalfScreenSubHeadingResources';
  block: Array<HalfScreenSubHeadingResourcesBlock>;
  hyperlink: Array<HalfScreenSubHeadingResourcesHyperlink>;
  inline: Array<HalfScreenSubHeadingResourcesInline>;
};

export type HalfScreenSubHeadingResourcesBlock = ResourceLink & {
  __typename?: 'HalfScreenSubHeadingResourcesBlock';
  sys: ResourceSys;
};

export type HalfScreenSubHeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'HalfScreenSubHeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type HalfScreenSubHeadingResourcesInline = ResourceLink & {
  __typename?: 'HalfScreenSubHeadingResourcesInline';
  sys: ResourceSys;
};

/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type Header = Entry & _Node & {
  __typename?: 'Header';
  _id: Scalars['ID']['output'];
  bookNowButton?: Maybe<Entry>;
  bottomAlertBanner?: Maybe<Banner>;
  componentName?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  darkHeader?: Maybe<Scalars['Boolean']['output']>;
  googleMapsForLocationCards?: Maybe<GoogleMapTemplate>;
  hideFullSiteSearch?: Maybe<Scalars['Boolean']['output']>;
  hideOdpLinks?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<HeaderLinkingCollections>;
  locationBarFindOfficeUrl?: Maybe<Scalars['String']['output']>;
  locationBarWithOfficeTitle?: Maybe<Scalars['String']['output']>;
  locationBarWithOutOfficeTitle?: Maybe<Scalars['String']['output']>;
  locationNavigationLinksCollection?: Maybe<HeaderLocationNavigationLinksCollection>;
  locationNavigationLinksCursorCollection?: Maybe<HeaderLocationNavigationLinksCursorCollection>;
  mobileQuizLink?: Maybe<Entry>;
  myAccountLabel?: Maybe<Scalars['String']['output']>;
  navigationLinksCollection?: Maybe<HeaderNavigationLinksCollection>;
  navigationLinksCursorCollection?: Maybe<HeaderNavigationLinksCursorCollection>;
  navigationMenu?: Maybe<HeaderNavMenu>;
  phoneNumber?: Maybe<NavigationLink>;
  profileLinkUrl?: Maybe<Scalars['String']['output']>;
  schedulingButtonText?: Maybe<Scalars['String']['output']>;
  schedulingButtonTextMobile?: Maybe<Scalars['String']['output']>;
  schedulingButtonUrl?: Maybe<Scalars['String']['output']>;
  schedulingButtonUrlMobile?: Maybe<Scalars['String']['output']>;
  schedulingNavigationLinksCollection?: Maybe<HeaderSchedulingNavigationLinksCollection>;
  schedulingNavigationLinksCursorCollection?: Maybe<HeaderSchedulingNavigationLinksCursorCollection>;
  searchFieldTitle?: Maybe<Scalars['String']['output']>;
  secondaryNavigationLinksCollection?: Maybe<HeaderSecondaryNavigationLinksCollection>;
  secondaryNavigationLinksCursorCollection?: Maybe<HeaderSecondaryNavigationLinksCursorCollection>;
  showSecondaryNavInMobileToolbar?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  topAlertBanner?: Maybe<Banner>;
  topNavigationLinksCollection?: Maybe<HeaderTopNavigationLinksCollection>;
  topNavigationLinksCursorCollection?: Maybe<HeaderTopNavigationLinksCursorCollection>;
  useHeaderLocationCards?: Maybe<Scalars['Boolean']['output']>;
  useNewLayout?: Maybe<Scalars['Boolean']['output']>;
  usePopupScheduling?: Maybe<Scalars['Boolean']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderBookNowButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BannerFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderComponentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderDarkHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderGoogleMapsForLocationCardsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GoogleMapTemplateFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderHideFullSiteSearchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderHideOdpLinksArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationBarFindOfficeUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationBarWithOfficeTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationBarWithOutOfficeTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderLocationNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderLocationNavigationLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderLocationNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderMobileQuizLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderMyAccountLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderNavigationLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderNavigationMenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderNavMenuFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderPhoneNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderProfileLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingButtonTextMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingButtonUrlMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSchedulingNavigationLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSchedulingNavigationLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSchedulingNavigationLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSearchFieldTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSecondaryNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderSecondaryNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderSecondaryNavigationLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderSecondaryNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderShowSecondaryNavInMobileToolbarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BannerFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderTopNavigationLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderTopNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderTopNavigationLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderTopNavigationLinksFilter>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderUseHeaderLocationCardsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderUseNewLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderUsePopupSchedulingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Header Component [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/header) */
export type HeaderVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderCollection = {
  __typename?: 'HeaderCollection';
  items: Array<Maybe<Header>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderCursorCollection = {
  __typename?: 'HeaderCursorCollection';
  items: Array<Maybe<Header>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderFilter>>>;
  bookNowButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomAlertBanner?: InputMaybe<CfBannerNestedFilter>;
  bottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>;
  darkHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkHeader_not?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsForLocationCards?: InputMaybe<CfGoogleMapTemplateNestedFilter>;
  googleMapsForLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpLinks_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarFindOfficeUrl?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarFindOfficeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarFindOfficeUrl_not?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOfficeTitle?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarWithOfficeTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOfficeTitle_not?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOutOfficeTitle?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarWithOutOfficeTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOutOfficeTitle_not?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationNavigationLinks?: InputMaybe<CflocationNavigationLinksMultiTypeNestedFilter>;
  locationNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileQuizLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  myAccountLabel?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_contains?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  myAccountLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  myAccountLabel_not?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationLinks?: InputMaybe<CfnavigationLinksMultiTypeNestedFilter>;
  navigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationMenu?: InputMaybe<CfHeaderNavMenuNestedFilter>;
  navigationMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<CfNavigationLinkNestedFilter>;
  phoneNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profileLinkUrl?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profileLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonTextMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonTextMobile_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonUrlMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrlMobile_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingNavigationLinks?: InputMaybe<CfNavigationGroupNestedFilter>;
  schedulingNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchFieldTitle?: InputMaybe<Scalars['String']['input']>;
  searchFieldTitle_contains?: InputMaybe<Scalars['String']['input']>;
  searchFieldTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchFieldTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFieldTitle_not?: InputMaybe<Scalars['String']['input']>;
  searchFieldTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  searchFieldTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryNavigationLinks?: InputMaybe<CfsecondaryNavigationLinksMultiTypeNestedFilter>;
  secondaryNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  topAlertBanner?: InputMaybe<CfBannerNestedFilter>;
  topAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  topNavigationLinks?: InputMaybe<CftopNavigationLinksMultiTypeNestedFilter>;
  topNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HeaderLinkingCollections = {
  __typename?: 'HeaderLinkingCollections';
  appCollection?: Maybe<AppCollection>;
  appCursorCollection?: Maybe<AppCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type HeaderLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderLinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderLinkingCollectionsAppCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderLinkingCollectionsAppCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderLinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderLinkingCollectionsAppCursorCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderLocationNavigationLinksCollection = {
  __typename?: 'HeaderLocationNavigationLinksCollection';
  items: Array<Maybe<HeaderLocationNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderLocationNavigationLinksCursorCollection = {
  __typename?: 'HeaderLocationNavigationLinksCursorCollection';
  items: Array<Maybe<HeaderLocationNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderLocationNavigationLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderLocationNavigationLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderLocationNavigationLinksFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderLocationNavigationLinksItem = NavigationLink | Page;

/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNav = Entry & _Node & {
  __typename?: 'HeaderMainNav';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  headerMainNavLink?: Maybe<NavigationLink>;
  headerSubNavMenu?: Maybe<HeaderSubNav>;
  linkedFrom?: Maybe<HeaderMainNavLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNavHeaderMainNavLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNavHeaderSubNavMenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderSubNavFilter>;
};


/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNavLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The Header Navigation Menu Link and Sub Menu(navigation groups with links) displayed on hover of this link. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerMainNav) */
export type HeaderMainNavNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderMainNavCollection = {
  __typename?: 'HeaderMainNavCollection';
  items: Array<Maybe<HeaderMainNav>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderMainNavCursorCollection = {
  __typename?: 'HeaderMainNavCursorCollection';
  items: Array<Maybe<HeaderMainNav>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderMainNavFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderMainNavFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderMainNavFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerMainNavLink?: InputMaybe<CfNavigationLinkNestedFilter>;
  headerMainNavLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSubNavMenu?: InputMaybe<CfHeaderSubNavNestedFilter>;
  headerSubNavMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderMainNavLinkingCollections = {
  __typename?: 'HeaderMainNavLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  headerNavMenuCollection?: Maybe<HeaderNavMenuCollection>;
  headerNavMenuCursorCollection?: Maybe<HeaderNavMenuCursorCollection>;
};


export type HeaderMainNavLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderMainNavLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderMainNavLinkingCollectionsHeaderNavMenuCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderMainNavLinkingCollectionsHeaderNavMenuCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderMainNavLinkingCollectionsHeaderNavMenuCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderMainNavLinkingCollectionsHeaderNavMenuCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderMainNavLinkingCollectionsHeaderNavMenuCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderMainNavLinkingCollectionsHeaderNavMenuCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderMainNavOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenu = Entry & _Node & {
  __typename?: 'HeaderNavMenu';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  headerMainNavLinksCollection?: Maybe<HeaderNavMenuHeaderMainNavLinksCollection>;
  headerMainNavLinksCursorCollection?: Maybe<HeaderNavMenuHeaderMainNavLinksCursorCollection>;
  linkedFrom?: Maybe<HeaderNavMenuLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenuHeaderMainNavLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuHeaderMainNavLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderMainNavFilter>;
};


/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenuHeaderMainNavLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuHeaderMainNavLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderMainNavFilter>;
};


/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenuLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The navigation menu displayed in the header with main nav links and the sub nav groups and links. The sub nav will be displayed when hover over the main nav links. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerNavMenu) */
export type HeaderNavMenuNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderNavMenuCollection = {
  __typename?: 'HeaderNavMenuCollection';
  items: Array<Maybe<HeaderNavMenu>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderNavMenuCursorCollection = {
  __typename?: 'HeaderNavMenuCursorCollection';
  items: Array<Maybe<HeaderNavMenu>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderNavMenuFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderNavMenuFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderNavMenuFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerMainNavLinks?: InputMaybe<CfHeaderMainNavNestedFilter>;
  headerMainNavLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderNavMenuHeaderMainNavLinksCollection = {
  __typename?: 'HeaderNavMenuHeaderMainNavLinksCollection';
  items: Array<Maybe<HeaderMainNav>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderNavMenuHeaderMainNavLinksCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderNavMenuHeaderMainNavLinksCursorCollection = {
  __typename?: 'HeaderNavMenuHeaderMainNavLinksCursorCollection';
  items: Array<Maybe<HeaderMainNav>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderNavMenuHeaderMainNavLinksCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderNavMenuLinkingCollections = {
  __typename?: 'HeaderNavMenuLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerCursorCollection?: Maybe<HeaderCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type HeaderNavMenuLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderNavMenuLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderNavMenuLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderNavMenuLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderNavMenuLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderNavMenuLinkingCollectionsHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuLinkingCollectionsHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderNavMenuLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderNavMenuLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderNavMenuLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type HeaderNavMenuLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type HeaderNavMenuLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HeaderNavMenuLinkingCollectionsHeaderCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HeaderNavMenuLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeaderNavMenuLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeaderNavMenuOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderNavigationLinksCollection = {
  __typename?: 'HeaderNavigationLinksCollection';
  items: Array<Maybe<HeaderNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderNavigationLinksCursorCollection = {
  __typename?: 'HeaderNavigationLinksCursorCollection';
  items: Array<Maybe<HeaderNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderNavigationLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderNavigationLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderNavigationLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderNavigationLinksItem = FooterNavigationGroup | NavigationGroup | NavigationLink | Page;

export type HeaderOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HeaderSchedulingNavigationLinksCollection = {
  __typename?: 'HeaderSchedulingNavigationLinksCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSchedulingNavigationLinksCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSchedulingNavigationLinksCursorCollection = {
  __typename?: 'HeaderSchedulingNavigationLinksCursorCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderSchedulingNavigationLinksCursorCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSecondaryNavigationLinksCollection = {
  __typename?: 'HeaderSecondaryNavigationLinksCollection';
  items: Array<Maybe<HeaderSecondaryNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSecondaryNavigationLinksCursorCollection = {
  __typename?: 'HeaderSecondaryNavigationLinksCursorCollection';
  items: Array<Maybe<HeaderSecondaryNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderSecondaryNavigationLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderSecondaryNavigationLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderSecondaryNavigationLinksFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderSecondaryNavigationLinksItem = NavigationLink | Page;

/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNav = Entry & _Node & {
  __typename?: 'HeaderSubNav';
  _id: Scalars['ID']['output'];
  contentTilesCollection?: Maybe<HeaderSubNavContentTilesCollection>;
  contentTilesCursorCollection?: Maybe<HeaderSubNavContentTilesCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  featuredLink?: Maybe<NavigationLink>;
  headerSubNavGroupsCollection?: Maybe<HeaderSubNavHeaderSubNavGroupsCollection>;
  headerSubNavGroupsCursorCollection?: Maybe<HeaderSubNavHeaderSubNavGroupsCursorCollection>;
  linkedFrom?: Maybe<HeaderSubNavLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavContentTilesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavContentTilesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTileFilter>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavContentTilesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavContentTilesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTileFilter>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavFeaturedLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavHeaderSubNavGroupsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavHeaderSubNavGroupsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavHeaderSubNavGroupsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavHeaderSubNavGroupsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The navigation groups with sub links when hover over the header main nav link [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/headerSubNav) */
export type HeaderSubNavNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderSubNavCollection = {
  __typename?: 'HeaderSubNavCollection';
  items: Array<Maybe<HeaderSubNav>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSubNavContentTilesCollection = {
  __typename?: 'HeaderSubNavContentTilesCollection';
  items: Array<Maybe<ContentTile>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSubNavContentTilesCollectionOrder =
  | 'description_ASC'
  | 'description_DESC'
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeaderSubNavContentTilesCursorCollection = {
  __typename?: 'HeaderSubNavContentTilesCursorCollection';
  items: Array<Maybe<ContentTile>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderSubNavContentTilesCursorCollectionOrder =
  | 'description_ASC'
  | 'description_DESC'
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeaderSubNavCursorCollection = {
  __typename?: 'HeaderSubNavCursorCollection';
  items: Array<Maybe<HeaderSubNav>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderSubNavFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderSubNavFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderSubNavFilter>>>;
  contentTiles?: InputMaybe<CfContentTileNestedFilter>;
  contentTilesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  featuredLink?: InputMaybe<CfNavigationLinkNestedFilter>;
  featuredLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSubNavGroups?: InputMaybe<CfNavigationGroupNestedFilter>;
  headerSubNavGroupsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderSubNavHeaderSubNavGroupsCollection = {
  __typename?: 'HeaderSubNavHeaderSubNavGroupsCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderSubNavHeaderSubNavGroupsCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSubNavHeaderSubNavGroupsCursorCollection = {
  __typename?: 'HeaderSubNavHeaderSubNavGroupsCursorCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderSubNavHeaderSubNavGroupsCursorCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSubNavLinkingCollections = {
  __typename?: 'HeaderSubNavLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  headerMainNavCollection?: Maybe<HeaderMainNavCollection>;
  headerMainNavCursorCollection?: Maybe<HeaderMainNavCursorCollection>;
};


export type HeaderSubNavLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderSubNavLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderSubNavLinkingCollectionsHeaderMainNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavLinkingCollectionsHeaderMainNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeaderSubNavLinkingCollectionsHeaderMainNavCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavLinkingCollectionsHeaderMainNavCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaderSubNavLinkingCollectionsHeaderMainNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSubNavLinkingCollectionsHeaderMainNavCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderSubNavOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeaderTopNavigationLinksCollection = {
  __typename?: 'HeaderTopNavigationLinksCollection';
  items: Array<Maybe<HeaderTopNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeaderTopNavigationLinksCursorCollection = {
  __typename?: 'HeaderTopNavigationLinksCursorCollection';
  items: Array<Maybe<HeaderTopNavigationLinksItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeaderTopNavigationLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderTopNavigationLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderTopNavigationLinksFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeaderTopNavigationLinksItem = NavigationLink | Page;

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heading) */
export type Heading = Entry & _Node & {
  __typename?: 'Heading';
  _id: Scalars['ID']['output'];
  content?: Maybe<HeadingContent>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<HeadingLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heading) */
export type HeadingContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heading) */
export type HeadingLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heading) */
export type HeadingNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeadingCollection = {
  __typename?: 'HeadingCollection';
  items: Array<Maybe<Heading>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeadingContent = {
  __typename?: 'HeadingContent';
  json: Scalars['JSON']['output'];
  links: HeadingContentLinks;
};

export type HeadingContentAssets = {
  __typename?: 'HeadingContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeadingContentEntries = {
  __typename?: 'HeadingContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeadingContentLinks = {
  __typename?: 'HeadingContentLinks';
  assets: HeadingContentAssets;
  entries: HeadingContentEntries;
  resources: HeadingContentResources;
};

export type HeadingContentResources = {
  __typename?: 'HeadingContentResources';
  block: Array<HeadingContentResourcesBlock>;
  hyperlink: Array<HeadingContentResourcesHyperlink>;
  inline: Array<HeadingContentResourcesInline>;
};

export type HeadingContentResourcesBlock = ResourceLink & {
  __typename?: 'HeadingContentResourcesBlock';
  sys: ResourceSys;
};

export type HeadingContentResourcesHyperlink = ResourceLink & {
  __typename?: 'HeadingContentResourcesHyperlink';
  sys: ResourceSys;
};

export type HeadingContentResourcesInline = ResourceLink & {
  __typename?: 'HeadingContentResourcesInline';
  sys: ResourceSys;
};

export type HeadingCursorCollection = {
  __typename?: 'HeadingCursorCollection';
  items: Array<Maybe<Heading>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeadingFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeadingFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeadingFilter>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeadingLinkingCollections = {
  __typename?: 'HeadingLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type HeadingLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeadingLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeadingOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2 = Entry & _Node & {
  __typename?: 'HeroV2';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  aspenDentalReasonForVisit?: Maybe<Scalars['String']['output']>;
  backgroundColorSmallScreen?: Maybe<Scalars['String']['output']>;
  body?: Maybe<HeroV2Body>;
  bodySize?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<HeroV2ButtonsCollection>;
  buttonsCursorCollection?: Maybe<HeroV2ButtonsCursorCollection>;
  contentAlign?: Maybe<Scalars['String']['output']>;
  contentPosition?: Maybe<Scalars['String']['output']>;
  contentPositionSmallScreen?: Maybe<Scalars['String']['output']>;
  contentSmallScreen?: Maybe<SmallScreenContent>;
  contentWidth?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  darkOverlay?: Maybe<Scalars['Boolean']['output']>;
  darkTextColor?: Maybe<Scalars['Boolean']['output']>;
  disclaimer?: Maybe<DisclaimerV2>;
  display?: Maybe<Scalars['String']['output']>;
  entryName?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowStyle?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  focalPointImage?: Maybe<FocalPointImage>;
  heading?: Maybe<HeroV2Heading>;
  headingSize?: Maybe<Scalars['String']['output']>;
  heightStyle?: Maybe<Scalars['String']['output']>;
  imageAsset?: Maybe<ImageAsset>;
  linkedFrom?: Maybe<HeroV2LinkingCollections>;
  mediaAspectRatioSmallScreen?: Maybe<Scalars['String']['output']>;
  nestedContentCollection?: Maybe<HeroV2NestedContentCollection>;
  nestedContentCursorCollection?: Maybe<HeroV2NestedContentCursorCollection>;
  promoHeadline?: Maybe<HeroV2PromoHeadline>;
  promoHeadlineSize?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  termsConditions?: Maybe<TermsAndConditions>;
  variant?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Asset>;
  videoAsset?: Maybe<VideoAsset>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2AnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2AspenDentalReasonForVisitArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2BackgroundColorSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2BodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2BodySizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2ButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2ButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentPositionSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ContentWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2DarkOverlayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2DarkTextColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2DisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2DisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2EntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2EyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2EyebrowStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2FacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2FocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2HeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2HeadingSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2HeightStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2ImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2MediaAspectRatioSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2NestedContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2NestedContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuizFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2NestedContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2NestedContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuizFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2PromoHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2PromoHeadlineSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2TemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2TermsConditionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2VariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2VideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/heroV2) */
export type HeroV2VideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};

export type HeroV2Body = {
  __typename?: 'HeroV2Body';
  json: Scalars['JSON']['output'];
  links: HeroV2BodyLinks;
};

export type HeroV2BodyAssets = {
  __typename?: 'HeroV2BodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeroV2BodyEntries = {
  __typename?: 'HeroV2BodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeroV2BodyLinks = {
  __typename?: 'HeroV2BodyLinks';
  assets: HeroV2BodyAssets;
  entries: HeroV2BodyEntries;
  resources: HeroV2BodyResources;
};

export type HeroV2BodyResources = {
  __typename?: 'HeroV2BodyResources';
  block: Array<HeroV2BodyResourcesBlock>;
  hyperlink: Array<HeroV2BodyResourcesHyperlink>;
  inline: Array<HeroV2BodyResourcesInline>;
};

export type HeroV2BodyResourcesBlock = ResourceLink & {
  __typename?: 'HeroV2BodyResourcesBlock';
  sys: ResourceSys;
};

export type HeroV2BodyResourcesHyperlink = ResourceLink & {
  __typename?: 'HeroV2BodyResourcesHyperlink';
  sys: ResourceSys;
};

export type HeroV2BodyResourcesInline = ResourceLink & {
  __typename?: 'HeroV2BodyResourcesInline';
  sys: ResourceSys;
};

export type HeroV2ButtonsCollection = {
  __typename?: 'HeroV2ButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroV2ButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HeroV2ButtonsCursorCollection = {
  __typename?: 'HeroV2ButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeroV2ButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HeroV2Collection = {
  __typename?: 'HeroV2Collection';
  items: Array<Maybe<HeroV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroV2CursorCollection = {
  __typename?: 'HeroV2CursorCollection';
  items: Array<Maybe<HeroV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeroV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<HeroV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroV2Filter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspenDentalReasonForVisit?: InputMaybe<Scalars['String']['input']>;
  aspenDentalReasonForVisit_contains?: InputMaybe<Scalars['String']['input']>;
  aspenDentalReasonForVisit_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aspenDentalReasonForVisit_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspenDentalReasonForVisit_not?: InputMaybe<Scalars['String']['input']>;
  aspenDentalReasonForVisit_not_contains?: InputMaybe<Scalars['String']['input']>;
  aspenDentalReasonForVisit_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColorSmallScreen?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColorSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColorSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodySize?: InputMaybe<Scalars['String']['input']>;
  bodySize_contains?: InputMaybe<Scalars['String']['input']>;
  bodySize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodySize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodySize_not?: InputMaybe<Scalars['String']['input']>;
  bodySize_not_contains?: InputMaybe<Scalars['String']['input']>;
  bodySize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPosition?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentPositionSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPositionSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentPositionSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPosition_contains?: InputMaybe<Scalars['String']['input']>;
  contentPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPosition_not?: InputMaybe<Scalars['String']['input']>;
  contentPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentSmallScreen?: InputMaybe<CfSmallScreenContentNestedFilter>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentWidth?: InputMaybe<Scalars['String']['input']>;
  contentWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  darkOverlay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_not?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer?: InputMaybe<CfDisclaimerV2NestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowStyle_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSize?: InputMaybe<Scalars['String']['input']>;
  headingSize_contains?: InputMaybe<Scalars['String']['input']>;
  headingSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingSize_not?: InputMaybe<Scalars['String']['input']>;
  headingSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heightStyle?: InputMaybe<Scalars['String']['input']>;
  heightStyle_contains?: InputMaybe<Scalars['String']['input']>;
  heightStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heightStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heightStyle_not?: InputMaybe<Scalars['String']['input']>;
  heightStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  heightStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaAspectRatioSmallScreen?: InputMaybe<Scalars['String']['input']>;
  mediaAspectRatioSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAspectRatioSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaAspectRatioSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaAspectRatioSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  mediaAspectRatioSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaAspectRatioSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nestedContent?: InputMaybe<CfQuizNestedFilter>;
  nestedContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  promoHeadlineSize?: InputMaybe<Scalars['String']['input']>;
  promoHeadlineSize_contains?: InputMaybe<Scalars['String']['input']>;
  promoHeadlineSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  promoHeadlineSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoHeadlineSize_not?: InputMaybe<Scalars['String']['input']>;
  promoHeadlineSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  promoHeadlineSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  promoHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  promoHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsConditions?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  termsConditions_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoAsset?: InputMaybe<CfVideoAssetNestedFilter>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroV2Heading = {
  __typename?: 'HeroV2Heading';
  json: Scalars['JSON']['output'];
  links: HeroV2HeadingLinks;
};

export type HeroV2HeadingAssets = {
  __typename?: 'HeroV2HeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeroV2HeadingEntries = {
  __typename?: 'HeroV2HeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeroV2HeadingLinks = {
  __typename?: 'HeroV2HeadingLinks';
  assets: HeroV2HeadingAssets;
  entries: HeroV2HeadingEntries;
  resources: HeroV2HeadingResources;
};

export type HeroV2HeadingResources = {
  __typename?: 'HeroV2HeadingResources';
  block: Array<HeroV2HeadingResourcesBlock>;
  hyperlink: Array<HeroV2HeadingResourcesHyperlink>;
  inline: Array<HeroV2HeadingResourcesInline>;
};

export type HeroV2HeadingResourcesBlock = ResourceLink & {
  __typename?: 'HeroV2HeadingResourcesBlock';
  sys: ResourceSys;
};

export type HeroV2HeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'HeroV2HeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type HeroV2HeadingResourcesInline = ResourceLink & {
  __typename?: 'HeroV2HeadingResourcesInline';
  sys: ResourceSys;
};

export type HeroV2LinkingCollections = {
  __typename?: 'HeroV2LinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type HeroV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HeroV2LinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2LinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeroV2LinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type HeroV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type HeroV2LinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2LinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2LinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2LinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2LinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeroV2LinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeroV2LinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2LinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type HeroV2NestedContentCollection = {
  __typename?: 'HeroV2NestedContentCollection';
  items: Array<Maybe<Quiz>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HeroV2NestedContentCollectionOrder =
  | 'clearChoicePoorCreditRedirectPath_ASC'
  | 'clearChoicePoorCreditRedirectPath_DESC'
  | 'isFormBuilder_ASC'
  | 'isFormBuilder_DESC'
  | 'leadGenPopUpImageDesktop_ASC'
  | 'leadGenPopUpImageDesktop_DESC'
  | 'leadGenPopUpImageMobile_ASC'
  | 'leadGenPopUpImageMobile_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizType_ASC'
  | 'quizType_DESC'
  | 'submitEndpointUrl_ASC'
  | 'submitEndpointUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeroV2NestedContentCursorCollection = {
  __typename?: 'HeroV2NestedContentCursorCollection';
  items: Array<Maybe<Quiz>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HeroV2NestedContentCursorCollectionOrder =
  | 'clearChoicePoorCreditRedirectPath_ASC'
  | 'clearChoicePoorCreditRedirectPath_DESC'
  | 'isFormBuilder_ASC'
  | 'isFormBuilder_DESC'
  | 'leadGenPopUpImageDesktop_ASC'
  | 'leadGenPopUpImageDesktop_DESC'
  | 'leadGenPopUpImageMobile_ASC'
  | 'leadGenPopUpImageMobile_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizType_ASC'
  | 'quizType_DESC'
  | 'submitEndpointUrl_ASC'
  | 'submitEndpointUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type HeroV2Order =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type HeroV2PromoHeadline = {
  __typename?: 'HeroV2PromoHeadline';
  json: Scalars['JSON']['output'];
  links: HeroV2PromoHeadlineLinks;
};

export type HeroV2PromoHeadlineAssets = {
  __typename?: 'HeroV2PromoHeadlineAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HeroV2PromoHeadlineEntries = {
  __typename?: 'HeroV2PromoHeadlineEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HeroV2PromoHeadlineLinks = {
  __typename?: 'HeroV2PromoHeadlineLinks';
  assets: HeroV2PromoHeadlineAssets;
  entries: HeroV2PromoHeadlineEntries;
  resources: HeroV2PromoHeadlineResources;
};

export type HeroV2PromoHeadlineResources = {
  __typename?: 'HeroV2PromoHeadlineResources';
  block: Array<HeroV2PromoHeadlineResourcesBlock>;
  hyperlink: Array<HeroV2PromoHeadlineResourcesHyperlink>;
  inline: Array<HeroV2PromoHeadlineResourcesInline>;
};

export type HeroV2PromoHeadlineResourcesBlock = ResourceLink & {
  __typename?: 'HeroV2PromoHeadlineResourcesBlock';
  sys: ResourceSys;
};

export type HeroV2PromoHeadlineResourcesHyperlink = ResourceLink & {
  __typename?: 'HeroV2PromoHeadlineResourcesHyperlink';
  sys: ResourceSys;
};

export type HeroV2PromoHeadlineResourcesInline = ResourceLink & {
  __typename?: 'HeroV2PromoHeadlineResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/icon) */
export type Icon = Entry & _Node & {
  __typename?: 'Icon';
  _id: Scalars['ID']['output'];
  brandfolderSvgUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<IconLinkingCollections>;
  muiIcon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/icon) */
export type IconBrandfolderSvgUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/icon) */
export type IconLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/icon) */
export type IconMuiIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/icon) */
export type IconNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconCollection = {
  __typename?: 'IconCollection';
  items: Array<Maybe<Icon>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IconCursorCollection = {
  __typename?: 'IconCursorCollection';
  items: Array<Maybe<Icon>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type IconFilter = {
  AND?: InputMaybe<Array<InputMaybe<IconFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IconFilter>>>;
  brandfolderSvgUrl?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderSvgUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandfolderSvgUrl_not?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  muiIcon?: InputMaybe<Scalars['String']['input']>;
  muiIcon_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  muiIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  muiIcon_not?: InputMaybe<Scalars['String']['input']>;
  muiIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type IconLinkingCollections = {
  __typename?: 'IconLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type IconLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IconLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IconOrder =
  | 'brandfolderSvgUrl_ASC'
  | 'brandfolderSvgUrl_DESC'
  | 'muiIcon_ASC'
  | 'muiIcon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type Iframe = Entry & _Node & {
  __typename?: 'Iframe';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<IframeLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  rawHtml?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeRawHtmlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Providing  a component to embed an iframe on the page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/iframe) */
export type IframeUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IframeCollection = {
  __typename?: 'IframeCollection';
  items: Array<Maybe<Iframe>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IframeCursorCollection = {
  __typename?: 'IframeCursorCollection';
  items: Array<Maybe<Iframe>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type IframeFilter = {
  AND?: InputMaybe<Array<InputMaybe<IframeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IframeFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawHtml?: InputMaybe<Scalars['String']['input']>;
  rawHtml_contains?: InputMaybe<Scalars['String']['input']>;
  rawHtml_exists?: InputMaybe<Scalars['Boolean']['input']>;
  rawHtml_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawHtml_not?: InputMaybe<Scalars['String']['input']>;
  rawHtml_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawHtml_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IframeLinkingCollections = {
  __typename?: 'IframeLinkingCollections';
  appCollection?: Maybe<AppCollection>;
  appCursorCollection?: Maybe<AppCursorCollection>;
  buttonCollection?: Maybe<ButtonCollection>;
  buttonCursorCollection?: Maybe<ButtonCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type IframeLinkingCollectionsAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsAppCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsAppCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsAppCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IframeLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IframeLinkingCollectionsAppCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type IframeLinkingCollectionsAppCursorCollectionOrder =
  | 'brandImageLink_ASC'
  | 'brandImageLink_DESC'
  | 'branding_ASC'
  | 'branding_DESC'
  | 'isDeprecated_ASC'
  | 'isDeprecated_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type IframeLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type IframeLinkingCollectionsButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type IframeLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type IframeLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type IframeLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type IframeLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type IframeOrder =
  | 'height_ASC'
  | 'height_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAsset = Entry & _Node & {
  __typename?: 'ImageAsset';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  desktopImage?: Maybe<Scalars['JSON']['output']>;
  linkedFrom?: Maybe<ImageAssetLinkingCollections>;
  mobileImage?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content type used to display images with focal point using Brand Folder Image with separate images for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/imageAsset) */
export type ImageAssetNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageAssetCollection = {
  __typename?: 'ImageAssetCollection';
  items: Array<Maybe<ImageAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ImageAssetCursorCollection = {
  __typename?: 'ImageAssetCursorCollection';
  items: Array<Maybe<ImageAsset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ImageAssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<ImageAssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageAssetFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ImageAssetLinkingCollections = {
  __typename?: 'ImageAssetLinkingCollections';
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  cardCollection?: Maybe<CardCollection>;
  cardCursorCollection?: Maybe<CardCursorCollection>;
  categoryCollection?: Maybe<CategoryCollection>;
  categoryCursorCollection?: Maybe<CategoryCursorCollection>;
  columnsCollection?: Maybe<ColumnsCollection>;
  columnsCursorCollection?: Maybe<ColumnsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  googleMapTemplateCursorCollection?: Maybe<GoogleMapTemplateCursorCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  multiCardV2CursorCollection?: Maybe<MultiCardV2CursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  patientReviewsV2Collection?: Maybe<PatientReviewsV2Collection>;
  patientReviewsV2CursorCollection?: Maybe<PatientReviewsV2CursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  singleMessageCursorCollection?: Maybe<SingleMessageCursorCollection>;
};


export type ImageAssetLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsCategoryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsCategoryCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsColumnsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsGoogleMapTemplateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsGoogleMapTemplateCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsGoogleMapTemplateCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsHalfScreenCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsHeroV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsMultiCardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsMultiCardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsMultiCardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsPatientReviewsV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsPatientReviewsV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsPatientReviewsV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsPatientReviewsV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ImageAssetLinkingCollectionsSingleMessageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetLinkingCollectionsSingleMessageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageAssetLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsCardCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsCategoryCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsCategoryCursorCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'link_ASC'
  | 'link_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsColumnsCursorCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsGoogleMapTemplateCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type ImageAssetLinkingCollectionsGoogleMapTemplateCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type ImageAssetLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsHalfScreenCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsHeroV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsMultiCardV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsMultiCardV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsPatientReviewsV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type ImageAssetLinkingCollectionsPatientReviewsV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type ImageAssetLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ImageAssetLinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ImageAssetLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ImageAssetLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetLinkingCollectionsSingleMessageCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ImageAssetOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ImageFormat =
  /** AVIF image format. */
  | 'AVIF'
  /** JPG image format. */
  | 'JPG'
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  | 'JPG_PROGRESSIVE'
  /** PNG image format */
  | 'PNG'
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  | 'PNG8'
  /** WebP image format. */
  | 'WEBP';

export type ImageResizeFocus =
  /** Focus the resizing on the bottom. */
  | 'BOTTOM'
  /** Focus the resizing on the bottom left. */
  | 'BOTTOM_LEFT'
  /** Focus the resizing on the bottom right. */
  | 'BOTTOM_RIGHT'
  /** Focus the resizing on the center. */
  | 'CENTER'
  /** Focus the resizing on the largest face. */
  | 'FACE'
  /** Focus the resizing on the area containing all the faces. */
  | 'FACES'
  /** Focus the resizing on the left. */
  | 'LEFT'
  /** Focus the resizing on the right. */
  | 'RIGHT'
  /** Focus the resizing on the top. */
  | 'TOP'
  /** Focus the resizing on the top left. */
  | 'TOP_LEFT'
  /** Focus the resizing on the top right. */
  | 'TOP_RIGHT';

export type ImageResizeStrategy =
  /** Crops a part of the original image to fit into the specified dimensions. */
  | 'CROP'
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  | 'FILL'
  /** Resizes the image to fit into the specified dimensions. */
  | 'FIT'
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  | 'PAD'
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  | 'SCALE'
  /** Creates a thumbnail from the image. */
  | 'THUMB';

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']['input']>;
};

/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type Insurance = Entry & _Node & {
  __typename?: 'Insurance';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  intro?: Maybe<InsuranceIntro>;
  linkedFrom?: Maybe<InsuranceLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type InsuranceIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type InsuranceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type InsuranceNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** List Insurance Providers by States with a Rich Text Introduction [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/insurance) */
export type InsuranceTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceCollection = {
  __typename?: 'InsuranceCollection';
  items: Array<Maybe<Insurance>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InsuranceCursorCollection = {
  __typename?: 'InsuranceCursorCollection';
  items: Array<Maybe<Insurance>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type InsuranceFilter = {
  AND?: InputMaybe<Array<InputMaybe<InsuranceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<InsuranceFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InsuranceIntro = {
  __typename?: 'InsuranceIntro';
  json: Scalars['JSON']['output'];
  links: InsuranceIntroLinks;
};

export type InsuranceIntroAssets = {
  __typename?: 'InsuranceIntroAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type InsuranceIntroEntries = {
  __typename?: 'InsuranceIntroEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type InsuranceIntroLinks = {
  __typename?: 'InsuranceIntroLinks';
  assets: InsuranceIntroAssets;
  entries: InsuranceIntroEntries;
  resources: InsuranceIntroResources;
};

export type InsuranceIntroResources = {
  __typename?: 'InsuranceIntroResources';
  block: Array<InsuranceIntroResourcesBlock>;
  hyperlink: Array<InsuranceIntroResourcesHyperlink>;
  inline: Array<InsuranceIntroResourcesInline>;
};

export type InsuranceIntroResourcesBlock = ResourceLink & {
  __typename?: 'InsuranceIntroResourcesBlock';
  sys: ResourceSys;
};

export type InsuranceIntroResourcesHyperlink = ResourceLink & {
  __typename?: 'InsuranceIntroResourcesHyperlink';
  sys: ResourceSys;
};

export type InsuranceIntroResourcesInline = ResourceLink & {
  __typename?: 'InsuranceIntroResourcesInline';
  sys: ResourceSys;
};

export type InsuranceLinkingCollections = {
  __typename?: 'InsuranceLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type InsuranceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InsuranceLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InsuranceLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<InsuranceLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InsuranceLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<InsuranceLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InsuranceLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<InsuranceLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InsuranceLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<InsuranceLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type InsuranceLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type InsuranceLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type InsuranceLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type InsuranceOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Allows one to forward a platform page to an external page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/linkForwarder) */
export type LinkForwarder = Entry & _Node & {
  __typename?: 'LinkForwarder';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<LinkForwarderLinkingCollections>;
  sys: Sys;
  url?: Maybe<Scalars['String']['output']>;
};


/** Allows one to forward a platform page to an external page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/linkForwarder) */
export type LinkForwarderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Allows one to forward a platform page to an external page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/linkForwarder) */
export type LinkForwarderUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkForwarderCollection = {
  __typename?: 'LinkForwarderCollection';
  items: Array<Maybe<LinkForwarder>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LinkForwarderCursorCollection = {
  __typename?: 'LinkForwarderCursorCollection';
  items: Array<Maybe<LinkForwarder>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LinkForwarderFilter = {
  AND?: InputMaybe<Array<InputMaybe<LinkForwarderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LinkForwarderFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LinkForwarderLinkingCollections = {
  __typename?: 'LinkForwarderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type LinkForwarderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkForwarderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkForwarderLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkForwarderLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkForwarderLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkForwarderLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkForwarderLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkForwarderLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkForwarderLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkForwarderLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkForwarderLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type LinkForwarderLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type LinkForwarderLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type LinkForwarderLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type LinkForwarderOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** Supports a collection of List Items [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/list) */
export type List = Entry & _Node & {
  __typename?: 'List';
  _id: Scalars['ID']['output'];
  brandfolderSvgUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  itemsCollection?: Maybe<ListItemsCollection>;
  itemsCursorCollection?: Maybe<ListItemsCursorCollection>;
  linkedFrom?: Maybe<ListLinkingCollections>;
  muiIcon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Supports a collection of List Items [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/list) */
export type ListBrandfolderSvgUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports a collection of List Items [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/list) */
export type ListItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ListItemFilter>;
};


/** Supports a collection of List Items [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/list) */
export type ListItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListItemsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ListItemFilter>;
};


/** Supports a collection of List Items [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/list) */
export type ListLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Supports a collection of List Items [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/list) */
export type ListMuiIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports a collection of List Items [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/list) */
export type ListNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListCollection = {
  __typename?: 'ListCollection';
  items: Array<Maybe<List>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ListCursorCollection = {
  __typename?: 'ListCursorCollection';
  items: Array<Maybe<List>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ListFilter>>>;
  brandfolderSvgUrl?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderSvgUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandfolderSvgUrl_not?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  items?: InputMaybe<CfListItemNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  muiIcon?: InputMaybe<Scalars['String']['input']>;
  muiIcon_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  muiIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  muiIcon_not?: InputMaybe<Scalars['String']['input']>;
  muiIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

/** Supports Icon and RTE [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/listItem) */
export type ListItem = Entry & _Node & {
  __typename?: 'ListItem';
  _id: Scalars['ID']['output'];
  brandfolderSvgUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkText?: Maybe<ListItemLinkText>;
  linkedFrom?: Maybe<ListItemLinkingCollections>;
  muiIcon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Supports Icon and RTE [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/listItem) */
export type ListItemBrandfolderSvgUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports Icon and RTE [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/listItem) */
export type ListItemLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports Icon and RTE [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/listItem) */
export type ListItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Supports Icon and RTE [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/listItem) */
export type ListItemMuiIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports Icon and RTE [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/listItem) */
export type ListItemNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListItemCollection = {
  __typename?: 'ListItemCollection';
  items: Array<Maybe<ListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ListItemCursorCollection = {
  __typename?: 'ListItemCursorCollection';
  items: Array<Maybe<ListItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ListItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ListItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ListItemFilter>>>;
  brandfolderSvgUrl?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderSvgUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandfolderSvgUrl_not?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon?: InputMaybe<Scalars['String']['input']>;
  muiIcon_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  muiIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  muiIcon_not?: InputMaybe<Scalars['String']['input']>;
  muiIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ListItemLinkText = {
  __typename?: 'ListItemLinkText';
  json: Scalars['JSON']['output'];
  links: ListItemLinkTextLinks;
};

export type ListItemLinkTextAssets = {
  __typename?: 'ListItemLinkTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ListItemLinkTextEntries = {
  __typename?: 'ListItemLinkTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ListItemLinkTextLinks = {
  __typename?: 'ListItemLinkTextLinks';
  assets: ListItemLinkTextAssets;
  entries: ListItemLinkTextEntries;
  resources: ListItemLinkTextResources;
};

export type ListItemLinkTextResources = {
  __typename?: 'ListItemLinkTextResources';
  block: Array<ListItemLinkTextResourcesBlock>;
  hyperlink: Array<ListItemLinkTextResourcesHyperlink>;
  inline: Array<ListItemLinkTextResourcesInline>;
};

export type ListItemLinkTextResourcesBlock = ResourceLink & {
  __typename?: 'ListItemLinkTextResourcesBlock';
  sys: ResourceSys;
};

export type ListItemLinkTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ListItemLinkTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ListItemLinkTextResourcesInline = ResourceLink & {
  __typename?: 'ListItemLinkTextResourcesInline';
  sys: ResourceSys;
};

export type ListItemLinkingCollections = {
  __typename?: 'ListItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  listCollection?: Maybe<ListCollection>;
  listCursorCollection?: Maybe<ListCursorCollection>;
};


export type ListItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ListItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ListItemLinkingCollectionsListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListItemLinkingCollectionsListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ListItemLinkingCollectionsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListItemLinkingCollectionsListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListItemLinkingCollectionsListCollectionOrder =
  | 'brandfolderSvgUrl_ASC'
  | 'brandfolderSvgUrl_DESC'
  | 'muiIcon_ASC'
  | 'muiIcon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ListItemLinkingCollectionsListCursorCollectionOrder =
  | 'brandfolderSvgUrl_ASC'
  | 'brandfolderSvgUrl_DESC'
  | 'muiIcon_ASC'
  | 'muiIcon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ListItemOrder =
  | 'brandfolderSvgUrl_ASC'
  | 'brandfolderSvgUrl_DESC'
  | 'muiIcon_ASC'
  | 'muiIcon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ListItemsCollection = {
  __typename?: 'ListItemsCollection';
  items: Array<Maybe<ListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ListItemsCollectionOrder =
  | 'brandfolderSvgUrl_ASC'
  | 'brandfolderSvgUrl_DESC'
  | 'muiIcon_ASC'
  | 'muiIcon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ListItemsCursorCollection = {
  __typename?: 'ListItemsCursorCollection';
  items: Array<Maybe<ListItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ListItemsCursorCollectionOrder =
  | 'brandfolderSvgUrl_ASC'
  | 'brandfolderSvgUrl_DESC'
  | 'muiIcon_ASC'
  | 'muiIcon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ListLinkingCollections = {
  __typename?: 'ListLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListOrder =
  | 'brandfolderSvgUrl_ASC'
  | 'brandfolderSvgUrl_DESC'
  | 'muiIcon_ASC'
  | 'muiIcon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitle = Entry & _Node & {
  __typename?: 'LocalizedServiceTitle';
  _id: Scalars['ID']['output'];
  callCenterLabel?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentTypeRichText>;
  googleMapsBusinessQuery?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<LocalizedServiceTitleLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  officeHoursLabel?: Maybe<Scalars['String']['output']>;
  showAddress?: Maybe<Scalars['Boolean']['output']>;
  showHours?: Maybe<Scalars['Boolean']['output']>;
  showPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleCallCenterLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleGoogleMapsBusinessQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleOfficeHoursLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleShowAddressArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleShowHoursArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleShowPhoneNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleTemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This template is to display office information on service details pages when we do not want to display same information in ODPHero. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/localizedServiceTitle) */
export type LocalizedServiceTitleTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalizedServiceTitleCollection = {
  __typename?: 'LocalizedServiceTitleCollection';
  items: Array<Maybe<LocalizedServiceTitle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LocalizedServiceTitleCursorCollection = {
  __typename?: 'LocalizedServiceTitleCursorCollection';
  items: Array<Maybe<LocalizedServiceTitle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LocalizedServiceTitleFilter = {
  AND?: InputMaybe<Array<InputMaybe<LocalizedServiceTitleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LocalizedServiceTitleFilter>>>;
  callCenterLabel?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_contains?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  callCenterLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callCenterLabel_not?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  officeHoursLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel_not?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHours?: InputMaybe<Scalars['Boolean']['input']>;
  showHours_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHours_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LocalizedServiceTitleLinkingCollections = {
  __typename?: 'LocalizedServiceTitleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type LocalizedServiceTitleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LocalizedServiceTitleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalizedServiceTitleOrder =
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type Marquee = Entry & _Node & {
  __typename?: 'Marquee';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MarqueeLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  textList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  withAutoScrolling?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeTextListArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/marquee) */
export type MarqueeWithAutoScrollingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarqueeCollection = {
  __typename?: 'MarqueeCollection';
  items: Array<Maybe<Marquee>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MarqueeCursorCollection = {
  __typename?: 'MarqueeCursorCollection';
  items: Array<Maybe<Marquee>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MarqueeFilter = {
  AND?: InputMaybe<Array<InputMaybe<MarqueeFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MarqueeFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['String']['input']>;
  height_contains?: InputMaybe<Scalars['String']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height_not?: InputMaybe<Scalars['String']['input']>;
  height_not_contains?: InputMaybe<Scalars['String']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  textList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  textList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withAutoScrolling?: InputMaybe<Scalars['Boolean']['input']>;
  withAutoScrolling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withAutoScrolling_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarqueeLinkingCollections = {
  __typename?: 'MarqueeLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type MarqueeLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarqueeLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarqueeLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MarqueeLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MarqueeLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MarqueeLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MarqueeLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MarqueeLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MarqueeLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MarqueeLinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MarqueeLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MarqueeLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MarqueeOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'height_ASC'
  | 'height_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'withAutoScrolling_ASC'
  | 'withAutoScrolling_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/media) */
export type Media = Entry & _Node & {
  __typename?: 'Media';
  _id: Scalars['ID']['output'];
  alt?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<MediaLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/media) */
export type MediaAltArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/media) */
export type MediaContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/media) */
export type MediaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/media) */
export type MediaNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/media) */
export type MediaPosterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/media) */
export type MediaSrcArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaCollection = {
  __typename?: 'MediaCollection';
  items: Array<Maybe<Media>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MediaCursorCollection = {
  __typename?: 'MediaCursorCollection';
  items: Array<Maybe<Media>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MediaFilter = {
  AND?: InputMaybe<Array<InputMaybe<MediaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MediaFilter>>>;
  alt?: InputMaybe<Scalars['String']['input']>;
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  alt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alt_not?: InputMaybe<Scalars['String']['input']>;
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poster?: InputMaybe<Scalars['String']['input']>;
  poster_contains?: InputMaybe<Scalars['String']['input']>;
  poster_exists?: InputMaybe<Scalars['Boolean']['input']>;
  poster_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poster_not?: InputMaybe<Scalars['String']['input']>;
  poster_not_contains?: InputMaybe<Scalars['String']['input']>;
  poster_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  src?: InputMaybe<Scalars['String']['input']>;
  src_contains?: InputMaybe<Scalars['String']['input']>;
  src_exists?: InputMaybe<Scalars['Boolean']['input']>;
  src_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  src_not?: InputMaybe<Scalars['String']['input']>;
  src_not_contains?: InputMaybe<Scalars['String']['input']>;
  src_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MediaLinkingCollections = {
  __typename?: 'MediaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  productCollection?: Maybe<ProductCollection>;
  productCursorCollection?: Maybe<ProductCursorCollection>;
};


export type MediaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaLinkingCollectionsProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaLinkingCollectionsProductCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaLinkingCollectionsProductCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaLinkingCollectionsProductCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaLinkingCollectionsProductCollectionOrder =
  | 'brandfolderImageAssetUrl_ASC'
  | 'brandfolderImageAssetUrl_DESC'
  | 'category_ASC'
  | 'category_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disclaimer_ASC'
  | 'disclaimer_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subCategory_ASC'
  | 'subCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MediaLinkingCollectionsProductCursorCollectionOrder =
  | 'brandfolderImageAssetUrl_ASC'
  | 'brandfolderImageAssetUrl_DESC'
  | 'category_ASC'
  | 'category_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disclaimer_ASC'
  | 'disclaimer_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subCategory_ASC'
  | 'subCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MediaOrder =
  | 'alt_ASC'
  | 'alt_DESC'
  | 'contentType_ASC'
  | 'contentType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'poster_ASC'
  | 'poster_DESC'
  | 'src_ASC'
  | 'src_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSlider = Entry & _Node & {
  __typename?: 'MediaSlider';
  _id: Scalars['ID']['output'];
  aspectRatio?: Maybe<Scalars['String']['output']>;
  badge?: Maybe<Badge>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<MediaSliderContentsCollection>;
  contentsCursorCollection?: Maybe<MediaSliderContentsCursorCollection>;
  linkedFrom?: Maybe<MediaSliderLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderBadgeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BadgeFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaSliderContentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderContentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaSliderContentsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mediaSlider) */
export type MediaSliderNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaSliderCollection = {
  __typename?: 'MediaSliderCollection';
  items: Array<Maybe<MediaSlider>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MediaSliderContentsCollection = {
  __typename?: 'MediaSliderContentsCollection';
  items: Array<Maybe<MediaSliderContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MediaSliderContentsCursorCollection = {
  __typename?: 'MediaSliderContentsCursorCollection';
  items: Array<Maybe<MediaSliderContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MediaSliderContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<MediaSliderContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MediaSliderContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MediaSliderContentsItem = FocalPointImage | Video;

export type MediaSliderCursorCollection = {
  __typename?: 'MediaSliderCursorCollection';
  items: Array<Maybe<MediaSlider>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MediaSliderFilter = {
  AND?: InputMaybe<Array<InputMaybe<MediaSliderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MediaSliderFilter>>>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badge?: InputMaybe<CfBadgeNestedFilter>;
  badge_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MediaSliderLinkingCollections = {
  __typename?: 'MediaSliderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureCursorCollection?: Maybe<ProductFeatureCursorCollection>;
};


export type MediaSliderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaSliderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaSliderLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaSliderLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaSliderLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaSliderLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaSliderLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MediaSliderLinkingCollectionsProductFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderLinkingCollectionsProductFeatureCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaSliderLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MediaSliderLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MediaSliderLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MediaSliderLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MediaSliderLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MediaSliderLinkingCollectionsProductFeatureCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MediaSliderOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalService = Entry & _Node & {
  __typename?: 'MedicalService';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<MedicalServiceDescription>;
  iconName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MedicalServiceLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceIconNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A medical service belongs to a service line, e.g Injury, X-ray, Covid-19 etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/medicalService) */
export type MedicalServiceTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MedicalServiceCollection = {
  __typename?: 'MedicalServiceCollection';
  items: Array<Maybe<MedicalService>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MedicalServiceCursorCollection = {
  __typename?: 'MedicalServiceCursorCollection';
  items: Array<Maybe<MedicalService>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MedicalServiceDescription = {
  __typename?: 'MedicalServiceDescription';
  json: Scalars['JSON']['output'];
  links: MedicalServiceDescriptionLinks;
};

export type MedicalServiceDescriptionAssets = {
  __typename?: 'MedicalServiceDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type MedicalServiceDescriptionEntries = {
  __typename?: 'MedicalServiceDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type MedicalServiceDescriptionLinks = {
  __typename?: 'MedicalServiceDescriptionLinks';
  assets: MedicalServiceDescriptionAssets;
  entries: MedicalServiceDescriptionEntries;
  resources: MedicalServiceDescriptionResources;
};

export type MedicalServiceDescriptionResources = {
  __typename?: 'MedicalServiceDescriptionResources';
  block: Array<MedicalServiceDescriptionResourcesBlock>;
  hyperlink: Array<MedicalServiceDescriptionResourcesHyperlink>;
  inline: Array<MedicalServiceDescriptionResourcesInline>;
};

export type MedicalServiceDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'MedicalServiceDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type MedicalServiceDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'MedicalServiceDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type MedicalServiceDescriptionResourcesInline = ResourceLink & {
  __typename?: 'MedicalServiceDescriptionResourcesInline';
  sys: ResourceSys;
};

export type MedicalServiceFilter = {
  AND?: InputMaybe<Array<InputMaybe<MedicalServiceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MedicalServiceFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  iconName_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconName_not?: InputMaybe<Scalars['String']['input']>;
  iconName_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MedicalServiceLinkingCollections = {
  __typename?: 'MedicalServiceLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
};


export type MedicalServiceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MedicalServiceLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MedicalServiceLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MedicalServiceLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MedicalServiceLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MedicalServiceLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MedicalServiceLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MedicalServiceLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MedicalServiceOrder =
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaff = Entry & _Node & {
  __typename?: 'MeetOurStaff';
  _id: Scalars['ID']['output'];
  alignment?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  contentMaxWidth?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MeetOurStaffLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  providerIDs?: Maybe<Scalars['String']['output']>;
  sectionBackground?: Maybe<Scalars['String']['output']>;
  showDisabledSwiperArrows?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  withDesktopPaginationNavigation?: Maybe<Scalars['Boolean']['output']>;
  withMobileArrowsNavigation?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffContentMaxWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffProviderIDsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffSectionBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffShowDisabledSwiperArrowsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffWithDesktopPaginationNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/meetOurStaff) */
export type MeetOurStaffWithMobileArrowsNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetOurStaffCollection = {
  __typename?: 'MeetOurStaffCollection';
  items: Array<Maybe<MeetOurStaff>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MeetOurStaffCursorCollection = {
  __typename?: 'MeetOurStaffCursorCollection';
  items: Array<Maybe<MeetOurStaff>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MeetOurStaffFilter = {
  AND?: InputMaybe<Array<InputMaybe<MeetOurStaffFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MeetOurStaffFilter>>>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignment_not?: InputMaybe<Scalars['String']['input']>;
  alignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerIDs?: InputMaybe<Scalars['String']['input']>;
  providerIDs_contains?: InputMaybe<Scalars['String']['input']>;
  providerIDs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  providerIDs_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerIDs_not?: InputMaybe<Scalars['String']['input']>;
  providerIDs_not_contains?: InputMaybe<Scalars['String']['input']>;
  providerIDs_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionBackground?: InputMaybe<Scalars['String']['input']>;
  sectionBackground_contains?: InputMaybe<Scalars['String']['input']>;
  sectionBackground_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionBackground_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionBackground_not?: InputMaybe<Scalars['String']['input']>;
  sectionBackground_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionBackground_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showDisabledSwiperArrows?: InputMaybe<Scalars['Boolean']['input']>;
  showDisabledSwiperArrows_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showDisabledSwiperArrows_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withDesktopPaginationNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  withDesktopPaginationNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withDesktopPaginationNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  withMobileArrowsNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  withMobileArrowsNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withMobileArrowsNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetOurStaffLinkingCollections = {
  __typename?: 'MeetOurStaffLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type MeetOurStaffLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MeetOurStaffLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MeetOurStaffLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MeetOurStaffLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MeetOurStaffLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MeetOurStaffOrder =
  | 'alignment_ASC'
  | 'alignment_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'contentMaxWidth_ASC'
  | 'contentMaxWidth_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'providerIDs_ASC'
  | 'providerIDs_DESC'
  | 'sectionBackground_ASC'
  | 'sectionBackground_DESC'
  | 'showDisabledSwiperArrows_ASC'
  | 'showDisabledSwiperArrows_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'withDesktopPaginationNavigation_ASC'
  | 'withDesktopPaginationNavigation_DESC'
  | 'withMobileArrowsNavigation_ASC'
  | 'withMobileArrowsNavigation_DESC';

/** A container component for metro region links (LD) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/metroLinks) */
export type MetroLinks = Entry & _Node & {
  __typename?: 'MetroLinks';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<MetroLinksLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A container component for metro region links (LD) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/metroLinks) */
export type MetroLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A container component for metro region links (LD) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/metroLinks) */
export type MetroLinksNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A container component for metro region links (LD) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/metroLinks) */
export type MetroLinksSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetroLinksCollection = {
  __typename?: 'MetroLinksCollection';
  items: Array<Maybe<MetroLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MetroLinksCursorCollection = {
  __typename?: 'MetroLinksCursorCollection';
  items: Array<Maybe<MetroLinks>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MetroLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<MetroLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MetroLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MetroLinksLinkingCollections = {
  __typename?: 'MetroLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type MetroLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetroLinksLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetroLinksLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MetroLinksLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetroLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MetroLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetroLinksLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MetroLinksLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MetroLinksLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MetroLinksLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetroLinksLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MetroLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MetroLinksLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MetroLinksLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MetroLinksOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButton = Entry & _Node & {
  __typename?: 'MobileButton';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']['output']>;
  iconPosition?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MobileButtonLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonIconPositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Mobile button content model [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/mobileButton) */
export type MobileButtonVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MobileButtonCollection = {
  __typename?: 'MobileButtonCollection';
  items: Array<Maybe<MobileButton>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MobileButtonCursorCollection = {
  __typename?: 'MobileButtonCursorCollection';
  items: Array<Maybe<MobileButton>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MobileButtonFilter = {
  AND?: InputMaybe<Array<InputMaybe<MobileButtonFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MobileButtonFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Scalars['String']['input']>;
  iconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MobileButtonLinkingCollections = {
  __typename?: 'MobileButtonLinkingCollections';
  buttonCollection?: Maybe<ButtonCollection>;
  buttonCursorCollection?: Maybe<ButtonCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type MobileButtonLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MobileButtonLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MobileButtonLinkingCollectionsButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MobileButtonLinkingCollectionsButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MobileButtonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MobileButtonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MobileButtonLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MobileButtonLinkingCollectionsButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MobileButtonOrder =
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2 = Entry & _Node & {
  __typename?: 'MultiCardV2';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<ImageAsset>;
  bigScreenBackground?: Maybe<Scalars['Boolean']['output']>;
  buttonsCollection?: Maybe<MultiCardV2ButtonsCollection>;
  buttonsCursorCollection?: Maybe<MultiCardV2ButtonsCursorCollection>;
  cardsAlignment?: Maybe<Scalars['String']['output']>;
  cardsCollection?: Maybe<MultiCardV2CardsCollection>;
  cardsCursorCollection?: Maybe<MultiCardV2CardsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  descriptionRichText?: Maybe<MultiCardV2DescriptionRichText>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  display?: Maybe<Scalars['String']['output']>;
  displayAsStepper?: Maybe<Scalars['Boolean']['output']>;
  enableMobileCarouselNavigation?: Maybe<Scalars['Boolean']['output']>;
  enableResourceCardMode?: Maybe<Scalars['Boolean']['output']>;
  eyebrowColor?: Maybe<Scalars['String']['output']>;
  eyebrowSx?: Maybe<Scalars['String']['output']>;
  eyebrowTextTransform?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  fixBackgroundToBottom?: Maybe<Scalars['Boolean']['output']>;
  forMobile?: Maybe<Scalars['String']['output']>;
  headerSpacing?: Maybe<Scalars['String']['output']>;
  lastRowCardsAlignment?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<MultiCardV2LinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  noResultsContent?: Maybe<MultiCardV2>;
  numberOfCardsInLineDesktop?: Maybe<Scalars['Int']['output']>;
  roundedImage?: Maybe<Scalars['Boolean']['output']>;
  sectionEyebrow?: Maybe<Scalars['String']['output']>;
  sectionInfoAlignment?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  sectionTitleHtag?: Maybe<Scalars['String']['output']>;
  shouldDisplayCarouselOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  simpleCard?: Maybe<MultiCardV2SimpleCard>;
  simpleCardFour?: Maybe<MultiCardV2SimpleCardFour>;
  simpleCardThree?: Maybe<MultiCardV2SimpleCardThree>;
  simpleCardTwo?: Maybe<MultiCardV2SimpleCardTwo>;
  sys: Sys;
  useCardMediaRoundedCorners?: Maybe<Scalars['Boolean']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2AnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2BackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2BackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2BigScreenBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2ButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2ButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2ButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2ButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2CardsAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2CardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2CardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CardFilter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2CardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2CardsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CardFilter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DescriptionRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2DisplayAsStepperArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EnableMobileCarouselNavigationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EnableResourceCardModeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EyebrowColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EyebrowSxArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2EyebrowTextTransformArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2FacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2FixBackgroundToBottomArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2ForMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2HeaderSpacingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2LastRowCardsAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2NameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2NoResultsContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MultiCardV2Filter>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2NumberOfCardsInLineDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2RoundedImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SectionEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SectionInfoAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SectionTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2ShouldDisplayCarouselOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SimpleCardArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SimpleCardFourArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SimpleCardThreeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2SimpleCardTwoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2UseCardMediaRoundedCornersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Supports either 2 or 3 Cards [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/multiCardV2) */
export type MultiCardV2VariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiCardV2ButtonsCollection = {
  __typename?: 'MultiCardV2ButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MultiCardV2ButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MultiCardV2ButtonsCursorCollection = {
  __typename?: 'MultiCardV2ButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MultiCardV2ButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MultiCardV2CardsCollection = {
  __typename?: 'MultiCardV2CardsCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MultiCardV2CardsCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2CardsCursorCollection = {
  __typename?: 'MultiCardV2CardsCursorCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MultiCardV2CardsCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2Collection = {
  __typename?: 'MultiCardV2Collection';
  items: Array<Maybe<MultiCardV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MultiCardV2CursorCollection = {
  __typename?: 'MultiCardV2CursorCollection';
  items: Array<Maybe<MultiCardV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MultiCardV2DescriptionRichText = {
  __typename?: 'MultiCardV2DescriptionRichText';
  json: Scalars['JSON']['output'];
  links: MultiCardV2DescriptionRichTextLinks;
};

export type MultiCardV2DescriptionRichTextAssets = {
  __typename?: 'MultiCardV2DescriptionRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type MultiCardV2DescriptionRichTextEntries = {
  __typename?: 'MultiCardV2DescriptionRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type MultiCardV2DescriptionRichTextLinks = {
  __typename?: 'MultiCardV2DescriptionRichTextLinks';
  assets: MultiCardV2DescriptionRichTextAssets;
  entries: MultiCardV2DescriptionRichTextEntries;
  resources: MultiCardV2DescriptionRichTextResources;
};

export type MultiCardV2DescriptionRichTextResources = {
  __typename?: 'MultiCardV2DescriptionRichTextResources';
  block: Array<MultiCardV2DescriptionRichTextResourcesBlock>;
  hyperlink: Array<MultiCardV2DescriptionRichTextResourcesHyperlink>;
  inline: Array<MultiCardV2DescriptionRichTextResourcesInline>;
};

export type MultiCardV2DescriptionRichTextResourcesBlock = ResourceLink & {
  __typename?: 'MultiCardV2DescriptionRichTextResourcesBlock';
  sys: ResourceSys;
};

export type MultiCardV2DescriptionRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'MultiCardV2DescriptionRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type MultiCardV2DescriptionRichTextResourcesInline = ResourceLink & {
  __typename?: 'MultiCardV2DescriptionRichTextResourcesInline';
  sys: ResourceSys;
};

export type MultiCardV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<MultiCardV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiCardV2Filter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage?: InputMaybe<CfImageAssetNestedFilter>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground_not?: InputMaybe<Scalars['Boolean']['input']>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<CfCardNestedFilter>;
  cardsAlignment?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardsAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardsAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayAsStepper?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsStepper_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsStepper_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableMobileCarouselNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  enableMobileCarouselNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableMobileCarouselNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode_not?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowColor?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowColor_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSx?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSx_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSx_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowTextTransform?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowTextTransform_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowTextTransform_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixBackgroundToBottom?: InputMaybe<Scalars['Boolean']['input']>;
  fixBackgroundToBottom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fixBackgroundToBottom_not?: InputMaybe<Scalars['Boolean']['input']>;
  forMobile?: InputMaybe<Scalars['String']['input']>;
  forMobile_contains?: InputMaybe<Scalars['String']['input']>;
  forMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  forMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  forMobile_not?: InputMaybe<Scalars['String']['input']>;
  forMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  forMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSpacing?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_contains?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSpacing_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSpacing_not?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRowCardsAlignment?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  lastRowCardsAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRowCardsAlignment_not?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noResultsContent?: InputMaybe<CfMultiCardV2NestedFilter>;
  noResultsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCardsInLineDesktop?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCardsInLineDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfCardsInLineDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  roundedImage?: InputMaybe<Scalars['Boolean']['input']>;
  roundedImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  roundedImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  sectionEyebrow?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionEyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionEyebrow_not?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionInfoAlignment?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionInfoAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionInfoAlignment_not?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitleHtag_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shouldDisplayCarouselOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCarouselOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCarouselOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCardFour_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardFour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCardFour_not_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardThree_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardThree_exists?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCardThree_not_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardTwo_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardTwo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCardTwo_not_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCard_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCard_exists?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCard_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  useCardMediaRoundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  useCardMediaRoundedCorners_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useCardMediaRoundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MultiCardV2LinkingCollections = {
  __typename?: 'MultiCardV2LinkingCollections';
  buttonCollection?: Maybe<ButtonCollection>;
  buttonCursorCollection?: Maybe<ButtonCursorCollection>;
  confirmationStepCollection?: Maybe<ConfirmationStepCollection>;
  confirmationStepCursorCollection?: Maybe<ConfirmationStepCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  googleMapTemplateCursorCollection?: Maybe<GoogleMapTemplateCursorCollection>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  multiCardV2CursorCollection?: Maybe<MultiCardV2CursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type MultiCardV2LinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsConfirmationStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsConfirmationStepCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsConfirmationStepCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsConfirmationStepCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsGoogleMapTemplateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsGoogleMapTemplateCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsGoogleMapTemplateCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsMultiCardV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsMultiCardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsMultiCardV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MultiCardV2LinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2LinkingCollectionsTabCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MultiCardV2LinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MultiCardV2LinkingCollectionsButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MultiCardV2LinkingCollectionsConfirmationStepCollectionOrder =
  | 'accountNumberText_ASC'
  | 'accountNumberText_DESC'
  | 'cardInfoText_ASC'
  | 'cardInfoText_DESC'
  | 'confirmationPageName_ASC'
  | 'confirmationPageName_DESC'
  | 'copyTextButtonText_ASC'
  | 'copyTextButtonText_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsConfirmationStepCursorCollectionOrder =
  | 'accountNumberText_ASC'
  | 'accountNumberText_DESC'
  | 'cardInfoText_ASC'
  | 'cardInfoText_DESC'
  | 'confirmationPageName_ASC'
  | 'confirmationPageName_DESC'
  | 'copyTextButtonText_ASC'
  | 'copyTextButtonText_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MultiCardV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type MultiCardV2LinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2LinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2LinkingCollectionsGoogleMapTemplateCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type MultiCardV2LinkingCollectionsGoogleMapTemplateCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type MultiCardV2LinkingCollectionsMultiCardV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MultiCardV2LinkingCollectionsMultiCardV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MultiCardV2LinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2LinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2LinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2LinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type MultiCardV2LinkingCollectionsTabCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2LinkingCollectionsTabCursorCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type MultiCardV2Order =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'bigScreenBackground_ASC'
  | 'bigScreenBackground_DESC'
  | 'cardsAlignment_ASC'
  | 'cardsAlignment_DESC'
  | 'displayAsStepper_ASC'
  | 'displayAsStepper_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'enableMobileCarouselNavigation_ASC'
  | 'enableMobileCarouselNavigation_DESC'
  | 'enableResourceCardMode_ASC'
  | 'enableResourceCardMode_DESC'
  | 'eyebrowColor_ASC'
  | 'eyebrowColor_DESC'
  | 'eyebrowSx_ASC'
  | 'eyebrowSx_DESC'
  | 'eyebrowTextTransform_ASC'
  | 'eyebrowTextTransform_DESC'
  | 'fixBackgroundToBottom_ASC'
  | 'fixBackgroundToBottom_DESC'
  | 'forMobile_ASC'
  | 'forMobile_DESC'
  | 'headerSpacing_ASC'
  | 'headerSpacing_DESC'
  | 'lastRowCardsAlignment_ASC'
  | 'lastRowCardsAlignment_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'numberOfCardsInLineDesktop_ASC'
  | 'numberOfCardsInLineDesktop_DESC'
  | 'roundedImage_ASC'
  | 'roundedImage_DESC'
  | 'sectionEyebrow_ASC'
  | 'sectionEyebrow_DESC'
  | 'sectionInfoAlignment_ASC'
  | 'sectionInfoAlignment_DESC'
  | 'sectionTitleHtag_ASC'
  | 'sectionTitleHtag_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'shouldDisplayCarouselOnDesktop_ASC'
  | 'shouldDisplayCarouselOnDesktop_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useCardMediaRoundedCorners_ASC'
  | 'useCardMediaRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type MultiCardV2SimpleCard = {
  __typename?: 'MultiCardV2SimpleCard';
  json: Scalars['JSON']['output'];
  links: MultiCardV2SimpleCardLinks;
};

export type MultiCardV2SimpleCardAssets = {
  __typename?: 'MultiCardV2SimpleCardAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type MultiCardV2SimpleCardEntries = {
  __typename?: 'MultiCardV2SimpleCardEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type MultiCardV2SimpleCardFour = {
  __typename?: 'MultiCardV2SimpleCardFour';
  json: Scalars['JSON']['output'];
  links: MultiCardV2SimpleCardFourLinks;
};

export type MultiCardV2SimpleCardFourAssets = {
  __typename?: 'MultiCardV2SimpleCardFourAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type MultiCardV2SimpleCardFourEntries = {
  __typename?: 'MultiCardV2SimpleCardFourEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type MultiCardV2SimpleCardFourLinks = {
  __typename?: 'MultiCardV2SimpleCardFourLinks';
  assets: MultiCardV2SimpleCardFourAssets;
  entries: MultiCardV2SimpleCardFourEntries;
  resources: MultiCardV2SimpleCardFourResources;
};

export type MultiCardV2SimpleCardFourResources = {
  __typename?: 'MultiCardV2SimpleCardFourResources';
  block: Array<MultiCardV2SimpleCardFourResourcesBlock>;
  hyperlink: Array<MultiCardV2SimpleCardFourResourcesHyperlink>;
  inline: Array<MultiCardV2SimpleCardFourResourcesInline>;
};

export type MultiCardV2SimpleCardFourResourcesBlock = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardFourResourcesBlock';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardFourResourcesHyperlink = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardFourResourcesHyperlink';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardFourResourcesInline = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardFourResourcesInline';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardLinks = {
  __typename?: 'MultiCardV2SimpleCardLinks';
  assets: MultiCardV2SimpleCardAssets;
  entries: MultiCardV2SimpleCardEntries;
  resources: MultiCardV2SimpleCardResources;
};

export type MultiCardV2SimpleCardResources = {
  __typename?: 'MultiCardV2SimpleCardResources';
  block: Array<MultiCardV2SimpleCardResourcesBlock>;
  hyperlink: Array<MultiCardV2SimpleCardResourcesHyperlink>;
  inline: Array<MultiCardV2SimpleCardResourcesInline>;
};

export type MultiCardV2SimpleCardResourcesBlock = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardResourcesBlock';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardResourcesHyperlink = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardResourcesHyperlink';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardResourcesInline = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardResourcesInline';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardThree = {
  __typename?: 'MultiCardV2SimpleCardThree';
  json: Scalars['JSON']['output'];
  links: MultiCardV2SimpleCardThreeLinks;
};

export type MultiCardV2SimpleCardThreeAssets = {
  __typename?: 'MultiCardV2SimpleCardThreeAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type MultiCardV2SimpleCardThreeEntries = {
  __typename?: 'MultiCardV2SimpleCardThreeEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type MultiCardV2SimpleCardThreeLinks = {
  __typename?: 'MultiCardV2SimpleCardThreeLinks';
  assets: MultiCardV2SimpleCardThreeAssets;
  entries: MultiCardV2SimpleCardThreeEntries;
  resources: MultiCardV2SimpleCardThreeResources;
};

export type MultiCardV2SimpleCardThreeResources = {
  __typename?: 'MultiCardV2SimpleCardThreeResources';
  block: Array<MultiCardV2SimpleCardThreeResourcesBlock>;
  hyperlink: Array<MultiCardV2SimpleCardThreeResourcesHyperlink>;
  inline: Array<MultiCardV2SimpleCardThreeResourcesInline>;
};

export type MultiCardV2SimpleCardThreeResourcesBlock = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardThreeResourcesBlock';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardThreeResourcesHyperlink = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardThreeResourcesHyperlink';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardThreeResourcesInline = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardThreeResourcesInline';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardTwo = {
  __typename?: 'MultiCardV2SimpleCardTwo';
  json: Scalars['JSON']['output'];
  links: MultiCardV2SimpleCardTwoLinks;
};

export type MultiCardV2SimpleCardTwoAssets = {
  __typename?: 'MultiCardV2SimpleCardTwoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type MultiCardV2SimpleCardTwoEntries = {
  __typename?: 'MultiCardV2SimpleCardTwoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type MultiCardV2SimpleCardTwoLinks = {
  __typename?: 'MultiCardV2SimpleCardTwoLinks';
  assets: MultiCardV2SimpleCardTwoAssets;
  entries: MultiCardV2SimpleCardTwoEntries;
  resources: MultiCardV2SimpleCardTwoResources;
};

export type MultiCardV2SimpleCardTwoResources = {
  __typename?: 'MultiCardV2SimpleCardTwoResources';
  block: Array<MultiCardV2SimpleCardTwoResourcesBlock>;
  hyperlink: Array<MultiCardV2SimpleCardTwoResourcesHyperlink>;
  inline: Array<MultiCardV2SimpleCardTwoResourcesInline>;
};

export type MultiCardV2SimpleCardTwoResourcesBlock = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardTwoResourcesBlock';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardTwoResourcesHyperlink = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardTwoResourcesHyperlink';
  sys: ResourceSys;
};

export type MultiCardV2SimpleCardTwoResourcesInline = ResourceLink & {
  __typename?: 'MultiCardV2SimpleCardTwoResourcesInline';
  sys: ResourceSys;
};

/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroup = Entry & _Node & {
  __typename?: 'NavigationGroup';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  displayAsExpandedForMobileMenu?: Maybe<Scalars['Boolean']['output']>;
  groupLink?: Maybe<NavigationLink>;
  linkedFrom?: Maybe<NavigationGroupLinkingCollections>;
  linksCollection?: Maybe<NavigationGroupLinksCollection>;
  linksCursorCollection?: Maybe<NavigationGroupLinksCursorCollection>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupDisplayAsExpandedForMobileMenuArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupGroupLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


/** A group of links supporting Internal and External URLs for Navigation purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationGroup) */
export type NavigationGroupNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationGroupCollection = {
  __typename?: 'NavigationGroupCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationGroupCursorCollection = {
  __typename?: 'NavigationGroupCursorCollection';
  items: Array<Maybe<NavigationGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationGroupFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayAsExpandedForMobileMenu?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsExpandedForMobileMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsExpandedForMobileMenu_not?: InputMaybe<Scalars['Boolean']['input']>;
  groupLink?: InputMaybe<CfNavigationLinkNestedFilter>;
  groupLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  links?: InputMaybe<CfNavigationLinkNestedFilter>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type NavigationGroupLinkingCollections = {
  __typename?: 'NavigationGroupLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerCursorCollection?: Maybe<HeaderCursorCollection>;
  headerSubNavCollection?: Maybe<HeaderSubNavCollection>;
  headerSubNavCursorCollection?: Maybe<HeaderSubNavCursorCollection>;
};


export type NavigationGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationGroupLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationGroupLinkingCollectionsHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinkingCollectionsHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationGroupLinkingCollectionsHeaderSubNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinkingCollectionsHeaderSubNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationGroupLinkingCollectionsHeaderSubNavCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupLinkingCollectionsHeaderSubNavCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationGroupLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationGroupLinkingCollectionsHeaderCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationGroupLinkingCollectionsHeaderSubNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationGroupLinkingCollectionsHeaderSubNavCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationGroupLinksCollection = {
  __typename?: 'NavigationGroupLinksCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationGroupLinksCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationGroupLinksCursorCollection = {
  __typename?: 'NavigationGroupLinksCursorCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationGroupLinksCursorCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationGroupOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLink = Entry & _Node & {
  __typename?: 'NavigationLink';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  contentfulMetadata: ContentfulMetadata;
  externalUrl?: Maybe<Scalars['String']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  isLocalized?: Maybe<Scalars['Boolean']['output']>;
  linkIcon?: Maybe<Asset>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<NavigationLinkLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  openInNewTab?: Maybe<Scalars['Boolean']['output']>;
  openInNewWindow?: Maybe<Scalars['Boolean']['output']>;
  pageData?: Maybe<NavigationLinkPageData>;
  sys: Sys;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkExternalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkIsInternalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkIsLocalizedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkLinkIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkOpenInNewTabArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkOpenInNewWindowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Link model for linking to internal and external pages. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/navigationLink) */
export type NavigationLinkPageDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationLinkCollection = {
  __typename?: 'NavigationLinkCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NavigationLinkCursorCollection = {
  __typename?: 'NavigationLinkCursorCollection';
  items: Array<Maybe<NavigationLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type NavigationLinkFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationLinkFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationLinkFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal_not?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  linkIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_not?: InputMaybe<Scalars['Boolean']['input']>;
  pageData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type NavigationLinkLinkingCollections = {
  __typename?: 'NavigationLinkLinkingCollections';
  adFooterCollection?: Maybe<AdFooterCollection>;
  adFooterCursorCollection?: Maybe<AdFooterCursorCollection>;
  buttonCollection?: Maybe<ButtonCollection>;
  buttonCursorCollection?: Maybe<ButtonCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  footerNavigationGroupCollection?: Maybe<FooterNavigationGroupCollection>;
  footerNavigationGroupCursorCollection?: Maybe<FooterNavigationGroupCursorCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerCursorCollection?: Maybe<HeaderCursorCollection>;
  headerMainNavCollection?: Maybe<HeaderMainNavCollection>;
  headerMainNavCursorCollection?: Maybe<HeaderMainNavCursorCollection>;
  headerSubNavCollection?: Maybe<HeaderSubNavCollection>;
  headerSubNavCursorCollection?: Maybe<HeaderSubNavCursorCollection>;
  navigationGroupCollection?: Maybe<NavigationGroupCollection>;
  navigationGroupCursorCollection?: Maybe<NavigationGroupCursorCollection>;
};


export type NavigationLinkLinkingCollectionsAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsAdFooterCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsAdFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsAdFooterCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsFooterNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsFooterNavigationGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsFooterNavigationGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsFooterNavigationGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsHeaderMainNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsHeaderMainNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsHeaderMainNavCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsHeaderMainNavCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsHeaderSubNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsHeaderSubNavCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsHeaderSubNavCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsHeaderSubNavCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type NavigationLinkLinkingCollectionsNavigationGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkLinkingCollectionsNavigationGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NavigationLinkLinkingCollectionsAdFooterCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationLinkLinkingCollectionsAdFooterCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'contactNumber_ASC'
  | 'contactNumber_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'isLightFooter_ASC'
  | 'isLightFooter_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useDesktopStickyFooter_ASC'
  | 'useDesktopStickyFooter_DESC'
  | 'useMobileStickyFooter_ASC'
  | 'useMobileStickyFooter_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationLinkLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationLinkLinkingCollectionsButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationLinkLinkingCollectionsFooterNavigationGroupCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsFooterNavigationGroupCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationLinkLinkingCollectionsHeaderCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type NavigationLinkLinkingCollectionsHeaderMainNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsHeaderMainNavCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsHeaderSubNavCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsHeaderSubNavCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsNavigationGroupCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkLinkingCollectionsNavigationGroupCursorCollectionOrder =
  | 'displayAsExpandedForMobileMenu_ASC'
  | 'displayAsExpandedForMobileMenu_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type NavigationLinkPageData = BlogDetailsPage | FacilityDetailsPage | Page | ServiceDetailsPage;

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHero = Entry & _Node & {
  __typename?: 'OdpHero';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  appointmentDataSource?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<OdpHeroButtonsCollection>;
  buttonsCursorCollection?: Maybe<OdpHeroButtonsCursorCollection>;
  callCenterLabel?: Maybe<Scalars['String']['output']>;
  contentSmallScreen?: Maybe<SmallScreenContent>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<ContentTypeRichText>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  googleMapsBusinessQuery?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FocalPointImage>;
  linkedFrom?: Maybe<OdpHeroLinkingCollections>;
  mobileBrandBannerImagesCollection?: Maybe<OdpHeroMobileBrandBannerImagesCollection>;
  mobileBrandBannerImagesCursorCollection?: Maybe<OdpHeroMobileBrandBannerImagesCursorCollection>;
  name?: Maybe<Scalars['String']['output']>;
  officeHoursLabel?: Maybe<Scalars['String']['output']>;
  promoTitle?: Maybe<Scalars['String']['output']>;
  secondaryImage?: Maybe<FocalPointImage>;
  showAddress?: Maybe<Scalars['Boolean']['output']>;
  showEmail?: Maybe<Scalars['Boolean']['output']>;
  showFax?: Maybe<Scalars['Boolean']['output']>;
  showHours?: Maybe<Scalars['Boolean']['output']>;
  showLocationStatusBadge?: Maybe<Scalars['Boolean']['output']>;
  showPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  showReviews?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroAppointmentDataSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroCallCenterLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroContentSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroGoogleMapsBusinessQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroMobileBrandBannerImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroMobileBrandBannerImagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroMobileBrandBannerImagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroMobileBrandBannerImagesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroOfficeHoursLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroPromoTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroSecondaryImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowAddressArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowEmailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowFaxArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowHoursArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowLocationStatusBadgeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowPhoneNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroShowReviewsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroTemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/ODPHero) */
export type OdpHeroTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdpHeroButtonsCollection = {
  __typename?: 'OdpHeroButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OdpHeroButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type OdpHeroButtonsCursorCollection = {
  __typename?: 'OdpHeroButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type OdpHeroButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type OdpHeroCollection = {
  __typename?: 'OdpHeroCollection';
  items: Array<Maybe<OdpHero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OdpHeroCursorCollection = {
  __typename?: 'OdpHeroCursorCollection';
  items: Array<Maybe<OdpHero>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type OdpHeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<OdpHeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<OdpHeroFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentDataSource?: InputMaybe<Scalars['String']['input']>;
  appointmentDataSource_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentDataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentDataSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentDataSource_not?: InputMaybe<Scalars['String']['input']>;
  appointmentDataSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentDataSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  callCenterLabel?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_contains?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  callCenterLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callCenterLabel_not?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  callCenterLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentSmallScreen?: InputMaybe<CfSmallScreenContentNestedFilter>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<CfFocalPointImageNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBrandBannerImages?: InputMaybe<CfFocalPointImageNestedFilter>;
  mobileBrandBannerImagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  officeHoursLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel_not?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoTitle?: InputMaybe<Scalars['String']['input']>;
  promoTitle_contains?: InputMaybe<Scalars['String']['input']>;
  promoTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  promoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promoTitle_not?: InputMaybe<Scalars['String']['input']>;
  promoTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  promoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  secondaryImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showAddress_not?: InputMaybe<Scalars['Boolean']['input']>;
  showEmail?: InputMaybe<Scalars['Boolean']['input']>;
  showEmail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showEmail_not?: InputMaybe<Scalars['Boolean']['input']>;
  showFax?: InputMaybe<Scalars['Boolean']['input']>;
  showFax_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showFax_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHours?: InputMaybe<Scalars['Boolean']['input']>;
  showHours_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHours_not?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationStatusBadge?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationStatusBadge_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLocationStatusBadge_not?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showPhoneNumber_not?: InputMaybe<Scalars['Boolean']['input']>;
  showReviews?: InputMaybe<Scalars['Boolean']['input']>;
  showReviews_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showReviews_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OdpHeroLinkingCollections = {
  __typename?: 'OdpHeroLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type OdpHeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OdpHeroLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OdpHeroLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type OdpHeroLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type OdpHeroLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type OdpHeroLinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type OdpHeroLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type OdpHeroMobileBrandBannerImagesCollection = {
  __typename?: 'OdpHeroMobileBrandBannerImagesCollection';
  items: Array<Maybe<FocalPointImage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OdpHeroMobileBrandBannerImagesCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type OdpHeroMobileBrandBannerImagesCursorCollection = {
  __typename?: 'OdpHeroMobileBrandBannerImagesCursorCollection';
  items: Array<Maybe<FocalPointImage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type OdpHeroMobileBrandBannerImagesCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type OdpHeroOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type Page = Entry & _Node & {
  __typename?: 'Page';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  appName?: Maybe<Scalars['String']['output']>;
  breadcrumbTitle?: Maybe<Scalars['String']['output']>;
  breadcrumbsCollection?: Maybe<PageBreadcrumbsCollection>;
  breadcrumbsCursorCollection?: Maybe<PageBreadcrumbsCursorCollection>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<PageContentsCollection>;
  contentsCursorCollection?: Maybe<PageContentsCursorCollection>;
  description?: Maybe<Scalars['String']['output']>;
  disableChatBot?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  displayOnMobile?: Maybe<Scalars['Boolean']['output']>;
  hideScheduleButtonInHeader?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Asset>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<PageLinkingCollections>;
  mobileBreadcrumbTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<ImageAsset>;
  pageTheme?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  personalized?: Maybe<Scalars['Boolean']['output']>;
  personalizedPathPrefix?: Maybe<Scalars['String']['output']>;
  personalizedPathSuffix?: Maybe<Scalars['String']['output']>;
  redirectFrom?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  redirectTo?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageAppNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageBreadcrumbTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageBreadcrumbsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageBreadcrumbsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageBreadcrumbsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageBreadcrumbsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageContentsFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageContentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageContentsFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableChatBotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageDisplayOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageHideScheduleButtonInHeaderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageMobileBreadcrumbTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePageThemeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePersonalizedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePersonalizedPathPrefixArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PagePersonalizedPathSuffixArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageRedirectFromArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageRedirectToArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Generic Landing Page, for all purposes [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/page) */
export type PageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageBreadcrumbsCollection = {
  __typename?: 'PageBreadcrumbsCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageBreadcrumbsCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageBreadcrumbsCursorCollection = {
  __typename?: 'PageBreadcrumbsCursorCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PageBreadcrumbsCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageCollection = {
  __typename?: 'PageCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageContentsCollection = {
  __typename?: 'PageContentsCollection';
  items: Array<Maybe<PageContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageContentsCursorCollection = {
  __typename?: 'PageContentsCursorCollection';
  items: Array<Maybe<PageContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PageContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type PageContentsItem = Accordions | AgendaStepper | BirdEyeReviews | BlogList | Carousel | CategoryPicker | CityLinks | Columns | ContentTypeRichText | ConvertFlowCta | ConvertFlowQuiz | DisclaimerV2 | ExperimentContainer | GoogleMapTemplate | HalfScreen | HeaderNavMenu | HeroV2 | Iframe | Insurance | LinkForwarder | Marquee | MediaSlider | MeetOurStaff | MetroLinks | MultiCardV2 | OdpHero | PatientReviewsV2 | ProductFeature | ProgressIndicator | Questionnaire | QuickLinks | Quiz | Schema | SchemaStep | SectionContent | SegmentsContainer | Service | ServiceGroup | ServiceLineHero | SharedForm | SingleMessage | SmileAssessmentForm | Spacer | StateLinks | Stepper | Table | Tabs | TermsAndConditions | TextBlockSeo | VideoCarousel;

export type PageCursorCollection = {
  __typename?: 'PageCursorCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appName_contains?: InputMaybe<Scalars['String']['input']>;
  appName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appName_not?: InputMaybe<Scalars['String']['input']>;
  appName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbTitle?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_contains?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumbTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbTitle_not?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbs?: InputMaybe<CfPageNestedFilter>;
  breadcrumbsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableChatBot?: InputMaybe<Scalars['Boolean']['input']>;
  disableChatBot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableChatBot_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader_not?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBreadcrumbTitle?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_contains?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBreadcrumbTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileBreadcrumbTitle_not?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfImageAssetNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTheme?: InputMaybe<Scalars['String']['input']>;
  pageTheme_contains?: InputMaybe<Scalars['String']['input']>;
  pageTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTheme_not?: InputMaybe<Scalars['String']['input']>;
  pageTheme_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalized?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathPrefix?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathPrefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathPrefix_not?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_not_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathSuffix?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathSuffix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathSuffix_not?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_not_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  redirectFrom_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  redirectTo?: InputMaybe<Scalars['String']['input']>;
  redirectTo_contains?: InputMaybe<Scalars['String']['input']>;
  redirectTo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  redirectTo_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectTo_not?: InputMaybe<Scalars['String']['input']>;
  redirectTo_not_contains?: InputMaybe<Scalars['String']['input']>;
  redirectTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Used for setup the page layout in Contentful Experiences (Studio) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageLayout) */
export type PageLayout = Entry & _Node & {
  __typename?: 'PageLayout';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  disableFixedHeaderOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooter?: Maybe<Scalars['Boolean']['output']>;
  footerSlug?: Maybe<Scalars['String']['output']>;
  headerSlug?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<PageLayoutLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Used for setup the page layout in Contentful Experiences (Studio) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageLayout) */
export type PageLayoutDisableFixedHeaderOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for setup the page layout in Contentful Experiences (Studio) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageLayout) */
export type PageLayoutDisableStickyFooterArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for setup the page layout in Contentful Experiences (Studio) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageLayout) */
export type PageLayoutFooterSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for setup the page layout in Contentful Experiences (Studio) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageLayout) */
export type PageLayoutHeaderSlugArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for setup the page layout in Contentful Experiences (Studio) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageLayout) */
export type PageLayoutLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for setup the page layout in Contentful Experiences (Studio) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageLayout) */
export type PageLayoutNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLayoutCollection = {
  __typename?: 'PageLayoutCollection';
  items: Array<Maybe<PageLayout>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageLayoutCursorCollection = {
  __typename?: 'PageLayoutCursorCollection';
  items: Array<Maybe<PageLayout>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PageLayoutFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageLayoutFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageLayoutFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disableFixedHeaderOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableFixedHeaderOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableFixedHeaderOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  footerSlug?: InputMaybe<Scalars['String']['input']>;
  footerSlug_contains?: InputMaybe<Scalars['String']['input']>;
  footerSlug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footerSlug_not?: InputMaybe<Scalars['String']['input']>;
  footerSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  footerSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSlug?: InputMaybe<Scalars['String']['input']>;
  headerSlug_contains?: InputMaybe<Scalars['String']['input']>;
  headerSlug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSlug_not?: InputMaybe<Scalars['String']['input']>;
  headerSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type PageLayoutLinkingCollections = {
  __typename?: 'PageLayoutLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experienceCollection?: Maybe<ExperienceCollection>;
  experienceCursorCollection?: Maybe<ExperienceCursorCollection>;
};


export type PageLayoutLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLayoutLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLayoutLinkingCollectionsExperienceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLayoutLinkingCollectionsExperienceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLayoutLinkingCollectionsExperienceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLayoutLinkingCollectionsExperienceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLayoutLinkingCollectionsExperienceCollectionOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageLayoutLinkingCollectionsExperienceCursorCollectionOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageLayoutOrder =
  | 'disableFixedHeaderOnDesktop_ASC'
  | 'disableFixedHeaderOnDesktop_DESC'
  | 'disableStickyFooter_ASC'
  | 'disableStickyFooter_DESC'
  | 'footerSlug_ASC'
  | 'footerSlug_DESC'
  | 'headerSlug_ASC'
  | 'headerSlug_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageLinkingCollections = {
  __typename?: 'PageLinkingCollections';
  contentTileCollection?: Maybe<ContentTileCollection>;
  contentTileCursorCollection?: Maybe<ContentTileCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  footerNavigationGroupCollection?: Maybe<FooterNavigationGroupCollection>;
  footerNavigationGroupCursorCollection?: Maybe<FooterNavigationGroupCursorCollection>;
  headerCollection?: Maybe<HeaderCollection>;
  headerCursorCollection?: Maybe<HeaderCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type PageLinkingCollectionsContentTileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsContentTileCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsContentTileCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsContentTileCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsFooterNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsFooterNavigationGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsFooterNavigationGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsFooterNavigationGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsHeaderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsHeaderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavigationLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageLinkingCollectionsContentTileCollectionOrder =
  | 'description_ASC'
  | 'description_DESC'
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageLinkingCollectionsContentTileCursorCollectionOrder =
  | 'description_ASC'
  | 'description_DESC'
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageLinkingCollectionsFooterNavigationGroupCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageLinkingCollectionsFooterNavigationGroupCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'navigationGroupTitle_ASC'
  | 'navigationGroupTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageLinkingCollectionsHeaderCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type PageLinkingCollectionsHeaderCursorCollectionOrder =
  | 'componentName_ASC'
  | 'componentName_DESC'
  | 'darkHeader_ASC'
  | 'darkHeader_DESC'
  | 'hideFullSiteSearch_ASC'
  | 'hideFullSiteSearch_DESC'
  | 'hideOdpLinks_ASC'
  | 'hideOdpLinks_DESC'
  | 'locationBarFindOfficeUrl_ASC'
  | 'locationBarFindOfficeUrl_DESC'
  | 'locationBarWithOfficeTitle_ASC'
  | 'locationBarWithOfficeTitle_DESC'
  | 'locationBarWithOutOfficeTitle_ASC'
  | 'locationBarWithOutOfficeTitle_DESC'
  | 'myAccountLabel_ASC'
  | 'myAccountLabel_DESC'
  | 'profileLinkUrl_ASC'
  | 'profileLinkUrl_DESC'
  | 'schedulingButtonTextMobile_ASC'
  | 'schedulingButtonTextMobile_DESC'
  | 'schedulingButtonText_ASC'
  | 'schedulingButtonText_DESC'
  | 'schedulingButtonUrlMobile_ASC'
  | 'schedulingButtonUrlMobile_DESC'
  | 'schedulingButtonUrl_ASC'
  | 'schedulingButtonUrl_DESC'
  | 'searchFieldTitle_ASC'
  | 'searchFieldTitle_DESC'
  | 'showSecondaryNavInMobileToolbar_ASC'
  | 'showSecondaryNavInMobileToolbar_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useHeaderLocationCards_ASC'
  | 'useHeaderLocationCards_DESC'
  | 'useNewLayout_ASC'
  | 'useNewLayout_DESC'
  | 'usePopupScheduling_ASC'
  | 'usePopupScheduling_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type PageLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageLinkingCollectionsNavigationLinkCursorCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMeta = Entry & _Node & {
  __typename?: 'PageMeta';
  _id: Scalars['ID']['output'];
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<PageMetaLinkingCollections>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  structuredDataCollection?: Maybe<PageMetaStructuredDataCollection>;
  structuredDataCursorCollection?: Maybe<PageMetaStructuredDataCursorCollection>;
  sys: Sys;
};


/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMetaCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMetaIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMetaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMetaMetaDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMetaMetaTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMetaNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMetaStructuredDataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageMetaStructuredDataCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchemaFilter>;
};


/** This will have page meta information like title, description, schemas etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/pageMeta) */
export type PageMetaStructuredDataCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageMetaStructuredDataCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchemaFilter>;
};

export type PageMetaCollection = {
  __typename?: 'PageMetaCollection';
  items: Array<Maybe<PageMeta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageMetaCursorCollection = {
  __typename?: 'PageMetaCursorCollection';
  items: Array<Maybe<PageMeta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PageMetaFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageMetaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageMetaFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structuredData?: InputMaybe<CfSchemaNestedFilter>;
  structuredDataCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type PageMetaLinkingCollections = {
  __typename?: 'PageMetaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experienceCollection?: Maybe<ExperienceCollection>;
  experienceCursorCollection?: Maybe<ExperienceCursorCollection>;
};


export type PageMetaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageMetaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageMetaLinkingCollectionsExperienceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageMetaLinkingCollectionsExperienceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageMetaLinkingCollectionsExperienceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageMetaLinkingCollectionsExperienceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PageMetaLinkingCollectionsExperienceCollectionOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageMetaLinkingCollectionsExperienceCursorCollectionOrder =
  | 'slug_ASC'
  | 'slug_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PageMetaOrder =
  | 'canonicalUrl_ASC'
  | 'canonicalUrl_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageMetaStructuredDataCollection = {
  __typename?: 'PageMetaStructuredDataCollection';
  items: Array<Maybe<Schema>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PageMetaStructuredDataCollectionOrder =
  | 'combinedSchema_ASC'
  | 'combinedSchema_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageMetaStructuredDataCursorCollection = {
  __typename?: 'PageMetaStructuredDataCursorCollection';
  items: Array<Maybe<Schema>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PageMetaStructuredDataCursorCollectionOrder =
  | 'combinedSchema_ASC'
  | 'combinedSchema_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PageOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2 = Entry & _Node & {
  __typename?: 'PatientReviewV2';
  _id: Scalars['ID']['output'];
  avatar?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<PatientReviewV2LinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  subText1?: Maybe<Scalars['String']['output']>;
  subText2?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<Scalars['String']['output']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2AvatarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2NameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2ScoreArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2SubText1Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2SubText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A single patient review as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewV2) */
export type PatientReviewV2TextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientReviewV2Collection = {
  __typename?: 'PatientReviewV2Collection';
  items: Array<Maybe<PatientReviewV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewV2CursorCollection = {
  __typename?: 'PatientReviewV2CursorCollection';
  items: Array<Maybe<PatientReviewV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PatientReviewV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<PatientReviewV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<PatientReviewV2Filter>>>;
  avatar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  score?: InputMaybe<Scalars['Int']['input']>;
  score_exists?: InputMaybe<Scalars['Boolean']['input']>;
  score_gt?: InputMaybe<Scalars['Int']['input']>;
  score_gte?: InputMaybe<Scalars['Int']['input']>;
  score_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  score_lt?: InputMaybe<Scalars['Int']['input']>;
  score_lte?: InputMaybe<Scalars['Int']['input']>;
  score_not?: InputMaybe<Scalars['Int']['input']>;
  score_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subText1?: InputMaybe<Scalars['String']['input']>;
  subText1_contains?: InputMaybe<Scalars['String']['input']>;
  subText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText1_not?: InputMaybe<Scalars['String']['input']>;
  subText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText2?: InputMaybe<Scalars['String']['input']>;
  subText2_contains?: InputMaybe<Scalars['String']['input']>;
  subText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText2_not?: InputMaybe<Scalars['String']['input']>;
  subText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PatientReviewV2LinkingCollections = {
  __typename?: 'PatientReviewV2LinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  patientReviewsV2Collection?: Maybe<PatientReviewsV2Collection>;
  patientReviewsV2CursorCollection?: Maybe<PatientReviewsV2CursorCollection>;
};


export type PatientReviewV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewV2LinkingCollectionsPatientReviewsV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewV2LinkingCollectionsPatientReviewsV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewV2LinkingCollectionsPatientReviewsV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewV2LinkingCollectionsPatientReviewsV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientReviewV2LinkingCollectionsPatientReviewsV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type PatientReviewV2LinkingCollectionsPatientReviewsV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type PatientReviewV2Order =
  | 'name_ASC'
  | 'name_DESC'
  | 'score_ASC'
  | 'score_DESC'
  | 'subText1_ASC'
  | 'subText1_DESC'
  | 'subText2_ASC'
  | 'subText2_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2 = Entry & _Node & {
  __typename?: 'PatientReviewsV2';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonsLargeScreensCollection?: Maybe<PatientReviewsV2ButtonsLargeScreensCollection>;
  buttonsLargeScreensCursorCollection?: Maybe<PatientReviewsV2ButtonsLargeScreensCursorCollection>;
  buttonsSmallScreensCollection?: Maybe<PatientReviewsV2ButtonsSmallScreensCollection>;
  buttonsSmallScreensCursorCollection?: Maybe<PatientReviewsV2ButtonsSmallScreensCursorCollection>;
  contentAlign?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entryName?: Maybe<Scalars['String']['output']>;
  eyebrowLargeScreens?: Maybe<Scalars['String']['output']>;
  eyebrowSmallScreens?: Maybe<Scalars['String']['output']>;
  imageLeftSide?: Maybe<ImageAsset>;
  linkedFrom?: Maybe<PatientReviewsV2LinkingCollections>;
  maxReviewsLargeScreens?: Maybe<Scalars['Int']['output']>;
  maxReviewsSmallScreens?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  reviewsCollection?: Maybe<PatientReviewsV2ReviewsCollection>;
  reviewsCursorCollection?: Maybe<PatientReviewsV2ReviewsCursorCollection>;
  scoreIcon?: Maybe<Scalars['String']['output']>;
  subtitleLargeScreens?: Maybe<Scalars['String']['output']>;
  subtitleSmallScreens?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  titleLargeScreens?: Maybe<Scalars['String']['output']>;
  titleSmallScreens?: Maybe<Scalars['String']['output']>;
  trimThreshold?: Maybe<Scalars['Int']['output']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2AnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2BackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ButtonsLargeScreensCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ButtonsLargeScreensCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ButtonsLargeScreensCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ButtonsLargeScreensCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ButtonsSmallScreensCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ButtonsSmallScreensCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ButtonsSmallScreensCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ButtonsSmallScreensCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ContentAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2DisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2EntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2EyebrowLargeScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2EyebrowSmallScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ImageLeftSideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2MaxReviewsLargeScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2MaxReviewsSmallScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ModeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ReviewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientReviewV2Filter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ReviewsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2ReviewsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientReviewV2Filter>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2ScoreIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2SubtitleLargeScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2SubtitleSmallScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TitleLargeScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TitleSmallScreensArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Patient reviews section as defined by WAD-2847 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/patientReviewsV2) */
export type PatientReviewsV2TrimThresholdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientReviewsV2ButtonsLargeScreensCollection = {
  __typename?: 'PatientReviewsV2ButtonsLargeScreensCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewsV2ButtonsLargeScreensCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type PatientReviewsV2ButtonsLargeScreensCursorCollection = {
  __typename?: 'PatientReviewsV2ButtonsLargeScreensCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PatientReviewsV2ButtonsLargeScreensCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type PatientReviewsV2ButtonsSmallScreensCollection = {
  __typename?: 'PatientReviewsV2ButtonsSmallScreensCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewsV2ButtonsSmallScreensCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type PatientReviewsV2ButtonsSmallScreensCursorCollection = {
  __typename?: 'PatientReviewsV2ButtonsSmallScreensCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PatientReviewsV2ButtonsSmallScreensCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type PatientReviewsV2Collection = {
  __typename?: 'PatientReviewsV2Collection';
  items: Array<Maybe<PatientReviewsV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewsV2CursorCollection = {
  __typename?: 'PatientReviewsV2CursorCollection';
  items: Array<Maybe<PatientReviewsV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PatientReviewsV2Filter = {
  AND?: InputMaybe<Array<InputMaybe<PatientReviewsV2Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<PatientReviewsV2Filter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsLargeScreens?: InputMaybe<CfButtonNestedFilter>;
  buttonsLargeScreensCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonsSmallScreens?: InputMaybe<CfButtonNestedFilter>;
  buttonsSmallScreensCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowLargeScreens?: InputMaybe<Scalars['String']['input']>;
  eyebrowLargeScreens_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowLargeScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowLargeScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowLargeScreens_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowLargeScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowLargeScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreens?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreens_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSmallScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreens_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageLeftSide?: InputMaybe<CfImageAssetNestedFilter>;
  imageLeftSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxReviewsLargeScreens?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxReviewsLargeScreens_gt?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_gte?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxReviewsLargeScreens_lt?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_lte?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_not?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsLargeScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxReviewsSmallScreens?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  maxReviewsSmallScreens_gt?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_gte?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxReviewsSmallScreens_lt?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_lte?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_not?: InputMaybe<Scalars['Int']['input']>;
  maxReviewsSmallScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mode?: InputMaybe<Scalars['String']['input']>;
  mode_contains?: InputMaybe<Scalars['String']['input']>;
  mode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mode_not?: InputMaybe<Scalars['String']['input']>;
  mode_not_contains?: InputMaybe<Scalars['String']['input']>;
  mode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviews?: InputMaybe<CfPatientReviewV2NestedFilter>;
  reviewsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scoreIcon?: InputMaybe<Scalars['String']['input']>;
  scoreIcon_contains?: InputMaybe<Scalars['String']['input']>;
  scoreIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scoreIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scoreIcon_not?: InputMaybe<Scalars['String']['input']>;
  scoreIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  scoreIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitleLargeScreens?: InputMaybe<Scalars['String']['input']>;
  subtitleLargeScreens_contains?: InputMaybe<Scalars['String']['input']>;
  subtitleLargeScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitleLargeScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitleLargeScreens_not?: InputMaybe<Scalars['String']['input']>;
  subtitleLargeScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitleLargeScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitleSmallScreens?: InputMaybe<Scalars['String']['input']>;
  subtitleSmallScreens_contains?: InputMaybe<Scalars['String']['input']>;
  subtitleSmallScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitleSmallScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitleSmallScreens_not?: InputMaybe<Scalars['String']['input']>;
  subtitleSmallScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitleSmallScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleLargeScreens?: InputMaybe<Scalars['String']['input']>;
  titleLargeScreens_contains?: InputMaybe<Scalars['String']['input']>;
  titleLargeScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleLargeScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleLargeScreens_not?: InputMaybe<Scalars['String']['input']>;
  titleLargeScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleLargeScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleSmallScreens?: InputMaybe<Scalars['String']['input']>;
  titleSmallScreens_contains?: InputMaybe<Scalars['String']['input']>;
  titleSmallScreens_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleSmallScreens_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleSmallScreens_not?: InputMaybe<Scalars['String']['input']>;
  titleSmallScreens_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleSmallScreens_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trimThreshold?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  trimThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  trimThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  trimThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type PatientReviewsV2LinkingCollections = {
  __typename?: 'PatientReviewsV2LinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type PatientReviewsV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PatientReviewsV2LinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2LinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientReviewsV2LinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type PatientReviewsV2LinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type PatientReviewsV2LinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2LinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2LinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2LinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2LinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2LinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type PatientReviewsV2Order =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowLargeScreens_ASC'
  | 'eyebrowLargeScreens_DESC'
  | 'eyebrowSmallScreens_ASC'
  | 'eyebrowSmallScreens_DESC'
  | 'maxReviewsLargeScreens_ASC'
  | 'maxReviewsLargeScreens_DESC'
  | 'maxReviewsSmallScreens_ASC'
  | 'maxReviewsSmallScreens_DESC'
  | 'mode_ASC'
  | 'mode_DESC'
  | 'scoreIcon_ASC'
  | 'scoreIcon_DESC'
  | 'subtitleLargeScreens_ASC'
  | 'subtitleLargeScreens_DESC'
  | 'subtitleSmallScreens_ASC'
  | 'subtitleSmallScreens_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'titleLargeScreens_ASC'
  | 'titleLargeScreens_DESC'
  | 'titleSmallScreens_ASC'
  | 'titleSmallScreens_DESC'
  | 'trimThreshold_ASC'
  | 'trimThreshold_DESC';

export type PatientReviewsV2ReviewsCollection = {
  __typename?: 'PatientReviewsV2ReviewsCollection';
  items: Array<Maybe<PatientReviewV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PatientReviewsV2ReviewsCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'score_ASC'
  | 'score_DESC'
  | 'subText1_ASC'
  | 'subText1_DESC'
  | 'subText2_ASC'
  | 'subText2_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type PatientReviewsV2ReviewsCursorCollection = {
  __typename?: 'PatientReviewsV2ReviewsCursorCollection';
  items: Array<Maybe<PatientReviewV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PatientReviewsV2ReviewsCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'score_ASC'
  | 'score_DESC'
  | 'subText1_ASC'
  | 'subText1_DESC'
  | 'subText2_ASC'
  | 'subText2_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Represents a dental procedure with a patient-friendly display label for use in the patient portal. Maps one or more clinical procedure codes to a single label shown in visit summaries such as "What was done" and "What to expect". [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/procedure) */
export type Procedure = Entry & _Node & {
  __typename?: 'Procedure';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ProcedureLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  procedureCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
};


/** Represents a dental procedure with a patient-friendly display label for use in the patient portal. Maps one or more clinical procedure codes to a single label shown in visit summaries such as "What was done" and "What to expect". [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/procedure) */
export type ProcedureLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a dental procedure with a patient-friendly display label for use in the patient portal. Maps one or more clinical procedure codes to a single label shown in visit summaries such as "What was done" and "What to expect". [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/procedure) */
export type ProcedureLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a dental procedure with a patient-friendly display label for use in the patient portal. Maps one or more clinical procedure codes to a single label shown in visit summaries such as "What was done" and "What to expect". [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/procedure) */
export type ProcedureNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a dental procedure with a patient-friendly display label for use in the patient portal. Maps one or more clinical procedure codes to a single label shown in visit summaries such as "What was done" and "What to expect". [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/procedure) */
export type ProcedureProcedureCodesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcedureCollection = {
  __typename?: 'ProcedureCollection';
  items: Array<Maybe<Procedure>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProcedureCursorCollection = {
  __typename?: 'ProcedureCursorCollection';
  items: Array<Maybe<Procedure>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProcedureFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProcedureFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProcedureFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedureCodes_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedureCodes_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedureCodes_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedureCodes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ProcedureLinkingCollections = {
  __typename?: 'ProcedureLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ProcedureLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProcedureLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcedureOrder =
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type Product = Entry & _Node & {
  __typename?: 'Product';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  brandfolderImageAssetUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ProductLinkingCollections>;
  mediaAssetsCollection?: Maybe<ProductMediaAssetsCollection>;
  mediaAssetsCursorCollection?: Maybe<ProductMediaAssetsCursorCollection>;
  name?: Maybe<Scalars['String']['output']>;
  procedures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subCategory?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductBrandfolderImageAssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductLinkTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductLinkUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductMediaAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductMediaAssetsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaFilter>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductMediaAssetsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductMediaAssetsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaFilter>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductProceduresArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A type to describe an entire product to be showcased in a global or facility based way.
 *
 * The format of the procedure text line is {procedure code},{quantity needed},{price},{discount percentage}
 * Example:
 * When
 * procedure code = A009
 * quantity needed = 2
 * price = 1,200.15
 * discount percentage = 12%
 *
 * The line will be (note the decimal separator for price is underscore _.)
 * A009, 2, 1200_00, 12 [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/product)
 */
export type ProductSubCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  items: Array<Maybe<Product>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductCursorCollection = {
  __typename?: 'ProductCursorCollection';
  items: Array<Maybe<Product>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplay = Entry & _Node & {
  __typename?: 'ProductDisplay';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ProductDisplayLinkingCollections>;
  productDisplayName?: Maybe<Scalars['String']['output']>;
  productListDescription?: Maybe<ProductDisplayProductListDescription>;
  productListTitle?: Maybe<Scalars['String']['output']>;
  productListTitleHtag?: Maybe<Scalars['String']['output']>;
  productsToDisplay?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showLocalizedProductPrice?: Maybe<Scalars['Boolean']['output']>;
  showProductCategory?: Maybe<Scalars['Boolean']['output']>;
  showProductPriceBreakdown?: Maybe<Scalars['Boolean']['output']>;
  showProductSubCategory?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductDisplayNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductListDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductListTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductListTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayProductsToDisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayShowLocalizedProductPriceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayShowProductCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayShowProductPriceBreakdownArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content model used to display the Products with details like Title, Description, Category, Subcategory, Localized( price specific to the selected facility) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productDisplay) */
export type ProductDisplayShowProductSubCategoryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductDisplayCollection = {
  __typename?: 'ProductDisplayCollection';
  items: Array<Maybe<ProductDisplay>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductDisplayCursorCollection = {
  __typename?: 'ProductDisplayCursorCollection';
  items: Array<Maybe<ProductDisplay>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProductDisplayFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductDisplayFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductDisplayFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  productDisplayName?: InputMaybe<Scalars['String']['input']>;
  productDisplayName_contains?: InputMaybe<Scalars['String']['input']>;
  productDisplayName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productDisplayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productDisplayName_not?: InputMaybe<Scalars['String']['input']>;
  productDisplayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  productDisplayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productListDescription_contains?: InputMaybe<Scalars['String']['input']>;
  productListDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productListDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitle?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productListTitleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productListTitleHtag_not?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productListTitle_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  productListTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productListTitle_not?: InputMaybe<Scalars['String']['input']>;
  productListTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  productListTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsToDisplay_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsToDisplay_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsToDisplay_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productsToDisplay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLocalizedProductPrice?: InputMaybe<Scalars['Boolean']['input']>;
  showLocalizedProductPrice_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showLocalizedProductPrice_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProductCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showProductCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProductCategory_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProductPriceBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
  showProductPriceBreakdown_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProductPriceBreakdown_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProductSubCategory?: InputMaybe<Scalars['Boolean']['input']>;
  showProductSubCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProductSubCategory_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductDisplayLinkingCollections = {
  __typename?: 'ProductDisplayLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type ProductDisplayLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductDisplayLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductDisplayLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductDisplayLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductDisplayLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductDisplayLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductDisplayLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductDisplayLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductDisplayLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductDisplayLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductDisplayOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'productDisplayName_ASC'
  | 'productDisplayName_DESC'
  | 'productListTitleHtag_ASC'
  | 'productListTitleHtag_DESC'
  | 'productListTitle_ASC'
  | 'productListTitle_DESC'
  | 'showLocalizedProductPrice_ASC'
  | 'showLocalizedProductPrice_DESC'
  | 'showProductCategory_ASC'
  | 'showProductCategory_DESC'
  | 'showProductPriceBreakdown_ASC'
  | 'showProductPriceBreakdown_DESC'
  | 'showProductSubCategory_ASC'
  | 'showProductSubCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductDisplayProductListDescription = {
  __typename?: 'ProductDisplayProductListDescription';
  json: Scalars['JSON']['output'];
  links: ProductDisplayProductListDescriptionLinks;
};

export type ProductDisplayProductListDescriptionAssets = {
  __typename?: 'ProductDisplayProductListDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ProductDisplayProductListDescriptionEntries = {
  __typename?: 'ProductDisplayProductListDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ProductDisplayProductListDescriptionLinks = {
  __typename?: 'ProductDisplayProductListDescriptionLinks';
  assets: ProductDisplayProductListDescriptionAssets;
  entries: ProductDisplayProductListDescriptionEntries;
  resources: ProductDisplayProductListDescriptionResources;
};

export type ProductDisplayProductListDescriptionResources = {
  __typename?: 'ProductDisplayProductListDescriptionResources';
  block: Array<ProductDisplayProductListDescriptionResourcesBlock>;
  hyperlink: Array<ProductDisplayProductListDescriptionResourcesHyperlink>;
  inline: Array<ProductDisplayProductListDescriptionResourcesInline>;
};

export type ProductDisplayProductListDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ProductDisplayProductListDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ProductDisplayProductListDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ProductDisplayProductListDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ProductDisplayProductListDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ProductDisplayProductListDescriptionResourcesInline';
  sys: ResourceSys;
};

/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeature = Entry & _Node & {
  __typename?: 'ProductFeature';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<ProductFeatureButtonsCollection>;
  buttonsCursorCollection?: Maybe<ProductFeatureButtonsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  descriptionButton?: Maybe<Button>;
  descriptionButtonsCollection?: Maybe<ProductFeatureDescriptionButtonsCollection>;
  descriptionButtonsCursorCollection?: Maybe<ProductFeatureDescriptionButtonsCursorCollection>;
  descriptionListCollection?: Maybe<ProductFeatureDescriptionListCollection>;
  descriptionListCursorCollection?: Maybe<ProductFeatureDescriptionListCursorCollection>;
  descriptionRichText?: Maybe<ContentTypeRichText>;
  disclaimer?: Maybe<DisclaimerV2>;
  enableSliderControlsBackgroundGradient?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<ContentSection>;
  linkedFrom?: Maybe<ProductFeatureLinkingCollections>;
  media?: Maybe<MediaSlider>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductFeatureDescriptionListItemFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductFeatureDescriptionListItemFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDescriptionRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureEnableSliderControlsBackgroundGradientArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaSliderFilter>;
};


/** A template that accepts only Product Feature content models [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeature) */
export type ProductFeatureNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductFeatureButtonsCollection = {
  __typename?: 'ProductFeatureButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ProductFeatureButtonsCursorCollection = {
  __typename?: 'ProductFeatureButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProductFeatureButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ProductFeatureCollection = {
  __typename?: 'ProductFeatureCollection';
  items: Array<Maybe<ProductFeature>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureCursorCollection = {
  __typename?: 'ProductFeatureCursorCollection';
  items: Array<Maybe<ProductFeature>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProductFeatureDescriptionButtonsCollection = {
  __typename?: 'ProductFeatureDescriptionButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureDescriptionButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ProductFeatureDescriptionButtonsCursorCollection = {
  __typename?: 'ProductFeatureDescriptionButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProductFeatureDescriptionButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ProductFeatureDescriptionListCollection = {
  __typename?: 'ProductFeatureDescriptionListCollection';
  items: Array<Maybe<ProductFeatureDescriptionListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureDescriptionListCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductFeatureDescriptionListCursorCollection = {
  __typename?: 'ProductFeatureDescriptionListCursorCollection';
  items: Array<Maybe<ProductFeatureDescriptionListItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProductFeatureDescriptionListCursorCollectionOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItem = Entry & _Node & {
  __typename?: 'ProductFeatureDescriptionListItem';
  _id: Scalars['ID']['output'];
  content?: Maybe<ContentTypeRichText>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ProductFeatureDescriptionListItemLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItemContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItemIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A List Item for the Product Feature Description List Array [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/productFeatureDescriptionListItem) */
export type ProductFeatureDescriptionListItemNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductFeatureDescriptionListItemCollection = {
  __typename?: 'ProductFeatureDescriptionListItemCollection';
  items: Array<Maybe<ProductFeatureDescriptionListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductFeatureDescriptionListItemCursorCollection = {
  __typename?: 'ProductFeatureDescriptionListItemCursorCollection';
  items: Array<Maybe<ProductFeatureDescriptionListItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProductFeatureDescriptionListItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemFilter>>>;
  content?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductFeatureDescriptionListItemLinkingCollections = {
  __typename?: 'ProductFeatureDescriptionListItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureCursorCollection?: Maybe<ProductFeatureCursorCollection>;
};


export type ProductFeatureDescriptionListItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureDescriptionListItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductFeatureDescriptionListItemLinkingCollectionsProductFeatureCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductFeatureDescriptionListItemOrder =
  | 'icon_ASC'
  | 'icon_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductFeatureFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFeatureFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFeatureFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionButton?: InputMaybe<CfButtonNestedFilter>;
  descriptionButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionButtons?: InputMaybe<CfButtonNestedFilter>;
  descriptionButtonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionList?: InputMaybe<CfProductFeatureDescriptionListItemNestedFilter>;
  descriptionListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText?: InputMaybe<CfContentTypeRichTextNestedFilter>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer?: InputMaybe<CfDisclaimerV2NestedFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableSliderControlsBackgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
  enableSliderControlsBackgroundGradient_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableSliderControlsBackgroundGradient_not?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<CfContentSectionNestedFilter>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<CfMediaSliderNestedFilter>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductFeatureLinkingCollections = {
  __typename?: 'ProductFeatureLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type ProductFeatureLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductFeatureLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductFeatureLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ProductFeatureLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ProductFeatureLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductFeatureLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductFeatureLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductFeatureLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProductFeatureOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'enableSliderControlsBackgroundGradient_ASC'
  | 'enableSliderControlsBackgroundGradient_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderImageAssetUrl?: InputMaybe<Scalars['String']['input']>;
  brandfolderImageAssetUrl_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderImageAssetUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderImageAssetUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandfolderImageAssetUrl_not?: InputMaybe<Scalars['String']['input']>;
  brandfolderImageAssetUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderImageAssetUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_contains?: InputMaybe<Scalars['String']['input']>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_not?: InputMaybe<Scalars['String']['input']>;
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  disclaimer_contains?: InputMaybe<Scalars['String']['input']>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer_not?: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_contains?: InputMaybe<Scalars['String']['input']>;
  disclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaAssets?: InputMaybe<CfMediaNestedFilter>;
  mediaAssetsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedures_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedures_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedures_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  procedures_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  subCategory_contains?: InputMaybe<Scalars['String']['input']>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategory_not?: InputMaybe<Scalars['String']['input']>;
  subCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  subCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductLinkingCollections = {
  __typename?: 'ProductLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ProductLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductMediaAssetsCollection = {
  __typename?: 'ProductMediaAssetsCollection';
  items: Array<Maybe<Media>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductMediaAssetsCollectionOrder =
  | 'alt_ASC'
  | 'alt_DESC'
  | 'contentType_ASC'
  | 'contentType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'poster_ASC'
  | 'poster_DESC'
  | 'src_ASC'
  | 'src_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductMediaAssetsCursorCollection = {
  __typename?: 'ProductMediaAssetsCursorCollection';
  items: Array<Maybe<Media>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProductMediaAssetsCursorCollectionOrder =
  | 'alt_ASC'
  | 'alt_DESC'
  | 'contentType_ASC'
  | 'contentType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'poster_ASC'
  | 'poster_DESC'
  | 'src_ASC'
  | 'src_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProductOrder =
  | 'brandfolderImageAssetUrl_ASC'
  | 'brandfolderImageAssetUrl_DESC'
  | 'category_ASC'
  | 'category_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disclaimer_ASC'
  | 'disclaimer_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'linkUrl_ASC'
  | 'linkUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subCategory_ASC'
  | 'subCategory_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** A horizontal progress indicator for multi-step flows. Renders nothing unless steps are provided. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/progressIndicator) */
export type ProgressIndicator = Entry & _Node & {
  __typename?: 'ProgressIndicator';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  enableStickyIndicator?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ProgressIndicatorLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  requireInPersonVisitFlow?: Maybe<Scalars['Boolean']['output']>;
  steps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
  withBackground?: Maybe<Scalars['Boolean']['output']>;
};


/** A horizontal progress indicator for multi-step flows. Renders nothing unless steps are provided. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/progressIndicator) */
export type ProgressIndicatorEnableStickyIndicatorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A horizontal progress indicator for multi-step flows. Renders nothing unless steps are provided. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/progressIndicator) */
export type ProgressIndicatorLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A horizontal progress indicator for multi-step flows. Renders nothing unless steps are provided. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/progressIndicator) */
export type ProgressIndicatorNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A horizontal progress indicator for multi-step flows. Renders nothing unless steps are provided. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/progressIndicator) */
export type ProgressIndicatorRequireInPersonVisitFlowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A horizontal progress indicator for multi-step flows. Renders nothing unless steps are provided. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/progressIndicator) */
export type ProgressIndicatorStepsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A horizontal progress indicator for multi-step flows. Renders nothing unless steps are provided. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/progressIndicator) */
export type ProgressIndicatorWithBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgressIndicatorCollection = {
  __typename?: 'ProgressIndicatorCollection';
  items: Array<Maybe<ProgressIndicator>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProgressIndicatorCursorCollection = {
  __typename?: 'ProgressIndicatorCursorCollection';
  items: Array<Maybe<ProgressIndicator>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProgressIndicatorFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProgressIndicatorFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProgressIndicatorFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  enableStickyIndicator?: InputMaybe<Scalars['Boolean']['input']>;
  enableStickyIndicator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableStickyIndicator_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requireInPersonVisitFlow?: InputMaybe<Scalars['Boolean']['input']>;
  requireInPersonVisitFlow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requireInPersonVisitFlow_not?: InputMaybe<Scalars['Boolean']['input']>;
  steps_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steps_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steps_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steps_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  withBackground?: InputMaybe<Scalars['Boolean']['input']>;
  withBackground_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withBackground_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgressIndicatorLinkingCollections = {
  __typename?: 'ProgressIndicatorLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type ProgressIndicatorLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgressIndicatorLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgressIndicatorLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgressIndicatorLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProgressIndicatorLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgressIndicatorLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgressIndicatorLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProgressIndicatorLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ProgressIndicatorOrder =
  | 'enableStickyIndicator_ASC'
  | 'enableStickyIndicator_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'requireInPersonVisitFlow_ASC'
  | 'requireInPersonVisitFlow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'withBackground_ASC'
  | 'withBackground_DESC';

/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPage = Entry & _Node & {
  __typename?: 'ProviderDetailsPage';
  _id: Scalars['ID']['output'];
  appCollection?: Maybe<ProviderDetailsPageAppCollection>;
  appCursorCollection?: Maybe<ProviderDetailsPageAppCursorCollection>;
  brand?: Maybe<Brand>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<ProviderDetailsPageContentsCollection>;
  contentsCursorCollection?: Maybe<ProviderDetailsPageContentsCursorCollection>;
  linkedFrom?: Maybe<ProviderDetailsPageLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  npiId?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<ImageAsset>;
  secondaryContentsCollection?: Maybe<ProviderDetailsPageSecondaryContentsCollection>;
  secondaryContentsCursorCollection?: Maybe<ProviderDetailsPageSecondaryContentsCursorCollection>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageAppCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProviderDetailsPageContentsFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageContentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProviderDetailsPageContentsFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageNpiIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageSecondaryContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProviderDetailsPageSecondaryContentsFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageSecondaryContentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProviderDetailsPageSecondaryContentsFilter>;
};


/** This is the content that needs to be displayed for Provider details page, default or for specific provider. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/providerDetailsPage) */
export type ProviderDetailsPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderDetailsPageAppCollection = {
  __typename?: 'ProviderDetailsPageAppCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProviderDetailsPageAppCursorCollection = {
  __typename?: 'ProviderDetailsPageAppCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProviderDetailsPageCollection = {
  __typename?: 'ProviderDetailsPageCollection';
  items: Array<Maybe<ProviderDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProviderDetailsPageContentsCollection = {
  __typename?: 'ProviderDetailsPageContentsCollection';
  items: Array<Maybe<ProviderDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProviderDetailsPageContentsCursorCollection = {
  __typename?: 'ProviderDetailsPageContentsCursorCollection';
  items: Array<Maybe<ProviderDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProviderDetailsPageContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProviderDetailsPageContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProviderDetailsPageContentsFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProviderDetailsPageContentsItem = Accordions | HalfScreen | MultiCardV2 | Service | SingleMessage | Spacer | VideoCarousel;

export type ProviderDetailsPageCursorCollection = {
  __typename?: 'ProviderDetailsPageCursorCollection';
  items: Array<Maybe<ProviderDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProviderDetailsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProviderDetailsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProviderDetailsPageFilter>>>;
  appCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  npiId?: InputMaybe<Scalars['String']['input']>;
  npiId_contains?: InputMaybe<Scalars['String']['input']>;
  npiId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  npiId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  npiId_not?: InputMaybe<Scalars['String']['input']>;
  npiId_not_contains?: InputMaybe<Scalars['String']['input']>;
  npiId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfImageAssetNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryContents?: InputMaybe<CfsecondaryContentsMultiTypeNestedFilter>;
  secondaryContentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderDetailsPageLinkingCollections = {
  __typename?: 'ProviderDetailsPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type ProviderDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProviderDetailsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderDetailsPageOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ProviderDetailsPageSecondaryContentsCollection = {
  __typename?: 'ProviderDetailsPageSecondaryContentsCollection';
  items: Array<Maybe<ProviderDetailsPageSecondaryContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProviderDetailsPageSecondaryContentsCursorCollection = {
  __typename?: 'ProviderDetailsPageSecondaryContentsCursorCollection';
  items: Array<Maybe<ProviderDetailsPageSecondaryContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProviderDetailsPageSecondaryContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProviderDetailsPageSecondaryContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProviderDetailsPageSecondaryContentsFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ProviderDetailsPageSecondaryContentsItem = Accordions | HalfScreen | MultiCardV2 | Service | SingleMessage | Spacer | VideoCarousel;

export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  accordions?: Maybe<Accordions>;
  accordionsCollection?: Maybe<AccordionsCollection>;
  accordionsCursorCollection?: Maybe<AccordionsCursorCollection>;
  adFooter?: Maybe<AdFooter>;
  adFooterCollection?: Maybe<AdFooterCollection>;
  adFooterCursorCollection?: Maybe<AdFooterCursorCollection>;
  agendaModal?: Maybe<AgendaModal>;
  agendaModalCollection?: Maybe<AgendaModalCollection>;
  agendaModalCursorCollection?: Maybe<AgendaModalCursorCollection>;
  agendaStepper?: Maybe<AgendaStepper>;
  agendaStepperCollection?: Maybe<AgendaStepperCollection>;
  agendaStepperCursorCollection?: Maybe<AgendaStepperCursorCollection>;
  analyticsContext?: Maybe<AnalyticsContext>;
  analyticsContextCollection?: Maybe<AnalyticsContextCollection>;
  analyticsContextCursorCollection?: Maybe<AnalyticsContextCursorCollection>;
  app?: Maybe<App>;
  appCollection?: Maybe<AppCollection>;
  appCopySlot?: Maybe<AppCopySlot>;
  appCopySlotCollection?: Maybe<AppCopySlotCollection>;
  appCopySlotCursorCollection?: Maybe<AppCopySlotCursorCollection>;
  appCursorCollection?: Maybe<AppCursorCollection>;
  appFaq?: Maybe<AppFaq>;
  appFaqCollection?: Maybe<AppFaqCollection>;
  appFaqCursorCollection?: Maybe<AppFaqCursorCollection>;
  appLegalDocument?: Maybe<AppLegalDocument>;
  appLegalDocumentCollection?: Maybe<AppLegalDocumentCollection>;
  appLegalDocumentCursorCollection?: Maybe<AppLegalDocumentCursorCollection>;
  appMediaSlot?: Maybe<AppMediaSlot>;
  appMediaSlotCollection?: Maybe<AppMediaSlotCollection>;
  appMediaSlotCursorCollection?: Maybe<AppMediaSlotCursorCollection>;
  appOffer?: Maybe<AppOffer>;
  appOfferCollection?: Maybe<AppOfferCollection>;
  appOfferCursorCollection?: Maybe<AppOfferCursorCollection>;
  appReachYouCard?: Maybe<AppReachYouCard>;
  appReachYouCardCollection?: Maybe<AppReachYouCardCollection>;
  appReachYouCardCursorCollection?: Maybe<AppReachYouCardCursorCollection>;
  appTip?: Maybe<AppTip>;
  appTipCollection?: Maybe<AppTipCollection>;
  appTipCursorCollection?: Maybe<AppTipCursorCollection>;
  appTreatmentInfo?: Maybe<AppTreatmentInfo>;
  appTreatmentInfoCollection?: Maybe<AppTreatmentInfoCollection>;
  appTreatmentInfoCursorCollection?: Maybe<AppTreatmentInfoCursorCollection>;
  appViewCopy?: Maybe<AppViewCopy>;
  appViewCopyCollection?: Maybe<AppViewCopyCollection>;
  appViewCopyCursorCollection?: Maybe<AppViewCopyCursorCollection>;
  appointmentBookingPage?: Maybe<AppointmentBookingPage>;
  appointmentBookingPageCollection?: Maybe<AppointmentBookingPageCollection>;
  appointmentBookingPageCursorCollection?: Maybe<AppointmentBookingPageCursorCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  assetCursorCollection?: Maybe<AssetCursorCollection>;
  badge?: Maybe<Badge>;
  badgeCollection?: Maybe<BadgeCollection>;
  badgeCursorCollection?: Maybe<BadgeCursorCollection>;
  banner?: Maybe<Banner>;
  bannerCollection?: Maybe<BannerCollection>;
  bannerCursorCollection?: Maybe<BannerCursorCollection>;
  birdEyeReviews?: Maybe<BirdEyeReviews>;
  birdEyeReviewsCollection?: Maybe<BirdEyeReviewsCollection>;
  birdEyeReviewsCursorCollection?: Maybe<BirdEyeReviewsCursorCollection>;
  blogAuthor?: Maybe<BlogAuthor>;
  blogAuthorCollection?: Maybe<BlogAuthorCollection>;
  blogAuthorCursorCollection?: Maybe<BlogAuthorCursorCollection>;
  blogCategory?: Maybe<BlogCategory>;
  blogCategoryCollection?: Maybe<BlogCategoryCollection>;
  blogCategoryCursorCollection?: Maybe<BlogCategoryCursorCollection>;
  blogDetailsPage?: Maybe<BlogDetailsPage>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  blogList?: Maybe<BlogList>;
  blogListCollection?: Maybe<BlogListCollection>;
  blogListCursorCollection?: Maybe<BlogListCursorCollection>;
  blogListPage?: Maybe<BlogListPage>;
  blogListPageCollection?: Maybe<BlogListPageCollection>;
  blogListPageCursorCollection?: Maybe<BlogListPageCursorCollection>;
  blogSubCategory?: Maybe<BlogSubCategory>;
  blogSubCategoryCollection?: Maybe<BlogSubCategoryCollection>;
  blogSubCategoryCursorCollection?: Maybe<BlogSubCategoryCursorCollection>;
  bodyText?: Maybe<BodyText>;
  bodyTextCollection?: Maybe<BodyTextCollection>;
  bodyTextCursorCollection?: Maybe<BodyTextCursorCollection>;
  brand?: Maybe<Brand>;
  brandCollection?: Maybe<BrandCollection>;
  brandCursorCollection?: Maybe<BrandCursorCollection>;
  button?: Maybe<Button>;
  buttonCollection?: Maybe<ButtonCollection>;
  buttonCursorCollection?: Maybe<ButtonCursorCollection>;
  card?: Maybe<Card>;
  cardCollection?: Maybe<CardCollection>;
  cardCursorCollection?: Maybe<CardCursorCollection>;
  carousel?: Maybe<Carousel>;
  carouselCollection?: Maybe<CarouselCollection>;
  carouselCursorCollection?: Maybe<CarouselCursorCollection>;
  category?: Maybe<Category>;
  categoryCollection?: Maybe<CategoryCollection>;
  categoryCursorCollection?: Maybe<CategoryCursorCollection>;
  categoryPicker?: Maybe<CategoryPicker>;
  categoryPickerCollection?: Maybe<CategoryPickerCollection>;
  categoryPickerCursorCollection?: Maybe<CategoryPickerCursorCollection>;
  cityLinks?: Maybe<CityLinks>;
  cityLinksCollection?: Maybe<CityLinksCollection>;
  cityLinksCursorCollection?: Maybe<CityLinksCursorCollection>;
  columns?: Maybe<Columns>;
  columnsCollection?: Maybe<ColumnsCollection>;
  columnsCursorCollection?: Maybe<ColumnsCursorCollection>;
  confirmationStep?: Maybe<ConfirmationStep>;
  confirmationStepCollection?: Maybe<ConfirmationStepCollection>;
  confirmationStepCursorCollection?: Maybe<ConfirmationStepCursorCollection>;
  contentData?: Maybe<ContentData>;
  contentDataCollection?: Maybe<ContentDataCollection>;
  contentDataCursorCollection?: Maybe<ContentDataCursorCollection>;
  contentSection?: Maybe<ContentSection>;
  contentSectionCollection?: Maybe<ContentSectionCollection>;
  contentSectionCursorCollection?: Maybe<ContentSectionCursorCollection>;
  contentTile?: Maybe<ContentTile>;
  contentTileCollection?: Maybe<ContentTileCollection>;
  contentTileCursorCollection?: Maybe<ContentTileCursorCollection>;
  contentTypeRichText?: Maybe<ContentTypeRichText>;
  contentTypeRichTextCollection?: Maybe<ContentTypeRichTextCollection>;
  contentTypeRichTextCursorCollection?: Maybe<ContentTypeRichTextCursorCollection>;
  convertFlowCta?: Maybe<ConvertFlowCta>;
  convertFlowCtaCollection?: Maybe<ConvertFlowCtaCollection>;
  convertFlowCtaCursorCollection?: Maybe<ConvertFlowCtaCursorCollection>;
  convertFlowQuiz?: Maybe<ConvertFlowQuiz>;
  convertFlowQuizCollection?: Maybe<ConvertFlowQuizCollection>;
  convertFlowQuizCursorCollection?: Maybe<ConvertFlowQuizCursorCollection>;
  disclaimerV2?: Maybe<DisclaimerV2>;
  disclaimerV2Collection?: Maybe<DisclaimerV2Collection>;
  disclaimerV2CursorCollection?: Maybe<DisclaimerV2CursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  error404?: Maybe<Error404>;
  error404Collection?: Maybe<Error404Collection>;
  error404CursorCollection?: Maybe<Error404CursorCollection>;
  experience?: Maybe<Experience>;
  experienceCollection?: Maybe<ExperienceCollection>;
  experienceCursorCollection?: Maybe<ExperienceCursorCollection>;
  experimentContainer?: Maybe<ExperimentContainer>;
  experimentContainerCollection?: Maybe<ExperimentContainerCollection>;
  experimentContainerCursorCollection?: Maybe<ExperimentContainerCursorCollection>;
  experimentVariationContentsItem?: Maybe<ExperimentVariationContentsItem>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  experimentalModal?: Maybe<ExperimentalModal>;
  experimentalModalCollection?: Maybe<ExperimentalModalCollection>;
  experimentalModalCursorCollection?: Maybe<ExperimentalModalCursorCollection>;
  facilityDetailsPage?: Maybe<FacilityDetailsPage>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  faqAccordion?: Maybe<FaqAccordion>;
  faqAccordionCollection?: Maybe<FaqAccordionCollection>;
  faqAccordionCursorCollection?: Maybe<FaqAccordionCursorCollection>;
  featureFlags?: Maybe<FeatureFlags>;
  featureFlagsCollection?: Maybe<FeatureFlagsCollection>;
  featureFlagsCursorCollection?: Maybe<FeatureFlagsCursorCollection>;
  focalPointImage?: Maybe<FocalPointImage>;
  focalPointImageCollection?: Maybe<FocalPointImageCollection>;
  focalPointImageCursorCollection?: Maybe<FocalPointImageCursorCollection>;
  footerNavigationGroup?: Maybe<FooterNavigationGroup>;
  footerNavigationGroupCollection?: Maybe<FooterNavigationGroupCollection>;
  footerNavigationGroupCursorCollection?: Maybe<FooterNavigationGroupCursorCollection>;
  formDropdownField?: Maybe<FormDropdownField>;
  formDropdownFieldCollection?: Maybe<FormDropdownFieldCollection>;
  formDropdownFieldCursorCollection?: Maybe<FormDropdownFieldCursorCollection>;
  formField?: Maybe<FormField>;
  formFieldCollection?: Maybe<FormFieldCollection>;
  formFieldCursorCollection?: Maybe<FormFieldCursorCollection>;
  googleMapTemplate?: Maybe<GoogleMapTemplate>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  googleMapTemplateCursorCollection?: Maybe<GoogleMapTemplateCursorCollection>;
  halfScreen?: Maybe<HalfScreen>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  header?: Maybe<Header>;
  headerCollection?: Maybe<HeaderCollection>;
  headerCursorCollection?: Maybe<HeaderCursorCollection>;
  headerMainNav?: Maybe<HeaderMainNav>;
  headerMainNavCollection?: Maybe<HeaderMainNavCollection>;
  headerMainNavCursorCollection?: Maybe<HeaderMainNavCursorCollection>;
  headerNavMenu?: Maybe<HeaderNavMenu>;
  headerNavMenuCollection?: Maybe<HeaderNavMenuCollection>;
  headerNavMenuCursorCollection?: Maybe<HeaderNavMenuCursorCollection>;
  headerSubNav?: Maybe<HeaderSubNav>;
  headerSubNavCollection?: Maybe<HeaderSubNavCollection>;
  headerSubNavCursorCollection?: Maybe<HeaderSubNavCursorCollection>;
  heading?: Maybe<Heading>;
  headingCollection?: Maybe<HeadingCollection>;
  headingCursorCollection?: Maybe<HeadingCursorCollection>;
  heroV2?: Maybe<HeroV2>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  icon?: Maybe<Icon>;
  iconCollection?: Maybe<IconCollection>;
  iconCursorCollection?: Maybe<IconCursorCollection>;
  iframe?: Maybe<Iframe>;
  iframeCollection?: Maybe<IframeCollection>;
  iframeCursorCollection?: Maybe<IframeCursorCollection>;
  imageAsset?: Maybe<ImageAsset>;
  imageAssetCollection?: Maybe<ImageAssetCollection>;
  imageAssetCursorCollection?: Maybe<ImageAssetCursorCollection>;
  insurance?: Maybe<Insurance>;
  insuranceCollection?: Maybe<InsuranceCollection>;
  insuranceCursorCollection?: Maybe<InsuranceCursorCollection>;
  linkForwarder?: Maybe<LinkForwarder>;
  linkForwarderCollection?: Maybe<LinkForwarderCollection>;
  linkForwarderCursorCollection?: Maybe<LinkForwarderCursorCollection>;
  list?: Maybe<List>;
  listCollection?: Maybe<ListCollection>;
  listCursorCollection?: Maybe<ListCursorCollection>;
  listItem?: Maybe<ListItem>;
  listItemCollection?: Maybe<ListItemCollection>;
  listItemCursorCollection?: Maybe<ListItemCursorCollection>;
  localizedServiceTitle?: Maybe<LocalizedServiceTitle>;
  localizedServiceTitleCollection?: Maybe<LocalizedServiceTitleCollection>;
  localizedServiceTitleCursorCollection?: Maybe<LocalizedServiceTitleCursorCollection>;
  marquee?: Maybe<Marquee>;
  marqueeCollection?: Maybe<MarqueeCollection>;
  marqueeCursorCollection?: Maybe<MarqueeCursorCollection>;
  media?: Maybe<Media>;
  mediaCollection?: Maybe<MediaCollection>;
  mediaCursorCollection?: Maybe<MediaCursorCollection>;
  mediaSlider?: Maybe<MediaSlider>;
  mediaSliderCollection?: Maybe<MediaSliderCollection>;
  mediaSliderCursorCollection?: Maybe<MediaSliderCursorCollection>;
  medicalService?: Maybe<MedicalService>;
  medicalServiceCollection?: Maybe<MedicalServiceCollection>;
  medicalServiceCursorCollection?: Maybe<MedicalServiceCursorCollection>;
  meetOurStaff?: Maybe<MeetOurStaff>;
  meetOurStaffCollection?: Maybe<MeetOurStaffCollection>;
  meetOurStaffCursorCollection?: Maybe<MeetOurStaffCursorCollection>;
  metroLinks?: Maybe<MetroLinks>;
  metroLinksCollection?: Maybe<MetroLinksCollection>;
  metroLinksCursorCollection?: Maybe<MetroLinksCursorCollection>;
  mobileButton?: Maybe<MobileButton>;
  mobileButtonCollection?: Maybe<MobileButtonCollection>;
  mobileButtonCursorCollection?: Maybe<MobileButtonCursorCollection>;
  multiCardV2?: Maybe<MultiCardV2>;
  multiCardV2Collection?: Maybe<MultiCardV2Collection>;
  multiCardV2CursorCollection?: Maybe<MultiCardV2CursorCollection>;
  navigationGroup?: Maybe<NavigationGroup>;
  navigationGroupCollection?: Maybe<NavigationGroupCollection>;
  navigationGroupCursorCollection?: Maybe<NavigationGroupCursorCollection>;
  navigationLink?: Maybe<NavigationLink>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
  odpHero?: Maybe<OdpHero>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  odpHeroCursorCollection?: Maybe<OdpHeroCursorCollection>;
  page?: Maybe<Page>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  pageLayout?: Maybe<PageLayout>;
  pageLayoutCollection?: Maybe<PageLayoutCollection>;
  pageLayoutCursorCollection?: Maybe<PageLayoutCursorCollection>;
  pageMeta?: Maybe<PageMeta>;
  pageMetaCollection?: Maybe<PageMetaCollection>;
  pageMetaCursorCollection?: Maybe<PageMetaCursorCollection>;
  patientReviewV2?: Maybe<PatientReviewV2>;
  patientReviewV2Collection?: Maybe<PatientReviewV2Collection>;
  patientReviewV2CursorCollection?: Maybe<PatientReviewV2CursorCollection>;
  patientReviewsV2?: Maybe<PatientReviewsV2>;
  patientReviewsV2Collection?: Maybe<PatientReviewsV2Collection>;
  patientReviewsV2CursorCollection?: Maybe<PatientReviewsV2CursorCollection>;
  procedure?: Maybe<Procedure>;
  procedureCollection?: Maybe<ProcedureCollection>;
  procedureCursorCollection?: Maybe<ProcedureCursorCollection>;
  product?: Maybe<Product>;
  productCollection?: Maybe<ProductCollection>;
  productCursorCollection?: Maybe<ProductCursorCollection>;
  productDisplay?: Maybe<ProductDisplay>;
  productDisplayCollection?: Maybe<ProductDisplayCollection>;
  productDisplayCursorCollection?: Maybe<ProductDisplayCursorCollection>;
  productFeature?: Maybe<ProductFeature>;
  productFeatureCollection?: Maybe<ProductFeatureCollection>;
  productFeatureCursorCollection?: Maybe<ProductFeatureCursorCollection>;
  productFeatureDescriptionListItem?: Maybe<ProductFeatureDescriptionListItem>;
  productFeatureDescriptionListItemCollection?: Maybe<ProductFeatureDescriptionListItemCollection>;
  productFeatureDescriptionListItemCursorCollection?: Maybe<ProductFeatureDescriptionListItemCursorCollection>;
  progressIndicator?: Maybe<ProgressIndicator>;
  progressIndicatorCollection?: Maybe<ProgressIndicatorCollection>;
  progressIndicatorCursorCollection?: Maybe<ProgressIndicatorCursorCollection>;
  providerDetailsPage?: Maybe<ProviderDetailsPage>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  questionAnswer?: Maybe<QuestionAnswer>;
  questionAnswerCollection?: Maybe<QuestionAnswerCollection>;
  questionAnswerCursorCollection?: Maybe<QuestionAnswerCursorCollection>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
  questionnaireCursorCollection?: Maybe<QuestionnaireCursorCollection>;
  quickLinks?: Maybe<QuickLinks>;
  quickLinksCollection?: Maybe<QuickLinksCollection>;
  quickLinksCursorCollection?: Maybe<QuickLinksCursorCollection>;
  quiz?: Maybe<Quiz>;
  quizCollection?: Maybe<QuizCollection>;
  quizCursorCollection?: Maybe<QuizCursorCollection>;
  reviewStep?: Maybe<ReviewStep>;
  reviewStepCollection?: Maybe<ReviewStepCollection>;
  reviewStepCursorCollection?: Maybe<ReviewStepCursorCollection>;
  schema?: Maybe<Schema>;
  schemaCollection?: Maybe<SchemaCollection>;
  schemaCursorCollection?: Maybe<SchemaCursorCollection>;
  schemaStep?: Maybe<SchemaStep>;
  schemaStepCollection?: Maybe<SchemaStepCollection>;
  schemaStepCursorCollection?: Maybe<SchemaStepCursorCollection>;
  sectionContent?: Maybe<SectionContent>;
  sectionContentCollection?: Maybe<SectionContentCollection>;
  sectionContentCursorCollection?: Maybe<SectionContentCursorCollection>;
  segmentsContainer?: Maybe<SegmentsContainer>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  service?: Maybe<Service>;
  serviceCollection?: Maybe<ServiceCollection>;
  serviceCursorCollection?: Maybe<ServiceCursorCollection>;
  serviceDetailsPage?: Maybe<ServiceDetailsPage>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
  serviceGroup?: Maybe<ServiceGroup>;
  serviceGroupCollection?: Maybe<ServiceGroupCollection>;
  serviceGroupCursorCollection?: Maybe<ServiceGroupCursorCollection>;
  serviceLineHero?: Maybe<ServiceLineHero>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
  sharedForm?: Maybe<SharedForm>;
  sharedFormCollection?: Maybe<SharedFormCollection>;
  sharedFormCursorCollection?: Maybe<SharedFormCursorCollection>;
  sharedFormDefinitions?: Maybe<SharedFormDefinitions>;
  sharedFormDefinitionsCollection?: Maybe<SharedFormDefinitionsCollection>;
  sharedFormDefinitionsCursorCollection?: Maybe<SharedFormDefinitionsCursorCollection>;
  sharedFormField?: Maybe<SharedFormField>;
  sharedFormFieldCollection?: Maybe<SharedFormFieldCollection>;
  sharedFormFieldCursorCollection?: Maybe<SharedFormFieldCursorCollection>;
  singleMessage?: Maybe<SingleMessage>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  singleMessageCursorCollection?: Maybe<SingleMessageCursorCollection>;
  smallScreenContent?: Maybe<SmallScreenContent>;
  smallScreenContentCollection?: Maybe<SmallScreenContentCollection>;
  smallScreenContentCursorCollection?: Maybe<SmallScreenContentCursorCollection>;
  smileAssessmentForm?: Maybe<SmileAssessmentForm>;
  smileAssessmentFormCollection?: Maybe<SmileAssessmentFormCollection>;
  smileAssessmentFormCursorCollection?: Maybe<SmileAssessmentFormCursorCollection>;
  spacer?: Maybe<Spacer>;
  spacerCollection?: Maybe<SpacerCollection>;
  spacerCursorCollection?: Maybe<SpacerCursorCollection>;
  stateLinks?: Maybe<StateLinks>;
  stateLinksCollection?: Maybe<StateLinksCollection>;
  stateLinksCursorCollection?: Maybe<StateLinksCursorCollection>;
  stepper?: Maybe<Stepper>;
  stepperCollection?: Maybe<StepperCollection>;
  stepperCursorCollection?: Maybe<StepperCursorCollection>;
  successCard?: Maybe<SuccessCard>;
  successCardCollection?: Maybe<SuccessCardCollection>;
  successCardCursorCollection?: Maybe<SuccessCardCursorCollection>;
  tab?: Maybe<Tab>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
  table?: Maybe<Table>;
  tableCollection?: Maybe<TableCollection>;
  tableCursorCollection?: Maybe<TableCursorCollection>;
  tabs?: Maybe<Tabs>;
  tabsCollection?: Maybe<TabsCollection>;
  tabsCursorCollection?: Maybe<TabsCursorCollection>;
  termsAndConditions?: Maybe<TermsAndConditions>;
  termsAndConditionsCollection?: Maybe<TermsAndConditionsCollection>;
  termsAndConditionsCursorCollection?: Maybe<TermsAndConditionsCursorCollection>;
  textBlockSeo?: Maybe<TextBlockSeo>;
  textBlockSeoCollection?: Maybe<TextBlockSeoCollection>;
  textBlockSeoCursorCollection?: Maybe<TextBlockSeoCursorCollection>;
  textHighlight?: Maybe<TextHighlight>;
  textHighlightCollection?: Maybe<TextHighlightCollection>;
  textHighlightCursorCollection?: Maybe<TextHighlightCursorCollection>;
  triggeredContentModal?: Maybe<TriggeredContentModal>;
  triggeredContentModalCollection?: Maybe<TriggeredContentModalCollection>;
  triggeredContentModalCursorCollection?: Maybe<TriggeredContentModalCursorCollection>;
  video?: Maybe<Video>;
  videoAsset?: Maybe<VideoAsset>;
  videoAssetCollection?: Maybe<VideoAssetCollection>;
  videoAssetCursorCollection?: Maybe<VideoAssetCursorCollection>;
  videoCarousel?: Maybe<VideoCarousel>;
  videoCarouselCollection?: Maybe<VideoCarouselCollection>;
  videoCarouselCursorCollection?: Maybe<VideoCarouselCursorCollection>;
  videoCollection?: Maybe<VideoCollection>;
  videoCursorCollection?: Maybe<VideoCursorCollection>;
  videoWithContent?: Maybe<VideoWithContent>;
  videoWithContentCollection?: Maybe<VideoWithContentCollection>;
  videoWithContentCursorCollection?: Maybe<VideoWithContentCursorCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccordionsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccordionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AccordionsFilter>;
};


export type QueryAccordionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AccordionsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AccordionsFilter>;
};


export type QueryAdFooterArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AdFooterFilter>;
};


export type QueryAdFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AdFooterOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AdFooterFilter>;
};


export type QueryAgendaModalArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAgendaModalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaModalOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgendaModalFilter>;
};


export type QueryAgendaModalCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaModalOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgendaModalFilter>;
};


export type QueryAgendaStepperArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAgendaStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgendaStepperFilter>;
};


export type QueryAgendaStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AgendaStepperOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgendaStepperFilter>;
};


export type QueryAnalyticsContextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAnalyticsContextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


export type QueryAnalyticsContextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AnalyticsContextOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


export type QueryAppArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppFilter>;
};


export type QueryAppCopySlotArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppCopySlotCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppCopySlotOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppCopySlotFilter>;
};


export type QueryAppCopySlotCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppCopySlotOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppCopySlotFilter>;
};


export type QueryAppCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppFilter>;
};


export type QueryAppFaqArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppFaqOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppFaqFilter>;
};


export type QueryAppFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppFaqOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppFaqFilter>;
};


export type QueryAppLegalDocumentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppLegalDocumentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppLegalDocumentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppLegalDocumentFilter>;
};


export type QueryAppLegalDocumentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppLegalDocumentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppLegalDocumentFilter>;
};


export type QueryAppMediaSlotArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppMediaSlotCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppMediaSlotOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppMediaSlotFilter>;
};


export type QueryAppMediaSlotCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppMediaSlotOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppMediaSlotFilter>;
};


export type QueryAppOfferArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppOfferCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppOfferOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppOfferFilter>;
};


export type QueryAppOfferCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppOfferOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppOfferFilter>;
};


export type QueryAppReachYouCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppReachYouCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppReachYouCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppReachYouCardFilter>;
};


export type QueryAppReachYouCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppReachYouCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppReachYouCardFilter>;
};


export type QueryAppTipArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppTipCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppTipOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppTipFilter>;
};


export type QueryAppTipCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppTipOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppTipFilter>;
};


export type QueryAppTreatmentInfoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppTreatmentInfoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppTreatmentInfoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppTreatmentInfoFilter>;
};


export type QueryAppTreatmentInfoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppTreatmentInfoOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppTreatmentInfoFilter>;
};


export type QueryAppViewCopyArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppViewCopyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppViewCopyOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppViewCopyFilter>;
};


export type QueryAppViewCopyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppViewCopyOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppViewCopyFilter>;
};


export type QueryAppointmentBookingPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppointmentBookingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppointmentBookingPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppointmentBookingPageFilter>;
};


export type QueryAppointmentBookingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppointmentBookingPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppointmentBookingPageFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryBadgeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBadgeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BadgeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BadgeFilter>;
};


export type QueryBadgeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BadgeOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BadgeFilter>;
};


export type QueryBannerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BannerFilter>;
};


export type QueryBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BannerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BannerFilter>;
};


export type QueryBirdEyeReviewsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBirdEyeReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BirdEyeReviewsFilter>;
};


export type QueryBirdEyeReviewsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BirdEyeReviewsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BirdEyeReviewsFilter>;
};


export type QueryBlogAuthorArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogAuthorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogAuthorOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogAuthorFilter>;
};


export type QueryBlogAuthorCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogAuthorOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogAuthorFilter>;
};


export type QueryBlogCategoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


export type QueryBlogCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


export type QueryBlogDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


export type QueryBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogDetailsPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogDetailsPageFilter>;
};


export type QueryBlogListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogListFilter>;
};


export type QueryBlogListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogListFilter>;
};


export type QueryBlogListPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogListPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogListPageFilter>;
};


export type QueryBlogListPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogListPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogListPageFilter>;
};


export type QueryBlogSubCategoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlogSubCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogSubCategoryFilter>;
};


export type QueryBlogSubCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BlogSubCategoryFilter>;
};


export type QueryBodyTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBodyTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BodyTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BodyTextFilter>;
};


export type QueryBodyTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BodyTextOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BodyTextFilter>;
};


export type QueryBrandArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBrandCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


export type QueryBrandCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BrandOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


export type QueryButtonArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


export type QueryButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ButtonOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


export type QueryCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CardFilter>;
};


export type QueryCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CardFilter>;
};


export type QueryCarouselArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CarouselOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CarouselFilter>;
};


export type QueryCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CarouselOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CarouselFilter>;
};


export type QueryCategoryArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryFilter>;
};


export type QueryCategoryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryFilter>;
};


export type QueryCategoryPickerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoryPickerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryPickerFilter>;
};


export type QueryCategoryPickerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CategoryPickerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CategoryPickerFilter>;
};


export type QueryCityLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCityLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CityLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CityLinksFilter>;
};


export type QueryCityLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CityLinksOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CityLinksFilter>;
};


export type QueryColumnsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ColumnsFilter>;
};


export type QueryColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ColumnsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ColumnsFilter>;
};


export type QueryConfirmationStepArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConfirmationStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ConfirmationStepFilter>;
};


export type QueryConfirmationStepCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConfirmationStepOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ConfirmationStepFilter>;
};


export type QueryContentDataArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentDataCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentDataOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentDataFilter>;
};


export type QueryContentDataCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentDataOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentDataFilter>;
};


export type QueryContentSectionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


export type QueryContentSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentSectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


export type QueryContentTileArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentTileCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTileOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTileFilter>;
};


export type QueryContentTileCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTileOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTileFilter>;
};


export type QueryContentTypeRichTextArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContentTypeRichTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


export type QueryContentTypeRichTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContentTypeRichTextOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentTypeRichTextFilter>;
};


export type QueryConvertFlowCtaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConvertFlowCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowCtaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ConvertFlowCtaFilter>;
};


export type QueryConvertFlowCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowCtaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ConvertFlowCtaFilter>;
};


export type QueryConvertFlowQuizArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConvertFlowQuizCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowQuizOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ConvertFlowQuizFilter>;
};


export type QueryConvertFlowQuizCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ConvertFlowQuizOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ConvertFlowQuizFilter>;
};


export type QueryDisclaimerV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDisclaimerV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


export type QueryDisclaimerV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DisclaimerV2Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DisclaimerV2Filter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryError404Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryError404CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Error404Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Error404Filter>;
};


export type QueryError404CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<Error404Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Error404Filter>;
};


export type QueryExperienceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExperienceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperienceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperienceFilter>;
};


export type QueryExperienceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperienceOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperienceFilter>;
};


export type QueryExperimentContainerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExperimentContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentContainerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentContainerFilter>;
};


export type QueryExperimentContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentContainerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentContainerFilter>;
};


export type QueryExperimentVariationContentsItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentVariationContentsItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentVariationContentsItemFilter>;
};


export type QueryExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentVariationContentsItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentVariationContentsItemFilter>;
};


export type QueryExperimentalModalArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExperimentalModalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentalModalOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentalModalFilter>;
};


export type QueryExperimentalModalCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ExperimentalModalOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExperimentalModalFilter>;
};


export type QueryFacilityDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FacilityDetailsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FacilityDetailsPageFilter>;
};


export type QueryFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FacilityDetailsPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FacilityDetailsPageFilter>;
};


export type QueryFaqAccordionArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFaqAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FaqAccordionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FaqAccordionFilter>;
};


export type QueryFaqAccordionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FaqAccordionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FaqAccordionFilter>;
};


export type QueryFeatureFlagsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFeatureFlagsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FeatureFlagsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FeatureFlagsFilter>;
};


export type QueryFeatureFlagsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FeatureFlagsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FeatureFlagsFilter>;
};


export type QueryFocalPointImageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFocalPointImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


export type QueryFocalPointImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FocalPointImageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


export type QueryFooterNavigationGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFooterNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FooterNavigationGroupFilter>;
};


export type QueryFooterNavigationGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FooterNavigationGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FooterNavigationGroupFilter>;
};


export type QueryFormDropdownFieldArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFormDropdownFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormDropdownFieldFilter>;
};


export type QueryFormDropdownFieldCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormDropdownFieldOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormDropdownFieldFilter>;
};


export type QueryFormFieldArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFormFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormFieldOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormFieldFilter>;
};


export type QueryFormFieldCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<FormFieldOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormFieldFilter>;
};


export type QueryGoogleMapTemplateArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GoogleMapTemplateFilter>;
};


export type QueryGoogleMapTemplateCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<GoogleMapTemplateOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GoogleMapTemplateFilter>;
};


export type QueryHalfScreenArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HalfScreenFilter>;
};


export type QueryHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HalfScreenOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HalfScreenFilter>;
};


export type QueryHeaderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeaderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderFilter>;
};


export type QueryHeaderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderFilter>;
};


export type QueryHeaderMainNavArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeaderMainNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderMainNavOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderMainNavFilter>;
};


export type QueryHeaderMainNavCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderMainNavOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderMainNavFilter>;
};


export type QueryHeaderNavMenuArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeaderNavMenuCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderNavMenuFilter>;
};


export type QueryHeaderNavMenuCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderNavMenuOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderNavMenuFilter>;
};


export type QueryHeaderSubNavArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeaderSubNavCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderSubNavFilter>;
};


export type QueryHeaderSubNavCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeaderSubNavOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeaderSubNavFilter>;
};


export type QueryHeadingArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeadingCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeadingOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeadingFilter>;
};


export type QueryHeadingCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeadingOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeadingFilter>;
};


export type QueryHeroV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroV2Filter>;
};


export type QueryHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<HeroV2Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroV2Filter>;
};


export type QueryIconArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIconCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IconOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IconFilter>;
};


export type QueryIconCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IconOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IconFilter>;
};


export type QueryIframeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIframeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IframeFilter>;
};


export type QueryIframeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<IframeOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IframeFilter>;
};


export type QueryImageAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryImageAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


export type QueryImageAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageAssetOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


export type QueryInsuranceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInsuranceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<InsuranceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<InsuranceFilter>;
};


export type QueryInsuranceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<InsuranceOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<InsuranceFilter>;
};


export type QueryLinkForwarderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLinkForwarderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkForwarderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkForwarderFilter>;
};


export type QueryLinkForwarderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LinkForwarderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkForwarderFilter>;
};


export type QueryListArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ListFilter>;
};


export type QueryListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ListFilter>;
};


export type QueryListItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ListItemFilter>;
};


export type QueryListItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ListItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ListItemFilter>;
};


export type QueryLocalizedServiceTitleArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocalizedServiceTitleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocalizedServiceTitleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LocalizedServiceTitleFilter>;
};


export type QueryLocalizedServiceTitleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocalizedServiceTitleOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LocalizedServiceTitleFilter>;
};


export type QueryMarqueeArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarqueeCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MarqueeFilter>;
};


export type QueryMarqueeCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MarqueeOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MarqueeFilter>;
};


export type QueryMediaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaFilter>;
};


export type QueryMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaFilter>;
};


export type QueryMediaSliderArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMediaSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaSliderFilter>;
};


export type QueryMediaSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MediaSliderOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaSliderFilter>;
};


export type QueryMedicalServiceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMedicalServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MedicalServiceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MedicalServiceFilter>;
};


export type QueryMedicalServiceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MedicalServiceOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MedicalServiceFilter>;
};


export type QueryMeetOurStaffArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMeetOurStaffCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MeetOurStaffFilter>;
};


export type QueryMeetOurStaffCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MeetOurStaffOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MeetOurStaffFilter>;
};


export type QueryMetroLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMetroLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MetroLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MetroLinksFilter>;
};


export type QueryMetroLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MetroLinksOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MetroLinksFilter>;
};


export type QueryMobileButtonArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMobileButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MobileButtonOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MobileButtonFilter>;
};


export type QueryMobileButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MobileButtonOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MobileButtonFilter>;
};


export type QueryMultiCardV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMultiCardV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MultiCardV2Filter>;
};


export type QueryMultiCardV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<MultiCardV2Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MultiCardV2Filter>;
};


export type QueryNavigationGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


export type QueryNavigationGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationGroupFilter>;
};


export type QueryNavigationLinkArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


export type QueryNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationLinkFilter>;
};


export type QueryOdpHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OdpHeroFilter>;
};


export type QueryOdpHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<OdpHeroOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OdpHeroFilter>;
};


export type QueryPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


export type QueryPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageFilter>;
};


export type QueryPageLayoutArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPageLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLayoutOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageLayoutFilter>;
};


export type QueryPageLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageLayoutOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageLayoutFilter>;
};


export type QueryPageMetaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPageMetaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageMetaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageMetaFilter>;
};


export type QueryPageMetaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PageMetaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageMetaFilter>;
};


export type QueryPatientReviewV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPatientReviewV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientReviewV2Filter>;
};


export type QueryPatientReviewV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewV2Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientReviewV2Filter>;
};


export type QueryPatientReviewsV2Args = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPatientReviewsV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2Order>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientReviewsV2Filter>;
};


export type QueryPatientReviewsV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<PatientReviewsV2Order>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientReviewsV2Filter>;
};


export type QueryProcedureArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProcedureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProcedureOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProcedureFilter>;
};


export type QueryProcedureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProcedureOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProcedureFilter>;
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductFilter>;
};


export type QueryProductCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductFilter>;
};


export type QueryProductDisplayArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductDisplayCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductDisplayFilter>;
};


export type QueryProductDisplayCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductDisplayOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductDisplayFilter>;
};


export type QueryProductFeatureArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductFeatureCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductFeatureFilter>;
};


export type QueryProductFeatureCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductFeatureFilter>;
};


export type QueryProductFeatureDescriptionListItemArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductFeatureDescriptionListItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductFeatureDescriptionListItemFilter>;
};


export type QueryProductFeatureDescriptionListItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductFeatureDescriptionListItemOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductFeatureDescriptionListItemFilter>;
};


export type QueryProgressIndicatorArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProgressIndicatorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgressIndicatorOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgressIndicatorFilter>;
};


export type QueryProgressIndicatorCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgressIndicatorOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgressIndicatorFilter>;
};


export type QueryProviderDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProviderDetailsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProviderDetailsPageFilter>;
};


export type QueryProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProviderDetailsPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProviderDetailsPageFilter>;
};


export type QueryQuestionAnswerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuestionAnswerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionAnswerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionAnswerFilter>;
};


export type QueryQuestionAnswerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionAnswerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionAnswerFilter>;
};


export type QueryQuestionnaireArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionnaireFilter>;
};


export type QueryQuestionnaireCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionnaireFilter>;
};


export type QueryQuickLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuickLinksFilter>;
};


export type QueryQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuickLinksFilter>;
};


export type QueryQuizArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuizCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuizFilter>;
};


export type QueryQuizCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuizFilter>;
};


export type QueryReviewStepArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryReviewStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewStepOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ReviewStepFilter>;
};


export type QueryReviewStepCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewStepOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ReviewStepFilter>;
};


export type QuerySchemaArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySchemaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchemaFilter>;
};


export type QuerySchemaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchemaFilter>;
};


export type QuerySchemaStepArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySchemaStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchemaStepFilter>;
};


export type QuerySchemaStepCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchemaStepFilter>;
};


export type QuerySectionContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySectionContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SectionContentFilter>;
};


export type QuerySectionContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SectionContentFilter>;
};


export type QuerySegmentsContainerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SegmentsContainerFilter>;
};


export type QuerySegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SegmentsContainerFilter>;
};


export type QueryServiceArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceFilter>;
};


export type QueryServiceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceFilter>;
};


export type QueryServiceDetailsPageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceDetailsPageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceDetailsPageFilter>;
};


export type QueryServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceDetailsPageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceDetailsPageFilter>;
};


export type QueryServiceGroupArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryServiceGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceGroupOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceGroupFilter>;
};


export type QueryServiceGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceGroupOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceGroupFilter>;
};


export type QueryServiceLineHeroArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceLineHeroFilter>;
};


export type QueryServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceLineHeroFilter>;
};


export type QuerySharedFormArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySharedFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormFilter>;
};


export type QuerySharedFormCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormFilter>;
};


export type QuerySharedFormDefinitionsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySharedFormDefinitionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormDefinitionsFilter>;
};


export type QuerySharedFormDefinitionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormDefinitionsFilter>;
};


export type QuerySharedFormFieldArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySharedFormFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormFieldOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormFieldFilter>;
};


export type QuerySharedFormFieldCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormFieldOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormFieldFilter>;
};


export type QuerySingleMessageArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SingleMessageFilter>;
};


export type QuerySingleMessageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SingleMessageFilter>;
};


export type QuerySmallScreenContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySmallScreenContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


export type QuerySmallScreenContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


export type QuerySmileAssessmentFormArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySmileAssessmentFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmileAssessmentFormOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmileAssessmentFormFilter>;
};


export type QuerySmileAssessmentFormCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmileAssessmentFormOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmileAssessmentFormFilter>;
};


export type QuerySpacerArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySpacerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SpacerFilter>;
};


export type QuerySpacerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SpacerFilter>;
};


export type QueryStateLinksArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStateLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StateLinksOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StateLinksFilter>;
};


export type QueryStateLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StateLinksOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StateLinksFilter>;
};


export type QueryStepperArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StepperFilter>;
};


export type QueryStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StepperFilter>;
};


export type QuerySuccessCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySuccessCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SuccessCardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SuccessCardFilter>;
};


export type QuerySuccessCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SuccessCardOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SuccessCardFilter>;
};


export type QueryTabArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabFilter>;
};


export type QueryTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabFilter>;
};


export type QueryTableArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTableCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TableFilter>;
};


export type QueryTableCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TableFilter>;
};


export type QueryTabsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabsFilter>;
};


export type QueryTabsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabsFilter>;
};


export type QueryTermsAndConditionsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTermsAndConditionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


export type QueryTermsAndConditionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


export type QueryTextBlockSeoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTextBlockSeoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextBlockSeoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TextBlockSeoFilter>;
};


export type QueryTextBlockSeoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextBlockSeoOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TextBlockSeoFilter>;
};


export type QueryTextHighlightArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTextHighlightCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextHighlightOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TextHighlightFilter>;
};


export type QueryTextHighlightCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextHighlightOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TextHighlightFilter>;
};


export type QueryTriggeredContentModalArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTriggeredContentModalCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TriggeredContentModalOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TriggeredContentModalFilter>;
};


export type QueryTriggeredContentModalCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TriggeredContentModalOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TriggeredContentModalFilter>;
};


export type QueryVideoArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVideoAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVideoAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};


export type QueryVideoAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};


export type QueryVideoCarouselArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVideoCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoCarouselFilter>;
};


export type QueryVideoCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoCarouselFilter>;
};


export type QueryVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


export type QueryVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


export type QueryVideoWithContentArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVideoWithContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoWithContentFilter>;
};


export type QueryVideoWithContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoWithContentFilter>;
};

/** Used in Accordion collections [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionAnswer) */
export type QuestionAnswer = Entry & _Node & {
  __typename?: 'QuestionAnswer';
  _id: Scalars['ID']['output'];
  answer?: Maybe<QuestionAnswerAnswer>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<QuestionAnswerLinkingCollections>;
  question?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Used in Accordion collections [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionAnswer) */
export type QuestionAnswerAnswerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used in Accordion collections [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionAnswer) */
export type QuestionAnswerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used in Accordion collections [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionAnswer) */
export type QuestionAnswerQuestionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionAnswerAnswer = {
  __typename?: 'QuestionAnswerAnswer';
  json: Scalars['JSON']['output'];
  links: QuestionAnswerAnswerLinks;
};

export type QuestionAnswerAnswerAssets = {
  __typename?: 'QuestionAnswerAnswerAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type QuestionAnswerAnswerEntries = {
  __typename?: 'QuestionAnswerAnswerEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type QuestionAnswerAnswerLinks = {
  __typename?: 'QuestionAnswerAnswerLinks';
  assets: QuestionAnswerAnswerAssets;
  entries: QuestionAnswerAnswerEntries;
  resources: QuestionAnswerAnswerResources;
};

export type QuestionAnswerAnswerResources = {
  __typename?: 'QuestionAnswerAnswerResources';
  block: Array<QuestionAnswerAnswerResourcesBlock>;
  hyperlink: Array<QuestionAnswerAnswerResourcesHyperlink>;
  inline: Array<QuestionAnswerAnswerResourcesInline>;
};

export type QuestionAnswerAnswerResourcesBlock = ResourceLink & {
  __typename?: 'QuestionAnswerAnswerResourcesBlock';
  sys: ResourceSys;
};

export type QuestionAnswerAnswerResourcesHyperlink = ResourceLink & {
  __typename?: 'QuestionAnswerAnswerResourcesHyperlink';
  sys: ResourceSys;
};

export type QuestionAnswerAnswerResourcesInline = ResourceLink & {
  __typename?: 'QuestionAnswerAnswerResourcesInline';
  sys: ResourceSys;
};

export type QuestionAnswerCollection = {
  __typename?: 'QuestionAnswerCollection';
  items: Array<Maybe<QuestionAnswer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuestionAnswerCursorCollection = {
  __typename?: 'QuestionAnswerCursorCollection';
  items: Array<Maybe<QuestionAnswer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuestionAnswerFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuestionAnswerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuestionAnswerFilter>>>;
  answer_contains?: InputMaybe<Scalars['String']['input']>;
  answer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  answer_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  question?: InputMaybe<Scalars['String']['input']>;
  question_contains?: InputMaybe<Scalars['String']['input']>;
  question_exists?: InputMaybe<Scalars['Boolean']['input']>;
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_not?: InputMaybe<Scalars['String']['input']>;
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type QuestionAnswerLinkingCollections = {
  __typename?: 'QuestionAnswerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  faqAccordionCollection?: Maybe<FaqAccordionCollection>;
  faqAccordionCursorCollection?: Maybe<FaqAccordionCursorCollection>;
};


export type QuestionAnswerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionAnswerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionAnswerLinkingCollectionsFaqAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionAnswerLinkingCollectionsFaqAccordionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionAnswerLinkingCollectionsFaqAccordionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionAnswerLinkingCollectionsFaqAccordionCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionAnswerLinkingCollectionsFaqAccordionCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type QuestionAnswerLinkingCollectionsFaqAccordionCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type QuestionAnswerOrder =
  | 'question_ASC'
  | 'question_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type Questionnaire = Entry & _Node & {
  __typename?: 'Questionnaire';
  _id: Scalars['ID']['output'];
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  defaultErrorMessage?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  formCollection?: Maybe<QuestionnaireFormCollection>;
  formCursorCollection?: Maybe<QuestionnaireFormCursorCollection>;
  image?: Maybe<FocalPointImage>;
  linkedFrom?: Maybe<QuestionnaireLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireDefaultErrorMessageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionnaireFormFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireFormCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionnaireFormFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireSubTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/questionnaire) */
export type QuestionnaireTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireCollection = {
  __typename?: 'QuestionnaireCollection';
  items: Array<Maybe<Questionnaire>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuestionnaireCursorCollection = {
  __typename?: 'QuestionnaireCursorCollection';
  items: Array<Maybe<Questionnaire>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuestionnaireFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuestionnaireFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuestionnaireFilter>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultErrorMessage?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  form?: InputMaybe<CfformMultiTypeNestedFilter>;
  formCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<CfFocalPointImageNestedFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subTitle_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle_not?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuestionnaireFormCollection = {
  __typename?: 'QuestionnaireFormCollection';
  items: Array<Maybe<QuestionnaireFormItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuestionnaireFormCursorCollection = {
  __typename?: 'QuestionnaireFormCursorCollection';
  items: Array<Maybe<QuestionnaireFormItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuestionnaireFormFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuestionnaireFormFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuestionnaireFormFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuestionnaireFormItem = FormDropdownField | FormField | SectionContent;

export type QuestionnaireLinkingCollections = {
  __typename?: 'QuestionnaireLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  smileAssessmentFormCollection?: Maybe<SmileAssessmentFormCollection>;
  smileAssessmentFormCursorCollection?: Maybe<SmileAssessmentFormCursorCollection>;
};


export type QuestionnaireLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionnaireLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionnaireLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionnaireLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionnaireLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionnaireLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionnaireLinkingCollectionsSmileAssessmentFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireLinkingCollectionsSmileAssessmentFormCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuestionnaireLinkingCollectionsSmileAssessmentFormCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuestionnaireLinkingCollectionsSmileAssessmentFormCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type QuestionnaireLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type QuestionnaireLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuestionnaireLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuestionnaireLinkingCollectionsSmileAssessmentFormCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type QuestionnaireLinkingCollectionsSmileAssessmentFormCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type QuestionnaireOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinks = Entry & _Node & {
  __typename?: 'QuickLinks';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  body?: Maybe<QuickLinksBody>;
  buttonsCollection?: Maybe<QuickLinksButtonsCollection>;
  buttonsCursorCollection?: Maybe<QuickLinksButtonsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  displayAsTitles?: Maybe<Scalars['Boolean']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowStyle?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<QuickLinksHeading>;
  linkedFrom?: Maybe<QuickLinksLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  quickLinksCollection?: Maybe<QuickLinksQuickLinksCollection>;
  quickLinksCursorCollection?: Maybe<QuickLinksQuickLinksCursorCollection>;
  sys: Sys;
  templateSize?: Maybe<Scalars['String']['output']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksBodyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksDisplayAsTitlesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksEyebrowStyleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksHeadingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksQuickLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksQuickLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksQuickLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksQuickLinksCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** QuickLinks template [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quickLinks) */
export type QuickLinksTemplateSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuickLinksBody = {
  __typename?: 'QuickLinksBody';
  json: Scalars['JSON']['output'];
  links: QuickLinksBodyLinks;
};

export type QuickLinksBodyAssets = {
  __typename?: 'QuickLinksBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type QuickLinksBodyEntries = {
  __typename?: 'QuickLinksBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type QuickLinksBodyLinks = {
  __typename?: 'QuickLinksBodyLinks';
  assets: QuickLinksBodyAssets;
  entries: QuickLinksBodyEntries;
  resources: QuickLinksBodyResources;
};

export type QuickLinksBodyResources = {
  __typename?: 'QuickLinksBodyResources';
  block: Array<QuickLinksBodyResourcesBlock>;
  hyperlink: Array<QuickLinksBodyResourcesHyperlink>;
  inline: Array<QuickLinksBodyResourcesInline>;
};

export type QuickLinksBodyResourcesBlock = ResourceLink & {
  __typename?: 'QuickLinksBodyResourcesBlock';
  sys: ResourceSys;
};

export type QuickLinksBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'QuickLinksBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type QuickLinksBodyResourcesInline = ResourceLink & {
  __typename?: 'QuickLinksBodyResourcesInline';
  sys: ResourceSys;
};

export type QuickLinksButtonsCollection = {
  __typename?: 'QuickLinksButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuickLinksButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuickLinksButtonsCursorCollection = {
  __typename?: 'QuickLinksButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuickLinksButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuickLinksCollection = {
  __typename?: 'QuickLinksCollection';
  items: Array<Maybe<QuickLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuickLinksCursorCollection = {
  __typename?: 'QuickLinksCursorCollection';
  items: Array<Maybe<QuickLinks>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuickLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuickLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuickLinksFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsTitles?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsTitles_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsTitles_not?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowStyle_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quickLinks?: InputMaybe<CfButtonNestedFilter>;
  quickLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateSize?: InputMaybe<Scalars['String']['input']>;
  templateSize_contains?: InputMaybe<Scalars['String']['input']>;
  templateSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateSize_not?: InputMaybe<Scalars['String']['input']>;
  templateSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuickLinksHeading = {
  __typename?: 'QuickLinksHeading';
  json: Scalars['JSON']['output'];
  links: QuickLinksHeadingLinks;
};

export type QuickLinksHeadingAssets = {
  __typename?: 'QuickLinksHeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type QuickLinksHeadingEntries = {
  __typename?: 'QuickLinksHeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type QuickLinksHeadingLinks = {
  __typename?: 'QuickLinksHeadingLinks';
  assets: QuickLinksHeadingAssets;
  entries: QuickLinksHeadingEntries;
  resources: QuickLinksHeadingResources;
};

export type QuickLinksHeadingResources = {
  __typename?: 'QuickLinksHeadingResources';
  block: Array<QuickLinksHeadingResourcesBlock>;
  hyperlink: Array<QuickLinksHeadingResourcesHyperlink>;
  inline: Array<QuickLinksHeadingResourcesInline>;
};

export type QuickLinksHeadingResourcesBlock = ResourceLink & {
  __typename?: 'QuickLinksHeadingResourcesBlock';
  sys: ResourceSys;
};

export type QuickLinksHeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'QuickLinksHeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type QuickLinksHeadingResourcesInline = ResourceLink & {
  __typename?: 'QuickLinksHeadingResourcesInline';
  sys: ResourceSys;
};

export type QuickLinksLinkingCollections = {
  __typename?: 'QuickLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type QuickLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuickLinksLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuickLinksLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuickLinksLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type QuickLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type QuickLinksLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuickLinksOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'displayAsTitles_ASC'
  | 'displayAsTitles_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC';

export type QuickLinksQuickLinksCollection = {
  __typename?: 'QuickLinksQuickLinksCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuickLinksQuickLinksCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuickLinksQuickLinksCursorCollection = {
  __typename?: 'QuickLinksQuickLinksCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuickLinksQuickLinksCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type Quiz = Entry & _Node & {
  __typename?: 'Quiz';
  _id: Scalars['ID']['output'];
  brand?: Maybe<Brand>;
  clearChoicePoorCreditRedirectPath?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  formBuilderConfig?: Maybe<Scalars['JSON']['output']>;
  isFormBuilder?: Maybe<Scalars['Boolean']['output']>;
  leadGenPopUpImageDesktop?: Maybe<Scalars['String']['output']>;
  leadGenPopUpImageMobile?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<QuizLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  quizFormData?: Maybe<Scalars['JSON']['output']>;
  quizType?: Maybe<Scalars['String']['output']>;
  submitEndpointUrl?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizBrandArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandFilter>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizClearChoicePoorCreditRedirectPathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizFormBuilderConfigArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizIsFormBuilderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizLeadGenPopUpImageDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizLeadGenPopUpImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizQuizFormDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizQuizTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Content model used to get the questions and other data for the Quiz displayed in Aspen Dental, ClearChoice etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/quiz) */
export type QuizSubmitEndpointUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizCollection = {
  __typename?: 'QuizCollection';
  items: Array<Maybe<Quiz>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type QuizCursorCollection = {
  __typename?: 'QuizCursorCollection';
  items: Array<Maybe<Quiz>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type QuizFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuizFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuizFilter>>>;
  brand?: InputMaybe<CfBrandNestedFilter>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearChoicePoorCreditRedirectPath?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_contains?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearChoicePoorCreditRedirectPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clearChoicePoorCreditRedirectPath_not?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  formBuilderConfig_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder_not?: InputMaybe<Scalars['Boolean']['input']>;
  leadGenPopUpImageDesktop?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageDesktop_contains?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  leadGenPopUpImageDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leadGenPopUpImageDesktop_not?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageDesktop_not_contains?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leadGenPopUpImageMobile?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageMobile_contains?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  leadGenPopUpImageMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leadGenPopUpImageMobile_not?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizFormData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizType?: InputMaybe<Scalars['String']['input']>;
  quizType_contains?: InputMaybe<Scalars['String']['input']>;
  quizType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizType_not?: InputMaybe<Scalars['String']['input']>;
  quizType_not_contains?: InputMaybe<Scalars['String']['input']>;
  quizType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  submitEndpointUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl_not?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type QuizLinkingCollections = {
  __typename?: 'QuizLinkingCollections';
  buttonCollection?: Maybe<ButtonCollection>;
  buttonCursorCollection?: Maybe<ButtonCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type QuizLinkingCollectionsButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsHeroV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuizLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<QuizLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuizLinkingCollectionsButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuizLinkingCollectionsButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuizLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type QuizLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type QuizLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuizLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuizLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuizLinkingCollectionsHeroV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type QuizLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuizLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type QuizOrder =
  | 'clearChoicePoorCreditRedirectPath_ASC'
  | 'clearChoicePoorCreditRedirectPath_DESC'
  | 'isFormBuilder_ASC'
  | 'isFormBuilder_DESC'
  | 'leadGenPopUpImageDesktop_ASC'
  | 'leadGenPopUpImageDesktop_DESC'
  | 'leadGenPopUpImageMobile_ASC'
  | 'leadGenPopUpImageMobile_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizType_ASC'
  | 'quizType_DESC'
  | 'submitEndpointUrl_ASC'
  | 'submitEndpointUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStep = Entry & _Node & {
  __typename?: 'ReviewStep';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ReviewStepLinkingCollections>;
  reviewCardsCollection?: Maybe<ReviewStepReviewCardsCollection>;
  reviewCardsCursorCollection?: Maybe<ReviewStepReviewCardsCursorCollection>;
  reviewStepName?: Maybe<Scalars['String']['output']>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
  stepSubtitle?: Maybe<Scalars['String']['output']>;
  stepTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepReviewCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepReviewCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepReviewStepNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepStepNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepStepSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/reviewStep) */
export type ReviewStepStepTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewStepCollection = {
  __typename?: 'ReviewStepCollection';
  items: Array<Maybe<ReviewStep>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ReviewStepCursorCollection = {
  __typename?: 'ReviewStepCursorCollection';
  items: Array<Maybe<ReviewStep>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ReviewStepFilter = {
  AND?: InputMaybe<Array<InputMaybe<ReviewStepFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ReviewStepFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  reviewCardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reviewStepName?: InputMaybe<Scalars['String']['input']>;
  reviewStepName_contains?: InputMaybe<Scalars['String']['input']>;
  reviewStepName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reviewStepName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewStepName_not?: InputMaybe<Scalars['String']['input']>;
  reviewStepName_not_contains?: InputMaybe<Scalars['String']['input']>;
  reviewStepName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepNumber?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepSubtitle?: InputMaybe<Scalars['String']['input']>;
  stepSubtitle_contains?: InputMaybe<Scalars['String']['input']>;
  stepSubtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepSubtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepSubtitle_not?: InputMaybe<Scalars['String']['input']>;
  stepSubtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepSubtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepTitle?: InputMaybe<Scalars['String']['input']>;
  stepTitle_contains?: InputMaybe<Scalars['String']['input']>;
  stepTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepTitle_not?: InputMaybe<Scalars['String']['input']>;
  stepTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type ReviewStepLinkingCollections = {
  __typename?: 'ReviewStepLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  stepperCollection?: Maybe<StepperCollection>;
  stepperCursorCollection?: Maybe<StepperCursorCollection>;
};


export type ReviewStepLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ReviewStepLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ReviewStepLinkingCollectionsStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewStepLinkingCollectionsStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ReviewStepLinkingCollectionsStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewStepLinkingCollectionsStepperCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewStepLinkingCollectionsStepperCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ReviewStepLinkingCollectionsStepperCursorCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ReviewStepOrder =
  | 'reviewStepName_ASC'
  | 'reviewStepName_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'stepSubtitle_ASC'
  | 'stepSubtitle_DESC'
  | 'stepTitle_ASC'
  | 'stepTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ReviewStepReviewCardsCollection = {
  __typename?: 'ReviewStepReviewCardsCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ReviewStepReviewCardsCursorCollection = {
  __typename?: 'ReviewStepReviewCardsCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type Schema = Entry & _Node & {
  __typename?: 'Schema';
  _id: Scalars['ID']['output'];
  combinedSchema?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<SchemaLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type SchemaCombinedSchemaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type SchemaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type SchemaNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schema) */
export type SchemaSchemaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchemaCollection = {
  __typename?: 'SchemaCollection';
  items: Array<Maybe<Schema>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SchemaCursorCollection = {
  __typename?: 'SchemaCursorCollection';
  items: Array<Maybe<Schema>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SchemaFilter = {
  AND?: InputMaybe<Array<InputMaybe<SchemaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SchemaFilter>>>;
  combinedSchema?: InputMaybe<Scalars['Boolean']['input']>;
  combinedSchema_exists?: InputMaybe<Scalars['Boolean']['input']>;
  combinedSchema_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schema_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type SchemaLinkingCollections = {
  __typename?: 'SchemaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  pageMetaCollection?: Maybe<PageMetaCollection>;
  pageMetaCursorCollection?: Maybe<PageMetaCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type SchemaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsPageMetaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsPageMetaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsPageMetaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsPageMetaCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchemaLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SchemaLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SchemaLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaLinkingCollectionsPageMetaCollectionOrder =
  | 'canonicalUrl_ASC'
  | 'canonicalUrl_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SchemaLinkingCollectionsPageMetaCursorCollectionOrder =
  | 'canonicalUrl_ASC'
  | 'canonicalUrl_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SchemaLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaOrder =
  | 'combinedSchema_ASC'
  | 'combinedSchema_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schemaStep) */
export type SchemaStep = Entry & _Node & {
  __typename?: 'SchemaStep';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  formFieldCollection?: Maybe<SchemaStepFormFieldCollection>;
  formFieldCursorCollection?: Maybe<SchemaStepFormFieldCursorCollection>;
  formTitle?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SchemaStepLinkingCollections>;
  stepNumber?: Maybe<Scalars['Int']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schemaStep) */
export type SchemaStepFormFieldCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchemaStepFormFieldFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schemaStep) */
export type SchemaStepFormFieldCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchemaStepFormFieldFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schemaStep) */
export type SchemaStepFormTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schemaStep) */
export type SchemaStepLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/schemaStep) */
export type SchemaStepStepNumberArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchemaStepCollection = {
  __typename?: 'SchemaStepCollection';
  items: Array<Maybe<SchemaStep>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SchemaStepCursorCollection = {
  __typename?: 'SchemaStepCursorCollection';
  items: Array<Maybe<SchemaStep>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SchemaStepFilter = {
  AND?: InputMaybe<Array<InputMaybe<SchemaStepFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SchemaStepFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  formField?: InputMaybe<CfformFieldMultiTypeNestedFilter>;
  formFieldCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formTitle?: InputMaybe<Scalars['String']['input']>;
  formTitle_contains?: InputMaybe<Scalars['String']['input']>;
  formTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formTitle_not?: InputMaybe<Scalars['String']['input']>;
  formTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  formTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepNumber?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not?: InputMaybe<Scalars['Int']['input']>;
  stepNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SchemaStepFormFieldCollection = {
  __typename?: 'SchemaStepFormFieldCollection';
  items: Array<Maybe<SchemaStepFormFieldItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SchemaStepFormFieldCursorCollection = {
  __typename?: 'SchemaStepFormFieldCursorCollection';
  items: Array<Maybe<SchemaStepFormFieldItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SchemaStepFormFieldFilter = {
  AND?: InputMaybe<Array<InputMaybe<SchemaStepFormFieldFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SchemaStepFormFieldFilter>>>;
  alertMessage?: InputMaybe<Scalars['String']['input']>;
  alertMessage_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alertMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alertMessage_not?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey_not?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  required_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchemaStepFormFieldItem = FormDropdownField | FormField;

export type SchemaStepLinkingCollections = {
  __typename?: 'SchemaStepLinkingCollections';
  columnsCollection?: Maybe<ColumnsCollection>;
  columnsCursorCollection?: Maybe<ColumnsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  stepperCollection?: Maybe<StepperCollection>;
  stepperCursorCollection?: Maybe<StepperCursorCollection>;
};


export type SchemaStepLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepLinkingCollectionsColumnsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepLinkingCollectionsStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SchemaStepLinkingCollectionsStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SchemaStepLinkingCollectionsStepperCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchemaStepLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaStepLinkingCollectionsColumnsCursorCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaStepLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SchemaStepLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SchemaStepLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaStepLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SchemaStepLinkingCollectionsStepperCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SchemaStepLinkingCollectionsStepperCursorCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SchemaStepOrder =
  | 'formTitle_ASC'
  | 'formTitle_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContent = Entry & _Node & {
  __typename?: 'SectionContent';
  _id: Scalars['ID']['output'];
  aditionalReferencesCollection?: Maybe<SectionContentAditionalReferencesCollection>;
  aditionalReferencesCursorCollection?: Maybe<SectionContentAditionalReferencesCursorCollection>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  image?: Maybe<FocalPointImage>;
  imageShape?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SectionContentLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  richTextContent?: Maybe<SectionContentRichTextContent>;
  subTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentAditionalReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentAditionalReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentImageShapeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentOrientationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentRichTextContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentSubTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should not be used anymore [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sectionContent) */
export type SectionContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SectionContentAditionalReferencesCollection = {
  __typename?: 'SectionContentAditionalReferencesCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SectionContentAditionalReferencesCursorCollection = {
  __typename?: 'SectionContentAditionalReferencesCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SectionContentCollection = {
  __typename?: 'SectionContentCollection';
  items: Array<Maybe<SectionContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SectionContentCursorCollection = {
  __typename?: 'SectionContentCursorCollection';
  items: Array<Maybe<SectionContent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SectionContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<SectionContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SectionContentFilter>>>;
  aditionalReferencesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image?: InputMaybe<CfFocalPointImageNestedFilter>;
  imageShape?: InputMaybe<Scalars['String']['input']>;
  imageShape_contains?: InputMaybe<Scalars['String']['input']>;
  imageShape_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageShape_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageShape_not?: InputMaybe<Scalars['String']['input']>;
  imageShape_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageShape_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  orientation_contains?: InputMaybe<Scalars['String']['input']>;
  orientation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  orientation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orientation_not?: InputMaybe<Scalars['String']['input']>;
  orientation_not_contains?: InputMaybe<Scalars['String']['input']>;
  orientation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  richTextContent_contains?: InputMaybe<Scalars['String']['input']>;
  richTextContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subTitle_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle_not?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SectionContentLinkingCollections = {
  __typename?: 'SectionContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  questionnaireCollection?: Maybe<QuestionnaireCollection>;
  questionnaireCursorCollection?: Maybe<QuestionnaireCursorCollection>;
};


export type SectionContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SectionContentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SectionContentLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SectionContentLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SectionContentLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SectionContentLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SectionContentLinkingCollectionsQuestionnaireCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentLinkingCollectionsQuestionnaireCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SectionContentLinkingCollectionsQuestionnaireCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SectionContentLinkingCollectionsQuestionnaireCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SectionContentLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SectionContentLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SectionContentLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SectionContentLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SectionContentLinkingCollectionsQuestionnaireCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SectionContentLinkingCollectionsQuestionnaireCursorCollectionOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'defaultErrorMessage_ASC'
  | 'defaultErrorMessage_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'text_ASC'
  | 'text_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SectionContentOrder =
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageShape_ASC'
  | 'imageShape_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'orientation_ASC'
  | 'orientation_DESC'
  | 'subTitle_ASC'
  | 'subTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type SectionContentRichTextContent = {
  __typename?: 'SectionContentRichTextContent';
  json: Scalars['JSON']['output'];
  links: SectionContentRichTextContentLinks;
};

export type SectionContentRichTextContentAssets = {
  __typename?: 'SectionContentRichTextContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SectionContentRichTextContentEntries = {
  __typename?: 'SectionContentRichTextContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SectionContentRichTextContentLinks = {
  __typename?: 'SectionContentRichTextContentLinks';
  assets: SectionContentRichTextContentAssets;
  entries: SectionContentRichTextContentEntries;
  resources: SectionContentRichTextContentResources;
};

export type SectionContentRichTextContentResources = {
  __typename?: 'SectionContentRichTextContentResources';
  block: Array<SectionContentRichTextContentResourcesBlock>;
  hyperlink: Array<SectionContentRichTextContentResourcesHyperlink>;
  inline: Array<SectionContentRichTextContentResourcesInline>;
};

export type SectionContentRichTextContentResourcesBlock = ResourceLink & {
  __typename?: 'SectionContentRichTextContentResourcesBlock';
  sys: ResourceSys;
};

export type SectionContentRichTextContentResourcesHyperlink = ResourceLink & {
  __typename?: 'SectionContentRichTextContentResourcesHyperlink';
  sys: ResourceSys;
};

export type SectionContentRichTextContentResourcesInline = ResourceLink & {
  __typename?: 'SectionContentRichTextContentResourcesInline';
  sys: ResourceSys;
};

/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainer = Entry & _Node & {
  __typename?: 'SegmentsContainer';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<SegmentsContainerContentsCollection>;
  contentsCursorCollection?: Maybe<SegmentsContainerContentsCursorCollection>;
  entryName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SegmentsContainerLinkingCollections>;
  sys: Sys;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SegmentsContainerContentsFilter>;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerContentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SegmentsContainerContentsFilter>;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerEntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** HeroV2, Service and HalfScreen are supported, but do not combine different templates in one SegmentsContainer [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/segmentsContainer) */
export type SegmentsContainerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SegmentsContainerCollection = {
  __typename?: 'SegmentsContainerCollection';
  items: Array<Maybe<SegmentsContainer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SegmentsContainerContentsCollection = {
  __typename?: 'SegmentsContainerContentsCollection';
  items: Array<Maybe<SegmentsContainerContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SegmentsContainerContentsCursorCollection = {
  __typename?: 'SegmentsContainerContentsCursorCollection';
  items: Array<Maybe<SegmentsContainerContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SegmentsContainerContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<SegmentsContainerContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SegmentsContainerContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SegmentsContainerContentsItem = ContentTypeRichText | DisclaimerV2 | HalfScreen | HeroV2 | Marquee | MultiCardV2 | OdpHero | ServiceLineHero | SingleMessage;

export type SegmentsContainerCursorCollection = {
  __typename?: 'SegmentsContainerCursorCollection';
  items: Array<Maybe<SegmentsContainer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SegmentsContainerFilter = {
  AND?: InputMaybe<Array<InputMaybe<SegmentsContainerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SegmentsContainerFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SegmentsContainerLinkingCollections = {
  __typename?: 'SegmentsContainerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type SegmentsContainerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SegmentsContainerLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SegmentsContainerLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SegmentsContainerLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SegmentsContainerLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SegmentsContainerLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SegmentsContainerOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type Service = Entry & _Node & {
  __typename?: 'Service';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonType?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<ServiceButtonsCollection>;
  buttonsCursorCollection?: Maybe<ServiceButtonsCursorCollection>;
  centerAlign?: Maybe<Scalars['Boolean']['output']>;
  contained?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
  imageLayout?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<ServiceLinkingCollections>;
  mediaType?: Maybe<Scalars['String']['output']>;
  mobileImage?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  richTextDescription?: Maybe<ServiceRichTextDescription>;
  sys: Sys;
  tc?: Maybe<TermsAndConditions>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Asset>;
  videoImage?: Maybe<Asset>;
  youTubeVideoId?: Maybe<Scalars['String']['output']>;
  youTubeVideoImage?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceCenterAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceContainedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceDirectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceImageLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceMediaTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceRichTextDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceTcArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceVideoImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceYouTubeVideoIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/service) */
export type ServiceYouTubeVideoImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceButtonsCollection = {
  __typename?: 'ServiceButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ServiceButtonsCursorCollection = {
  __typename?: 'ServiceButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ServiceCollection = {
  __typename?: 'ServiceCollection';
  items: Array<Maybe<Service>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceCursorCollection = {
  __typename?: 'ServiceCursorCollection';
  items: Array<Maybe<Service>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPage = Entry & _Node & {
  __typename?: 'ServiceDetailsPage';
  _id: Scalars['ID']['output'];
  analyticsContext?: Maybe<AnalyticsContext>;
  appName?: Maybe<Scalars['String']['output']>;
  bannerInPage?: Maybe<Banner>;
  canonical?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  contentsCollection?: Maybe<ServiceDetailsPageContentsCollection>;
  contentsCursorCollection?: Maybe<ServiceDetailsPageContentsCursorCollection>;
  description?: Maybe<Scalars['String']['output']>;
  disableHeaderBottomAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableHeaderTopAlertBanner?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  disableStickyFooterOnMobile?: Maybe<Scalars['Boolean']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  indexed?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ServiceDetailsPageLinkingCollections>;
  moreTextSeo?: Maybe<ServiceDetailsPageMoreTextSeo>;
  name?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<ImageAsset>;
  pageContentDataJson?: Maybe<Scalars['JSON']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  textSeo?: Maybe<ServiceDetailsPageTextSeo>;
  title?: Maybe<Scalars['String']['output']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageAnalyticsContextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnalyticsContextFilter>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageAppNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageBannerInPageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BannerFilter>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageCanonicalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageContentsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceDetailsPageContentsFilter>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageContentsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceDetailsPageContentsFilter>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDisableHeaderBottomAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDisableHeaderTopAlertBannerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDisableStickyFooterOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageDisableStickyFooterOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageFacilityIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageIndexedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageMoreTextSeoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageOgImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPagePageContentDataJsonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPagePathArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageTagsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageTextSeoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The content type used to define any Service Details for a brand. Example Dentures, Cosmetic Dentistry, Vaccination etc [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceDetailsPage) */
export type ServiceDetailsPageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceDetailsPageCollection = {
  __typename?: 'ServiceDetailsPageCollection';
  items: Array<Maybe<ServiceDetailsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceDetailsPageContentsCollection = {
  __typename?: 'ServiceDetailsPageContentsCollection';
  items: Array<Maybe<ServiceDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceDetailsPageContentsCursorCollection = {
  __typename?: 'ServiceDetailsPageContentsCursorCollection';
  items: Array<Maybe<ServiceDetailsPageContentsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceDetailsPageContentsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceDetailsPageContentsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceDetailsPageContentsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type ServiceDetailsPageContentsItem = Accordions | BirdEyeReviews | BlogList | CategoryPicker | Columns | ContentTypeRichText | DisclaimerV2 | GoogleMapTemplate | HalfScreen | HeroV2 | Marquee | MeetOurStaff | MultiCardV2 | OdpHero | PatientReviewsV2 | ProductDisplay | QuickLinks | Schema | SegmentsContainer | ServiceLineHero | SingleMessage | Spacer;

export type ServiceDetailsPageCursorCollection = {
  __typename?: 'ServiceDetailsPageCursorCollection';
  items: Array<Maybe<ServiceDetailsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceDetailsPageFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceDetailsPageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceDetailsPageFilter>>>;
  analyticsContext?: InputMaybe<CfAnalyticsContextNestedFilter>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appName_contains?: InputMaybe<Scalars['String']['input']>;
  appName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appName_not?: InputMaybe<Scalars['String']['input']>;
  appName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bannerInPage?: InputMaybe<CfBannerNestedFilter>;
  bannerInPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contents?: InputMaybe<CfcontentsMultiTypeNestedFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  facilityId_contains?: InputMaybe<Scalars['String']['input']>;
  facilityId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityId_not?: InputMaybe<Scalars['String']['input']>;
  facilityId_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  moreTextSeo_contains?: InputMaybe<Scalars['String']['input']>;
  moreTextSeo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreTextSeo_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage?: InputMaybe<CfImageAssetNestedFilter>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageContentDataJson_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textSeo_contains?: InputMaybe<Scalars['String']['input']>;
  textSeo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  textSeo_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceDetailsPageLinkingCollections = {
  __typename?: 'ServiceDetailsPageLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  navigationLinkCollection?: Maybe<NavigationLinkCollection>;
  navigationLinkCursorCollection?: Maybe<NavigationLinkCursorCollection>;
};


export type ServiceDetailsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceDetailsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceDetailsPageLinkingCollectionsNavigationLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceDetailsPageLinkingCollectionsNavigationLinkCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceDetailsPageLinkingCollectionsNavigationLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceDetailsPageLinkingCollectionsNavigationLinkCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceDetailsPageLinkingCollectionsNavigationLinkCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceDetailsPageLinkingCollectionsNavigationLinkCursorCollectionOrder =
  | 'externalUrl_ASC'
  | 'externalUrl_DESC'
  | 'isInternal_ASC'
  | 'isInternal_DESC'
  | 'isLocalized_ASC'
  | 'isLocalized_DESC'
  | 'linkText_ASC'
  | 'linkText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'openInNewTab_ASC'
  | 'openInNewTab_DESC'
  | 'openInNewWindow_ASC'
  | 'openInNewWindow_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceDetailsPageMoreTextSeo = {
  __typename?: 'ServiceDetailsPageMoreTextSeo';
  json: Scalars['JSON']['output'];
  links: ServiceDetailsPageMoreTextSeoLinks;
};

export type ServiceDetailsPageMoreTextSeoAssets = {
  __typename?: 'ServiceDetailsPageMoreTextSeoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceDetailsPageMoreTextSeoEntries = {
  __typename?: 'ServiceDetailsPageMoreTextSeoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceDetailsPageMoreTextSeoLinks = {
  __typename?: 'ServiceDetailsPageMoreTextSeoLinks';
  assets: ServiceDetailsPageMoreTextSeoAssets;
  entries: ServiceDetailsPageMoreTextSeoEntries;
  resources: ServiceDetailsPageMoreTextSeoResources;
};

export type ServiceDetailsPageMoreTextSeoResources = {
  __typename?: 'ServiceDetailsPageMoreTextSeoResources';
  block: Array<ServiceDetailsPageMoreTextSeoResourcesBlock>;
  hyperlink: Array<ServiceDetailsPageMoreTextSeoResourcesHyperlink>;
  inline: Array<ServiceDetailsPageMoreTextSeoResourcesInline>;
};

export type ServiceDetailsPageMoreTextSeoResourcesBlock = ResourceLink & {
  __typename?: 'ServiceDetailsPageMoreTextSeoResourcesBlock';
  sys: ResourceSys;
};

export type ServiceDetailsPageMoreTextSeoResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceDetailsPageMoreTextSeoResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceDetailsPageMoreTextSeoResourcesInline = ResourceLink & {
  __typename?: 'ServiceDetailsPageMoreTextSeoResourcesInline';
  sys: ResourceSys;
};

export type ServiceDetailsPageOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceDetailsPageTextSeo = {
  __typename?: 'ServiceDetailsPageTextSeo';
  json: Scalars['JSON']['output'];
  links: ServiceDetailsPageTextSeoLinks;
};

export type ServiceDetailsPageTextSeoAssets = {
  __typename?: 'ServiceDetailsPageTextSeoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceDetailsPageTextSeoEntries = {
  __typename?: 'ServiceDetailsPageTextSeoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceDetailsPageTextSeoLinks = {
  __typename?: 'ServiceDetailsPageTextSeoLinks';
  assets: ServiceDetailsPageTextSeoAssets;
  entries: ServiceDetailsPageTextSeoEntries;
  resources: ServiceDetailsPageTextSeoResources;
};

export type ServiceDetailsPageTextSeoResources = {
  __typename?: 'ServiceDetailsPageTextSeoResources';
  block: Array<ServiceDetailsPageTextSeoResourcesBlock>;
  hyperlink: Array<ServiceDetailsPageTextSeoResourcesHyperlink>;
  inline: Array<ServiceDetailsPageTextSeoResourcesInline>;
};

export type ServiceDetailsPageTextSeoResourcesBlock = ResourceLink & {
  __typename?: 'ServiceDetailsPageTextSeoResourcesBlock';
  sys: ResourceSys;
};

export type ServiceDetailsPageTextSeoResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceDetailsPageTextSeoResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceDetailsPageTextSeoResourcesInline = ResourceLink & {
  __typename?: 'ServiceDetailsPageTextSeoResourcesInline';
  sys: ResourceSys;
};

export type ServiceFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType?: InputMaybe<Scalars['String']['input']>;
  buttonType_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_not?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contained?: InputMaybe<Scalars['Boolean']['input']>;
  contained_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contained_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  direction_contains?: InputMaybe<Scalars['String']['input']>;
  direction_exists?: InputMaybe<Scalars['Boolean']['input']>;
  direction_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction_not?: InputMaybe<Scalars['String']['input']>;
  direction_not_contains?: InputMaybe<Scalars['String']['input']>;
  direction_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageLayout?: InputMaybe<Scalars['String']['input']>;
  imageLayout_contains?: InputMaybe<Scalars['String']['input']>;
  imageLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageLayout_not?: InputMaybe<Scalars['String']['input']>;
  imageLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  mediaType_contains?: InputMaybe<Scalars['String']['input']>;
  mediaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaType_not?: InputMaybe<Scalars['String']['input']>;
  mediaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  tc?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youTubeVideoId?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_contains?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youTubeVideoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeVideoId_not?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeVideoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceGroup) */
export type ServiceGroup = Entry & _Node & {
  __typename?: 'ServiceGroup';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ServiceGroupLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  servicesCollection?: Maybe<ServiceGroupServicesCollection>;
  servicesCursorCollection?: Maybe<ServiceGroupServicesCursorCollection>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceGroup) */
export type ServiceGroupDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceGroup) */
export type ServiceGroupFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceGroup) */
export type ServiceGroupLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceGroup) */
export type ServiceGroupNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceGroup) */
export type ServiceGroupServicesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceGroupServicesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceGroup) */
export type ServiceGroupServicesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceGroupServicesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceGroup) */
export type ServiceGroupTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceGroupCollection = {
  __typename?: 'ServiceGroupCollection';
  items: Array<Maybe<ServiceGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceGroupCursorCollection = {
  __typename?: 'ServiceGroupCursorCollection';
  items: Array<Maybe<ServiceGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceGroupFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceGroupFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceGroupFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  services?: InputMaybe<CfServiceNestedFilter>;
  servicesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceGroupLinkingCollections = {
  __typename?: 'ServiceGroupLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type ServiceGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceGroupLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceGroupLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceGroupLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceGroupLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceGroupLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceGroupLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceGroupLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceGroupLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceGroupLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ServiceGroupLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ServiceGroupLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceGroupLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceGroupOrder =
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceGroupServicesCollection = {
  __typename?: 'ServiceGroupServicesCollection';
  items: Array<Maybe<Service>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceGroupServicesCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type ServiceGroupServicesCursorCollection = {
  __typename?: 'ServiceGroupServicesCursorCollection';
  items: Array<Maybe<Service>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceGroupServicesCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHero = Entry & _Node & {
  __typename?: 'ServiceLineHero';
  _id: Scalars['ID']['output'];
  allowPatientInfoWidget?: Maybe<Scalars['Boolean']['output']>;
  allowScheduleTimes?: Maybe<Scalars['Boolean']['output']>;
  allowScheduleWidget?: Maybe<Scalars['Boolean']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundColorMobile?: Maybe<Scalars['String']['output']>;
  bodyCopy?: Maybe<ServiceLineHeroBodyCopy>;
  buttonCollection?: Maybe<ServiceLineHeroButtonCollection>;
  buttonCursorCollection?: Maybe<ServiceLineHeroButtonCursorCollection>;
  contentAlign?: Maybe<Scalars['String']['output']>;
  contentListBelowButtonsCollection?: Maybe<ServiceLineHeroContentListBelowButtonsCollection>;
  contentListBelowButtonsCursorCollection?: Maybe<ServiceLineHeroContentListBelowButtonsCursorCollection>;
  contentListCollection?: Maybe<ServiceLineHeroContentListCollection>;
  contentListCursorCollection?: Maybe<ServiceLineHeroContentListCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  display?: Maybe<Scalars['String']['output']>;
  displayOfficeHoursInModal?: Maybe<Scalars['Boolean']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  eyebrowHtag?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  focalPointImage?: Maybe<FocalPointImage>;
  googleMapsBusinessQuery?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<ServiceLineHeroHeadline>;
  hideHeroOnMobile?: Maybe<Scalars['Boolean']['output']>;
  imageAsset?: Maybe<ImageAsset>;
  imageWithBorderRadius?: Maybe<Scalars['Boolean']['output']>;
  imgDisplaysFirstOnDesktop?: Maybe<Scalars['Boolean']['output']>;
  imgDisplaysFirstOnMobile?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<ServiceLineHeroLinkingCollections>;
  mediaRoundedCornerSize?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  officeHoursLabel?: Maybe<Scalars['String']['output']>;
  schedulingImageAsset?: Maybe<ImageAsset>;
  servicesCollection?: Maybe<ServiceLineHeroServicesCollection>;
  servicesCursorCollection?: Maybe<ServiceLineHeroServicesCursorCollection>;
  showOfficeDetails?: Maybe<Scalars['Boolean']['output']>;
  subHeadline?: Maybe<ServiceLineHeroSubHeadline>;
  sys: Sys;
  templateWidth?: Maybe<Scalars['String']['output']>;
  termsConditions?: Maybe<TermsAndConditions>;
  variant?: Maybe<Scalars['String']['output']>;
  videoAsset?: Maybe<VideoAsset>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroAllowPatientInfoWidgetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroAllowScheduleTimesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroAllowScheduleWidgetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroBackgroundColorMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroBodyCopyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroButtonCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroButtonCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroContentAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroContentListBelowButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceLineHeroContentListBelowButtonsFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroContentListBelowButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceLineHeroContentListBelowButtonsFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroContentListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceLineHeroContentListFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroContentListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ServiceLineHeroContentListFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroDisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroDisplayOfficeHoursInModalArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroEyebrowHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroFocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroGoogleMapsBusinessQueryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroHideHeroOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroImageWithBorderRadiusArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroImgDisplaysFirstOnDesktopArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroImgDisplaysFirstOnMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroMediaRoundedCornerSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroOfficeHoursLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroSchedulingImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroServicesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroServicesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MedicalServiceFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroServicesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroServicesCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MedicalServiceFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroShowOfficeDetailsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroSubHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroTemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroTermsConditionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Hero for a service line, e.g Allergy, Urgent Care, OCC Med, etc. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/serviceLineHero) */
export type ServiceLineHeroVideoAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};

export type ServiceLineHeroBodyCopy = {
  __typename?: 'ServiceLineHeroBodyCopy';
  json: Scalars['JSON']['output'];
  links: ServiceLineHeroBodyCopyLinks;
};

export type ServiceLineHeroBodyCopyAssets = {
  __typename?: 'ServiceLineHeroBodyCopyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceLineHeroBodyCopyEntries = {
  __typename?: 'ServiceLineHeroBodyCopyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceLineHeroBodyCopyLinks = {
  __typename?: 'ServiceLineHeroBodyCopyLinks';
  assets: ServiceLineHeroBodyCopyAssets;
  entries: ServiceLineHeroBodyCopyEntries;
  resources: ServiceLineHeroBodyCopyResources;
};

export type ServiceLineHeroBodyCopyResources = {
  __typename?: 'ServiceLineHeroBodyCopyResources';
  block: Array<ServiceLineHeroBodyCopyResourcesBlock>;
  hyperlink: Array<ServiceLineHeroBodyCopyResourcesHyperlink>;
  inline: Array<ServiceLineHeroBodyCopyResourcesInline>;
};

export type ServiceLineHeroBodyCopyResourcesBlock = ResourceLink & {
  __typename?: 'ServiceLineHeroBodyCopyResourcesBlock';
  sys: ResourceSys;
};

export type ServiceLineHeroBodyCopyResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceLineHeroBodyCopyResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceLineHeroBodyCopyResourcesInline = ResourceLink & {
  __typename?: 'ServiceLineHeroBodyCopyResourcesInline';
  sys: ResourceSys;
};

export type ServiceLineHeroButtonCollection = {
  __typename?: 'ServiceLineHeroButtonCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroButtonCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ServiceLineHeroButtonCursorCollection = {
  __typename?: 'ServiceLineHeroButtonCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceLineHeroButtonCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ServiceLineHeroCollection = {
  __typename?: 'ServiceLineHeroCollection';
  items: Array<Maybe<ServiceLineHero>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroContentListBelowButtonsCollection = {
  __typename?: 'ServiceLineHeroContentListBelowButtonsCollection';
  items: Array<Maybe<ServiceLineHeroContentListBelowButtonsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroContentListBelowButtonsCursorCollection = {
  __typename?: 'ServiceLineHeroContentListBelowButtonsCursorCollection';
  items: Array<Maybe<ServiceLineHeroContentListBelowButtonsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceLineHeroContentListBelowButtonsFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceLineHeroContentListBelowButtonsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceLineHeroContentListBelowButtonsFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceLineHeroContentListBelowButtonsItem = ContentTypeRichText | SingleMessage;

export type ServiceLineHeroContentListCollection = {
  __typename?: 'ServiceLineHeroContentListCollection';
  items: Array<Maybe<ServiceLineHeroContentListItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroContentListCursorCollection = {
  __typename?: 'ServiceLineHeroContentListCursorCollection';
  items: Array<Maybe<ServiceLineHeroContentListItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceLineHeroContentListFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceLineHeroContentListFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceLineHeroContentListFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServiceLineHeroContentListItem = Accordions | ContentTypeRichText | SingleMessage | Table;

export type ServiceLineHeroCursorCollection = {
  __typename?: 'ServiceLineHeroCursorCollection';
  items: Array<Maybe<ServiceLineHero>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceLineHeroFilter = {
  AND?: InputMaybe<Array<InputMaybe<ServiceLineHeroFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ServiceLineHeroFilter>>>;
  allowPatientInfoWidget?: InputMaybe<Scalars['Boolean']['input']>;
  allowPatientInfoWidget_exists?: InputMaybe<Scalars['Boolean']['input']>;
  allowPatientInfoWidget_not?: InputMaybe<Scalars['Boolean']['input']>;
  allowScheduleTimes?: InputMaybe<Scalars['Boolean']['input']>;
  allowScheduleTimes_exists?: InputMaybe<Scalars['Boolean']['input']>;
  allowScheduleTimes_not?: InputMaybe<Scalars['Boolean']['input']>;
  allowScheduleWidget?: InputMaybe<Scalars['Boolean']['input']>;
  allowScheduleWidget_exists?: InputMaybe<Scalars['Boolean']['input']>;
  allowScheduleWidget_not?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColorMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColorMobile_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColorMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyCopy_contains?: InputMaybe<Scalars['String']['input']>;
  bodyCopy_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyCopy_not_contains?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<CfButtonNestedFilter>;
  buttonCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentList?: InputMaybe<CfcontentListMultiTypeNestedFilter>;
  contentListBelowButtons?: InputMaybe<CfcontentListBelowButtonsMultiTypeNestedFilter>;
  contentListBelowButtonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayOfficeHoursInModal?: InputMaybe<Scalars['Boolean']['input']>;
  displayOfficeHoursInModal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOfficeHoursInModal_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHtag_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  headline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  hideHeroOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeroOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeroOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageWithBorderRadius?: InputMaybe<Scalars['Boolean']['input']>;
  imageWithBorderRadius_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageWithBorderRadius_not?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imgDisplaysFirstOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  mediaRoundedCornerSize?: InputMaybe<Scalars['String']['input']>;
  mediaRoundedCornerSize_contains?: InputMaybe<Scalars['String']['input']>;
  mediaRoundedCornerSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaRoundedCornerSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaRoundedCornerSize_not?: InputMaybe<Scalars['String']['input']>;
  mediaRoundedCornerSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaRoundedCornerSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  officeHoursLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeHoursLabel_not?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeHoursLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingImageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  schedulingImageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  services?: InputMaybe<CfMedicalServiceNestedFilter>;
  servicesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficeDetails?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficeDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showOfficeDetails_not?: InputMaybe<Scalars['Boolean']['input']>;
  subHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  subHeadline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsConditions?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  termsConditions_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoAsset?: InputMaybe<CfVideoAssetNestedFilter>;
  videoAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLineHeroHeadline = {
  __typename?: 'ServiceLineHeroHeadline';
  json: Scalars['JSON']['output'];
  links: ServiceLineHeroHeadlineLinks;
};

export type ServiceLineHeroHeadlineAssets = {
  __typename?: 'ServiceLineHeroHeadlineAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceLineHeroHeadlineEntries = {
  __typename?: 'ServiceLineHeroHeadlineEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceLineHeroHeadlineLinks = {
  __typename?: 'ServiceLineHeroHeadlineLinks';
  assets: ServiceLineHeroHeadlineAssets;
  entries: ServiceLineHeroHeadlineEntries;
  resources: ServiceLineHeroHeadlineResources;
};

export type ServiceLineHeroHeadlineResources = {
  __typename?: 'ServiceLineHeroHeadlineResources';
  block: Array<ServiceLineHeroHeadlineResourcesBlock>;
  hyperlink: Array<ServiceLineHeroHeadlineResourcesHyperlink>;
  inline: Array<ServiceLineHeroHeadlineResourcesInline>;
};

export type ServiceLineHeroHeadlineResourcesBlock = ResourceLink & {
  __typename?: 'ServiceLineHeroHeadlineResourcesBlock';
  sys: ResourceSys;
};

export type ServiceLineHeroHeadlineResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceLineHeroHeadlineResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceLineHeroHeadlineResourcesInline = ResourceLink & {
  __typename?: 'ServiceLineHeroHeadlineResourcesInline';
  sys: ResourceSys;
};

export type ServiceLineHeroLinkingCollections = {
  __typename?: 'ServiceLineHeroLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type ServiceLineHeroLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLineHeroLinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLineHeroLinkingCollectionsTabCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLineHeroLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ServiceLineHeroLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ServiceLineHeroLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceLineHeroLinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceLineHeroLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroLinkingCollectionsTabCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceLineHeroLinkingCollectionsTabCursorCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceLineHeroOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type ServiceLineHeroServicesCollection = {
  __typename?: 'ServiceLineHeroServicesCollection';
  items: Array<Maybe<MedicalService>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ServiceLineHeroServicesCollectionOrder =
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroServicesCursorCollection = {
  __typename?: 'ServiceLineHeroServicesCursorCollection';
  items: Array<Maybe<MedicalService>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ServiceLineHeroServicesCursorCollectionOrder =
  | 'iconName_ASC'
  | 'iconName_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLineHeroSubHeadline = {
  __typename?: 'ServiceLineHeroSubHeadline';
  json: Scalars['JSON']['output'];
  links: ServiceLineHeroSubHeadlineLinks;
};

export type ServiceLineHeroSubHeadlineAssets = {
  __typename?: 'ServiceLineHeroSubHeadlineAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceLineHeroSubHeadlineEntries = {
  __typename?: 'ServiceLineHeroSubHeadlineEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceLineHeroSubHeadlineLinks = {
  __typename?: 'ServiceLineHeroSubHeadlineLinks';
  assets: ServiceLineHeroSubHeadlineAssets;
  entries: ServiceLineHeroSubHeadlineEntries;
  resources: ServiceLineHeroSubHeadlineResources;
};

export type ServiceLineHeroSubHeadlineResources = {
  __typename?: 'ServiceLineHeroSubHeadlineResources';
  block: Array<ServiceLineHeroSubHeadlineResourcesBlock>;
  hyperlink: Array<ServiceLineHeroSubHeadlineResourcesHyperlink>;
  inline: Array<ServiceLineHeroSubHeadlineResourcesInline>;
};

export type ServiceLineHeroSubHeadlineResourcesBlock = ResourceLink & {
  __typename?: 'ServiceLineHeroSubHeadlineResourcesBlock';
  sys: ResourceSys;
};

export type ServiceLineHeroSubHeadlineResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceLineHeroSubHeadlineResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceLineHeroSubHeadlineResourcesInline = ResourceLink & {
  __typename?: 'ServiceLineHeroSubHeadlineResourcesInline';
  sys: ResourceSys;
};

export type ServiceLinkingCollections = {
  __typename?: 'ServiceLinkingCollections';
  carouselCollection?: Maybe<CarouselCollection>;
  carouselCursorCollection?: Maybe<CarouselCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  serviceGroupCollection?: Maybe<ServiceGroupCollection>;
  serviceGroupCursorCollection?: Maybe<ServiceGroupCursorCollection>;
};


export type ServiceLinkingCollectionsCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsServiceGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsServiceGroupCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceLinkingCollectionsServiceGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<ServiceLinkingCollectionsServiceGroupCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLinkingCollectionsCarouselCollectionOrder =
  | 'arrowsColor_ASC'
  | 'arrowsColor_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRounded_ASC'
  | 'imageRounded_DESC'
  | 'imageWidth_ASC'
  | 'imageWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quotesColor_ASC'
  | 'quotesColor_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLinkingCollectionsCarouselCursorCollectionOrder =
  | 'arrowsColor_ASC'
  | 'arrowsColor_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRounded_ASC'
  | 'imageRounded_DESC'
  | 'imageWidth_ASC'
  | 'imageWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quotesColor_ASC'
  | 'quotesColor_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ServiceLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type ServiceLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceLinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type ServiceLinkingCollectionsServiceGroupCollectionOrder =
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceLinkingCollectionsServiceGroupCursorCollectionOrder =
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type ServiceOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type ServiceRichTextDescription = {
  __typename?: 'ServiceRichTextDescription';
  json: Scalars['JSON']['output'];
  links: ServiceRichTextDescriptionLinks;
};

export type ServiceRichTextDescriptionAssets = {
  __typename?: 'ServiceRichTextDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ServiceRichTextDescriptionEntries = {
  __typename?: 'ServiceRichTextDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ServiceRichTextDescriptionLinks = {
  __typename?: 'ServiceRichTextDescriptionLinks';
  assets: ServiceRichTextDescriptionAssets;
  entries: ServiceRichTextDescriptionEntries;
  resources: ServiceRichTextDescriptionResources;
};

export type ServiceRichTextDescriptionResources = {
  __typename?: 'ServiceRichTextDescriptionResources';
  block: Array<ServiceRichTextDescriptionResourcesBlock>;
  hyperlink: Array<ServiceRichTextDescriptionResourcesHyperlink>;
  inline: Array<ServiceRichTextDescriptionResourcesInline>;
};

export type ServiceRichTextDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ServiceRichTextDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ServiceRichTextDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ServiceRichTextDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ServiceRichTextDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ServiceRichTextDescriptionResourcesInline';
  sys: ResourceSys;
};

/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedForm = Entry & _Node & {
  __typename?: 'SharedForm';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  definitionsCollection?: Maybe<SharedFormDefinitionsCollection>;
  definitionsCursorCollection?: Maybe<SharedFormDefinitionsCursorCollection>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionColor?: Maybe<Scalars['String']['output']>;
  descriptionFont?: Maybe<Scalars['String']['output']>;
  formButtonPrimary?: Maybe<Scalars['String']['output']>;
  formButtonPrimaryUrl?: Maybe<Scalars['String']['output']>;
  formButtonSecondary?: Maybe<Scalars['String']['output']>;
  formButtonSecondaryUrl?: Maybe<Scalars['String']['output']>;
  formFieldsCollection?: Maybe<SharedFormFormFieldsCollection>;
  formFieldsCursorCollection?: Maybe<SharedFormFormFieldsCursorCollection>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SharedFormLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Scalars['String']['output']>;
  titleFont?: Maybe<Scalars['String']['output']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormDefinitionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormDefinitionsFilter>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormDefinitionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormDefinitionsFilter>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormDescriptionColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormDescriptionFontArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormFormButtonPrimaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormFormButtonPrimaryUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormFormButtonSecondaryArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormFormButtonSecondaryUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormFormFieldsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormFormFieldsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormFieldFilter>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormFormFieldsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormFormFieldsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormFieldFilter>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormTitleColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Form container for all form fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedForm) */
export type SharedFormTitleFontArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharedFormCollection = {
  __typename?: 'SharedFormCollection';
  items: Array<Maybe<SharedForm>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SharedFormCursorCollection = {
  __typename?: 'SharedFormCursorCollection';
  items: Array<Maybe<SharedForm>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitions = Entry & _Node & {
  __typename?: 'SharedFormDefinitions';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  createNewLine?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionFont?: Maybe<Scalars['String']['output']>;
  displayDefinition?: Maybe<Scalars['Boolean']['output']>;
  divider?: Maybe<Scalars['Boolean']['output']>;
  formFieldsCollection?: Maybe<SharedFormDefinitionsFormFieldsCollection>;
  formFieldsCursorCollection?: Maybe<SharedFormDefinitionsFormFieldsCursorCollection>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SharedFormDefinitionsLinkingCollections>;
  needLabel?: Maybe<Scalars['Boolean']['output']>;
  phoneSize?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  titleFont?: Maybe<Scalars['String']['output']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsCreateNewLineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsDescriptionFontArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsDisplayDefinitionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsDividerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsFormFieldsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsFormFieldsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormFieldFilter>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsFormFieldsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsFormFieldsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SharedFormFieldFilter>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsNeedLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsPhoneSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A section of the shared form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormDefinitions) */
export type SharedFormDefinitionsTitleFontArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharedFormDefinitionsCollection = {
  __typename?: 'SharedFormDefinitionsCollection';
  items: Array<Maybe<SharedFormDefinitions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SharedFormDefinitionsCollectionOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'displayDefinition_ASC'
  | 'displayDefinition_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'needLabel_ASC'
  | 'needLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormDefinitionsCursorCollection = {
  __typename?: 'SharedFormDefinitionsCursorCollection';
  items: Array<Maybe<SharedFormDefinitions>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SharedFormDefinitionsCursorCollectionOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'displayDefinition_ASC'
  | 'displayDefinition_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'needLabel_ASC'
  | 'needLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormDefinitionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  createNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  createNewLine_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createNewLine_not?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionFont?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionFont_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionFont_not?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayDefinition?: InputMaybe<Scalars['Boolean']['input']>;
  displayDefinition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayDefinition_not?: InputMaybe<Scalars['Boolean']['input']>;
  divider?: InputMaybe<Scalars['Boolean']['input']>;
  divider_exists?: InputMaybe<Scalars['Boolean']['input']>;
  divider_not?: InputMaybe<Scalars['Boolean']['input']>;
  formFields?: InputMaybe<CfSharedFormFieldNestedFilter>;
  formFieldsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  needLabel?: InputMaybe<Scalars['Boolean']['input']>;
  needLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSize?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSize_gt?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_gte?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  phoneSize_lt?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_lte?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_not?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  size?: InputMaybe<Scalars['Float']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  size_not?: InputMaybe<Scalars['Float']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleFont?: InputMaybe<Scalars['String']['input']>;
  titleFont_contains?: InputMaybe<Scalars['String']['input']>;
  titleFont_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleFont_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleFont_not?: InputMaybe<Scalars['String']['input']>;
  titleFont_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleFont_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SharedFormDefinitionsFormFieldsCollection = {
  __typename?: 'SharedFormDefinitionsFormFieldsCollection';
  items: Array<Maybe<SharedFormField>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SharedFormDefinitionsFormFieldsCollectionOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'field_ASC'
  | 'field_DESC'
  | 'format_ASC'
  | 'format_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'minLength_ASC'
  | 'minLength_DESC'
  | 'needOuterLabel_ASC'
  | 'needOuterLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'placeHolder_ASC'
  | 'placeHolder_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type SharedFormDefinitionsFormFieldsCursorCollection = {
  __typename?: 'SharedFormDefinitionsFormFieldsCursorCollection';
  items: Array<Maybe<SharedFormField>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SharedFormDefinitionsFormFieldsCursorCollectionOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'field_ASC'
  | 'field_DESC'
  | 'format_ASC'
  | 'format_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'minLength_ASC'
  | 'minLength_DESC'
  | 'needOuterLabel_ASC'
  | 'needOuterLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'placeHolder_ASC'
  | 'placeHolder_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type SharedFormDefinitionsLinkingCollections = {
  __typename?: 'SharedFormDefinitionsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  sharedFormCollection?: Maybe<SharedFormCollection>;
  sharedFormCursorCollection?: Maybe<SharedFormCursorCollection>;
};


export type SharedFormDefinitionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormDefinitionsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormDefinitionsLinkingCollectionsSharedFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsLinkingCollectionsSharedFormCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormDefinitionsLinkingCollectionsSharedFormCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormDefinitionsLinkingCollectionsSharedFormCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharedFormDefinitionsLinkingCollectionsSharedFormCollectionOrder =
  | 'descriptionColor_ASC'
  | 'descriptionColor_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'formButtonPrimaryURL_ASC'
  | 'formButtonPrimaryURL_DESC'
  | 'formButtonPrimary_ASC'
  | 'formButtonPrimary_DESC'
  | 'formButtonSecondaryURL_ASC'
  | 'formButtonSecondaryURL_DESC'
  | 'formButtonSecondary_ASC'
  | 'formButtonSecondary_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormDefinitionsLinkingCollectionsSharedFormCursorCollectionOrder =
  | 'descriptionColor_ASC'
  | 'descriptionColor_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'formButtonPrimaryURL_ASC'
  | 'formButtonPrimaryURL_DESC'
  | 'formButtonPrimary_ASC'
  | 'formButtonPrimary_DESC'
  | 'formButtonSecondaryURL_ASC'
  | 'formButtonSecondaryURL_DESC'
  | 'formButtonSecondary_ASC'
  | 'formButtonSecondary_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormDefinitionsOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'displayDefinition_ASC'
  | 'displayDefinition_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'needLabel_ASC'
  | 'needLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormField = Entry & _Node & {
  __typename?: 'SharedFormField';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  createNewLine?: Maybe<Scalars['Boolean']['output']>;
  default?: Maybe<Scalars['String']['output']>;
  dependency?: Maybe<Scalars['JSON']['output']>;
  divider?: Maybe<Scalars['Boolean']['output']>;
  enum?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  field?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SharedFormFieldLinkingCollections>;
  minLength?: Maybe<Scalars['Int']['output']>;
  needOuterLabel?: Maybe<Scalars['Boolean']['output']>;
  phoneSize?: Maybe<Scalars['Float']['output']>;
  placeHolder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldCreateNewLineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldDefaultArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldDependencyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldDividerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldEnumArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldFieldArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldFormatArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldItemsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldMinLengthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldNeedOuterLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldPhoneSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldPlaceHolderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldRequiredArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The actual field within the definition, within the form [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/sharedFormField) */
export type SharedFormFieldTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharedFormFieldCollection = {
  __typename?: 'SharedFormFieldCollection';
  items: Array<Maybe<SharedFormField>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SharedFormFieldCursorCollection = {
  __typename?: 'SharedFormFieldCursorCollection';
  items: Array<Maybe<SharedFormField>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SharedFormFieldFilter = {
  AND?: InputMaybe<Array<InputMaybe<SharedFormFieldFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SharedFormFieldFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  createNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  createNewLine_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createNewLine_not?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['String']['input']>;
  default_contains?: InputMaybe<Scalars['String']['input']>;
  default_exists?: InputMaybe<Scalars['Boolean']['input']>;
  default_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  default_not?: InputMaybe<Scalars['String']['input']>;
  default_not_contains?: InputMaybe<Scalars['String']['input']>;
  default_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dependency_exists?: InputMaybe<Scalars['Boolean']['input']>;
  divider?: InputMaybe<Scalars['Boolean']['input']>;
  divider_exists?: InputMaybe<Scalars['Boolean']['input']>;
  divider_not?: InputMaybe<Scalars['Boolean']['input']>;
  enum_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enum_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enum_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enum_exists?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  field_contains?: InputMaybe<Scalars['String']['input']>;
  field_exists?: InputMaybe<Scalars['Boolean']['input']>;
  field_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field_not?: InputMaybe<Scalars['String']['input']>;
  field_not_contains?: InputMaybe<Scalars['String']['input']>;
  field_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  format?: InputMaybe<Scalars['String']['input']>;
  format_contains?: InputMaybe<Scalars['String']['input']>;
  format_exists?: InputMaybe<Scalars['Boolean']['input']>;
  format_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  format_not?: InputMaybe<Scalars['String']['input']>;
  format_not_contains?: InputMaybe<Scalars['String']['input']>;
  format_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  minLength_exists?: InputMaybe<Scalars['Boolean']['input']>;
  minLength_gt?: InputMaybe<Scalars['Int']['input']>;
  minLength_gte?: InputMaybe<Scalars['Int']['input']>;
  minLength_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minLength_lt?: InputMaybe<Scalars['Int']['input']>;
  minLength_lte?: InputMaybe<Scalars['Int']['input']>;
  minLength_not?: InputMaybe<Scalars['Int']['input']>;
  minLength_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needOuterLabel?: InputMaybe<Scalars['Boolean']['input']>;
  needOuterLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needOuterLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSize?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSize_gt?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_gte?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  phoneSize_lt?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_lte?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_not?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  placeHolder?: InputMaybe<Scalars['String']['input']>;
  placeHolder_contains?: InputMaybe<Scalars['String']['input']>;
  placeHolder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  placeHolder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  placeHolder_not?: InputMaybe<Scalars['String']['input']>;
  placeHolder_not_contains?: InputMaybe<Scalars['String']['input']>;
  placeHolder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  required_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  size_not?: InputMaybe<Scalars['Float']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SharedFormFieldLinkingCollections = {
  __typename?: 'SharedFormFieldLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  sharedFormCollection?: Maybe<SharedFormCollection>;
  sharedFormCursorCollection?: Maybe<SharedFormCursorCollection>;
  sharedFormDefinitionsCollection?: Maybe<SharedFormDefinitionsCollection>;
  sharedFormDefinitionsCursorCollection?: Maybe<SharedFormDefinitionsCursorCollection>;
};


export type SharedFormFieldLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormFieldLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormFieldLinkingCollectionsSharedFormCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormFieldLinkingCollectionsSharedFormCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormFieldLinkingCollectionsSharedFormCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormFieldLinkingCollectionsSharedFormCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormFieldLinkingCollectionsSharedFormDefinitionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormFieldLinkingCollectionsSharedFormDefinitionsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormFieldLinkingCollectionsSharedFormDefinitionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormFieldLinkingCollectionsSharedFormDefinitionsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharedFormFieldLinkingCollectionsSharedFormCollectionOrder =
  | 'descriptionColor_ASC'
  | 'descriptionColor_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'formButtonPrimaryURL_ASC'
  | 'formButtonPrimaryURL_DESC'
  | 'formButtonPrimary_ASC'
  | 'formButtonPrimary_DESC'
  | 'formButtonSecondaryURL_ASC'
  | 'formButtonSecondaryURL_DESC'
  | 'formButtonSecondary_ASC'
  | 'formButtonSecondary_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormFieldLinkingCollectionsSharedFormCursorCollectionOrder =
  | 'descriptionColor_ASC'
  | 'descriptionColor_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'formButtonPrimaryURL_ASC'
  | 'formButtonPrimaryURL_DESC'
  | 'formButtonPrimary_ASC'
  | 'formButtonPrimary_DESC'
  | 'formButtonSecondaryURL_ASC'
  | 'formButtonSecondaryURL_DESC'
  | 'formButtonSecondary_ASC'
  | 'formButtonSecondary_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormFieldLinkingCollectionsSharedFormDefinitionsCollectionOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'displayDefinition_ASC'
  | 'displayDefinition_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'needLabel_ASC'
  | 'needLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormFieldLinkingCollectionsSharedFormDefinitionsCursorCollectionOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'displayDefinition_ASC'
  | 'displayDefinition_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'needLabel_ASC'
  | 'needLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormFieldOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'field_ASC'
  | 'field_DESC'
  | 'format_ASC'
  | 'format_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'minLength_ASC'
  | 'minLength_DESC'
  | 'needOuterLabel_ASC'
  | 'needOuterLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'placeHolder_ASC'
  | 'placeHolder_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type SharedFormFilter = {
  AND?: InputMaybe<Array<InputMaybe<SharedFormFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SharedFormFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  definitions?: InputMaybe<CfSharedFormDefinitionsNestedFilter>;
  definitionsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionColor?: InputMaybe<Scalars['String']['input']>;
  descriptionColor_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionColor_not?: InputMaybe<Scalars['String']['input']>;
  descriptionColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionFont?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionFont_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionFont_not?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formButtonPrimary?: InputMaybe<Scalars['String']['input']>;
  formButtonPrimaryURL?: InputMaybe<Scalars['String']['input']>;
  formButtonPrimaryURL_contains?: InputMaybe<Scalars['String']['input']>;
  formButtonPrimaryURL_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formButtonPrimaryURL_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formButtonPrimaryURL_not?: InputMaybe<Scalars['String']['input']>;
  formButtonPrimaryURL_not_contains?: InputMaybe<Scalars['String']['input']>;
  formButtonPrimaryURL_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formButtonPrimary_contains?: InputMaybe<Scalars['String']['input']>;
  formButtonPrimary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formButtonPrimary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formButtonPrimary_not?: InputMaybe<Scalars['String']['input']>;
  formButtonPrimary_not_contains?: InputMaybe<Scalars['String']['input']>;
  formButtonPrimary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formButtonSecondary?: InputMaybe<Scalars['String']['input']>;
  formButtonSecondaryURL?: InputMaybe<Scalars['String']['input']>;
  formButtonSecondaryURL_contains?: InputMaybe<Scalars['String']['input']>;
  formButtonSecondaryURL_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formButtonSecondaryURL_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formButtonSecondaryURL_not?: InputMaybe<Scalars['String']['input']>;
  formButtonSecondaryURL_not_contains?: InputMaybe<Scalars['String']['input']>;
  formButtonSecondaryURL_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formButtonSecondary_contains?: InputMaybe<Scalars['String']['input']>;
  formButtonSecondary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formButtonSecondary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formButtonSecondary_not?: InputMaybe<Scalars['String']['input']>;
  formButtonSecondary_not_contains?: InputMaybe<Scalars['String']['input']>;
  formButtonSecondary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formFields?: InputMaybe<CfSharedFormFieldNestedFilter>;
  formFieldsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleColor?: InputMaybe<Scalars['String']['input']>;
  titleColor_contains?: InputMaybe<Scalars['String']['input']>;
  titleColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleColor_not?: InputMaybe<Scalars['String']['input']>;
  titleColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleFont?: InputMaybe<Scalars['String']['input']>;
  titleFont_contains?: InputMaybe<Scalars['String']['input']>;
  titleFont_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleFont_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleFont_not?: InputMaybe<Scalars['String']['input']>;
  titleFont_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleFont_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SharedFormFormFieldsCollection = {
  __typename?: 'SharedFormFormFieldsCollection';
  items: Array<Maybe<SharedFormField>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SharedFormFormFieldsCollectionOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'field_ASC'
  | 'field_DESC'
  | 'format_ASC'
  | 'format_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'minLength_ASC'
  | 'minLength_DESC'
  | 'needOuterLabel_ASC'
  | 'needOuterLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'placeHolder_ASC'
  | 'placeHolder_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type SharedFormFormFieldsCursorCollection = {
  __typename?: 'SharedFormFormFieldsCursorCollection';
  items: Array<Maybe<SharedFormField>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SharedFormFormFieldsCursorCollectionOrder =
  | 'createNewLine_ASC'
  | 'createNewLine_DESC'
  | 'default_ASC'
  | 'default_DESC'
  | 'divider_ASC'
  | 'divider_DESC'
  | 'field_ASC'
  | 'field_DESC'
  | 'format_ASC'
  | 'format_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'minLength_ASC'
  | 'minLength_DESC'
  | 'needOuterLabel_ASC'
  | 'needOuterLabel_DESC'
  | 'phoneSize_ASC'
  | 'phoneSize_DESC'
  | 'placeHolder_ASC'
  | 'placeHolder_DESC'
  | 'required_ASC'
  | 'required_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'type_ASC'
  | 'type_DESC';

export type SharedFormLinkingCollections = {
  __typename?: 'SharedFormLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  stepperCollection?: Maybe<StepperCollection>;
  stepperCursorCollection?: Maybe<StepperCursorCollection>;
};


export type SharedFormLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormLinkingCollectionsStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormLinkingCollectionsStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SharedFormLinkingCollectionsStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SharedFormLinkingCollectionsStepperCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SharedFormLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SharedFormLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SharedFormLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SharedFormLinkingCollectionsStepperCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SharedFormLinkingCollectionsStepperCursorCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SharedFormOrder =
  | 'descriptionColor_ASC'
  | 'descriptionColor_DESC'
  | 'descriptionFont_ASC'
  | 'descriptionFont_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'formButtonPrimaryURL_ASC'
  | 'formButtonPrimaryURL_DESC'
  | 'formButtonPrimary_ASC'
  | 'formButtonPrimary_DESC'
  | 'formButtonSecondaryURL_ASC'
  | 'formButtonSecondaryURL_DESC'
  | 'formButtonSecondary_ASC'
  | 'formButtonSecondary_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleColor_ASC'
  | 'titleColor_DESC'
  | 'titleFont_ASC'
  | 'titleFont_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessage = Entry & _Node & {
  __typename?: 'SingleMessage';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonSize?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  buttonType?: Maybe<Scalars['String']['output']>;
  buttonUrl?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<SingleMessageButtonsCollection>;
  buttonsCursorCollection?: Maybe<SingleMessageButtonsCursorCollection>;
  content?: Maybe<SingleMessageContent>;
  contentAlign?: Maybe<Scalars['String']['output']>;
  contentFillVerticalSpace?: Maybe<Scalars['Boolean']['output']>;
  contentSmallScreen?: Maybe<SmallScreenContent>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  display?: Maybe<Scalars['String']['output']>;
  displayTitleInline?: Maybe<Scalars['Boolean']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  facilitySegmentCollection?: Maybe<Scalars['String']['output']>;
  focalPointImage?: Maybe<FocalPointImage>;
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iconSize?: Maybe<Scalars['String']['output']>;
  imageAsset?: Maybe<ImageAsset>;
  imageLeftSide?: Maybe<ImageAsset>;
  imageRightSide?: Maybe<ImageAsset>;
  isBannerImage?: Maybe<Scalars['Boolean']['output']>;
  isHeaderAboveSideImages?: Maybe<Scalars['Boolean']['output']>;
  isInlineLayout?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<SingleMessageLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  showSubscriptionForm?: Maybe<Scalars['Boolean']['output']>;
  subText?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tc?: Maybe<TermsAndConditions>;
  templateHeight?: Maybe<Scalars['String']['output']>;
  templateWidth?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleAlign?: Maybe<Scalars['String']['output']>;
  titleVariant?: Maybe<Scalars['String']['output']>;
  useRoundedCorners?: Maybe<Scalars['Boolean']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageContentAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageContentFillVerticalSpaceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageContentSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SmallScreenContentFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageDisplayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageDisplayTitleInlineArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageEyebrowArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageFacilitySegmentCollectionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageFocalPointImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageFullWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIconSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageImageAssetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageImageLeftSideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageImageRightSideArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIsBannerImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIsHeaderAboveSideImagesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageIsInlineLayoutArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageShowSubscriptionFormArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageSubTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTcArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TermsAndConditionsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTemplateHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTemplateWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTitleAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageTitleVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageUseRoundedCornersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/singleMessage) */
export type SingleMessageVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SingleMessageButtonsCollection = {
  __typename?: 'SingleMessageButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SingleMessageButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SingleMessageButtonsCursorCollection = {
  __typename?: 'SingleMessageButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SingleMessageButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SingleMessageCollection = {
  __typename?: 'SingleMessageCollection';
  items: Array<Maybe<SingleMessage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SingleMessageContent = {
  __typename?: 'SingleMessageContent';
  json: Scalars['JSON']['output'];
  links: SingleMessageContentLinks;
};

export type SingleMessageContentAssets = {
  __typename?: 'SingleMessageContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SingleMessageContentEntries = {
  __typename?: 'SingleMessageContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SingleMessageContentLinks = {
  __typename?: 'SingleMessageContentLinks';
  assets: SingleMessageContentAssets;
  entries: SingleMessageContentEntries;
  resources: SingleMessageContentResources;
};

export type SingleMessageContentResources = {
  __typename?: 'SingleMessageContentResources';
  block: Array<SingleMessageContentResourcesBlock>;
  hyperlink: Array<SingleMessageContentResourcesHyperlink>;
  inline: Array<SingleMessageContentResourcesInline>;
};

export type SingleMessageContentResourcesBlock = ResourceLink & {
  __typename?: 'SingleMessageContentResourcesBlock';
  sys: ResourceSys;
};

export type SingleMessageContentResourcesHyperlink = ResourceLink & {
  __typename?: 'SingleMessageContentResourcesHyperlink';
  sys: ResourceSys;
};

export type SingleMessageContentResourcesInline = ResourceLink & {
  __typename?: 'SingleMessageContentResourcesInline';
  sys: ResourceSys;
};

export type SingleMessageCursorCollection = {
  __typename?: 'SingleMessageCursorCollection';
  items: Array<Maybe<SingleMessage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SingleMessageFilter = {
  AND?: InputMaybe<Array<InputMaybe<SingleMessageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SingleMessageFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize?: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType?: InputMaybe<Scalars['String']['input']>;
  buttonType_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_not?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFillVerticalSpace?: InputMaybe<Scalars['Boolean']['input']>;
  contentFillVerticalSpace_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentFillVerticalSpace_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentSmallScreen?: InputMaybe<CfSmallScreenContentNestedFilter>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconSize?: InputMaybe<Scalars['String']['input']>;
  iconSize_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize_not?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset?: InputMaybe<CfImageAssetNestedFilter>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageLeftSide?: InputMaybe<CfImageAssetNestedFilter>;
  imageLeftSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRightSide?: InputMaybe<CfImageAssetNestedFilter>;
  imageRightSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages_not?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showSubscriptionForm?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriptionForm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriptionForm_not?: InputMaybe<Scalars['Boolean']['input']>;
  subText?: InputMaybe<Scalars['String']['input']>;
  subText_contains?: InputMaybe<Scalars['String']['input']>;
  subText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText_not?: InputMaybe<Scalars['String']['input']>;
  subText_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tc?: InputMaybe<CfTermsAndConditionsNestedFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateHeight?: InputMaybe<Scalars['String']['input']>;
  templateHeight_contains?: InputMaybe<Scalars['String']['input']>;
  templateHeight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateHeight_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateHeight_not?: InputMaybe<Scalars['String']['input']>;
  templateHeight_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateHeight_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAlign?: InputMaybe<Scalars['String']['input']>;
  titleAlign_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleAlign_not?: InputMaybe<Scalars['String']['input']>;
  titleAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant?: InputMaybe<Scalars['String']['input']>;
  titleVariant_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant_not?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useRoundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  useRoundedCorners_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useRoundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SingleMessageLinkingCollections = {
  __typename?: 'SingleMessageLinkingCollections';
  appointmentBookingPageCollection?: Maybe<AppointmentBookingPageCollection>;
  appointmentBookingPageCursorCollection?: Maybe<AppointmentBookingPageCursorCollection>;
  blogDetailsPageCollection?: Maybe<BlogDetailsPageCollection>;
  blogDetailsPageCursorCollection?: Maybe<BlogDetailsPageCursorCollection>;
  blogListPageCollection?: Maybe<BlogListPageCollection>;
  blogListPageCursorCollection?: Maybe<BlogListPageCursorCollection>;
  carouselCollection?: Maybe<CarouselCollection>;
  carouselCursorCollection?: Maybe<CarouselCursorCollection>;
  columnsCollection?: Maybe<ColumnsCollection>;
  columnsCursorCollection?: Maybe<ColumnsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  segmentsContainerCollection?: Maybe<SegmentsContainerCollection>;
  segmentsContainerCursorCollection?: Maybe<SegmentsContainerCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
  tabCollection?: Maybe<TabCollection>;
  tabCursorCollection?: Maybe<TabCursorCollection>;
};


export type SingleMessageLinkingCollectionsAppointmentBookingPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsAppointmentBookingPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsAppointmentBookingPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsAppointmentBookingPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsBlogDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsBlogDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsBlogDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsBlogDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsBlogListPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsBlogListPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsBlogListPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsBlogListPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsColumnsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsSegmentsContainerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsSegmentsContainerCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsSegmentsContainerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsSegmentsContainerCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsTabCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsTabCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SingleMessageLinkingCollectionsTabCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SingleMessageLinkingCollectionsTabCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SingleMessageLinkingCollectionsAppointmentBookingPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'enableBirdEyeChatBot_ASC'
  | 'enableBirdEyeChatBot_DESC'
  | 'enableFraudCheck_ASC'
  | 'enableFraudCheck_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsAppointmentBookingPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'enableBirdEyeChatBot_ASC'
  | 'enableBirdEyeChatBot_DESC'
  | 'enableFraudCheck_ASC'
  | 'enableFraudCheck_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsBlogDetailsPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsBlogDetailsPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'heroBackgroundColor_ASC'
  | 'heroBackgroundColor_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageDesignType_ASC'
  | 'pageDesignType_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'theme_ASC'
  | 'theme_DESC'
  | 'timeToRead_ASC'
  | 'timeToRead_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsBlogListPageCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SingleMessageLinkingCollectionsBlogListPageCursorCollectionOrder =
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'shouldDisplayCategoryFilterChips_ASC'
  | 'shouldDisplayCategoryFilterChips_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SingleMessageLinkingCollectionsCarouselCollectionOrder =
  | 'arrowsColor_ASC'
  | 'arrowsColor_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRounded_ASC'
  | 'imageRounded_DESC'
  | 'imageWidth_ASC'
  | 'imageWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quotesColor_ASC'
  | 'quotesColor_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsCarouselCursorCollectionOrder =
  | 'arrowsColor_ASC'
  | 'arrowsColor_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRounded_ASC'
  | 'imageRounded_DESC'
  | 'imageWidth_ASC'
  | 'imageWidth_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quotesColor_ASC'
  | 'quotesColor_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsColumnsCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsColumnsCursorCollectionOrder =
  | 'allowEqualHeights_ASC'
  | 'allowEqualHeights_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'mobileDisplayAccordion_ASC'
  | 'mobileDisplayAccordion_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SingleMessageLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SingleMessageLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SingleMessageLinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SingleMessageLinkingCollectionsSegmentsContainerCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SingleMessageLinkingCollectionsSegmentsContainerCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SingleMessageLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SingleMessageLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SingleMessageLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SingleMessageLinkingCollectionsTabCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SingleMessageLinkingCollectionsTabCursorCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SingleMessageOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContent = Entry & _Node & {
  __typename?: 'SmallScreenContent';
  _id: Scalars['ID']['output'];
  bodySmallScreen?: Maybe<SmallScreenContentBodySmallScreen>;
  contentfulMetadata: ContentfulMetadata;
  controllableVideo?: Maybe<Video>;
  entryName?: Maybe<Scalars['String']['output']>;
  eyebrowSmallScreen?: Maybe<Scalars['String']['output']>;
  focalPointImageSmallScreen?: Maybe<FocalPointImage>;
  headingSmallScreen?: Maybe<SmallScreenContentHeadingSmallScreen>;
  imageSmallScreen?: Maybe<Asset>;
  linkedFrom?: Maybe<SmallScreenContentLinkingCollections>;
  mediaFirst?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  videoSmallScreen?: Maybe<Asset>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentBodySmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentControllableVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentEntryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentEyebrowSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentFocalPointImageSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FocalPointImageFilter>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentHeadingSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentImageSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentMediaFirstArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Component for small screen content fields. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smallScreenContent) */
export type SmallScreenContentVideoSmallScreenArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmallScreenContentBodySmallScreen = {
  __typename?: 'SmallScreenContentBodySmallScreen';
  json: Scalars['JSON']['output'];
  links: SmallScreenContentBodySmallScreenLinks;
};

export type SmallScreenContentBodySmallScreenAssets = {
  __typename?: 'SmallScreenContentBodySmallScreenAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SmallScreenContentBodySmallScreenEntries = {
  __typename?: 'SmallScreenContentBodySmallScreenEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SmallScreenContentBodySmallScreenLinks = {
  __typename?: 'SmallScreenContentBodySmallScreenLinks';
  assets: SmallScreenContentBodySmallScreenAssets;
  entries: SmallScreenContentBodySmallScreenEntries;
  resources: SmallScreenContentBodySmallScreenResources;
};

export type SmallScreenContentBodySmallScreenResources = {
  __typename?: 'SmallScreenContentBodySmallScreenResources';
  block: Array<SmallScreenContentBodySmallScreenResourcesBlock>;
  hyperlink: Array<SmallScreenContentBodySmallScreenResourcesHyperlink>;
  inline: Array<SmallScreenContentBodySmallScreenResourcesInline>;
};

export type SmallScreenContentBodySmallScreenResourcesBlock = ResourceLink & {
  __typename?: 'SmallScreenContentBodySmallScreenResourcesBlock';
  sys: ResourceSys;
};

export type SmallScreenContentBodySmallScreenResourcesHyperlink = ResourceLink & {
  __typename?: 'SmallScreenContentBodySmallScreenResourcesHyperlink';
  sys: ResourceSys;
};

export type SmallScreenContentBodySmallScreenResourcesInline = ResourceLink & {
  __typename?: 'SmallScreenContentBodySmallScreenResourcesInline';
  sys: ResourceSys;
};

export type SmallScreenContentCollection = {
  __typename?: 'SmallScreenContentCollection';
  items: Array<Maybe<SmallScreenContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SmallScreenContentCursorCollection = {
  __typename?: 'SmallScreenContentCursorCollection';
  items: Array<Maybe<SmallScreenContent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SmallScreenContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<SmallScreenContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SmallScreenContentFilter>>>;
  bodySmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  bodySmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodySmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  controllableVideo?: InputMaybe<CfVideoNestedFilter>;
  controllableVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreen?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImageSmallScreen?: InputMaybe<CfFocalPointImageNestedFilter>;
  focalPointImageSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  headingSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  videoSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmallScreenContentHeadingSmallScreen = {
  __typename?: 'SmallScreenContentHeadingSmallScreen';
  json: Scalars['JSON']['output'];
  links: SmallScreenContentHeadingSmallScreenLinks;
};

export type SmallScreenContentHeadingSmallScreenAssets = {
  __typename?: 'SmallScreenContentHeadingSmallScreenAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SmallScreenContentHeadingSmallScreenEntries = {
  __typename?: 'SmallScreenContentHeadingSmallScreenEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SmallScreenContentHeadingSmallScreenLinks = {
  __typename?: 'SmallScreenContentHeadingSmallScreenLinks';
  assets: SmallScreenContentHeadingSmallScreenAssets;
  entries: SmallScreenContentHeadingSmallScreenEntries;
  resources: SmallScreenContentHeadingSmallScreenResources;
};

export type SmallScreenContentHeadingSmallScreenResources = {
  __typename?: 'SmallScreenContentHeadingSmallScreenResources';
  block: Array<SmallScreenContentHeadingSmallScreenResourcesBlock>;
  hyperlink: Array<SmallScreenContentHeadingSmallScreenResourcesHyperlink>;
  inline: Array<SmallScreenContentHeadingSmallScreenResourcesInline>;
};

export type SmallScreenContentHeadingSmallScreenResourcesBlock = ResourceLink & {
  __typename?: 'SmallScreenContentHeadingSmallScreenResourcesBlock';
  sys: ResourceSys;
};

export type SmallScreenContentHeadingSmallScreenResourcesHyperlink = ResourceLink & {
  __typename?: 'SmallScreenContentHeadingSmallScreenResourcesHyperlink';
  sys: ResourceSys;
};

export type SmallScreenContentHeadingSmallScreenResourcesInline = ResourceLink & {
  __typename?: 'SmallScreenContentHeadingSmallScreenResourcesInline';
  sys: ResourceSys;
};

export type SmallScreenContentLinkingCollections = {
  __typename?: 'SmallScreenContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  odpHeroCollection?: Maybe<OdpHeroCollection>;
  odpHeroCursorCollection?: Maybe<OdpHeroCursorCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  singleMessageCursorCollection?: Maybe<SingleMessageCursorCollection>;
};


export type SmallScreenContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsHalfScreenCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsHeroV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsOdpHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsOdpHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsOdpHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsOdpHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmallScreenContentLinkingCollectionsSingleMessageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmallScreenContentLinkingCollectionsSingleMessageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmallScreenContentLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SmallScreenContentLinkingCollectionsHalfScreenCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SmallScreenContentLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SmallScreenContentLinkingCollectionsHeroV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SmallScreenContentLinkingCollectionsOdpHeroCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SmallScreenContentLinkingCollectionsOdpHeroCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'appointmentDataSource_ASC'
  | 'appointmentDataSource_DESC'
  | 'callCenterLabel_ASC'
  | 'callCenterLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'promoTitle_ASC'
  | 'promoTitle_DESC'
  | 'showAddress_ASC'
  | 'showAddress_DESC'
  | 'showEmail_ASC'
  | 'showEmail_DESC'
  | 'showFax_ASC'
  | 'showFax_DESC'
  | 'showHours_ASC'
  | 'showHours_DESC'
  | 'showLocationStatusBadge_ASC'
  | 'showLocationStatusBadge_DESC'
  | 'showPhoneNumber_ASC'
  | 'showPhoneNumber_DESC'
  | 'showReviews_ASC'
  | 'showReviews_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SmallScreenContentLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SmallScreenContentLinkingCollectionsSingleMessageCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type SmallScreenContentOrder =
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowSmallScreen_ASC'
  | 'eyebrowSmallScreen_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smileAssessmentForm) */
export type SmileAssessmentForm = Entry & _Node & {
  __typename?: 'SmileAssessmentForm';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  formContent?: Maybe<Questionnaire>;
  linkedFrom?: Maybe<SmileAssessmentFormLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smileAssessmentForm) */
export type SmileAssessmentFormFormContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionnaireFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smileAssessmentForm) */
export type SmileAssessmentFormLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/smileAssessmentForm) */
export type SmileAssessmentFormNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmileAssessmentFormCollection = {
  __typename?: 'SmileAssessmentFormCollection';
  items: Array<Maybe<SmileAssessmentForm>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SmileAssessmentFormCursorCollection = {
  __typename?: 'SmileAssessmentFormCursorCollection';
  items: Array<Maybe<SmileAssessmentForm>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SmileAssessmentFormFilter = {
  AND?: InputMaybe<Array<InputMaybe<SmileAssessmentFormFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SmileAssessmentFormFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  formContent?: InputMaybe<CfQuestionnaireNestedFilter>;
  formContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SmileAssessmentFormLinkingCollections = {
  __typename?: 'SmileAssessmentFormLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type SmileAssessmentFormLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmileAssessmentFormLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmileAssessmentFormLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmileAssessmentFormLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmileAssessmentFormLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmileAssessmentFormLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmileAssessmentFormLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmileAssessmentFormLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SmileAssessmentFormLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SmileAssessmentFormLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmileAssessmentFormLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SmileAssessmentFormLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SmileAssessmentFormLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SmileAssessmentFormLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SmileAssessmentFormOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type Spacer = Entry & _Node & {
  __typename?: 'Spacer';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<SpacerLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A spacer component to create empty spaces between other templates and to serve as anchor to scroll to [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/spacer) */
export type SpacerSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpacerCollection = {
  __typename?: 'SpacerCollection';
  items: Array<Maybe<Spacer>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SpacerCursorCollection = {
  __typename?: 'SpacerCursorCollection';
  items: Array<Maybe<Spacer>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SpacerFilter = {
  AND?: InputMaybe<Array<InputMaybe<SpacerFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SpacerFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  color_contains?: InputMaybe<Scalars['String']['input']>;
  color_exists?: InputMaybe<Scalars['Boolean']['input']>;
  color_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  color_not?: InputMaybe<Scalars['String']['input']>;
  color_not_contains?: InputMaybe<Scalars['String']['input']>;
  color_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SpacerLinkingCollections = {
  __typename?: 'SpacerLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
  serviceDetailsPageCollection?: Maybe<ServiceDetailsPageCollection>;
  serviceDetailsPageCursorCollection?: Maybe<ServiceDetailsPageCursorCollection>;
};


export type SpacerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsServiceDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsServiceDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpacerLinkingCollectionsServiceDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SpacerLinkingCollectionsServiceDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpacerLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SpacerLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type SpacerLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SpacerLinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SpacerLinkingCollectionsServiceDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerLinkingCollectionsServiceDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type SpacerOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'color_ASC'
  | 'color_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** A container component for state links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stateLinks) */
export type StateLinks = Entry & _Node & {
  __typename?: 'StateLinks';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<StateLinksLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** A container component for state links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stateLinks) */
export type StateLinksLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A container component for state links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stateLinks) */
export type StateLinksNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A container component for state links (ODP) [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stateLinks) */
export type StateLinksSectionTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateLinksCollection = {
  __typename?: 'StateLinksCollection';
  items: Array<Maybe<StateLinks>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StateLinksCursorCollection = {
  __typename?: 'StateLinksCursorCollection';
  items: Array<Maybe<StateLinks>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type StateLinksFilter = {
  AND?: InputMaybe<Array<InputMaybe<StateLinksFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StateLinksFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type StateLinksLinkingCollections = {
  __typename?: 'StateLinksLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type StateLinksLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StateLinksLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StateLinksLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StateLinksLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StateLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StateLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StateLinksLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StateLinksLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StateLinksLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StateLinksLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateLinksLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type StateLinksLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type StateLinksLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type StateLinksLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type StateLinksOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sectionTitle_ASC'
  | 'sectionTitle_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type Stepper = Entry & _Node & {
  __typename?: 'Stepper';
  _id: Scalars['ID']['output'];
  confirmButtonText?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  continueButtonText?: Maybe<Scalars['String']['output']>;
  headingScheduledText?: Maybe<Scalars['String']['output']>;
  headingText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<StepperLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  needAssistanceText?: Maybe<Scalars['String']['output']>;
  stepLabels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stepsCollection?: Maybe<StepperStepsCollection>;
  stepsCursorCollection?: Maybe<StepperStepsCursorCollection>;
  sys: Sys;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperConfirmButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperContinueButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperHeadingScheduledTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperHeadingTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperNeedAssistanceTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperStepLabelsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperStepsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StepperStepsFilter>;
};


/** NOTE: only for Scheduling, not ready for general consumption [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/stepper) */
export type StepperStepsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StepperStepsFilter>;
};

export type StepperCollection = {
  __typename?: 'StepperCollection';
  items: Array<Maybe<Stepper>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StepperCursorCollection = {
  __typename?: 'StepperCursorCollection';
  items: Array<Maybe<Stepper>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type StepperFilter = {
  AND?: InputMaybe<Array<InputMaybe<StepperFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StepperFilter>>>;
  confirmButtonText?: InputMaybe<Scalars['String']['input']>;
  confirmButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  confirmButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmButtonText_not?: InputMaybe<Scalars['String']['input']>;
  confirmButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  continueButtonText?: InputMaybe<Scalars['String']['input']>;
  continueButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  continueButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  continueButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  continueButtonText_not?: InputMaybe<Scalars['String']['input']>;
  continueButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  continueButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingScheduledText?: InputMaybe<Scalars['String']['input']>;
  headingScheduledText_contains?: InputMaybe<Scalars['String']['input']>;
  headingScheduledText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingScheduledText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingScheduledText_not?: InputMaybe<Scalars['String']['input']>;
  headingScheduledText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingScheduledText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingText?: InputMaybe<Scalars['String']['input']>;
  headingText_contains?: InputMaybe<Scalars['String']['input']>;
  headingText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headingText_not?: InputMaybe<Scalars['String']['input']>;
  headingText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headingText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  needAssistanceText?: InputMaybe<Scalars['String']['input']>;
  needAssistanceText_contains?: InputMaybe<Scalars['String']['input']>;
  needAssistanceText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needAssistanceText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  needAssistanceText_not?: InputMaybe<Scalars['String']['input']>;
  needAssistanceText_not_contains?: InputMaybe<Scalars['String']['input']>;
  needAssistanceText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepLabels_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepLabels_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepLabels_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepLabels_exists?: InputMaybe<Scalars['Boolean']['input']>;
  steps?: InputMaybe<CfstepsMultiTypeNestedFilter>;
  stepsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type StepperLinkingCollections = {
  __typename?: 'StepperLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  stepperCollection?: Maybe<StepperCollection>;
  stepperCursorCollection?: Maybe<StepperCursorCollection>;
};


export type StepperLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StepperLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StepperLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StepperLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StepperLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StepperLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StepperLinkingCollectionsStepperCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperLinkingCollectionsStepperCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StepperLinkingCollectionsStepperCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<StepperLinkingCollectionsStepperCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StepperLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type StepperLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type StepperLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type StepperLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type StepperLinkingCollectionsStepperCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type StepperLinkingCollectionsStepperCursorCollectionOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type StepperOrder =
  | 'confirmButtonText_ASC'
  | 'confirmButtonText_DESC'
  | 'continueButtonText_ASC'
  | 'continueButtonText_DESC'
  | 'headingScheduledText_ASC'
  | 'headingScheduledText_DESC'
  | 'headingText_ASC'
  | 'headingText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'needAssistanceText_ASC'
  | 'needAssistanceText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type StepperStepsCollection = {
  __typename?: 'StepperStepsCollection';
  items: Array<Maybe<StepperStepsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StepperStepsCursorCollection = {
  __typename?: 'StepperStepsCursorCollection';
  items: Array<Maybe<StepperStepsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type StepperStepsFilter = {
  AND?: InputMaybe<Array<InputMaybe<StepperStepsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StepperStepsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type StepperStepsItem = ConfirmationStep | ReviewStep | SchemaStep | SharedForm | Stepper;

/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCard = Entry & _Node & {
  __typename?: 'SuccessCard';
  _id: Scalars['ID']['output'];
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  cardImage?: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  descriptionText?: Maybe<Scalars['String']['output']>;
  imageAltText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<SuccessCardLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  titleText?: Maybe<Scalars['String']['output']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardButtonLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardCardImageArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardDescriptionTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardImageAltTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A card that is displayed at the bottom of the confirmation page [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/successCard) */
export type SuccessCardTitleTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuccessCardCollection = {
  __typename?: 'SuccessCardCollection';
  items: Array<Maybe<SuccessCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SuccessCardCursorCollection = {
  __typename?: 'SuccessCardCursorCollection';
  items: Array<Maybe<SuccessCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SuccessCardFilter = {
  AND?: InputMaybe<Array<InputMaybe<SuccessCardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SuccessCardFilter>>>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionText_not?: InputMaybe<Scalars['String']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAltText?: InputMaybe<Scalars['String']['input']>;
  imageAltText_contains?: InputMaybe<Scalars['String']['input']>;
  imageAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAltText_not?: InputMaybe<Scalars['String']['input']>;
  imageAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  titleText?: InputMaybe<Scalars['String']['input']>;
  titleText_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleText_not?: InputMaybe<Scalars['String']['input']>;
  titleText_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SuccessCardLinkingCollections = {
  __typename?: 'SuccessCardLinkingCollections';
  confirmationStepCollection?: Maybe<ConfirmationStepCollection>;
  confirmationStepCursorCollection?: Maybe<ConfirmationStepCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type SuccessCardLinkingCollectionsConfirmationStepCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SuccessCardLinkingCollectionsConfirmationStepCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SuccessCardLinkingCollectionsConfirmationStepCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<SuccessCardLinkingCollectionsConfirmationStepCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SuccessCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SuccessCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuccessCardLinkingCollectionsConfirmationStepCollectionOrder =
  | 'accountNumberText_ASC'
  | 'accountNumberText_DESC'
  | 'cardInfoText_ASC'
  | 'cardInfoText_DESC'
  | 'confirmationPageName_ASC'
  | 'confirmationPageName_DESC'
  | 'copyTextButtonText_ASC'
  | 'copyTextButtonText_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SuccessCardLinkingCollectionsConfirmationStepCursorCollectionOrder =
  | 'accountNumberText_ASC'
  | 'accountNumberText_DESC'
  | 'cardInfoText_ASC'
  | 'cardInfoText_DESC'
  | 'confirmationPageName_ASC'
  | 'confirmationPageName_DESC'
  | 'copyTextButtonText_ASC'
  | 'copyTextButtonText_DESC'
  | 'stepNumber_ASC'
  | 'stepNumber_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type SuccessCardOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'imageAltText_ASC'
  | 'imageAltText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleText_ASC'
  | 'titleText_DESC';

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type Tab = Entry & _Node & {
  __typename?: 'Tab';
  _id: Scalars['ID']['output'];
  content?: Maybe<TabContent>;
  contentfulMetadata: ContentfulMetadata;
  jumplinkName?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<TabLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabJumplinkNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tab) */
export type TabNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabCollection = {
  __typename?: 'TabCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabContent = Accordions | HalfScreen | MultiCardV2 | ServiceLineHero | SingleMessage;

export type TabCursorCollection = {
  __typename?: 'TabCursorCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TabFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabFilter>>>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  jumplinkName?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_contains?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jumplinkName_not?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_not_contains?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TabLinkingCollections = {
  __typename?: 'TabLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  tabsCollection?: Maybe<TabsCollection>;
  tabsCursorCollection?: Maybe<TabsCursorCollection>;
};


export type TabLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabLinkingCollectionsTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabLinkingCollectionsTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabLinkingCollectionsTabsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabLinkingCollectionsTabsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabLinkingCollectionsTabsCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'jumplinkTabs_ASC'
  | 'jumplinkTabs_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tabRowVariant_ASC'
  | 'tabRowVariant_DESC'
  | 'tabsSize_ASC'
  | 'tabsSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC'
  | 'withContentInnerGap_ASC'
  | 'withContentInnerGap_DESC';

export type TabLinkingCollectionsTabsCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'jumplinkTabs_ASC'
  | 'jumplinkTabs_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tabRowVariant_ASC'
  | 'tabRowVariant_DESC'
  | 'tabsSize_ASC'
  | 'tabsSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC'
  | 'withContentInnerGap_ASC'
  | 'withContentInnerGap_DESC';

export type TabOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type Table = Entry & _Node & {
  __typename?: 'Table';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  border?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  descriptionRichText?: Maybe<TableDescriptionRichText>;
  firstColumnSticky?: Maybe<Scalars['Boolean']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  footnote?: Maybe<TableFootnote>;
  linkedFrom?: Maybe<TableLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tableContent?: Maybe<TableTableContent>;
  tableJsonData?: Maybe<Scalars['JSON']['output']>;
  tableJsonDataMobile?: Maybe<Scalars['JSON']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleHtag?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableBorderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableDescriptionRichTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableFirstColumnStickyArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableFontSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableFootnoteArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTableContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTableJsonDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTableJsonDataMobileArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableTitleHtagArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/table) */
export type TableVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TableCollection = {
  __typename?: 'TableCollection';
  items: Array<Maybe<Table>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TableCursorCollection = {
  __typename?: 'TableCursorCollection';
  items: Array<Maybe<Table>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TableDescriptionRichText = {
  __typename?: 'TableDescriptionRichText';
  json: Scalars['JSON']['output'];
  links: TableDescriptionRichTextLinks;
};

export type TableDescriptionRichTextAssets = {
  __typename?: 'TableDescriptionRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TableDescriptionRichTextEntries = {
  __typename?: 'TableDescriptionRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TableDescriptionRichTextLinks = {
  __typename?: 'TableDescriptionRichTextLinks';
  assets: TableDescriptionRichTextAssets;
  entries: TableDescriptionRichTextEntries;
  resources: TableDescriptionRichTextResources;
};

export type TableDescriptionRichTextResources = {
  __typename?: 'TableDescriptionRichTextResources';
  block: Array<TableDescriptionRichTextResourcesBlock>;
  hyperlink: Array<TableDescriptionRichTextResourcesHyperlink>;
  inline: Array<TableDescriptionRichTextResourcesInline>;
};

export type TableDescriptionRichTextResourcesBlock = ResourceLink & {
  __typename?: 'TableDescriptionRichTextResourcesBlock';
  sys: ResourceSys;
};

export type TableDescriptionRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'TableDescriptionRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type TableDescriptionRichTextResourcesInline = ResourceLink & {
  __typename?: 'TableDescriptionRichTextResourcesInline';
  sys: ResourceSys;
};

export type TableFilter = {
  AND?: InputMaybe<Array<InputMaybe<TableFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TableFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  border?: InputMaybe<Scalars['Boolean']['input']>;
  border_exists?: InputMaybe<Scalars['Boolean']['input']>;
  border_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  firstColumnSticky?: InputMaybe<Scalars['Boolean']['input']>;
  firstColumnSticky_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstColumnSticky_not?: InputMaybe<Scalars['Boolean']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  fontSize_contains?: InputMaybe<Scalars['String']['input']>;
  fontSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fontSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fontSize_not?: InputMaybe<Scalars['String']['input']>;
  fontSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  fontSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footnote_contains?: InputMaybe<Scalars['String']['input']>;
  footnote_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footnote_not_contains?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tableContent_contains?: InputMaybe<Scalars['String']['input']>;
  tableContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tableContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  tableJsonDataMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tableJsonData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TableFootnote = {
  __typename?: 'TableFootnote';
  json: Scalars['JSON']['output'];
  links: TableFootnoteLinks;
};

export type TableFootnoteAssets = {
  __typename?: 'TableFootnoteAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TableFootnoteEntries = {
  __typename?: 'TableFootnoteEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TableFootnoteLinks = {
  __typename?: 'TableFootnoteLinks';
  assets: TableFootnoteAssets;
  entries: TableFootnoteEntries;
  resources: TableFootnoteResources;
};

export type TableFootnoteResources = {
  __typename?: 'TableFootnoteResources';
  block: Array<TableFootnoteResourcesBlock>;
  hyperlink: Array<TableFootnoteResourcesHyperlink>;
  inline: Array<TableFootnoteResourcesInline>;
};

export type TableFootnoteResourcesBlock = ResourceLink & {
  __typename?: 'TableFootnoteResourcesBlock';
  sys: ResourceSys;
};

export type TableFootnoteResourcesHyperlink = ResourceLink & {
  __typename?: 'TableFootnoteResourcesHyperlink';
  sys: ResourceSys;
};

export type TableFootnoteResourcesInline = ResourceLink & {
  __typename?: 'TableFootnoteResourcesInline';
  sys: ResourceSys;
};

export type TableLinkingCollections = {
  __typename?: 'TableLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
};


export type TableLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TableLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TableLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TableLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TableLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TableLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TableLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TableLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TableLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TableLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type TableLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type TableLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TableLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TableLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TableLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TableOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'border_ASC'
  | 'border_DESC'
  | 'firstColumnSticky_ASC'
  | 'firstColumnSticky_DESC'
  | 'fontSize_ASC'
  | 'fontSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TableTableContent = {
  __typename?: 'TableTableContent';
  json: Scalars['JSON']['output'];
  links: TableTableContentLinks;
};

export type TableTableContentAssets = {
  __typename?: 'TableTableContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TableTableContentEntries = {
  __typename?: 'TableTableContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TableTableContentLinks = {
  __typename?: 'TableTableContentLinks';
  assets: TableTableContentAssets;
  entries: TableTableContentEntries;
  resources: TableTableContentResources;
};

export type TableTableContentResources = {
  __typename?: 'TableTableContentResources';
  block: Array<TableTableContentResourcesBlock>;
  hyperlink: Array<TableTableContentResourcesHyperlink>;
  inline: Array<TableTableContentResourcesInline>;
};

export type TableTableContentResourcesBlock = ResourceLink & {
  __typename?: 'TableTableContentResourcesBlock';
  sys: ResourceSys;
};

export type TableTableContentResourcesHyperlink = ResourceLink & {
  __typename?: 'TableTableContentResourcesHyperlink';
  sys: ResourceSys;
};

export type TableTableContentResourcesInline = ResourceLink & {
  __typename?: 'TableTableContentResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type Tabs = Entry & _Node & {
  __typename?: 'Tabs';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  jumplinkTabs?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<TabsLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  tabRowVariant?: Maybe<Scalars['String']['output']>;
  tabsCollection?: Maybe<TabsTabsCollection>;
  tabsCursorCollection?: Maybe<TabsTabsCursorCollection>;
  tabsSize?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  withContentInnerGap?: Maybe<Scalars['Boolean']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsJumplinkTabsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsTabRowVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsTabsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsTabsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsTabsSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsVariantArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/tabs) */
export type TabsWithContentInnerGapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabsCollection = {
  __typename?: 'TabsCollection';
  items: Array<Maybe<Tabs>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabsCursorCollection = {
  __typename?: 'TabsCursorCollection';
  items: Array<Maybe<Tabs>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TabsFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabsFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  jumplinkTabs?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkTabs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkTabs_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tabRowVariant?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_contains?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabRowVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabRowVariant_not?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabs?: InputMaybe<CfTabNestedFilter>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabsSize?: InputMaybe<Scalars['String']['input']>;
  tabsSize_contains?: InputMaybe<Scalars['String']['input']>;
  tabsSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabsSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabsSize_not?: InputMaybe<Scalars['String']['input']>;
  tabsSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabsSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withContentInnerGap?: InputMaybe<Scalars['Boolean']['input']>;
  withContentInnerGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withContentInnerGap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabsLinkingCollections = {
  __typename?: 'TabsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  facilityDetailsPageCollection?: Maybe<FacilityDetailsPageCollection>;
  facilityDetailsPageCursorCollection?: Maybe<FacilityDetailsPageCursorCollection>;
  googleMapTemplateCollection?: Maybe<GoogleMapTemplateCollection>;
  googleMapTemplateCursorCollection?: Maybe<GoogleMapTemplateCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type TabsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsFacilityDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsFacilityDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsFacilityDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsFacilityDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsGoogleMapTemplateCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsGoogleMapTemplateCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsGoogleMapTemplateCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsGoogleMapTemplateCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TabsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TabsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TabsLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type TabsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type TabsLinkingCollectionsFacilityDetailsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TabsLinkingCollectionsFacilityDetailsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'facilityId_ASC'
  | 'facilityId_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'teletriageEnabled_ASC'
  | 'teletriageEnabled_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TabsLinkingCollectionsGoogleMapTemplateCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type TabsLinkingCollectionsGoogleMapTemplateCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'desktopZoom_ASC'
  | 'desktopZoom_DESC'
  | 'disableMarkerClick_ASC'
  | 'disableMarkerClick_DESC'
  | 'facilityBadgeLabel_ASC'
  | 'facilityBadgeLabel_DESC'
  | 'facilityBasePath_ASC'
  | 'facilityBasePath_DESC'
  | 'facilityButtonLabel_ASC'
  | 'facilityButtonLabel_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideLocationCardButtons_ASC'
  | 'hideLocationCardButtons_DESC'
  | 'hideLocationsListOnMobile_ASC'
  | 'hideLocationsListOnMobile_DESC'
  | 'hideOfficeDetailsButton_ASC'
  | 'hideOfficeDetailsButton_DESC'
  | 'holidayHoursMessageText_ASC'
  | 'holidayHoursMessageText_DESC'
  | 'listTabIsHorizontalScrolling_ASC'
  | 'listTabIsHorizontalScrolling_DESC'
  | 'locationScheduleButtonUrl_ASC'
  | 'locationScheduleButtonUrl_DESC'
  | 'mobileZoom_ASC'
  | 'mobileZoom_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'searchRadius_ASC'
  | 'searchRadius_DESC'
  | 'searchResultLimit_ASC'
  | 'searchResultLimit_DESC'
  | 'service_ASC'
  | 'service_DESC'
  | 'setAsOfficeButtonText_ASC'
  | 'setAsOfficeButtonText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useCumulativeDesign_ASC'
  | 'useCumulativeDesign_DESC'
  | 'useModernDesign_ASC'
  | 'useModernDesign_DESC'
  | 'useUsaCountryMap_ASC'
  | 'useUsaCountryMap_DESC';

export type TabsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TabsLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TabsOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'jumplinkTabs_ASC'
  | 'jumplinkTabs_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tabRowVariant_ASC'
  | 'tabRowVariant_DESC'
  | 'tabsSize_ASC'
  | 'tabsSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC'
  | 'withContentInnerGap_ASC'
  | 'withContentInnerGap_DESC';

export type TabsTabsCollection = {
  __typename?: 'TabsTabsCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TabsTabsCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type TabsTabsCursorCollection = {
  __typename?: 'TabsTabsCursorCollection';
  items: Array<Maybe<Tab>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TabsTabsCursorCollectionOrder =
  | 'jumplinkName_ASC'
  | 'jumplinkName_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditions = Entry & _Node & {
  __typename?: 'TermsAndConditions';
  _id: Scalars['ID']['output'];
  content?: Maybe<TermsAndConditionsContent>;
  contentfulMetadata: ContentfulMetadata;
  headlineText?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<TermsAndConditionsLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  showTcTextAs?: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  tcLink?: Maybe<Scalars['String']['output']>;
  tcText?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsHeadlineTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsShowTcTextAsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsTcLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/termsAndConditions) */
export type TermsAndConditionsTcTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TermsAndConditionsCollection = {
  __typename?: 'TermsAndConditionsCollection';
  items: Array<Maybe<TermsAndConditions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TermsAndConditionsContent = {
  __typename?: 'TermsAndConditionsContent';
  json: Scalars['JSON']['output'];
  links: TermsAndConditionsContentLinks;
};

export type TermsAndConditionsContentAssets = {
  __typename?: 'TermsAndConditionsContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TermsAndConditionsContentEntries = {
  __typename?: 'TermsAndConditionsContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TermsAndConditionsContentLinks = {
  __typename?: 'TermsAndConditionsContentLinks';
  assets: TermsAndConditionsContentAssets;
  entries: TermsAndConditionsContentEntries;
  resources: TermsAndConditionsContentResources;
};

export type TermsAndConditionsContentResources = {
  __typename?: 'TermsAndConditionsContentResources';
  block: Array<TermsAndConditionsContentResourcesBlock>;
  hyperlink: Array<TermsAndConditionsContentResourcesHyperlink>;
  inline: Array<TermsAndConditionsContentResourcesInline>;
};

export type TermsAndConditionsContentResourcesBlock = ResourceLink & {
  __typename?: 'TermsAndConditionsContentResourcesBlock';
  sys: ResourceSys;
};

export type TermsAndConditionsContentResourcesHyperlink = ResourceLink & {
  __typename?: 'TermsAndConditionsContentResourcesHyperlink';
  sys: ResourceSys;
};

export type TermsAndConditionsContentResourcesInline = ResourceLink & {
  __typename?: 'TermsAndConditionsContentResourcesInline';
  sys: ResourceSys;
};

export type TermsAndConditionsCursorCollection = {
  __typename?: 'TermsAndConditionsCursorCollection';
  items: Array<Maybe<TermsAndConditions>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TermsAndConditionsFilter = {
  AND?: InputMaybe<Array<InputMaybe<TermsAndConditionsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TermsAndConditionsFilter>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineText?: InputMaybe<Scalars['String']['input']>;
  headlineText_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText_not?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTcTextAs?: InputMaybe<Scalars['Boolean']['input']>;
  showTcTextAs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTcTextAs_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tcLink?: InputMaybe<Scalars['String']['input']>;
  tcLink_contains?: InputMaybe<Scalars['String']['input']>;
  tcLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcLink_not?: InputMaybe<Scalars['String']['input']>;
  tcLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText?: InputMaybe<Scalars['String']['input']>;
  tcText_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText_not?: InputMaybe<Scalars['String']['input']>;
  tcText_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TermsAndConditionsLinkingCollections = {
  __typename?: 'TermsAndConditionsLinkingCollections';
  cardCollection?: Maybe<CardCollection>;
  cardCursorCollection?: Maybe<CardCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  serviceCollection?: Maybe<ServiceCollection>;
  serviceCursorCollection?: Maybe<ServiceCursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
  singleMessageCollection?: Maybe<SingleMessageCollection>;
  singleMessageCursorCollection?: Maybe<SingleMessageCursorCollection>;
};


export type TermsAndConditionsLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsCardCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsCardCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsHalfScreenCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsHeroV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsServiceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsServiceCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsServiceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsServiceCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsSingleMessageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsSingleMessageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TermsAndConditionsLinkingCollectionsSingleMessageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TermsAndConditionsLinkingCollectionsSingleMessageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TermsAndConditionsLinkingCollectionsCardCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TermsAndConditionsLinkingCollectionsCardCursorCollectionOrder =
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonIconPosition_ASC'
  | 'buttonIconPosition_DESC'
  | 'buttonIconSize_ASC'
  | 'buttonIconSize_DESC'
  | 'buttonIcon_ASC'
  | 'buttonIcon_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'buttonVariant_ASC'
  | 'buttonVariant_DESC'
  | 'cardIconAlignment_ASC'
  | 'cardIconAlignment_DESC'
  | 'cardIcon_ASC'
  | 'cardIcon_DESC'
  | 'cardTextAlignment_ASC'
  | 'cardTextAlignment_DESC'
  | 'eventType_ASC'
  | 'eventType_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageRatio_ASC'
  | 'imageRatio_DESC'
  | 'imageUrl_ASC'
  | 'imageUrl_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pdfDownloadTitle_ASC'
  | 'pdfDownloadTitle_DESC'
  | 'priority_ASC'
  | 'priority_DESC'
  | 'showBorder_ASC'
  | 'showBorder_DESC'
  | 'slot_ASC'
  | 'slot_DESC'
  | 'stepName_ASC'
  | 'stepName_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC'
  | 'tcUrl_ASC'
  | 'tcUrl_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TermsAndConditionsLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type TermsAndConditionsLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type TermsAndConditionsLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TermsAndConditionsLinkingCollectionsHalfScreenCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TermsAndConditionsLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TermsAndConditionsLinkingCollectionsHeroV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TermsAndConditionsLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TermsAndConditionsLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TermsAndConditionsLinkingCollectionsServiceCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type TermsAndConditionsLinkingCollectionsServiceCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'centerAlign_ASC'
  | 'centerAlign_DESC'
  | 'contained_ASC'
  | 'contained_DESC'
  | 'direction_ASC'
  | 'direction_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'imageLayout_ASC'
  | 'imageLayout_DESC'
  | 'mediaType_ASC'
  | 'mediaType_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHtag_ASC'
  | 'titleHtag_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'youTubeVideoId_ASC'
  | 'youTubeVideoId_DESC';

export type TermsAndConditionsLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TermsAndConditionsLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TermsAndConditionsLinkingCollectionsSingleMessageCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TermsAndConditionsLinkingCollectionsSingleMessageCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'buttonSize_ASC'
  | 'buttonSize_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonType_ASC'
  | 'buttonType_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentFillVerticalSpace_ASC'
  | 'contentFillVerticalSpace_DESC'
  | 'displayTitleInline_ASC'
  | 'displayTitleInline_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'fullWidth_ASC'
  | 'fullWidth_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'isBannerImage_ASC'
  | 'isBannerImage_DESC'
  | 'isHeaderAboveSideImages_ASC'
  | 'isHeaderAboveSideImages_DESC'
  | 'isInlineLayout_ASC'
  | 'isInlineLayout_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showSubscriptionForm_ASC'
  | 'showSubscriptionForm_DESC'
  | 'subText_ASC'
  | 'subText_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateHeight_ASC'
  | 'templateHeight_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'titleAlign_ASC'
  | 'titleAlign_DESC'
  | 'titleVariant_ASC'
  | 'titleVariant_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'useRoundedCorners_ASC'
  | 'useRoundedCorners_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TermsAndConditionsOrder =
  | 'headlineText_ASC'
  | 'headlineText_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'showTcTextAs_ASC'
  | 'showTcTextAs_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'tcLink_ASC'
  | 'tcLink_DESC'
  | 'tcText_ASC'
  | 'tcText_DESC';

/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeo = Entry & _Node & {
  __typename?: 'TextBlockSeo';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  content?: Maybe<TextBlockSeoContent>;
  contentfulMetadata: ContentfulMetadata;
  disablePaddingOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  facilityFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom?: Maybe<TextBlockSeoLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoDisablePaddingOnArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoFacilityFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textBlockSeo) */
export type TextBlockSeoNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextBlockSeoCollection = {
  __typename?: 'TextBlockSeoCollection';
  items: Array<Maybe<TextBlockSeo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TextBlockSeoContent = {
  __typename?: 'TextBlockSeoContent';
  json: Scalars['JSON']['output'];
  links: TextBlockSeoContentLinks;
};

export type TextBlockSeoContentAssets = {
  __typename?: 'TextBlockSeoContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TextBlockSeoContentEntries = {
  __typename?: 'TextBlockSeoContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TextBlockSeoContentLinks = {
  __typename?: 'TextBlockSeoContentLinks';
  assets: TextBlockSeoContentAssets;
  entries: TextBlockSeoContentEntries;
  resources: TextBlockSeoContentResources;
};

export type TextBlockSeoContentResources = {
  __typename?: 'TextBlockSeoContentResources';
  block: Array<TextBlockSeoContentResourcesBlock>;
  hyperlink: Array<TextBlockSeoContentResourcesHyperlink>;
  inline: Array<TextBlockSeoContentResourcesInline>;
};

export type TextBlockSeoContentResourcesBlock = ResourceLink & {
  __typename?: 'TextBlockSeoContentResourcesBlock';
  sys: ResourceSys;
};

export type TextBlockSeoContentResourcesHyperlink = ResourceLink & {
  __typename?: 'TextBlockSeoContentResourcesHyperlink';
  sys: ResourceSys;
};

export type TextBlockSeoContentResourcesInline = ResourceLink & {
  __typename?: 'TextBlockSeoContentResourcesInline';
  sys: ResourceSys;
};

export type TextBlockSeoCursorCollection = {
  __typename?: 'TextBlockSeoCursorCollection';
  items: Array<Maybe<TextBlockSeo>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TextBlockSeoFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextBlockSeoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextBlockSeoFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityFields_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityFields_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityFields_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityFields_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TextBlockSeoLinkingCollections = {
  __typename?: 'TextBlockSeoLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
};


export type TextBlockSeoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TextBlockSeoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TextBlockSeoLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextBlockSeoLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TextBlockSeoLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextBlockSeoLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TextBlockSeoLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextBlockSeoLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TextBlockSeoLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TextBlockSeoLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextBlockSeoLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type TextBlockSeoLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type TextBlockSeoLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TextBlockSeoLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type TextBlockSeoOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Used for colored text in RichText fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textHighlight) */
export type TextHighlight = Entry & _Node & {
  __typename?: 'TextHighlight';
  _id: Scalars['ID']['output'];
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<TextHighlightContent>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<TextHighlightLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Used for colored text in RichText fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textHighlight) */
export type TextHighlightColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for colored text in RichText fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textHighlight) */
export type TextHighlightContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for colored text in RichText fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textHighlight) */
export type TextHighlightLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for colored text in RichText fields [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/textHighlight) */
export type TextHighlightNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextHighlightCollection = {
  __typename?: 'TextHighlightCollection';
  items: Array<Maybe<TextHighlight>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TextHighlightContent = {
  __typename?: 'TextHighlightContent';
  json: Scalars['JSON']['output'];
  links: TextHighlightContentLinks;
};

export type TextHighlightContentAssets = {
  __typename?: 'TextHighlightContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TextHighlightContentEntries = {
  __typename?: 'TextHighlightContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TextHighlightContentLinks = {
  __typename?: 'TextHighlightContentLinks';
  assets: TextHighlightContentAssets;
  entries: TextHighlightContentEntries;
  resources: TextHighlightContentResources;
};

export type TextHighlightContentResources = {
  __typename?: 'TextHighlightContentResources';
  block: Array<TextHighlightContentResourcesBlock>;
  hyperlink: Array<TextHighlightContentResourcesHyperlink>;
  inline: Array<TextHighlightContentResourcesInline>;
};

export type TextHighlightContentResourcesBlock = ResourceLink & {
  __typename?: 'TextHighlightContentResourcesBlock';
  sys: ResourceSys;
};

export type TextHighlightContentResourcesHyperlink = ResourceLink & {
  __typename?: 'TextHighlightContentResourcesHyperlink';
  sys: ResourceSys;
};

export type TextHighlightContentResourcesInline = ResourceLink & {
  __typename?: 'TextHighlightContentResourcesInline';
  sys: ResourceSys;
};

export type TextHighlightCursorCollection = {
  __typename?: 'TextHighlightCursorCollection';
  items: Array<Maybe<TextHighlight>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TextHighlightFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextHighlightFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextHighlightFilter>>>;
  color?: InputMaybe<Scalars['String']['input']>;
  color_contains?: InputMaybe<Scalars['String']['input']>;
  color_exists?: InputMaybe<Scalars['Boolean']['input']>;
  color_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  color_not?: InputMaybe<Scalars['String']['input']>;
  color_not_contains?: InputMaybe<Scalars['String']['input']>;
  color_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TextHighlightLinkingCollections = {
  __typename?: 'TextHighlightLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type TextHighlightLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TextHighlightLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextHighlightOrder =
  | 'color_ASC'
  | 'color_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type TimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte?: InputMaybe<Scalars['String']['input']>;
  /** Preview content starting from a given timestamp */
  timestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModal = Entry & _Node & {
  __typename?: 'TriggeredContentModal';
  _id: Scalars['ID']['output'];
  bodyText?: Maybe<TriggeredContentModalBodyText>;
  bodyTextAlign?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  delay?: Maybe<Scalars['Int']['output']>;
  dismissLabel?: Maybe<Scalars['String']['output']>;
  excludePaths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  footerButtonsCollection?: Maybe<TriggeredContentModalFooterButtonsCollection>;
  footerButtonsCursorCollection?: Maybe<TriggeredContentModalFooterButtonsCursorCollection>;
  includePaths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom?: Maybe<TriggeredContentModalLinkingCollections>;
  modalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  queryParams?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
  trigger?: Maybe<Scalars['String']['output']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalBodyTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalBodyTextAlignArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalDelayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalDismissLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalExcludePathsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalFooterButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TriggeredContentModalFooterButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalFooterButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TriggeredContentModalFooterButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalIncludePathsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalModalIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalQueryParamsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Triggered by Page events; Fetched at runtime by id [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/triggeredContentModal) */
export type TriggeredContentModalTriggerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TriggeredContentModalBodyText = {
  __typename?: 'TriggeredContentModalBodyText';
  json: Scalars['JSON']['output'];
  links: TriggeredContentModalBodyTextLinks;
};

export type TriggeredContentModalBodyTextAssets = {
  __typename?: 'TriggeredContentModalBodyTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TriggeredContentModalBodyTextEntries = {
  __typename?: 'TriggeredContentModalBodyTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TriggeredContentModalBodyTextLinks = {
  __typename?: 'TriggeredContentModalBodyTextLinks';
  assets: TriggeredContentModalBodyTextAssets;
  entries: TriggeredContentModalBodyTextEntries;
  resources: TriggeredContentModalBodyTextResources;
};

export type TriggeredContentModalBodyTextResources = {
  __typename?: 'TriggeredContentModalBodyTextResources';
  block: Array<TriggeredContentModalBodyTextResourcesBlock>;
  hyperlink: Array<TriggeredContentModalBodyTextResourcesHyperlink>;
  inline: Array<TriggeredContentModalBodyTextResourcesInline>;
};

export type TriggeredContentModalBodyTextResourcesBlock = ResourceLink & {
  __typename?: 'TriggeredContentModalBodyTextResourcesBlock';
  sys: ResourceSys;
};

export type TriggeredContentModalBodyTextResourcesHyperlink = ResourceLink & {
  __typename?: 'TriggeredContentModalBodyTextResourcesHyperlink';
  sys: ResourceSys;
};

export type TriggeredContentModalBodyTextResourcesInline = ResourceLink & {
  __typename?: 'TriggeredContentModalBodyTextResourcesInline';
  sys: ResourceSys;
};

export type TriggeredContentModalCollection = {
  __typename?: 'TriggeredContentModalCollection';
  items: Array<Maybe<TriggeredContentModal>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TriggeredContentModalCursorCollection = {
  __typename?: 'TriggeredContentModalCursorCollection';
  items: Array<Maybe<TriggeredContentModal>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TriggeredContentModalFilter = {
  AND?: InputMaybe<Array<InputMaybe<TriggeredContentModalFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TriggeredContentModalFilter>>>;
  bodyTextAlign?: InputMaybe<Scalars['String']['input']>;
  bodyTextAlign_contains?: InputMaybe<Scalars['String']['input']>;
  bodyTextAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyTextAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyTextAlign_not?: InputMaybe<Scalars['String']['input']>;
  bodyTextAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  bodyTextAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyText_contains?: InputMaybe<Scalars['String']['input']>;
  bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodyText_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  delay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  delay_gt?: InputMaybe<Scalars['Int']['input']>;
  delay_gte?: InputMaybe<Scalars['Int']['input']>;
  delay_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  delay_lt?: InputMaybe<Scalars['Int']['input']>;
  delay_lte?: InputMaybe<Scalars['Int']['input']>;
  delay_not?: InputMaybe<Scalars['Int']['input']>;
  delay_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dismissLabel?: InputMaybe<Scalars['String']['input']>;
  dismissLabel_contains?: InputMaybe<Scalars['String']['input']>;
  dismissLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  dismissLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dismissLabel_not?: InputMaybe<Scalars['String']['input']>;
  dismissLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  dismissLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePaths_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePaths_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePaths_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePaths_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerButtons?: InputMaybe<CfButtonNestedFilter>;
  footerButtonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  includePaths_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includePaths_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includePaths_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includePaths_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalId?: InputMaybe<Scalars['String']['input']>;
  modalId_contains?: InputMaybe<Scalars['String']['input']>;
  modalId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalId_not?: InputMaybe<Scalars['String']['input']>;
  modalId_not_contains?: InputMaybe<Scalars['String']['input']>;
  modalId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryParams_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryParams_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryParams_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryParams_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  trigger_contains?: InputMaybe<Scalars['String']['input']>;
  trigger_exists?: InputMaybe<Scalars['Boolean']['input']>;
  trigger_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trigger_not?: InputMaybe<Scalars['String']['input']>;
  trigger_not_contains?: InputMaybe<Scalars['String']['input']>;
  trigger_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TriggeredContentModalFooterButtonsCollection = {
  __typename?: 'TriggeredContentModalFooterButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TriggeredContentModalFooterButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TriggeredContentModalFooterButtonsCursorCollection = {
  __typename?: 'TriggeredContentModalFooterButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TriggeredContentModalFooterButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type TriggeredContentModalLinkingCollections = {
  __typename?: 'TriggeredContentModalLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
};


export type TriggeredContentModalLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TriggeredContentModalLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TriggeredContentModalOrder =
  | 'bodyTextAlign_ASC'
  | 'bodyTextAlign_DESC'
  | 'delay_ASC'
  | 'delay_DESC'
  | 'dismissLabel_ASC'
  | 'dismissLabel_DESC'
  | 'modalId_ASC'
  | 'modalId_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'trigger_ASC'
  | 'trigger_DESC';

/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type Video = Entry & _Node & {
  __typename?: 'Video';
  _id: Scalars['ID']['output'];
  adjustedWidth?: Maybe<Scalars['Int']['output']>;
  autoPlay?: Maybe<Scalars['Boolean']['output']>;
  contentfulMetadata: ContentfulMetadata;
  hlsVideoStreamLink?: Maybe<Scalars['String']['output']>;
  isLooped?: Maybe<Scalars['Boolean']['output']>;
  isMuted?: Maybe<Scalars['Boolean']['output']>;
  linkedFrom?: Maybe<VideoLinkingCollections>;
  media?: Maybe<Asset>;
  name?: Maybe<Scalars['String']['output']>;
  posterMedia?: Maybe<Asset>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  useOriginalVideoSize?: Maybe<Scalars['Boolean']['output']>;
  videoSource?: Maybe<Scalars['String']['output']>;
  youtubeId?: Maybe<Scalars['String']['output']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoAdjustedWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoAutoPlayArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoHlsVideoStreamLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoIsLoopedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoIsMutedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoPosterMediaArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoPosterUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoUseOriginalVideoSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoVideoSourceArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** generic model for Video content [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/video) */
export type VideoYoutubeIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAsset = Entry & _Node & {
  __typename?: 'VideoAsset';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  desktopVideo?: Maybe<Video>;
  linkedFrom?: Maybe<VideoAssetLinkingCollections>;
  mobileVideo?: Maybe<Video>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetDesktopVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetMobileVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoFilter>;
};


/** Content type used to display video using Video content type with separate video selection for Desktop and Mobile. [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoAsset) */
export type VideoAssetNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoAssetCollection = {
  __typename?: 'VideoAssetCollection';
  items: Array<Maybe<VideoAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoAssetCursorCollection = {
  __typename?: 'VideoAssetCursorCollection';
  items: Array<Maybe<VideoAsset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoAssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoAssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoAssetFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopVideo?: InputMaybe<CfVideoNestedFilter>;
  desktopVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileVideo?: InputMaybe<CfVideoNestedFilter>;
  mobileVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type VideoAssetLinkingCollections = {
  __typename?: 'VideoAssetLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  heroV2Collection?: Maybe<HeroV2Collection>;
  heroV2CursorCollection?: Maybe<HeroV2CursorCollection>;
  serviceLineHeroCollection?: Maybe<ServiceLineHeroCollection>;
  serviceLineHeroCursorCollection?: Maybe<ServiceLineHeroCursorCollection>;
  videoWithContentCollection?: Maybe<VideoWithContentCollection>;
  videoWithContentCursorCollection?: Maybe<VideoWithContentCursorCollection>;
};


export type VideoAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsHalfScreenCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsHeroV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsHeroV2CollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsHeroV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsHeroV2CursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsServiceLineHeroCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsServiceLineHeroCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsServiceLineHeroCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsServiceLineHeroCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsVideoWithContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsVideoWithContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoAssetLinkingCollectionsVideoWithContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoAssetLinkingCollectionsVideoWithContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoAssetLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoAssetLinkingCollectionsHalfScreenCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoAssetLinkingCollectionsHeroV2CollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoAssetLinkingCollectionsHeroV2CursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'aspenDentalReasonForVisit_ASC'
  | 'aspenDentalReasonForVisit_DESC'
  | 'backgroundColorSmallScreen_ASC'
  | 'backgroundColorSmallScreen_DESC'
  | 'bodySize_ASC'
  | 'bodySize_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'contentPositionSmallScreen_ASC'
  | 'contentPositionSmallScreen_DESC'
  | 'contentPosition_ASC'
  | 'contentPosition_DESC'
  | 'contentWidth_ASC'
  | 'contentWidth_DESC'
  | 'darkOverlay_ASC'
  | 'darkOverlay_DESC'
  | 'darkTextColor_ASC'
  | 'darkTextColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'headingSize_ASC'
  | 'headingSize_DESC'
  | 'heightStyle_ASC'
  | 'heightStyle_DESC'
  | 'mediaAspectRatioSmallScreen_ASC'
  | 'mediaAspectRatioSmallScreen_DESC'
  | 'promoHeadlineSize_ASC'
  | 'promoHeadlineSize_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoAssetLinkingCollectionsServiceLineHeroCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoAssetLinkingCollectionsServiceLineHeroCursorCollectionOrder =
  | 'allowPatientInfoWidget_ASC'
  | 'allowPatientInfoWidget_DESC'
  | 'allowScheduleTimes_ASC'
  | 'allowScheduleTimes_DESC'
  | 'allowScheduleWidget_ASC'
  | 'allowScheduleWidget_DESC'
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColorMobile_ASC'
  | 'backgroundColorMobile_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'contentAlign_ASC'
  | 'contentAlign_DESC'
  | 'displayOfficeHoursInModal_ASC'
  | 'displayOfficeHoursInModal_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowHtag_ASC'
  | 'eyebrowHtag_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'googleMapsBusinessQuery_ASC'
  | 'googleMapsBusinessQuery_DESC'
  | 'hideHeroOnMobile_ASC'
  | 'hideHeroOnMobile_DESC'
  | 'imageWithBorderRadius_ASC'
  | 'imageWithBorderRadius_DESC'
  | 'imgDisplaysFirstOnDesktop_ASC'
  | 'imgDisplaysFirstOnDesktop_DESC'
  | 'imgDisplaysFirstOnMobile_ASC'
  | 'imgDisplaysFirstOnMobile_DESC'
  | 'mediaRoundedCornerSize_ASC'
  | 'mediaRoundedCornerSize_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'officeHoursLabel_ASC'
  | 'officeHoursLabel_DESC'
  | 'showOfficeDetails_ASC'
  | 'showOfficeDetails_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateWidth_ASC'
  | 'templateWidth_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoAssetLinkingCollectionsVideoWithContentCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoAssetLinkingCollectionsVideoWithContentCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoAssetOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarousel = Entry & _Node & {
  __typename?: 'VideoCarousel';
  _id: Scalars['ID']['output'];
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonsCollection?: Maybe<VideoCarouselButtonsCollection>;
  buttonsCursorCollection?: Maybe<VideoCarouselButtonsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  desktopVideosAspectRatio?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<VideoCarouselLinkingCollections>;
  mobileVideosAspectRatio?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  topFields?: Maybe<ContentSection>;
  videosCollection?: Maybe<VideoCarouselVideosCollection>;
  videosCursorCollection?: Maybe<VideoCarouselVideosCursorCollection>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselAnchorIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselDesktopVideosAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselMobileVideosAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselTopFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselVideosCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselVideosCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoWithContentFilter>;
};


/** Used for displaying horizontal scrollable videos [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoCarousel) */
export type VideoCarouselVideosCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselVideosCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoWithContentFilter>;
};

export type VideoCarouselButtonsCollection = {
  __typename?: 'VideoCarouselButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoCarouselButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoCarouselButtonsCursorCollection = {
  __typename?: 'VideoCarouselButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoCarouselButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoCarouselCollection = {
  __typename?: 'VideoCarouselCollection';
  items: Array<Maybe<VideoCarousel>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoCarouselCursorCollection = {
  __typename?: 'VideoCarouselCursorCollection';
  items: Array<Maybe<VideoCarousel>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoCarouselFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoCarouselFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoCarouselFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopVideosAspectRatio?: InputMaybe<Scalars['String']['input']>;
  desktopVideosAspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  desktopVideosAspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopVideosAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  desktopVideosAspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  desktopVideosAspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  desktopVideosAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileVideosAspectRatio?: InputMaybe<Scalars['String']['input']>;
  mobileVideosAspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  mobileVideosAspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileVideosAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileVideosAspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  mobileVideosAspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  mobileVideosAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  topFields?: InputMaybe<CfContentSectionNestedFilter>;
  topFields_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videos?: InputMaybe<CfVideoWithContentNestedFilter>;
  videosCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoCarouselLinkingCollections = {
  __typename?: 'VideoCarouselLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  experimentVariationContentsItemCollection?: Maybe<ExperimentVariationContentsItemCollection>;
  experimentVariationContentsItemCursorCollection?: Maybe<ExperimentVariationContentsItemCursorCollection>;
  pageCollection?: Maybe<PageCollection>;
  pageCursorCollection?: Maybe<PageCursorCollection>;
  providerDetailsPageCollection?: Maybe<ProviderDetailsPageCollection>;
  providerDetailsPageCursorCollection?: Maybe<ProviderDetailsPageCursorCollection>;
};


export type VideoCarouselLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoCarouselLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoCarouselLinkingCollectionsExperimentVariationContentsItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselLinkingCollectionsExperimentVariationContentsItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoCarouselLinkingCollectionsExperimentVariationContentsItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoCarouselLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoCarouselLinkingCollectionsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselLinkingCollectionsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoCarouselLinkingCollectionsProviderDetailsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselLinkingCollectionsProviderDetailsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoCarouselLinkingCollectionsProviderDetailsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoCarouselLinkingCollectionsProviderDetailsPageCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoCarouselLinkingCollectionsExperimentVariationContentsItemCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type VideoCarouselLinkingCollectionsExperimentVariationContentsItemCursorCollectionOrder =
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variationContentsItemName_ASC'
  | 'variationContentsItemName_DESC'
  | 'variationId_ASC'
  | 'variationId_DESC';

export type VideoCarouselLinkingCollectionsPageCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type VideoCarouselLinkingCollectionsPageCursorCollectionOrder =
  | 'appName_ASC'
  | 'appName_DESC'
  | 'breadcrumbTitle_ASC'
  | 'breadcrumbTitle_DESC'
  | 'buttonText_ASC'
  | 'buttonText_DESC'
  | 'buttonUrl_ASC'
  | 'buttonUrl_DESC'
  | 'canonical_ASC'
  | 'canonical_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'disableChatBot_ASC'
  | 'disableChatBot_DESC'
  | 'disableHeaderBottomAlertBanner_ASC'
  | 'disableHeaderBottomAlertBanner_DESC'
  | 'disableHeaderTopAlertBanner_ASC'
  | 'disableHeaderTopAlertBanner_DESC'
  | 'disableStickyFooterOnDesktop_ASC'
  | 'disableStickyFooterOnDesktop_DESC'
  | 'disableStickyFooterOnMobile_ASC'
  | 'disableStickyFooterOnMobile_DESC'
  | 'displayOnMobile_ASC'
  | 'displayOnMobile_DESC'
  | 'hideScheduleButtonInHeader_ASC'
  | 'hideScheduleButtonInHeader_DESC'
  | 'indexed_ASC'
  | 'indexed_DESC'
  | 'mobileBreadcrumbTitle_ASC'
  | 'mobileBreadcrumbTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'pageTheme_ASC'
  | 'pageTheme_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC'
  | 'path_ASC'
  | 'path_DESC'
  | 'personalizedPathPrefix_ASC'
  | 'personalizedPathPrefix_DESC'
  | 'personalizedPathSuffix_ASC'
  | 'personalizedPathSuffix_DESC'
  | 'personalized_ASC'
  | 'personalized_DESC'
  | 'redirectTo_ASC'
  | 'redirectTo_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type VideoCarouselLinkingCollectionsProviderDetailsPageCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoCarouselLinkingCollectionsProviderDetailsPageCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'npiId_ASC'
  | 'npiId_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoCarouselOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoCarouselVideosCollection = {
  __typename?: 'VideoCarouselVideosCollection';
  items: Array<Maybe<VideoWithContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoCarouselVideosCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoCarouselVideosCursorCollection = {
  __typename?: 'VideoCarouselVideosCursorCollection';
  items: Array<Maybe<VideoWithContent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoCarouselVideosCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoCollection = {
  __typename?: 'VideoCollection';
  items: Array<Maybe<Video>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoCursorCollection = {
  __typename?: 'VideoCursorCollection';
  items: Array<Maybe<Video>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  adjustedWidth?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  adjustedWidth_gt?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_gte?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  adjustedWidth_lt?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_lte?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_not?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  autoPlay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  autoPlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hlsVideoStreamLink?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_contains?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hlsVideoStreamLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hlsVideoStreamLink_not?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isLooped?: InputMaybe<Scalars['Boolean']['input']>;
  isLooped_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLooped_not?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted_not?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posterMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  posterUrl?: InputMaybe<Scalars['String']['input']>;
  posterUrl_contains?: InputMaybe<Scalars['String']['input']>;
  posterUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  posterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posterUrl_not?: InputMaybe<Scalars['String']['input']>;
  posterUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  posterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  useOriginalVideoSize?: InputMaybe<Scalars['Boolean']['input']>;
  useOriginalVideoSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useOriginalVideoSize_not?: InputMaybe<Scalars['Boolean']['input']>;
  videoSource?: InputMaybe<Scalars['String']['input']>;
  videoSource_contains?: InputMaybe<Scalars['String']['input']>;
  videoSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoSource_not?: InputMaybe<Scalars['String']['input']>;
  videoSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
  youtubeId_contains?: InputMaybe<Scalars['String']['input']>;
  youtubeId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youtubeId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeId_not?: InputMaybe<Scalars['String']['input']>;
  youtubeId_not_contains?: InputMaybe<Scalars['String']['input']>;
  youtubeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VideoLinkingCollections = {
  __typename?: 'VideoLinkingCollections';
  birdEyeReviewsCollection?: Maybe<BirdEyeReviewsCollection>;
  birdEyeReviewsCursorCollection?: Maybe<BirdEyeReviewsCursorCollection>;
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  halfScreenCollection?: Maybe<HalfScreenCollection>;
  halfScreenCursorCollection?: Maybe<HalfScreenCursorCollection>;
  mediaSliderCollection?: Maybe<MediaSliderCollection>;
  mediaSliderCursorCollection?: Maybe<MediaSliderCursorCollection>;
  smallScreenContentCollection?: Maybe<SmallScreenContentCollection>;
  smallScreenContentCursorCollection?: Maybe<SmallScreenContentCursorCollection>;
  videoAssetCollection?: Maybe<VideoAssetCollection>;
  videoAssetCursorCollection?: Maybe<VideoAssetCursorCollection>;
};


export type VideoLinkingCollectionsBirdEyeReviewsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsBirdEyeReviewsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsBirdEyeReviewsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsBirdEyeReviewsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsHalfScreenCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsHalfScreenCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsHalfScreenCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsHalfScreenCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsMediaSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsMediaSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsMediaSliderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsMediaSliderCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsSmallScreenContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsSmallScreenContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsSmallScreenContentCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsSmallScreenContentCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsVideoAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsVideoAssetCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoLinkingCollectionsVideoAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsVideoAssetCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoLinkingCollectionsBirdEyeReviewsCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'filteredReviewsMinRating_ASC'
  | 'filteredReviewsMinRating_DESC'
  | 'filteredReviewsTitle_ASC'
  | 'filteredReviewsTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type VideoLinkingCollectionsBirdEyeReviewsCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'filteredReviewsMinRating_ASC'
  | 'filteredReviewsMinRating_DESC'
  | 'filteredReviewsTitle_ASC'
  | 'filteredReviewsTitle_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'titleHeading_ASC'
  | 'titleHeading_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type VideoLinkingCollectionsHalfScreenCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoLinkingCollectionsHalfScreenCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'display_ASC'
  | 'display_DESC'
  | 'eyebrowStyle_ASC'
  | 'eyebrowStyle_DESC'
  | 'eyebrow_ASC'
  | 'eyebrow_DESC'
  | 'hideContentHalf_ASC'
  | 'hideContentHalf_DESC'
  | 'isInsetLayout_ASC'
  | 'isInsetLayout_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'templateSize_ASC'
  | 'templateSize_DESC'
  | 'textAlignment_ASC'
  | 'textAlignment_DESC'
  | 'useStaticImageSize_ASC'
  | 'useStaticImageSize_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoLinkingCollectionsMediaSliderCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoLinkingCollectionsMediaSliderCursorCollectionOrder =
  | 'aspectRatio_ASC'
  | 'aspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoLinkingCollectionsSmallScreenContentCollectionOrder =
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowSmallScreen_ASC'
  | 'eyebrowSmallScreen_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoLinkingCollectionsSmallScreenContentCursorCollectionOrder =
  | 'entryName_ASC'
  | 'entryName_DESC'
  | 'eyebrowSmallScreen_ASC'
  | 'eyebrowSmallScreen_DESC'
  | 'mediaFirst_ASC'
  | 'mediaFirst_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoLinkingCollectionsVideoAssetCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoLinkingCollectionsVideoAssetCursorCollectionOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoOrder =
  | 'adjustedWidth_ASC'
  | 'adjustedWidth_DESC'
  | 'autoPlay_ASC'
  | 'autoPlay_DESC'
  | 'hlsVideoStreamLink_ASC'
  | 'hlsVideoStreamLink_DESC'
  | 'isLooped_ASC'
  | 'isLooped_DESC'
  | 'isMuted_ASC'
  | 'isMuted_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'posterUrl_ASC'
  | 'posterUrl_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'useOriginalVideoSize_ASC'
  | 'useOriginalVideoSize_DESC'
  | 'videoSource_ASC'
  | 'videoSource_DESC'
  | 'youtubeId_ASC'
  | 'youtubeId_DESC';

/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContent = Entry & _Node & {
  __typename?: 'VideoWithContent';
  _id: Scalars['ID']['output'];
  buttonsCollection?: Maybe<VideoWithContentButtonsCollection>;
  buttonsCursorCollection?: Maybe<VideoWithContentButtonsCursorCollection>;
  content?: Maybe<ContentSection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<VideoWithContentLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  video?: Maybe<VideoAsset>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentButtonsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentButtonsCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ButtonFilter>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentContentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContentSectionFilter>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Use this to render video with some eyebrow, title and description like a card [See type definition](https://app.contentful.com/spaces/m8zwsu9tyucg/content_types/videoWithContent) */
export type VideoWithContentVideoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoAssetFilter>;
};

export type VideoWithContentButtonsCollection = {
  __typename?: 'VideoWithContentButtonsCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoWithContentButtonsCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoWithContentButtonsCursorCollection = {
  __typename?: 'VideoWithContentButtonsCursorCollection';
  items: Array<Maybe<Button>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoWithContentButtonsCursorCollectionOrder =
  | 'buttonLink_ASC'
  | 'buttonLink_DESC'
  | 'iconPosition_ASC'
  | 'iconPosition_DESC'
  | 'iconSize_ASC'
  | 'iconSize_DESC'
  | 'icon_ASC'
  | 'icon_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'launchCrestaAgent_ASC'
  | 'launchCrestaAgent_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'quizSelector_ASC'
  | 'quizSelector_DESC'
  | 'size_ASC'
  | 'size_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

export type VideoWithContentCollection = {
  __typename?: 'VideoWithContentCollection';
  items: Array<Maybe<VideoWithContent>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VideoWithContentCursorCollection = {
  __typename?: 'VideoWithContentCursorCollection';
  items: Array<Maybe<VideoWithContent>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type VideoWithContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoWithContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoWithContentFilter>>>;
  buttons?: InputMaybe<CfButtonNestedFilter>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<CfContentSectionNestedFilter>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  video?: InputMaybe<CfVideoAssetNestedFilter>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoWithContentLinkingCollections = {
  __typename?: 'VideoWithContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  entryCursorCollection?: Maybe<EntryCursorCollection>;
  videoCarouselCollection?: Maybe<VideoCarouselCollection>;
  videoCarouselCursorCollection?: Maybe<VideoCarouselCursorCollection>;
};


export type VideoWithContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoWithContentLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoWithContentLinkingCollectionsVideoCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentLinkingCollectionsVideoCarouselCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VideoWithContentLinkingCollectionsVideoCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoWithContentLinkingCollectionsVideoCarouselCursorCollectionOrder>>>;
  pageNext?: InputMaybe<Scalars['String']['input']>;
  pagePrev?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoWithContentLinkingCollectionsVideoCarouselCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoWithContentLinkingCollectionsVideoCarouselCursorCollectionOrder =
  | 'anchorId_ASC'
  | 'anchorId_DESC'
  | 'backgroundColor_ASC'
  | 'backgroundColor_DESC'
  | 'desktopVideosAspectRatio_ASC'
  | 'desktopVideosAspectRatio_DESC'
  | 'mobileVideosAspectRatio_ASC'
  | 'mobileVideosAspectRatio_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type VideoWithContentOrder =
  | 'name_ASC'
  | 'name_DESC'
  | 'sys_firstPublishedAt_ASC'
  | 'sys_firstPublishedAt_DESC'
  | 'sys_id_ASC'
  | 'sys_id_DESC'
  | 'sys_publishedAt_ASC'
  | 'sys_publishedAt_DESC'
  | 'sys_publishedVersion_ASC'
  | 'sys_publishedVersion_DESC';

export type _Node = {
  _id: Scalars['ID']['output'];
};

export type CfAdFooterNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAdFooterNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAdFooterNestedFilter>>>;
  aboutDescription_contains?: InputMaybe<Scalars['String']['input']>;
  aboutDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aboutDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  about_contains?: InputMaybe<Scalars['String']['input']>;
  about_exists?: InputMaybe<Scalars['Boolean']['input']>;
  about_not_contains?: InputMaybe<Scalars['String']['input']>;
  bookNowButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  contactNumber_contains?: InputMaybe<Scalars['String']['input']>;
  contactNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contactNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber_not?: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  copyright_contains?: InputMaybe<Scalars['String']['input']>;
  copyright_exists?: InputMaybe<Scalars['Boolean']['input']>;
  copyright_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  copyright_not?: InputMaybe<Scalars['String']['input']>;
  copyright_not_contains?: InputMaybe<Scalars['String']['input']>;
  copyright_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  exclusivelyAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerPolicyGroupCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLightFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  logo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialNetworksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterButtonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stickyFooterScheduleButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  useDesktopStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  useDesktopStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useDesktopStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useMobileStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfAgendaModalNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAgendaModalNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAgendaModalNestedFilter>>>;
  bodyText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineHeading?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_contains?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineHeading_not?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText?: InputMaybe<Scalars['String']['input']>;
  headlineText_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText_not?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalName?: InputMaybe<Scalars['String']['input']>;
  modalName_contains?: InputMaybe<Scalars['String']['input']>;
  modalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  modalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalName_not?: InputMaybe<Scalars['String']['input']>;
  modalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  modalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfAnalyticsContextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAnalyticsContextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAnalyticsContextNestedFilter>>>;
  appointmentSelectedFacilityId?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSelectedFacilityId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityId_not?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityName?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSelectedFacilityName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appointmentSelectedFacilityName_not?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appointmentSelectedFacilityName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand?: InputMaybe<Scalars['String']['input']>;
  brand_contains?: InputMaybe<Scalars['String']['input']>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brand_not?: InputMaybe<Scalars['String']['input']>;
  brand_not_contains?: InputMaybe<Scalars['String']['input']>;
  brand_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickName?: InputMaybe<Scalars['String']['input']>;
  clickName_contains?: InputMaybe<Scalars['String']['input']>;
  clickName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickName_not?: InputMaybe<Scalars['String']['input']>;
  clickName_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickPosition?: InputMaybe<Scalars['String']['input']>;
  clickPosition_contains?: InputMaybe<Scalars['String']['input']>;
  clickPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickPosition_not?: InputMaybe<Scalars['String']['input']>;
  clickPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickType?: InputMaybe<Scalars['String']['input']>;
  clickType_contains?: InputMaybe<Scalars['String']['input']>;
  clickType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clickType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clickType_not?: InputMaybe<Scalars['String']['input']>;
  clickType_not_contains?: InputMaybe<Scalars['String']['input']>;
  clickType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  errorDetails?: InputMaybe<Scalars['String']['input']>;
  errorDetails_contains?: InputMaybe<Scalars['String']['input']>;
  errorDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorDetails_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorDetails_not?: InputMaybe<Scalars['String']['input']>;
  errorDetails_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorDetails_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorStatus?: InputMaybe<Scalars['String']['input']>;
  errorStatus_contains?: InputMaybe<Scalars['String']['input']>;
  errorStatus_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorStatus_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorStatus_not?: InputMaybe<Scalars['String']['input']>;
  errorStatus_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorStatus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorType?: InputMaybe<Scalars['String']['input']>;
  errorType_contains?: InputMaybe<Scalars['String']['input']>;
  errorType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  errorType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorType_not?: InputMaybe<Scalars['String']['input']>;
  errorType_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventName_contains?: InputMaybe<Scalars['String']['input']>;
  eventName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventName_not?: InputMaybe<Scalars['String']['input']>;
  eventName_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_contains?: InputMaybe<Scalars['String']['input']>;
  event_exists?: InputMaybe<Scalars['Boolean']['input']>;
  event_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  event_not?: InputMaybe<Scalars['String']['input']>;
  event_not_contains?: InputMaybe<Scalars['String']['input']>;
  event_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  linkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkUrl_not?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationType?: InputMaybe<Scalars['String']['input']>;
  navigationType_contains?: InputMaybe<Scalars['String']['input']>;
  navigationType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationType_not?: InputMaybe<Scalars['String']['input']>;
  navigationType_not_contains?: InputMaybe<Scalars['String']['input']>;
  navigationType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  pageName_contains?: InputMaybe<Scalars['String']['input']>;
  pageName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not?: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  pageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  pageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageUrl_not?: InputMaybe<Scalars['String']['input']>;
  pageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteSection?: InputMaybe<Scalars['String']['input']>;
  siteSection_contains?: InputMaybe<Scalars['String']['input']>;
  siteSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  siteSection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteSection_not?: InputMaybe<Scalars['String']['input']>;
  siteSection_not_contains?: InputMaybe<Scalars['String']['input']>;
  siteSection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaName?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_contains?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  socialMediaName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMediaName_not?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_not_contains?: InputMaybe<Scalars['String']['input']>;
  socialMediaName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  virtualPageTitle?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  virtualPageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageTitle_not?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageUrl?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  virtualPageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  virtualPageUrl_not?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  virtualPageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBadgeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBadgeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBadgeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBannerNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBannerNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBannerNestedFilter>>>;
  alertMessagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  mobileAlertMessagesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogAuthorNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogAuthorNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogAuthorNestedFilter>>>;
  authorBioSummary_contains?: InputMaybe<Scalars['String']['input']>;
  authorBioSummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  authorBioSummary_not_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary?: InputMaybe<Scalars['String']['input']>;
  bioSummary_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bioSummary_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bioSummary_not?: InputMaybe<Scalars['String']['input']>;
  bioSummary_not_contains?: InputMaybe<Scalars['String']['input']>;
  bioSummary_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreAboutTheAuthorPagePath?: InputMaybe<Scalars['String']['input']>;
  moreAboutTheAuthorPagePath_contains?: InputMaybe<Scalars['String']['input']>;
  moreAboutTheAuthorPagePath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  moreAboutTheAuthorPagePath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  moreAboutTheAuthorPagePath_not?: InputMaybe<Scalars['String']['input']>;
  moreAboutTheAuthorPagePath_not_contains?: InputMaybe<Scalars['String']['input']>;
  moreAboutTheAuthorPagePath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogCategoryNestedFilter>>>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfBlogDetailsPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogDetailsPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogDetailsPageNestedFilter>>>;
  additionalContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  author_exists?: InputMaybe<Scalars['Boolean']['input']>;
  blogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_exists?: InputMaybe<Scalars['Boolean']['input']>;
  date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  date_not?: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  facilityIds_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityIds_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityIds_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityIds_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroBackgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroBackgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  heroBackgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroButtonCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  heroContentTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heroContentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDesignType?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_contains?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageDesignType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageDesignType_not?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageDesignType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedBlogsContentSection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_contains?: InputMaybe<Scalars['String']['input']>;
  summary_exists?: InputMaybe<Scalars['Boolean']['input']>;
  summary_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  theme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not?: InputMaybe<Scalars['String']['input']>;
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeToRead?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_exists?: InputMaybe<Scalars['Boolean']['input']>;
  timeToRead_gt?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_gte?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeToRead_lt?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_lte?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_not?: InputMaybe<Scalars['Int']['input']>;
  timeToRead_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogListNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogListNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogListNestedFilter>>>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardDesignType?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_contains?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardDesignType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardDesignType_not?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardDesignType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countAcrossDesktop?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countAcrossDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  countAcrossDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossMobile?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  countAcrossMobile_gt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_gte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  countAcrossMobile_lt?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_lte?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_not?: InputMaybe<Scalars['Int']['input']>;
  countAcrossMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  displayType?: InputMaybe<Scalars['String']['input']>;
  displayType_contains?: InputMaybe<Scalars['String']['input']>;
  displayType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayType_not?: InputMaybe<Scalars['String']['input']>;
  displayType_not_contains?: InputMaybe<Scalars['String']['input']>;
  displayType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featuredBlogsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasPagination_not?: InputMaybe<Scalars['Boolean']['input']>;
  heroBlogsListCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreButtonLabel?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadMoreButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loadMoreButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  loadMoreButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subCategory_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tagsFilter_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tagsFilter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfBlogSubCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogSubCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogSubCategoryNestedFilter>>>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfBrandNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBrandNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBrandNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfButtonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfButtonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfButtonNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Scalars['String']['input']>;
  iconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize?: InputMaybe<Scalars['String']['input']>;
  iconSize_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize_not?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  launchCrestaAgent?: InputMaybe<Scalars['Boolean']['input']>;
  launchCrestaAgent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  launchCrestaAgent_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  popoverContentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizDetails_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizSelector?: InputMaybe<Scalars['String']['input']>;
  quizSelector_contains?: InputMaybe<Scalars['String']['input']>;
  quizSelector_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizSelector_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizSelector_not?: InputMaybe<Scalars['String']['input']>;
  quizSelector_not_contains?: InputMaybe<Scalars['String']['input']>;
  quizSelector_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconPosition_not?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconSize?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIconSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonIcon_not?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize?: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonVariant?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_contains?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonVariant_not?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIcon?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIconAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIconAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardIconAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_contains?: InputMaybe<Scalars['String']['input']>;
  cardIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardIcon_not?: InputMaybe<Scalars['String']['input']>;
  cardIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTextAlignment?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardTextAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardTextAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardTextAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventType_contains?: InputMaybe<Scalars['String']['input']>;
  eventType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eventType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType_not?: InputMaybe<Scalars['String']['input']>;
  eventType_not_contains?: InputMaybe<Scalars['String']['input']>;
  eventType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRatio?: InputMaybe<Scalars['String']['input']>;
  imageRatio_contains?: InputMaybe<Scalars['String']['input']>;
  imageRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageRatio_not?: InputMaybe<Scalars['String']['input']>;
  imageRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_contains?: InputMaybe<Scalars['String']['input']>;
  imageUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl_not?: InputMaybe<Scalars['String']['input']>;
  imageUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfDownloadTitle?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pdfDownloadTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfDownloadTitle_not?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pdfDownloadTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdfFileLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  priority_exists?: InputMaybe<Scalars['Boolean']['input']>;
  priority_gt?: InputMaybe<Scalars['Int']['input']>;
  priority_gte?: InputMaybe<Scalars['Int']['input']>;
  priority_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priority_lt?: InputMaybe<Scalars['Int']['input']>;
  priority_lte?: InputMaybe<Scalars['Int']['input']>;
  priority_not?: InputMaybe<Scalars['Int']['input']>;
  priority_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  showBorder?: InputMaybe<Scalars['Boolean']['input']>;
  showBorder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showBorder_not?: InputMaybe<Scalars['Boolean']['input']>;
  slot?: InputMaybe<Scalars['Int']['input']>;
  slot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slot_gt?: InputMaybe<Scalars['Int']['input']>;
  slot_gte?: InputMaybe<Scalars['Int']['input']>;
  slot_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  slot_lt?: InputMaybe<Scalars['Int']['input']>;
  slot_lte?: InputMaybe<Scalars['Int']['input']>;
  slot_not?: InputMaybe<Scalars['Int']['input']>;
  slot_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stepName?: InputMaybe<Scalars['String']['input']>;
  stepName_contains?: InputMaybe<Scalars['String']['input']>;
  stepName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  stepName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stepName_not?: InputMaybe<Scalars['String']['input']>;
  stepName_not_contains?: InputMaybe<Scalars['String']['input']>;
  stepName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText?: InputMaybe<Scalars['String']['input']>;
  tcText_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText_not?: InputMaybe<Scalars['String']['input']>;
  tcText_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcUrl?: InputMaybe<Scalars['String']['input']>;
  tcUrl_contains?: InputMaybe<Scalars['String']['input']>;
  tcUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcUrl_not?: InputMaybe<Scalars['String']['input']>;
  tcUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCategoryNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_contains?: InputMaybe<Scalars['String']['input']>;
  link_exists?: InputMaybe<Scalars['Boolean']['input']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not?: InputMaybe<Scalars['String']['input']>;
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentSectionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentSectionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentSectionNestedFilter>>>;
  alignment?: InputMaybe<Scalars['String']['input']>;
  alignment_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alignment_not?: InputMaybe<Scalars['String']['input']>;
  alignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowHtag_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon?: InputMaybe<Scalars['String']['input']>;
  titleIcon_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon_not?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentTileNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentTileNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentTileNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalPage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfContentTypeRichTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfContentTypeRichTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfContentTypeRichTextNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contained?: InputMaybe<Scalars['Boolean']['input']>;
  contained_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contained_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentMaxWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentMaxWidth_not?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentMaxWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryContent_contains?: InputMaybe<Scalars['String']['input']>;
  secondaryContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHeading?: InputMaybe<Scalars['String']['input']>;
  titleHeading_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHeading_not?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon?: InputMaybe<Scalars['String']['input']>;
  titleIcon_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleIcon_not?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfDisclaimerV2NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfDisclaimerV2NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfDisclaimerV2NestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfError404NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfError404NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfError404NestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImageMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_exists?: InputMaybe<Scalars['Boolean']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkTextColor?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkTextColor_not?: InputMaybe<Scalars['Boolean']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  heading_exists?: InputMaybe<Scalars['Boolean']['input']>;
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not?: InputMaybe<Scalars['String']['input']>;
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplementaryButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfExperienceNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfExperienceNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfExperienceNestedFilter>>>;
  componentSettings_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentTree_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  dataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageMetaInfo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unboundValues_exists?: InputMaybe<Scalars['Boolean']['input']>;
  usedComponentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfExperimentVariationContentsItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfExperimentVariationContentsItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfExperimentVariationContentsItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  variationContentsItemName?: InputMaybe<Scalars['String']['input']>;
  variationContentsItemName_contains?: InputMaybe<Scalars['String']['input']>;
  variationContentsItemName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variationContentsItemName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variationContentsItemName_not?: InputMaybe<Scalars['String']['input']>;
  variationContentsItemName_not_contains?: InputMaybe<Scalars['String']['input']>;
  variationContentsItemName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variationId?: InputMaybe<Scalars['String']['input']>;
  variationId_contains?: InputMaybe<Scalars['String']['input']>;
  variationId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variationId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variationId_not?: InputMaybe<Scalars['String']['input']>;
  variationId_not_contains?: InputMaybe<Scalars['String']['input']>;
  variationId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfFeatureFlagsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFeatureFlagsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFeatureFlagsNestedFilter>>>;
  alternateSchedulingFlowOffices_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alternateSchedulingFlowOffices_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alternateSchedulingFlowOffices_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alternateSchedulingFlowOffices_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  continentalUsMapFallbackThreshold?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_exists?: InputMaybe<Scalars['Boolean']['input']>;
  continentalUsMapFallbackThreshold_gt?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_gte?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  continentalUsMapFallbackThreshold_lt?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_lte?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_not?: InputMaybe<Scalars['Int']['input']>;
  continentalUsMapFallbackThreshold_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  defaultToCdn?: InputMaybe<Scalars['Boolean']['input']>;
  defaultToCdn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultToCdn_not?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite_exists?: InputMaybe<Scalars['Boolean']['input']>;
  doNotIndexWholeSite_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableCcMarketingSourceTransformation?: InputMaybe<Scalars['Boolean']['input']>;
  enableCcMarketingSourceTransformation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableCcMarketingSourceTransformation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFacilityContextInSsr_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFicoTraffic_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableFicoTraffic_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableFicoTraffic_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableFicoTraffic_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFluidTypography_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableFraudCheck_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePageReloadOnOdpLink?: InputMaybe<Scalars['Boolean']['input']>;
  enablePageReloadOnOdpLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePageReloadOnOdpLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePatientPortalPhase2_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePersistOnClearChoiceScheduler?: InputMaybe<Scalars['Boolean']['input']>;
  enablePersistOnClearChoiceScheduler_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePersistOnClearChoiceScheduler_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableProvidersSitemap_not?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enablePtcSlotFilter_not?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enforceContinentalUsZoom_not?: InputMaybe<Scalars['Boolean']['input']>;
  featureList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fetchAllLocationsOnEmptyResults_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderFacilityLocator_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideHeaderSchedulingButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpHeaderLinks_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideProviderWithNoImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideSearchWithLocationCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  loadFacilityReviewsFromBeffe_not?: InputMaybe<Scalars['Boolean']['input']>;
  migrationPaths_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  migrationPaths_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  migrationPaths_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  migrationPaths_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officeRollout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  oneTrust?: InputMaybe<Scalars['Boolean']['input']>;
  oneTrust_exists?: InputMaybe<Scalars['Boolean']['input']>;
  oneTrust_not?: InputMaybe<Scalars['Boolean']['input']>;
  previsitPaperworkLocations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  providerHeroTheme?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_contains?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  providerHeroTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerHeroTheme_not?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_not_contains?: InputMaybe<Scalars['String']['input']>;
  providerHeroTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providersExclusionList_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providersExclusionList_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providersExclusionList_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providersExclusionList_exists?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceEvergageScript?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_contains?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_exists?: InputMaybe<Scalars['Boolean']['input']>;
  salesForceEvergageScript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salesForceEvergageScript_not?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_not_contains?: InputMaybe<Scalars['String']['input']>;
  salesForceEvergageScript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showHeaderNavigationMenu?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderNavigationMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderNavigationMenu_not?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showHeaderWithLocationNav_not?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showMobileHeaderLocationBar_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageCtaInMeetOurStaff_not?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showProviderPageInsuranceInfo_not?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showReadMoreForBioInMeetOurStaff_not?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSetOfficeButtonInGoogleMapsCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  transitionallyUseBeffe?: InputMaybe<Scalars['Boolean']['input']>;
  transitionallyUseBeffe_exists?: InputMaybe<Scalars['Boolean']['input']>;
  transitionallyUseBeffe_not?: InputMaybe<Scalars['Boolean']['input']>;
  updateAddressLocations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFacilityBeffeDataSource_not?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useFilterForOdpDetailsContent_not?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useGoogleMapAutocompleteSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useInlineOneTrust_not?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useSessionStorageFacilityCode_not?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useSimpleFindOfficeLink_not?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withLeadingProviderAssociations_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfFocalPointImageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFocalPointImageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFocalPointImageNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  focalPoint_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfFooterNavigationGroupNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFooterNavigationGroupNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFooterNavigationGroupNestedFilter>>>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  navigationGroupLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupTitle?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_contains?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationGroupTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationGroupTitle_not?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  navigationGroupTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationLinksForGroupCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfGoogleMapTemplateNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfGoogleMapTemplateNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfGoogleMapTemplateNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  availableServicesTabs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopZoom?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  desktopZoom_gt?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_gte?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  desktopZoom_lt?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_lte?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_not?: InputMaybe<Scalars['Float']['input']>;
  desktopZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  disableMarkerClick?: InputMaybe<Scalars['Boolean']['input']>;
  disableMarkerClick_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableMarkerClick_not?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBadgeLabel?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBadgeLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBadgeLabel_not?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBadgeLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBasePath?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityBasePath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityBasePath_not?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityBasePath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityButtonLabel?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilityButtonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityButtonLabel_not?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilityButtonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_exists?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsBusinessQuery_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleMapsBusinessQuery_not?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_contains?: InputMaybe<Scalars['String']['input']>;
  googleMapsBusinessQuery_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hideLocationCardButtons?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationCardButtons_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationCardButtons_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationsListOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationsListOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideLocationsListOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideOfficeDetailsButton?: InputMaybe<Scalars['Boolean']['input']>;
  hideOfficeDetailsButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideOfficeDetailsButton_not?: InputMaybe<Scalars['Boolean']['input']>;
  holidayHoursMessageText?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_contains?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  holidayHoursMessageText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  holidayHoursMessageText_not?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_not_contains?: InputMaybe<Scalars['String']['input']>;
  holidayHoursMessageText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listTabIsHorizontalScrolling?: InputMaybe<Scalars['Boolean']['input']>;
  listTabIsHorizontalScrolling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  listTabIsHorizontalScrolling_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationScheduleButtonUrl?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationScheduleButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationScheduleButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationScheduleButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileZoom?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileZoom_gt?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_gte?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  mobileZoom_lt?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_lte?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_not?: InputMaybe<Scalars['Float']['input']>;
  mobileZoom_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noResultsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundMessage_contains?: InputMaybe<Scalars['String']['input']>;
  noResultsFoundMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  noResultsFoundMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  officeDetailsButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRadius?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchRadius_gt?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_gte?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchRadius_lt?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_lte?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_not?: InputMaybe<Scalars['Int']['input']>;
  searchRadius_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchResultLimit?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchResultLimit_gt?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_gte?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  searchResultLimit_lt?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_lte?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_not?: InputMaybe<Scalars['Int']['input']>;
  searchResultLimit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  selectedImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  service_contains?: InputMaybe<Scalars['String']['input']>;
  service_exists?: InputMaybe<Scalars['Boolean']['input']>;
  service_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  service_not?: InputMaybe<Scalars['String']['input']>;
  service_not_contains?: InputMaybe<Scalars['String']['input']>;
  service_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setAsOfficeButtonText?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  setAsOfficeButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setAsOfficeButtonText_not?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  setAsOfficeButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  singleComingSoonMessage_contains?: InputMaybe<Scalars['String']['input']>;
  singleComingSoonMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  singleComingSoonMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useCumulativeDesign?: InputMaybe<Scalars['Boolean']['input']>;
  useCumulativeDesign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useCumulativeDesign_not?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useModernDesign_not?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useUsaCountryMap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfHeaderMainNavNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeaderMainNavNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeaderMainNavNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerMainNavLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSubNavMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfHeaderNavMenuNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeaderNavMenuNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeaderNavMenuNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headerMainNavLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfHeaderNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeaderNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeaderNestedFilter>>>;
  bookNowButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName?: InputMaybe<Scalars['String']['input']>;
  componentName_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not?: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains?: InputMaybe<Scalars['String']['input']>;
  componentName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  darkHeader?: InputMaybe<Scalars['Boolean']['input']>;
  darkHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  darkHeader_not?: InputMaybe<Scalars['Boolean']['input']>;
  googleMapsForLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideFullSiteSearch_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpLinks?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpLinks_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideOdpLinks_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarFindOfficeUrl?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarFindOfficeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarFindOfficeUrl_not?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarFindOfficeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOfficeTitle?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarWithOfficeTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOfficeTitle_not?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOfficeTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOutOfficeTitle?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  locationBarWithOutOfficeTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationBarWithOutOfficeTitle_not?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  locationBarWithOutOfficeTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileQuizLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  myAccountLabel?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_contains?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  myAccountLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  myAccountLabel_not?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  myAccountLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  navigationMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profileLinkUrl?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_contains?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  profileLinkUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profileLinkUrl_not?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  profileLinkUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonTextMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonTextMobile_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonTextMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonText_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonUrlMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrlMobile_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrlMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  schedulingButtonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingButtonUrl_not?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  schedulingButtonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schedulingNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchFieldTitle?: InputMaybe<Scalars['String']['input']>;
  searchFieldTitle_contains?: InputMaybe<Scalars['String']['input']>;
  searchFieldTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  searchFieldTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchFieldTitle_not?: InputMaybe<Scalars['String']['input']>;
  searchFieldTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  searchFieldTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secondaryNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSecondaryNavInMobileToolbar_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  topAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  topNavigationLinksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useHeaderLocationCards_not?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useNewLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling_exists?: InputMaybe<Scalars['Boolean']['input']>;
  usePopupScheduling_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfHeaderSubNavNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeaderSubNavNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeaderSubNavNestedFilter>>>;
  contentTilesCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  featuredLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSubNavGroupsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfIframeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfIframeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfIframeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawHtml?: InputMaybe<Scalars['String']['input']>;
  rawHtml_contains?: InputMaybe<Scalars['String']['input']>;
  rawHtml_exists?: InputMaybe<Scalars['Boolean']['input']>;
  rawHtml_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rawHtml_not?: InputMaybe<Scalars['String']['input']>;
  rawHtml_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawHtml_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfImageAssetNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfImageAssetNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfImageAssetNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfListItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfListItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfListItemNestedFilter>>>;
  brandfolderSvgUrl?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  brandfolderSvgUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandfolderSvgUrl_not?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandfolderSvgUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon?: InputMaybe<Scalars['String']['input']>;
  muiIcon_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  muiIcon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  muiIcon_not?: InputMaybe<Scalars['String']['input']>;
  muiIcon_not_contains?: InputMaybe<Scalars['String']['input']>;
  muiIcon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfMediaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMediaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMediaNestedFilter>>>;
  alt?: InputMaybe<Scalars['String']['input']>;
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  alt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alt_not?: InputMaybe<Scalars['String']['input']>;
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poster?: InputMaybe<Scalars['String']['input']>;
  poster_contains?: InputMaybe<Scalars['String']['input']>;
  poster_exists?: InputMaybe<Scalars['Boolean']['input']>;
  poster_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poster_not?: InputMaybe<Scalars['String']['input']>;
  poster_not_contains?: InputMaybe<Scalars['String']['input']>;
  poster_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  src?: InputMaybe<Scalars['String']['input']>;
  src_contains?: InputMaybe<Scalars['String']['input']>;
  src_exists?: InputMaybe<Scalars['Boolean']['input']>;
  src_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  src_not?: InputMaybe<Scalars['String']['input']>;
  src_not_contains?: InputMaybe<Scalars['String']['input']>;
  src_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfMediaSliderNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMediaSliderNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMediaSliderNestedFilter>>>;
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_exists?: InputMaybe<Scalars['Boolean']['input']>;
  aspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspectRatio_not?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_contains?: InputMaybe<Scalars['String']['input']>;
  aspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  badge_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfMedicalServiceNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMedicalServiceNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMedicalServiceNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName?: InputMaybe<Scalars['String']['input']>;
  iconName_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconName_not?: InputMaybe<Scalars['String']['input']>;
  iconName_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfMobileButtonNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMobileButtonNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMobileButtonNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconPosition?: InputMaybe<Scalars['String']['input']>;
  iconPosition_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconPosition_not?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size?: InputMaybe<Scalars['String']['input']>;
  size_contains?: InputMaybe<Scalars['String']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size_not?: InputMaybe<Scalars['String']['input']>;
  size_not_contains?: InputMaybe<Scalars['String']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfMultiCardV2NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMultiCardV2NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMultiCardV2NestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bigScreenBackground_not?: InputMaybe<Scalars['Boolean']['input']>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardsAlignment?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  cardsAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardsAlignment_not?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  cardsAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionRichText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionRichText_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayAsStepper?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsStepper_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsStepper_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enableMobileCarouselNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  enableMobileCarouselNavigation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableMobileCarouselNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode_exists?: InputMaybe<Scalars['Boolean']['input']>;
  enableResourceCardMode_not?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowColor?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowColor_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSx?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSx_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSx_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSx_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowTextTransform?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowTextTransform_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowTextTransform_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowTextTransform_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixBackgroundToBottom?: InputMaybe<Scalars['Boolean']['input']>;
  fixBackgroundToBottom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fixBackgroundToBottom_not?: InputMaybe<Scalars['Boolean']['input']>;
  forMobile?: InputMaybe<Scalars['String']['input']>;
  forMobile_contains?: InputMaybe<Scalars['String']['input']>;
  forMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  forMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  forMobile_not?: InputMaybe<Scalars['String']['input']>;
  forMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  forMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSpacing?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_contains?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSpacing_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSpacing_not?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerSpacing_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRowCardsAlignment?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  lastRowCardsAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastRowCardsAlignment_not?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastRowCardsAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noResultsContent_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCardsInLineDesktop?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfCardsInLineDesktop_gt?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_gte?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfCardsInLineDesktop_lt?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_lte?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_not?: InputMaybe<Scalars['Int']['input']>;
  numberOfCardsInLineDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  roundedImage?: InputMaybe<Scalars['Boolean']['input']>;
  roundedImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  roundedImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  sectionEyebrow?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionEyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionEyebrow_not?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionEyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionInfoAlignment?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_contains?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionInfoAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionInfoAlignment_not?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionInfoAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitleHtag_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sectionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionTitle_not?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  sectionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shouldDisplayCarouselOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCarouselOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDisplayCarouselOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCardFour_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardFour_exists?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCardFour_not_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardThree_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardThree_exists?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCardThree_not_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardTwo_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCardTwo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCardTwo_not_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCard_contains?: InputMaybe<Scalars['String']['input']>;
  simpleCard_exists?: InputMaybe<Scalars['Boolean']['input']>;
  simpleCard_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  useCardMediaRoundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  useCardMediaRoundedCorners_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useCardMediaRoundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfNavigationGroupNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationGroupNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationGroupNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayAsExpandedForMobileMenu?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsExpandedForMobileMenu_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayAsExpandedForMobileMenu_not?: InputMaybe<Scalars['Boolean']['input']>;
  groupLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linksCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfNavigationLinkNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationLinkNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationLinkNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_not?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  externalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal_not?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLocalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  linkIcon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  openInNewWindow_not?: InputMaybe<Scalars['Boolean']['input']>;
  pageData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPageLayoutNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPageLayoutNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPageLayoutNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disableFixedHeaderOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableFixedHeaderOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableFixedHeaderOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooter?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooter_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooter_not?: InputMaybe<Scalars['Boolean']['input']>;
  footerSlug?: InputMaybe<Scalars['String']['input']>;
  footerSlug_contains?: InputMaybe<Scalars['String']['input']>;
  footerSlug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  footerSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  footerSlug_not?: InputMaybe<Scalars['String']['input']>;
  footerSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  footerSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSlug?: InputMaybe<Scalars['String']['input']>;
  headerSlug_contains?: InputMaybe<Scalars['String']['input']>;
  headerSlug_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headerSlug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headerSlug_not?: InputMaybe<Scalars['String']['input']>;
  headerSlug_not_contains?: InputMaybe<Scalars['String']['input']>;
  headerSlug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPageMetaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPageMetaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPageMetaNestedFilter>>>;
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalUrl_not?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structuredDataCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  appName_contains?: InputMaybe<Scalars['String']['input']>;
  appName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  appName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appName_not?: InputMaybe<Scalars['String']['input']>;
  appName_not_contains?: InputMaybe<Scalars['String']['input']>;
  appName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbTitle?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_contains?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  breadcrumbTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbTitle_not?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  breadcrumbTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  breadcrumbsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical?: InputMaybe<Scalars['String']['input']>;
  canonical_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_exists?: InputMaybe<Scalars['Boolean']['input']>;
  canonical_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonical_not?: InputMaybe<Scalars['String']['input']>;
  canonical_not_contains?: InputMaybe<Scalars['String']['input']>;
  canonical_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  contentsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disableChatBot?: InputMaybe<Scalars['Boolean']['input']>;
  disableChatBot_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableChatBot_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderBottomAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableHeaderTopAlertBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnDesktop_not?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  disableStickyFooterOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hideScheduleButtonInHeader_not?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_exists?: InputMaybe<Scalars['Boolean']['input']>;
  indexed_not?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBreadcrumbTitle?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_contains?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileBreadcrumbTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileBreadcrumbTitle_not?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  mobileBreadcrumbTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTheme?: InputMaybe<Scalars['String']['input']>;
  pageTheme_contains?: InputMaybe<Scalars['String']['input']>;
  pageTheme_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTheme_not?: InputMaybe<Scalars['String']['input']>;
  pageTheme_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_exists?: InputMaybe<Scalars['Boolean']['input']>;
  path_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalized?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathPrefix?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathPrefix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathPrefix_not?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_not_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathPrefix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathSuffix?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalizedPathSuffix_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalizedPathSuffix_not?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_not_contains?: InputMaybe<Scalars['String']['input']>;
  personalizedPathSuffix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  personalized_exists?: InputMaybe<Scalars['Boolean']['input']>;
  personalized_not?: InputMaybe<Scalars['Boolean']['input']>;
  redirectFrom_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectFrom_exists?: InputMaybe<Scalars['Boolean']['input']>;
  redirectTo?: InputMaybe<Scalars['String']['input']>;
  redirectTo_contains?: InputMaybe<Scalars['String']['input']>;
  redirectTo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  redirectTo_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  redirectTo_not?: InputMaybe<Scalars['String']['input']>;
  redirectTo_not_contains?: InputMaybe<Scalars['String']['input']>;
  redirectTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tags_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfPatientReviewV2NestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPatientReviewV2NestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPatientReviewV2NestedFilter>>>;
  avatar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  score?: InputMaybe<Scalars['Int']['input']>;
  score_exists?: InputMaybe<Scalars['Boolean']['input']>;
  score_gt?: InputMaybe<Scalars['Int']['input']>;
  score_gte?: InputMaybe<Scalars['Int']['input']>;
  score_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  score_lt?: InputMaybe<Scalars['Int']['input']>;
  score_lte?: InputMaybe<Scalars['Int']['input']>;
  score_not?: InputMaybe<Scalars['Int']['input']>;
  score_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subText1?: InputMaybe<Scalars['String']['input']>;
  subText1_contains?: InputMaybe<Scalars['String']['input']>;
  subText1_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText1_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText1_not?: InputMaybe<Scalars['String']['input']>;
  subText1_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText1_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText2?: InputMaybe<Scalars['String']['input']>;
  subText2_contains?: InputMaybe<Scalars['String']['input']>;
  subText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText2_not?: InputMaybe<Scalars['String']['input']>;
  subText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfProductFeatureDescriptionListItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfProductFeatureDescriptionListItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfProductFeatureDescriptionListItemNestedFilter>>>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']['input']>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfQuestionAnswerNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfQuestionAnswerNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfQuestionAnswerNestedFilter>>>;
  answer_contains?: InputMaybe<Scalars['String']['input']>;
  answer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  answer_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  question?: InputMaybe<Scalars['String']['input']>;
  question_contains?: InputMaybe<Scalars['String']['input']>;
  question_exists?: InputMaybe<Scalars['Boolean']['input']>;
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_not?: InputMaybe<Scalars['String']['input']>;
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfQuestionnaireNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfQuestionnaireNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfQuestionnaireNestedFilter>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  defaultErrorMessage?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  defaultErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  defaultErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subTitle_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subTitle_not?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfQuizNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfQuizNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfQuizNestedFilter>>>;
  brand_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearChoicePoorCreditRedirectPath?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_contains?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_exists?: InputMaybe<Scalars['Boolean']['input']>;
  clearChoicePoorCreditRedirectPath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clearChoicePoorCreditRedirectPath_not?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_not_contains?: InputMaybe<Scalars['String']['input']>;
  clearChoicePoorCreditRedirectPath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  formBuilderConfig_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isFormBuilder_not?: InputMaybe<Scalars['Boolean']['input']>;
  leadGenPopUpImageDesktop?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageDesktop_contains?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageDesktop_exists?: InputMaybe<Scalars['Boolean']['input']>;
  leadGenPopUpImageDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leadGenPopUpImageDesktop_not?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageDesktop_not_contains?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leadGenPopUpImageMobile?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageMobile_contains?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageMobile_exists?: InputMaybe<Scalars['Boolean']['input']>;
  leadGenPopUpImageMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leadGenPopUpImageMobile_not?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  leadGenPopUpImageMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizFormData_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizType?: InputMaybe<Scalars['String']['input']>;
  quizType_contains?: InputMaybe<Scalars['String']['input']>;
  quizType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  quizType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quizType_not?: InputMaybe<Scalars['String']['input']>;
  quizType_not_contains?: InputMaybe<Scalars['String']['input']>;
  quizType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  submitEndpointUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitEndpointUrl_not?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  submitEndpointUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfSchemaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSchemaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSchemaNestedFilter>>>;
  combinedSchema?: InputMaybe<Scalars['Boolean']['input']>;
  combinedSchema_exists?: InputMaybe<Scalars['Boolean']['input']>;
  combinedSchema_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schema_exists?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfServiceNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfServiceNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfServiceNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType?: InputMaybe<Scalars['String']['input']>;
  buttonType_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_not?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  centerAlign_not?: InputMaybe<Scalars['Boolean']['input']>;
  contained?: InputMaybe<Scalars['Boolean']['input']>;
  contained_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contained_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  direction_contains?: InputMaybe<Scalars['String']['input']>;
  direction_exists?: InputMaybe<Scalars['Boolean']['input']>;
  direction_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction_not?: InputMaybe<Scalars['String']['input']>;
  direction_not_contains?: InputMaybe<Scalars['String']['input']>;
  direction_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageLayout?: InputMaybe<Scalars['String']['input']>;
  imageLayout_contains?: InputMaybe<Scalars['String']['input']>;
  imageLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageLayout_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageLayout_not?: InputMaybe<Scalars['String']['input']>;
  imageLayout_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageLayout_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  mediaType_contains?: InputMaybe<Scalars['String']['input']>;
  mediaType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaType_not?: InputMaybe<Scalars['String']['input']>;
  mediaType_not_contains?: InputMaybe<Scalars['String']['input']>;
  mediaType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  richTextDescription_contains?: InputMaybe<Scalars['String']['input']>;
  richTextDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  richTextDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  sys?: InputMaybe<SysFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleHtag?: InputMaybe<Scalars['String']['input']>;
  titleHtag_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleHtag_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleHtag_not?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleHtag_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youTubeVideoId?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_contains?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youTubeVideoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeVideoId_not?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  youTubeVideoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youTubeVideoImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfSharedFormDefinitionsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSharedFormDefinitionsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSharedFormDefinitionsNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  createNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  createNewLine_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createNewLine_not?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionFont?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionFont_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionFont_not?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionFont_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayDefinition?: InputMaybe<Scalars['Boolean']['input']>;
  displayDefinition_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayDefinition_not?: InputMaybe<Scalars['Boolean']['input']>;
  divider?: InputMaybe<Scalars['Boolean']['input']>;
  divider_exists?: InputMaybe<Scalars['Boolean']['input']>;
  divider_not?: InputMaybe<Scalars['Boolean']['input']>;
  formFieldsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  needLabel?: InputMaybe<Scalars['Boolean']['input']>;
  needLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSize?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSize_gt?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_gte?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  phoneSize_lt?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_lte?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_not?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  size?: InputMaybe<Scalars['Float']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  size_not?: InputMaybe<Scalars['Float']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleFont?: InputMaybe<Scalars['String']['input']>;
  titleFont_contains?: InputMaybe<Scalars['String']['input']>;
  titleFont_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleFont_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleFont_not?: InputMaybe<Scalars['String']['input']>;
  titleFont_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleFont_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSharedFormFieldNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSharedFormFieldNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSharedFormFieldNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  createNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  createNewLine_exists?: InputMaybe<Scalars['Boolean']['input']>;
  createNewLine_not?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['String']['input']>;
  default_contains?: InputMaybe<Scalars['String']['input']>;
  default_exists?: InputMaybe<Scalars['Boolean']['input']>;
  default_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  default_not?: InputMaybe<Scalars['String']['input']>;
  default_not_contains?: InputMaybe<Scalars['String']['input']>;
  default_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dependency_exists?: InputMaybe<Scalars['Boolean']['input']>;
  divider?: InputMaybe<Scalars['Boolean']['input']>;
  divider_exists?: InputMaybe<Scalars['Boolean']['input']>;
  divider_not?: InputMaybe<Scalars['Boolean']['input']>;
  enum_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enum_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enum_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enum_exists?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  field_contains?: InputMaybe<Scalars['String']['input']>;
  field_exists?: InputMaybe<Scalars['Boolean']['input']>;
  field_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field_not?: InputMaybe<Scalars['String']['input']>;
  field_not_contains?: InputMaybe<Scalars['String']['input']>;
  field_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  format?: InputMaybe<Scalars['String']['input']>;
  format_contains?: InputMaybe<Scalars['String']['input']>;
  format_exists?: InputMaybe<Scalars['Boolean']['input']>;
  format_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  format_not?: InputMaybe<Scalars['String']['input']>;
  format_not_contains?: InputMaybe<Scalars['String']['input']>;
  format_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  items_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  minLength_exists?: InputMaybe<Scalars['Boolean']['input']>;
  minLength_gt?: InputMaybe<Scalars['Int']['input']>;
  minLength_gte?: InputMaybe<Scalars['Int']['input']>;
  minLength_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minLength_lt?: InputMaybe<Scalars['Int']['input']>;
  minLength_lte?: InputMaybe<Scalars['Int']['input']>;
  minLength_not?: InputMaybe<Scalars['Int']['input']>;
  minLength_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  needOuterLabel?: InputMaybe<Scalars['Boolean']['input']>;
  needOuterLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  needOuterLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSize?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSize_gt?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_gte?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  phoneSize_lt?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_lte?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_not?: InputMaybe<Scalars['Float']['input']>;
  phoneSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  placeHolder?: InputMaybe<Scalars['String']['input']>;
  placeHolder_contains?: InputMaybe<Scalars['String']['input']>;
  placeHolder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  placeHolder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  placeHolder_not?: InputMaybe<Scalars['String']['input']>;
  placeHolder_not_contains?: InputMaybe<Scalars['String']['input']>;
  placeHolder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  required_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  size_not?: InputMaybe<Scalars['Float']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_exists?: InputMaybe<Scalars['Boolean']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSingleMessageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSingleMessageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSingleMessageNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize?: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType?: InputMaybe<Scalars['String']['input']>;
  buttonType_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonType_not?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign?: InputMaybe<Scalars['String']['input']>;
  contentAlign_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentAlign_not?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentFillVerticalSpace?: InputMaybe<Scalars['Boolean']['input']>;
  contentFillVerticalSpace_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentFillVerticalSpace_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  displayTitleInline?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitleInline_exists?: InputMaybe<Scalars['Boolean']['input']>;
  displayTitleInline_not?: InputMaybe<Scalars['Boolean']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconSize?: InputMaybe<Scalars['String']['input']>;
  iconSize_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  iconSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconSize_not?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  iconSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains?: InputMaybe<Scalars['String']['input']>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not?: InputMaybe<Scalars['String']['input']>;
  icon_not_contains?: InputMaybe<Scalars['String']['input']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageLeftSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageRightSide_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isBannerImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isHeaderAboveSideImages_not?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isInlineLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showSubscriptionForm?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriptionForm_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriptionForm_not?: InputMaybe<Scalars['Boolean']['input']>;
  subText?: InputMaybe<Scalars['String']['input']>;
  subText_contains?: InputMaybe<Scalars['String']['input']>;
  subText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  subText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subText_not?: InputMaybe<Scalars['String']['input']>;
  subText_not_contains?: InputMaybe<Scalars['String']['input']>;
  subText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateHeight?: InputMaybe<Scalars['String']['input']>;
  templateHeight_contains?: InputMaybe<Scalars['String']['input']>;
  templateHeight_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateHeight_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateHeight_not?: InputMaybe<Scalars['String']['input']>;
  templateHeight_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateHeight_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth?: InputMaybe<Scalars['String']['input']>;
  templateWidth_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  templateWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateWidth_not?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  templateWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleAlign?: InputMaybe<Scalars['String']['input']>;
  titleAlign_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlign_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleAlign_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleAlign_not?: InputMaybe<Scalars['String']['input']>;
  titleAlign_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleAlign_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant?: InputMaybe<Scalars['String']['input']>;
  titleVariant_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleVariant_not?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useRoundedCorners?: InputMaybe<Scalars['Boolean']['input']>;
  useRoundedCorners_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useRoundedCorners_not?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSmallScreenContentNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSmallScreenContentNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSmallScreenContentNestedFilter>>>;
  bodySmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  bodySmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bodySmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  controllableVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName?: InputMaybe<Scalars['String']['input']>;
  entryName_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  entryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryName_not?: InputMaybe<Scalars['String']['input']>;
  entryName_not_contains?: InputMaybe<Scalars['String']['input']>;
  entryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreen?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrowSmallScreen_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrowSmallScreen_not?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrowSmallScreen_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focalPointImageSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSmallScreen_contains?: InputMaybe<Scalars['String']['input']>;
  headingSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headingSmallScreen_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mediaFirst_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  videoSmallScreen_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfSuccessCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSuccessCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSuccessCardNestedFilter>>>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonLink_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cardImage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  descriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionText_not?: InputMaybe<Scalars['String']['input']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  descriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAltText?: InputMaybe<Scalars['String']['input']>;
  imageAltText_contains?: InputMaybe<Scalars['String']['input']>;
  imageAltText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  imageAltText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAltText_not?: InputMaybe<Scalars['String']['input']>;
  imageAltText_not_contains?: InputMaybe<Scalars['String']['input']>;
  imageAltText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  titleText?: InputMaybe<Scalars['String']['input']>;
  titleText_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  titleText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleText_not?: InputMaybe<Scalars['String']['input']>;
  titleText_not_contains?: InputMaybe<Scalars['String']['input']>;
  titleText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTabNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTabNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTabNestedFilter>>>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  jumplinkName?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_contains?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jumplinkName_not?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_not_contains?: InputMaybe<Scalars['String']['input']>;
  jumplinkName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfTabsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTabsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTabsNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  jumplinkTabs?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkTabs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  jumplinkTabs_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tabRowVariant?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_contains?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabRowVariant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabRowVariant_not?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabRowVariant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabsSize?: InputMaybe<Scalars['String']['input']>;
  tabsSize_contains?: InputMaybe<Scalars['String']['input']>;
  tabsSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tabsSize_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tabsSize_not?: InputMaybe<Scalars['String']['input']>;
  tabsSize_not_contains?: InputMaybe<Scalars['String']['input']>;
  tabsSize_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withContentInnerGap?: InputMaybe<Scalars['Boolean']['input']>;
  withContentInnerGap_exists?: InputMaybe<Scalars['Boolean']['input']>;
  withContentInnerGap_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfTermsAndConditionsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTermsAndConditionsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTermsAndConditionsNestedFilter>>>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineText?: InputMaybe<Scalars['String']['input']>;
  headlineText_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  headlineText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  headlineText_not?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_contains?: InputMaybe<Scalars['String']['input']>;
  headlineText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showTcTextAs?: InputMaybe<Scalars['Boolean']['input']>;
  showTcTextAs_exists?: InputMaybe<Scalars['Boolean']['input']>;
  showTcTextAs_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  tcLink?: InputMaybe<Scalars['String']['input']>;
  tcLink_contains?: InputMaybe<Scalars['String']['input']>;
  tcLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcLink_not?: InputMaybe<Scalars['String']['input']>;
  tcLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText?: InputMaybe<Scalars['String']['input']>;
  tcText_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tcText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tcText_not?: InputMaybe<Scalars['String']['input']>;
  tcText_not_contains?: InputMaybe<Scalars['String']['input']>;
  tcText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfVideoAssetNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfVideoAssetNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfVideoAssetNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  mobileVideo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfVideoNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfVideoNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfVideoNestedFilter>>>;
  adjustedWidth?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  adjustedWidth_gt?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_gte?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  adjustedWidth_lt?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_lte?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_not?: InputMaybe<Scalars['Int']['input']>;
  adjustedWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  autoPlay_exists?: InputMaybe<Scalars['Boolean']['input']>;
  autoPlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hlsVideoStreamLink?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_contains?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  hlsVideoStreamLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hlsVideoStreamLink_not?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  hlsVideoStreamLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isLooped?: InputMaybe<Scalars['Boolean']['input']>;
  isLooped_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isLooped_not?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted_exists?: InputMaybe<Scalars['Boolean']['input']>;
  isMuted_not?: InputMaybe<Scalars['Boolean']['input']>;
  media_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posterMedia_exists?: InputMaybe<Scalars['Boolean']['input']>;
  posterUrl?: InputMaybe<Scalars['String']['input']>;
  posterUrl_contains?: InputMaybe<Scalars['String']['input']>;
  posterUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  posterUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  posterUrl_not?: InputMaybe<Scalars['String']['input']>;
  posterUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  posterUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  useOriginalVideoSize?: InputMaybe<Scalars['Boolean']['input']>;
  useOriginalVideoSize_exists?: InputMaybe<Scalars['Boolean']['input']>;
  useOriginalVideoSize_not?: InputMaybe<Scalars['Boolean']['input']>;
  videoSource?: InputMaybe<Scalars['String']['input']>;
  videoSource_contains?: InputMaybe<Scalars['String']['input']>;
  videoSource_exists?: InputMaybe<Scalars['Boolean']['input']>;
  videoSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoSource_not?: InputMaybe<Scalars['String']['input']>;
  videoSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  videoSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
  youtubeId_contains?: InputMaybe<Scalars['String']['input']>;
  youtubeId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  youtubeId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtubeId_not?: InputMaybe<Scalars['String']['input']>;
  youtubeId_not_contains?: InputMaybe<Scalars['String']['input']>;
  youtubeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfVideoWithContentNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfVideoWithContentNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfVideoWithContentNestedFilter>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  video_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfaccordionsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfaccordionsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfaccordionsMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfadditionalContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfadditionalContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfadditionalContentMultiTypeNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfbottomContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfbottomContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfbottomContentMultiTypeNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant?: InputMaybe<Scalars['String']['input']>;
  variant_contains?: InputMaybe<Scalars['String']['input']>;
  variant_exists?: InputMaybe<Scalars['Boolean']['input']>;
  variant_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  variant_not?: InputMaybe<Scalars['String']['input']>;
  variant_not_contains?: InputMaybe<Scalars['String']['input']>;
  variant_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcolumnsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcolumnsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcolumnsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfcontentListBelowButtonsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentListBelowButtonsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentListBelowButtonsMultiTypeNestedFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_contains?: InputMaybe<Scalars['String']['input']>;
  content_exists?: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disablePaddingOn_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disablePaddingOn_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  display_contains?: InputMaybe<Scalars['String']['input']>;
  display_exists?: InputMaybe<Scalars['Boolean']['input']>;
  display_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_not?: InputMaybe<Scalars['String']['input']>;
  display_not_contains?: InputMaybe<Scalars['String']['input']>;
  display_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  facilitySegmentCollection_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilitySegmentCollection_not?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_contains?: InputMaybe<Scalars['String']['input']>;
  facilitySegmentCollection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullWidth?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullWidth_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcontentListMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentListMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentListMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfcontentsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfformFieldMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfformFieldMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfformFieldMultiTypeNestedFilter>>>;
  alertMessage?: InputMaybe<Scalars['String']['input']>;
  alertMessage_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_exists?: InputMaybe<Scalars['Boolean']['input']>;
  alertMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  alertMessage_not?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  alertMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_exists?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey_not?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  apiKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_exists?: InputMaybe<Scalars['Boolean']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  required_exists?: InputMaybe<Scalars['Boolean']['input']>;
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfformMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfformMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfformMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CflocationNavigationLinksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CflocationNavigationLinksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CflocationNavigationLinksMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfmediaContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfmediaContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfmediaContentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfnavigationLinksForGroupMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfnavigationLinksForGroupMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfnavigationLinksForGroupMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfnavigationLinksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfnavigationLinksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfnavigationLinksMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CfpopoverContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfpopoverContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfpopoverContentMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfrotationContentMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfrotationContentMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfrotationContentMultiTypeNestedFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']['input']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']['input']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonUrl_not?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow?: InputMaybe<Scalars['String']['input']>;
  eyebrow_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eyebrow_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyebrow_not?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_contains?: InputMaybe<Scalars['String']['input']>;
  eyebrow_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  tc_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfsecondaryContentsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfsecondaryContentsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfsecondaryContentsMultiTypeNestedFilter>>>;
  anchorId?: InputMaybe<Scalars['String']['input']>;
  anchorId_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_exists?: InputMaybe<Scalars['Boolean']['input']>;
  anchorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  anchorId_not?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  anchorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfsecondaryNavigationLinksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfsecondaryNavigationLinksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfsecondaryNavigationLinksMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfstepsMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfstepsMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfstepsMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CftopNavigationLinksMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CftopNavigationLinksMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CftopNavigationLinksMultiTypeNestedFilter>>>;
  analyticsContext_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AccordionFragment = (
  { __typename?: 'Accordions', title?: string | null, titleHtag?: string | null, titleColor?: string | null, centerAlign?: boolean | null, fullWidth?: boolean | null, disablePaddingOn?: Array<string | null> | null, imagePositionRight?: boolean | null, imageRoundedCorner?: string | null, titleAlignment?: string | null, descriptionAlignment?: string | null, backgroundColor?: string | null, expandIconType?: string | null, expandIconPosition?: string | null, roundedCornersSize?: string | null, withInnerGap?: boolean | null, anchorId?: string | null, allowMultipleExpanded?: boolean | null, defaultExpanded?: boolean | null, descriptionRichText?: { __typename?: 'AccordionsDescriptionRichText', json: any } | null, image?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, backgroundImage?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, accordionsCollection?: { __typename?: 'AccordionsAccordionsCollection', items: Array<(
      { __typename?: 'AgendaStepper' }
      & Meta_AgendaStepper_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | null> } | null, buttonsCollection?: { __typename?: 'AccordionsButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_Accordions_Fragment
);

export type AgendaModalFragment = (
  { __typename?: 'AgendaModal', headlineText?: string | null, headlineHeading?: string | null, icon?: string | null, bodyText?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextFragment
  ) | null }
  & Meta_AgendaModal_Fragment
);

export type AnalyticsFragment = { __typename?: 'AnalyticsContext', brand?: string | null, event?: string | null, pageUrl?: string | null, pageName?: string | null, linkUrl?: string | null, linkText?: string | null, clickName?: string | null, clickPosition?: string | null, siteSection?: string | null, virtualPageUrl?: string | null, virtualPageTitle?: string | null, appointmentSelectedFacilityId?: string | null, appointmentSelectedFacilityName?: string | null };

export type BannerFragment = (
  { __typename?: 'Banner', variant?: string | null, alertMessagesCollection?: { __typename?: 'BannerAlertMessagesCollection', items: Array<{ __typename: 'ContentTypeRichText', backgroundColor?: string | null, facilitySegmentCollection?: string | null, content?: { __typename?: 'ContentTypeRichTextContent', json: any } | null } | null> } | null, mobileAlertMessagesCollection?: { __typename?: 'BannerMobileAlertMessagesCollection', items: Array<{ __typename: 'ContentTypeRichText', backgroundColor?: string | null, facilitySegmentCollection?: string | null, content?: { __typename?: 'ContentTypeRichTextContent', json: any } | null } | null> } | null }
  & Meta_Banner_Fragment
);

export type BlogAuthorFragment = (
  { __typename?: 'BlogAuthor', title?: string | null, name?: string | null, image?: any | null, moreAboutTheAuthorPagePath?: string | null, authorBioSummary?: (
    { __typename?: 'BlogAuthorAuthorBioSummary' }
    & BlogAuthorAuthorBioSummaryFragment
  ) | null }
  & Meta_BlogAuthor_Fragment
);

export type BlogAuthorAuthorBioSummaryAssetsFragment = { __typename?: 'BlogAuthorAuthorBioSummaryAssets', block: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null> };

export type BlogAuthorAuthorBioSummaryEntriesFragment = { __typename?: 'BlogAuthorAuthorBioSummaryEntries', inline: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, block: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null> };

export type BlogAuthorAuthorBioSummaryResourcesFragment = { __typename?: 'BlogAuthorAuthorBioSummaryResources', block: Array<(
    { __typename?: 'BlogAuthorAuthorBioSummaryResourcesBlock' }
    & ResourceMeta_BlogAuthorAuthorBioSummaryResourcesBlock_Fragment
  )>, inline: Array<(
    { __typename?: 'BlogAuthorAuthorBioSummaryResourcesInline' }
    & ResourceMeta_BlogAuthorAuthorBioSummaryResourcesInline_Fragment
  )>, hyperlink: Array<(
    { __typename?: 'BlogAuthorAuthorBioSummaryResourcesHyperlink' }
    & ResourceMeta_BlogAuthorAuthorBioSummaryResourcesHyperlink_Fragment
  )> };

export type BlogAuthorAuthorBioSummaryFragment = { __typename?: 'BlogAuthorAuthorBioSummary', json: any, links: { __typename?: 'BlogAuthorAuthorBioSummaryLinks', assets: (
      { __typename?: 'BlogAuthorAuthorBioSummaryAssets' }
      & BlogAuthorAuthorBioSummaryAssetsFragment
    ), entries: (
      { __typename?: 'BlogAuthorAuthorBioSummaryEntries' }
      & BlogAuthorAuthorBioSummaryEntriesFragment
    ), resources: (
      { __typename?: 'BlogAuthorAuthorBioSummaryResources' }
      & BlogAuthorAuthorBioSummaryResourcesFragment
    ) } };

export type BlogCategoryFragment = (
  { __typename?: 'BlogCategory', name?: string | null, slug?: string | null }
  & Meta_BlogCategory_Fragment
);

export type BlogDetailsPageFragment = (
  { __typename?: 'BlogDetailsPage', name?: string | null, path?: string | null, metaTitle?: string | null, metaDescription?: string | null, canonical?: string | null, indexed?: boolean | null, pageDesignType?: string | null, heroBackgroundColor?: string | null, date?: any | null, title?: string | null, tags?: Array<string | null> | null, blogImage?: any | null, timeToRead?: number | null, disableStickyFooterOnDesktop?: boolean | null, disableStickyFooterOnMobile?: boolean | null, disableHeaderTopAlertBanner?: boolean | null, disableHeaderBottomAlertBanner?: boolean | null, brand?: (
    { __typename?: 'Brand' }
    & BrandFragment
  ) | null, summary?: (
    { __typename?: 'BlogDetailsPageSummary' }
    & BlogDetailsPageSummaryFragment
  ) | null, category?: (
    { __typename?: 'BlogCategory' }
    & BlogCategoryFragment
  ) | null, subCategory?: (
    { __typename?: 'BlogSubCategory' }
    & BlogSubCategoryFragment
  ) | null, text?: (
    { __typename?: 'BlogDetailsPageText' }
    & BlogDetailsPageTextFragment
  ) | null, author?: (
    { __typename?: 'BlogAuthor' }
    & BlogAuthorFragment
  ) | null, reviewer?: (
    { __typename?: 'BlogAuthor' }
    & BlogAuthorFragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, heroContentTitle?: { __typename?: 'BlogDetailsPageHeroContentTitle', json: any } | null, heroContentCollection?: { __typename?: 'BlogDetailsPageHeroContentCollection', items: Array<(
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | null> } | null, heroButtonCollection?: { __typename?: 'BlogDetailsPageHeroButtonCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, relatedBlogsContentSection?: (
    { __typename?: 'ContentSection' }
    & ContentSectionFragment
  ) | null, additionalContentCollection?: { __typename?: 'BlogDetailsPageAdditionalContentCollection', items: Array<(
      { __typename?: 'Accordions' }
      & AccordionFragment
    ) | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | null> } | null }
  & Meta_BlogDetailsPage_Fragment
);

export type BlogDetailsPageBaseFragment = (
  { __typename?: 'BlogDetailsPage', path?: string | null }
  & Meta_BlogDetailsPage_Fragment
);

export type HeroBlogDetailsPageListFragment = (
  { __typename?: 'BlogDetailsPage', title?: string | null, path?: string | null, blogImage?: any | null, summary?: { __typename?: 'BlogDetailsPageSummary', json: any } | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_BlogDetailsPage_Fragment
);

export type FeaturedBlogDetailsPageListFragment = (
  { __typename?: 'BlogDetailsPage', title?: string | null, date?: any | null, path?: string | null, tags?: Array<string | null> | null, timeToRead?: number | null, blogImage?: any | null, summary?: { __typename?: 'BlogDetailsPageSummary', json: any } | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, category?: (
    { __typename?: 'BlogCategory' }
    & BlogCategoryFragment
  ) | null, subCategory?: (
    { __typename?: 'BlogSubCategory' }
    & BlogSubCategoryFragment
  ) | null }
  & Meta_BlogDetailsPage_Fragment
);

export type BlogDetailsPageSummaryAssetsFragment = { __typename?: 'BlogDetailsPageSummaryAssets', block: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null> };

export type BlogDetailsPageSummaryEntriesFragment = { __typename?: 'BlogDetailsPageSummaryEntries', inline: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, block: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null> };

export type BlogDetailsPageSummaryResourcesFragment = { __typename?: 'BlogDetailsPageSummaryResources', block: Array<(
    { __typename?: 'BlogDetailsPageSummaryResourcesBlock' }
    & ResourceMeta_BlogDetailsPageSummaryResourcesBlock_Fragment
  )>, inline: Array<(
    { __typename?: 'BlogDetailsPageSummaryResourcesInline' }
    & ResourceMeta_BlogDetailsPageSummaryResourcesInline_Fragment
  )>, hyperlink: Array<(
    { __typename?: 'BlogDetailsPageSummaryResourcesHyperlink' }
    & ResourceMeta_BlogDetailsPageSummaryResourcesHyperlink_Fragment
  )> };

export type BlogDetailsPageSummaryFragment = { __typename?: 'BlogDetailsPageSummary', json: any, links: { __typename?: 'BlogDetailsPageSummaryLinks', assets: (
      { __typename?: 'BlogDetailsPageSummaryAssets' }
      & BlogDetailsPageSummaryAssetsFragment
    ), entries: (
      { __typename?: 'BlogDetailsPageSummaryEntries' }
      & BlogDetailsPageSummaryEntriesFragment
    ), resources: (
      { __typename?: 'BlogDetailsPageSummaryResources' }
      & BlogDetailsPageSummaryResourcesFragment
    ) } };

export type BlogDetailsPageTextAssetsFragment = { __typename?: 'BlogDetailsPageTextAssets', block: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
    & LinkMetaFragment
  ) | null> };

export type BlogDetailsPageTextEntriesFragment = { __typename?: 'BlogDetailsPageTextEntries', inline: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, block: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
    & ColumnsFragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
    & SingleMessageFragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
    & TableFragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
    & VideoAssetFragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null>, hyperlink: Array<(
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
    & BlogDetailsPageBaseFragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
    & FacilityDetailsPageBaseFragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
    & BasePageFragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
    & ServiceDetailsPageBaseFragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null> };

export type BlogDetailsPageTextResourcesFragment = { __typename?: 'BlogDetailsPageTextResources', block: Array<(
    { __typename?: 'BlogDetailsPageTextResourcesBlock' }
    & ResourceMeta_BlogDetailsPageTextResourcesBlock_Fragment
  )>, inline: Array<(
    { __typename?: 'BlogDetailsPageTextResourcesInline' }
    & ResourceMeta_BlogDetailsPageTextResourcesInline_Fragment
  )>, hyperlink: Array<(
    { __typename?: 'BlogDetailsPageTextResourcesHyperlink' }
    & ResourceMeta_BlogDetailsPageTextResourcesHyperlink_Fragment
  )> };

export type BlogDetailsPageTextFragment = { __typename?: 'BlogDetailsPageText', json: any, links: { __typename?: 'BlogDetailsPageTextLinks', assets: (
      { __typename?: 'BlogDetailsPageTextAssets' }
      & BlogDetailsPageTextAssetsFragment
    ), entries: (
      { __typename?: 'BlogDetailsPageTextEntries' }
      & BlogDetailsPageTextEntriesFragment
    ), resources: (
      { __typename?: 'BlogDetailsPageTextResources' }
      & BlogDetailsPageTextResourcesFragment
    ) } };

export type BlogListFragment = (
  { __typename?: 'BlogList', title?: string | null, displayType?: string | null, tagsFilter?: Array<string | null> | null, buttonLabel?: string | null, loadMoreButtonLabel?: string | null, countAcrossDesktop?: number | null, countAcrossMobile?: number | null, hasPagination?: boolean | null, cardDesignType?: string | null, variant?: string | null, category?: (
    { __typename?: 'BlogCategory' }
    & BlogCategoryFragment
  ) | null, subCategory?: (
    { __typename?: 'BlogSubCategory' }
    & BlogSubCategoryFragment
  ) | null, brand?: (
    { __typename?: 'Brand' }
    & BrandFragment
  ) | null, heroBlogsListCollection?: { __typename?: 'BlogListHeroBlogsListCollection', items: Array<(
      { __typename?: 'BlogDetailsPage' }
      & HeroBlogDetailsPageListFragment
    ) | null> } | null, featuredBlogsListCollection?: { __typename?: 'BlogListFeaturedBlogsListCollection', items: Array<(
      { __typename?: 'BlogDetailsPage' }
      & FeaturedBlogDetailsPageListFragment
    ) | null> } | null }
  & Meta_BlogList_Fragment
);

export type BlogListPageFragment = (
  { __typename?: 'BlogListPage', metaTitle?: string | null, metaDescription?: string | null, canonical?: string | null, indexed?: boolean | null, title?: string | null, tags?: Array<string | null> | null, disableStickyFooterOnDesktop?: boolean | null, disableStickyFooterOnMobile?: boolean | null, disableHeaderTopAlertBanner?: boolean | null, disableHeaderBottomAlertBanner?: boolean | null, shouldDisplayCategoryFilterChips?: boolean | null, variant?: string | null, brand?: (
    { __typename?: 'Brand' }
    & BrandFragment
  ) | null, blogList?: (
    { __typename?: 'BlogList' }
    & BlogListFragment
  ) | null, description?: { __typename?: 'BlogListPageDescription', json: any } | null, contentListCollection?: { __typename?: 'BlogListPageContentListCollection', items: Array<(
      { __typename?: 'BlogList' }
      & BlogListFragment
    ) | null> } | null, contentAfterListCollection?: { __typename?: 'BlogListPageContentAfterListCollection', items: Array<(
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | null> } | null }
  & Meta_BlogListPage_Fragment
);

export type BlogSubCategoryFragment = (
  { __typename?: 'BlogSubCategory', name?: string | null, slug?: string | null }
  & Meta_BlogSubCategory_Fragment
);

export type BrandFragment = (
  { __typename?: 'Brand', name?: string | null, title?: string | null }
  & Meta_Brand_Fragment
);

export type ButtonFragment = (
  { __typename?: 'Button', name?: string | null, label?: string | null, variant?: string | null, buttonLink?: string | null, size?: string | null, icon?: string | null, iconPosition?: string | null, iconSize?: string | null, launchCrestaAgent?: boolean | null, mobileButton?: (
    { __typename?: 'MobileButton' }
    & MobileButtonFragment
  ) | null, analyticsContext?: (
    { __typename?: 'AnalyticsContext' }
    & AnalyticsFragment
  ) | null, navigationDetails?: (
    { __typename?: 'NavigationLink' }
    & NavLinkFragment
  ) | null, quizDetails?: (
    { __typename?: 'Quiz' }
    & QuizFragment
  ) | null, popoverContentCollection?: { __typename?: 'ButtonPopoverContentCollection', items: Array<(
      { __typename?: 'Iframe' }
      & IframeFragment
    ) | (
      { __typename?: 'MultiCardV2', display?: string | null, sectionEyebrow?: string | null, backgroundColor?: string | null, sectionInfoAlignment?: string | null, sectionTitle?: string | null, sectionTitleHtag?: string | null, variant?: string | null, simpleCard?: { __typename?: 'MultiCardV2SimpleCard', json: any } | null, simpleCardTwo?: { __typename?: 'MultiCardV2SimpleCardTwo', json: any } | null, simpleCardThree?: { __typename?: 'MultiCardV2SimpleCardThree', json: any } | null }
      & Meta_MultiCardV2_Fragment
    ) | null> } | null }
  & Meta_Button_Fragment
);

export type CardFragment = (
  { __typename?: 'Card', name?: string | null, title?: string | null, titleHtag?: string | null, description?: string | null, imageRatio?: string | null, cardIcon?: string | null, cardIconAlignment?: string | null, cardTextAlignment?: string | null, eyebrow?: string | null, backgroundColor?: string | null, buttonVariant?: string | null, buttonText?: string | null, buttonUrl?: string | null, buttonSize?: string | null, buttonIcon?: string | null, buttonIconSize?: string | null, buttonIconPosition?: string | null, pdfDownloadTitle?: string | null, tags?: Array<string | null> | null, richTextDescription?: { __typename?: 'CardRichTextDescription', json: any } | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
    & ImageAssetFragment
  ) | null, pdfFileLink?: (
    { __typename?: 'Asset' }
    & PdfFragment
  ) | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, analyticsContext?: (
    { __typename?: 'AnalyticsContext' }
    & AnalyticsFragment
  ) | null, buttonsCollection?: { __typename?: 'CardButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_Card_Fragment
);

export type CategoryPickerFragment = (
  { __typename?: 'CategoryPicker', eyebrow?: string | null, eyebrowHeading?: string | null, mobileThreshold?: number | null, title?: string | null, titleHeading?: string | null, setTwoRows?: boolean | null, anchorId?: string | null, variant?: string | null, categoriesCollection?: { __typename?: 'CategoryPickerCategoriesCollection', items: Array<{ __typename?: 'Category', icon?: string | null, title?: string | null, link?: string | null, imageAsset?: (
        { __typename?: 'ImageAsset' }
        & ImageAssetFragment
      ) | null } | null> } | null, bodyCopy?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextFragment
  ) | null, buttonsCollection?: { __typename?: 'CategoryPickerButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_CategoryPicker_Fragment
);

export type ColumnsFragment = (
  { __typename?: 'Columns', eyebrow?: string | null, title?: string | null, titleHtag?: string | null, description?: string | null, fullWidth?: boolean | null, disablePaddingOn?: Array<string | null> | null, backgroundColor?: string | null, allowEqualHeights?: boolean | null, anchorId?: string | null, columnsCollection?: { __typename?: 'ColumnsColumnsCollection', items: Array<(
      { __typename?: 'Accordions' }
      & AccordionFragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | (
      { __typename?: 'ImageAsset' }
      & ImageAssetFragment
    ) | { __typename?: 'SchemaStep' } | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | null> } | null }
  & Meta_Columns_Fragment
);

export type ContentSectionFragment = (
  { __typename?: 'ContentSection', eyebrow?: string | null, eyebrowHtag?: string | null, title?: string | null, titleHtag?: string | null, alignment?: string | null, titleIcon?: string | null, description?: { __typename?: 'ContentSectionDescription', json: any } | null }
  & Meta_ContentSection_Fragment
);

export type ConvertFlowCtaFragment = (
  { __typename?: 'ConvertFlowCta', ctaId?: string | null, websiteId?: string | null, loadingMessage?: string | null, fallbackUrl?: string | null, fallbackLabel?: string | null, timeoutMs?: number | null, enableUserDetailsValidation?: boolean | null, buttonLabel?: string | null, embedId?: string | null }
  & Meta_ConvertFlowCta_Fragment
);

export type ConvertFlowQuizFragment = (
  { __typename?: 'ConvertFlowQuiz', ctaId?: string | null, websiteId?: string | null, loadingMessage?: string | null, fallbackUrl?: string | null, fallbackLabel?: string | null, timeoutMs?: number | null, enableUserDetailsValidation?: boolean | null }
  & Meta_ConvertFlowQuiz_Fragment
);

export type DisclaimerV2Fragment = (
  { __typename?: 'DisclaimerV2', size?: string | null, templateWidth?: string | null, facilitySegmentCollection?: string | null, anchorId?: string | null, disclaimer?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextFragment
  ) | null }
  & Meta_DisclaimerV2_Fragment
);

export type Meta_Accordions_Fragment = { __typename: 'Accordions', sys: { __typename?: 'Sys', id: string } };

export type Meta_AdFooter_Fragment = { __typename: 'AdFooter', sys: { __typename?: 'Sys', id: string } };

export type Meta_AgendaModal_Fragment = { __typename: 'AgendaModal', sys: { __typename?: 'Sys', id: string } };

export type Meta_AgendaStepper_Fragment = { __typename: 'AgendaStepper', sys: { __typename?: 'Sys', id: string } };

export type Meta_AnalyticsContext_Fragment = { __typename: 'AnalyticsContext', sys: { __typename?: 'Sys', id: string } };

export type Meta_App_Fragment = { __typename: 'App', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppCopySlot_Fragment = { __typename: 'AppCopySlot', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppFaq_Fragment = { __typename: 'AppFaq', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppLegalDocument_Fragment = { __typename: 'AppLegalDocument', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppMediaSlot_Fragment = { __typename: 'AppMediaSlot', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppOffer_Fragment = { __typename: 'AppOffer', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppReachYouCard_Fragment = { __typename: 'AppReachYouCard', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppTip_Fragment = { __typename: 'AppTip', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppTreatmentInfo_Fragment = { __typename: 'AppTreatmentInfo', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppViewCopy_Fragment = { __typename: 'AppViewCopy', sys: { __typename?: 'Sys', id: string } };

export type Meta_AppointmentBookingPage_Fragment = { __typename: 'AppointmentBookingPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_Badge_Fragment = { __typename: 'Badge', sys: { __typename?: 'Sys', id: string } };

export type Meta_Banner_Fragment = { __typename: 'Banner', sys: { __typename?: 'Sys', id: string } };

export type Meta_BirdEyeReviews_Fragment = { __typename: 'BirdEyeReviews', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogAuthor_Fragment = { __typename: 'BlogAuthor', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogDetailsPage_Fragment = { __typename: 'BlogDetailsPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogList_Fragment = { __typename: 'BlogList', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogListPage_Fragment = { __typename: 'BlogListPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_BlogSubCategory_Fragment = { __typename: 'BlogSubCategory', sys: { __typename?: 'Sys', id: string } };

export type Meta_BodyText_Fragment = { __typename: 'BodyText', sys: { __typename?: 'Sys', id: string } };

export type Meta_Brand_Fragment = { __typename: 'Brand', sys: { __typename?: 'Sys', id: string } };

export type Meta_Button_Fragment = { __typename: 'Button', sys: { __typename?: 'Sys', id: string } };

export type Meta_Card_Fragment = { __typename: 'Card', sys: { __typename?: 'Sys', id: string } };

export type Meta_Carousel_Fragment = { __typename: 'Carousel', sys: { __typename?: 'Sys', id: string } };

export type Meta_Category_Fragment = { __typename: 'Category', sys: { __typename?: 'Sys', id: string } };

export type Meta_CategoryPicker_Fragment = { __typename: 'CategoryPicker', sys: { __typename?: 'Sys', id: string } };

export type Meta_CityLinks_Fragment = { __typename: 'CityLinks', sys: { __typename?: 'Sys', id: string } };

export type Meta_Columns_Fragment = { __typename: 'Columns', sys: { __typename?: 'Sys', id: string } };

export type Meta_ConfirmationStep_Fragment = { __typename: 'ConfirmationStep', sys: { __typename?: 'Sys', id: string } };

export type Meta_ContentData_Fragment = { __typename: 'ContentData', sys: { __typename?: 'Sys', id: string } };

export type Meta_ContentSection_Fragment = { __typename: 'ContentSection', sys: { __typename?: 'Sys', id: string } };

export type Meta_ContentTile_Fragment = { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string } };

export type Meta_ContentTypeRichText_Fragment = { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } };

export type Meta_ConvertFlowCta_Fragment = { __typename: 'ConvertFlowCta', sys: { __typename?: 'Sys', id: string } };

export type Meta_ConvertFlowQuiz_Fragment = { __typename: 'ConvertFlowQuiz', sys: { __typename?: 'Sys', id: string } };

export type Meta_DisclaimerV2_Fragment = { __typename: 'DisclaimerV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_Error404_Fragment = { __typename: 'Error404', sys: { __typename?: 'Sys', id: string } };

export type Meta_Experience_Fragment = { __typename: 'Experience', sys: { __typename?: 'Sys', id: string } };

export type Meta_ExperimentContainer_Fragment = { __typename: 'ExperimentContainer', sys: { __typename?: 'Sys', id: string } };

export type Meta_ExperimentVariationContentsItem_Fragment = { __typename: 'ExperimentVariationContentsItem', sys: { __typename?: 'Sys', id: string } };

export type Meta_ExperimentalModal_Fragment = { __typename: 'ExperimentalModal', sys: { __typename?: 'Sys', id: string } };

export type Meta_FacilityDetailsPage_Fragment = { __typename: 'FacilityDetailsPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_FaqAccordion_Fragment = { __typename: 'FaqAccordion', sys: { __typename?: 'Sys', id: string } };

export type Meta_FeatureFlags_Fragment = { __typename: 'FeatureFlags', sys: { __typename?: 'Sys', id: string } };

export type Meta_FocalPointImage_Fragment = { __typename: 'FocalPointImage', sys: { __typename?: 'Sys', id: string } };

export type Meta_FooterNavigationGroup_Fragment = { __typename: 'FooterNavigationGroup', sys: { __typename?: 'Sys', id: string } };

export type Meta_FormDropdownField_Fragment = { __typename: 'FormDropdownField', sys: { __typename?: 'Sys', id: string } };

export type Meta_FormField_Fragment = { __typename: 'FormField', sys: { __typename?: 'Sys', id: string } };

export type Meta_GoogleMapTemplate_Fragment = { __typename: 'GoogleMapTemplate', sys: { __typename?: 'Sys', id: string } };

export type Meta_HalfScreen_Fragment = { __typename: 'HalfScreen', sys: { __typename?: 'Sys', id: string } };

export type Meta_Header_Fragment = { __typename: 'Header', sys: { __typename?: 'Sys', id: string } };

export type Meta_HeaderMainNav_Fragment = { __typename: 'HeaderMainNav', sys: { __typename?: 'Sys', id: string } };

export type Meta_HeaderNavMenu_Fragment = { __typename: 'HeaderNavMenu', sys: { __typename?: 'Sys', id: string } };

export type Meta_HeaderSubNav_Fragment = { __typename: 'HeaderSubNav', sys: { __typename?: 'Sys', id: string } };

export type Meta_Heading_Fragment = { __typename: 'Heading', sys: { __typename?: 'Sys', id: string } };

export type Meta_HeroV2_Fragment = { __typename: 'HeroV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_Icon_Fragment = { __typename: 'Icon', sys: { __typename?: 'Sys', id: string } };

export type Meta_Iframe_Fragment = { __typename: 'Iframe', sys: { __typename?: 'Sys', id: string } };

export type Meta_ImageAsset_Fragment = { __typename: 'ImageAsset', sys: { __typename?: 'Sys', id: string } };

export type Meta_Insurance_Fragment = { __typename: 'Insurance', sys: { __typename?: 'Sys', id: string } };

export type Meta_LinkForwarder_Fragment = { __typename: 'LinkForwarder', sys: { __typename?: 'Sys', id: string } };

export type Meta_List_Fragment = { __typename: 'List', sys: { __typename?: 'Sys', id: string } };

export type Meta_ListItem_Fragment = { __typename: 'ListItem', sys: { __typename?: 'Sys', id: string } };

export type Meta_LocalizedServiceTitle_Fragment = { __typename: 'LocalizedServiceTitle', sys: { __typename?: 'Sys', id: string } };

export type Meta_Marquee_Fragment = { __typename: 'Marquee', sys: { __typename?: 'Sys', id: string } };

export type Meta_Media_Fragment = { __typename: 'Media', sys: { __typename?: 'Sys', id: string } };

export type Meta_MediaSlider_Fragment = { __typename: 'MediaSlider', sys: { __typename?: 'Sys', id: string } };

export type Meta_MedicalService_Fragment = { __typename: 'MedicalService', sys: { __typename?: 'Sys', id: string } };

export type Meta_MeetOurStaff_Fragment = { __typename: 'MeetOurStaff', sys: { __typename?: 'Sys', id: string } };

export type Meta_MetroLinks_Fragment = { __typename: 'MetroLinks', sys: { __typename?: 'Sys', id: string } };

export type Meta_MobileButton_Fragment = { __typename: 'MobileButton', sys: { __typename?: 'Sys', id: string } };

export type Meta_MultiCardV2_Fragment = { __typename: 'MultiCardV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_NavigationGroup_Fragment = { __typename: 'NavigationGroup', sys: { __typename?: 'Sys', id: string } };

export type Meta_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string } };

export type Meta_OdpHero_Fragment = { __typename: 'OdpHero', sys: { __typename?: 'Sys', id: string } };

export type Meta_Page_Fragment = { __typename: 'Page', sys: { __typename?: 'Sys', id: string } };

export type Meta_PageLayout_Fragment = { __typename: 'PageLayout', sys: { __typename?: 'Sys', id: string } };

export type Meta_PageMeta_Fragment = { __typename: 'PageMeta', sys: { __typename?: 'Sys', id: string } };

export type Meta_PatientReviewV2_Fragment = { __typename: 'PatientReviewV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_PatientReviewsV2_Fragment = { __typename: 'PatientReviewsV2', sys: { __typename?: 'Sys', id: string } };

export type Meta_Procedure_Fragment = { __typename: 'Procedure', sys: { __typename?: 'Sys', id: string } };

export type Meta_Product_Fragment = { __typename: 'Product', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProductDisplay_Fragment = { __typename: 'ProductDisplay', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProductFeature_Fragment = { __typename: 'ProductFeature', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProductFeatureDescriptionListItem_Fragment = { __typename: 'ProductFeatureDescriptionListItem', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProgressIndicator_Fragment = { __typename: 'ProgressIndicator', sys: { __typename?: 'Sys', id: string } };

export type Meta_ProviderDetailsPage_Fragment = { __typename: 'ProviderDetailsPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_QuestionAnswer_Fragment = { __typename: 'QuestionAnswer', sys: { __typename?: 'Sys', id: string } };

export type Meta_Questionnaire_Fragment = { __typename: 'Questionnaire', sys: { __typename?: 'Sys', id: string } };

export type Meta_QuickLinks_Fragment = { __typename: 'QuickLinks', sys: { __typename?: 'Sys', id: string } };

export type Meta_Quiz_Fragment = { __typename: 'Quiz', sys: { __typename?: 'Sys', id: string } };

export type Meta_ReviewStep_Fragment = { __typename: 'ReviewStep', sys: { __typename?: 'Sys', id: string } };

export type Meta_Schema_Fragment = { __typename: 'Schema', sys: { __typename?: 'Sys', id: string } };

export type Meta_SchemaStep_Fragment = { __typename: 'SchemaStep', sys: { __typename?: 'Sys', id: string } };

export type Meta_SectionContent_Fragment = { __typename: 'SectionContent', sys: { __typename?: 'Sys', id: string } };

export type Meta_SegmentsContainer_Fragment = { __typename: 'SegmentsContainer', sys: { __typename?: 'Sys', id: string } };

export type Meta_Service_Fragment = { __typename: 'Service', sys: { __typename?: 'Sys', id: string } };

export type Meta_ServiceDetailsPage_Fragment = { __typename: 'ServiceDetailsPage', sys: { __typename?: 'Sys', id: string } };

export type Meta_ServiceGroup_Fragment = { __typename: 'ServiceGroup', sys: { __typename?: 'Sys', id: string } };

export type Meta_ServiceLineHero_Fragment = { __typename: 'ServiceLineHero', sys: { __typename?: 'Sys', id: string } };

export type Meta_SharedForm_Fragment = { __typename: 'SharedForm', sys: { __typename?: 'Sys', id: string } };

export type Meta_SharedFormDefinitions_Fragment = { __typename: 'SharedFormDefinitions', sys: { __typename?: 'Sys', id: string } };

export type Meta_SharedFormField_Fragment = { __typename: 'SharedFormField', sys: { __typename?: 'Sys', id: string } };

export type Meta_SingleMessage_Fragment = { __typename: 'SingleMessage', sys: { __typename?: 'Sys', id: string } };

export type Meta_SmallScreenContent_Fragment = { __typename: 'SmallScreenContent', sys: { __typename?: 'Sys', id: string } };

export type Meta_SmileAssessmentForm_Fragment = { __typename: 'SmileAssessmentForm', sys: { __typename?: 'Sys', id: string } };

export type Meta_Spacer_Fragment = { __typename: 'Spacer', sys: { __typename?: 'Sys', id: string } };

export type Meta_StateLinks_Fragment = { __typename: 'StateLinks', sys: { __typename?: 'Sys', id: string } };

export type Meta_Stepper_Fragment = { __typename: 'Stepper', sys: { __typename?: 'Sys', id: string } };

export type Meta_SuccessCard_Fragment = { __typename: 'SuccessCard', sys: { __typename?: 'Sys', id: string } };

export type Meta_Tab_Fragment = { __typename: 'Tab', sys: { __typename?: 'Sys', id: string } };

export type Meta_Table_Fragment = { __typename: 'Table', sys: { __typename?: 'Sys', id: string } };

export type Meta_Tabs_Fragment = { __typename: 'Tabs', sys: { __typename?: 'Sys', id: string } };

export type Meta_TermsAndConditions_Fragment = { __typename: 'TermsAndConditions', sys: { __typename?: 'Sys', id: string } };

export type Meta_TextBlockSeo_Fragment = { __typename: 'TextBlockSeo', sys: { __typename?: 'Sys', id: string } };

export type Meta_TextHighlight_Fragment = { __typename: 'TextHighlight', sys: { __typename?: 'Sys', id: string } };

export type Meta_TriggeredContentModal_Fragment = { __typename: 'TriggeredContentModal', sys: { __typename?: 'Sys', id: string } };

export type Meta_Video_Fragment = { __typename: 'Video', sys: { __typename?: 'Sys', id: string } };

export type Meta_VideoAsset_Fragment = { __typename: 'VideoAsset', sys: { __typename?: 'Sys', id: string } };

export type Meta_VideoCarousel_Fragment = { __typename: 'VideoCarousel', sys: { __typename?: 'Sys', id: string } };

export type Meta_VideoWithContent_Fragment = { __typename: 'VideoWithContent', sys: { __typename?: 'Sys', id: string } };

export type MetaFragment = Meta_Accordions_Fragment | Meta_AdFooter_Fragment | Meta_AgendaModal_Fragment | Meta_AgendaStepper_Fragment | Meta_AnalyticsContext_Fragment | Meta_App_Fragment | Meta_AppCopySlot_Fragment | Meta_AppFaq_Fragment | Meta_AppLegalDocument_Fragment | Meta_AppMediaSlot_Fragment | Meta_AppOffer_Fragment | Meta_AppReachYouCard_Fragment | Meta_AppTip_Fragment | Meta_AppTreatmentInfo_Fragment | Meta_AppViewCopy_Fragment | Meta_AppointmentBookingPage_Fragment | Meta_Badge_Fragment | Meta_Banner_Fragment | Meta_BirdEyeReviews_Fragment | Meta_BlogAuthor_Fragment | Meta_BlogCategory_Fragment | Meta_BlogDetailsPage_Fragment | Meta_BlogList_Fragment | Meta_BlogListPage_Fragment | Meta_BlogSubCategory_Fragment | Meta_BodyText_Fragment | Meta_Brand_Fragment | Meta_Button_Fragment | Meta_Card_Fragment | Meta_Carousel_Fragment | Meta_Category_Fragment | Meta_CategoryPicker_Fragment | Meta_CityLinks_Fragment | Meta_Columns_Fragment | Meta_ConfirmationStep_Fragment | Meta_ContentData_Fragment | Meta_ContentSection_Fragment | Meta_ContentTile_Fragment | Meta_ContentTypeRichText_Fragment | Meta_ConvertFlowCta_Fragment | Meta_ConvertFlowQuiz_Fragment | Meta_DisclaimerV2_Fragment | Meta_Error404_Fragment | Meta_Experience_Fragment | Meta_ExperimentContainer_Fragment | Meta_ExperimentVariationContentsItem_Fragment | Meta_ExperimentalModal_Fragment | Meta_FacilityDetailsPage_Fragment | Meta_FaqAccordion_Fragment | Meta_FeatureFlags_Fragment | Meta_FocalPointImage_Fragment | Meta_FooterNavigationGroup_Fragment | Meta_FormDropdownField_Fragment | Meta_FormField_Fragment | Meta_GoogleMapTemplate_Fragment | Meta_HalfScreen_Fragment | Meta_Header_Fragment | Meta_HeaderMainNav_Fragment | Meta_HeaderNavMenu_Fragment | Meta_HeaderSubNav_Fragment | Meta_Heading_Fragment | Meta_HeroV2_Fragment | Meta_Icon_Fragment | Meta_Iframe_Fragment | Meta_ImageAsset_Fragment | Meta_Insurance_Fragment | Meta_LinkForwarder_Fragment | Meta_List_Fragment | Meta_ListItem_Fragment | Meta_LocalizedServiceTitle_Fragment | Meta_Marquee_Fragment | Meta_Media_Fragment | Meta_MediaSlider_Fragment | Meta_MedicalService_Fragment | Meta_MeetOurStaff_Fragment | Meta_MetroLinks_Fragment | Meta_MobileButton_Fragment | Meta_MultiCardV2_Fragment | Meta_NavigationGroup_Fragment | Meta_NavigationLink_Fragment | Meta_OdpHero_Fragment | Meta_Page_Fragment | Meta_PageLayout_Fragment | Meta_PageMeta_Fragment | Meta_PatientReviewV2_Fragment | Meta_PatientReviewsV2_Fragment | Meta_Procedure_Fragment | Meta_Product_Fragment | Meta_ProductDisplay_Fragment | Meta_ProductFeature_Fragment | Meta_ProductFeatureDescriptionListItem_Fragment | Meta_ProgressIndicator_Fragment | Meta_ProviderDetailsPage_Fragment | Meta_QuestionAnswer_Fragment | Meta_Questionnaire_Fragment | Meta_QuickLinks_Fragment | Meta_Quiz_Fragment | Meta_ReviewStep_Fragment | Meta_Schema_Fragment | Meta_SchemaStep_Fragment | Meta_SectionContent_Fragment | Meta_SegmentsContainer_Fragment | Meta_Service_Fragment | Meta_ServiceDetailsPage_Fragment | Meta_ServiceGroup_Fragment | Meta_ServiceLineHero_Fragment | Meta_SharedForm_Fragment | Meta_SharedFormDefinitions_Fragment | Meta_SharedFormField_Fragment | Meta_SingleMessage_Fragment | Meta_SmallScreenContent_Fragment | Meta_SmileAssessmentForm_Fragment | Meta_Spacer_Fragment | Meta_StateLinks_Fragment | Meta_Stepper_Fragment | Meta_SuccessCard_Fragment | Meta_Tab_Fragment | Meta_Table_Fragment | Meta_Tabs_Fragment | Meta_TermsAndConditions_Fragment | Meta_TextBlockSeo_Fragment | Meta_TextHighlight_Fragment | Meta_TriggeredContentModal_Fragment | Meta_Video_Fragment | Meta_VideoAsset_Fragment | Meta_VideoCarousel_Fragment | Meta_VideoWithContent_Fragment;

export type EnrichedMeta_Accordions_Fragment = { __typename: 'Accordions', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AdFooter_Fragment = { __typename: 'AdFooter', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AgendaModal_Fragment = { __typename: 'AgendaModal', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AgendaStepper_Fragment = { __typename: 'AgendaStepper', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AnalyticsContext_Fragment = { __typename: 'AnalyticsContext', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_App_Fragment = { __typename: 'App', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppCopySlot_Fragment = { __typename: 'AppCopySlot', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppFaq_Fragment = { __typename: 'AppFaq', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppLegalDocument_Fragment = { __typename: 'AppLegalDocument', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppMediaSlot_Fragment = { __typename: 'AppMediaSlot', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppOffer_Fragment = { __typename: 'AppOffer', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppReachYouCard_Fragment = { __typename: 'AppReachYouCard', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppTip_Fragment = { __typename: 'AppTip', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppTreatmentInfo_Fragment = { __typename: 'AppTreatmentInfo', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppViewCopy_Fragment = { __typename: 'AppViewCopy', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_AppointmentBookingPage_Fragment = { __typename: 'AppointmentBookingPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Badge_Fragment = { __typename: 'Badge', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Banner_Fragment = { __typename: 'Banner', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BirdEyeReviews_Fragment = { __typename: 'BirdEyeReviews', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogAuthor_Fragment = { __typename: 'BlogAuthor', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogCategory_Fragment = { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogDetailsPage_Fragment = { __typename: 'BlogDetailsPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogList_Fragment = { __typename: 'BlogList', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogListPage_Fragment = { __typename: 'BlogListPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BlogSubCategory_Fragment = { __typename: 'BlogSubCategory', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_BodyText_Fragment = { __typename: 'BodyText', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Brand_Fragment = { __typename: 'Brand', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Button_Fragment = { __typename: 'Button', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Card_Fragment = { __typename: 'Card', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Carousel_Fragment = { __typename: 'Carousel', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Category_Fragment = { __typename: 'Category', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_CategoryPicker_Fragment = { __typename: 'CategoryPicker', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_CityLinks_Fragment = { __typename: 'CityLinks', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Columns_Fragment = { __typename: 'Columns', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ConfirmationStep_Fragment = { __typename: 'ConfirmationStep', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ContentData_Fragment = { __typename: 'ContentData', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ContentSection_Fragment = { __typename: 'ContentSection', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ContentTile_Fragment = { __typename: 'ContentTile', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ContentTypeRichText_Fragment = { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ConvertFlowCta_Fragment = { __typename: 'ConvertFlowCta', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ConvertFlowQuiz_Fragment = { __typename: 'ConvertFlowQuiz', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_DisclaimerV2_Fragment = { __typename: 'DisclaimerV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Error404_Fragment = { __typename: 'Error404', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Experience_Fragment = { __typename: 'Experience', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ExperimentContainer_Fragment = { __typename: 'ExperimentContainer', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ExperimentVariationContentsItem_Fragment = { __typename: 'ExperimentVariationContentsItem', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ExperimentalModal_Fragment = { __typename: 'ExperimentalModal', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FacilityDetailsPage_Fragment = { __typename: 'FacilityDetailsPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FaqAccordion_Fragment = { __typename: 'FaqAccordion', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FeatureFlags_Fragment = { __typename: 'FeatureFlags', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FocalPointImage_Fragment = { __typename: 'FocalPointImage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FooterNavigationGroup_Fragment = { __typename: 'FooterNavigationGroup', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FormDropdownField_Fragment = { __typename: 'FormDropdownField', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_FormField_Fragment = { __typename: 'FormField', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_GoogleMapTemplate_Fragment = { __typename: 'GoogleMapTemplate', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HalfScreen_Fragment = { __typename: 'HalfScreen', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Header_Fragment = { __typename: 'Header', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HeaderMainNav_Fragment = { __typename: 'HeaderMainNav', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HeaderNavMenu_Fragment = { __typename: 'HeaderNavMenu', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HeaderSubNav_Fragment = { __typename: 'HeaderSubNav', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Heading_Fragment = { __typename: 'Heading', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_HeroV2_Fragment = { __typename: 'HeroV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Icon_Fragment = { __typename: 'Icon', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Iframe_Fragment = { __typename: 'Iframe', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ImageAsset_Fragment = { __typename: 'ImageAsset', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Insurance_Fragment = { __typename: 'Insurance', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_LinkForwarder_Fragment = { __typename: 'LinkForwarder', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_List_Fragment = { __typename: 'List', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ListItem_Fragment = { __typename: 'ListItem', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_LocalizedServiceTitle_Fragment = { __typename: 'LocalizedServiceTitle', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Marquee_Fragment = { __typename: 'Marquee', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Media_Fragment = { __typename: 'Media', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MediaSlider_Fragment = { __typename: 'MediaSlider', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MedicalService_Fragment = { __typename: 'MedicalService', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MeetOurStaff_Fragment = { __typename: 'MeetOurStaff', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MetroLinks_Fragment = { __typename: 'MetroLinks', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MobileButton_Fragment = { __typename: 'MobileButton', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_MultiCardV2_Fragment = { __typename: 'MultiCardV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_NavigationGroup_Fragment = { __typename: 'NavigationGroup', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_NavigationLink_Fragment = { __typename: 'NavigationLink', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_OdpHero_Fragment = { __typename: 'OdpHero', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Page_Fragment = { __typename: 'Page', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_PageLayout_Fragment = { __typename: 'PageLayout', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_PageMeta_Fragment = { __typename: 'PageMeta', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_PatientReviewV2_Fragment = { __typename: 'PatientReviewV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_PatientReviewsV2_Fragment = { __typename: 'PatientReviewsV2', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Procedure_Fragment = { __typename: 'Procedure', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Product_Fragment = { __typename: 'Product', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProductDisplay_Fragment = { __typename: 'ProductDisplay', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProductFeature_Fragment = { __typename: 'ProductFeature', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProductFeatureDescriptionListItem_Fragment = { __typename: 'ProductFeatureDescriptionListItem', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProgressIndicator_Fragment = { __typename: 'ProgressIndicator', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ProviderDetailsPage_Fragment = { __typename: 'ProviderDetailsPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_QuestionAnswer_Fragment = { __typename: 'QuestionAnswer', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Questionnaire_Fragment = { __typename: 'Questionnaire', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_QuickLinks_Fragment = { __typename: 'QuickLinks', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Quiz_Fragment = { __typename: 'Quiz', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ReviewStep_Fragment = { __typename: 'ReviewStep', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Schema_Fragment = { __typename: 'Schema', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SchemaStep_Fragment = { __typename: 'SchemaStep', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SectionContent_Fragment = { __typename: 'SectionContent', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SegmentsContainer_Fragment = { __typename: 'SegmentsContainer', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Service_Fragment = { __typename: 'Service', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ServiceDetailsPage_Fragment = { __typename: 'ServiceDetailsPage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ServiceGroup_Fragment = { __typename: 'ServiceGroup', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_ServiceLineHero_Fragment = { __typename: 'ServiceLineHero', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SharedForm_Fragment = { __typename: 'SharedForm', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SharedFormDefinitions_Fragment = { __typename: 'SharedFormDefinitions', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SharedFormField_Fragment = { __typename: 'SharedFormField', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SingleMessage_Fragment = { __typename: 'SingleMessage', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SmallScreenContent_Fragment = { __typename: 'SmallScreenContent', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SmileAssessmentForm_Fragment = { __typename: 'SmileAssessmentForm', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Spacer_Fragment = { __typename: 'Spacer', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_StateLinks_Fragment = { __typename: 'StateLinks', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Stepper_Fragment = { __typename: 'Stepper', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_SuccessCard_Fragment = { __typename: 'SuccessCard', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Tab_Fragment = { __typename: 'Tab', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Table_Fragment = { __typename: 'Table', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Tabs_Fragment = { __typename: 'Tabs', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_TermsAndConditions_Fragment = { __typename: 'TermsAndConditions', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_TextBlockSeo_Fragment = { __typename: 'TextBlockSeo', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_TextHighlight_Fragment = { __typename: 'TextHighlight', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_TriggeredContentModal_Fragment = { __typename: 'TriggeredContentModal', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_Video_Fragment = { __typename: 'Video', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_VideoAsset_Fragment = { __typename: 'VideoAsset', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_VideoCarousel_Fragment = { __typename: 'VideoCarousel', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMeta_VideoWithContent_Fragment = { __typename: 'VideoWithContent', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> } };

export type EnrichedMetaFragment = EnrichedMeta_Accordions_Fragment | EnrichedMeta_AdFooter_Fragment | EnrichedMeta_AgendaModal_Fragment | EnrichedMeta_AgendaStepper_Fragment | EnrichedMeta_AnalyticsContext_Fragment | EnrichedMeta_App_Fragment | EnrichedMeta_AppCopySlot_Fragment | EnrichedMeta_AppFaq_Fragment | EnrichedMeta_AppLegalDocument_Fragment | EnrichedMeta_AppMediaSlot_Fragment | EnrichedMeta_AppOffer_Fragment | EnrichedMeta_AppReachYouCard_Fragment | EnrichedMeta_AppTip_Fragment | EnrichedMeta_AppTreatmentInfo_Fragment | EnrichedMeta_AppViewCopy_Fragment | EnrichedMeta_AppointmentBookingPage_Fragment | EnrichedMeta_Badge_Fragment | EnrichedMeta_Banner_Fragment | EnrichedMeta_BirdEyeReviews_Fragment | EnrichedMeta_BlogAuthor_Fragment | EnrichedMeta_BlogCategory_Fragment | EnrichedMeta_BlogDetailsPage_Fragment | EnrichedMeta_BlogList_Fragment | EnrichedMeta_BlogListPage_Fragment | EnrichedMeta_BlogSubCategory_Fragment | EnrichedMeta_BodyText_Fragment | EnrichedMeta_Brand_Fragment | EnrichedMeta_Button_Fragment | EnrichedMeta_Card_Fragment | EnrichedMeta_Carousel_Fragment | EnrichedMeta_Category_Fragment | EnrichedMeta_CategoryPicker_Fragment | EnrichedMeta_CityLinks_Fragment | EnrichedMeta_Columns_Fragment | EnrichedMeta_ConfirmationStep_Fragment | EnrichedMeta_ContentData_Fragment | EnrichedMeta_ContentSection_Fragment | EnrichedMeta_ContentTile_Fragment | EnrichedMeta_ContentTypeRichText_Fragment | EnrichedMeta_ConvertFlowCta_Fragment | EnrichedMeta_ConvertFlowQuiz_Fragment | EnrichedMeta_DisclaimerV2_Fragment | EnrichedMeta_Error404_Fragment | EnrichedMeta_Experience_Fragment | EnrichedMeta_ExperimentContainer_Fragment | EnrichedMeta_ExperimentVariationContentsItem_Fragment | EnrichedMeta_ExperimentalModal_Fragment | EnrichedMeta_FacilityDetailsPage_Fragment | EnrichedMeta_FaqAccordion_Fragment | EnrichedMeta_FeatureFlags_Fragment | EnrichedMeta_FocalPointImage_Fragment | EnrichedMeta_FooterNavigationGroup_Fragment | EnrichedMeta_FormDropdownField_Fragment | EnrichedMeta_FormField_Fragment | EnrichedMeta_GoogleMapTemplate_Fragment | EnrichedMeta_HalfScreen_Fragment | EnrichedMeta_Header_Fragment | EnrichedMeta_HeaderMainNav_Fragment | EnrichedMeta_HeaderNavMenu_Fragment | EnrichedMeta_HeaderSubNav_Fragment | EnrichedMeta_Heading_Fragment | EnrichedMeta_HeroV2_Fragment | EnrichedMeta_Icon_Fragment | EnrichedMeta_Iframe_Fragment | EnrichedMeta_ImageAsset_Fragment | EnrichedMeta_Insurance_Fragment | EnrichedMeta_LinkForwarder_Fragment | EnrichedMeta_List_Fragment | EnrichedMeta_ListItem_Fragment | EnrichedMeta_LocalizedServiceTitle_Fragment | EnrichedMeta_Marquee_Fragment | EnrichedMeta_Media_Fragment | EnrichedMeta_MediaSlider_Fragment | EnrichedMeta_MedicalService_Fragment | EnrichedMeta_MeetOurStaff_Fragment | EnrichedMeta_MetroLinks_Fragment | EnrichedMeta_MobileButton_Fragment | EnrichedMeta_MultiCardV2_Fragment | EnrichedMeta_NavigationGroup_Fragment | EnrichedMeta_NavigationLink_Fragment | EnrichedMeta_OdpHero_Fragment | EnrichedMeta_Page_Fragment | EnrichedMeta_PageLayout_Fragment | EnrichedMeta_PageMeta_Fragment | EnrichedMeta_PatientReviewV2_Fragment | EnrichedMeta_PatientReviewsV2_Fragment | EnrichedMeta_Procedure_Fragment | EnrichedMeta_Product_Fragment | EnrichedMeta_ProductDisplay_Fragment | EnrichedMeta_ProductFeature_Fragment | EnrichedMeta_ProductFeatureDescriptionListItem_Fragment | EnrichedMeta_ProgressIndicator_Fragment | EnrichedMeta_ProviderDetailsPage_Fragment | EnrichedMeta_QuestionAnswer_Fragment | EnrichedMeta_Questionnaire_Fragment | EnrichedMeta_QuickLinks_Fragment | EnrichedMeta_Quiz_Fragment | EnrichedMeta_ReviewStep_Fragment | EnrichedMeta_Schema_Fragment | EnrichedMeta_SchemaStep_Fragment | EnrichedMeta_SectionContent_Fragment | EnrichedMeta_SegmentsContainer_Fragment | EnrichedMeta_Service_Fragment | EnrichedMeta_ServiceDetailsPage_Fragment | EnrichedMeta_ServiceGroup_Fragment | EnrichedMeta_ServiceLineHero_Fragment | EnrichedMeta_SharedForm_Fragment | EnrichedMeta_SharedFormDefinitions_Fragment | EnrichedMeta_SharedFormField_Fragment | EnrichedMeta_SingleMessage_Fragment | EnrichedMeta_SmallScreenContent_Fragment | EnrichedMeta_SmileAssessmentForm_Fragment | EnrichedMeta_Spacer_Fragment | EnrichedMeta_StateLinks_Fragment | EnrichedMeta_Stepper_Fragment | EnrichedMeta_SuccessCard_Fragment | EnrichedMeta_Tab_Fragment | EnrichedMeta_Table_Fragment | EnrichedMeta_Tabs_Fragment | EnrichedMeta_TermsAndConditions_Fragment | EnrichedMeta_TextBlockSeo_Fragment | EnrichedMeta_TextHighlight_Fragment | EnrichedMeta_TriggeredContentModal_Fragment | EnrichedMeta_Video_Fragment | EnrichedMeta_VideoAsset_Fragment | EnrichedMeta_VideoCarousel_Fragment | EnrichedMeta_VideoWithContent_Fragment;

export type LinkMetaFragment = { __typename: 'Asset', sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null, name?: string | null } | null> } };

export type ResourceMeta_AccordionsDescriptionRichTextResourcesBlock_Fragment = { __typename?: 'AccordionsDescriptionRichTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AccordionsDescriptionRichTextResourcesHyperlink_Fragment = { __typename?: 'AccordionsDescriptionRichTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AccordionsDescriptionRichTextResourcesInline_Fragment = { __typename?: 'AccordionsDescriptionRichTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutDescriptionResourcesBlock_Fragment = { __typename?: 'AdFooterAboutDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutDescriptionResourcesHyperlink_Fragment = { __typename?: 'AdFooterAboutDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutDescriptionResourcesInline_Fragment = { __typename?: 'AdFooterAboutDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutResourcesBlock_Fragment = { __typename?: 'AdFooterAboutResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutResourcesHyperlink_Fragment = { __typename?: 'AdFooterAboutResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AdFooterAboutResourcesInline_Fragment = { __typename?: 'AdFooterAboutResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AppViewCopyBodyResourcesBlock_Fragment = { __typename?: 'AppViewCopyBodyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AppViewCopyBodyResourcesHyperlink_Fragment = { __typename?: 'AppViewCopyBodyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AppViewCopyBodyResourcesInline_Fragment = { __typename?: 'AppViewCopyBodyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AppointmentBookingPagePageTitleResourcesBlock_Fragment = { __typename?: 'AppointmentBookingPagePageTitleResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AppointmentBookingPagePageTitleResourcesHyperlink_Fragment = { __typename?: 'AppointmentBookingPagePageTitleResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_AppointmentBookingPagePageTitleResourcesInline_Fragment = { __typename?: 'AppointmentBookingPagePageTitleResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogAuthorAuthorBioSummaryResourcesBlock_Fragment = { __typename?: 'BlogAuthorAuthorBioSummaryResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogAuthorAuthorBioSummaryResourcesHyperlink_Fragment = { __typename?: 'BlogAuthorAuthorBioSummaryResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogAuthorAuthorBioSummaryResourcesInline_Fragment = { __typename?: 'BlogAuthorAuthorBioSummaryResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageHeroContentTitleResourcesBlock_Fragment = { __typename?: 'BlogDetailsPageHeroContentTitleResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageHeroContentTitleResourcesHyperlink_Fragment = { __typename?: 'BlogDetailsPageHeroContentTitleResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageHeroContentTitleResourcesInline_Fragment = { __typename?: 'BlogDetailsPageHeroContentTitleResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageSummaryResourcesBlock_Fragment = { __typename?: 'BlogDetailsPageSummaryResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageSummaryResourcesHyperlink_Fragment = { __typename?: 'BlogDetailsPageSummaryResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageSummaryResourcesInline_Fragment = { __typename?: 'BlogDetailsPageSummaryResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageTextResourcesBlock_Fragment = { __typename?: 'BlogDetailsPageTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageTextResourcesHyperlink_Fragment = { __typename?: 'BlogDetailsPageTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogDetailsPageTextResourcesInline_Fragment = { __typename?: 'BlogDetailsPageTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogListPageDescriptionResourcesBlock_Fragment = { __typename?: 'BlogListPageDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogListPageDescriptionResourcesHyperlink_Fragment = { __typename?: 'BlogListPageDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BlogListPageDescriptionResourcesInline_Fragment = { __typename?: 'BlogListPageDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BodyTextContentResourcesBlock_Fragment = { __typename?: 'BodyTextContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BodyTextContentResourcesHyperlink_Fragment = { __typename?: 'BodyTextContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_BodyTextContentResourcesInline_Fragment = { __typename?: 'BodyTextContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_CardRichTextDescriptionResourcesBlock_Fragment = { __typename?: 'CardRichTextDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_CardRichTextDescriptionResourcesHyperlink_Fragment = { __typename?: 'CardRichTextDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_CardRichTextDescriptionResourcesInline_Fragment = { __typename?: 'CardRichTextDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentSectionDescriptionResourcesBlock_Fragment = { __typename?: 'ContentSectionDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentSectionDescriptionResourcesHyperlink_Fragment = { __typename?: 'ContentSectionDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentSectionDescriptionResourcesInline_Fragment = { __typename?: 'ContentSectionDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextContentResourcesBlock_Fragment = { __typename?: 'ContentTypeRichTextContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextContentResourcesHyperlink_Fragment = { __typename?: 'ContentTypeRichTextContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextContentResourcesInline_Fragment = { __typename?: 'ContentTypeRichTextContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextSecondaryContentResourcesBlock_Fragment = { __typename?: 'ContentTypeRichTextSecondaryContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextSecondaryContentResourcesHyperlink_Fragment = { __typename?: 'ContentTypeRichTextSecondaryContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ContentTypeRichTextSecondaryContentResourcesInline_Fragment = { __typename?: 'ContentTypeRichTextSecondaryContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ExperimentalModalBodyTextResourcesBlock_Fragment = { __typename?: 'ExperimentalModalBodyTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ExperimentalModalBodyTextResourcesHyperlink_Fragment = { __typename?: 'ExperimentalModalBodyTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ExperimentalModalBodyTextResourcesInline_Fragment = { __typename?: 'ExperimentalModalBodyTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesBlock_Fragment = { __typename?: 'FacilityDetailsPageMoreTextSeoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesHyperlink_Fragment = { __typename?: 'FacilityDetailsPageMoreTextSeoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesInline_Fragment = { __typename?: 'FacilityDetailsPageMoreTextSeoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageTextSeoResourcesBlock_Fragment = { __typename?: 'FacilityDetailsPageTextSeoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageTextSeoResourcesHyperlink_Fragment = { __typename?: 'FacilityDetailsPageTextSeoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_FacilityDetailsPageTextSeoResourcesInline_Fragment = { __typename?: 'FacilityDetailsPageTextSeoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesBlock_Fragment = { __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink_Fragment = { __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesInline_Fragment = { __typename?: 'GoogleMapTemplateNoResultsFoundMessageResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesBlock_Fragment = { __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink_Fragment = { __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesInline_Fragment = { __typename?: 'GoogleMapTemplateSingleComingSoonMessageResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenBodyResourcesBlock_Fragment = { __typename?: 'HalfScreenBodyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenBodyResourcesHyperlink_Fragment = { __typename?: 'HalfScreenBodyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenBodyResourcesInline_Fragment = { __typename?: 'HalfScreenBodyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenHeadingResourcesBlock_Fragment = { __typename?: 'HalfScreenHeadingResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenHeadingResourcesHyperlink_Fragment = { __typename?: 'HalfScreenHeadingResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenHeadingResourcesInline_Fragment = { __typename?: 'HalfScreenHeadingResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenSubHeadingResourcesBlock_Fragment = { __typename?: 'HalfScreenSubHeadingResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenSubHeadingResourcesHyperlink_Fragment = { __typename?: 'HalfScreenSubHeadingResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HalfScreenSubHeadingResourcesInline_Fragment = { __typename?: 'HalfScreenSubHeadingResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeadingContentResourcesBlock_Fragment = { __typename?: 'HeadingContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeadingContentResourcesHyperlink_Fragment = { __typename?: 'HeadingContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeadingContentResourcesInline_Fragment = { __typename?: 'HeadingContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2BodyResourcesBlock_Fragment = { __typename?: 'HeroV2BodyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2BodyResourcesHyperlink_Fragment = { __typename?: 'HeroV2BodyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2BodyResourcesInline_Fragment = { __typename?: 'HeroV2BodyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2HeadingResourcesBlock_Fragment = { __typename?: 'HeroV2HeadingResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2HeadingResourcesHyperlink_Fragment = { __typename?: 'HeroV2HeadingResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2HeadingResourcesInline_Fragment = { __typename?: 'HeroV2HeadingResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2PromoHeadlineResourcesBlock_Fragment = { __typename?: 'HeroV2PromoHeadlineResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2PromoHeadlineResourcesHyperlink_Fragment = { __typename?: 'HeroV2PromoHeadlineResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_HeroV2PromoHeadlineResourcesInline_Fragment = { __typename?: 'HeroV2PromoHeadlineResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_InsuranceIntroResourcesBlock_Fragment = { __typename?: 'InsuranceIntroResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_InsuranceIntroResourcesHyperlink_Fragment = { __typename?: 'InsuranceIntroResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_InsuranceIntroResourcesInline_Fragment = { __typename?: 'InsuranceIntroResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ListItemLinkTextResourcesBlock_Fragment = { __typename?: 'ListItemLinkTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ListItemLinkTextResourcesHyperlink_Fragment = { __typename?: 'ListItemLinkTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ListItemLinkTextResourcesInline_Fragment = { __typename?: 'ListItemLinkTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MedicalServiceDescriptionResourcesBlock_Fragment = { __typename?: 'MedicalServiceDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MedicalServiceDescriptionResourcesHyperlink_Fragment = { __typename?: 'MedicalServiceDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MedicalServiceDescriptionResourcesInline_Fragment = { __typename?: 'MedicalServiceDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2DescriptionRichTextResourcesBlock_Fragment = { __typename?: 'MultiCardV2DescriptionRichTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2DescriptionRichTextResourcesHyperlink_Fragment = { __typename?: 'MultiCardV2DescriptionRichTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2DescriptionRichTextResourcesInline_Fragment = { __typename?: 'MultiCardV2DescriptionRichTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardFourResourcesBlock_Fragment = { __typename?: 'MultiCardV2SimpleCardFourResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardFourResourcesHyperlink_Fragment = { __typename?: 'MultiCardV2SimpleCardFourResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardFourResourcesInline_Fragment = { __typename?: 'MultiCardV2SimpleCardFourResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardResourcesBlock_Fragment = { __typename?: 'MultiCardV2SimpleCardResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardResourcesHyperlink_Fragment = { __typename?: 'MultiCardV2SimpleCardResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardResourcesInline_Fragment = { __typename?: 'MultiCardV2SimpleCardResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardThreeResourcesBlock_Fragment = { __typename?: 'MultiCardV2SimpleCardThreeResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardThreeResourcesHyperlink_Fragment = { __typename?: 'MultiCardV2SimpleCardThreeResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardThreeResourcesInline_Fragment = { __typename?: 'MultiCardV2SimpleCardThreeResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardTwoResourcesBlock_Fragment = { __typename?: 'MultiCardV2SimpleCardTwoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardTwoResourcesHyperlink_Fragment = { __typename?: 'MultiCardV2SimpleCardTwoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_MultiCardV2SimpleCardTwoResourcesInline_Fragment = { __typename?: 'MultiCardV2SimpleCardTwoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ProductDisplayProductListDescriptionResourcesBlock_Fragment = { __typename?: 'ProductDisplayProductListDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ProductDisplayProductListDescriptionResourcesHyperlink_Fragment = { __typename?: 'ProductDisplayProductListDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ProductDisplayProductListDescriptionResourcesInline_Fragment = { __typename?: 'ProductDisplayProductListDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuestionAnswerAnswerResourcesBlock_Fragment = { __typename?: 'QuestionAnswerAnswerResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuestionAnswerAnswerResourcesHyperlink_Fragment = { __typename?: 'QuestionAnswerAnswerResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuestionAnswerAnswerResourcesInline_Fragment = { __typename?: 'QuestionAnswerAnswerResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksBodyResourcesBlock_Fragment = { __typename?: 'QuickLinksBodyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksBodyResourcesHyperlink_Fragment = { __typename?: 'QuickLinksBodyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksBodyResourcesInline_Fragment = { __typename?: 'QuickLinksBodyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksHeadingResourcesBlock_Fragment = { __typename?: 'QuickLinksHeadingResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksHeadingResourcesHyperlink_Fragment = { __typename?: 'QuickLinksHeadingResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_QuickLinksHeadingResourcesInline_Fragment = { __typename?: 'QuickLinksHeadingResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SectionContentRichTextContentResourcesBlock_Fragment = { __typename?: 'SectionContentRichTextContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SectionContentRichTextContentResourcesHyperlink_Fragment = { __typename?: 'SectionContentRichTextContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SectionContentRichTextContentResourcesInline_Fragment = { __typename?: 'SectionContentRichTextContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesBlock_Fragment = { __typename?: 'ServiceDetailsPageMoreTextSeoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesHyperlink_Fragment = { __typename?: 'ServiceDetailsPageMoreTextSeoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesInline_Fragment = { __typename?: 'ServiceDetailsPageMoreTextSeoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageTextSeoResourcesBlock_Fragment = { __typename?: 'ServiceDetailsPageTextSeoResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageTextSeoResourcesHyperlink_Fragment = { __typename?: 'ServiceDetailsPageTextSeoResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceDetailsPageTextSeoResourcesInline_Fragment = { __typename?: 'ServiceDetailsPageTextSeoResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroBodyCopyResourcesBlock_Fragment = { __typename?: 'ServiceLineHeroBodyCopyResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroBodyCopyResourcesHyperlink_Fragment = { __typename?: 'ServiceLineHeroBodyCopyResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroBodyCopyResourcesInline_Fragment = { __typename?: 'ServiceLineHeroBodyCopyResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroHeadlineResourcesBlock_Fragment = { __typename?: 'ServiceLineHeroHeadlineResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroHeadlineResourcesHyperlink_Fragment = { __typename?: 'ServiceLineHeroHeadlineResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroHeadlineResourcesInline_Fragment = { __typename?: 'ServiceLineHeroHeadlineResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroSubHeadlineResourcesBlock_Fragment = { __typename?: 'ServiceLineHeroSubHeadlineResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroSubHeadlineResourcesHyperlink_Fragment = { __typename?: 'ServiceLineHeroSubHeadlineResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceLineHeroSubHeadlineResourcesInline_Fragment = { __typename?: 'ServiceLineHeroSubHeadlineResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceRichTextDescriptionResourcesBlock_Fragment = { __typename?: 'ServiceRichTextDescriptionResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceRichTextDescriptionResourcesHyperlink_Fragment = { __typename?: 'ServiceRichTextDescriptionResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_ServiceRichTextDescriptionResourcesInline_Fragment = { __typename?: 'ServiceRichTextDescriptionResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SingleMessageContentResourcesBlock_Fragment = { __typename?: 'SingleMessageContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SingleMessageContentResourcesHyperlink_Fragment = { __typename?: 'SingleMessageContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SingleMessageContentResourcesInline_Fragment = { __typename?: 'SingleMessageContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentBodySmallScreenResourcesBlock_Fragment = { __typename?: 'SmallScreenContentBodySmallScreenResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentBodySmallScreenResourcesHyperlink_Fragment = { __typename?: 'SmallScreenContentBodySmallScreenResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentBodySmallScreenResourcesInline_Fragment = { __typename?: 'SmallScreenContentBodySmallScreenResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesBlock_Fragment = { __typename?: 'SmallScreenContentHeadingSmallScreenResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesHyperlink_Fragment = { __typename?: 'SmallScreenContentHeadingSmallScreenResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesInline_Fragment = { __typename?: 'SmallScreenContentHeadingSmallScreenResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableDescriptionRichTextResourcesBlock_Fragment = { __typename?: 'TableDescriptionRichTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableDescriptionRichTextResourcesHyperlink_Fragment = { __typename?: 'TableDescriptionRichTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableDescriptionRichTextResourcesInline_Fragment = { __typename?: 'TableDescriptionRichTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableFootnoteResourcesBlock_Fragment = { __typename?: 'TableFootnoteResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableFootnoteResourcesHyperlink_Fragment = { __typename?: 'TableFootnoteResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableFootnoteResourcesInline_Fragment = { __typename?: 'TableFootnoteResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableTableContentResourcesBlock_Fragment = { __typename?: 'TableTableContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableTableContentResourcesHyperlink_Fragment = { __typename?: 'TableTableContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TableTableContentResourcesInline_Fragment = { __typename?: 'TableTableContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TermsAndConditionsContentResourcesBlock_Fragment = { __typename?: 'TermsAndConditionsContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TermsAndConditionsContentResourcesHyperlink_Fragment = { __typename?: 'TermsAndConditionsContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TermsAndConditionsContentResourcesInline_Fragment = { __typename?: 'TermsAndConditionsContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextBlockSeoContentResourcesBlock_Fragment = { __typename?: 'TextBlockSeoContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextBlockSeoContentResourcesHyperlink_Fragment = { __typename?: 'TextBlockSeoContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextBlockSeoContentResourcesInline_Fragment = { __typename?: 'TextBlockSeoContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextHighlightContentResourcesBlock_Fragment = { __typename?: 'TextHighlightContentResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextHighlightContentResourcesHyperlink_Fragment = { __typename?: 'TextHighlightContentResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TextHighlightContentResourcesInline_Fragment = { __typename?: 'TextHighlightContentResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TriggeredContentModalBodyTextResourcesBlock_Fragment = { __typename?: 'TriggeredContentModalBodyTextResourcesBlock', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TriggeredContentModalBodyTextResourcesHyperlink_Fragment = { __typename?: 'TriggeredContentModalBodyTextResourcesHyperlink', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMeta_TriggeredContentModalBodyTextResourcesInline_Fragment = { __typename?: 'TriggeredContentModalBodyTextResourcesInline', sys: { __typename?: 'ResourceSys', urn: string, linkType: string } };

export type ResourceMetaFragment = ResourceMeta_AccordionsDescriptionRichTextResourcesBlock_Fragment | ResourceMeta_AccordionsDescriptionRichTextResourcesHyperlink_Fragment | ResourceMeta_AccordionsDescriptionRichTextResourcesInline_Fragment | ResourceMeta_AdFooterAboutDescriptionResourcesBlock_Fragment | ResourceMeta_AdFooterAboutDescriptionResourcesHyperlink_Fragment | ResourceMeta_AdFooterAboutDescriptionResourcesInline_Fragment | ResourceMeta_AdFooterAboutResourcesBlock_Fragment | ResourceMeta_AdFooterAboutResourcesHyperlink_Fragment | ResourceMeta_AdFooterAboutResourcesInline_Fragment | ResourceMeta_AppViewCopyBodyResourcesBlock_Fragment | ResourceMeta_AppViewCopyBodyResourcesHyperlink_Fragment | ResourceMeta_AppViewCopyBodyResourcesInline_Fragment | ResourceMeta_AppointmentBookingPagePageTitleResourcesBlock_Fragment | ResourceMeta_AppointmentBookingPagePageTitleResourcesHyperlink_Fragment | ResourceMeta_AppointmentBookingPagePageTitleResourcesInline_Fragment | ResourceMeta_BlogAuthorAuthorBioSummaryResourcesBlock_Fragment | ResourceMeta_BlogAuthorAuthorBioSummaryResourcesHyperlink_Fragment | ResourceMeta_BlogAuthorAuthorBioSummaryResourcesInline_Fragment | ResourceMeta_BlogDetailsPageHeroContentTitleResourcesBlock_Fragment | ResourceMeta_BlogDetailsPageHeroContentTitleResourcesHyperlink_Fragment | ResourceMeta_BlogDetailsPageHeroContentTitleResourcesInline_Fragment | ResourceMeta_BlogDetailsPageSummaryResourcesBlock_Fragment | ResourceMeta_BlogDetailsPageSummaryResourcesHyperlink_Fragment | ResourceMeta_BlogDetailsPageSummaryResourcesInline_Fragment | ResourceMeta_BlogDetailsPageTextResourcesBlock_Fragment | ResourceMeta_BlogDetailsPageTextResourcesHyperlink_Fragment | ResourceMeta_BlogDetailsPageTextResourcesInline_Fragment | ResourceMeta_BlogListPageDescriptionResourcesBlock_Fragment | ResourceMeta_BlogListPageDescriptionResourcesHyperlink_Fragment | ResourceMeta_BlogListPageDescriptionResourcesInline_Fragment | ResourceMeta_BodyTextContentResourcesBlock_Fragment | ResourceMeta_BodyTextContentResourcesHyperlink_Fragment | ResourceMeta_BodyTextContentResourcesInline_Fragment | ResourceMeta_CardRichTextDescriptionResourcesBlock_Fragment | ResourceMeta_CardRichTextDescriptionResourcesHyperlink_Fragment | ResourceMeta_CardRichTextDescriptionResourcesInline_Fragment | ResourceMeta_ContentSectionDescriptionResourcesBlock_Fragment | ResourceMeta_ContentSectionDescriptionResourcesHyperlink_Fragment | ResourceMeta_ContentSectionDescriptionResourcesInline_Fragment | ResourceMeta_ContentTypeRichTextContentResourcesBlock_Fragment | ResourceMeta_ContentTypeRichTextContentResourcesHyperlink_Fragment | ResourceMeta_ContentTypeRichTextContentResourcesInline_Fragment | ResourceMeta_ContentTypeRichTextSecondaryContentResourcesBlock_Fragment | ResourceMeta_ContentTypeRichTextSecondaryContentResourcesHyperlink_Fragment | ResourceMeta_ContentTypeRichTextSecondaryContentResourcesInline_Fragment | ResourceMeta_ExperimentalModalBodyTextResourcesBlock_Fragment | ResourceMeta_ExperimentalModalBodyTextResourcesHyperlink_Fragment | ResourceMeta_ExperimentalModalBodyTextResourcesInline_Fragment | ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesBlock_Fragment | ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesHyperlink_Fragment | ResourceMeta_FacilityDetailsPageMoreTextSeoResourcesInline_Fragment | ResourceMeta_FacilityDetailsPageTextSeoResourcesBlock_Fragment | ResourceMeta_FacilityDetailsPageTextSeoResourcesHyperlink_Fragment | ResourceMeta_FacilityDetailsPageTextSeoResourcesInline_Fragment | ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesBlock_Fragment | ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesHyperlink_Fragment | ResourceMeta_GoogleMapTemplateNoResultsFoundMessageResourcesInline_Fragment | ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesBlock_Fragment | ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesHyperlink_Fragment | ResourceMeta_GoogleMapTemplateSingleComingSoonMessageResourcesInline_Fragment | ResourceMeta_HalfScreenBodyResourcesBlock_Fragment | ResourceMeta_HalfScreenBodyResourcesHyperlink_Fragment | ResourceMeta_HalfScreenBodyResourcesInline_Fragment | ResourceMeta_HalfScreenHeadingResourcesBlock_Fragment | ResourceMeta_HalfScreenHeadingResourcesHyperlink_Fragment | ResourceMeta_HalfScreenHeadingResourcesInline_Fragment | ResourceMeta_HalfScreenSubHeadingResourcesBlock_Fragment | ResourceMeta_HalfScreenSubHeadingResourcesHyperlink_Fragment | ResourceMeta_HalfScreenSubHeadingResourcesInline_Fragment | ResourceMeta_HeadingContentResourcesBlock_Fragment | ResourceMeta_HeadingContentResourcesHyperlink_Fragment | ResourceMeta_HeadingContentResourcesInline_Fragment | ResourceMeta_HeroV2BodyResourcesBlock_Fragment | ResourceMeta_HeroV2BodyResourcesHyperlink_Fragment | ResourceMeta_HeroV2BodyResourcesInline_Fragment | ResourceMeta_HeroV2HeadingResourcesBlock_Fragment | ResourceMeta_HeroV2HeadingResourcesHyperlink_Fragment | ResourceMeta_HeroV2HeadingResourcesInline_Fragment | ResourceMeta_HeroV2PromoHeadlineResourcesBlock_Fragment | ResourceMeta_HeroV2PromoHeadlineResourcesHyperlink_Fragment | ResourceMeta_HeroV2PromoHeadlineResourcesInline_Fragment | ResourceMeta_InsuranceIntroResourcesBlock_Fragment | ResourceMeta_InsuranceIntroResourcesHyperlink_Fragment | ResourceMeta_InsuranceIntroResourcesInline_Fragment | ResourceMeta_ListItemLinkTextResourcesBlock_Fragment | ResourceMeta_ListItemLinkTextResourcesHyperlink_Fragment | ResourceMeta_ListItemLinkTextResourcesInline_Fragment | ResourceMeta_MedicalServiceDescriptionResourcesBlock_Fragment | ResourceMeta_MedicalServiceDescriptionResourcesHyperlink_Fragment | ResourceMeta_MedicalServiceDescriptionResourcesInline_Fragment | ResourceMeta_MultiCardV2DescriptionRichTextResourcesBlock_Fragment | ResourceMeta_MultiCardV2DescriptionRichTextResourcesHyperlink_Fragment | ResourceMeta_MultiCardV2DescriptionRichTextResourcesInline_Fragment | ResourceMeta_MultiCardV2SimpleCardFourResourcesBlock_Fragment | ResourceMeta_MultiCardV2SimpleCardFourResourcesHyperlink_Fragment | ResourceMeta_MultiCardV2SimpleCardFourResourcesInline_Fragment | ResourceMeta_MultiCardV2SimpleCardResourcesBlock_Fragment | ResourceMeta_MultiCardV2SimpleCardResourcesHyperlink_Fragment | ResourceMeta_MultiCardV2SimpleCardResourcesInline_Fragment | ResourceMeta_MultiCardV2SimpleCardThreeResourcesBlock_Fragment | ResourceMeta_MultiCardV2SimpleCardThreeResourcesHyperlink_Fragment | ResourceMeta_MultiCardV2SimpleCardThreeResourcesInline_Fragment | ResourceMeta_MultiCardV2SimpleCardTwoResourcesBlock_Fragment | ResourceMeta_MultiCardV2SimpleCardTwoResourcesHyperlink_Fragment | ResourceMeta_MultiCardV2SimpleCardTwoResourcesInline_Fragment | ResourceMeta_ProductDisplayProductListDescriptionResourcesBlock_Fragment | ResourceMeta_ProductDisplayProductListDescriptionResourcesHyperlink_Fragment | ResourceMeta_ProductDisplayProductListDescriptionResourcesInline_Fragment | ResourceMeta_QuestionAnswerAnswerResourcesBlock_Fragment | ResourceMeta_QuestionAnswerAnswerResourcesHyperlink_Fragment | ResourceMeta_QuestionAnswerAnswerResourcesInline_Fragment | ResourceMeta_QuickLinksBodyResourcesBlock_Fragment | ResourceMeta_QuickLinksBodyResourcesHyperlink_Fragment | ResourceMeta_QuickLinksBodyResourcesInline_Fragment | ResourceMeta_QuickLinksHeadingResourcesBlock_Fragment | ResourceMeta_QuickLinksHeadingResourcesHyperlink_Fragment | ResourceMeta_QuickLinksHeadingResourcesInline_Fragment | ResourceMeta_SectionContentRichTextContentResourcesBlock_Fragment | ResourceMeta_SectionContentRichTextContentResourcesHyperlink_Fragment | ResourceMeta_SectionContentRichTextContentResourcesInline_Fragment | ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesBlock_Fragment | ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesHyperlink_Fragment | ResourceMeta_ServiceDetailsPageMoreTextSeoResourcesInline_Fragment | ResourceMeta_ServiceDetailsPageTextSeoResourcesBlock_Fragment | ResourceMeta_ServiceDetailsPageTextSeoResourcesHyperlink_Fragment | ResourceMeta_ServiceDetailsPageTextSeoResourcesInline_Fragment | ResourceMeta_ServiceLineHeroBodyCopyResourcesBlock_Fragment | ResourceMeta_ServiceLineHeroBodyCopyResourcesHyperlink_Fragment | ResourceMeta_ServiceLineHeroBodyCopyResourcesInline_Fragment | ResourceMeta_ServiceLineHeroHeadlineResourcesBlock_Fragment | ResourceMeta_ServiceLineHeroHeadlineResourcesHyperlink_Fragment | ResourceMeta_ServiceLineHeroHeadlineResourcesInline_Fragment | ResourceMeta_ServiceLineHeroSubHeadlineResourcesBlock_Fragment | ResourceMeta_ServiceLineHeroSubHeadlineResourcesHyperlink_Fragment | ResourceMeta_ServiceLineHeroSubHeadlineResourcesInline_Fragment | ResourceMeta_ServiceRichTextDescriptionResourcesBlock_Fragment | ResourceMeta_ServiceRichTextDescriptionResourcesHyperlink_Fragment | ResourceMeta_ServiceRichTextDescriptionResourcesInline_Fragment | ResourceMeta_SingleMessageContentResourcesBlock_Fragment | ResourceMeta_SingleMessageContentResourcesHyperlink_Fragment | ResourceMeta_SingleMessageContentResourcesInline_Fragment | ResourceMeta_SmallScreenContentBodySmallScreenResourcesBlock_Fragment | ResourceMeta_SmallScreenContentBodySmallScreenResourcesHyperlink_Fragment | ResourceMeta_SmallScreenContentBodySmallScreenResourcesInline_Fragment | ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesBlock_Fragment | ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesHyperlink_Fragment | ResourceMeta_SmallScreenContentHeadingSmallScreenResourcesInline_Fragment | ResourceMeta_TableDescriptionRichTextResourcesBlock_Fragment | ResourceMeta_TableDescriptionRichTextResourcesHyperlink_Fragment | ResourceMeta_TableDescriptionRichTextResourcesInline_Fragment | ResourceMeta_TableFootnoteResourcesBlock_Fragment | ResourceMeta_TableFootnoteResourcesHyperlink_Fragment | ResourceMeta_TableFootnoteResourcesInline_Fragment | ResourceMeta_TableTableContentResourcesBlock_Fragment | ResourceMeta_TableTableContentResourcesHyperlink_Fragment | ResourceMeta_TableTableContentResourcesInline_Fragment | ResourceMeta_TermsAndConditionsContentResourcesBlock_Fragment | ResourceMeta_TermsAndConditionsContentResourcesHyperlink_Fragment | ResourceMeta_TermsAndConditionsContentResourcesInline_Fragment | ResourceMeta_TextBlockSeoContentResourcesBlock_Fragment | ResourceMeta_TextBlockSeoContentResourcesHyperlink_Fragment | ResourceMeta_TextBlockSeoContentResourcesInline_Fragment | ResourceMeta_TextHighlightContentResourcesBlock_Fragment | ResourceMeta_TextHighlightContentResourcesHyperlink_Fragment | ResourceMeta_TextHighlightContentResourcesInline_Fragment | ResourceMeta_TriggeredContentModalBodyTextResourcesBlock_Fragment | ResourceMeta_TriggeredContentModalBodyTextResourcesHyperlink_Fragment | ResourceMeta_TriggeredContentModalBodyTextResourcesInline_Fragment;

export type Error404Fragment = { __typename?: 'Error404', heading?: string | null, subtitle?: string | null, body?: string | null, buttonLabel?: string | null, darkTextColor?: boolean | null, backgroundImage?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, backgroundImageMobile?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> }, supplementaryButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null };

export type ExperimentContainerFragment = (
  { __typename?: 'ExperimentContainer', experimentId?: string | null, experimentType?: string | null, featureFlagKey?: string | null, variationItemsCollection?: { __typename?: 'ExperimentContainerVariationItemsCollection', items: Array<(
      { __typename?: 'ExperimentVariationContentsItem', variationId?: string | null, contentsCollection?: { __typename?: 'ExperimentVariationContentsItemContentsCollection', items: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | null> } | null }
      & Meta_ExperimentVariationContentsItem_Fragment
    ) | null> } | null }
  & Meta_ExperimentContainer_Fragment
);

export type GoogleMapTemplateFragment = (
  { __typename?: 'GoogleMapTemplate', title?: string | null, titleHtag?: string | null, useUsaCountryMap?: boolean | null, desktopZoom?: number | null, mobileZoom?: number | null, locationScheduleButtonUrl?: string | null, googleMapsBusinessQuery?: string | null, facilityBasePath?: string | null, holidayHoursMessageText?: string | null, listTabIsHorizontalScrolling?: boolean | null, facilityBadgeLabel?: string | null, facilityButtonLabel?: string | null, useModernDesign?: boolean | null, setAsOfficeButtonText?: string | null, useCumulativeDesign?: boolean | null, anchorId?: string | null, hideLocationCardButtons?: boolean | null, hideOfficeDetailsButton?: boolean | null, disableMarkerClick?: boolean | null, hideLocationsListOnMobile?: boolean | null, defaultImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, selectedImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, noResultsFoundMessage?: { __typename?: 'GoogleMapTemplateNoResultsFoundMessage', json: any } | null, singleComingSoonMessage?: { __typename?: 'GoogleMapTemplateSingleComingSoonMessage', json: any } | null, scheduleButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null, officeDetailsButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null, noResultsFoundImage?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, noResultsContent?: (
    { __typename?: 'MultiCardV2' }
    & CardsFragment
  ) | null, availableServicesTabs?: (
    { __typename?: 'Tabs' }
    & TabsFragment
  ) | null }
  & Meta_GoogleMapTemplate_Fragment
);

export type GoogleMapInHeaderFragment = (
  { __typename?: 'GoogleMapTemplate', title?: string | null, titleHtag?: string | null, locationScheduleButtonUrl?: string | null, googleMapsBusinessQuery?: string | null, facilityBadgeLabel?: string | null, facilityButtonLabel?: string | null, setAsOfficeButtonText?: string | null, disableMarkerClick?: boolean | null, defaultImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, selectedImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, noResultsFoundMessage?: { __typename?: 'GoogleMapTemplateNoResultsFoundMessage', json: any } | null, scheduleButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null, officeDetailsButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null }
  & Meta_GoogleMapTemplate_Fragment
);

export type HalfScreenFragment = (
  { __typename?: 'HalfScreen', name?: string | null, backgroundColor?: string | null, display?: string | null, eyebrow?: string | null, eyebrowStyle?: string | null, templateSize?: string | null, mediaFirst?: boolean | null, facilitySegmentCollection?: string | null, hideContentHalf?: boolean | null, isInsetLayout?: boolean | null, useStaticImageSize?: boolean | null, anchorId?: string | null, textAlignment?: string | null, variant?: string | null, termsAndConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, heading?: { __typename?: 'HalfScreenHeading', json: any } | null, subHeading?: { __typename?: 'HalfScreenSubHeading', json: any } | null, body?: { __typename?: 'HalfScreenBody', json: any } | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, buttonCollection?: { __typename?: 'HalfScreenButtonCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, video?: (
    { __typename?: 'Video' }
    & VideoFragment
  ) | null, contentSmallScreen?: { __typename?: 'SmallScreenContent', mediaFirst?: boolean | null, headingSmallScreen?: { __typename?: 'SmallScreenContentHeadingSmallScreen', json: any } | null, bodySmallScreen?: { __typename?: 'SmallScreenContentBodySmallScreen', json: any } | null, imageSmallScreen?: (
      { __typename?: 'Asset' }
      & ImageFragment
    ) | null } | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2Fragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, videoAsset?: (
    { __typename?: 'VideoAsset' }
    & VideoAssetFragment
  ) | null, imageAssetTwo?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_HalfScreen_Fragment
);

export type HeroFragment = (
  { __typename?: 'HeroV2', entryName?: string | null, display?: string | null, backgroundColorSmallScreen?: string | null, bodySize?: string | null, contentAlign?: string | null, contentWidth?: string | null, contentPosition?: string | null, contentPositionSmallScreen?: string | null, darkOverlay?: boolean | null, darkTextColor?: boolean | null, eyebrow?: string | null, eyebrowStyle?: string | null, facilitySegmentCollection?: string | null, headingSize?: string | null, mediaAspectRatioSmallScreen?: string | null, templateWidth?: string | null, heightStyle?: string | null, promoHeadlineSize?: string | null, anchorId?: string | null, variant?: string | null, aspenDentalReasonForVisit?: string | null, body?: { __typename?: 'HeroV2Body', json: any } | null, buttonsCollection?: { __typename?: 'HeroV2ButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, contentSmallScreen?: { __typename?: 'SmallScreenContent', eyebrowSmallScreen?: string | null, mediaFirst?: boolean | null, headingSmallScreen?: { __typename?: 'SmallScreenContentHeadingSmallScreen', json: any } | null, bodySmallScreen?: { __typename?: 'SmallScreenContentBodySmallScreen', json: any } | null, imageSmallScreen?: (
      { __typename?: 'Asset' }
      & ImageFragment
    ) | null, focalPointImageSmallScreen?: (
      { __typename?: 'FocalPointImage' }
      & FocalPointImageFragment
    ) | null } | null, focalPointImage?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, heading?: { __typename?: 'HeroV2Heading', json: any } | null, termsConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, video?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, promoHeadline?: { __typename?: 'HeroV2PromoHeadline', json: any } | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2Fragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, videoAsset?: (
    { __typename?: 'VideoAsset' }
    & VideoAssetFragment
  ) | null, nestedContentCollection?: { __typename?: 'HeroV2NestedContentCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'Quiz' }
      & QuizFragment
    ) | null> } | null }
  & Meta_HeroV2_Fragment
);

export type IframeFragment = (
  { __typename?: 'Iframe', title?: string | null, url?: string | null, height?: number | null, rawHtml?: string | null }
  & Meta_Iframe_Fragment
);

export type FocalPointImageFragment = (
  { __typename?: 'FocalPointImage', focalPoint?: any | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null }
  & Meta_FocalPointImage_Fragment
);

export type ImageFragment = (
  { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null }
  & CommonAssetFragment
);

export type PdfFragment = (
  { __typename?: 'Asset', url?: string | null }
  & CommonAssetFragment
);

export type CommonAssetFragment = { __typename: 'Asset', title?: string | null, description?: string | null, fileName?: string | null, contentType?: string | null, size?: number | null, sys: { __typename?: 'Sys', id: string, spaceId: string, environmentId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', name?: string | null, id?: string | null } | null> } };

export type VideoFragment = (
  { __typename: 'Video', autoPlay?: boolean | null, isMuted?: boolean | null, isLooped?: boolean | null, posterUrl?: string | null, youtubeId?: string | null, useOriginalVideoSize?: boolean | null, videoSource?: string | null, hlsVideoStreamLink?: string | null, media?: (
    { __typename: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, posterMedia?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null }
  & Meta_Video_Fragment
);

export type ImageAssetFragment = (
  { __typename?: 'ImageAsset', desktopImage?: any | null, mobileImage?: any | null }
  & Meta_ImageAsset_Fragment
);

export type InsuranceFragment = (
  { __typename?: 'Insurance', title?: string | null, intro?: { __typename?: 'InsuranceIntro', json: any } | null }
  & Meta_Insurance_Fragment
);

export type MarqueeFragment = (
  { __typename?: 'Marquee', textList?: Array<string | null> | null, icon?: string | null, height?: string | null, backgroundColor?: string | null, withAutoScrolling?: boolean | null, facilitySegmentCollection?: string | null, anchorId?: string | null }
  & Meta_Marquee_Fragment
);

export type MeetOurStaffFragment = (
  { __typename?: 'MeetOurStaff', title?: string | null, description?: string | null, sectionBackground?: string | null, alignment?: string | null, contentMaxWidth?: string | null, showDisabledSwiperArrows?: boolean | null, withDesktopPaginationNavigation?: boolean | null, withMobileArrowsNavigation?: boolean | null, anchorId?: string | null }
  & Meta_MeetOurStaff_Fragment
);

export type MobileButtonFragment = (
  { __typename?: 'MobileButton', name?: string | null, label?: string | null, variant?: string | null, size?: string | null, icon?: string | null, iconPosition?: string | null }
  & Meta_MobileButton_Fragment
);

export type CardsFragment = (
  { __typename?: 'MultiCardV2', anchorId?: string | null, backgroundColor?: string | null, display?: string | null, bigScreenBackground?: boolean | null, cardsAlignment?: string | null, eyebrowColor?: string | null, eyebrowSx?: string | null, eyebrowTextTransform?: string | null, disablePaddingOn?: Array<string | null> | null, forMobile?: string | null, enableMobileCarouselNavigation?: boolean | null, lastRowCardsAlignment?: string | null, name?: string | null, numberOfCardsInLineDesktop?: number | null, roundedImage?: boolean | null, sectionEyebrow?: string | null, sectionInfoAlignment?: string | null, sectionTitle?: string | null, sectionTitleHtag?: string | null, facilitySegmentCollection?: string | null, displayAsStepper?: boolean | null, fixBackgroundToBottom?: boolean | null, headerSpacing?: string | null, enableResourceCardMode?: boolean | null, shouldDisplayCarouselOnDesktop?: boolean | null, useCardMediaRoundedCorners?: boolean | null, variant?: string | null, descriptionRichText?: { __typename?: 'MultiCardV2DescriptionRichText', json: any } | null, cardsCollection?: { __typename?: 'MultiCardV2CardsCollection', items: Array<(
      { __typename?: 'Card' }
      & CardFragment
    ) | null> } | null, buttonsCollection?: { __typename?: 'MultiCardV2ButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, backgroundImage?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, simpleCard?: { __typename?: 'MultiCardV2SimpleCard', json: any } | null, simpleCardTwo?: { __typename?: 'MultiCardV2SimpleCardTwo', json: any } | null, simpleCardThree?: { __typename?: 'MultiCardV2SimpleCardThree', json: any } | null, simpleCardFour?: { __typename?: 'MultiCardV2SimpleCardFour', json: any } | null }
  & Meta_MultiCardV2_Fragment
);

export type FooterNavigationGroupFragment = (
  { __typename?: 'FooterNavigationGroup', componentName?: string | null, navigationGroupLink?: (
    { __typename?: 'Page' }
    & BasePageFragment
  ) | null, navigationLinksForGroupCollection?: { __typename?: 'FooterNavigationGroupNavigationLinksForGroupCollection', skip: number, limit: number, total: number, items: Array<{ __typename?: 'NavigationLink' } | (
      { __typename?: 'Page' }
      & BasePageFragment
    ) | null> } | null }
  & EnrichedMeta_FooterNavigationGroup_Fragment
);

export type BasePageFragment = (
  { __typename?: 'Page', path?: string | null, title?: string | null, breadcrumbTitle?: string | null, description?: string | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null }
  & EnrichedMeta_Page_Fragment
);

export type NavLinkFragment = (
  { __typename?: 'NavigationLink', externalUrl?: string | null, linkText?: string | null, openInNewTab?: boolean | null, openInNewWindow?: boolean | null, isInternal?: boolean | null, linkIcon?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, pageData?: (
    { __typename?: 'BlogDetailsPage', path?: string | null }
    & Meta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage', path?: string | null }
    & Meta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'Page' }
    & BasePageFragment
  ) | (
    { __typename?: 'ServiceDetailsPage', path?: string | null }
    & Meta_ServiceDetailsPage_Fragment
  ) | null, analyticsContext?: (
    { __typename?: 'AnalyticsContext' }
    & AnalyticsFragment
  ) | null }
  & EnrichedMeta_NavigationLink_Fragment
);

export type ContentTileFragment = (
  { __typename?: 'ContentTile', title?: string | null, description?: string | null, image?: any | null, externalUrl?: string | null, internalPage?: (
    { __typename?: 'Page' }
    & BasePageFragment
  ) | null }
  & EnrichedMeta_ContentTile_Fragment
);

export type HeaderSubNavFragment = { __typename?: 'HeaderSubNav', featuredLink?: (
    { __typename?: 'NavigationLink' }
    & NavLinkFragment
  ) | null, headerSubNavGroupsCollection?: { __typename?: 'HeaderSubNavHeaderSubNavGroupsCollection', items: Array<{ __typename?: 'NavigationGroup', displayAsExpandedForMobileMenu?: boolean | null, groupLink?: (
        { __typename?: 'NavigationLink' }
        & NavLinkFragment
      ) | null, linksCollection?: { __typename?: 'NavigationGroupLinksCollection', items: Array<(
          { __typename?: 'NavigationLink' }
          & NavLinkFragment
        ) | null> } | null } | null> } | null, contentTilesCollection?: { __typename?: 'HeaderSubNavContentTilesCollection', items: Array<(
      { __typename?: 'ContentTile' }
      & ContentTileFragment
    ) | null> } | null };

export type HeaderMainNavFragment = { __typename?: 'HeaderMainNav', headerMainNavLink?: (
    { __typename?: 'NavigationLink' }
    & NavLinkFragment
  ) | null, headerSubNavMenu?: (
    { __typename?: 'HeaderSubNav' }
    & HeaderSubNavFragment
  ) | null };

export type HeaderNavMenuFragment = { __typename?: 'HeaderNavMenu', headerMainNavLinksCollection?: { __typename?: 'HeaderNavMenuHeaderMainNavLinksCollection', items: Array<(
      { __typename?: 'HeaderMainNav' }
      & HeaderMainNavFragment
    ) | null> } | null };

export type HeaderFragment = (
  { __typename?: 'Header', darkHeader?: boolean | null, componentName?: string | null, variant?: string | null, hideFullSiteSearch?: boolean | null, locationBarFindOfficeUrl?: string | null, locationBarWithOfficeTitle?: string | null, locationBarWithOutOfficeTitle?: string | null, useNewLayout?: boolean | null, schedulingButtonUrlMobile?: string | null, schedulingButtonUrl?: string | null, schedulingButtonText?: string | null, schedulingButtonTextMobile?: string | null, myAccountLabel?: string | null, profileLinkUrl?: string | null, useHeaderLocationCards?: boolean | null, showSecondaryNavInMobileToolbar?: boolean | null, searchFieldTitle?: string | null, hideOdpLinks?: boolean | null, usePopupScheduling?: boolean | null, bookNowButton?: (
    { __typename?: 'Accordions' }
    & EnrichedMeta_Accordions_Fragment
  ) | (
    { __typename?: 'AdFooter' }
    & EnrichedMeta_AdFooter_Fragment
  ) | (
    { __typename?: 'AgendaModal' }
    & EnrichedMeta_AgendaModal_Fragment
  ) | (
    { __typename?: 'AgendaStepper' }
    & EnrichedMeta_AgendaStepper_Fragment
  ) | (
    { __typename?: 'AnalyticsContext' }
    & EnrichedMeta_AnalyticsContext_Fragment
  ) | (
    { __typename?: 'App' }
    & EnrichedMeta_App_Fragment
  ) | (
    { __typename?: 'AppCopySlot' }
    & EnrichedMeta_AppCopySlot_Fragment
  ) | (
    { __typename?: 'AppFaq' }
    & EnrichedMeta_AppFaq_Fragment
  ) | (
    { __typename?: 'AppLegalDocument' }
    & EnrichedMeta_AppLegalDocument_Fragment
  ) | (
    { __typename?: 'AppMediaSlot' }
    & EnrichedMeta_AppMediaSlot_Fragment
  ) | (
    { __typename?: 'AppOffer' }
    & EnrichedMeta_AppOffer_Fragment
  ) | (
    { __typename?: 'AppReachYouCard' }
    & EnrichedMeta_AppReachYouCard_Fragment
  ) | (
    { __typename?: 'AppTip' }
    & EnrichedMeta_AppTip_Fragment
  ) | (
    { __typename?: 'AppTreatmentInfo' }
    & EnrichedMeta_AppTreatmentInfo_Fragment
  ) | (
    { __typename?: 'AppViewCopy' }
    & EnrichedMeta_AppViewCopy_Fragment
  ) | (
    { __typename?: 'AppointmentBookingPage' }
    & EnrichedMeta_AppointmentBookingPage_Fragment
  ) | (
    { __typename?: 'Badge' }
    & EnrichedMeta_Badge_Fragment
  ) | (
    { __typename?: 'Banner' }
    & EnrichedMeta_Banner_Fragment
  ) | (
    { __typename?: 'BirdEyeReviews' }
    & EnrichedMeta_BirdEyeReviews_Fragment
  ) | (
    { __typename?: 'BlogAuthor' }
    & EnrichedMeta_BlogAuthor_Fragment
  ) | (
    { __typename?: 'BlogCategory' }
    & EnrichedMeta_BlogCategory_Fragment
  ) | (
    { __typename?: 'BlogDetailsPage' }
    & EnrichedMeta_BlogDetailsPage_Fragment
  ) | (
    { __typename?: 'BlogList' }
    & EnrichedMeta_BlogList_Fragment
  ) | (
    { __typename?: 'BlogListPage' }
    & EnrichedMeta_BlogListPage_Fragment
  ) | (
    { __typename?: 'BlogSubCategory' }
    & EnrichedMeta_BlogSubCategory_Fragment
  ) | (
    { __typename?: 'BodyText' }
    & EnrichedMeta_BodyText_Fragment
  ) | (
    { __typename?: 'Brand' }
    & EnrichedMeta_Brand_Fragment
  ) | (
    { __typename?: 'Button' }
    & EnrichedMeta_Button_Fragment
  ) | (
    { __typename?: 'Card' }
    & EnrichedMeta_Card_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & EnrichedMeta_Carousel_Fragment
  ) | (
    { __typename?: 'Category' }
    & EnrichedMeta_Category_Fragment
  ) | (
    { __typename?: 'CategoryPicker' }
    & EnrichedMeta_CategoryPicker_Fragment
  ) | (
    { __typename?: 'CityLinks' }
    & EnrichedMeta_CityLinks_Fragment
  ) | (
    { __typename?: 'Columns' }
    & EnrichedMeta_Columns_Fragment
  ) | (
    { __typename?: 'ConfirmationStep' }
    & EnrichedMeta_ConfirmationStep_Fragment
  ) | (
    { __typename?: 'ContentData' }
    & EnrichedMeta_ContentData_Fragment
  ) | (
    { __typename?: 'ContentSection' }
    & EnrichedMeta_ContentSection_Fragment
  ) | (
    { __typename?: 'ContentTile' }
    & EnrichedMeta_ContentTile_Fragment
  ) | (
    { __typename?: 'ContentTypeRichText' }
    & EnrichedMeta_ContentTypeRichText_Fragment
  ) | (
    { __typename?: 'ConvertFlowCta' }
    & EnrichedMeta_ConvertFlowCta_Fragment
  ) | (
    { __typename?: 'ConvertFlowQuiz' }
    & EnrichedMeta_ConvertFlowQuiz_Fragment
  ) | (
    { __typename?: 'DisclaimerV2' }
    & EnrichedMeta_DisclaimerV2_Fragment
  ) | (
    { __typename?: 'Error404' }
    & EnrichedMeta_Error404_Fragment
  ) | (
    { __typename?: 'Experience' }
    & EnrichedMeta_Experience_Fragment
  ) | (
    { __typename?: 'ExperimentContainer' }
    & EnrichedMeta_ExperimentContainer_Fragment
  ) | (
    { __typename?: 'ExperimentVariationContentsItem' }
    & EnrichedMeta_ExperimentVariationContentsItem_Fragment
  ) | (
    { __typename?: 'ExperimentalModal' }
    & EnrichedMeta_ExperimentalModal_Fragment
  ) | (
    { __typename?: 'FacilityDetailsPage' }
    & EnrichedMeta_FacilityDetailsPage_Fragment
  ) | (
    { __typename?: 'FaqAccordion' }
    & EnrichedMeta_FaqAccordion_Fragment
  ) | (
    { __typename?: 'FeatureFlags' }
    & EnrichedMeta_FeatureFlags_Fragment
  ) | (
    { __typename?: 'FocalPointImage' }
    & EnrichedMeta_FocalPointImage_Fragment
  ) | (
    { __typename?: 'FooterNavigationGroup' }
    & EnrichedMeta_FooterNavigationGroup_Fragment
  ) | (
    { __typename?: 'FormDropdownField' }
    & EnrichedMeta_FormDropdownField_Fragment
  ) | (
    { __typename?: 'FormField' }
    & EnrichedMeta_FormField_Fragment
  ) | (
    { __typename?: 'GoogleMapTemplate' }
    & EnrichedMeta_GoogleMapTemplate_Fragment
  ) | (
    { __typename?: 'HalfScreen' }
    & EnrichedMeta_HalfScreen_Fragment
  ) | (
    { __typename?: 'Header' }
    & EnrichedMeta_Header_Fragment
  ) | (
    { __typename?: 'HeaderMainNav' }
    & EnrichedMeta_HeaderMainNav_Fragment
  ) | (
    { __typename?: 'HeaderNavMenu' }
    & EnrichedMeta_HeaderNavMenu_Fragment
  ) | (
    { __typename?: 'HeaderSubNav' }
    & EnrichedMeta_HeaderSubNav_Fragment
  ) | (
    { __typename?: 'Heading' }
    & EnrichedMeta_Heading_Fragment
  ) | (
    { __typename?: 'HeroV2' }
    & EnrichedMeta_HeroV2_Fragment
  ) | (
    { __typename?: 'Icon' }
    & EnrichedMeta_Icon_Fragment
  ) | (
    { __typename?: 'Iframe' }
    & EnrichedMeta_Iframe_Fragment
  ) | (
    { __typename?: 'ImageAsset' }
    & EnrichedMeta_ImageAsset_Fragment
  ) | (
    { __typename?: 'Insurance' }
    & EnrichedMeta_Insurance_Fragment
  ) | (
    { __typename?: 'LinkForwarder' }
    & EnrichedMeta_LinkForwarder_Fragment
  ) | (
    { __typename?: 'List' }
    & EnrichedMeta_List_Fragment
  ) | (
    { __typename?: 'ListItem' }
    & EnrichedMeta_ListItem_Fragment
  ) | (
    { __typename?: 'LocalizedServiceTitle' }
    & EnrichedMeta_LocalizedServiceTitle_Fragment
  ) | (
    { __typename?: 'Marquee' }
    & EnrichedMeta_Marquee_Fragment
  ) | (
    { __typename?: 'Media' }
    & EnrichedMeta_Media_Fragment
  ) | (
    { __typename?: 'MediaSlider' }
    & EnrichedMeta_MediaSlider_Fragment
  ) | (
    { __typename?: 'MedicalService' }
    & EnrichedMeta_MedicalService_Fragment
  ) | (
    { __typename?: 'MeetOurStaff' }
    & EnrichedMeta_MeetOurStaff_Fragment
  ) | (
    { __typename?: 'MetroLinks' }
    & EnrichedMeta_MetroLinks_Fragment
  ) | (
    { __typename?: 'MobileButton' }
    & EnrichedMeta_MobileButton_Fragment
  ) | (
    { __typename?: 'MultiCardV2' }
    & EnrichedMeta_MultiCardV2_Fragment
  ) | (
    { __typename?: 'NavigationGroup' }
    & EnrichedMeta_NavigationGroup_Fragment
  ) | (
    { __typename?: 'NavigationLink' }
    & EnrichedMeta_NavigationLink_Fragment
  ) | (
    { __typename?: 'OdpHero' }
    & EnrichedMeta_OdpHero_Fragment
  ) | (
    { __typename?: 'Page' }
    & EnrichedMeta_Page_Fragment
  ) | (
    { __typename?: 'PageLayout' }
    & EnrichedMeta_PageLayout_Fragment
  ) | (
    { __typename?: 'PageMeta' }
    & EnrichedMeta_PageMeta_Fragment
  ) | (
    { __typename?: 'PatientReviewV2' }
    & EnrichedMeta_PatientReviewV2_Fragment
  ) | (
    { __typename?: 'PatientReviewsV2' }
    & EnrichedMeta_PatientReviewsV2_Fragment
  ) | (
    { __typename?: 'Procedure' }
    & EnrichedMeta_Procedure_Fragment
  ) | (
    { __typename?: 'Product' }
    & EnrichedMeta_Product_Fragment
  ) | (
    { __typename?: 'ProductDisplay' }
    & EnrichedMeta_ProductDisplay_Fragment
  ) | (
    { __typename?: 'ProductFeature' }
    & EnrichedMeta_ProductFeature_Fragment
  ) | (
    { __typename?: 'ProductFeatureDescriptionListItem' }
    & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
  ) | (
    { __typename?: 'ProgressIndicator' }
    & EnrichedMeta_ProgressIndicator_Fragment
  ) | (
    { __typename?: 'ProviderDetailsPage' }
    & EnrichedMeta_ProviderDetailsPage_Fragment
  ) | (
    { __typename?: 'QuestionAnswer' }
    & EnrichedMeta_QuestionAnswer_Fragment
  ) | (
    { __typename?: 'Questionnaire' }
    & EnrichedMeta_Questionnaire_Fragment
  ) | (
    { __typename?: 'QuickLinks' }
    & EnrichedMeta_QuickLinks_Fragment
  ) | (
    { __typename?: 'Quiz' }
    & EnrichedMeta_Quiz_Fragment
  ) | (
    { __typename?: 'ReviewStep' }
    & EnrichedMeta_ReviewStep_Fragment
  ) | (
    { __typename?: 'Schema' }
    & EnrichedMeta_Schema_Fragment
  ) | (
    { __typename?: 'SchemaStep' }
    & EnrichedMeta_SchemaStep_Fragment
  ) | (
    { __typename?: 'SectionContent' }
    & EnrichedMeta_SectionContent_Fragment
  ) | (
    { __typename?: 'SegmentsContainer' }
    & EnrichedMeta_SegmentsContainer_Fragment
  ) | (
    { __typename?: 'Service' }
    & EnrichedMeta_Service_Fragment
  ) | (
    { __typename?: 'ServiceDetailsPage' }
    & EnrichedMeta_ServiceDetailsPage_Fragment
  ) | (
    { __typename?: 'ServiceGroup' }
    & EnrichedMeta_ServiceGroup_Fragment
  ) | (
    { __typename?: 'ServiceLineHero' }
    & EnrichedMeta_ServiceLineHero_Fragment
  ) | (
    { __typename?: 'SharedForm' }
    & EnrichedMeta_SharedForm_Fragment
  ) | (
    { __typename?: 'SharedFormDefinitions' }
    & EnrichedMeta_SharedFormDefinitions_Fragment
  ) | (
    { __typename?: 'SharedFormField' }
    & EnrichedMeta_SharedFormField_Fragment
  ) | (
    { __typename?: 'SingleMessage' }
    & EnrichedMeta_SingleMessage_Fragment
  ) | (
    { __typename?: 'SmallScreenContent' }
    & EnrichedMeta_SmallScreenContent_Fragment
  ) | (
    { __typename?: 'SmileAssessmentForm' }
    & EnrichedMeta_SmileAssessmentForm_Fragment
  ) | (
    { __typename?: 'Spacer' }
    & EnrichedMeta_Spacer_Fragment
  ) | (
    { __typename?: 'StateLinks' }
    & EnrichedMeta_StateLinks_Fragment
  ) | (
    { __typename?: 'Stepper' }
    & EnrichedMeta_Stepper_Fragment
  ) | (
    { __typename?: 'SuccessCard' }
    & EnrichedMeta_SuccessCard_Fragment
  ) | (
    { __typename?: 'Tab' }
    & EnrichedMeta_Tab_Fragment
  ) | (
    { __typename?: 'Table' }
    & EnrichedMeta_Table_Fragment
  ) | (
    { __typename?: 'Tabs' }
    & EnrichedMeta_Tabs_Fragment
  ) | (
    { __typename?: 'TermsAndConditions' }
    & EnrichedMeta_TermsAndConditions_Fragment
  ) | (
    { __typename?: 'TextBlockSeo' }
    & EnrichedMeta_TextBlockSeo_Fragment
  ) | (
    { __typename?: 'TextHighlight' }
    & EnrichedMeta_TextHighlight_Fragment
  ) | (
    { __typename?: 'TriggeredContentModal' }
    & EnrichedMeta_TriggeredContentModal_Fragment
  ) | (
    { __typename?: 'Video' }
    & EnrichedMeta_Video_Fragment
  ) | (
    { __typename?: 'VideoAsset' }
    & EnrichedMeta_VideoAsset_Fragment
  ) | (
    { __typename?: 'VideoCarousel' }
    & EnrichedMeta_VideoCarousel_Fragment
  ) | (
    { __typename?: 'VideoWithContent' }
    & EnrichedMeta_VideoWithContent_Fragment
  ) | null, navigationLinksCollection?: { __typename?: 'HeaderNavigationLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'FooterNavigationGroup' }
      & FooterNavigationGroupFragment
      & EnrichedMeta_FooterNavigationGroup_Fragment
    ) | (
      { __typename?: 'NavigationGroup' }
      & GenericNavigationGroupFragment
      & EnrichedMeta_NavigationGroup_Fragment
    ) | (
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
      & EnrichedMeta_Page_Fragment
    ) | null> } | null, topNavigationLinksCollection?: { __typename?: 'HeaderTopNavigationLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
      & EnrichedMeta_Page_Fragment
    ) | null> } | null, schedulingNavigationLinksCollection?: { __typename?: 'HeaderSchedulingNavigationLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'NavigationGroup' }
      & GenericNavigationGroupFragment
      & EnrichedMeta_NavigationGroup_Fragment
    ) | null> } | null, navigationMenu?: (
    { __typename?: 'HeaderNavMenu' }
    & HeaderNavMenuFragment
  ) | null, locationNavigationLinksCollection?: { __typename?: 'HeaderLocationNavigationLinksCollection', items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
    ) | null> } | null, phoneNumber?: (
    { __typename?: 'NavigationLink' }
    & NavLinkFragment
  ) | null, secondaryNavigationLinksCollection?: { __typename?: 'HeaderSecondaryNavigationLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
      & EnrichedMeta_Page_Fragment
    ) | null> } | null, googleMapsForLocationCards?: (
    { __typename?: 'GoogleMapTemplate' }
    & GoogleMapInHeaderFragment
  ) | null, topAlertBanner?: (
    { __typename?: 'Banner' }
    & BannerFragment
  ) | null, bottomAlertBanner?: (
    { __typename?: 'Banner' }
    & BannerFragment
  ) | null, mobileQuizLink?: { __typename?: 'Accordions' } | { __typename?: 'AdFooter' } | { __typename?: 'AgendaModal' } | { __typename?: 'AgendaStepper' } | { __typename?: 'AnalyticsContext' } | { __typename?: 'App' } | { __typename?: 'AppCopySlot' } | { __typename?: 'AppFaq' } | { __typename?: 'AppLegalDocument' } | { __typename?: 'AppMediaSlot' } | { __typename?: 'AppOffer' } | { __typename?: 'AppReachYouCard' } | { __typename?: 'AppTip' } | { __typename?: 'AppTreatmentInfo' } | { __typename?: 'AppViewCopy' } | { __typename?: 'AppointmentBookingPage' } | { __typename?: 'Badge' } | { __typename?: 'Banner' } | { __typename?: 'BirdEyeReviews' } | { __typename?: 'BlogAuthor' } | { __typename?: 'BlogCategory' } | { __typename?: 'BlogDetailsPage' } | { __typename?: 'BlogList' } | { __typename?: 'BlogListPage' } | { __typename?: 'BlogSubCategory' } | { __typename?: 'BodyText' } | { __typename?: 'Brand' } | { __typename?: 'Button' } | { __typename?: 'Card' } | { __typename?: 'Carousel' } | { __typename?: 'Category' } | { __typename?: 'CategoryPicker' } | { __typename?: 'CityLinks' } | { __typename?: 'Columns' } | { __typename?: 'ConfirmationStep' } | { __typename?: 'ContentData' } | { __typename?: 'ContentSection' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'ConvertFlowCta' } | { __typename?: 'ConvertFlowQuiz' } | { __typename?: 'DisclaimerV2' } | { __typename?: 'Error404' } | { __typename?: 'Experience' } | { __typename?: 'ExperimentContainer' } | { __typename?: 'ExperimentVariationContentsItem' } | { __typename?: 'ExperimentalModal' } | { __typename?: 'FacilityDetailsPage' } | { __typename?: 'FaqAccordion' } | { __typename?: 'FeatureFlags' } | { __typename?: 'FocalPointImage' } | { __typename?: 'FooterNavigationGroup' } | { __typename?: 'FormDropdownField' } | { __typename?: 'FormField' } | { __typename?: 'GoogleMapTemplate' } | { __typename?: 'HalfScreen' } | { __typename?: 'Header' } | { __typename?: 'HeaderMainNav' } | { __typename?: 'HeaderNavMenu' } | { __typename?: 'HeaderSubNav' } | { __typename?: 'Heading' } | { __typename?: 'HeroV2' } | { __typename?: 'Icon' } | { __typename?: 'Iframe' } | { __typename?: 'ImageAsset' } | { __typename?: 'Insurance' } | { __typename?: 'LinkForwarder' } | { __typename?: 'List' } | { __typename?: 'ListItem' } | { __typename?: 'LocalizedServiceTitle' } | { __typename?: 'Marquee' } | { __typename?: 'Media' } | { __typename?: 'MediaSlider' } | { __typename?: 'MedicalService' } | { __typename?: 'MeetOurStaff' } | { __typename?: 'MetroLinks' } | { __typename?: 'MobileButton' } | { __typename?: 'MultiCardV2' } | { __typename?: 'NavigationGroup' } | (
    { __typename?: 'NavigationLink' }
    & NavLinkFragment
  ) | { __typename?: 'OdpHero' } | { __typename?: 'Page' } | { __typename?: 'PageLayout' } | { __typename?: 'PageMeta' } | { __typename?: 'PatientReviewV2' } | { __typename?: 'PatientReviewsV2' } | { __typename?: 'Procedure' } | { __typename?: 'Product' } | { __typename?: 'ProductDisplay' } | { __typename?: 'ProductFeature' } | { __typename?: 'ProductFeatureDescriptionListItem' } | { __typename?: 'ProgressIndicator' } | { __typename?: 'ProviderDetailsPage' } | { __typename?: 'QuestionAnswer' } | { __typename?: 'Questionnaire' } | { __typename?: 'QuickLinks' } | { __typename?: 'Quiz' } | { __typename?: 'ReviewStep' } | { __typename?: 'Schema' } | { __typename?: 'SchemaStep' } | { __typename?: 'SectionContent' } | { __typename?: 'SegmentsContainer' } | { __typename?: 'Service' } | { __typename?: 'ServiceDetailsPage' } | { __typename?: 'ServiceGroup' } | { __typename?: 'ServiceLineHero' } | { __typename?: 'SharedForm' } | { __typename?: 'SharedFormDefinitions' } | { __typename?: 'SharedFormField' } | { __typename?: 'SingleMessage' } | { __typename?: 'SmallScreenContent' } | { __typename?: 'SmileAssessmentForm' } | { __typename?: 'Spacer' } | { __typename?: 'StateLinks' } | { __typename?: 'Stepper' } | { __typename?: 'SuccessCard' } | { __typename?: 'Tab' } | { __typename?: 'Table' } | { __typename?: 'Tabs' } | { __typename?: 'TermsAndConditions' } | { __typename?: 'TextBlockSeo' } | { __typename?: 'TextHighlight' } | { __typename?: 'TriggeredContentModal' } | { __typename?: 'Video' } | { __typename?: 'VideoAsset' } | { __typename?: 'VideoCarousel' } | { __typename?: 'VideoWithContent' } | null }
  & EnrichedMeta_Header_Fragment
);

export type GenericNavigationGroupFragment = { __typename?: 'NavigationGroup', groupLink?: (
    { __typename?: 'NavigationLink', linkText?: string | null, isInternal?: boolean | null, openInNewTab?: boolean | null }
    & EnrichedMeta_NavigationLink_Fragment
  ) | null, linksCollection?: { __typename?: 'NavigationGroupLinksCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
    ) | null> } | null };

export type FooterFragment = (
  { __typename?: 'AdFooter', componentName?: string | null, variant?: string | null, contactNumber?: string | null, copyright?: string | null, isLightFooter?: boolean | null, useMobileStickyFooter?: boolean | null, useDesktopStickyFooter?: boolean | null, stickyFooterScheduleButton?: (
    { __typename?: 'Button' }
    & ButtonFragment
  ) | null, stickyFooterButtonsCollection?: { __typename?: 'AdFooterStickyFooterButtonsCollection', limit: number, skip: number, total: number, items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, logo?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2Fragment
  ) | null, about?: { __typename?: 'AdFooterAbout', json: any, links: { __typename?: 'AdFooterAboutLinks', assets: { __typename?: 'AdFooterAboutAssets', block: Array<(
          { __typename?: 'Asset' }
          & LinkMetaFragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Asset' }
          & LinkMetaFragment
        ) | null> }, entries: { __typename?: 'AdFooterAboutEntries', inline: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> }, resources: { __typename?: 'AdFooterAboutResources', block: Array<(
          { __typename?: 'AdFooterAboutResourcesBlock' }
          & ResourceMeta_AdFooterAboutResourcesBlock_Fragment
        )>, inline: Array<(
          { __typename?: 'AdFooterAboutResourcesInline' }
          & ResourceMeta_AdFooterAboutResourcesInline_Fragment
        )>, hyperlink: Array<(
          { __typename?: 'AdFooterAboutResourcesHyperlink' }
          & ResourceMeta_AdFooterAboutResourcesHyperlink_Fragment
        )> } } } | null, aboutDescription?: { __typename?: 'AdFooterAboutDescription', json: any, links: { __typename?: 'AdFooterAboutDescriptionLinks', assets: { __typename?: 'AdFooterAboutDescriptionAssets', block: Array<(
          { __typename?: 'Asset' }
          & LinkMetaFragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Asset' }
          & LinkMetaFragment
        ) | null> }, entries: { __typename?: 'AdFooterAboutDescriptionEntries', inline: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> }, resources: { __typename?: 'AdFooterAboutDescriptionResources', block: Array<(
          { __typename?: 'AdFooterAboutDescriptionResourcesBlock' }
          & ResourceMeta_AdFooterAboutDescriptionResourcesBlock_Fragment
        )>, inline: Array<(
          { __typename?: 'AdFooterAboutDescriptionResourcesInline' }
          & ResourceMeta_AdFooterAboutDescriptionResourcesInline_Fragment
        )>, hyperlink: Array<(
          { __typename?: 'AdFooterAboutDescriptionResourcesHyperlink' }
          & ResourceMeta_AdFooterAboutDescriptionResourcesHyperlink_Fragment
        )> } } } | null, navigationGroupsCollection?: { __typename?: 'AdFooterNavigationGroupsCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'FooterNavigationGroup', componentName?: string | null, navigationGroupTitle?: string | null, navigationGroupLink?: (
        { __typename?: 'Page' }
        & BasePageFragment
      ) | null, navigationLinksForGroupCollection?: { __typename?: 'FooterNavigationGroupNavigationLinksForGroupCollection', skip: number, limit: number, total: number, items: Array<(
          { __typename?: 'NavigationLink' }
          & NavLinkFragment
        ) | (
          { __typename?: 'Page' }
          & BasePageFragment
        ) | null> } | null }
      & EnrichedMeta_FooterNavigationGroup_Fragment
    ) | null> } | null, socialNetworksCollection?: { __typename?: 'AdFooterSocialNetworksCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'Accordions' }
      & EnrichedMeta_Accordions_Fragment
    ) | (
      { __typename?: 'AdFooter' }
      & EnrichedMeta_AdFooter_Fragment
    ) | (
      { __typename?: 'AgendaModal' }
      & EnrichedMeta_AgendaModal_Fragment
    ) | (
      { __typename?: 'AgendaStepper' }
      & EnrichedMeta_AgendaStepper_Fragment
    ) | (
      { __typename?: 'AnalyticsContext' }
      & EnrichedMeta_AnalyticsContext_Fragment
    ) | (
      { __typename?: 'App' }
      & EnrichedMeta_App_Fragment
    ) | (
      { __typename?: 'AppCopySlot' }
      & EnrichedMeta_AppCopySlot_Fragment
    ) | (
      { __typename?: 'AppFaq' }
      & EnrichedMeta_AppFaq_Fragment
    ) | (
      { __typename?: 'AppLegalDocument' }
      & EnrichedMeta_AppLegalDocument_Fragment
    ) | (
      { __typename?: 'AppMediaSlot' }
      & EnrichedMeta_AppMediaSlot_Fragment
    ) | (
      { __typename?: 'AppOffer' }
      & EnrichedMeta_AppOffer_Fragment
    ) | (
      { __typename?: 'AppReachYouCard' }
      & EnrichedMeta_AppReachYouCard_Fragment
    ) | (
      { __typename?: 'AppTip' }
      & EnrichedMeta_AppTip_Fragment
    ) | (
      { __typename?: 'AppTreatmentInfo' }
      & EnrichedMeta_AppTreatmentInfo_Fragment
    ) | (
      { __typename?: 'AppViewCopy' }
      & EnrichedMeta_AppViewCopy_Fragment
    ) | (
      { __typename?: 'AppointmentBookingPage' }
      & EnrichedMeta_AppointmentBookingPage_Fragment
    ) | (
      { __typename?: 'Badge' }
      & EnrichedMeta_Badge_Fragment
    ) | (
      { __typename?: 'Banner' }
      & EnrichedMeta_Banner_Fragment
    ) | (
      { __typename?: 'BirdEyeReviews' }
      & EnrichedMeta_BirdEyeReviews_Fragment
    ) | (
      { __typename?: 'BlogAuthor' }
      & EnrichedMeta_BlogAuthor_Fragment
    ) | (
      { __typename?: 'BlogCategory' }
      & EnrichedMeta_BlogCategory_Fragment
    ) | (
      { __typename?: 'BlogDetailsPage' }
      & EnrichedMeta_BlogDetailsPage_Fragment
    ) | (
      { __typename?: 'BlogList' }
      & EnrichedMeta_BlogList_Fragment
    ) | (
      { __typename?: 'BlogListPage' }
      & EnrichedMeta_BlogListPage_Fragment
    ) | (
      { __typename?: 'BlogSubCategory' }
      & EnrichedMeta_BlogSubCategory_Fragment
    ) | (
      { __typename?: 'BodyText' }
      & EnrichedMeta_BodyText_Fragment
    ) | (
      { __typename?: 'Brand' }
      & EnrichedMeta_Brand_Fragment
    ) | (
      { __typename?: 'Button' }
      & EnrichedMeta_Button_Fragment
    ) | (
      { __typename?: 'Card' }
      & EnrichedMeta_Card_Fragment
    ) | (
      { __typename?: 'Carousel' }
      & EnrichedMeta_Carousel_Fragment
    ) | (
      { __typename?: 'Category' }
      & EnrichedMeta_Category_Fragment
    ) | (
      { __typename?: 'CategoryPicker' }
      & EnrichedMeta_CategoryPicker_Fragment
    ) | (
      { __typename?: 'CityLinks' }
      & EnrichedMeta_CityLinks_Fragment
    ) | (
      { __typename?: 'Columns' }
      & EnrichedMeta_Columns_Fragment
    ) | (
      { __typename?: 'ConfirmationStep' }
      & EnrichedMeta_ConfirmationStep_Fragment
    ) | (
      { __typename?: 'ContentData' }
      & EnrichedMeta_ContentData_Fragment
    ) | (
      { __typename?: 'ContentSection' }
      & EnrichedMeta_ContentSection_Fragment
    ) | (
      { __typename?: 'ContentTile' }
      & EnrichedMeta_ContentTile_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & EnrichedMeta_ContentTypeRichText_Fragment
    ) | (
      { __typename?: 'ConvertFlowCta' }
      & EnrichedMeta_ConvertFlowCta_Fragment
    ) | (
      { __typename?: 'ConvertFlowQuiz' }
      & EnrichedMeta_ConvertFlowQuiz_Fragment
    ) | (
      { __typename?: 'DisclaimerV2' }
      & EnrichedMeta_DisclaimerV2_Fragment
    ) | (
      { __typename?: 'Error404' }
      & EnrichedMeta_Error404_Fragment
    ) | (
      { __typename?: 'Experience' }
      & EnrichedMeta_Experience_Fragment
    ) | (
      { __typename?: 'ExperimentContainer' }
      & EnrichedMeta_ExperimentContainer_Fragment
    ) | (
      { __typename?: 'ExperimentVariationContentsItem' }
      & EnrichedMeta_ExperimentVariationContentsItem_Fragment
    ) | (
      { __typename?: 'ExperimentalModal' }
      & EnrichedMeta_ExperimentalModal_Fragment
    ) | (
      { __typename?: 'FacilityDetailsPage' }
      & EnrichedMeta_FacilityDetailsPage_Fragment
    ) | (
      { __typename?: 'FaqAccordion' }
      & EnrichedMeta_FaqAccordion_Fragment
    ) | (
      { __typename?: 'FeatureFlags' }
      & EnrichedMeta_FeatureFlags_Fragment
    ) | (
      { __typename?: 'FocalPointImage' }
      & EnrichedMeta_FocalPointImage_Fragment
    ) | (
      { __typename?: 'FooterNavigationGroup' }
      & EnrichedMeta_FooterNavigationGroup_Fragment
    ) | (
      { __typename?: 'FormDropdownField' }
      & EnrichedMeta_FormDropdownField_Fragment
    ) | (
      { __typename?: 'FormField' }
      & EnrichedMeta_FormField_Fragment
    ) | (
      { __typename?: 'GoogleMapTemplate' }
      & EnrichedMeta_GoogleMapTemplate_Fragment
    ) | (
      { __typename?: 'HalfScreen' }
      & EnrichedMeta_HalfScreen_Fragment
    ) | (
      { __typename?: 'Header' }
      & EnrichedMeta_Header_Fragment
    ) | (
      { __typename?: 'HeaderMainNav' }
      & EnrichedMeta_HeaderMainNav_Fragment
    ) | (
      { __typename?: 'HeaderNavMenu' }
      & EnrichedMeta_HeaderNavMenu_Fragment
    ) | (
      { __typename?: 'HeaderSubNav' }
      & EnrichedMeta_HeaderSubNav_Fragment
    ) | (
      { __typename?: 'Heading' }
      & EnrichedMeta_Heading_Fragment
    ) | (
      { __typename?: 'HeroV2' }
      & EnrichedMeta_HeroV2_Fragment
    ) | (
      { __typename?: 'Icon' }
      & EnrichedMeta_Icon_Fragment
    ) | (
      { __typename?: 'Iframe' }
      & EnrichedMeta_Iframe_Fragment
    ) | (
      { __typename?: 'ImageAsset' }
      & EnrichedMeta_ImageAsset_Fragment
    ) | (
      { __typename?: 'Insurance' }
      & EnrichedMeta_Insurance_Fragment
    ) | (
      { __typename?: 'LinkForwarder' }
      & EnrichedMeta_LinkForwarder_Fragment
    ) | (
      { __typename?: 'List' }
      & EnrichedMeta_List_Fragment
    ) | (
      { __typename?: 'ListItem' }
      & EnrichedMeta_ListItem_Fragment
    ) | (
      { __typename?: 'LocalizedServiceTitle' }
      & EnrichedMeta_LocalizedServiceTitle_Fragment
    ) | (
      { __typename?: 'Marquee' }
      & EnrichedMeta_Marquee_Fragment
    ) | (
      { __typename?: 'Media' }
      & EnrichedMeta_Media_Fragment
    ) | (
      { __typename?: 'MediaSlider' }
      & EnrichedMeta_MediaSlider_Fragment
    ) | (
      { __typename?: 'MedicalService' }
      & EnrichedMeta_MedicalService_Fragment
    ) | (
      { __typename?: 'MeetOurStaff' }
      & EnrichedMeta_MeetOurStaff_Fragment
    ) | (
      { __typename?: 'MetroLinks' }
      & EnrichedMeta_MetroLinks_Fragment
    ) | (
      { __typename?: 'MobileButton' }
      & EnrichedMeta_MobileButton_Fragment
    ) | (
      { __typename?: 'MultiCardV2' }
      & EnrichedMeta_MultiCardV2_Fragment
    ) | (
      { __typename?: 'NavigationGroup' }
      & EnrichedMeta_NavigationGroup_Fragment
    ) | (
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | (
      { __typename?: 'OdpHero' }
      & EnrichedMeta_OdpHero_Fragment
    ) | (
      { __typename?: 'Page' }
      & BasePageFragment
      & EnrichedMeta_Page_Fragment
    ) | (
      { __typename?: 'PageLayout' }
      & EnrichedMeta_PageLayout_Fragment
    ) | (
      { __typename?: 'PageMeta' }
      & EnrichedMeta_PageMeta_Fragment
    ) | (
      { __typename?: 'PatientReviewV2' }
      & EnrichedMeta_PatientReviewV2_Fragment
    ) | (
      { __typename?: 'PatientReviewsV2' }
      & EnrichedMeta_PatientReviewsV2_Fragment
    ) | (
      { __typename?: 'Procedure' }
      & EnrichedMeta_Procedure_Fragment
    ) | (
      { __typename?: 'Product' }
      & EnrichedMeta_Product_Fragment
    ) | (
      { __typename?: 'ProductDisplay' }
      & EnrichedMeta_ProductDisplay_Fragment
    ) | (
      { __typename?: 'ProductFeature' }
      & EnrichedMeta_ProductFeature_Fragment
    ) | (
      { __typename?: 'ProductFeatureDescriptionListItem' }
      & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
    ) | (
      { __typename?: 'ProgressIndicator' }
      & EnrichedMeta_ProgressIndicator_Fragment
    ) | (
      { __typename?: 'ProviderDetailsPage' }
      & EnrichedMeta_ProviderDetailsPage_Fragment
    ) | (
      { __typename?: 'QuestionAnswer' }
      & EnrichedMeta_QuestionAnswer_Fragment
    ) | (
      { __typename?: 'Questionnaire' }
      & EnrichedMeta_Questionnaire_Fragment
    ) | (
      { __typename?: 'QuickLinks' }
      & EnrichedMeta_QuickLinks_Fragment
    ) | (
      { __typename?: 'Quiz' }
      & EnrichedMeta_Quiz_Fragment
    ) | (
      { __typename?: 'ReviewStep' }
      & EnrichedMeta_ReviewStep_Fragment
    ) | (
      { __typename?: 'Schema' }
      & EnrichedMeta_Schema_Fragment
    ) | (
      { __typename?: 'SchemaStep' }
      & EnrichedMeta_SchemaStep_Fragment
    ) | (
      { __typename?: 'SectionContent' }
      & EnrichedMeta_SectionContent_Fragment
    ) | (
      { __typename?: 'SegmentsContainer' }
      & EnrichedMeta_SegmentsContainer_Fragment
    ) | (
      { __typename?: 'Service' }
      & EnrichedMeta_Service_Fragment
    ) | (
      { __typename?: 'ServiceDetailsPage' }
      & EnrichedMeta_ServiceDetailsPage_Fragment
    ) | (
      { __typename?: 'ServiceGroup' }
      & EnrichedMeta_ServiceGroup_Fragment
    ) | (
      { __typename?: 'ServiceLineHero' }
      & EnrichedMeta_ServiceLineHero_Fragment
    ) | (
      { __typename?: 'SharedForm' }
      & EnrichedMeta_SharedForm_Fragment
    ) | (
      { __typename?: 'SharedFormDefinitions' }
      & EnrichedMeta_SharedFormDefinitions_Fragment
    ) | (
      { __typename?: 'SharedFormField' }
      & EnrichedMeta_SharedFormField_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & EnrichedMeta_SingleMessage_Fragment
    ) | (
      { __typename?: 'SmallScreenContent' }
      & EnrichedMeta_SmallScreenContent_Fragment
    ) | (
      { __typename?: 'SmileAssessmentForm' }
      & EnrichedMeta_SmileAssessmentForm_Fragment
    ) | (
      { __typename?: 'Spacer' }
      & EnrichedMeta_Spacer_Fragment
    ) | (
      { __typename?: 'StateLinks' }
      & EnrichedMeta_StateLinks_Fragment
    ) | (
      { __typename?: 'Stepper' }
      & EnrichedMeta_Stepper_Fragment
    ) | (
      { __typename?: 'SuccessCard' }
      & EnrichedMeta_SuccessCard_Fragment
    ) | (
      { __typename?: 'Tab' }
      & EnrichedMeta_Tab_Fragment
    ) | (
      { __typename?: 'Table' }
      & EnrichedMeta_Table_Fragment
    ) | (
      { __typename?: 'Tabs' }
      & EnrichedMeta_Tabs_Fragment
    ) | (
      { __typename?: 'TermsAndConditions' }
      & EnrichedMeta_TermsAndConditions_Fragment
    ) | (
      { __typename?: 'TextBlockSeo' }
      & EnrichedMeta_TextBlockSeo_Fragment
    ) | (
      { __typename?: 'TextHighlight' }
      & EnrichedMeta_TextHighlight_Fragment
    ) | (
      { __typename?: 'TriggeredContentModal' }
      & EnrichedMeta_TriggeredContentModal_Fragment
    ) | (
      { __typename?: 'Video' }
      & EnrichedMeta_Video_Fragment
    ) | (
      { __typename?: 'VideoAsset' }
      & EnrichedMeta_VideoAsset_Fragment
    ) | (
      { __typename?: 'VideoCarousel' }
      & EnrichedMeta_VideoCarousel_Fragment
    ) | (
      { __typename?: 'VideoWithContent' }
      & EnrichedMeta_VideoWithContent_Fragment
    ) | null> } | null, footerPolicyGroupCollection?: { __typename?: 'AdFooterFooterPolicyGroupCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'NavigationLink' }
      & NavLinkFragment
      & EnrichedMeta_NavigationLink_Fragment
    ) | null> } | null }
  & EnrichedMeta_AdFooter_Fragment
);

export type AppMetadataFragment = { __typename: 'App', name?: string | null, branding?: string | null, config?: any | null, sys: { __typename?: 'Sys', id: string, environmentId: string, spaceId: string }, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> }, logo?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, logoMobile?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, featureFlags?: (
    { __typename?: 'FeatureFlags' }
    & FeatureFlagsFragment
  ) | null };

export type AppPagesDataFragment = { __typename?: 'App', header?: (
    { __typename?: 'Header' }
    & HeaderFragment
  ) | null, footer?: (
    { __typename?: 'AdFooter' }
    & FooterFragment
  ) | null, notFoundPage?: (
    { __typename?: 'Error404' }
    & Error404Fragment
  ) | null };

export type AppFragment = (
  { __typename?: 'App' }
  & AppMetadataFragment
  & AppPagesDataFragment
);

export type FeatureFlagsFragment = { __typename?: 'FeatureFlags', continentalUsMapFallbackThreshold?: number | null, enforceContinentalUsZoom?: boolean | null, featureList?: Array<string | null> | null, salesForceEvergageScript?: string | null, providerHeroTheme?: string | null, showMobileHeaderLocationBar?: boolean | null, showHeaderWithLocationNav?: boolean | null, defaultToCdn?: boolean | null, useFacilityBeffeDataSource?: boolean | null, useInlineOneTrust?: boolean | null, useSessionStorageFacilityCode?: boolean | null, doNotIndexWholeSite?: boolean | null, showHeaderNavigationMenu?: boolean | null, hideHeaderFacilityLocator?: boolean | null, hideHeaderSchedulingButton?: boolean | null, hideProviderWithNoImage?: boolean | null, useGoogleMapAutocompleteSearch?: boolean | null, fetchAllLocationsOnEmptyResults?: boolean | null, showSetOfficeButtonInGoogleMapsCards?: boolean | null, useSimpleFindOfficeLink?: boolean | null, enableFluidTypography?: boolean | null, oneTrust?: boolean | null, enableCcMarketingSourceTransformation?: boolean | null, migrationPaths?: Array<string | null> | null, loadFacilityReviewsFromBeffe?: boolean | null, useFilterForOdpDetailsContent?: boolean | null, showReadMoreForBioInMeetOurStaff?: boolean | null, showProviderPageCtaInMeetOurStaff?: boolean | null };

export type OdpHeroFragment = (
  { __typename?: 'OdpHero', name?: string | null, templateWidth?: string | null, showReviews?: boolean | null, title?: string | null, titleHtag?: string | null, showAddress?: boolean | null, showPhoneNumber?: boolean | null, showHours?: boolean | null, officeHoursLabel?: string | null, callCenterLabel?: string | null, googleMapsBusinessQuery?: string | null, facilitySegmentCollection?: string | null, promoTitle?: string | null, anchorId?: string | null, image?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, bodyCopy?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextFragment
  ) | null, buttonsCollection?: { __typename?: 'OdpHeroButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_OdpHero_Fragment
);

export type PageFragment = (
  { __typename?: 'Page', name?: string | null, breadcrumbTitle?: string | null, description?: string | null, pageTitle?: string | null, path?: string | null, title?: string | null, tags?: Array<string | null> | null, canonical?: string | null, indexed?: boolean | null, personalized?: boolean | null, pageTheme?: string | null, disableChatBot?: boolean | null, disableStickyFooterOnDesktop?: boolean | null, disableStickyFooterOnMobile?: boolean | null, disableHeaderTopAlertBanner?: boolean | null, disableHeaderBottomAlertBanner?: boolean | null, hideScheduleButtonInHeader?: boolean | null, redirectTo?: string | null, ogImage?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, contentsCollection?: { __typename?: 'PageContentsCollection', items: Array<(
      { __typename?: 'Accordions' }
      & Meta_Accordions_Fragment
    ) | (
      { __typename?: 'AgendaStepper' }
      & Meta_AgendaStepper_Fragment
    ) | (
      { __typename?: 'BirdEyeReviews' }
      & Meta_BirdEyeReviews_Fragment
    ) | (
      { __typename?: 'BlogList' }
      & Meta_BlogList_Fragment
    ) | (
      { __typename?: 'Carousel' }
      & Meta_Carousel_Fragment
    ) | (
      { __typename?: 'CategoryPicker' }
      & Meta_CategoryPicker_Fragment
    ) | (
      { __typename?: 'CityLinks' }
      & Meta_CityLinks_Fragment
    ) | (
      { __typename?: 'Columns' }
      & Meta_Columns_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & Meta_ContentTypeRichText_Fragment
    ) | (
      { __typename?: 'ConvertFlowCta' }
      & Meta_ConvertFlowCta_Fragment
    ) | (
      { __typename?: 'ConvertFlowQuiz' }
      & Meta_ConvertFlowQuiz_Fragment
    ) | (
      { __typename?: 'DisclaimerV2' }
      & Meta_DisclaimerV2_Fragment
    ) | (
      { __typename?: 'ExperimentContainer' }
      & Meta_ExperimentContainer_Fragment
    ) | (
      { __typename?: 'GoogleMapTemplate' }
      & Meta_GoogleMapTemplate_Fragment
    ) | (
      { __typename?: 'HalfScreen' }
      & Meta_HalfScreen_Fragment
    ) | (
      { __typename?: 'HeaderNavMenu' }
      & Meta_HeaderNavMenu_Fragment
    ) | (
      { __typename?: 'HeroV2' }
      & Meta_HeroV2_Fragment
    ) | (
      { __typename?: 'Iframe' }
      & Meta_Iframe_Fragment
    ) | (
      { __typename?: 'Insurance' }
      & Meta_Insurance_Fragment
    ) | (
      { __typename?: 'LinkForwarder' }
      & Meta_LinkForwarder_Fragment
    ) | (
      { __typename?: 'Marquee' }
      & Meta_Marquee_Fragment
    ) | (
      { __typename?: 'MediaSlider' }
      & Meta_MediaSlider_Fragment
    ) | (
      { __typename?: 'MeetOurStaff' }
      & Meta_MeetOurStaff_Fragment
    ) | (
      { __typename?: 'MetroLinks' }
      & Meta_MetroLinks_Fragment
    ) | (
      { __typename?: 'MultiCardV2' }
      & Meta_MultiCardV2_Fragment
    ) | (
      { __typename?: 'OdpHero' }
      & Meta_OdpHero_Fragment
    ) | (
      { __typename?: 'PatientReviewsV2' }
      & Meta_PatientReviewsV2_Fragment
    ) | (
      { __typename?: 'ProductFeature' }
      & Meta_ProductFeature_Fragment
    ) | (
      { __typename?: 'ProgressIndicator' }
      & Meta_ProgressIndicator_Fragment
    ) | (
      { __typename?: 'Questionnaire' }
      & Meta_Questionnaire_Fragment
    ) | (
      { __typename?: 'QuickLinks' }
      & Meta_QuickLinks_Fragment
    ) | (
      { __typename?: 'Quiz' }
      & Meta_Quiz_Fragment
    ) | (
      { __typename?: 'Schema' }
      & Meta_Schema_Fragment
    ) | (
      { __typename?: 'SchemaStep' }
      & Meta_SchemaStep_Fragment
    ) | (
      { __typename?: 'SectionContent' }
      & Meta_SectionContent_Fragment
    ) | (
      { __typename?: 'SegmentsContainer' }
      & Meta_SegmentsContainer_Fragment
    ) | (
      { __typename?: 'Service' }
      & Meta_Service_Fragment
    ) | (
      { __typename?: 'ServiceGroup' }
      & Meta_ServiceGroup_Fragment
    ) | (
      { __typename?: 'ServiceLineHero' }
      & Meta_ServiceLineHero_Fragment
    ) | (
      { __typename?: 'SharedForm' }
      & Meta_SharedForm_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & Meta_SingleMessage_Fragment
    ) | (
      { __typename?: 'SmileAssessmentForm' }
      & Meta_SmileAssessmentForm_Fragment
    ) | (
      { __typename?: 'Spacer' }
      & Meta_Spacer_Fragment
    ) | (
      { __typename?: 'StateLinks' }
      & Meta_StateLinks_Fragment
    ) | (
      { __typename?: 'Stepper' }
      & Meta_Stepper_Fragment
    ) | (
      { __typename?: 'Table' }
      & Meta_Table_Fragment
    ) | (
      { __typename?: 'Tabs' }
      & Meta_Tabs_Fragment
    ) | (
      { __typename?: 'TermsAndConditions' }
      & Meta_TermsAndConditions_Fragment
    ) | (
      { __typename?: 'TextBlockSeo' }
      & Meta_TextBlockSeo_Fragment
    ) | (
      { __typename?: 'VideoCarousel' }
      & Meta_VideoCarousel_Fragment
    ) | null> } | null, analyticsContext?: (
    { __typename?: 'AnalyticsContext' }
    & AnalyticsFragment
  ) | null }
  & Meta_Page_Fragment
);

export type FacilityDetailsPageBaseFragment = (
  { __typename?: 'FacilityDetailsPage', path?: string | null }
  & Meta_FacilityDetailsPage_Fragment
);

export type ServiceDetailsPageBaseFragment = (
  { __typename?: 'ServiceDetailsPage', path?: string | null }
  & Meta_ServiceDetailsPage_Fragment
);

export type PatientReviewsV2Fragment = (
  { __typename?: 'PatientReviewsV2', eyebrowSmallScreens?: string | null, eyebrowLargeScreens?: string | null, titleSmallScreens?: string | null, titleLargeScreens?: string | null, subtitleSmallScreens?: string | null, subtitleLargeScreens?: string | null, titleHtag?: string | null, maxReviewsSmallScreens?: number | null, maxReviewsLargeScreens?: number | null, trimThreshold?: number | null, disablePaddingOn?: Array<string | null> | null, backgroundColor?: string | null, templateWidth?: string | null, contentAlign?: string | null, mode?: string | null, scoreIcon?: string | null, anchorId?: string | null, imageLeftSide?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, reviewsCollection?: { __typename?: 'PatientReviewsV2ReviewsCollection', items: Array<(
      { __typename?: 'PatientReviewV2', score?: number | null, text?: string | null, subText1?: string | null, subText2?: string | null, avatar?: (
        { __typename?: 'Asset' }
        & ImageFragment
      ) | null }
      & Meta_PatientReviewV2_Fragment
    ) | null> } | null, buttonsSmallScreensCollection?: { __typename?: 'PatientReviewsV2ButtonsSmallScreensCollection', items: Array<(
      { __typename?: 'Button', variant?: string | null, label?: string | null, buttonLink?: string | null, size?: string | null }
      & Meta_Button_Fragment
    ) | null> } | null, buttonsLargeScreensCollection?: { __typename?: 'PatientReviewsV2ButtonsLargeScreensCollection', items: Array<(
      { __typename?: 'Button', variant?: string | null, label?: string | null, buttonLink?: string | null, size?: string | null }
      & Meta_Button_Fragment
    ) | null> } | null }
  & Meta_PatientReviewsV2_Fragment
);

export type ProductDisplayFragment = (
  { __typename?: 'ProductDisplay', anchorId?: string | null, productListTitleHtag?: string | null, productListTitle?: string | null, showProductCategory?: boolean | null, showProductSubCategory?: boolean | null, productsToDisplay?: Array<string | null> | null, showLocalizedProductPrice?: boolean | null, productListDescription?: { __typename?: 'ProductDisplayProductListDescription', json: any } | null }
  & Meta_ProductDisplay_Fragment
);

export type ProviderDetailsPageFragment = (
  { __typename?: 'ProviderDetailsPage', name?: string | null, npiId?: string | null, ogImage?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, contentsCollection?: { __typename?: 'ProviderDetailsPageContentsCollection', items: Array<(
      { __typename?: 'Accordions' }
      & AccordionFragment
    ) | (
      { __typename?: 'HalfScreen' }
      & HalfScreenFragment
    ) | (
      { __typename?: 'MultiCardV2' }
      & CardsFragment
    ) | (
      { __typename?: 'Service' }
      & ServiceFragment
    ) | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | (
      { __typename?: 'Spacer' }
      & SpacerFragment
    ) | (
      { __typename?: 'VideoCarousel' }
      & VideoCarouselFragment
    ) | null> } | null, secondaryContentsCollection?: { __typename?: 'ProviderDetailsPageSecondaryContentsCollection', items: Array<(
      { __typename?: 'Accordions' }
      & AccordionFragment
    ) | (
      { __typename?: 'HalfScreen' }
      & HalfScreenFragment
    ) | (
      { __typename?: 'MultiCardV2' }
      & CardsFragment
    ) | (
      { __typename?: 'Service' }
      & ServiceFragment
    ) | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | (
      { __typename?: 'Spacer' }
      & SpacerFragment
    ) | (
      { __typename?: 'VideoCarousel' }
      & VideoCarouselFragment
    ) | null> } | null }
  & Meta_ProviderDetailsPage_Fragment
);

export type QuickLinksFragment = (
  { __typename?: 'QuickLinks', templateSize?: string | null, eyebrow?: string | null, eyebrowStyle?: string | null, backgroundColor?: string | null, disablePaddingOn?: Array<string | null> | null, displayAsTitles?: boolean | null, anchorId?: string | null, heading?: { __typename?: 'QuickLinksHeading', json: any } | null, body?: { __typename?: 'QuickLinksBody', json: any } | null, quickLinksCollection?: { __typename?: 'QuickLinksQuickLinksCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, buttonsCollection?: { __typename?: 'QuickLinksButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_QuickLinks_Fragment
);

export type QuizFragment = (
  { __typename?: 'Quiz', submitEndpointUrl?: string | null, quizFormData?: any | null, quizType?: string | null, isFormBuilder?: boolean | null, formBuilderConfig?: any | null, clearChoicePoorCreditRedirectPath?: string | null }
  & Meta_Quiz_Fragment
);

export type RichTextFragment = (
  { __typename?: 'ContentTypeRichText', fullWidth?: boolean | null, disablePaddingOn?: Array<string | null> | null, backgroundColor?: string | null, display?: string | null, centerAlign?: boolean | null, contained?: boolean | null, titleHeading?: string | null, title?: string | null, titleIcon?: string | null, contentMaxWidth?: string | null, facilitySegmentCollection?: string | null, id?: string | null, content?: { __typename?: 'ContentTypeRichTextContent', json: any } | null, secondaryContent?: { __typename?: 'ContentTypeRichTextSecondaryContent', json: any } | null, buttonsCollection?: { __typename?: 'ContentTypeRichTextButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_ContentTypeRichText_Fragment
);

export type RichTextWithLinksFragment = (
  { __typename?: 'ContentTypeRichText', fullWidth?: boolean | null, disablePaddingOn?: Array<string | null> | null, backgroundColor?: string | null, display?: string | null, centerAlign?: boolean | null, contained?: boolean | null, titleHeading?: string | null, title?: string | null, titleIcon?: string | null, contentMaxWidth?: string | null, facilitySegmentCollection?: string | null, id?: string | null, content?: { __typename?: 'ContentTypeRichTextContent', json: any, links: { __typename?: 'ContentTypeRichTextContentLinks', assets: { __typename?: 'ContentTypeRichTextContentAssets', block: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null> }, entries: { __typename?: 'ContentTypeRichTextContentEntries', inline: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
          & ImageAssetFragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
          & TableFragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
          & VideoAssetFragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage', path?: string | null }
          & Meta_FacilityDetailsPage_Fragment
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage', path?: string | null }
          & Meta_ServiceDetailsPage_Fragment
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> }, resources: { __typename?: 'ContentTypeRichTextContentResources', block: Array<(
          { __typename?: 'ContentTypeRichTextContentResourcesBlock' }
          & ResourceMeta_ContentTypeRichTextContentResourcesBlock_Fragment
        )>, inline: Array<(
          { __typename?: 'ContentTypeRichTextContentResourcesInline' }
          & ResourceMeta_ContentTypeRichTextContentResourcesInline_Fragment
        )>, hyperlink: Array<(
          { __typename?: 'ContentTypeRichTextContentResourcesHyperlink' }
          & ResourceMeta_ContentTypeRichTextContentResourcesHyperlink_Fragment
        )> } } } | null, secondaryContent?: { __typename?: 'ContentTypeRichTextSecondaryContent', json: any, links: { __typename?: 'ContentTypeRichTextSecondaryContentLinks', assets: { __typename?: 'ContentTypeRichTextSecondaryContentAssets', block: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null> }, entries: { __typename?: 'ContentTypeRichTextSecondaryContentEntries', inline: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage', path?: string | null }
          & Meta_FacilityDetailsPage_Fragment
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage', path?: string | null }
          & Meta_ServiceDetailsPage_Fragment
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> }, resources: { __typename?: 'ContentTypeRichTextSecondaryContentResources', block: Array<(
          { __typename?: 'ContentTypeRichTextSecondaryContentResourcesBlock' }
          & ResourceMeta_ContentTypeRichTextSecondaryContentResourcesBlock_Fragment
        )>, inline: Array<(
          { __typename?: 'ContentTypeRichTextSecondaryContentResourcesInline' }
          & ResourceMeta_ContentTypeRichTextSecondaryContentResourcesInline_Fragment
        )>, hyperlink: Array<(
          { __typename?: 'ContentTypeRichTextSecondaryContentResourcesHyperlink' }
          & ResourceMeta_ContentTypeRichTextSecondaryContentResourcesHyperlink_Fragment
        )> } } } | null, buttonsCollection?: { __typename?: 'ContentTypeRichTextButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & EnrichedMeta_ContentTypeRichText_Fragment
);

export type SchemaFragment = (
  { __typename?: 'Schema', schema?: any | null, combinedSchema?: boolean | null }
  & Meta_Schema_Fragment
);

export type SegmentsContainerFragment = (
  { __typename?: 'SegmentsContainer', anchorId?: string | null, contentsCollection?: { __typename?: 'SegmentsContainerContentsCollection', items: Array<(
      { __typename?: 'ContentTypeRichText' }
      & Meta_ContentTypeRichText_Fragment
    ) | (
      { __typename?: 'DisclaimerV2' }
      & Meta_DisclaimerV2_Fragment
    ) | (
      { __typename?: 'HalfScreen' }
      & Meta_HalfScreen_Fragment
    ) | (
      { __typename?: 'HeroV2' }
      & Meta_HeroV2_Fragment
    ) | (
      { __typename?: 'Marquee' }
      & Meta_Marquee_Fragment
    ) | (
      { __typename?: 'MultiCardV2' }
      & Meta_MultiCardV2_Fragment
    ) | (
      { __typename?: 'OdpHero' }
      & Meta_OdpHero_Fragment
    ) | (
      { __typename?: 'ServiceLineHero' }
      & Meta_ServiceLineHero_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & Meta_SingleMessage_Fragment
    ) | null> } | null }
  & Meta_SegmentsContainer_Fragment
);

export type ServiceFragment = (
  { __typename?: 'Service', name?: string | null, backgroundColor?: string | null, description?: string | null, direction?: string | null, centerAlign?: boolean | null, contained?: boolean | null, eyebrow?: string | null, title?: string | null, titleHtag?: string | null, buttonText?: string | null, buttonUrl?: string | null, buttonType?: string | null, mediaType?: string | null, imageLayout?: string | null, youTubeVideoId?: string | null, facilitySegmentCollection?: string | null, anchorId?: string | null, richTextDescription?: { __typename?: 'ServiceRichTextDescription', json: any } | null, image?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, mobileImage?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, video?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, buttonsCollection?: { __typename?: 'ServiceButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, youTubeVideoImage?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null }
  & Meta_Service_Fragment
);

export type ServiceLineHeroFragment = (
  { __typename?: 'ServiceLineHero', eyebrow?: string | null, eyebrowHtag?: string | null, templateWidth?: string | null, hideHeroOnMobile?: boolean | null, imgDisplaysFirstOnMobile?: boolean | null, imageWithBorderRadius?: boolean | null, backgroundColor?: string | null, display?: string | null, backgroundColorMobile?: string | null, contentAlign?: string | null, facilitySegmentCollection?: string | null, disablePaddingOn?: Array<string | null> | null, mediaRoundedCornerSize?: string | null, imgDisplaysFirstOnDesktop?: boolean | null, showOfficeDetails?: boolean | null, displayOfficeHoursInModal?: boolean | null, googleMapsBusinessQuery?: string | null, anchorId?: string | null, variant?: string | null, allowScheduleTimes?: boolean | null, officeHoursLabel?: string | null, headline?: { __typename?: 'ServiceLineHeroHeadline', json: any } | null, subHeadline?: { __typename?: 'ServiceLineHeroSubHeadline', json: any } | null, bodyCopy?: { __typename?: 'ServiceLineHeroBodyCopy', json: any } | null, termsConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, buttonCollection?: { __typename?: 'ServiceLineHeroButtonCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, focalPointImage?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, videoAsset?: (
    { __typename?: 'VideoAsset' }
    & VideoAssetFragment
  ) | null, contentListCollection?: { __typename?: 'ServiceLineHeroContentListCollection', items: Array<(
      { __typename?: 'Accordions' }
      & ContentListItem_Accordions_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & ContentListItem_ContentTypeRichText_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & ContentListItem_SingleMessage_Fragment
    ) | (
      { __typename?: 'Table' }
      & ContentListItem_Table_Fragment
    ) | null> } | null, contentListBelowButtonsCollection?: { __typename?: 'ServiceLineHeroContentListBelowButtonsCollection', items: Array<(
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
      & RichTextFragment
      & RichTextFragment
    ) | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
      & SingleMessageFragment
      & SingleMessageFragment
    ) | null> } | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, schedulingImageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_ServiceLineHero_Fragment
);

export type ContentListItem_Accordions_Fragment = (
  { __typename?: 'Accordions' }
  & AccordionFragment
);

export type ContentListItem_ContentTypeRichText_Fragment = (
  { __typename?: 'ContentTypeRichText' }
  & RichTextFragment
);

export type ContentListItem_SingleMessage_Fragment = (
  { __typename?: 'SingleMessage' }
  & SingleMessageFragment
);

export type ContentListItem_Table_Fragment = (
  { __typename?: 'Table' }
  & TableFragment
);

export type ContentListItemFragment = ContentListItem_Accordions_Fragment | ContentListItem_ContentTypeRichText_Fragment | ContentListItem_SingleMessage_Fragment | ContentListItem_Table_Fragment;

export type SingleMessageFragment = (
  { __typename?: 'SingleMessage', backgroundColor?: string | null, display?: string | null, buttonSize?: string | null, buttonText?: string | null, buttonType?: string | null, buttonUrl?: string | null, description?: string | null, disablePaddingOn?: Array<string | null> | null, eyebrow?: string | null, icon?: string | null, iconSize?: string | null, name?: string | null, subText?: string | null, templateWidth?: string | null, templateHeight?: string | null, title?: string | null, titleAlign?: string | null, titleVariant?: string | null, facilitySegmentCollection?: string | null, isBannerImage?: boolean | null, contentFillVerticalSpace?: boolean | null, contentAlign?: string | null, isHeaderAboveSideImages?: boolean | null, isInlineLayout?: boolean | null, displayTitleInline?: boolean | null, useRoundedCorners?: boolean | null, showSubscriptionForm?: boolean | null, anchorId?: string | null, variant?: string | null, focalPointImage?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, buttonsCollection?: { __typename?: 'SingleMessageButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null, content?: { __typename?: 'SingleMessageContent', json: any } | null, contentSmallScreen?: (
    { __typename?: 'SmallScreenContent' }
    & SmallScreenContentFragment
  ) | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null, imageAsset?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, imageLeftSide?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null, imageRightSide?: (
    { __typename?: 'ImageAsset' }
    & ImageAssetFragment
  ) | null }
  & Meta_SingleMessage_Fragment
);

export type SmallScreenContentFragment = { __typename?: 'SmallScreenContent', eyebrowSmallScreen?: string | null, mediaFirst?: boolean | null, headingSmallScreen?: { __typename?: 'SmallScreenContentHeadingSmallScreen', json: any } | null, bodySmallScreen?: { __typename?: 'SmallScreenContentBodySmallScreen', json: any } | null, imageSmallScreen?: (
    { __typename?: 'Asset' }
    & ImageFragment
  ) | null, focalPointImageSmallScreen?: (
    { __typename?: 'FocalPointImage' }
    & FocalPointImageFragment
  ) | null, controllableVideo?: (
    { __typename?: 'Video' }
    & VideoFragment
  ) | null, videoSmallScreen?: (
    { __typename?: 'Asset', url?: string | null }
    & CommonAssetFragment
  ) | null };

export type SpacerFragment = (
  { __typename?: 'Spacer', size?: string | null, color?: string | null, anchorId?: string | null }
  & Meta_Spacer_Fragment
);

export type TableFragment = (
  { __typename?: 'Table', variant?: string | null, fontSize?: string | null, border?: boolean | null, firstColumnSticky?: boolean | null, titleHtag?: string | null, title?: string | null, tableJsonData?: any | null, tableJsonDataMobile?: any | null, anchorId?: string | null, descriptionRichText?: { __typename?: 'TableDescriptionRichText', json: any } | null, tableContent?: { __typename?: 'TableTableContent', json: any, links: { __typename?: 'TableTableContentLinks', entries: { __typename?: 'TableTableContentEntries', inline: Array<{ __typename?: 'Accordions' } | { __typename?: 'AdFooter' } | { __typename?: 'AgendaModal' } | { __typename?: 'AgendaStepper' } | { __typename?: 'AnalyticsContext' } | { __typename?: 'App' } | { __typename?: 'AppCopySlot' } | { __typename?: 'AppFaq' } | { __typename?: 'AppLegalDocument' } | { __typename?: 'AppMediaSlot' } | { __typename?: 'AppOffer' } | { __typename?: 'AppReachYouCard' } | { __typename?: 'AppTip' } | { __typename?: 'AppTreatmentInfo' } | { __typename?: 'AppViewCopy' } | { __typename?: 'AppointmentBookingPage' } | { __typename?: 'Badge' } | { __typename?: 'Banner' } | { __typename?: 'BirdEyeReviews' } | { __typename?: 'BlogAuthor' } | { __typename?: 'BlogCategory' } | { __typename?: 'BlogDetailsPage' } | { __typename?: 'BlogList' } | { __typename?: 'BlogListPage' } | { __typename?: 'BlogSubCategory' } | { __typename?: 'BodyText' } | { __typename?: 'Brand' } | { __typename?: 'Button' } | (
          { __typename?: 'Card', image?: (
            { __typename?: 'Asset', url?: string | null }
            & CommonAssetFragment
          ) | null }
          & Meta_Card_Fragment
        ) | { __typename?: 'Carousel' } | { __typename?: 'Category' } | { __typename?: 'CategoryPicker' } | { __typename?: 'CityLinks' } | { __typename?: 'Columns' } | { __typename?: 'ConfirmationStep' } | { __typename?: 'ContentData' } | { __typename?: 'ContentSection' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'ConvertFlowCta' } | { __typename?: 'ConvertFlowQuiz' } | { __typename?: 'DisclaimerV2' } | { __typename?: 'Error404' } | { __typename?: 'Experience' } | { __typename?: 'ExperimentContainer' } | { __typename?: 'ExperimentVariationContentsItem' } | { __typename?: 'ExperimentalModal' } | { __typename?: 'FacilityDetailsPage' } | { __typename?: 'FaqAccordion' } | { __typename?: 'FeatureFlags' } | { __typename?: 'FocalPointImage' } | { __typename?: 'FooterNavigationGroup' } | { __typename?: 'FormDropdownField' } | { __typename?: 'FormField' } | { __typename?: 'GoogleMapTemplate' } | { __typename?: 'HalfScreen' } | { __typename?: 'Header' } | { __typename?: 'HeaderMainNav' } | { __typename?: 'HeaderNavMenu' } | { __typename?: 'HeaderSubNav' } | { __typename?: 'Heading' } | { __typename?: 'HeroV2' } | { __typename?: 'Icon' } | { __typename?: 'Iframe' } | { __typename?: 'ImageAsset' } | { __typename?: 'Insurance' } | { __typename?: 'LinkForwarder' } | { __typename?: 'List' } | { __typename?: 'ListItem' } | { __typename?: 'LocalizedServiceTitle' } | { __typename?: 'Marquee' } | { __typename?: 'Media' } | { __typename?: 'MediaSlider' } | { __typename?: 'MedicalService' } | { __typename?: 'MeetOurStaff' } | { __typename?: 'MetroLinks' } | { __typename?: 'MobileButton' } | { __typename?: 'MultiCardV2' } | { __typename?: 'NavigationGroup' } | { __typename?: 'NavigationLink' } | { __typename?: 'OdpHero' } | { __typename?: 'Page' } | { __typename?: 'PageLayout' } | { __typename?: 'PageMeta' } | { __typename?: 'PatientReviewV2' } | { __typename?: 'PatientReviewsV2' } | { __typename?: 'Procedure' } | { __typename?: 'Product' } | { __typename?: 'ProductDisplay' } | { __typename?: 'ProductFeature' } | { __typename?: 'ProductFeatureDescriptionListItem' } | { __typename?: 'ProgressIndicator' } | { __typename?: 'ProviderDetailsPage' } | { __typename?: 'QuestionAnswer' } | { __typename?: 'Questionnaire' } | { __typename?: 'QuickLinks' } | { __typename?: 'Quiz' } | { __typename?: 'ReviewStep' } | { __typename?: 'Schema' } | { __typename?: 'SchemaStep' } | { __typename?: 'SectionContent' } | { __typename?: 'SegmentsContainer' } | { __typename?: 'Service' } | { __typename?: 'ServiceDetailsPage' } | { __typename?: 'ServiceGroup' } | { __typename?: 'ServiceLineHero' } | { __typename?: 'SharedForm' } | { __typename?: 'SharedFormDefinitions' } | { __typename?: 'SharedFormField' } | { __typename?: 'SingleMessage' } | { __typename?: 'SmallScreenContent' } | { __typename?: 'SmileAssessmentForm' } | { __typename?: 'Spacer' } | { __typename?: 'StateLinks' } | { __typename?: 'Stepper' } | { __typename?: 'SuccessCard' } | { __typename?: 'Tab' } | { __typename?: 'Table' } | { __typename?: 'Tabs' } | { __typename?: 'TermsAndConditions' } | { __typename?: 'TextBlockSeo' } | { __typename?: 'TextHighlight' } | { __typename?: 'TriggeredContentModal' } | { __typename?: 'Video' } | { __typename?: 'VideoAsset' } | { __typename?: 'VideoCarousel' } | { __typename?: 'VideoWithContent' } | null> } } } | null, footnote?: { __typename?: 'TableFootnote', json: any } | null }
  & Meta_Table_Fragment
);

export type TabsFragment = (
  { __typename?: 'Tabs', backgroundColor?: string | null, jumplinkTabs?: boolean | null, tabRowVariant?: string | null, tabsSize?: string | null, withContentInnerGap?: boolean | null, anchorId?: string | null, variant?: string | null, tabsCollection?: { __typename?: 'TabsTabsCollection', items: Array<(
      { __typename?: 'Tab', label?: string | null, jumplinkName?: string | null, content?: (
        { __typename?: 'Accordions' }
        & AccordionFragment
      ) | (
        { __typename?: 'HalfScreen' }
        & HalfScreenFragment
      ) | (
        { __typename?: 'MultiCardV2' }
        & CardsFragment
      ) | (
        { __typename?: 'ServiceLineHero' }
        & ServiceLineHeroFragment
      ) | (
        { __typename?: 'SingleMessage' }
        & SingleMessageFragment
      ) | null }
      & Meta_Tab_Fragment
    ) | null> } | null }
  & Meta_Tabs_Fragment
);

export type TermOfConditionsFragment = (
  { __typename?: 'TermsAndConditions', showTcTextAs?: boolean | null, tcText?: string | null, tcLink?: string | null, headlineText?: string | null, content?: { __typename?: 'TermsAndConditionsContent', json: any } | null }
  & Meta_TermsAndConditions_Fragment
);

export type TextBlockSeoFragment = (
  { __typename?: 'TextBlockSeo', name?: string | null, backgroundColor?: string | null, disablePaddingOn?: Array<string | null> | null, anchorId?: string | null, content?: { __typename?: 'TextBlockSeoContent', json: any } | null }
  & Meta_TextBlockSeo_Fragment
);

export type VideoAssetFragment = (
  { __typename?: 'VideoAsset', desktopVideo?: (
    { __typename?: 'Video' }
    & VideoFragment
  ) | null, mobileVideo?: (
    { __typename?: 'Video' }
    & VideoFragment
  ) | null }
  & Meta_VideoAsset_Fragment
);

export type VideoCarouselFragment = (
  { __typename?: 'VideoCarousel', backgroundColor?: string | null, desktopVideosAspectRatio?: string | null, mobileVideosAspectRatio?: string | null, anchorId?: string | null, topFields?: (
    { __typename?: 'ContentSection' }
    & ContentSectionFragment
  ) | null, videosCollection?: { __typename?: 'VideoCarouselVideosCollection', skip: number, total: number, items: Array<(
      { __typename?: 'VideoWithContent', content?: (
        { __typename?: 'ContentSection' }
        & ContentSectionFragment
      ) | null, video?: (
        { __typename?: 'VideoAsset' }
        & VideoAssetFragment
      ) | null, buttonsCollection?: { __typename?: 'VideoWithContentButtonsCollection', items: Array<(
          { __typename?: 'Button' }
          & ButtonFragment
        ) | null> } | null }
      & Meta_VideoWithContent_Fragment
    ) | null> } | null, buttonsCollection?: { __typename?: 'VideoCarouselButtonsCollection', items: Array<(
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null> } | null }
  & Meta_VideoCarousel_Fragment
);

export type AccordionsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccordionsByIdQuery = { __typename?: 'Query', accordions?: (
    { __typename?: 'Accordions' }
    & AccordionFragment
  ) | null };

export type AgendaStepperByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AgendaStepperByIdQuery = { __typename?: 'Query', agendaStepper?: { __typename?: 'AgendaStepper', icon?: string | null, title?: string | null, titleHtag?: string | null, hideStepperDot?: boolean | null, backgroundColor?: string | null, useNumericStepper?: boolean | null, isHighlightedSteps?: boolean | null, areStepsCenteredForMobile?: boolean | null, anchorId?: string | null, description?: (
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | null, stepsCollection?: { __typename?: 'AgendaStepperStepsCollection', items: Array<(
        { __typename?: 'AgendaModal' }
        & AgendaModalFragment
      ) | null> } | null } | null };

export type AppMetadataByAppNameQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AppMetadataByAppNameQuery = { __typename?: 'Query', appCollection?: { __typename?: 'AppCollection', items: Array<(
      { __typename?: 'App' }
      & AppMetadataFragment
    ) | null> } | null };

export type AppPagesDataByAppNameQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AppPagesDataByAppNameQuery = { __typename?: 'Query', appCollection?: { __typename?: 'AppCollection', items: Array<(
      { __typename?: 'App' }
      & AppPagesDataFragment
    ) | null> } | null };

export type BirdEyeReviewsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BirdEyeReviewsByIdQuery = { __typename?: 'Query', birdEyeReviews?: (
    { __typename?: 'BirdEyeReviews', title?: string | null, titleHeading?: string | null, tags?: Array<string | null> | null, filteredReviewsMinRating?: string | null, filteredReviewsTitle?: string | null, anchorId?: string | null, mediaContent?: (
      { __typename?: 'FocalPointImage' }
      & FocalPointImageFragment
    ) | (
      { __typename?: 'Video' }
      & VideoFragment
    ) | null }
    & Meta_BirdEyeReviews_Fragment
  ) | null };

export type BlogCategoriesByBrandQueryVariables = Exact<{
  brandName: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryOrder>> | InputMaybe<BlogCategoryOrder>>;
}>;


export type BlogCategoriesByBrandQuery = { __typename?: 'Query', blogCategoryCollection?: { __typename?: 'BlogCategoryCollection', items: Array<{ __typename?: 'BlogCategory', name?: string | null, slug?: string | null } | null> } | null };

export type BlogSubCategoriesByBrandQueryVariables = Exact<{
  brandName: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<BlogSubCategoryOrder>> | InputMaybe<BlogSubCategoryOrder>>;
}>;


export type BlogSubCategoriesByBrandQuery = { __typename?: 'Query', blogSubCategoryCollection?: { __typename?: 'BlogSubCategoryCollection', items: Array<{ __typename?: 'BlogSubCategory', name?: string | null, slug?: string | null } | null> } | null };

export type BlogDetailsPageByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
  title: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlogDetailsPageByPathQuery = { __typename?: 'Query', blogDetailsPageCollection?: { __typename?: 'BlogDetailsPageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'BlogDetailsPage' }
      & BlogDetailsPageFragment
    ) | null> } | null };

export type BlogListByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlogListByIdQuery = { __typename?: 'Query', blogList?: (
    { __typename?: 'BlogList' }
    & BlogListFragment
  ) | null };

export type BlogListPageByBrandQueryVariables = Exact<{
  brandName: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlogListPageByBrandQuery = { __typename?: 'Query', blogListPageCollection?: { __typename?: 'BlogListPageCollection', items: Array<(
      { __typename?: 'BlogListPage' }
      & BlogListPageFragment
    ) | null> } | null };

export type BlogsListByBrandQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandName: Scalars['String']['input'];
  order?: InputMaybe<Array<BlogDetailsPageOrder> | BlogDetailsPageOrder>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  subCategoryName?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type BlogsListByBrandQuery = { __typename?: 'Query', blogDetailsPageCollection?: { __typename?: 'BlogDetailsPageCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'BlogDetailsPage', timeToRead?: number | null, title?: string | null, path?: string | null, blogImage?: any | null, date?: any | null, tags?: Array<string | null> | null, category?: { __typename?: 'BlogCategory', name?: string | null, slug?: string | null } | null, summary?: { __typename?: 'BlogDetailsPageSummary', json: any } | null, imageAsset?: { __typename?: 'ImageAsset', desktopImage?: any | null, mobileImage?: any | null } | null } | null> } | null };

export type BlogTagsByBrandQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandName: Scalars['String']['input'];
  order?: InputMaybe<Array<BlogDetailsPageOrder> | BlogDetailsPageOrder>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BlogTagsByBrandQuery = { __typename?: 'Query', blogDetailsPageCollection?: { __typename?: 'BlogDetailsPageCollection', total: number, skip: number, limit: number, items: Array<{ __typename?: 'BlogDetailsPage', tags?: Array<string | null> | null } | null> } | null };

export type BlogDetailsPageItemFragment = { __typename?: 'BlogDetailsPage', path?: string | null, indexed?: boolean | null, sys: { __typename?: 'Sys', publishedAt?: any | null }, category?: (
    { __typename?: 'BlogCategory' }
    & BlogCategoryFragment
  ) | null };

export type BlogListPageItemFragment = { __typename?: 'BlogListPage', indexed?: boolean | null, sys: { __typename?: 'Sys', publishedAt?: any | null } };

export type BlogPagesQueryVariables = Exact<{
  brandName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BlogPagesQuery = { __typename?: 'Query', blogDetailsPageCollection?: { __typename?: 'BlogDetailsPageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'BlogDetailsPage' }
      & BlogDetailsPageItemFragment
    ) | null> } | null, blogListPageCollection?: { __typename?: 'BlogListPageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'BlogListPage' }
      & BlogListPageItemFragment
    ) | null> } | null };

export type CategoryPickerByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CategoryPickerByIdQuery = { __typename?: 'Query', categoryPicker?: (
    { __typename?: 'CategoryPicker' }
    & CategoryPickerFragment
  ) | null };

export type CityLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CityLinksByIdQuery = { __typename?: 'Query', cityLinks?: (
    { __typename?: 'CityLinks', name?: string | null }
    & Meta_CityLinks_Fragment
  ) | null };

export type ColumnsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ColumnsByIdQuery = { __typename?: 'Query', columns?: (
    { __typename?: 'Columns' }
    & ColumnsFragment
  ) | null };

export type ConvertFlowCtaByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConvertFlowCtaByIdQuery = { __typename?: 'Query', convertFlowCta?: (
    { __typename?: 'ConvertFlowCta' }
    & ConvertFlowCtaFragment
  ) | null };

export type ConvertFlowQuizByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConvertFlowQuizByIdQuery = { __typename?: 'Query', convertFlowQuiz?: (
    { __typename?: 'ConvertFlowQuiz' }
    & ConvertFlowQuizFragment
  ) | null };

export type DisclaimerV2ByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DisclaimerV2ByIdQuery = { __typename?: 'Query', disclaimerV2?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2Fragment
  ) | null };

export type ExperimentContainerByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExperimentContainerByIdQuery = { __typename?: 'Query', experimentContainer?: (
    { __typename?: 'ExperimentContainer' }
    & ExperimentContainerFragment
  ) | null };

export type FacilityDetailsPageByIdQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FacilityDetailsPageByIdQuery = { __typename?: 'Query', facilityDetailsPageCollection?: { __typename?: 'FacilityDetailsPageCollection', items: Array<{ __typename?: 'FacilityDetailsPage', path?: string | null, title?: string | null, indexed?: boolean | null, description?: string | null, canonical?: string | null, teletriageEnabled?: boolean | null, textSeo?: { __typename?: 'FacilityDetailsPageTextSeo', json: any } | null, moreTextSeo?: { __typename?: 'FacilityDetailsPageMoreTextSeo', json: any } | null, ogImage?: { __typename?: 'ImageAsset', desktopImage?: any | null } | null, analyticsContext?: { __typename?: 'AnalyticsContext', sys: { __typename?: 'Sys', id: string } } | null, contentsCollection?: { __typename?: 'FacilityDetailsPageContentsCollection', items: Array<{ __typename: 'Accordions', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BirdEyeReviews', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategoryPicker', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Columns', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'DisclaimerV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'GoogleMapTemplate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HalfScreen', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Marquee', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MeetOurStaff', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiCardV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'OdpHero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PatientReviewsV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductDisplay', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductFeature', sys: { __typename?: 'Sys', id: string } } | { __typename: 'QuickLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Quiz', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Schema', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SegmentsContainer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ServiceLineHero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SingleMessage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Spacer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Tabs', sys: { __typename?: 'Sys', id: string } } | null> } | null } | null> } | null };

export type FacilityDetailsPageContentDataByFacilityIdQueryVariables = Exact<{
  facilityId: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FacilityDetailsPageContentDataByFacilityIdQuery = { __typename?: 'Query', facilityDetailsPageCollection?: { __typename?: 'FacilityDetailsPageCollection', items: Array<{ __typename?: 'FacilityDetailsPage', facilityId?: string | null, pageContentDataJson?: any | null } | null> } | null };

export type GoogleMapTemplateByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GoogleMapTemplateByIdQuery = { __typename?: 'Query', googleMapTemplate?: (
    { __typename?: 'GoogleMapTemplate' }
    & GoogleMapTemplateFragment
  ) | null };

export type HalfScreenByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HalfScreenByIdQuery = { __typename?: 'Query', halfScreen?: (
    { __typename?: 'HalfScreen' }
    & HalfScreenFragment
  ) | null };

export type HeroV2ByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HeroV2ByIdQuery = { __typename?: 'Query', heroV2?: (
    { __typename?: 'HeroV2' }
    & HeroFragment
  ) | null };

export type IframeByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IframeByIdQuery = { __typename?: 'Query', iframe?: (
    { __typename?: 'Iframe' }
    & IframeFragment
  ) | null };

export type InsuranceByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsuranceByIdQuery = { __typename?: 'Query', insurance?: (
    { __typename?: 'Insurance' }
    & InsuranceFragment
  ) | null };

export type MarqueeByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarqueeByIdQuery = { __typename?: 'Query', marquee?: (
    { __typename?: 'Marquee' }
    & MarqueeFragment
  ) | null };

export type MeetOurStaffByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MeetOurStaffByIdQuery = { __typename?: 'Query', meetOurStaff?: (
    { __typename?: 'MeetOurStaff' }
    & MeetOurStaffFragment
  ) | null };

export type MultiCardV2ByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MultiCardV2ByIdQuery = { __typename?: 'Query', multiCardV2?: (
    { __typename?: 'MultiCardV2' }
    & CardsFragment
  ) | null };

export type OdpHeroByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OdpHeroByIdQuery = { __typename?: 'Query', odpHero?: (
    { __typename?: 'OdpHero' }
    & OdpHeroFragment
  ) | null };

export type LandingPageByPathQueryVariables = Exact<{
  path: Scalars['String']['input'];
  content_limit?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LandingPageByPathQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'Page' }
      & PageFragment
    ) | null> } | null };

export type LandingPageByAppNameWithPathQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  path: Scalars['String']['input'];
  content_limit?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LandingPageByAppNameWithPathQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'Page' }
      & PageFragment
    ) | null> } | null };

export type PageByAppAndAlternatePathQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  path: Scalars['String']['input'];
  alternativePath: Scalars['String']['input'];
  content_limit?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PageByAppAndAlternatePathQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', skip: number, limit: number, total: number, items: Array<(
      { __typename?: 'Page' }
      & PageFragment
    ) | null> } | null };

export type PatientReviewsV2ByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PatientReviewsV2ByIdQuery = { __typename?: 'Query', patientReviewsV2?: (
    { __typename?: 'PatientReviewsV2' }
    & PatientReviewsV2Fragment
  ) | null };

export type ProductDisplayByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductDisplayByIdQuery = { __typename?: 'Query', productDisplay?: (
    { __typename?: 'ProductDisplay' }
    & Meta_ProductDisplay_Fragment
    & ProductDisplayFragment
  ) | null };

export type ProductFeatureByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductFeatureByIdQuery = { __typename?: 'Query', productFeature?: (
    { __typename?: 'ProductFeature', enableSliderControlsBackgroundGradient?: boolean | null, anchorId?: string | null, headline?: (
      { __typename?: 'ContentSection' }
      & ContentSectionFragment
    ) | null, descriptionRichText?: (
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | null, descriptionButton?: (
      { __typename?: 'Button' }
      & ButtonFragment
    ) | null, descriptionButtonsCollection?: { __typename?: 'ProductFeatureDescriptionButtonsCollection', items: Array<(
        { __typename?: 'Button' }
        & ButtonFragment
      ) | null> } | null, descriptionListCollection?: { __typename?: 'ProductFeatureDescriptionListCollection', items: Array<(
        { __typename?: 'ProductFeatureDescriptionListItem', icon?: string | null, content?: (
          { __typename?: 'ContentTypeRichText' }
          & RichTextFragment
        ) | null }
        & Meta_ProductFeatureDescriptionListItem_Fragment
      ) | null> } | null, buttonsCollection?: { __typename?: 'ProductFeatureButtonsCollection', items: Array<(
        { __typename?: 'Button' }
        & ButtonFragment
      ) | null> } | null, media?: { __typename?: 'MediaSlider', badge?: { __typename?: 'Badge', label?: string | null, variant?: string | null } | null, contentsCollection?: { __typename?: 'MediaSliderContentsCollection', items: Array<(
          { __typename?: 'FocalPointImage' }
          & FocalPointImageFragment
        ) | (
          { __typename?: 'Video' }
          & VideoFragment
        ) | null> } | null } | null, disclaimer?: (
      { __typename?: 'DisclaimerV2' }
      & DisclaimerV2Fragment
    ) | null }
    & Meta_ProductFeature_Fragment
  ) | null };

export type QuickLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuickLinksByIdQuery = { __typename?: 'Query', quickLinks?: (
    { __typename?: 'QuickLinks' }
    & QuickLinksFragment
  ) | null };

export type QuizByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuizByIdQuery = { __typename?: 'Query', quiz?: (
    { __typename?: 'Quiz' }
    & QuizFragment
  ) | null };

export type RichTextByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RichTextByIdQuery = { __typename?: 'Query', contentTypeRichText?: (
    { __typename?: 'ContentTypeRichText' }
    & RichTextWithLinksFragment
  ) | null };

export type SmallScreenContentEntryLinksFragment = (
  { __typename?: 'SmallScreenContent', entryName?: string | null, bodySmallScreen?: { __typename?: 'SmallScreenContentBodySmallScreen', links: { __typename?: 'SmallScreenContentBodySmallScreenLinks', entries: { __typename?: 'SmallScreenContentBodySmallScreenEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_SmallScreenContent_Fragment
);

export type ContentTypeRichTextEntryLinksFragment = (
  { __typename?: 'ContentTypeRichText', content?: { __typename?: 'ContentTypeRichTextContent', links: { __typename?: 'ContentTypeRichTextContentLinks', entries: { __typename?: 'ContentTypeRichTextContentEntries', block: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
          & ImageAssetFragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, secondaryContent?: { __typename?: 'ContentTypeRichTextSecondaryContent', links: { __typename?: 'ContentTypeRichTextSecondaryContentLinks', entries: { __typename?: 'ContentTypeRichTextSecondaryContentEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_ContentTypeRichText_Fragment
);

export type HeroV2EntryLinksFragment = (
  { __typename?: 'HeroV2', entryName?: string | null, body?: { __typename?: 'HeroV2Body', links: { __typename?: 'HeroV2BodyLinks', entries: { __typename?: 'HeroV2BodyEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, contentSmallScreen?: (
    { __typename?: 'SmallScreenContent' }
    & SmallScreenContentEntryLinksFragment
  ) | null, termsConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2EntryLinksFragment
  ) | null }
  & Meta_HeroV2_Fragment
);

export type HalfScreenEntryLinksFragment = (
  { __typename?: 'HalfScreen', name?: string | null, body?: { __typename?: 'HalfScreenBody', links: { __typename?: 'HalfScreenBodyLinks', entries: { __typename?: 'HalfScreenBodyEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, contentSmallScreen?: (
    { __typename?: 'SmallScreenContent' }
    & SmallScreenContentEntryLinksFragment
  ) | null, termsAndConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null, disclaimer?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2EntryLinksFragment
  ) | null }
  & Meta_HalfScreen_Fragment
);

export type SingleMessageEntryLinksFragment = (
  { __typename?: 'SingleMessage', name?: string | null, content?: { __typename?: 'SingleMessageContent', links: { __typename?: 'SingleMessageContentLinks', entries: { __typename?: 'SingleMessageContentEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, contentSmallScreen?: (
    { __typename?: 'SmallScreenContent' }
    & SmallScreenContentEntryLinksFragment
  ) | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null }
  & Meta_SingleMessage_Fragment
);

export type CardEntryLinksFragment = (
  { __typename?: 'Card', name?: string | null, richTextDescription?: { __typename?: 'CardRichTextDescription', links: { __typename?: 'CardRichTextDescriptionLinks', entries: { __typename?: 'CardRichTextDescriptionEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> }, assets: { __typename?: 'CardRichTextDescriptionAssets', block: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null>, hyperlink: Array<(
          { __typename?: 'Asset', contentType?: string | null, url?: string | null, description?: string | null, fileName?: string | null }
          & LinkMetaFragment
        ) | null> } } } | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null }
  & Meta_Card_Fragment
);

export type MulticardV2EntryLinksFragment = (
  { __typename?: 'MultiCardV2', descriptionRichText?: { __typename?: 'MultiCardV2DescriptionRichText', links: { __typename?: 'MultiCardV2DescriptionRichTextLinks', entries: { __typename?: 'MultiCardV2DescriptionRichTextEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> } } } | null, simpleCard?: { __typename?: 'MultiCardV2SimpleCard', links: { __typename?: 'MultiCardV2SimpleCardLinks', entries: { __typename?: 'MultiCardV2SimpleCardEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> } } } | null, simpleCardTwo?: { __typename?: 'MultiCardV2SimpleCardTwo', links: { __typename?: 'MultiCardV2SimpleCardTwoLinks', entries: { __typename?: 'MultiCardV2SimpleCardTwoEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> } } } | null, simpleCardThree?: { __typename?: 'MultiCardV2SimpleCardThree', links: { __typename?: 'MultiCardV2SimpleCardThreeLinks', entries: { __typename?: 'MultiCardV2SimpleCardThreeEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> } } } | null, cardsCollection?: { __typename?: 'MultiCardV2CardsCollection', items: Array<(
      { __typename?: 'Card' }
      & CardEntryLinksFragment
    ) | null> } | null }
  & Meta_MultiCardV2_Fragment
);

export type TextBlockSeoEntryLinksFragment = (
  { __typename?: 'TextBlockSeo', content?: { __typename?: 'TextBlockSeoContent', links: { __typename?: 'TextBlockSeoContentLinks', entries: { __typename?: 'TextBlockSeoContentEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_TextBlockSeo_Fragment
);

export type TermsAndConditionsEntryLinksFragment = (
  { __typename?: 'TermsAndConditions', content?: { __typename?: 'TermsAndConditionsContent', links: { __typename?: 'TermsAndConditionsContentLinks', entries: { __typename?: 'TermsAndConditionsContentEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_TermsAndConditions_Fragment
);

export type AccordionsEntryLinksFragment = (
  { __typename?: 'Accordions', title?: string | null, descriptionRichText?: { __typename?: 'AccordionsDescriptionRichText', links: { __typename?: 'AccordionsDescriptionRichTextLinks', entries: { __typename?: 'AccordionsDescriptionRichTextEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & EnrichedMeta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & EnrichedMeta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & EnrichedMeta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & EnrichedMeta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & EnrichedMeta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & EnrichedMeta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & EnrichedMeta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & EnrichedMeta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & EnrichedMeta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & EnrichedMeta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & EnrichedMeta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & EnrichedMeta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & EnrichedMeta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & EnrichedMeta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & EnrichedMeta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & EnrichedMeta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & EnrichedMeta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & EnrichedMeta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & EnrichedMeta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & EnrichedMeta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & EnrichedMeta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & EnrichedMeta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & EnrichedMeta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & EnrichedMeta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & EnrichedMeta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & EnrichedMeta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & EnrichedMeta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & EnrichedMeta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & EnrichedMeta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & EnrichedMeta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & EnrichedMeta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & EnrichedMeta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & EnrichedMeta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & EnrichedMeta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & EnrichedMeta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & EnrichedMeta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & EnrichedMeta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & EnrichedMeta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & EnrichedMeta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & EnrichedMeta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & EnrichedMeta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & EnrichedMeta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & EnrichedMeta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & EnrichedMeta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & EnrichedMeta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & EnrichedMeta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & EnrichedMeta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & EnrichedMeta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & EnrichedMeta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & EnrichedMeta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & EnrichedMeta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & EnrichedMeta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & EnrichedMeta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & EnrichedMeta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & EnrichedMeta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & EnrichedMeta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & EnrichedMeta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & EnrichedMeta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & EnrichedMeta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & EnrichedMeta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & EnrichedMeta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & EnrichedMeta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & EnrichedMeta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & EnrichedMeta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & EnrichedMeta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & EnrichedMeta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & EnrichedMeta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & EnrichedMeta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & EnrichedMeta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & EnrichedMeta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & EnrichedMeta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & EnrichedMeta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & EnrichedMeta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & EnrichedMeta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & EnrichedMeta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & EnrichedMeta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & EnrichedMeta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & EnrichedMeta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & EnrichedMeta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & EnrichedMeta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & EnrichedMeta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & EnrichedMeta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & EnrichedMeta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & EnrichedMeta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & EnrichedMeta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & EnrichedMeta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & EnrichedMeta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & EnrichedMeta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & EnrichedMeta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & EnrichedMeta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & EnrichedMeta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & EnrichedMeta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & EnrichedMeta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & EnrichedMeta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & EnrichedMeta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & EnrichedMeta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & EnrichedMeta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & EnrichedMeta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & EnrichedMeta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & EnrichedMeta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & EnrichedMeta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & EnrichedMeta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & EnrichedMeta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & EnrichedMeta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & EnrichedMeta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & EnrichedMeta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & EnrichedMeta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & EnrichedMeta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & EnrichedMeta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & EnrichedMeta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & EnrichedMeta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & EnrichedMeta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & EnrichedMeta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & EnrichedMeta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & EnrichedMeta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & EnrichedMeta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & EnrichedMeta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & EnrichedMeta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & EnrichedMeta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & EnrichedMeta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & EnrichedMeta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & EnrichedMeta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & EnrichedMeta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & EnrichedMeta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & EnrichedMeta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & EnrichedMeta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & EnrichedMeta_VideoWithContent_Fragment
        ) | null> } } } | null, accordionsCollection?: { __typename?: 'AccordionsAccordionsCollection', items: Array<{ __typename?: 'AgendaStepper' } | (
      { __typename?: 'ContentTypeRichText' }
      & ContentTypeRichTextEntryLinksFragment
    ) | null> } | null }
  & Meta_Accordions_Fragment
);

export type DisclaimerV2EntryLinksFragment = (
  { __typename?: 'DisclaimerV2', entryName?: string | null, disclaimer?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null }
  & Meta_DisclaimerV2_Fragment
);

export type InsuranceEntryLinksFragment = (
  { __typename?: 'Insurance', name?: string | null, intro?: { __typename?: 'InsuranceIntro', links: { __typename?: 'InsuranceIntroLinks', entries: { __typename?: 'InsuranceIntroEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_Insurance_Fragment
);

export type CategoryPickerEntryLinksFragment = (
  { __typename?: 'CategoryPicker', name?: string | null, bodyCopy?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null }
  & Meta_CategoryPicker_Fragment
);

export type ColumnsEntryLinksFragment = (
  { __typename?: 'Columns', title?: string | null, columnsCollection?: { __typename?: 'ColumnsColumnsCollection', items: Array<(
      { __typename?: 'Accordions' }
      & AccordionsEntryLinksFragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & ContentTypeRichTextEntryLinksFragment
    ) | { __typename?: 'ImageAsset' } | { __typename?: 'SchemaStep' } | (
      { __typename?: 'SingleMessage' }
      & SingleMessageEntryLinksFragment
    ) | null> } | null }
  & Meta_Columns_Fragment
);

export type ContentListItemEntryLinks_Accordions_Fragment = (
  { __typename?: 'Accordions' }
  & AccordionsEntryLinksFragment
);

export type ContentListItemEntryLinks_ContentTypeRichText_Fragment = (
  { __typename?: 'ContentTypeRichText' }
  & ContentTypeRichTextEntryLinksFragment
);

export type ContentListItemEntryLinks_SingleMessage_Fragment = (
  { __typename?: 'SingleMessage' }
  & SingleMessageEntryLinksFragment
);

export type ContentListItemEntryLinks_Table_Fragment = { __typename?: 'Table' };

export type ContentListItemEntryLinksFragment = ContentListItemEntryLinks_Accordions_Fragment | ContentListItemEntryLinks_ContentTypeRichText_Fragment | ContentListItemEntryLinks_SingleMessage_Fragment | ContentListItemEntryLinks_Table_Fragment;

export type ServiceLineHeroEntryLinksFragment = (
  { __typename?: 'ServiceLineHero', subHeadline?: { __typename?: 'ServiceLineHeroSubHeadline', links: { __typename?: 'ServiceLineHeroSubHeadlineLinks', entries: { __typename?: 'ServiceLineHeroSubHeadlineEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, bodyCopy?: { __typename?: 'ServiceLineHeroBodyCopy', links: { __typename?: 'ServiceLineHeroBodyCopyLinks', entries: { __typename?: 'ServiceLineHeroBodyCopyEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, termsConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null, contentListCollection?: { __typename?: 'ServiceLineHeroContentListCollection', items: Array<(
      { __typename?: 'Accordions' }
      & ContentListItemEntryLinks_Accordions_Fragment
    ) | (
      { __typename?: 'ContentTypeRichText' }
      & ContentListItemEntryLinks_ContentTypeRichText_Fragment
    ) | (
      { __typename?: 'SingleMessage' }
      & ContentListItemEntryLinks_SingleMessage_Fragment
    ) | (
      { __typename?: 'Table' }
      & ContentListItemEntryLinks_Table_Fragment
    ) | null> } | null, contentListBelowButtonsCollection?: { __typename?: 'ServiceLineHeroContentListBelowButtonsCollection', items: Array<(
      { __typename?: 'ContentTypeRichText' }
      & RichTextFragment
    ) | (
      { __typename?: 'SingleMessage' }
      & SingleMessageFragment
    ) | null> } | null }
  & Meta_ServiceLineHero_Fragment
);

export type OdpHeroEntryLinksFragment = (
  { __typename?: 'OdpHero', name?: string | null, bodyCopy?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null }
  & Meta_OdpHero_Fragment
);

export type QuickLinksEntryLinksFragment = (
  { __typename?: 'QuickLinks', body?: { __typename?: 'QuickLinksBody', links: { __typename?: 'QuickLinksBodyLinks', entries: { __typename?: 'QuickLinksBodyEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null }
  & Meta_QuickLinks_Fragment
);

export type ServiceEntryLinksFragment = (
  { __typename?: 'Service', name?: string | null, richTextDescription?: { __typename?: 'ServiceRichTextDescription', links: { __typename?: 'ServiceRichTextDescriptionLinks', entries: { __typename?: 'ServiceRichTextDescriptionEntries', hyperlink: Array<(
          { __typename?: 'Accordions' }
          & Meta_Accordions_Fragment
        ) | (
          { __typename?: 'AdFooter' }
          & Meta_AdFooter_Fragment
        ) | (
          { __typename?: 'AgendaModal' }
          & Meta_AgendaModal_Fragment
        ) | (
          { __typename?: 'AgendaStepper' }
          & Meta_AgendaStepper_Fragment
        ) | (
          { __typename?: 'AnalyticsContext' }
          & Meta_AnalyticsContext_Fragment
        ) | (
          { __typename?: 'App' }
          & Meta_App_Fragment
        ) | (
          { __typename?: 'AppCopySlot' }
          & Meta_AppCopySlot_Fragment
        ) | (
          { __typename?: 'AppFaq' }
          & Meta_AppFaq_Fragment
        ) | (
          { __typename?: 'AppLegalDocument' }
          & Meta_AppLegalDocument_Fragment
        ) | (
          { __typename?: 'AppMediaSlot' }
          & Meta_AppMediaSlot_Fragment
        ) | (
          { __typename?: 'AppOffer' }
          & Meta_AppOffer_Fragment
        ) | (
          { __typename?: 'AppReachYouCard' }
          & Meta_AppReachYouCard_Fragment
        ) | (
          { __typename?: 'AppTip' }
          & Meta_AppTip_Fragment
        ) | (
          { __typename?: 'AppTreatmentInfo' }
          & Meta_AppTreatmentInfo_Fragment
        ) | (
          { __typename?: 'AppViewCopy' }
          & Meta_AppViewCopy_Fragment
        ) | (
          { __typename?: 'AppointmentBookingPage' }
          & Meta_AppointmentBookingPage_Fragment
        ) | (
          { __typename?: 'Badge' }
          & Meta_Badge_Fragment
        ) | (
          { __typename?: 'Banner' }
          & Meta_Banner_Fragment
        ) | (
          { __typename?: 'BirdEyeReviews' }
          & Meta_BirdEyeReviews_Fragment
        ) | (
          { __typename?: 'BlogAuthor' }
          & Meta_BlogAuthor_Fragment
        ) | (
          { __typename?: 'BlogCategory' }
          & Meta_BlogCategory_Fragment
        ) | (
          { __typename?: 'BlogDetailsPage' }
          & Meta_BlogDetailsPage_Fragment
          & BlogDetailsPageBaseFragment
        ) | (
          { __typename?: 'BlogList' }
          & Meta_BlogList_Fragment
        ) | (
          { __typename?: 'BlogListPage' }
          & Meta_BlogListPage_Fragment
        ) | (
          { __typename?: 'BlogSubCategory' }
          & Meta_BlogSubCategory_Fragment
        ) | (
          { __typename?: 'BodyText' }
          & Meta_BodyText_Fragment
        ) | (
          { __typename?: 'Brand' }
          & Meta_Brand_Fragment
        ) | (
          { __typename?: 'Button' }
          & Meta_Button_Fragment
        ) | (
          { __typename?: 'Card' }
          & Meta_Card_Fragment
        ) | (
          { __typename?: 'Carousel' }
          & Meta_Carousel_Fragment
        ) | (
          { __typename?: 'Category' }
          & Meta_Category_Fragment
        ) | (
          { __typename?: 'CategoryPicker' }
          & Meta_CategoryPicker_Fragment
        ) | (
          { __typename?: 'CityLinks' }
          & Meta_CityLinks_Fragment
        ) | (
          { __typename?: 'Columns' }
          & Meta_Columns_Fragment
        ) | (
          { __typename?: 'ConfirmationStep' }
          & Meta_ConfirmationStep_Fragment
        ) | (
          { __typename?: 'ContentData' }
          & Meta_ContentData_Fragment
        ) | (
          { __typename?: 'ContentSection' }
          & Meta_ContentSection_Fragment
        ) | (
          { __typename?: 'ContentTile' }
          & Meta_ContentTile_Fragment
        ) | (
          { __typename?: 'ContentTypeRichText' }
          & Meta_ContentTypeRichText_Fragment
        ) | (
          { __typename?: 'ConvertFlowCta' }
          & Meta_ConvertFlowCta_Fragment
        ) | (
          { __typename?: 'ConvertFlowQuiz' }
          & Meta_ConvertFlowQuiz_Fragment
        ) | (
          { __typename?: 'DisclaimerV2' }
          & Meta_DisclaimerV2_Fragment
        ) | (
          { __typename?: 'Error404' }
          & Meta_Error404_Fragment
        ) | (
          { __typename?: 'Experience' }
          & Meta_Experience_Fragment
        ) | (
          { __typename?: 'ExperimentContainer' }
          & Meta_ExperimentContainer_Fragment
        ) | (
          { __typename?: 'ExperimentVariationContentsItem' }
          & Meta_ExperimentVariationContentsItem_Fragment
        ) | (
          { __typename?: 'ExperimentalModal' }
          & Meta_ExperimentalModal_Fragment
        ) | (
          { __typename?: 'FacilityDetailsPage' }
          & Meta_FacilityDetailsPage_Fragment
          & FacilityDetailsPageBaseFragment
        ) | (
          { __typename?: 'FaqAccordion' }
          & Meta_FaqAccordion_Fragment
        ) | (
          { __typename?: 'FeatureFlags' }
          & Meta_FeatureFlags_Fragment
        ) | (
          { __typename?: 'FocalPointImage' }
          & Meta_FocalPointImage_Fragment
        ) | (
          { __typename?: 'FooterNavigationGroup' }
          & Meta_FooterNavigationGroup_Fragment
        ) | (
          { __typename?: 'FormDropdownField' }
          & Meta_FormDropdownField_Fragment
        ) | (
          { __typename?: 'FormField' }
          & Meta_FormField_Fragment
        ) | (
          { __typename?: 'GoogleMapTemplate' }
          & Meta_GoogleMapTemplate_Fragment
        ) | (
          { __typename?: 'HalfScreen' }
          & Meta_HalfScreen_Fragment
        ) | (
          { __typename?: 'Header' }
          & Meta_Header_Fragment
        ) | (
          { __typename?: 'HeaderMainNav' }
          & Meta_HeaderMainNav_Fragment
        ) | (
          { __typename?: 'HeaderNavMenu' }
          & Meta_HeaderNavMenu_Fragment
        ) | (
          { __typename?: 'HeaderSubNav' }
          & Meta_HeaderSubNav_Fragment
        ) | (
          { __typename?: 'Heading' }
          & Meta_Heading_Fragment
        ) | (
          { __typename?: 'HeroV2' }
          & Meta_HeroV2_Fragment
        ) | (
          { __typename?: 'Icon' }
          & Meta_Icon_Fragment
        ) | (
          { __typename?: 'Iframe' }
          & Meta_Iframe_Fragment
        ) | (
          { __typename?: 'ImageAsset' }
          & Meta_ImageAsset_Fragment
        ) | (
          { __typename?: 'Insurance' }
          & Meta_Insurance_Fragment
        ) | (
          { __typename?: 'LinkForwarder' }
          & Meta_LinkForwarder_Fragment
        ) | (
          { __typename?: 'List' }
          & Meta_List_Fragment
        ) | (
          { __typename?: 'ListItem' }
          & Meta_ListItem_Fragment
        ) | (
          { __typename?: 'LocalizedServiceTitle' }
          & Meta_LocalizedServiceTitle_Fragment
        ) | (
          { __typename?: 'Marquee' }
          & Meta_Marquee_Fragment
        ) | (
          { __typename?: 'Media' }
          & Meta_Media_Fragment
        ) | (
          { __typename?: 'MediaSlider' }
          & Meta_MediaSlider_Fragment
        ) | (
          { __typename?: 'MedicalService' }
          & Meta_MedicalService_Fragment
        ) | (
          { __typename?: 'MeetOurStaff' }
          & Meta_MeetOurStaff_Fragment
        ) | (
          { __typename?: 'MetroLinks' }
          & Meta_MetroLinks_Fragment
        ) | (
          { __typename?: 'MobileButton' }
          & Meta_MobileButton_Fragment
        ) | (
          { __typename?: 'MultiCardV2' }
          & Meta_MultiCardV2_Fragment
        ) | (
          { __typename?: 'NavigationGroup' }
          & Meta_NavigationGroup_Fragment
        ) | (
          { __typename?: 'NavigationLink' }
          & Meta_NavigationLink_Fragment
        ) | (
          { __typename?: 'OdpHero' }
          & Meta_OdpHero_Fragment
        ) | (
          { __typename?: 'Page' }
          & Meta_Page_Fragment
          & BasePageFragment
        ) | (
          { __typename?: 'PageLayout' }
          & Meta_PageLayout_Fragment
        ) | (
          { __typename?: 'PageMeta' }
          & Meta_PageMeta_Fragment
        ) | (
          { __typename?: 'PatientReviewV2' }
          & Meta_PatientReviewV2_Fragment
        ) | (
          { __typename?: 'PatientReviewsV2' }
          & Meta_PatientReviewsV2_Fragment
        ) | (
          { __typename?: 'Procedure' }
          & Meta_Procedure_Fragment
        ) | (
          { __typename?: 'Product' }
          & Meta_Product_Fragment
        ) | (
          { __typename?: 'ProductDisplay' }
          & Meta_ProductDisplay_Fragment
        ) | (
          { __typename?: 'ProductFeature' }
          & Meta_ProductFeature_Fragment
        ) | (
          { __typename?: 'ProductFeatureDescriptionListItem' }
          & Meta_ProductFeatureDescriptionListItem_Fragment
        ) | (
          { __typename?: 'ProgressIndicator' }
          & Meta_ProgressIndicator_Fragment
        ) | (
          { __typename?: 'ProviderDetailsPage' }
          & Meta_ProviderDetailsPage_Fragment
        ) | (
          { __typename?: 'QuestionAnswer' }
          & Meta_QuestionAnswer_Fragment
        ) | (
          { __typename?: 'Questionnaire' }
          & Meta_Questionnaire_Fragment
        ) | (
          { __typename?: 'QuickLinks' }
          & Meta_QuickLinks_Fragment
        ) | (
          { __typename?: 'Quiz' }
          & Meta_Quiz_Fragment
        ) | (
          { __typename?: 'ReviewStep' }
          & Meta_ReviewStep_Fragment
        ) | (
          { __typename?: 'Schema' }
          & Meta_Schema_Fragment
        ) | (
          { __typename?: 'SchemaStep' }
          & Meta_SchemaStep_Fragment
        ) | (
          { __typename?: 'SectionContent' }
          & Meta_SectionContent_Fragment
        ) | (
          { __typename?: 'SegmentsContainer' }
          & Meta_SegmentsContainer_Fragment
        ) | (
          { __typename?: 'Service' }
          & Meta_Service_Fragment
        ) | (
          { __typename?: 'ServiceDetailsPage' }
          & Meta_ServiceDetailsPage_Fragment
          & ServiceDetailsPageBaseFragment
        ) | (
          { __typename?: 'ServiceGroup' }
          & Meta_ServiceGroup_Fragment
        ) | (
          { __typename?: 'ServiceLineHero' }
          & Meta_ServiceLineHero_Fragment
        ) | (
          { __typename?: 'SharedForm' }
          & Meta_SharedForm_Fragment
        ) | (
          { __typename?: 'SharedFormDefinitions' }
          & Meta_SharedFormDefinitions_Fragment
        ) | (
          { __typename?: 'SharedFormField' }
          & Meta_SharedFormField_Fragment
        ) | (
          { __typename?: 'SingleMessage' }
          & Meta_SingleMessage_Fragment
        ) | (
          { __typename?: 'SmallScreenContent' }
          & Meta_SmallScreenContent_Fragment
        ) | (
          { __typename?: 'SmileAssessmentForm' }
          & Meta_SmileAssessmentForm_Fragment
        ) | (
          { __typename?: 'Spacer' }
          & Meta_Spacer_Fragment
        ) | (
          { __typename?: 'StateLinks' }
          & Meta_StateLinks_Fragment
        ) | (
          { __typename?: 'Stepper' }
          & Meta_Stepper_Fragment
        ) | (
          { __typename?: 'SuccessCard' }
          & Meta_SuccessCard_Fragment
        ) | (
          { __typename?: 'Tab' }
          & Meta_Tab_Fragment
        ) | (
          { __typename?: 'Table' }
          & Meta_Table_Fragment
        ) | (
          { __typename?: 'Tabs' }
          & Meta_Tabs_Fragment
        ) | (
          { __typename?: 'TermsAndConditions' }
          & Meta_TermsAndConditions_Fragment
        ) | (
          { __typename?: 'TextBlockSeo' }
          & Meta_TextBlockSeo_Fragment
        ) | (
          { __typename?: 'TextHighlight' }
          & Meta_TextHighlight_Fragment
        ) | (
          { __typename?: 'TriggeredContentModal' }
          & Meta_TriggeredContentModal_Fragment
        ) | (
          { __typename?: 'Video' }
          & Meta_Video_Fragment
        ) | (
          { __typename?: 'VideoAsset' }
          & Meta_VideoAsset_Fragment
        ) | (
          { __typename?: 'VideoCarousel' }
          & Meta_VideoCarousel_Fragment
        ) | (
          { __typename?: 'VideoWithContent' }
          & Meta_VideoWithContent_Fragment
        ) | null> } } } | null, tc?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null }
  & Meta_Service_Fragment
);

export type SegmentContainerEntryLinksFragment = (
  { __typename?: 'SegmentsContainer', contentsCollection?: { __typename?: 'SegmentsContainerContentsCollection', items: Array<(
      { __typename?: 'ContentTypeRichText' }
      & ContentTypeRichTextEntryLinksFragment
    ) | { __typename?: 'DisclaimerV2' } | (
      { __typename?: 'HalfScreen' }
      & HalfScreenEntryLinksFragment
    ) | (
      { __typename?: 'HeroV2' }
      & HeroV2EntryLinksFragment
    ) | { __typename?: 'Marquee' } | (
      { __typename?: 'MultiCardV2' }
      & MulticardV2EntryLinksFragment
    ) | (
      { __typename?: 'OdpHero' }
      & OdpHeroEntryLinksFragment
    ) | { __typename?: 'ServiceLineHero' } | (
      { __typename?: 'SingleMessage' }
      & SingleMessageEntryLinksFragment
    ) | null> } | null }
  & Meta_SegmentsContainer_Fragment
);

export type ProductFeatureEntryLinksFragment = (
  { __typename?: 'ProductFeature', descriptionRichText?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null, descriptionListCollection?: { __typename?: 'ProductFeatureDescriptionListCollection', items: Array<(
      { __typename?: 'ProductFeatureDescriptionListItem', content?: (
        { __typename?: 'ContentTypeRichText' }
        & ContentTypeRichTextEntryLinksFragment
      ) | null }
      & Meta_ProductFeatureDescriptionListItem_Fragment
    ) | null> } | null }
  & Meta_ProductFeature_Fragment
);

export type AgendaStepperEntryLinksFragment = (
  { __typename?: 'AgendaStepper', description?: (
    { __typename?: 'ContentTypeRichText' }
    & ContentTypeRichTextEntryLinksFragment
  ) | null, stepsCollection?: { __typename?: 'AgendaStepperStepsCollection', items: Array<(
      { __typename?: 'AgendaModal', bodyText?: (
        { __typename?: 'ContentTypeRichText' }
        & ContentTypeRichTextEntryLinksFragment
      ) | null }
      & Meta_AgendaModal_Fragment
    ) | null> } | null }
  & Meta_AgendaStepper_Fragment
);

export type TabsEntryLinksFragment = (
  { __typename?: 'Tabs', name?: string | null, tabsCollection?: { __typename?: 'TabsTabsCollection', items: Array<(
      { __typename?: 'Tab', content?: (
        { __typename?: 'Accordions' }
        & AccordionsEntryLinksFragment
        & Meta_Accordions_Fragment
      ) | (
        { __typename?: 'HalfScreen' }
        & HalfScreenEntryLinksFragment
        & Meta_HalfScreen_Fragment
      ) | (
        { __typename?: 'MultiCardV2' }
        & MulticardV2EntryLinksFragment
        & Meta_MultiCardV2_Fragment
      ) | (
        { __typename?: 'ServiceLineHero' }
        & ServiceLineHeroEntryLinksFragment
        & Meta_ServiceLineHero_Fragment
      ) | (
        { __typename?: 'SingleMessage' }
        & SingleMessageEntryLinksFragment
        & Meta_SingleMessage_Fragment
      ) | null }
      & Meta_Tab_Fragment
    ) | null> } | null }
  & Meta_Tabs_Fragment
);

export type HeroV2EntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HeroV2EntryLinksByIdQuery = { __typename?: 'Query', heroV2?: (
    { __typename?: 'HeroV2' }
    & HeroV2EntryLinksFragment
  ) | null };

export type SingleMessageEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SingleMessageEntryLinksByIdQuery = { __typename?: 'Query', singleMessage?: (
    { __typename?: 'SingleMessage' }
    & SingleMessageEntryLinksFragment
  ) | null };

export type MultiCardV2EntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MultiCardV2EntryLinksByIdQuery = { __typename?: 'Query', multiCardV2?: (
    { __typename?: 'MultiCardV2' }
    & MulticardV2EntryLinksFragment
  ) | null };

export type TextBlockSeoEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TextBlockSeoEntryLinksByIdQuery = { __typename?: 'Query', textBlockSeo?: (
    { __typename?: 'TextBlockSeo' }
    & TextBlockSeoEntryLinksFragment
  ) | null };

export type TermsAndConditionsEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TermsAndConditionsEntryLinksByIdQuery = { __typename?: 'Query', termsAndConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermsAndConditionsEntryLinksFragment
  ) | null };

export type AccordionsEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccordionsEntryLinksByIdQuery = { __typename?: 'Query', accordions?: (
    { __typename?: 'Accordions' }
    & AccordionsEntryLinksFragment
  ) | null };

export type HalfScreenEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HalfScreenEntryLinksByIdQuery = { __typename?: 'Query', halfScreen?: (
    { __typename?: 'HalfScreen' }
    & HalfScreenEntryLinksFragment
  ) | null };

export type DisclaimerV2EntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DisclaimerV2EntryLinksByIdQuery = { __typename?: 'Query', disclaimerV2?: (
    { __typename?: 'DisclaimerV2' }
    & DisclaimerV2EntryLinksFragment
  ) | null };

export type InsuranceEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsuranceEntryLinksByIdQuery = { __typename?: 'Query', insurance?: (
    { __typename?: 'Insurance' }
    & InsuranceEntryLinksFragment
  ) | null };

export type CategoryPickerEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CategoryPickerEntryLinksByIdQuery = { __typename?: 'Query', categoryPicker?: (
    { __typename?: 'CategoryPicker' }
    & CategoryPickerEntryLinksFragment
  ) | null };

export type ColumnsEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ColumnsEntryLinksByIdQuery = { __typename?: 'Query', columns?: (
    { __typename?: 'Columns' }
    & ColumnsEntryLinksFragment
  ) | null };

export type ServiceLineHeroEntryLinksQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceLineHeroEntryLinksQuery = { __typename?: 'Query', serviceLineHero?: (
    { __typename?: 'ServiceLineHero' }
    & ServiceLineHeroEntryLinksFragment
  ) | null };

export type OdpHeroEntryLinksQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OdpHeroEntryLinksQuery = { __typename?: 'Query', odpHero?: (
    { __typename?: 'OdpHero' }
    & OdpHeroEntryLinksFragment
  ) | null };

export type QuickLinksEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuickLinksEntryLinksByIdQuery = { __typename?: 'Query', quickLinks?: (
    { __typename?: 'QuickLinks' }
    & QuickLinksEntryLinksFragment
  ) | null };

export type ServiceEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceEntryLinksByIdQuery = { __typename?: 'Query', service?: (
    { __typename?: 'Service' }
    & ServiceEntryLinksFragment
  ) | null };

export type SegmentContainerLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SegmentContainerLinksByIdQuery = { __typename?: 'Query', segmentsContainer?: (
    { __typename?: 'SegmentsContainer' }
    & SegmentContainerEntryLinksFragment
  ) | null };

export type ProductFeatureEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductFeatureEntryLinksByIdQuery = { __typename?: 'Query', productFeature?: (
    { __typename?: 'ProductFeature' }
    & ProductFeatureEntryLinksFragment
  ) | null };

export type AgendaStepperEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AgendaStepperEntryLinksByIdQuery = { __typename?: 'Query', agendaStepper?: (
    { __typename?: 'AgendaStepper' }
    & AgendaStepperEntryLinksFragment
  ) | null };

export type TabsEntryLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TabsEntryLinksByIdQuery = { __typename?: 'Query', tabs?: (
    { __typename?: 'Tabs' }
    & TabsEntryLinksFragment
  ) | null };

export type SchemaByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SchemaByIdQuery = { __typename?: 'Query', schema?: (
    { __typename?: 'Schema' }
    & SchemaFragment
  ) | null };

export type SegmentsContainerByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SegmentsContainerByIdQuery = { __typename?: 'Query', segmentsContainer?: (
    { __typename?: 'SegmentsContainer' }
    & SegmentsContainerFragment
  ) | null };

export type ServiceByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceByIdQuery = { __typename?: 'Query', service?: (
    { __typename?: 'Service' }
    & ServiceFragment
  ) | null };

export type ServiceDetailsPageByIdAndPathQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  path: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceDetailsPageByIdAndPathQuery = { __typename?: 'Query', serviceDetailsPageCollection?: { __typename?: 'ServiceDetailsPageCollection', items: Array<{ __typename?: 'ServiceDetailsPage', path?: string | null, title?: string | null, indexed?: boolean | null, description?: string | null, canonical?: string | null, textSeo?: { __typename?: 'ServiceDetailsPageTextSeo', json: any } | null, moreTextSeo?: { __typename?: 'ServiceDetailsPageMoreTextSeo', json: any } | null, ogImage?: { __typename?: 'ImageAsset', desktopImage?: any | null } | null, analyticsContext?: { __typename?: 'AnalyticsContext', sys: { __typename?: 'Sys', id: string } } | null, contentsCollection?: { __typename?: 'ServiceDetailsPageContentsCollection', items: Array<{ __typename: 'Accordions', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BirdEyeReviews', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogList', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategoryPicker', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Columns', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ContentTypeRichText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'DisclaimerV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'GoogleMapTemplate', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HalfScreen', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Marquee', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MeetOurStaff', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiCardV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'OdpHero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'PatientReviewsV2', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductDisplay', sys: { __typename?: 'Sys', id: string } } | { __typename: 'QuickLinks', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Schema', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SegmentsContainer', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ServiceLineHero', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SingleMessage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Spacer', sys: { __typename?: 'Sys', id: string } } | null> } | null } | null> } | null };

export type ServiceLineHeroByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceLineHeroByIdQuery = { __typename?: 'Query', serviceLineHero?: (
    { __typename?: 'ServiceLineHero' }
    & ServiceLineHeroFragment
  ) | null };

export type SingleMessageByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SingleMessageByIdQuery = { __typename?: 'Query', singleMessage?: (
    { __typename?: 'SingleMessage' }
    & SingleMessageFragment
  ) | null };

export type SitemapPagesFragment = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', path?: string | null, indexed?: boolean | null, sys: { __typename?: 'Sys', publishedAt?: any | null } } | null> } | null };

export type SitemapPagesQueryVariables = Exact<{
  appName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  indexed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitemapPagesQuery = (
  { __typename?: 'Query' }
  & SitemapPagesFragment
);

export type SmileAssessmentFormByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SmileAssessmentFormByIdQuery = { __typename?: 'Query', smileAssessmentForm?: { __typename?: 'SmileAssessmentForm', formContent?: { __typename?: 'Questionnaire', buttonText?: string | null, buttonUrl?: string | null, defaultErrorMessage?: string | null, formCollection?: { __typename?: 'QuestionnaireFormCollection', items: Array<{ __typename?: 'FormDropdownField' } | { __typename?: 'FormField' } | { __typename?: 'SectionContent', title?: string | null, type?: string | null, aditionalReferencesCollection?: { __typename?: 'SectionContentAditionalReferencesCollection', items: Array<{ __typename?: 'Accordions' } | { __typename?: 'AdFooter' } | { __typename?: 'AgendaModal' } | { __typename?: 'AgendaStepper' } | { __typename?: 'AnalyticsContext' } | { __typename?: 'App' } | { __typename?: 'AppCopySlot' } | { __typename?: 'AppFaq' } | { __typename?: 'AppLegalDocument' } | { __typename?: 'AppMediaSlot' } | { __typename?: 'AppOffer' } | { __typename?: 'AppReachYouCard' } | { __typename?: 'AppTip' } | { __typename?: 'AppTreatmentInfo' } | { __typename?: 'AppViewCopy' } | { __typename?: 'AppointmentBookingPage' } | { __typename?: 'Badge' } | { __typename?: 'Banner' } | { __typename?: 'BirdEyeReviews' } | { __typename?: 'BlogAuthor' } | { __typename?: 'BlogCategory' } | { __typename?: 'BlogDetailsPage' } | { __typename?: 'BlogList' } | { __typename?: 'BlogListPage' } | { __typename?: 'BlogSubCategory' } | { __typename?: 'BodyText' } | { __typename?: 'Brand' } | { __typename?: 'Button' } | { __typename?: 'Card' } | { __typename?: 'Carousel' } | { __typename?: 'Category' } | { __typename?: 'CategoryPicker' } | { __typename?: 'CityLinks' } | { __typename?: 'Columns' } | { __typename?: 'ConfirmationStep' } | { __typename?: 'ContentData' } | { __typename?: 'ContentSection' } | { __typename?: 'ContentTile' } | { __typename?: 'ContentTypeRichText' } | { __typename?: 'ConvertFlowCta' } | { __typename?: 'ConvertFlowQuiz' } | { __typename?: 'DisclaimerV2' } | { __typename?: 'Error404' } | { __typename?: 'Experience' } | { __typename?: 'ExperimentContainer' } | { __typename?: 'ExperimentVariationContentsItem' } | { __typename?: 'ExperimentalModal' } | { __typename?: 'FacilityDetailsPage' } | { __typename?: 'FaqAccordion' } | { __typename?: 'FeatureFlags' } | { __typename?: 'FocalPointImage' } | { __typename?: 'FooterNavigationGroup' } | { __typename?: 'FormDropdownField', title?: string | null, clearTextItem?: string | null, itemList?: Array<string | null> | null, apiKey?: string | null, required?: boolean | null } | { __typename?: 'FormField', title?: string | null, required?: boolean | null, onSubmitFormUrl?: string | null, alertMessage?: string | null, type?: string | null, label?: string | null, placeholder?: string | null, apiKey?: string | null, image?: { __typename?: 'Asset', url?: string | null } | null } | { __typename?: 'GoogleMapTemplate' } | { __typename?: 'HalfScreen' } | { __typename?: 'Header' } | { __typename?: 'HeaderMainNav' } | { __typename?: 'HeaderNavMenu' } | { __typename?: 'HeaderSubNav' } | { __typename?: 'Heading' } | { __typename?: 'HeroV2' } | { __typename?: 'Icon' } | { __typename?: 'Iframe' } | { __typename?: 'ImageAsset' } | { __typename?: 'Insurance' } | { __typename?: 'LinkForwarder' } | { __typename?: 'List' } | { __typename?: 'ListItem' } | { __typename?: 'LocalizedServiceTitle' } | { __typename?: 'Marquee' } | { __typename?: 'Media' } | { __typename?: 'MediaSlider' } | { __typename?: 'MedicalService' } | { __typename?: 'MeetOurStaff' } | { __typename?: 'MetroLinks' } | { __typename?: 'MobileButton' } | { __typename?: 'MultiCardV2' } | { __typename?: 'NavigationGroup' } | { __typename?: 'NavigationLink' } | { __typename?: 'OdpHero' } | { __typename?: 'Page' } | { __typename?: 'PageLayout' } | { __typename?: 'PageMeta' } | { __typename?: 'PatientReviewV2' } | { __typename?: 'PatientReviewsV2' } | { __typename?: 'Procedure' } | { __typename?: 'Product' } | { __typename?: 'ProductDisplay' } | { __typename?: 'ProductFeature' } | { __typename?: 'ProductFeatureDescriptionListItem' } | { __typename?: 'ProgressIndicator' } | { __typename?: 'ProviderDetailsPage' } | { __typename?: 'QuestionAnswer' } | { __typename?: 'Questionnaire' } | { __typename?: 'QuickLinks' } | { __typename?: 'Quiz' } | { __typename?: 'ReviewStep' } | { __typename?: 'Schema' } | { __typename?: 'SchemaStep' } | { __typename?: 'SectionContent' } | { __typename?: 'SegmentsContainer' } | { __typename?: 'Service' } | { __typename?: 'ServiceDetailsPage' } | { __typename?: 'ServiceGroup' } | { __typename?: 'ServiceLineHero' } | { __typename?: 'SharedForm' } | { __typename?: 'SharedFormDefinitions' } | { __typename?: 'SharedFormField' } | { __typename?: 'SingleMessage' } | { __typename?: 'SmallScreenContent' } | { __typename?: 'SmileAssessmentForm' } | { __typename?: 'Spacer' } | { __typename?: 'StateLinks' } | { __typename?: 'Stepper' } | { __typename?: 'SuccessCard' } | { __typename?: 'Tab' } | { __typename?: 'Table' } | { __typename?: 'Tabs' } | { __typename?: 'TermsAndConditions' } | { __typename?: 'TextBlockSeo' } | { __typename?: 'TextHighlight' } | { __typename?: 'TriggeredContentModal' } | { __typename?: 'Video' } | { __typename?: 'VideoAsset' } | { __typename?: 'VideoCarousel' } | { __typename?: 'VideoWithContent' } | null> } | null } | null> } | null } | null } | null };

export type SpacerByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SpacerByIdQuery = { __typename?: 'Query', spacer?: (
    { __typename?: 'Spacer' }
    & SpacerFragment
  ) | null };

export type StateLinksByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StateLinksByIdQuery = { __typename?: 'Query', stateLinks?: (
    { __typename?: 'StateLinks', name?: string | null }
    & Meta_StateLinks_Fragment
  ) | null };

export type TableByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TableByIdQuery = { __typename?: 'Query', table?: (
    { __typename?: 'Table' }
    & TableFragment
  ) | null };

export type TabsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TabsByIdQuery = { __typename?: 'Query', tabs?: (
    { __typename?: 'Tabs' }
    & TabsFragment
  ) | null };

export type TermsAndConditionsByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TermsAndConditionsByIdQuery = { __typename?: 'Query', termsAndConditions?: (
    { __typename?: 'TermsAndConditions' }
    & TermOfConditionsFragment
  ) | null };

export type TextBlockSeoByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TextBlockSeoByIdQuery = { __typename?: 'Query', textBlockSeo?: (
    { __typename?: 'TextBlockSeo' }
    & TextBlockSeoFragment
  ) | null };

export type VideoCarouselByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VideoCarouselByIdQuery = { __typename?: 'Query', videoCarousel?: (
    { __typename?: 'VideoCarousel', backgroundColor?: string | null, desktopVideosAspectRatio?: string | null, mobileVideosAspectRatio?: string | null, anchorId?: string | null, topFields?: (
      { __typename?: 'ContentSection' }
      & ContentSectionFragment
    ) | null, videosCollection?: { __typename?: 'VideoCarouselVideosCollection', skip: number, total: number, items: Array<(
        { __typename?: 'VideoWithContent', content?: (
          { __typename?: 'ContentSection' }
          & ContentSectionFragment
        ) | null, video?: (
          { __typename?: 'VideoAsset' }
          & VideoAssetFragment
        ) | null, buttonsCollection?: { __typename?: 'VideoWithContentButtonsCollection', items: Array<(
            { __typename?: 'Button' }
            & ButtonFragment
          ) | null> } | null }
        & Meta_VideoWithContent_Fragment
      ) | null> } | null, buttonsCollection?: { __typename?: 'VideoCarouselButtonsCollection', items: Array<(
        { __typename?: 'Button' }
        & ButtonFragment
      ) | null> } | null }
    & Meta_VideoCarousel_Fragment
  ) | null };

export const MetaFragmentDoc = gql`
    fragment Meta on Entry {
  __typename
  sys {
    id
  }
}
    `;
export const MobileButtonFragmentDoc = gql`
    fragment MobileButton on MobileButton {
  ...Meta
  name
  label
  variant
  size
  icon
  iconPosition
}
    `;
export const AnalyticsFragmentDoc = gql`
    fragment Analytics on AnalyticsContext {
  brand
  event
  pageUrl
  pageName
  linkUrl
  linkText
  clickName
  clickPosition
  siteSection
  virtualPageUrl
  virtualPageTitle
  appointmentSelectedFacilityId
  appointmentSelectedFacilityName
}
    `;
export const EnrichedMetaFragmentDoc = gql`
    fragment EnrichedMeta on Entry {
  __typename
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
    }
  }
}
    `;
export const CommonAssetFragmentDoc = gql`
    fragment CommonAsset on Asset {
  __typename
  sys {
    id
    spaceId
    environmentId
  }
  contentfulMetadata {
    tags {
      name
      id
    }
  }
  title
  description
  fileName
  contentType
  size
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on Asset {
  ...CommonAsset
  url(
    transform: {resizeStrategy: FILL, resizeFocus: FACE, backgroundColor: "rgb:321032", format: WEBP, quality: 90}
  )
  width
  height
}
    `;
export const BasePageFragmentDoc = gql`
    fragment BasePage on Page {
  ...EnrichedMeta
  path
  title
  breadcrumbTitle
  description
  image {
    ...Image
  }
}
    `;
export const NavLinkFragmentDoc = gql`
    fragment NavLink on NavigationLink {
  ...EnrichedMeta
  externalUrl
  linkText
  openInNewTab
  openInNewWindow
  isInternal
  linkIcon {
    ...Image
  }
  pageData {
    ... on Page {
      ...BasePage
    }
    ... on BlogDetailsPage {
      ...Meta
      path
    }
    ... on ServiceDetailsPage {
      ...Meta
      path
    }
    ... on FacilityDetailsPage {
      ...Meta
      path
    }
  }
  analyticsContext {
    ...Analytics
  }
}
    `;
export const QuizFragmentDoc = gql`
    fragment Quiz on Quiz {
  ...Meta
  submitEndpointUrl
  quizFormData
  quizType
  isFormBuilder
  formBuilderConfig
  clearChoicePoorCreditRedirectPath
}
    `;
export const IframeFragmentDoc = gql`
    fragment Iframe on Iframe {
  ...Meta
  title
  url
  height
  rawHtml
}
    `;
export const ButtonFragmentDoc = gql`
    fragment Button on Button {
  ...Meta
  name
  label
  variant
  buttonLink
  size
  icon
  iconPosition
  iconSize
  mobileButton {
    ... on MobileButton {
      ...MobileButton
    }
  }
  analyticsContext {
    ...Analytics
  }
  navigationDetails {
    ... on NavigationLink {
      ...NavLink
    }
  }
  launchCrestaAgent
  quizDetails {
    ...Quiz
  }
  popoverContentCollection {
    items {
      ... on Iframe {
        ...Iframe
      }
      ... on MultiCardV2 {
        ...Meta
        display
        sectionEyebrow
        backgroundColor
        sectionInfoAlignment
        sectionTitle
        sectionTitleHtag
        variant
        simpleCard {
          json
        }
        simpleCardTwo {
          json
        }
        simpleCardThree {
          json
        }
      }
    }
  }
}
    `;
export const RichTextFragmentDoc = gql`
    fragment RichText on ContentTypeRichText {
  ...Meta
  fullWidth
  disablePaddingOn
  backgroundColor
  display
  centerAlign
  contained
  titleHeading
  title
  titleIcon
  contentMaxWidth
  facilitySegmentCollection
  id
  content {
    json
  }
  secondaryContent {
    json
  }
  buttonsCollection(limit: 2) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
}
    `;
export const AgendaModalFragmentDoc = gql`
    fragment AgendaModal on AgendaModal {
  ...Meta
  headlineText
  headlineHeading
  bodyText {
    ... on ContentTypeRichText {
      ...RichText
    }
  }
  icon
}
    `;
export const BrandFragmentDoc = gql`
    fragment Brand on Brand {
  ...Meta
  name
  title
}
    `;
export const LinkMetaFragmentDoc = gql`
    fragment LinkMeta on Asset {
  __typename
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
}
    `;
export const BlogDetailsPageSummaryAssetsFragmentDoc = gql`
    fragment BlogDetailsPageSummaryAssets on BlogDetailsPageSummaryAssets {
  block {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
  hyperlink {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
}
    `;
export const BlogDetailsPageSummaryEntriesFragmentDoc = gql`
    fragment BlogDetailsPageSummaryEntries on BlogDetailsPageSummaryEntries {
  inline {
    ...EnrichedMeta
    ...BasePage
  }
  block {
    ...EnrichedMeta
    ...BasePage
  }
  hyperlink {
    ...EnrichedMeta
    ...BasePage
  }
}
    `;
export const ResourceMetaFragmentDoc = gql`
    fragment ResourceMeta on ResourceLink {
  sys {
    urn
    linkType
  }
}
    `;
export const BlogDetailsPageSummaryResourcesFragmentDoc = gql`
    fragment BlogDetailsPageSummaryResources on BlogDetailsPageSummaryResources {
  block {
    ...ResourceMeta
  }
  inline {
    ...ResourceMeta
  }
  hyperlink {
    ...ResourceMeta
  }
}
    `;
export const BlogDetailsPageSummaryFragmentDoc = gql`
    fragment BlogDetailsPageSummary on BlogDetailsPageSummary {
  json
  links {
    assets {
      ...BlogDetailsPageSummaryAssets
    }
    entries {
      ...BlogDetailsPageSummaryEntries
    }
    resources {
      ...BlogDetailsPageSummaryResources
    }
  }
}
    `;
export const BlogCategoryFragmentDoc = gql`
    fragment BlogCategory on BlogCategory {
  ...Meta
  name
  slug
}
    `;
export const BlogSubCategoryFragmentDoc = gql`
    fragment BlogSubCategory on BlogSubCategory {
  ...Meta
  name
  slug
}
    `;
export const BlogDetailsPageTextAssetsFragmentDoc = gql`
    fragment BlogDetailsPageTextAssets on BlogDetailsPageTextAssets {
  block {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
  hyperlink {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
}
    `;
export const TableFragmentDoc = gql`
    fragment Table on Table {
  ...Meta
  variant
  fontSize
  border
  firstColumnSticky
  titleHtag
  title
  descriptionRichText {
    json
  }
  tableContent {
    json
    links {
      entries {
        inline {
          ... on Card {
            ...Meta
            image {
              ...CommonAsset
              url
            }
          }
        }
      }
    }
  }
  footnote {
    json
  }
  tableJsonData
  tableJsonDataMobile
  anchorId
}
    `;
export const VideoFragmentDoc = gql`
    fragment Video on Video {
  ...Meta
  media {
    ...CommonAsset
    url
    __typename
  }
  autoPlay
  isMuted
  isLooped
  posterUrl
  posterMedia {
    ...CommonAsset
    url
  }
  __typename
  youtubeId
  useOriginalVideoSize
  videoSource
  hlsVideoStreamLink
}
    `;
export const VideoAssetFragmentDoc = gql`
    fragment VideoAsset on VideoAsset {
  ...Meta
  desktopVideo {
    ...Video
  }
  mobileVideo {
    ...Video
  }
}
    `;
export const FocalPointImageFragmentDoc = gql`
    fragment FocalPointImage on FocalPointImage {
  ...Meta
  image {
    ...Image
  }
  focalPoint
}
    `;
export const SmallScreenContentFragmentDoc = gql`
    fragment SmallScreenContent on SmallScreenContent {
  eyebrowSmallScreen
  headingSmallScreen {
    json
  }
  bodySmallScreen {
    json
  }
  imageSmallScreen {
    ...Image
  }
  focalPointImageSmallScreen {
    ...FocalPointImage
  }
  controllableVideo {
    ...Video
  }
  videoSmallScreen {
    ...CommonAsset
    url
  }
  mediaFirst
}
    `;
export const TermOfConditionsFragmentDoc = gql`
    fragment TermOfConditions on TermsAndConditions {
  ...Meta
  showTcTextAs
  tcText
  tcLink
  headlineText
  content {
    json
  }
}
    `;
export const ImageAssetFragmentDoc = gql`
    fragment ImageAsset on ImageAsset {
  ...Meta
  desktopImage
  mobileImage
}
    `;
export const SingleMessageFragmentDoc = gql`
    fragment SingleMessage on SingleMessage {
  ...Meta
  backgroundColor
  display
  focalPointImage {
    ...FocalPointImage
  }
  buttonsCollection(limit: 2) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  buttonSize
  buttonText
  buttonType
  buttonUrl
  description
  disablePaddingOn
  eyebrow
  icon
  iconSize
  name
  subText
  templateWidth
  templateHeight
  title
  titleAlign
  titleVariant
  facilitySegmentCollection
  isBannerImage
  contentFillVerticalSpace
  content {
    json
  }
  contentSmallScreen {
    ...SmallScreenContent
  }
  tc {
    ...TermOfConditions
  }
  contentAlign
  imageAsset {
    ...ImageAsset
  }
  imageLeftSide {
    ...ImageAsset
  }
  imageRightSide {
    ...ImageAsset
  }
  isHeaderAboveSideImages
  isInlineLayout
  displayTitleInline
  useRoundedCorners
  showSubscriptionForm
  anchorId
  variant
}
    `;
export const AccordionFragmentDoc = gql`
    fragment Accordion on Accordions {
  ...Meta
  title
  titleHtag
  titleColor
  descriptionRichText {
    json
  }
  centerAlign
  fullWidth
  disablePaddingOn
  imagePositionRight
  imageRoundedCorner
  titleAlignment
  descriptionAlignment
  image {
    ...FocalPointImage
  }
  backgroundColor
  backgroundImage {
    ...Image
  }
  accordionsCollection(limit: 20) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
      ... on AgendaStepper {
        ...Meta
      }
    }
  }
  buttonsCollection(limit: 2) {
    items {
      ...Button
    }
  }
  expandIconType
  expandIconPosition
  roundedCornersSize
  withInnerGap
  anchorId
  allowMultipleExpanded
  defaultExpanded
}
    `;
export const ColumnsFragmentDoc = gql`
    fragment Columns on Columns {
  ...Meta
  eyebrow
  title
  titleHtag
  description
  fullWidth
  disablePaddingOn
  backgroundColor
  allowEqualHeights
  anchorId
  columnsCollection(limit: 5) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
      ... on SingleMessage {
        ...SingleMessage
      }
      ... on Accordions {
        ...Accordion
      }
      ... on ImageAsset {
        ...ImageAsset
      }
    }
  }
}
    `;
export const BlogDetailsPageBaseFragmentDoc = gql`
    fragment BlogDetailsPageBase on BlogDetailsPage {
  ...Meta
  path
}
    `;
export const ServiceDetailsPageBaseFragmentDoc = gql`
    fragment ServiceDetailsPageBase on ServiceDetailsPage {
  ...Meta
  path
}
    `;
export const FacilityDetailsPageBaseFragmentDoc = gql`
    fragment FacilityDetailsPageBase on FacilityDetailsPage {
  ...Meta
  path
}
    `;
export const BlogDetailsPageTextEntriesFragmentDoc = gql`
    fragment BlogDetailsPageTextEntries on BlogDetailsPageTextEntries {
  inline {
    ...EnrichedMeta
    ...BasePage
  }
  block {
    ...EnrichedMeta
    ...BasePage
    ...Table
    ...VideoAsset
    ...Columns
    ...SingleMessage
  }
  hyperlink {
    ...EnrichedMeta
    ...BasePage
    ...BlogDetailsPageBase
    ...ServiceDetailsPageBase
    ...FacilityDetailsPageBase
  }
}
    `;
export const BlogDetailsPageTextResourcesFragmentDoc = gql`
    fragment BlogDetailsPageTextResources on BlogDetailsPageTextResources {
  block {
    ...ResourceMeta
  }
  inline {
    ...ResourceMeta
  }
  hyperlink {
    ...ResourceMeta
  }
}
    `;
export const BlogDetailsPageTextFragmentDoc = gql`
    fragment BlogDetailsPageText on BlogDetailsPageText {
  json
  links {
    assets {
      ...BlogDetailsPageTextAssets
    }
    entries {
      ...BlogDetailsPageTextEntries
    }
    resources {
      ...BlogDetailsPageTextResources
    }
  }
}
    `;
export const BlogAuthorAuthorBioSummaryAssetsFragmentDoc = gql`
    fragment BlogAuthorAuthorBioSummaryAssets on BlogAuthorAuthorBioSummaryAssets {
  block {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
  hyperlink {
    ...LinkMeta
    contentType
    url
    description
    fileName
  }
}
    `;
export const BlogAuthorAuthorBioSummaryEntriesFragmentDoc = gql`
    fragment BlogAuthorAuthorBioSummaryEntries on BlogAuthorAuthorBioSummaryEntries {
  inline {
    ...EnrichedMeta
    ...BasePage
  }
  block {
    ...EnrichedMeta
    ...BasePage
  }
  hyperlink {
    ...EnrichedMeta
    ...BasePage
  }
}
    `;
export const BlogAuthorAuthorBioSummaryResourcesFragmentDoc = gql`
    fragment BlogAuthorAuthorBioSummaryResources on BlogAuthorAuthorBioSummaryResources {
  block {
    ...ResourceMeta
  }
  inline {
    ...ResourceMeta
  }
  hyperlink {
    ...ResourceMeta
  }
}
    `;
export const BlogAuthorAuthorBioSummaryFragmentDoc = gql`
    fragment BlogAuthorAuthorBioSummary on BlogAuthorAuthorBioSummary {
  json
  links {
    assets {
      ...BlogAuthorAuthorBioSummaryAssets
    }
    entries {
      ...BlogAuthorAuthorBioSummaryEntries
    }
    resources {
      ...BlogAuthorAuthorBioSummaryResources
    }
  }
}
    `;
export const BlogAuthorFragmentDoc = gql`
    fragment BlogAuthor on BlogAuthor {
  ...Meta
  title
  name
  image
  moreAboutTheAuthorPagePath
  authorBioSummary {
    ...BlogAuthorAuthorBioSummary
  }
}
    `;
export const ContentSectionFragmentDoc = gql`
    fragment ContentSection on ContentSection {
  ...Meta
  eyebrow
  eyebrowHtag
  title
  titleHtag
  description {
    json
  }
  alignment
  titleIcon
}
    `;
export const BlogDetailsPageFragmentDoc = gql`
    fragment BlogDetailsPage on BlogDetailsPage {
  ...Meta
  name
  brand {
    ...Brand
  }
  path
  metaTitle
  metaDescription
  canonical
  indexed
  pageDesignType
  heroBackgroundColor
  date
  title
  tags
  summary {
    ...BlogDetailsPageSummary
  }
  category {
    ...BlogCategory
  }
  subCategory {
    ...BlogSubCategory
  }
  text {
    ...BlogDetailsPageText
  }
  blogImage
  timeToRead
  author {
    ...BlogAuthor
  }
  reviewer {
    ...BlogAuthor
  }
  imageAsset {
    ...ImageAsset
  }
  disableStickyFooterOnDesktop
  disableStickyFooterOnMobile
  disableHeaderTopAlertBanner
  disableHeaderBottomAlertBanner
  heroContentTitle {
    json
  }
  heroContentCollection(limit: 3) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
    }
  }
  heroButtonCollection(limit: 1) {
    items {
      ...Button
    }
  }
  relatedBlogsContentSection {
    ...ContentSection
  }
  additionalContentCollection(limit: 2) {
    items {
      ... on SingleMessage {
        ...SingleMessage
      }
      ... on Accordions {
        ...Accordion
      }
    }
  }
}
    `;
export const HeroBlogDetailsPageListFragmentDoc = gql`
    fragment HeroBlogDetailsPageList on BlogDetailsPage {
  ...Meta
  title
  path
  summary {
    json
  }
  blogImage
  imageAsset {
    ...ImageAsset
  }
}
    `;
export const FeaturedBlogDetailsPageListFragmentDoc = gql`
    fragment FeaturedBlogDetailsPageList on BlogDetailsPage {
  ...Meta
  title
  date
  path
  tags
  summary {
    json
  }
  timeToRead
  blogImage
  imageAsset {
    ...ImageAsset
  }
  category {
    ...BlogCategory
  }
  subCategory {
    ...BlogSubCategory
  }
}
    `;
export const BlogListFragmentDoc = gql`
    fragment BlogList on BlogList {
  ...Meta
  title
  category {
    ...BlogCategory
  }
  subCategory {
    ...BlogSubCategory
  }
  displayType
  tagsFilter
  brand {
    ...Brand
  }
  buttonLabel
  loadMoreButtonLabel
  heroBlogsListCollection(limit: 4) {
    items {
      ...HeroBlogDetailsPageList
    }
  }
  featuredBlogsListCollection(limit: 4) {
    items {
      ...FeaturedBlogDetailsPageList
    }
  }
  countAcrossDesktop
  countAcrossMobile
  hasPagination
  cardDesignType
  variant
}
    `;
export const BlogListPageFragmentDoc = gql`
    fragment BlogListPage on BlogListPage {
  ...Meta
  metaTitle
  metaDescription
  canonical
  indexed
  brand {
    ...Brand
  }
  title
  tags
  blogList {
    ...BlogList
  }
  disableStickyFooterOnDesktop
  disableStickyFooterOnMobile
  disableHeaderTopAlertBanner
  disableHeaderBottomAlertBanner
  description {
    json
  }
  contentListCollection(limit: 1) {
    items {
      ... on BlogList {
        ...BlogList
      }
    }
  }
  contentAfterListCollection(limit: 1) {
    items {
      ... on SingleMessage {
        ...SingleMessage
      }
    }
  }
  shouldDisplayCategoryFilterChips
  variant
}
    `;
export const CategoryPickerFragmentDoc = gql`
    fragment CategoryPicker on CategoryPicker {
  ...Meta
  categoriesCollection(limit: 12) {
    items {
      icon
      title
      link
      imageAsset {
        ...ImageAsset
      }
    }
  }
  bodyCopy: description {
    ... on ContentTypeRichText {
      ...RichText
    }
  }
  eyebrow
  eyebrowHeading
  mobileThreshold
  title
  titleHeading
  setTwoRows
  buttonsCollection(limit: 2) {
    items {
      ...Button
    }
  }
  anchorId
  variant
}
    `;
export const ConvertFlowCtaFragmentDoc = gql`
    fragment ConvertFlowCta on ConvertFlowCta {
  ...Meta
  ctaId
  websiteId
  loadingMessage
  fallbackUrl
  fallbackLabel
  timeoutMs
  enableUserDetailsValidation
  buttonLabel
  embedId
}
    `;
export const ConvertFlowQuizFragmentDoc = gql`
    fragment ConvertFlowQuiz on ConvertFlowQuiz {
  ...Meta
  ctaId
  websiteId
  loadingMessage
  fallbackUrl
  fallbackLabel
  timeoutMs
  enableUserDetailsValidation
}
    `;
export const ExperimentContainerFragmentDoc = gql`
    fragment ExperimentContainer on ExperimentContainer {
  ...Meta
  experimentId
  experimentType
  featureFlagKey
  variationItemsCollection(limit: 10) {
    items {
      ...Meta
      variationId
      contentsCollection(limit: 12) {
        items {
          ...Meta
        }
      }
    }
  }
}
    `;
export const PdfFragmentDoc = gql`
    fragment Pdf on Asset {
  ...CommonAsset
  url
}
    `;
export const CardFragmentDoc = gql`
    fragment Card on Card {
  ...Meta
  name
  title
  titleHtag
  description
  richTextDescription {
    json
  }
  image {
    ...Image
  }
  imageAsset {
    ...ImageAsset
  }
  imageRatio
  cardIcon
  cardIconAlignment
  cardTextAlignment
  eyebrow
  backgroundColor
  buttonVariant
  buttonText
  buttonUrl
  buttonSize
  buttonIcon
  buttonIconSize
  buttonIconPosition
  pdfFileLink {
    ...Pdf
  }
  pdfDownloadTitle
  tc {
    ...TermOfConditions
  }
  imageAsset {
    ...ImageAsset
  }
  analyticsContext {
    ...Analytics
  }
  buttonsCollection(limit: 1) {
    items {
      ...Button
    }
  }
  tags
}
    `;
export const CardsFragmentDoc = gql`
    fragment Cards on MultiCardV2 {
  ...Meta
  anchorId
  backgroundColor
  display
  bigScreenBackground
  cardsAlignment
  eyebrowColor
  eyebrowSx
  eyebrowTextTransform
  disablePaddingOn
  forMobile
  enableMobileCarouselNavigation
  lastRowCardsAlignment
  name
  numberOfCardsInLineDesktop
  roundedImage
  sectionEyebrow
  sectionInfoAlignment
  sectionTitle
  sectionTitleHtag
  descriptionRichText {
    json
  }
  facilitySegmentCollection
  cardsCollection(limit: 15) {
    items {
      ... on Card {
        ...Card
      }
    }
  }
  buttonsCollection(limit: 2) {
    items {
      ...Button
    }
  }
  displayAsStepper
  fixBackgroundToBottom
  backgroundImage {
    ...ImageAsset
  }
  headerSpacing
  enableResourceCardMode
  shouldDisplayCarouselOnDesktop
  useCardMediaRoundedCorners
  variant
  simpleCard {
    json
  }
  simpleCardTwo {
    json
  }
  simpleCardThree {
    json
  }
  simpleCardFour {
    json
  }
}
    `;
export const DisclaimerV2FragmentDoc = gql`
    fragment DisclaimerV2 on DisclaimerV2 {
  ...Meta
  disclaimer {
    ...RichText
  }
  size
  templateWidth
  facilitySegmentCollection
  anchorId
}
    `;
export const HalfScreenFragmentDoc = gql`
    fragment HalfScreen on HalfScreen {
  ...Meta
  name
  backgroundColor
  display
  eyebrow
  eyebrowStyle
  templateSize
  mediaFirst
  facilitySegmentCollection
  termsAndConditions {
    ...TermOfConditions
  }
  heading {
    json
  }
  subHeading {
    json
  }
  body {
    json
  }
  image {
    ...Image
  }
  buttonCollection(limit: 2) {
    items {
      ...Button
    }
    limit
    skip
    total
  }
  video {
    ...Video
  }
  contentSmallScreen {
    headingSmallScreen {
      json
    }
    bodySmallScreen {
      json
    }
    imageSmallScreen {
      ...Image
    }
    mediaFirst
  }
  disclaimer {
    ...DisclaimerV2
  }
  imageAsset {
    ...ImageAsset
  }
  videoAsset {
    ...VideoAsset
  }
  hideContentHalf
  imageAssetTwo {
    ...ImageAsset
  }
  isInsetLayout
  useStaticImageSize
  anchorId
  textAlignment
  variant
}
    `;
export const ContentListItemFragmentDoc = gql`
    fragment ContentListItem on ServiceLineHeroContentListItem {
  ... on ContentTypeRichText {
    ...RichText
  }
  ... on SingleMessage {
    ...SingleMessage
  }
  ... on Table {
    ...Table
  }
  ... on Accordions {
    ...Accordion
  }
}
    `;
export const ServiceLineHeroFragmentDoc = gql`
    fragment ServiceLineHero on ServiceLineHero {
  ...Meta
  eyebrow
  eyebrowHtag
  headline {
    json
  }
  subHeadline {
    json
  }
  bodyCopy {
    json
  }
  termsConditions {
    ...TermOfConditions
  }
  buttonCollection(limit: 2) {
    items {
      ...Button
    }
  }
  focalPointImage {
    ...FocalPointImage
  }
  videoAsset {
    ...VideoAsset
  }
  templateWidth
  hideHeroOnMobile
  imgDisplaysFirstOnMobile
  imageWithBorderRadius
  backgroundColor
  display
  backgroundColorMobile
  contentAlign
  facilitySegmentCollection
  disablePaddingOn
  mediaRoundedCornerSize
  imgDisplaysFirstOnDesktop
  showOfficeDetails
  displayOfficeHoursInModal
  googleMapsBusinessQuery
  contentListCollection(limit: 3) {
    items {
      ...ContentListItem
    }
  }
  contentListBelowButtonsCollection(limit: 3) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
      ... on SingleMessage {
        ...SingleMessage
      }
    }
  }
  anchorId
  variant
  imageAsset {
    ...ImageAsset
  }
  schedulingImageAsset {
    ...ImageAsset
  }
  allowScheduleTimes
  officeHoursLabel
  contentListBelowButtonsCollection(limit: 3) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
      ... on SingleMessage {
        ...SingleMessage
      }
    }
  }
}
    `;
export const TabsFragmentDoc = gql`
    fragment Tabs on Tabs {
  ...Meta
  tabsCollection(limit: 5) {
    items {
      ...Meta
      label
      jumplinkName
      content {
        ... on Accordions {
          ...Accordion
        }
        ... on MultiCardV2 {
          ...Cards
        }
        ... on SingleMessage {
          ...SingleMessage
        }
        ... on HalfScreen {
          ...HalfScreen
        }
        ... on ServiceLineHero {
          ...ServiceLineHero
        }
      }
    }
  }
  backgroundColor
  jumplinkTabs
  tabRowVariant
  tabsSize
  withContentInnerGap
  anchorId
  variant
}
    `;
export const GoogleMapTemplateFragmentDoc = gql`
    fragment GoogleMapTemplate on GoogleMapTemplate {
  ...Meta
  title
  titleHtag
  useUsaCountryMap
  desktopZoom
  mobileZoom
  locationScheduleButtonUrl
  googleMapsBusinessQuery
  defaultImage {
    ...CommonAsset
    url
  }
  selectedImage {
    ...CommonAsset
    url
  }
  facilityBasePath
  holidayHoursMessageText
  noResultsFoundMessage {
    json
  }
  singleComingSoonMessage {
    json
  }
  listTabIsHorizontalScrolling
  facilityBadgeLabel
  facilityButtonLabel
  scheduleButton {
    ...Button
  }
  officeDetailsButton {
    ...Button
  }
  useModernDesign
  noResultsFoundImage {
    ...ImageAsset
  }
  noResultsContent {
    ... on MultiCardV2 {
      ...Cards
    }
  }
  availableServicesTabs {
    ... on Tabs {
      ...Tabs
    }
  }
  setAsOfficeButtonText
  useCumulativeDesign
  anchorId
  hideLocationCardButtons
  hideOfficeDetailsButton
  disableMarkerClick
  hideLocationsListOnMobile
}
    `;
export const HeroFragmentDoc = gql`
    fragment Hero on HeroV2 {
  ...Meta
  entryName
  display
  backgroundColorSmallScreen
  body {
    json
  }
  bodySize
  buttonsCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  contentAlign
  contentWidth
  contentPosition
  contentPositionSmallScreen
  contentSmallScreen {
    eyebrowSmallScreen
    headingSmallScreen {
      json
    }
    bodySmallScreen {
      json
    }
    imageSmallScreen {
      ...Image
    }
    focalPointImageSmallScreen {
      ...FocalPointImage
    }
    mediaFirst
  }
  darkOverlay
  darkTextColor
  eyebrow
  eyebrowStyle
  facilitySegmentCollection
  focalPointImage {
    ...FocalPointImage
  }
  heading {
    json
  }
  headingSize
  mediaAspectRatioSmallScreen
  templateWidth
  termsConditions {
    ...TermOfConditions
  }
  video {
    ...CommonAsset
    url
  }
  heightStyle
  promoHeadline {
    json
  }
  promoHeadlineSize
  disclaimer {
    ...DisclaimerV2
  }
  imageAsset {
    ...ImageAsset
  }
  videoAsset {
    ...VideoAsset
  }
  anchorId
  variant
  nestedContentCollection(limit: 2) {
    items {
      ... on Quiz {
        ...Quiz
      }
    }
    limit
    skip
    total
  }
  aspenDentalReasonForVisit
}
    `;
export const InsuranceFragmentDoc = gql`
    fragment Insurance on Insurance {
  ...Meta
  title
  intro {
    json
  }
}
    `;
export const MarqueeFragmentDoc = gql`
    fragment Marquee on Marquee {
  ...Meta
  textList
  icon
  height
  backgroundColor
  withAutoScrolling
  facilitySegmentCollection
  anchorId
}
    `;
export const MeetOurStaffFragmentDoc = gql`
    fragment MeetOurStaff on MeetOurStaff {
  ...Meta
  title
  description
  sectionBackground
  alignment
  contentMaxWidth
  showDisabledSwiperArrows
  withDesktopPaginationNavigation
  withMobileArrowsNavigation
  anchorId
}
    `;
export const FeatureFlagsFragmentDoc = gql`
    fragment FeatureFlags on FeatureFlags {
  continentalUsMapFallbackThreshold
  enforceContinentalUsZoom
  featureList
  salesForceEvergageScript
  providerHeroTheme
  showMobileHeaderLocationBar
  showHeaderWithLocationNav
  defaultToCdn
  useFacilityBeffeDataSource
  useInlineOneTrust
  useSessionStorageFacilityCode
  doNotIndexWholeSite
  showHeaderNavigationMenu
  hideHeaderFacilityLocator
  hideHeaderSchedulingButton
  hideProviderWithNoImage
  useGoogleMapAutocompleteSearch
  fetchAllLocationsOnEmptyResults
  showSetOfficeButtonInGoogleMapsCards
  useSimpleFindOfficeLink
  enableFluidTypography
  oneTrust
  enableCcMarketingSourceTransformation
  migrationPaths
  loadFacilityReviewsFromBeffe
  useFilterForOdpDetailsContent
  showReadMoreForBioInMeetOurStaff
  showProviderPageCtaInMeetOurStaff
}
    `;
export const AppMetadataFragmentDoc = gql`
    fragment AppMetadata on App {
  __typename
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
    }
  }
  name
  branding
  config
  logo {
    ...Image
  }
  logoMobile {
    ...Image
  }
  featureFlags {
    ...FeatureFlags
  }
}
    `;
export const FooterNavigationGroupFragmentDoc = gql`
    fragment FooterNavigationGroup on FooterNavigationGroup {
  ...EnrichedMeta
  componentName
  navigationGroupLink {
    ... on Page {
      ...BasePage
    }
  }
  navigationLinksForGroupCollection(limit: 10) {
    items {
      ... on Page {
        ...BasePage
      }
    }
    skip
    limit
    total
  }
}
    `;
export const GenericNavigationGroupFragmentDoc = gql`
    fragment GenericNavigationGroup on NavigationGroup {
  groupLink {
    ...EnrichedMeta
    linkText
    isInternal
    openInNewTab
  }
  linksCollection(limit: 8) {
    items {
      ... on NavigationLink {
        ...NavLink
      }
    }
    limit
    skip
    total
  }
}
    `;
export const ContentTileFragmentDoc = gql`
    fragment ContentTile on ContentTile {
  ...EnrichedMeta
  title
  description
  image
  internalPage {
    ... on Page {
      ...BasePage
    }
  }
  externalUrl
}
    `;
export const HeaderSubNavFragmentDoc = gql`
    fragment HeaderSubNav on HeaderSubNav {
  featuredLink {
    ... on NavigationLink {
      ...NavLink
    }
  }
  headerSubNavGroupsCollection(limit: 20) {
    items {
      displayAsExpandedForMobileMenu
      groupLink {
        ... on NavigationLink {
          ...NavLink
        }
      }
      linksCollection(limit: 10) {
        items {
          ... on NavigationLink {
            ...NavLink
          }
        }
      }
    }
  }
  contentTilesCollection(limit: 3) {
    items {
      ...ContentTile
    }
  }
}
    `;
export const HeaderMainNavFragmentDoc = gql`
    fragment HeaderMainNav on HeaderMainNav {
  headerMainNavLink {
    ... on NavigationLink {
      ...NavLink
    }
  }
  headerSubNavMenu {
    ...HeaderSubNav
  }
}
    `;
export const HeaderNavMenuFragmentDoc = gql`
    fragment HeaderNavMenu on HeaderNavMenu {
  headerMainNavLinksCollection(limit: 10) {
    items {
      ...HeaderMainNav
    }
  }
}
    `;
export const GoogleMapInHeaderFragmentDoc = gql`
    fragment GoogleMapInHeader on GoogleMapTemplate {
  ...Meta
  title
  titleHtag
  locationScheduleButtonUrl
  googleMapsBusinessQuery
  defaultImage {
    ...CommonAsset
    url
  }
  selectedImage {
    ...CommonAsset
    url
  }
  noResultsFoundMessage {
    json
  }
  facilityBadgeLabel
  facilityButtonLabel
  scheduleButton {
    ...Button
  }
  officeDetailsButton {
    ...Button
  }
  setAsOfficeButtonText
  disableMarkerClick
}
    `;
export const BannerFragmentDoc = gql`
    fragment Banner on Banner {
  ...Meta
  variant
  alertMessagesCollection(limit: 5) {
    items {
      ... on ContentTypeRichText {
        backgroundColor
        content {
          json
        }
        facilitySegmentCollection
        __typename
      }
      __typename
    }
  }
  mobileAlertMessagesCollection(limit: 5) {
    items {
      ... on ContentTypeRichText {
        backgroundColor
        content {
          json
        }
        facilitySegmentCollection
        __typename
      }
      __typename
    }
  }
}
    `;
export const HeaderFragmentDoc = gql`
    fragment Header on Header {
  ...EnrichedMeta
  bookNowButton {
    ...EnrichedMeta
  }
  darkHeader
  componentName
  variant
  hideFullSiteSearch
  locationBarFindOfficeUrl
  locationBarWithOfficeTitle
  locationBarWithOutOfficeTitle
  useNewLayout
  schedulingButtonUrlMobile
  schedulingButtonUrl
  schedulingButtonText
  schedulingButtonTextMobile
  myAccountLabel
  profileLinkUrl
  useHeaderLocationCards
  showSecondaryNavInMobileToolbar
  searchFieldTitle
  hideOdpLinks
  navigationLinksCollection(limit: 10) {
    items {
      ...EnrichedMeta
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
      ... on FooterNavigationGroup {
        ...FooterNavigationGroup
      }
      ... on NavigationGroup {
        ...GenericNavigationGroup
      }
    }
    limit
    skip
    total
  }
  topNavigationLinksCollection(limit: 4) {
    items {
      ...EnrichedMeta
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
    }
    limit
    skip
    total
  }
  usePopupScheduling
  schedulingNavigationLinksCollection(limit: 4) {
    items {
      ...EnrichedMeta
      ... on NavigationGroup {
        ...GenericNavigationGroup
      }
    }
    limit
    skip
    total
  }
  navigationMenu {
    ...HeaderNavMenu
  }
  locationNavigationLinksCollection(limit: 5) {
    items {
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
    }
  }
  phoneNumber {
    ... on NavigationLink {
      ...NavLink
    }
  }
  secondaryNavigationLinksCollection(limit: 4) {
    items {
      ...EnrichedMeta
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
    }
    limit
    skip
    total
  }
  googleMapsForLocationCards {
    ...GoogleMapInHeader
  }
  topAlertBanner {
    ...Banner
  }
  bottomAlertBanner {
    ...Banner
  }
  mobileQuizLink {
    ... on NavigationLink {
      ...NavLink
    }
  }
}
    `;
export const FooterFragmentDoc = gql`
    fragment Footer on AdFooter {
  ...EnrichedMeta
  componentName
  variant
  contactNumber
  copyright
  isLightFooter
  useMobileStickyFooter
  useDesktopStickyFooter
  stickyFooterScheduleButton {
    ... on Button {
      ...Button
    }
  }
  stickyFooterButtonsCollection(limit: 3) {
    items {
      ...Button
    }
    limit
    skip
    total
  }
  logo {
    ...Image
  }
  disclaimer {
    ...DisclaimerV2
  }
  about {
    json
    links {
      assets {
        block {
          ...LinkMeta
        }
        hyperlink {
          ...LinkMeta
        }
      }
      entries {
        inline {
          ...EnrichedMeta
        }
        block {
          ...EnrichedMeta
        }
        hyperlink {
          ...EnrichedMeta
        }
      }
      resources {
        block {
          ...ResourceMeta
        }
        inline {
          ...ResourceMeta
        }
        hyperlink {
          ...ResourceMeta
        }
      }
    }
  }
  aboutDescription {
    json
    links {
      assets {
        block {
          ...LinkMeta
        }
        hyperlink {
          ...LinkMeta
        }
      }
      entries {
        inline {
          ...EnrichedMeta
        }
        block {
          ...EnrichedMeta
        }
        hyperlink {
          ...EnrichedMeta
        }
      }
      resources {
        block {
          ...ResourceMeta
        }
        inline {
          ...ResourceMeta
        }
        hyperlink {
          ...ResourceMeta
        }
      }
    }
  }
  navigationGroupsCollection(limit: 20, skip: 0) {
    items {
      ...EnrichedMeta
      componentName
      navigationGroupTitle
      navigationGroupLink {
        ... on Page {
          ...BasePage
        }
      }
      navigationLinksForGroupCollection(limit: 20) {
        items {
          ... on Page {
            ...BasePage
          }
          ... on NavigationLink {
            ...NavLink
          }
        }
        skip
        limit
        total
      }
    }
    skip
    limit
    total
  }
  socialNetworksCollection(limit: 20) {
    items {
      ...EnrichedMeta
      ... on Page {
        ...BasePage
      }
      ... on NavigationLink {
        ...NavLink
      }
    }
    skip
    limit
    total
  }
  footerPolicyGroupCollection(limit: 5) {
    items {
      ...EnrichedMeta
      ... on NavigationLink {
        ...NavLink
      }
    }
    skip
    limit
    total
  }
}
    `;
export const Error404FragmentDoc = gql`
    fragment Error404 on Error404 {
  heading
  subtitle
  body
  buttonLabel
  backgroundImage {
    ...Image
  }
  backgroundImageMobile {
    ...Image
  }
  sys {
    id
    environmentId
    spaceId
  }
  contentfulMetadata {
    tags {
      id
    }
  }
  darkTextColor
  supplementaryButton {
    ...Button
  }
}
    `;
export const AppPagesDataFragmentDoc = gql`
    fragment AppPagesData on App {
  header {
    ...Header
  }
  footer {
    ...Footer
  }
  notFoundPage {
    ...Error404
  }
}
    `;
export const AppFragmentDoc = gql`
    fragment App on App {
  ...AppMetadata
  ...AppPagesData
}
    `;
export const OdpHeroFragmentDoc = gql`
    fragment OdpHero on OdpHero {
  ...Meta
  name
  templateWidth
  image {
    ...FocalPointImage
  }
  showReviews
  title
  titleHtag
  bodyCopy: description {
    ... on ContentTypeRichText {
      ...RichText
    }
  }
  showAddress
  showPhoneNumber
  showHours
  buttonsCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  officeHoursLabel
  callCenterLabel
  googleMapsBusinessQuery
  facilitySegmentCollection
  promoTitle
  anchorId
}
    `;
export const PageFragmentDoc = gql`
    fragment Page on Page {
  ...Meta
  name
  breadcrumbTitle
  description
  pageTitle
  path
  title
  tags
  canonical
  indexed
  personalized
  pageTheme
  disableChatBot
  ogImage {
    ...ImageAsset
  }
  disableStickyFooterOnDesktop
  disableStickyFooterOnMobile
  disableHeaderTopAlertBanner
  disableHeaderBottomAlertBanner
  hideScheduleButtonInHeader
  redirectTo
  contentsCollection(limit: $content_limit) {
    items {
      ... on Entry {
        ...Meta
      }
    }
  }
  analyticsContext {
    ...Analytics
  }
}
    `;
export const PatientReviewsV2FragmentDoc = gql`
    fragment PatientReviewsV2 on PatientReviewsV2 {
  ...Meta
  eyebrowSmallScreens
  eyebrowLargeScreens
  titleSmallScreens
  titleLargeScreens
  subtitleSmallScreens
  subtitleLargeScreens
  titleHtag
  maxReviewsSmallScreens
  maxReviewsLargeScreens
  trimThreshold
  disablePaddingOn
  backgroundColor
  templateWidth
  contentAlign
  imageLeftSide {
    ...ImageAsset
  }
  reviewsCollection(limit: 4) {
    items {
      ...Meta
      score
      text
      subText1
      subText2
      avatar {
        ...Image
      }
    }
  }
  buttonsSmallScreensCollection(limit: 2) {
    items {
      ...Meta
      variant
      label
      buttonLink
      size
    }
  }
  buttonsLargeScreensCollection(limit: 2) {
    items {
      ...Meta
      variant
      label
      buttonLink
      size
    }
  }
  mode
  scoreIcon
  anchorId
}
    `;
export const ProductDisplayFragmentDoc = gql`
    fragment ProductDisplay on ProductDisplay {
  ...Meta
  anchorId
  productListTitleHtag
  productListTitle
  productListDescription {
    json
  }
  showProductCategory
  showProductSubCategory
  productsToDisplay
  showLocalizedProductPrice
}
    `;
export const VideoCarouselFragmentDoc = gql`
    fragment VideoCarousel on VideoCarousel {
  ...Meta
  backgroundColor
  topFields {
    ...ContentSection
  }
  desktopVideosAspectRatio
  mobileVideosAspectRatio
  videosCollection(limit: 5) {
    skip
    total
    items {
      ... on VideoWithContent {
        ...Meta
        content {
          ...ContentSection
        }
        video {
          ...VideoAsset
        }
        buttonsCollection(limit: 1) {
          items {
            ...Button
          }
        }
      }
    }
  }
  buttonsCollection(limit: 2) {
    items {
      ...Button
    }
  }
  anchorId
}
    `;
export const ServiceFragmentDoc = gql`
    fragment Service on Service {
  ...Meta
  name
  backgroundColor
  description
  direction
  centerAlign
  contained
  eyebrow
  title
  titleHtag
  direction
  buttonText
  buttonUrl
  buttonType
  mediaType
  imageLayout
  richTextDescription {
    json
  }
  image {
    ...Image
  }
  mobileImage {
    ...Image
  }
  video {
    ...CommonAsset
    url
  }
  buttonsCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  youTubeVideoId
  youTubeVideoImage {
    ...CommonAsset
    url
  }
  facilitySegmentCollection
  tc {
    ...TermOfConditions
  }
  anchorId
}
    `;
export const SpacerFragmentDoc = gql`
    fragment Spacer on Spacer {
  ...Meta
  size
  color
  anchorId
}
    `;
export const ProviderDetailsPageFragmentDoc = gql`
    fragment ProviderDetailsPage on ProviderDetailsPage {
  ...Meta
  name
  npiId
  ogImage {
    ...ImageAsset
  }
  contentsCollection(limit: 8) {
    items {
      ...SingleMessage
      ...Cards
      ...HalfScreen
      ...Accordion
      ...VideoCarousel
      ...Service
      ...Spacer
    }
  }
  secondaryContentsCollection(limit: 8) {
    items {
      ...SingleMessage
      ...Cards
      ...HalfScreen
      ...Accordion
      ...VideoCarousel
      ...Service
      ...Spacer
    }
  }
}
    `;
export const QuickLinksFragmentDoc = gql`
    fragment QuickLinks on QuickLinks {
  ...Meta
  templateSize
  eyebrow
  eyebrowStyle
  heading {
    json
  }
  body {
    json
  }
  backgroundColor
  disablePaddingOn
  displayAsTitles
  quickLinksCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  buttonsCollection(limit: 4) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
  anchorId
}
    `;
export const RichTextWithLinksFragmentDoc = gql`
    fragment RichTextWithLinks on ContentTypeRichText {
  ...EnrichedMeta
  fullWidth
  disablePaddingOn
  backgroundColor
  display
  centerAlign
  contained
  titleHeading
  title
  titleIcon
  contentMaxWidth
  facilitySegmentCollection
  id
  content {
    json
    links {
      assets {
        block {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
        hyperlink {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
      }
      entries {
        inline {
          ...EnrichedMeta
          ...BasePage
        }
        block {
          ...EnrichedMeta
          ...BasePage
          ...Table
          ...ImageAsset
          ...VideoAsset
        }
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ... on ServiceDetailsPage {
            ...Meta
            path
          }
          ... on FacilityDetailsPage {
            ...Meta
            path
          }
        }
      }
      resources {
        block {
          ...ResourceMeta
        }
        inline {
          ...ResourceMeta
        }
        hyperlink {
          ...ResourceMeta
        }
      }
    }
  }
  secondaryContent {
    json
    links {
      assets {
        block {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
        hyperlink {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
      }
      entries {
        inline {
          ...EnrichedMeta
          ...BasePage
        }
        block {
          ...EnrichedMeta
          ...BasePage
        }
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ... on ServiceDetailsPage {
            ...Meta
            path
          }
          ... on FacilityDetailsPage {
            ...Meta
            path
          }
        }
      }
      resources {
        block {
          ...ResourceMeta
        }
        inline {
          ...ResourceMeta
        }
        hyperlink {
          ...ResourceMeta
        }
      }
    }
  }
  buttonsCollection(limit: 2) {
    items {
      ... on Button {
        ...Button
      }
    }
  }
}
    `;
export const SchemaFragmentDoc = gql`
    fragment Schema on Schema {
  ...Meta
  schema
  combinedSchema
}
    `;
export const SegmentsContainerFragmentDoc = gql`
    fragment SegmentsContainer on SegmentsContainer {
  ...Meta
  contentsCollection(limit: 12) {
    items {
      ...Meta
    }
  }
  anchorId
}
    `;
export const TextBlockSeoFragmentDoc = gql`
    fragment TextBlockSeo on TextBlockSeo {
  ...Meta
  name
  backgroundColor
  disablePaddingOn
  content {
    json
  }
  anchorId
}
    `;
export const BlogDetailsPageItemFragmentDoc = gql`
    fragment BlogDetailsPageItem on BlogDetailsPage {
  path
  indexed
  sys {
    publishedAt
  }
  category {
    ...BlogCategory
  }
}
    `;
export const BlogListPageItemFragmentDoc = gql`
    fragment BlogListPageItem on BlogListPage {
  indexed
  sys {
    publishedAt
  }
}
    `;
export const TextBlockSeoEntryLinksFragmentDoc = gql`
    fragment TextBlockSeoEntryLinks on TextBlockSeo {
  ...Meta
  content {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const InsuranceEntryLinksFragmentDoc = gql`
    fragment InsuranceEntryLinks on Insurance {
  ...Meta
  name
  intro {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const ContentTypeRichTextEntryLinksFragmentDoc = gql`
    fragment ContentTypeRichTextEntryLinks on ContentTypeRichText {
  ...Meta
  content {
    links {
      entries {
        block {
          ...EnrichedMeta
          ...ImageAsset
        }
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  secondaryContent {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const CategoryPickerEntryLinksFragmentDoc = gql`
    fragment CategoryPickerEntryLinks on CategoryPicker {
  ...Meta
  name
  bodyCopy: description {
    ...ContentTypeRichTextEntryLinks
  }
}
    `;
export const SmallScreenContentEntryLinksFragmentDoc = gql`
    fragment SmallScreenContentEntryLinks on SmallScreenContent {
  ...Meta
  entryName
  bodySmallScreen {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const TermsAndConditionsEntryLinksFragmentDoc = gql`
    fragment TermsAndConditionsEntryLinks on TermsAndConditions {
  ...Meta
  content {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const SingleMessageEntryLinksFragmentDoc = gql`
    fragment SingleMessageEntryLinks on SingleMessage {
  ...Meta
  name
  content {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  contentSmallScreen {
    ...SmallScreenContentEntryLinks
  }
  tc {
    ...TermsAndConditionsEntryLinks
  }
}
    `;
export const AccordionsEntryLinksFragmentDoc = gql`
    fragment AccordionsEntryLinks on Accordions {
  ...Meta
  title
  descriptionRichText {
    links {
      entries {
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  accordionsCollection(limit: 20) {
    items {
      ... on ContentTypeRichText {
        ...ContentTypeRichTextEntryLinks
      }
    }
  }
}
    `;
export const ColumnsEntryLinksFragmentDoc = gql`
    fragment ColumnsEntryLinks on Columns {
  ...Meta
  title
  columnsCollection(limit: 5) {
    items {
      ... on ContentTypeRichText {
        ...ContentTypeRichTextEntryLinks
      }
      ... on SingleMessage {
        ...SingleMessageEntryLinks
      }
      ... on Accordions {
        ...AccordionsEntryLinks
      }
    }
  }
}
    `;
export const QuickLinksEntryLinksFragmentDoc = gql`
    fragment QuickLinksEntryLinks on QuickLinks {
  ...Meta
  body {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
}
    `;
export const ServiceEntryLinksFragmentDoc = gql`
    fragment ServiceEntryLinks on Service {
  ...Meta
  name
  richTextDescription {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  tc {
    ...TermsAndConditionsEntryLinks
  }
}
    `;
export const DisclaimerV2EntryLinksFragmentDoc = gql`
    fragment DisclaimerV2EntryLinks on DisclaimerV2 {
  ...Meta
  entryName
  disclaimer {
    ...ContentTypeRichTextEntryLinks
  }
}
    `;
export const HeroV2EntryLinksFragmentDoc = gql`
    fragment HeroV2EntryLinks on HeroV2 {
  ...Meta
  entryName
  body {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  contentSmallScreen {
    ...SmallScreenContentEntryLinks
  }
  termsConditions {
    ...TermsAndConditionsEntryLinks
  }
  disclaimer {
    ...DisclaimerV2EntryLinks
  }
}
    `;
export const HalfScreenEntryLinksFragmentDoc = gql`
    fragment HalfScreenEntryLinks on HalfScreen {
  ...Meta
  name
  body {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  contentSmallScreen {
    ...SmallScreenContentEntryLinks
  }
  termsAndConditions {
    ...TermsAndConditionsEntryLinks
  }
  disclaimer {
    ...DisclaimerV2EntryLinks
  }
}
    `;
export const CardEntryLinksFragmentDoc = gql`
    fragment CardEntryLinks on Card {
  ...Meta
  name
  richTextDescription {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
      assets {
        block {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
        hyperlink {
          ...LinkMeta
          contentType
          url
          description
          fileName
        }
      }
    }
  }
  tc {
    ...TermsAndConditionsEntryLinks
  }
}
    `;
export const MulticardV2EntryLinksFragmentDoc = gql`
    fragment MulticardV2EntryLinks on MultiCardV2 {
  ...Meta
  descriptionRichText {
    links {
      entries {
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  simpleCard {
    links {
      entries {
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  simpleCardTwo {
    links {
      entries {
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  simpleCardThree {
    links {
      entries {
        hyperlink {
          ...EnrichedMeta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  cardsCollection(limit: 8) {
    items {
      ...CardEntryLinks
    }
  }
}
    `;
export const OdpHeroEntryLinksFragmentDoc = gql`
    fragment ODPHeroEntryLinks on OdpHero {
  ...Meta
  name
  bodyCopy: description {
    ...ContentTypeRichTextEntryLinks
  }
}
    `;
export const SegmentContainerEntryLinksFragmentDoc = gql`
    fragment SegmentContainerEntryLinks on SegmentsContainer {
  ...Meta
  contentsCollection(limit: 12) {
    items {
      ... on HeroV2 {
        ...HeroV2EntryLinks
      }
      ... on HalfScreen {
        ...HalfScreenEntryLinks
      }
      ... on SingleMessage {
        ...SingleMessageEntryLinks
      }
      ... on ContentTypeRichText {
        ...ContentTypeRichTextEntryLinks
      }
      ... on MultiCardV2 {
        ...MulticardV2EntryLinks
      }
      ... on OdpHero {
        ...ODPHeroEntryLinks
      }
    }
  }
}
    `;
export const ProductFeatureEntryLinksFragmentDoc = gql`
    fragment ProductFeatureEntryLinks on ProductFeature {
  ...Meta
  descriptionRichText {
    ...ContentTypeRichTextEntryLinks
  }
  descriptionListCollection(limit: 5) {
    items {
      ...Meta
      ... on ProductFeatureDescriptionListItem {
        content {
          ...ContentTypeRichTextEntryLinks
        }
      }
    }
  }
}
    `;
export const AgendaStepperEntryLinksFragmentDoc = gql`
    fragment AgendaStepperEntryLinks on AgendaStepper {
  ...Meta
  description {
    ...ContentTypeRichTextEntryLinks
  }
  stepsCollection(limit: 10) {
    items {
      ...Meta
      ... on AgendaModal {
        bodyText {
          ...ContentTypeRichTextEntryLinks
        }
      }
    }
  }
}
    `;
export const ContentListItemEntryLinksFragmentDoc = gql`
    fragment ContentListItemEntryLinks on ServiceLineHeroContentListItem {
  ... on ContentTypeRichText {
    ...ContentTypeRichTextEntryLinks
  }
  ... on SingleMessage {
    ...SingleMessageEntryLinks
  }
  ... on Accordions {
    ...AccordionsEntryLinks
  }
}
    `;
export const ServiceLineHeroEntryLinksFragmentDoc = gql`
    fragment ServiceLineHeroEntryLinks on ServiceLineHero {
  ...Meta
  subHeadline {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  bodyCopy {
    links {
      entries {
        hyperlink {
          ...Meta
          ...BasePage
          ...BlogDetailsPageBase
          ...ServiceDetailsPageBase
          ...FacilityDetailsPageBase
        }
      }
    }
  }
  termsConditions {
    ...TermsAndConditionsEntryLinks
  }
  contentListCollection(limit: 1) {
    items {
      ...ContentListItemEntryLinks
    }
  }
  contentListBelowButtonsCollection(limit: 1) {
    items {
      ... on ContentTypeRichText {
        ...RichText
      }
      ... on SingleMessage {
        ...SingleMessage
      }
    }
  }
}
    `;
export const TabsEntryLinksFragmentDoc = gql`
    fragment TabsEntryLinks on Tabs {
  ...Meta
  name
  tabsCollection(limit: 10) {
    items {
      ...Meta
      content {
        ...Meta
        ... on Accordions {
          ...AccordionsEntryLinks
        }
        ... on HalfScreen {
          ...HalfScreenEntryLinks
        }
        ... on SingleMessage {
          ...SingleMessageEntryLinks
        }
        ... on MultiCardV2 {
          ...MulticardV2EntryLinks
        }
        ... on ServiceLineHero {
          ...ServiceLineHeroEntryLinks
        }
      }
    }
  }
}
    `;
export const SitemapPagesFragmentDoc = gql`
    fragment sitemapPages on Query {
  pageCollection(
    limit: $limit
    skip: $skip
    where: {indexed: $indexed, appName: $appName}
    locale: $locale
  ) {
    items {
      path
      indexed
      sys {
        publishedAt
      }
    }
  }
}
    `;
export const AccordionsByIdDocument = gql`
    query accordionsById($id: String!, $preview: Boolean = false) {
  accordions(id: $id, preview: $preview) {
    ...Accordion
  }
}
    ${AccordionFragmentDoc}
${MetaFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}`;

export function useAccordionsByIdQuery(options: Omit<Urql.UseQueryArgs<AccordionsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AccordionsByIdQuery, AccordionsByIdQueryVariables>({ query: AccordionsByIdDocument, ...options });
};
export const AgendaStepperByIdDocument = gql`
    query agendaStepperById($id: String!, $preview: Boolean = false) {
  agendaStepper(id: $id, preview: $preview) {
    icon
    title
    titleHtag
    description {
      ... on ContentTypeRichText {
        ...RichText
      }
    }
    stepsCollection(limit: 10) {
      items {
        ...AgendaModal
      }
    }
    hideStepperDot
    backgroundColor
    useNumericStepper
    isHighlightedSteps
    areStepsCenteredForMobile
    anchorId
  }
}
    ${RichTextFragmentDoc}
${MetaFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${AgendaModalFragmentDoc}`;

export function useAgendaStepperByIdQuery(options: Omit<Urql.UseQueryArgs<AgendaStepperByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AgendaStepperByIdQuery, AgendaStepperByIdQueryVariables>({ query: AgendaStepperByIdDocument, ...options });
};
export const AppMetadataByAppNameDocument = gql`
    query appMetadataByAppName($appName: String!, $preview: Boolean = false) {
  appCollection(limit: 1, where: {name: $appName}, preview: $preview) {
    items {
      ...AppMetadata
    }
  }
}
    ${AppMetadataFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${FeatureFlagsFragmentDoc}`;

export function useAppMetadataByAppNameQuery(options: Omit<Urql.UseQueryArgs<AppMetadataByAppNameQueryVariables>, 'query'>) {
  return Urql.useQuery<AppMetadataByAppNameQuery, AppMetadataByAppNameQueryVariables>({ query: AppMetadataByAppNameDocument, ...options });
};
export const AppPagesDataByAppNameDocument = gql`
    query appPagesDataByAppName($appName: String!, $preview: Boolean = false) {
  appCollection(limit: 1, where: {name: $appName}, preview: $preview) {
    items {
      ...AppPagesData
    }
  }
}
    ${AppPagesDataFragmentDoc}
${HeaderFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${NavLinkFragmentDoc}
${MetaFragmentDoc}
${AnalyticsFragmentDoc}
${FooterNavigationGroupFragmentDoc}
${GenericNavigationGroupFragmentDoc}
${HeaderNavMenuFragmentDoc}
${HeaderMainNavFragmentDoc}
${HeaderSubNavFragmentDoc}
${ContentTileFragmentDoc}
${GoogleMapInHeaderFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${BannerFragmentDoc}
${FooterFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${LinkMetaFragmentDoc}
${ResourceMetaFragmentDoc}
${Error404FragmentDoc}`;

export function useAppPagesDataByAppNameQuery(options: Omit<Urql.UseQueryArgs<AppPagesDataByAppNameQueryVariables>, 'query'>) {
  return Urql.useQuery<AppPagesDataByAppNameQuery, AppPagesDataByAppNameQueryVariables>({ query: AppPagesDataByAppNameDocument, ...options });
};
export const BirdEyeReviewsByIdDocument = gql`
    query birdEyeReviewsById($id: String!, $preview: Boolean = false) {
  birdEyeReviews(id: $id, preview: $preview) {
    ...Meta
    title
    titleHeading
    mediaContent {
      ...Video
      ...FocalPointImage
    }
    tags
    filteredReviewsMinRating
    filteredReviewsTitle
    anchorId
  }
}
    ${MetaFragmentDoc}
${VideoFragmentDoc}
${CommonAssetFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}`;

export function useBirdEyeReviewsByIdQuery(options: Omit<Urql.UseQueryArgs<BirdEyeReviewsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<BirdEyeReviewsByIdQuery, BirdEyeReviewsByIdQueryVariables>({ query: BirdEyeReviewsByIdDocument, ...options });
};
export const BlogCategoriesByBrandDocument = gql`
    query blogCategoriesByBrand($brandName: String!, $preview: Boolean = false, $order: [BlogCategoryOrder] = [name_ASC]) {
  blogCategoryCollection(
    where: {brand: {title: $brandName}}
    preview: $preview
    order: $order
  ) {
    items {
      name
      slug
    }
  }
}
    `;

export function useBlogCategoriesByBrandQuery(options: Omit<Urql.UseQueryArgs<BlogCategoriesByBrandQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogCategoriesByBrandQuery, BlogCategoriesByBrandQueryVariables>({ query: BlogCategoriesByBrandDocument, ...options });
};
export const BlogSubCategoriesByBrandDocument = gql`
    query blogSubCategoriesByBrand($brandName: String!, $preview: Boolean = false, $order: [BlogSubCategoryOrder] = [name_ASC]) {
  blogSubCategoryCollection(
    where: {brand: {title: $brandName}}
    preview: $preview
    order: $order
  ) {
    items {
      name
      slug
    }
  }
}
    `;

export function useBlogSubCategoriesByBrandQuery(options: Omit<Urql.UseQueryArgs<BlogSubCategoriesByBrandQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogSubCategoriesByBrandQuery, BlogSubCategoriesByBrandQueryVariables>({ query: BlogSubCategoriesByBrandDocument, ...options });
};
export const BlogDetailsPageByPathDocument = gql`
    query blogDetailsPageByPath($path: String!, $title: String!, $preview: Boolean = false) {
  blogDetailsPageCollection(
    limit: 1
    where: {path: $path, brand: {title: $title}}
    preview: $preview
  ) {
    items {
      ...BlogDetailsPage
    }
    skip
    limit
    total
  }
}
    ${BlogDetailsPageFragmentDoc}
${MetaFragmentDoc}
${BrandFragmentDoc}
${BlogDetailsPageSummaryFragmentDoc}
${BlogDetailsPageSummaryAssetsFragmentDoc}
${LinkMetaFragmentDoc}
${BlogDetailsPageSummaryEntriesFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageSummaryResourcesFragmentDoc}
${ResourceMetaFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogSubCategoryFragmentDoc}
${BlogDetailsPageTextFragmentDoc}
${BlogDetailsPageTextAssetsFragmentDoc}
${BlogDetailsPageTextEntriesFragmentDoc}
${TableFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${ColumnsFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${TermOfConditionsFragmentDoc}
${ImageAssetFragmentDoc}
${AccordionFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${BlogDetailsPageTextResourcesFragmentDoc}
${BlogAuthorFragmentDoc}
${BlogAuthorAuthorBioSummaryFragmentDoc}
${BlogAuthorAuthorBioSummaryAssetsFragmentDoc}
${BlogAuthorAuthorBioSummaryEntriesFragmentDoc}
${BlogAuthorAuthorBioSummaryResourcesFragmentDoc}
${ContentSectionFragmentDoc}`;

export function useBlogDetailsPageByPathQuery(options: Omit<Urql.UseQueryArgs<BlogDetailsPageByPathQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogDetailsPageByPathQuery, BlogDetailsPageByPathQueryVariables>({ query: BlogDetailsPageByPathDocument, ...options });
};
export const BlogListByIdDocument = gql`
    query blogListById($id: String!, $preview: Boolean = false) {
  blogList(id: $id, preview: $preview) {
    ...BlogList
  }
}
    ${BlogListFragmentDoc}
${MetaFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogSubCategoryFragmentDoc}
${BrandFragmentDoc}
${HeroBlogDetailsPageListFragmentDoc}
${ImageAssetFragmentDoc}
${FeaturedBlogDetailsPageListFragmentDoc}`;

export function useBlogListByIdQuery(options: Omit<Urql.UseQueryArgs<BlogListByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogListByIdQuery, BlogListByIdQueryVariables>({ query: BlogListByIdDocument, ...options });
};
export const BlogListPageByBrandDocument = gql`
    query blogListPageByBrand($brandName: String!, $preview: Boolean = false) {
  blogListPageCollection(
    limit: 1
    where: {brand: {title: $brandName}}
    preview: $preview
  ) {
    items {
      ...BlogListPage
    }
  }
}
    ${BlogListPageFragmentDoc}
${MetaFragmentDoc}
${BrandFragmentDoc}
${BlogListFragmentDoc}
${BlogCategoryFragmentDoc}
${BlogSubCategoryFragmentDoc}
${HeroBlogDetailsPageListFragmentDoc}
${ImageAssetFragmentDoc}
${FeaturedBlogDetailsPageListFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${TermOfConditionsFragmentDoc}`;

export function useBlogListPageByBrandQuery(options: Omit<Urql.UseQueryArgs<BlogListPageByBrandQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogListPageByBrandQuery, BlogListPageByBrandQueryVariables>({ query: BlogListPageByBrandDocument, ...options });
};
export const BlogsListByBrandDocument = gql`
    query blogsListByBrand($limit: Int!, $skip: Int!, $brandName: String!, $order: [BlogDetailsPageOrder!], $preview: Boolean = false, $categoryName: String, $subCategoryName: String, $tags: [String]) {
  blogDetailsPageCollection(
    limit: $limit
    skip: $skip
    where: {brand: {title: $brandName}, tags_contains_some: $tags, category: {name: $categoryName}, subCategory: {name: $subCategoryName}}
    order: $order
    preview: $preview
  ) {
    items {
      category {
        name
        slug
      }
      timeToRead
      title
      path
      blogImage
      date
      tags
      summary {
        json
      }
      imageAsset {
        desktopImage
        mobileImage
      }
    }
    total
    skip
    limit
  }
}
    `;

export function useBlogsListByBrandQuery(options: Omit<Urql.UseQueryArgs<BlogsListByBrandQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogsListByBrandQuery, BlogsListByBrandQueryVariables>({ query: BlogsListByBrandDocument, ...options });
};
export const BlogTagsByBrandDocument = gql`
    query blogTagsByBrand($limit: Int!, $skip: Int!, $brandName: String!, $order: [BlogDetailsPageOrder!], $preview: Boolean = false) {
  blogDetailsPageCollection(
    limit: $limit
    skip: $skip
    where: {brand: {title: $brandName}, tags_exists: true}
    order: $order
    preview: $preview
  ) {
    items {
      tags
    }
    total
    skip
    limit
  }
}
    `;

export function useBlogTagsByBrandQuery(options: Omit<Urql.UseQueryArgs<BlogTagsByBrandQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogTagsByBrandQuery, BlogTagsByBrandQueryVariables>({ query: BlogTagsByBrandDocument, ...options });
};
export const BlogPagesDocument = gql`
    query blogPages($brandName: String!, $locale: String!, $indexed: Boolean = true, $limit: Int = 500, $skip: Int = 0) {
  blogDetailsPageCollection(
    limit: $limit
    skip: $skip
    where: {indexed: $indexed, brand: {title: $brandName}}
    locale: $locale
  ) {
    items {
      ...BlogDetailsPageItem
    }
    skip
    limit
    total
  }
  blogListPageCollection(
    limit: $limit
    skip: $skip
    where: {indexed: $indexed, brand: {title: $brandName}}
    locale: $locale
  ) {
    items {
      ...BlogListPageItem
    }
    skip
    limit
    total
  }
}
    ${BlogDetailsPageItemFragmentDoc}
${BlogCategoryFragmentDoc}
${MetaFragmentDoc}
${BlogListPageItemFragmentDoc}`;

export function useBlogPagesQuery(options: Omit<Urql.UseQueryArgs<BlogPagesQueryVariables>, 'query'>) {
  return Urql.useQuery<BlogPagesQuery, BlogPagesQueryVariables>({ query: BlogPagesDocument, ...options });
};
export const CategoryPickerByIdDocument = gql`
    query CategoryPickerById($id: String!, $preview: Boolean = false) {
  categoryPicker(id: $id, preview: $preview) {
    ...CategoryPicker
  }
}
    ${CategoryPickerFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}`;

export function useCategoryPickerByIdQuery(options: Omit<Urql.UseQueryArgs<CategoryPickerByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<CategoryPickerByIdQuery, CategoryPickerByIdQueryVariables>({ query: CategoryPickerByIdDocument, ...options });
};
export const CityLinksByIdDocument = gql`
    query cityLinksById($id: String!, $preview: Boolean = false) {
  cityLinks(id: $id, preview: $preview) {
    ...Meta
    name
  }
}
    ${MetaFragmentDoc}`;

export function useCityLinksByIdQuery(options: Omit<Urql.UseQueryArgs<CityLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<CityLinksByIdQuery, CityLinksByIdQueryVariables>({ query: CityLinksByIdDocument, ...options });
};
export const ColumnsByIdDocument = gql`
    query columnsById($id: String!, $preview: Boolean = false) {
  columns(id: $id, preview: $preview) {
    ...Columns
  }
}
    ${ColumnsFragmentDoc}
${MetaFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${TermOfConditionsFragmentDoc}
${ImageAssetFragmentDoc}
${AccordionFragmentDoc}`;

export function useColumnsByIdQuery(options: Omit<Urql.UseQueryArgs<ColumnsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ColumnsByIdQuery, ColumnsByIdQueryVariables>({ query: ColumnsByIdDocument, ...options });
};
export const ConvertFlowCtaByIdDocument = gql`
    query convertFlowCtaById($id: String!, $preview: Boolean = false) {
  convertFlowCta(id: $id, preview: $preview) {
    ...ConvertFlowCta
  }
}
    ${ConvertFlowCtaFragmentDoc}
${MetaFragmentDoc}`;

export function useConvertFlowCtaByIdQuery(options: Omit<Urql.UseQueryArgs<ConvertFlowCtaByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ConvertFlowCtaByIdQuery, ConvertFlowCtaByIdQueryVariables>({ query: ConvertFlowCtaByIdDocument, ...options });
};
export const ConvertFlowQuizByIdDocument = gql`
    query convertFlowQuizById($id: String!, $preview: Boolean = false) {
  convertFlowQuiz(id: $id, preview: $preview) {
    ...ConvertFlowQuiz
  }
}
    ${ConvertFlowQuizFragmentDoc}
${MetaFragmentDoc}`;

export function useConvertFlowQuizByIdQuery(options: Omit<Urql.UseQueryArgs<ConvertFlowQuizByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ConvertFlowQuizByIdQuery, ConvertFlowQuizByIdQueryVariables>({ query: ConvertFlowQuizByIdDocument, ...options });
};
export const DisclaimerV2ByIdDocument = gql`
    query disclaimerV2ById($id: String!, $preview: Boolean = false) {
  disclaimerV2(id: $id, preview: $preview) {
    ...DisclaimerV2
  }
}
    ${DisclaimerV2FragmentDoc}
${MetaFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}`;

export function useDisclaimerV2ByIdQuery(options: Omit<Urql.UseQueryArgs<DisclaimerV2ByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<DisclaimerV2ByIdQuery, DisclaimerV2ByIdQueryVariables>({ query: DisclaimerV2ByIdDocument, ...options });
};
export const ExperimentContainerByIdDocument = gql`
    query experimentContainerById($id: String!, $preview: Boolean = false) {
  experimentContainer(id: $id, preview: $preview) {
    ...ExperimentContainer
  }
}
    ${ExperimentContainerFragmentDoc}
${MetaFragmentDoc}`;

export function useExperimentContainerByIdQuery(options: Omit<Urql.UseQueryArgs<ExperimentContainerByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ExperimentContainerByIdQuery, ExperimentContainerByIdQueryVariables>({ query: ExperimentContainerByIdDocument, ...options });
};
export const FacilityDetailsPageByIdDocument = gql`
    query FacilityDetailsPageById($appName: String!, $facilityId: String!, $preview: Boolean = false) {
  facilityDetailsPageCollection(
    where: {appName: $appName, facilityId: $facilityId}
    limit: 1
    preview: $preview
  ) {
    items {
      path
      title
      indexed
      description
      canonical
      textSeo {
        json
      }
      moreTextSeo {
        json
      }
      ogImage {
        desktopImage
      }
      teletriageEnabled
      analyticsContext {
        sys {
          id
        }
      }
      contentsCollection(limit: 100) {
        items {
          __typename
          ... on Entry {
            sys {
              id
            }
          }
        }
      }
    }
  }
}
    `;

export function useFacilityDetailsPageByIdQuery(options: Omit<Urql.UseQueryArgs<FacilityDetailsPageByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<FacilityDetailsPageByIdQuery, FacilityDetailsPageByIdQueryVariables>({ query: FacilityDetailsPageByIdDocument, ...options });
};
export const FacilityDetailsPageContentDataByFacilityIdDocument = gql`
    query facilityDetailsPageContentDataByFacilityId($facilityId: String!, $preview: Boolean) {
  facilityDetailsPageCollection(
    where: {facilityId: $facilityId}
    limit: 1
    preview: $preview
  ) {
    items {
      facilityId
      pageContentDataJson
    }
  }
}
    `;

export function useFacilityDetailsPageContentDataByFacilityIdQuery(options: Omit<Urql.UseQueryArgs<FacilityDetailsPageContentDataByFacilityIdQueryVariables>, 'query'>) {
  return Urql.useQuery<FacilityDetailsPageContentDataByFacilityIdQuery, FacilityDetailsPageContentDataByFacilityIdQueryVariables>({ query: FacilityDetailsPageContentDataByFacilityIdDocument, ...options });
};
export const GoogleMapTemplateByIdDocument = gql`
    query googleMapTemplateById($id: String!, $preview: Boolean = false) {
  googleMapTemplate(id: $id, preview: $preview) {
    ...GoogleMapTemplate
  }
}
    ${GoogleMapTemplateFragmentDoc}
${MetaFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${ImageAssetFragmentDoc}
${CardsFragmentDoc}
${CardFragmentDoc}
${PdfFragmentDoc}
${TermOfConditionsFragmentDoc}
${TabsFragmentDoc}
${AccordionFragmentDoc}
${FocalPointImageFragmentDoc}
${RichTextFragmentDoc}
${SingleMessageFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${HalfScreenFragmentDoc}
${DisclaimerV2FragmentDoc}
${VideoAssetFragmentDoc}
${ServiceLineHeroFragmentDoc}
${ContentListItemFragmentDoc}
${TableFragmentDoc}`;

export function useGoogleMapTemplateByIdQuery(options: Omit<Urql.UseQueryArgs<GoogleMapTemplateByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GoogleMapTemplateByIdQuery, GoogleMapTemplateByIdQueryVariables>({ query: GoogleMapTemplateByIdDocument, ...options });
};
export const HalfScreenByIdDocument = gql`
    query halfScreenById($id: String!, $preview: Boolean = false) {
  halfScreen(id: $id, preview: $preview) {
    ...HalfScreen
  }
}
    ${HalfScreenFragmentDoc}
${MetaFragmentDoc}
${TermOfConditionsFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${VideoFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${ImageAssetFragmentDoc}
${VideoAssetFragmentDoc}`;

export function useHalfScreenByIdQuery(options: Omit<Urql.UseQueryArgs<HalfScreenByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<HalfScreenByIdQuery, HalfScreenByIdQueryVariables>({ query: HalfScreenByIdDocument, ...options });
};
export const HeroV2ByIdDocument = gql`
    query heroV2ById($id: String!, $preview: Boolean = false) {
  heroV2(id: $id, preview: $preview) {
    ...Hero
  }
}
    ${HeroFragmentDoc}
${MetaFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${FocalPointImageFragmentDoc}
${TermOfConditionsFragmentDoc}
${DisclaimerV2FragmentDoc}
${RichTextFragmentDoc}
${ImageAssetFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}`;

export function useHeroV2ByIdQuery(options: Omit<Urql.UseQueryArgs<HeroV2ByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<HeroV2ByIdQuery, HeroV2ByIdQueryVariables>({ query: HeroV2ByIdDocument, ...options });
};
export const IframeByIdDocument = gql`
    query iframeById($id: String!, $preview: Boolean = false) {
  iframe(id: $id, preview: $preview) {
    ...Iframe
  }
}
    ${IframeFragmentDoc}
${MetaFragmentDoc}`;

export function useIframeByIdQuery(options: Omit<Urql.UseQueryArgs<IframeByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<IframeByIdQuery, IframeByIdQueryVariables>({ query: IframeByIdDocument, ...options });
};
export const InsuranceByIdDocument = gql`
    query insuranceById($id: String!, $preview: Boolean = false) {
  insurance(id: $id, preview: $preview) {
    ...Insurance
  }
}
    ${InsuranceFragmentDoc}
${MetaFragmentDoc}`;

export function useInsuranceByIdQuery(options: Omit<Urql.UseQueryArgs<InsuranceByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<InsuranceByIdQuery, InsuranceByIdQueryVariables>({ query: InsuranceByIdDocument, ...options });
};
export const MarqueeByIdDocument = gql`
    query marqueeById($id: String!, $preview: Boolean = false) {
  marquee(id: $id, preview: $preview) {
    ...Marquee
  }
}
    ${MarqueeFragmentDoc}
${MetaFragmentDoc}`;

export function useMarqueeByIdQuery(options: Omit<Urql.UseQueryArgs<MarqueeByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<MarqueeByIdQuery, MarqueeByIdQueryVariables>({ query: MarqueeByIdDocument, ...options });
};
export const MeetOurStaffByIdDocument = gql`
    query meetOurStaffById($id: String!, $preview: Boolean = false) {
  meetOurStaff(id: $id, preview: $preview) {
    ...MeetOurStaff
  }
}
    ${MeetOurStaffFragmentDoc}
${MetaFragmentDoc}`;

export function useMeetOurStaffByIdQuery(options: Omit<Urql.UseQueryArgs<MeetOurStaffByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<MeetOurStaffByIdQuery, MeetOurStaffByIdQueryVariables>({ query: MeetOurStaffByIdDocument, ...options });
};
export const MultiCardV2ByIdDocument = gql`
    query multiCardV2ById($id: String!, $preview: Boolean = false) {
  multiCardV2(id: $id, preview: $preview) {
    ...Cards
  }
}
    ${CardsFragmentDoc}
${MetaFragmentDoc}
${CardFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${ImageAssetFragmentDoc}
${PdfFragmentDoc}
${TermOfConditionsFragmentDoc}
${AnalyticsFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}`;

export function useMultiCardV2ByIdQuery(options: Omit<Urql.UseQueryArgs<MultiCardV2ByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<MultiCardV2ByIdQuery, MultiCardV2ByIdQueryVariables>({ query: MultiCardV2ByIdDocument, ...options });
};
export const OdpHeroByIdDocument = gql`
    query OdpHeroById($id: String!, $preview: Boolean = false) {
  odpHero(id: $id, preview: $preview) {
    ...OdpHero
  }
}
    ${OdpHeroFragmentDoc}
${MetaFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}`;

export function useOdpHeroByIdQuery(options: Omit<Urql.UseQueryArgs<OdpHeroByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<OdpHeroByIdQuery, OdpHeroByIdQueryVariables>({ query: OdpHeroByIdDocument, ...options });
};
export const LandingPageByPathDocument = gql`
    query landingPageByPath($path: String!, $content_limit: Int = 25, $preview: Boolean = false) {
  pageCollection(limit: 1, where: {path: $path}, preview: $preview) {
    items {
      ...Page
    }
    skip
    limit
    total
  }
}
    ${PageFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${AnalyticsFragmentDoc}`;

export function useLandingPageByPathQuery(options: Omit<Urql.UseQueryArgs<LandingPageByPathQueryVariables>, 'query'>) {
  return Urql.useQuery<LandingPageByPathQuery, LandingPageByPathQueryVariables>({ query: LandingPageByPathDocument, ...options });
};
export const LandingPageByAppNameWithPathDocument = gql`
    query landingPageByAppNameWithPath($appName: String!, $path: String!, $content_limit: Int = 25, $preview: Boolean = false) {
  pageCollection(
    limit: 1
    where: {path: $path, appName: $appName}
    preview: $preview
  ) {
    items {
      ...Page
    }
    skip
    limit
    total
  }
}
    ${PageFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${AnalyticsFragmentDoc}`;

export function useLandingPageByAppNameWithPathQuery(options: Omit<Urql.UseQueryArgs<LandingPageByAppNameWithPathQueryVariables>, 'query'>) {
  return Urql.useQuery<LandingPageByAppNameWithPathQuery, LandingPageByAppNameWithPathQueryVariables>({ query: LandingPageByAppNameWithPathDocument, ...options });
};
export const PageByAppAndAlternatePathDocument = gql`
    query pageByAppAndAlternatePath($appName: String!, $path: String!, $alternativePath: String!, $content_limit: Int = 25, $preview: Boolean = false) {
  pageCollection(
    limit: 1
    where: {appName: $appName, path_in: [$path, $alternativePath]}
    preview: $preview
  ) {
    items {
      ...Page
    }
    skip
    limit
    total
  }
}
    ${PageFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${AnalyticsFragmentDoc}`;

export function usePageByAppAndAlternatePathQuery(options: Omit<Urql.UseQueryArgs<PageByAppAndAlternatePathQueryVariables>, 'query'>) {
  return Urql.useQuery<PageByAppAndAlternatePathQuery, PageByAppAndAlternatePathQueryVariables>({ query: PageByAppAndAlternatePathDocument, ...options });
};
export const PatientReviewsV2ByIdDocument = gql`
    query patientReviewsV2ById($id: String!, $preview: Boolean = false) {
  patientReviewsV2(id: $id, preview: $preview) {
    ...PatientReviewsV2
  }
}
    ${PatientReviewsV2FragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}`;

export function usePatientReviewsV2ByIdQuery(options: Omit<Urql.UseQueryArgs<PatientReviewsV2ByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<PatientReviewsV2ByIdQuery, PatientReviewsV2ByIdQueryVariables>({ query: PatientReviewsV2ByIdDocument, ...options });
};
export const ProductDisplayByIdDocument = gql`
    query productDisplayById($id: String!, $preview: Boolean = false) {
  productDisplay(id: $id, preview: $preview) {
    ...Meta
    ...ProductDisplay
  }
}
    ${MetaFragmentDoc}
${ProductDisplayFragmentDoc}`;

export function useProductDisplayByIdQuery(options: Omit<Urql.UseQueryArgs<ProductDisplayByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductDisplayByIdQuery, ProductDisplayByIdQueryVariables>({ query: ProductDisplayByIdDocument, ...options });
};
export const ProductFeatureByIdDocument = gql`
    query productFeatureById($id: String!, $preview: Boolean = false) {
  productFeature(id: $id, preview: $preview) {
    ...Meta
    headline {
      ...ContentSection
    }
    descriptionRichText {
      ...RichText
    }
    descriptionButton {
      ...Button
    }
    descriptionButtonsCollection(limit: 2) {
      items {
        ...Button
      }
    }
    descriptionListCollection(limit: 5) {
      items {
        ...Meta
        icon
        content {
          ...RichText
        }
      }
    }
    buttonsCollection(limit: 10) {
      items {
        ...Button
      }
    }
    media {
      badge {
        label
        variant
      }
      contentsCollection(limit: 5) {
        items {
          ...FocalPointImage
          ...Video
        }
      }
    }
    disclaimer {
      ...DisclaimerV2
    }
    enableSliderControlsBackgroundGradient
    anchorId
  }
}
    ${MetaFragmentDoc}
${ContentSectionFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${FocalPointImageFragmentDoc}
${VideoFragmentDoc}
${DisclaimerV2FragmentDoc}`;

export function useProductFeatureByIdQuery(options: Omit<Urql.UseQueryArgs<ProductFeatureByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductFeatureByIdQuery, ProductFeatureByIdQueryVariables>({ query: ProductFeatureByIdDocument, ...options });
};
export const QuickLinksByIdDocument = gql`
    query QuickLinksById($id: String!, $preview: Boolean = false) {
  quickLinks(id: $id, preview: $preview) {
    ...QuickLinks
  }
}
    ${QuickLinksFragmentDoc}
${MetaFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}`;

export function useQuickLinksByIdQuery(options: Omit<Urql.UseQueryArgs<QuickLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<QuickLinksByIdQuery, QuickLinksByIdQueryVariables>({ query: QuickLinksByIdDocument, ...options });
};
export const QuizByIdDocument = gql`
    query quizById($id: String!, $preview: Boolean = false) {
  quiz(id: $id, preview: $preview) {
    ...Quiz
  }
}
    ${QuizFragmentDoc}
${MetaFragmentDoc}`;

export function useQuizByIdQuery(options: Omit<Urql.UseQueryArgs<QuizByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<QuizByIdQuery, QuizByIdQueryVariables>({ query: QuizByIdDocument, ...options });
};
export const RichTextByIdDocument = gql`
    query richTextById($id: String!, $preview: Boolean = false) {
  contentTypeRichText(id: $id, preview: $preview) {
    ...RichTextWithLinks
  }
}
    ${RichTextWithLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${LinkMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${TableFragmentDoc}
${MetaFragmentDoc}
${ImageAssetFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ResourceMetaFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}`;

export function useRichTextByIdQuery(options: Omit<Urql.UseQueryArgs<RichTextByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<RichTextByIdQuery, RichTextByIdQueryVariables>({ query: RichTextByIdDocument, ...options });
};
export const HeroV2EntryLinksByIdDocument = gql`
    query heroV2EntryLinksById($id: String!, $preview: Boolean = false) {
  heroV2(id: $id, preview: $preview) {
    ...HeroV2EntryLinks
  }
}
    ${HeroV2EntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${DisclaimerV2EntryLinksFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}`;

export function useHeroV2EntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<HeroV2EntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<HeroV2EntryLinksByIdQuery, HeroV2EntryLinksByIdQueryVariables>({ query: HeroV2EntryLinksByIdDocument, ...options });
};
export const SingleMessageEntryLinksByIdDocument = gql`
    query singleMessageEntryLinksById($id: String!, $preview: Boolean = false) {
  singleMessage(id: $id, preview: $preview) {
    ...SingleMessageEntryLinks
  }
}
    ${SingleMessageEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}`;

export function useSingleMessageEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<SingleMessageEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SingleMessageEntryLinksByIdQuery, SingleMessageEntryLinksByIdQueryVariables>({ query: SingleMessageEntryLinksByIdDocument, ...options });
};
export const MultiCardV2EntryLinksByIdDocument = gql`
    query multiCardV2EntryLinksById($id: String!, $preview: Boolean = false) {
  multiCardV2(id: $id, preview: $preview) {
    ...MulticardV2EntryLinks
  }
}
    ${MulticardV2EntryLinksFragmentDoc}
${MetaFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${CardEntryLinksFragmentDoc}
${LinkMetaFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}`;

export function useMultiCardV2EntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<MultiCardV2EntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<MultiCardV2EntryLinksByIdQuery, MultiCardV2EntryLinksByIdQueryVariables>({ query: MultiCardV2EntryLinksByIdDocument, ...options });
};
export const TextBlockSeoEntryLinksByIdDocument = gql`
    query textBlockSeoEntryLinksById($id: String!, $preview: Boolean = false) {
  textBlockSeo(id: $id, preview: $preview) {
    ...TextBlockSeoEntryLinks
  }
}
    ${TextBlockSeoEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useTextBlockSeoEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<TextBlockSeoEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TextBlockSeoEntryLinksByIdQuery, TextBlockSeoEntryLinksByIdQueryVariables>({ query: TextBlockSeoEntryLinksByIdDocument, ...options });
};
export const TermsAndConditionsEntryLinksByIdDocument = gql`
    query termsAndConditionsEntryLinksById($id: String!, $preview: Boolean = false) {
  termsAndConditions(id: $id, preview: $preview) {
    ...TermsAndConditionsEntryLinks
  }
}
    ${TermsAndConditionsEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useTermsAndConditionsEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<TermsAndConditionsEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TermsAndConditionsEntryLinksByIdQuery, TermsAndConditionsEntryLinksByIdQueryVariables>({ query: TermsAndConditionsEntryLinksByIdDocument, ...options });
};
export const AccordionsEntryLinksByIdDocument = gql`
    query accordionsEntryLinksById($id: String!, $preview: Boolean = false) {
  accordions(id: $id, preview: $preview) {
    ...AccordionsEntryLinks
  }
}
    ${AccordionsEntryLinksFragmentDoc}
${MetaFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}`;

export function useAccordionsEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<AccordionsEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AccordionsEntryLinksByIdQuery, AccordionsEntryLinksByIdQueryVariables>({ query: AccordionsEntryLinksByIdDocument, ...options });
};
export const HalfScreenEntryLinksByIdDocument = gql`
    query halfScreenEntryLinksById($id: String!, $preview: Boolean = false) {
  halfScreen(id: $id, preview: $preview) {
    ...HalfScreenEntryLinks
  }
}
    ${HalfScreenEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${DisclaimerV2EntryLinksFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}`;

export function useHalfScreenEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<HalfScreenEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<HalfScreenEntryLinksByIdQuery, HalfScreenEntryLinksByIdQueryVariables>({ query: HalfScreenEntryLinksByIdDocument, ...options });
};
export const DisclaimerV2EntryLinksByIdDocument = gql`
    query disclaimerV2EntryLinksById($id: String!, $preview: Boolean = false) {
  disclaimerV2(id: $id, preview: $preview) {
    ...DisclaimerV2EntryLinks
  }
}
    ${DisclaimerV2EntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useDisclaimerV2EntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<DisclaimerV2EntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<DisclaimerV2EntryLinksByIdQuery, DisclaimerV2EntryLinksByIdQueryVariables>({ query: DisclaimerV2EntryLinksByIdDocument, ...options });
};
export const InsuranceEntryLinksByIdDocument = gql`
    query insuranceEntryLinksById($id: String!, $preview: Boolean = false) {
  insurance(id: $id, preview: $preview) {
    ...InsuranceEntryLinks
  }
}
    ${InsuranceEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useInsuranceEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<InsuranceEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<InsuranceEntryLinksByIdQuery, InsuranceEntryLinksByIdQueryVariables>({ query: InsuranceEntryLinksByIdDocument, ...options });
};
export const CategoryPickerEntryLinksByIdDocument = gql`
    query categoryPickerEntryLinksById($id: String!, $preview: Boolean = false) {
  categoryPicker(id: $id, preview: $preview) {
    ...CategoryPickerEntryLinks
  }
}
    ${CategoryPickerEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useCategoryPickerEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<CategoryPickerEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<CategoryPickerEntryLinksByIdQuery, CategoryPickerEntryLinksByIdQueryVariables>({ query: CategoryPickerEntryLinksByIdDocument, ...options });
};
export const ColumnsEntryLinksByIdDocument = gql`
    query columnsEntryLinksById($id: String!, $preview: Boolean = false) {
  columns(id: $id, preview: $preview) {
    ...ColumnsEntryLinks
  }
}
    ${ColumnsEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SingleMessageEntryLinksFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${AccordionsEntryLinksFragmentDoc}`;

export function useColumnsEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<ColumnsEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ColumnsEntryLinksByIdQuery, ColumnsEntryLinksByIdQueryVariables>({ query: ColumnsEntryLinksByIdDocument, ...options });
};
export const ServiceLineHeroEntryLinksDocument = gql`
    query serviceLineHeroEntryLinks($id: String!, $preview: Boolean = false) {
  serviceLineHero(id: $id, preview: $preview) {
    ...ServiceLineHeroEntryLinks
  }
}
    ${ServiceLineHeroEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${ContentListItemEntryLinksFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}
${SingleMessageEntryLinksFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${AccordionsEntryLinksFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${TermOfConditionsFragmentDoc}`;

export function useServiceLineHeroEntryLinksQuery(options: Omit<Urql.UseQueryArgs<ServiceLineHeroEntryLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceLineHeroEntryLinksQuery, ServiceLineHeroEntryLinksQueryVariables>({ query: ServiceLineHeroEntryLinksDocument, ...options });
};
export const OdpHeroEntryLinksDocument = gql`
    query ODPHeroEntryLinks($id: String!, $preview: Boolean = false) {
  odpHero(id: $id, preview: $preview) {
    ...ODPHeroEntryLinks
  }
}
    ${OdpHeroEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useOdpHeroEntryLinksQuery(options: Omit<Urql.UseQueryArgs<OdpHeroEntryLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<OdpHeroEntryLinksQuery, OdpHeroEntryLinksQueryVariables>({ query: OdpHeroEntryLinksDocument, ...options });
};
export const QuickLinksEntryLinksByIdDocument = gql`
    query QuickLinksEntryLinksById($id: String!, $preview: Boolean = false) {
  quickLinks(id: $id, preview: $preview) {
    ...QuickLinksEntryLinks
  }
}
    ${QuickLinksEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useQuickLinksEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<QuickLinksEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<QuickLinksEntryLinksByIdQuery, QuickLinksEntryLinksByIdQueryVariables>({ query: QuickLinksEntryLinksByIdDocument, ...options });
};
export const ServiceEntryLinksByIdDocument = gql`
    query ServiceEntryLinksById($id: String!, $preview: Boolean = false) {
  service(id: $id, preview: $preview) {
    ...ServiceEntryLinks
  }
}
    ${ServiceEntryLinksFragmentDoc}
${MetaFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}`;

export function useServiceEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<ServiceEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceEntryLinksByIdQuery, ServiceEntryLinksByIdQueryVariables>({ query: ServiceEntryLinksByIdDocument, ...options });
};
export const SegmentContainerLinksByIdDocument = gql`
    query SegmentContainerLinksById($id: String!, $preview: Boolean = false) {
  segmentsContainer(id: $id, preview: $preview) {
    ...SegmentContainerEntryLinks
  }
}
    ${SegmentContainerEntryLinksFragmentDoc}
${MetaFragmentDoc}
${HeroV2EntryLinksFragmentDoc}
${BasePageFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${DisclaimerV2EntryLinksFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}
${HalfScreenEntryLinksFragmentDoc}
${SingleMessageEntryLinksFragmentDoc}
${MulticardV2EntryLinksFragmentDoc}
${CardEntryLinksFragmentDoc}
${LinkMetaFragmentDoc}
${OdpHeroEntryLinksFragmentDoc}`;

export function useSegmentContainerLinksByIdQuery(options: Omit<Urql.UseQueryArgs<SegmentContainerLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SegmentContainerLinksByIdQuery, SegmentContainerLinksByIdQueryVariables>({ query: SegmentContainerLinksByIdDocument, ...options });
};
export const ProductFeatureEntryLinksByIdDocument = gql`
    query ProductFeatureEntryLinksById($id: String!, $preview: Boolean = false) {
  productFeature(id: $id, preview: $preview) {
    ...ProductFeatureEntryLinks
  }
}
    ${ProductFeatureEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useProductFeatureEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<ProductFeatureEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ProductFeatureEntryLinksByIdQuery, ProductFeatureEntryLinksByIdQueryVariables>({ query: ProductFeatureEntryLinksByIdDocument, ...options });
};
export const AgendaStepperEntryLinksByIdDocument = gql`
    query AgendaStepperEntryLinksById($id: String!, $preview: Boolean = false) {
  agendaStepper(id: $id, preview: $preview) {
    ...AgendaStepperEntryLinks
  }
}
    ${AgendaStepperEntryLinksFragmentDoc}
${MetaFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageAssetFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}`;

export function useAgendaStepperEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<AgendaStepperEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<AgendaStepperEntryLinksByIdQuery, AgendaStepperEntryLinksByIdQueryVariables>({ query: AgendaStepperEntryLinksByIdDocument, ...options });
};
export const TabsEntryLinksByIdDocument = gql`
    query TabsEntryLinksById($id: String!, $preview: Boolean = false) {
  tabs(id: $id, preview: $preview) {
    ...TabsEntryLinks
  }
}
    ${TabsEntryLinksFragmentDoc}
${MetaFragmentDoc}
${AccordionsEntryLinksFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BlogDetailsPageBaseFragmentDoc}
${ServiceDetailsPageBaseFragmentDoc}
${FacilityDetailsPageBaseFragmentDoc}
${ContentTypeRichTextEntryLinksFragmentDoc}
${ImageAssetFragmentDoc}
${HalfScreenEntryLinksFragmentDoc}
${SmallScreenContentEntryLinksFragmentDoc}
${TermsAndConditionsEntryLinksFragmentDoc}
${DisclaimerV2EntryLinksFragmentDoc}
${SingleMessageEntryLinksFragmentDoc}
${MulticardV2EntryLinksFragmentDoc}
${CardEntryLinksFragmentDoc}
${LinkMetaFragmentDoc}
${ServiceLineHeroEntryLinksFragmentDoc}
${ContentListItemEntryLinksFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${SingleMessageFragmentDoc}
${FocalPointImageFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${TermOfConditionsFragmentDoc}`;

export function useTabsEntryLinksByIdQuery(options: Omit<Urql.UseQueryArgs<TabsEntryLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TabsEntryLinksByIdQuery, TabsEntryLinksByIdQueryVariables>({ query: TabsEntryLinksByIdDocument, ...options });
};
export const SchemaByIdDocument = gql`
    query schemaById($id: String!, $preview: Boolean = false) {
  schema(id: $id, preview: $preview) {
    ...Schema
  }
}
    ${SchemaFragmentDoc}
${MetaFragmentDoc}`;

export function useSchemaByIdQuery(options: Omit<Urql.UseQueryArgs<SchemaByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SchemaByIdQuery, SchemaByIdQueryVariables>({ query: SchemaByIdDocument, ...options });
};
export const SegmentsContainerByIdDocument = gql`
    query segmentsContainerById($id: String!, $preview: Boolean = false) {
  segmentsContainer(id: $id, preview: $preview) {
    ...SegmentsContainer
  }
}
    ${SegmentsContainerFragmentDoc}
${MetaFragmentDoc}`;

export function useSegmentsContainerByIdQuery(options: Omit<Urql.UseQueryArgs<SegmentsContainerByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SegmentsContainerByIdQuery, SegmentsContainerByIdQueryVariables>({ query: SegmentsContainerByIdDocument, ...options });
};
export const ServiceByIdDocument = gql`
    query ServiceById($id: String!, $preview: Boolean = false) {
  service(id: $id, preview: $preview) {
    ...Service
  }
}
    ${ServiceFragmentDoc}
${MetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${TermOfConditionsFragmentDoc}`;

export function useServiceByIdQuery(options: Omit<Urql.UseQueryArgs<ServiceByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceByIdQuery, ServiceByIdQueryVariables>({ query: ServiceByIdDocument, ...options });
};
export const ServiceDetailsPageByIdAndPathDocument = gql`
    query ServiceDetailsPageByIdAndPath($appName: String!, $facilityId: String!, $path: String!, $preview: Boolean = false) {
  serviceDetailsPageCollection(
    where: {appName: $appName, facilityId: $facilityId, path: $path}
    limit: 1
    preview: $preview
  ) {
    items {
      path
      title
      indexed
      description
      canonical
      textSeo {
        json
      }
      moreTextSeo {
        json
      }
      ogImage {
        desktopImage
      }
      analyticsContext {
        sys {
          id
        }
      }
      contentsCollection(limit: 100) {
        items {
          __typename
          ... on Entry {
            sys {
              id
            }
          }
        }
      }
    }
  }
}
    `;

export function useServiceDetailsPageByIdAndPathQuery(options: Omit<Urql.UseQueryArgs<ServiceDetailsPageByIdAndPathQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceDetailsPageByIdAndPathQuery, ServiceDetailsPageByIdAndPathQueryVariables>({ query: ServiceDetailsPageByIdAndPathDocument, ...options });
};
export const ServiceLineHeroByIdDocument = gql`
    query serviceLineHeroById($id: String!, $preview: Boolean = false) {
  serviceLineHero(id: $id, preview: $preview) {
    ...ServiceLineHero
  }
}
    ${ServiceLineHeroFragmentDoc}
${MetaFragmentDoc}
${TermOfConditionsFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${FocalPointImageFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${ContentListItemFragmentDoc}
${RichTextFragmentDoc}
${SingleMessageFragmentDoc}
${SmallScreenContentFragmentDoc}
${ImageAssetFragmentDoc}
${TableFragmentDoc}
${AccordionFragmentDoc}`;

export function useServiceLineHeroByIdQuery(options: Omit<Urql.UseQueryArgs<ServiceLineHeroByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<ServiceLineHeroByIdQuery, ServiceLineHeroByIdQueryVariables>({ query: ServiceLineHeroByIdDocument, ...options });
};
export const SingleMessageByIdDocument = gql`
    query singleMessageById($id: String!, $preview: Boolean = false) {
  singleMessage(id: $id, preview: $preview) {
    ...SingleMessage
  }
}
    ${SingleMessageFragmentDoc}
${MetaFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${TermOfConditionsFragmentDoc}
${ImageAssetFragmentDoc}`;

export function useSingleMessageByIdQuery(options: Omit<Urql.UseQueryArgs<SingleMessageByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SingleMessageByIdQuery, SingleMessageByIdQueryVariables>({ query: SingleMessageByIdDocument, ...options });
};
export const SitemapPagesDocument = gql`
    query sitemapPages($appName: String!, $locale: String!, $indexed: Boolean = true, $limit: Int = 500, $skip: Int = 0) {
  ...sitemapPages
}
    ${SitemapPagesFragmentDoc}`;

export function useSitemapPagesQuery(options: Omit<Urql.UseQueryArgs<SitemapPagesQueryVariables>, 'query'>) {
  return Urql.useQuery<SitemapPagesQuery, SitemapPagesQueryVariables>({ query: SitemapPagesDocument, ...options });
};
export const SmileAssessmentFormByIdDocument = gql`
    query smileAssessmentFormById($id: String!, $preview: Boolean = false) {
  smileAssessmentForm(id: $id, preview: $preview) {
    formContent {
      buttonText
      buttonUrl
      defaultErrorMessage
      formCollection(limit: 10) {
        items {
          ... on SectionContent {
            title
            type
            aditionalReferencesCollection(limit: 10) {
              items {
                ... on FormField {
                  title
                  required
                  onSubmitFormUrl
                  alertMessage
                  type
                  label
                  placeholder
                  apiKey
                  image {
                    url
                  }
                }
                ... on FormDropdownField {
                  title
                  clearTextItem
                  itemList
                  apiKey
                  required
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

export function useSmileAssessmentFormByIdQuery(options: Omit<Urql.UseQueryArgs<SmileAssessmentFormByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SmileAssessmentFormByIdQuery, SmileAssessmentFormByIdQueryVariables>({ query: SmileAssessmentFormByIdDocument, ...options });
};
export const SpacerByIdDocument = gql`
    query spacerById($id: String!, $preview: Boolean = false) {
  spacer(id: $id, preview: $preview) {
    ...Spacer
  }
}
    ${SpacerFragmentDoc}
${MetaFragmentDoc}`;

export function useSpacerByIdQuery(options: Omit<Urql.UseQueryArgs<SpacerByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<SpacerByIdQuery, SpacerByIdQueryVariables>({ query: SpacerByIdDocument, ...options });
};
export const StateLinksByIdDocument = gql`
    query stateLinksById($id: String!, $preview: Boolean = false) {
  stateLinks(id: $id, preview: $preview) {
    ...Meta
    name
  }
}
    ${MetaFragmentDoc}`;

export function useStateLinksByIdQuery(options: Omit<Urql.UseQueryArgs<StateLinksByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<StateLinksByIdQuery, StateLinksByIdQueryVariables>({ query: StateLinksByIdDocument, ...options });
};
export const TableByIdDocument = gql`
    query tableById($id: String!, $preview: Boolean = false) {
  table(id: $id, preview: $preview) {
    ...Table
  }
}
    ${TableFragmentDoc}
${MetaFragmentDoc}
${CommonAssetFragmentDoc}`;

export function useTableByIdQuery(options: Omit<Urql.UseQueryArgs<TableByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TableByIdQuery, TableByIdQueryVariables>({ query: TableByIdDocument, ...options });
};
export const TabsByIdDocument = gql`
    query tabsById($id: String!, $preview: Boolean = false) {
  tabs(id: $id, preview: $preview) {
    ...Tabs
  }
}
    ${TabsFragmentDoc}
${MetaFragmentDoc}
${AccordionFragmentDoc}
${FocalPointImageFragmentDoc}
${ImageFragmentDoc}
${CommonAssetFragmentDoc}
${RichTextFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}
${CardsFragmentDoc}
${CardFragmentDoc}
${ImageAssetFragmentDoc}
${PdfFragmentDoc}
${TermOfConditionsFragmentDoc}
${SingleMessageFragmentDoc}
${SmallScreenContentFragmentDoc}
${VideoFragmentDoc}
${HalfScreenFragmentDoc}
${DisclaimerV2FragmentDoc}
${VideoAssetFragmentDoc}
${ServiceLineHeroFragmentDoc}
${ContentListItemFragmentDoc}
${TableFragmentDoc}`;

export function useTabsByIdQuery(options: Omit<Urql.UseQueryArgs<TabsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TabsByIdQuery, TabsByIdQueryVariables>({ query: TabsByIdDocument, ...options });
};
export const TermsAndConditionsByIdDocument = gql`
    query termsAndConditionsById($id: String!, $preview: Boolean = false) {
  termsAndConditions(id: $id, preview: $preview) {
    ...TermOfConditions
  }
}
    ${TermOfConditionsFragmentDoc}
${MetaFragmentDoc}`;

export function useTermsAndConditionsByIdQuery(options: Omit<Urql.UseQueryArgs<TermsAndConditionsByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TermsAndConditionsByIdQuery, TermsAndConditionsByIdQueryVariables>({ query: TermsAndConditionsByIdDocument, ...options });
};
export const TextBlockSeoByIdDocument = gql`
    query textBlockSeoById($id: String!, $preview: Boolean = false) {
  textBlockSeo(id: $id, preview: $preview) {
    ...TextBlockSeo
  }
}
    ${TextBlockSeoFragmentDoc}
${MetaFragmentDoc}`;

export function useTextBlockSeoByIdQuery(options: Omit<Urql.UseQueryArgs<TextBlockSeoByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<TextBlockSeoByIdQuery, TextBlockSeoByIdQueryVariables>({ query: TextBlockSeoByIdDocument, ...options });
};
export const VideoCarouselByIdDocument = gql`
    query videoCarouselById($id: String!, $preview: Boolean = false) {
  videoCarousel(id: $id, preview: $preview) {
    ...Meta
    backgroundColor
    topFields {
      ...ContentSection
    }
    desktopVideosAspectRatio
    mobileVideosAspectRatio
    videosCollection(limit: 5) {
      skip
      total
      items {
        ... on VideoWithContent {
          ...Meta
          content {
            ...ContentSection
          }
          video {
            ...VideoAsset
          }
          buttonsCollection(limit: 1) {
            items {
              ...Button
            }
          }
        }
      }
    }
    buttonsCollection(limit: 2) {
      items {
        ...Button
      }
    }
    anchorId
  }
}
    ${MetaFragmentDoc}
${ContentSectionFragmentDoc}
${VideoAssetFragmentDoc}
${VideoFragmentDoc}
${CommonAssetFragmentDoc}
${ButtonFragmentDoc}
${MobileButtonFragmentDoc}
${AnalyticsFragmentDoc}
${NavLinkFragmentDoc}
${EnrichedMetaFragmentDoc}
${ImageFragmentDoc}
${BasePageFragmentDoc}
${QuizFragmentDoc}
${IframeFragmentDoc}`;

export function useVideoCarouselByIdQuery(options: Omit<Urql.UseQueryArgs<VideoCarouselByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<VideoCarouselByIdQuery, VideoCarouselByIdQueryVariables>({ query: VideoCarouselByIdDocument, ...options });
};